
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaa5c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaa5c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iHpLz", function(module, exports) {
'use strict';

module.exports = (parcelRequire("21hEy"));

});
parcelRegister("21hEy", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $17895e47fd54f731$export$ffb0004e005737fa; }, function (v) { return $17895e47fd54f731$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $17895e47fd54f731$export$34b9dba7ce09269b; }, function (v) { return $17895e47fd54f731$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $17895e47fd54f731$export$25062201e9e25d76; }, function (v) { return $17895e47fd54f731$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $17895e47fd54f731$export$ffb0004e005737fa;
var $17895e47fd54f731$export$34b9dba7ce09269b;
var $17895e47fd54f731$export$25062201e9e25d76;
'use strict';

var $7hhBq = parcelRequire("7hhBq");
var $17895e47fd54f731$var$k = Symbol.for("react.element"), $17895e47fd54f731$var$l = Symbol.for("react.fragment"), $17895e47fd54f731$var$m = Object.prototype.hasOwnProperty, $17895e47fd54f731$var$n = $7hhBq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $17895e47fd54f731$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $17895e47fd54f731$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$17895e47fd54f731$var$m.call(a, b) && !$17895e47fd54f731$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $17895e47fd54f731$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $17895e47fd54f731$var$n.current
    };
}
$17895e47fd54f731$export$ffb0004e005737fa = $17895e47fd54f731$var$l;
$17895e47fd54f731$export$34b9dba7ce09269b = $17895e47fd54f731$var$q;
$17895e47fd54f731$export$25062201e9e25d76 = $17895e47fd54f731$var$q;

});
parcelRegister("7hhBq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bDgOE"));

});
parcelRegister("bDgOE", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $8780618088598118$export$dca3b0875bd9a954; }, function (v) { return $8780618088598118$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $8780618088598118$export$16fa2f45be04daa8; }, function (v) { return $8780618088598118$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8780618088598118$export$ffb0004e005737fa; }, function (v) { return $8780618088598118$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $8780618088598118$export$e2c29f18771995cb; }, function (v) { return $8780618088598118$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $8780618088598118$export$221d75b3f55bb0bd; }, function (v) { return $8780618088598118$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8780618088598118$export$5f8d39834fd61797; }, function (v) { return $8780618088598118$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8780618088598118$export$74bf444e3cd11ea5; }, function (v) { return $8780618088598118$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $8780618088598118$export$ae55be85d98224ed; }, function (v) { return $8780618088598118$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $8780618088598118$export$3ba232387fd5d6dd; }, function (v) { return $8780618088598118$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $8780618088598118$export$e530037191fcd5d7; }, function (v) { return $8780618088598118$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $8780618088598118$export$fd42f52fd3ae1109; }, function (v) { return $8780618088598118$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $8780618088598118$export$c8a8987d4410bf2d; }, function (v) { return $8780618088598118$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $8780618088598118$export$d38cd72104c1f0e9; }, function (v) { return $8780618088598118$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $8780618088598118$export$7d1e3a5e95ceca43; }, function (v) { return $8780618088598118$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $8780618088598118$export$257a8862b851cb5b; }, function (v) { return $8780618088598118$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $8780618088598118$export$a8257692ac88316c; }, function (v) { return $8780618088598118$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $8780618088598118$export$488013bae63b21da; }, function (v) { return $8780618088598118$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $8780618088598118$export$7c73462e0d25e514; }, function (v) { return $8780618088598118$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $8780618088598118$export$7568632d0d33d16d; }, function (v) { return $8780618088598118$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $8780618088598118$export$88948ce120ea2619; }, function (v) { return $8780618088598118$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $8780618088598118$export$35808ee640e87ca7; }, function (v) { return $8780618088598118$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $8780618088598118$export$fae74005e78b1a27; }, function (v) { return $8780618088598118$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $8780618088598118$export$dc8fbce3eb94dc1e; }, function (v) { return $8780618088598118$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $8780618088598118$export$6a7bc4e911dc01cf; }, function (v) { return $8780618088598118$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $8780618088598118$export$6d9c69b0de29b591; }, function (v) { return $8780618088598118$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $8780618088598118$export$f680877a34711e37; }, function (v) { return $8780618088598118$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $8780618088598118$export$d5a552a76deda3c2; }, function (v) { return $8780618088598118$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $8780618088598118$export$aaabe4eda9ed9969; }, function (v) { return $8780618088598118$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $8780618088598118$export$e5c5a5f917a5871c; }, function (v) { return $8780618088598118$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $8780618088598118$export$1538c33de8887b59; }, function (v) { return $8780618088598118$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $8780618088598118$export$13e3392192263954; }, function (v) { return $8780618088598118$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $8780618088598118$export$b8f5890fc79d6aca; }, function (v) { return $8780618088598118$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $8780618088598118$export$60241385465d0a34; }, function (v) { return $8780618088598118$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $8780618088598118$export$306c0aa65ff9ec16; }, function (v) { return $8780618088598118$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $8780618088598118$export$7b286972b8d8ccbf; }, function (v) { return $8780618088598118$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $8780618088598118$export$83d89fbfd8236492; }, function (v) { return $8780618088598118$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8780618088598118$export$dca3b0875bd9a954;
var $8780618088598118$export$16fa2f45be04daa8;
var $8780618088598118$export$ffb0004e005737fa;
var $8780618088598118$export$e2c29f18771995cb;
var $8780618088598118$export$221d75b3f55bb0bd;
var $8780618088598118$export$5f8d39834fd61797;
var $8780618088598118$export$74bf444e3cd11ea5;
var $8780618088598118$export$ae55be85d98224ed;
var $8780618088598118$export$3ba232387fd5d6dd;
var $8780618088598118$export$e530037191fcd5d7;
var $8780618088598118$export$fd42f52fd3ae1109;
var $8780618088598118$export$c8a8987d4410bf2d;
var $8780618088598118$export$d38cd72104c1f0e9;
var $8780618088598118$export$7d1e3a5e95ceca43;
var $8780618088598118$export$257a8862b851cb5b;
var $8780618088598118$export$a8257692ac88316c;
var $8780618088598118$export$488013bae63b21da;
var $8780618088598118$export$7c73462e0d25e514;
var $8780618088598118$export$7568632d0d33d16d;
var $8780618088598118$export$88948ce120ea2619;
var $8780618088598118$export$35808ee640e87ca7;
var $8780618088598118$export$fae74005e78b1a27;
var $8780618088598118$export$dc8fbce3eb94dc1e;
var $8780618088598118$export$6a7bc4e911dc01cf;
var $8780618088598118$export$6d9c69b0de29b591;
var $8780618088598118$export$f680877a34711e37;
var $8780618088598118$export$d5a552a76deda3c2;
var $8780618088598118$export$aaabe4eda9ed9969;
var $8780618088598118$export$e5c5a5f917a5871c;
var $8780618088598118$export$1538c33de8887b59;
var $8780618088598118$export$13e3392192263954;
var $8780618088598118$export$b8f5890fc79d6aca;
var $8780618088598118$export$60241385465d0a34;
var $8780618088598118$export$306c0aa65ff9ec16;
var $8780618088598118$export$7b286972b8d8ccbf;
var $8780618088598118$export$83d89fbfd8236492;
'use strict';
var $8780618088598118$var$l = Symbol.for("react.element"), $8780618088598118$var$n = Symbol.for("react.portal"), $8780618088598118$var$p = Symbol.for("react.fragment"), $8780618088598118$var$q = Symbol.for("react.strict_mode"), $8780618088598118$var$r = Symbol.for("react.profiler"), $8780618088598118$var$t = Symbol.for("react.provider"), $8780618088598118$var$u = Symbol.for("react.context"), $8780618088598118$var$v = Symbol.for("react.forward_ref"), $8780618088598118$var$w = Symbol.for("react.suspense"), $8780618088598118$var$x = Symbol.for("react.memo"), $8780618088598118$var$y = Symbol.for("react.lazy"), $8780618088598118$var$z = Symbol.iterator;
function $8780618088598118$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8780618088598118$var$z && a[$8780618088598118$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $8780618088598118$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8780618088598118$var$C = Object.assign, $8780618088598118$var$D = {};
function $8780618088598118$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $8780618088598118$var$D;
    this.updater = e || $8780618088598118$var$B;
}
$8780618088598118$var$E.prototype.isReactComponent = {};
$8780618088598118$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$8780618088598118$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $8780618088598118$var$F() {}
$8780618088598118$var$F.prototype = $8780618088598118$var$E.prototype;
function $8780618088598118$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $8780618088598118$var$D;
    this.updater = e || $8780618088598118$var$B;
}
var $8780618088598118$var$H = $8780618088598118$var$G.prototype = new $8780618088598118$var$F;
$8780618088598118$var$H.constructor = $8780618088598118$var$G;
$8780618088598118$var$C($8780618088598118$var$H, $8780618088598118$var$E.prototype);
$8780618088598118$var$H.isPureReactComponent = !0;
var $8780618088598118$var$I = Array.isArray, $8780618088598118$var$J = Object.prototype.hasOwnProperty, $8780618088598118$var$K = {
    current: null
}, $8780618088598118$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8780618088598118$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$8780618088598118$var$J.call(b, d) && !$8780618088598118$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $8780618088598118$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $8780618088598118$var$K.current
    };
}
function $8780618088598118$var$N(a, b) {
    return {
        $$typeof: $8780618088598118$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $8780618088598118$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8780618088598118$var$l;
}
function $8780618088598118$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $8780618088598118$var$P = /\/+/g;
function $8780618088598118$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $8780618088598118$var$escape("" + a.key) : b.toString(36);
}
function $8780618088598118$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $8780618088598118$var$l:
                case $8780618088598118$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $8780618088598118$var$Q(h, 0) : d, $8780618088598118$var$I(c) ? (e = "", null != a && (e = a.replace($8780618088598118$var$P, "$&/") + "/"), $8780618088598118$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($8780618088598118$var$O(c) && (c = $8780618088598118$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($8780618088598118$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($8780618088598118$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $8780618088598118$var$Q(k, g);
        h += $8780618088598118$var$R(k, b, e, f, c);
    }
    else if (f = $8780618088598118$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $8780618088598118$var$Q(k, g++), h += $8780618088598118$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $8780618088598118$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $8780618088598118$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $8780618088598118$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $8780618088598118$var$U = {
    current: null
}, $8780618088598118$var$V = {
    transition: null
}, $8780618088598118$var$W = {
    ReactCurrentDispatcher: $8780618088598118$var$U,
    ReactCurrentBatchConfig: $8780618088598118$var$V,
    ReactCurrentOwner: $8780618088598118$var$K
};
function $8780618088598118$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$8780618088598118$export$dca3b0875bd9a954 = {
    map: $8780618088598118$var$S,
    forEach: function(a, b, e) {
        $8780618088598118$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $8780618088598118$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $8780618088598118$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$8780618088598118$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$8780618088598118$export$16fa2f45be04daa8 = $8780618088598118$var$E;
$8780618088598118$export$ffb0004e005737fa = $8780618088598118$var$p;
$8780618088598118$export$e2c29f18771995cb = $8780618088598118$var$r;
$8780618088598118$export$221d75b3f55bb0bd = $8780618088598118$var$G;
$8780618088598118$export$5f8d39834fd61797 = $8780618088598118$var$q;
$8780618088598118$export$74bf444e3cd11ea5 = $8780618088598118$var$w;
$8780618088598118$export$ae55be85d98224ed = $8780618088598118$var$W;
$8780618088598118$export$3ba232387fd5d6dd = $8780618088598118$var$X;
$8780618088598118$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $8780618088598118$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $8780618088598118$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$8780618088598118$var$J.call(b, f) && !$8780618088598118$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $8780618088598118$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$8780618088598118$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $8780618088598118$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $8780618088598118$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$8780618088598118$export$c8a8987d4410bf2d = $8780618088598118$var$M;
$8780618088598118$export$d38cd72104c1f0e9 = function(a) {
    var b = $8780618088598118$var$M.bind(null, a);
    b.type = a;
    return b;
};
$8780618088598118$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8780618088598118$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $8780618088598118$var$v,
        render: a
    };
};
$8780618088598118$export$a8257692ac88316c = $8780618088598118$var$O;
$8780618088598118$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $8780618088598118$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $8780618088598118$var$T
    };
};
$8780618088598118$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $8780618088598118$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$8780618088598118$export$7568632d0d33d16d = function(a) {
    var b = $8780618088598118$var$V.transition;
    $8780618088598118$var$V.transition = {};
    try {
        a();
    } finally{
        $8780618088598118$var$V.transition = b;
    }
};
$8780618088598118$export$88948ce120ea2619 = $8780618088598118$var$X;
$8780618088598118$export$35808ee640e87ca7 = function(a, b) {
    return $8780618088598118$var$U.current.useCallback(a, b);
};
$8780618088598118$export$fae74005e78b1a27 = function(a) {
    return $8780618088598118$var$U.current.useContext(a);
};
$8780618088598118$export$dc8fbce3eb94dc1e = function() {};
$8780618088598118$export$6a7bc4e911dc01cf = function(a) {
    return $8780618088598118$var$U.current.useDeferredValue(a);
};
$8780618088598118$export$6d9c69b0de29b591 = function(a, b) {
    return $8780618088598118$var$U.current.useEffect(a, b);
};
$8780618088598118$export$f680877a34711e37 = function() {
    return $8780618088598118$var$U.current.useId();
};
$8780618088598118$export$d5a552a76deda3c2 = function(a, b, e) {
    return $8780618088598118$var$U.current.useImperativeHandle(a, b, e);
};
$8780618088598118$export$aaabe4eda9ed9969 = function(a, b) {
    return $8780618088598118$var$U.current.useInsertionEffect(a, b);
};
$8780618088598118$export$e5c5a5f917a5871c = function(a, b) {
    return $8780618088598118$var$U.current.useLayoutEffect(a, b);
};
$8780618088598118$export$1538c33de8887b59 = function(a, b) {
    return $8780618088598118$var$U.current.useMemo(a, b);
};
$8780618088598118$export$13e3392192263954 = function(a, b, e) {
    return $8780618088598118$var$U.current.useReducer(a, b, e);
};
$8780618088598118$export$b8f5890fc79d6aca = function(a) {
    return $8780618088598118$var$U.current.useRef(a);
};
$8780618088598118$export$60241385465d0a34 = function(a) {
    return $8780618088598118$var$U.current.useState(a);
};
$8780618088598118$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $8780618088598118$var$U.current.useSyncExternalStore(a, b, e);
};
$8780618088598118$export$7b286972b8d8ccbf = function() {
    return $8780618088598118$var$U.current.useTransition();
};
$8780618088598118$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("4unLw", function(module, exports) {
'use strict';
function $344c66123da0149d$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($344c66123da0149d$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$344c66123da0149d$var$checkDCE();

module.exports = (parcelRequire("k2buO"));

});
parcelRegister("k2buO", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e95ce96b80fe8388$export$ae55be85d98224ed; }, function (v) { return $e95ce96b80fe8388$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e95ce96b80fe8388$export$d39a5bbd09211389; }, function (v) { return $e95ce96b80fe8388$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e95ce96b80fe8388$export$882461b6382ed46c; }, function (v) { return $e95ce96b80fe8388$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e95ce96b80fe8388$export$466bfc07425424d5; }, function (v) { return $e95ce96b80fe8388$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e95ce96b80fe8388$export$cd75ccfd720a3cd4; }, function (v) { return $e95ce96b80fe8388$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e95ce96b80fe8388$export$fa8d919ba61d84db; }, function (v) { return $e95ce96b80fe8388$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e95ce96b80fe8388$export$757ceba2d55c277e; }, function (v) { return $e95ce96b80fe8388$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e95ce96b80fe8388$export$b3890eb0ae9dca99; }, function (v) { return $e95ce96b80fe8388$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e95ce96b80fe8388$export$502457920280e6be; }, function (v) { return $e95ce96b80fe8388$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e95ce96b80fe8388$export$c78a37762a8d58e1; }, function (v) { return $e95ce96b80fe8388$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e95ce96b80fe8388$export$dc54d992c10e8a18; }, function (v) { return $e95ce96b80fe8388$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e95ce96b80fe8388$export$83d89fbfd8236492; }, function (v) { return $e95ce96b80fe8388$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e95ce96b80fe8388$export$ae55be85d98224ed;
var $e95ce96b80fe8388$export$d39a5bbd09211389;
var $e95ce96b80fe8388$export$882461b6382ed46c;
var $e95ce96b80fe8388$export$466bfc07425424d5;
var $e95ce96b80fe8388$export$cd75ccfd720a3cd4;
var $e95ce96b80fe8388$export$fa8d919ba61d84db;
var $e95ce96b80fe8388$export$757ceba2d55c277e;
var $e95ce96b80fe8388$export$b3890eb0ae9dca99;
var $e95ce96b80fe8388$export$502457920280e6be;
var $e95ce96b80fe8388$export$c78a37762a8d58e1;
var $e95ce96b80fe8388$export$dc54d992c10e8a18;
var $e95ce96b80fe8388$export$83d89fbfd8236492;
'use strict';

var $7hhBq = parcelRequire("7hhBq");

var $7P9w1 = parcelRequire("7P9w1");
function $e95ce96b80fe8388$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e95ce96b80fe8388$var$da = new Set, $e95ce96b80fe8388$var$ea = {};
function $e95ce96b80fe8388$var$fa(a, b) {
    $e95ce96b80fe8388$var$ha(a, b);
    $e95ce96b80fe8388$var$ha(a + "Capture", b);
}
function $e95ce96b80fe8388$var$ha(a, b) {
    $e95ce96b80fe8388$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e95ce96b80fe8388$var$da.add(b[a]);
}
var $e95ce96b80fe8388$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e95ce96b80fe8388$var$ja = Object.prototype.hasOwnProperty, $e95ce96b80fe8388$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e95ce96b80fe8388$var$la = {}, $e95ce96b80fe8388$var$ma = {};
function $e95ce96b80fe8388$var$oa(a) {
    if ($e95ce96b80fe8388$var$ja.call($e95ce96b80fe8388$var$ma, a)) return !0;
    if ($e95ce96b80fe8388$var$ja.call($e95ce96b80fe8388$var$la, a)) return !1;
    if ($e95ce96b80fe8388$var$ka.test(a)) return $e95ce96b80fe8388$var$ma[a] = !0;
    $e95ce96b80fe8388$var$la[a] = !0;
    return !1;
}
function $e95ce96b80fe8388$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e95ce96b80fe8388$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e95ce96b80fe8388$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e95ce96b80fe8388$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e95ce96b80fe8388$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e95ce96b80fe8388$var$z[a] = new $e95ce96b80fe8388$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e95ce96b80fe8388$var$z[b] = new $e95ce96b80fe8388$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e95ce96b80fe8388$var$z[a] = new $e95ce96b80fe8388$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e95ce96b80fe8388$var$z[a] = new $e95ce96b80fe8388$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e95ce96b80fe8388$var$z[a] = new $e95ce96b80fe8388$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e95ce96b80fe8388$var$z[a] = new $e95ce96b80fe8388$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e95ce96b80fe8388$var$z[a] = new $e95ce96b80fe8388$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e95ce96b80fe8388$var$z[a] = new $e95ce96b80fe8388$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e95ce96b80fe8388$var$z[a] = new $e95ce96b80fe8388$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e95ce96b80fe8388$var$ra = /[\-:]([a-z])/g;
function $e95ce96b80fe8388$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e95ce96b80fe8388$var$ra, $e95ce96b80fe8388$var$sa);
    $e95ce96b80fe8388$var$z[b] = new $e95ce96b80fe8388$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e95ce96b80fe8388$var$ra, $e95ce96b80fe8388$var$sa);
    $e95ce96b80fe8388$var$z[b] = new $e95ce96b80fe8388$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e95ce96b80fe8388$var$ra, $e95ce96b80fe8388$var$sa);
    $e95ce96b80fe8388$var$z[b] = new $e95ce96b80fe8388$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e95ce96b80fe8388$var$z[a] = new $e95ce96b80fe8388$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e95ce96b80fe8388$var$z.xlinkHref = new $e95ce96b80fe8388$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e95ce96b80fe8388$var$z[a] = new $e95ce96b80fe8388$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e95ce96b80fe8388$var$ta(a, b, c, d) {
    var e = $e95ce96b80fe8388$var$z.hasOwnProperty(b) ? $e95ce96b80fe8388$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e95ce96b80fe8388$var$qa(b, c, e, d) && (c = null), d || null === e ? $e95ce96b80fe8388$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e95ce96b80fe8388$var$ua = $7hhBq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e95ce96b80fe8388$var$va = Symbol.for("react.element"), $e95ce96b80fe8388$var$wa = Symbol.for("react.portal"), $e95ce96b80fe8388$var$ya = Symbol.for("react.fragment"), $e95ce96b80fe8388$var$za = Symbol.for("react.strict_mode"), $e95ce96b80fe8388$var$Aa = Symbol.for("react.profiler"), $e95ce96b80fe8388$var$Ba = Symbol.for("react.provider"), $e95ce96b80fe8388$var$Ca = Symbol.for("react.context"), $e95ce96b80fe8388$var$Da = Symbol.for("react.forward_ref"), $e95ce96b80fe8388$var$Ea = Symbol.for("react.suspense"), $e95ce96b80fe8388$var$Fa = Symbol.for("react.suspense_list"), $e95ce96b80fe8388$var$Ga = Symbol.for("react.memo"), $e95ce96b80fe8388$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e95ce96b80fe8388$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e95ce96b80fe8388$var$Ja = Symbol.iterator;
function $e95ce96b80fe8388$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e95ce96b80fe8388$var$Ja && a[$e95ce96b80fe8388$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e95ce96b80fe8388$var$A = Object.assign, $e95ce96b80fe8388$var$La;
function $e95ce96b80fe8388$var$Ma(a) {
    if (void 0 === $e95ce96b80fe8388$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e95ce96b80fe8388$var$La = b && b[1] || "";
    }
    return "\n" + $e95ce96b80fe8388$var$La + a;
}
var $e95ce96b80fe8388$var$Na = !1;
function $e95ce96b80fe8388$var$Oa(a, b) {
    if (!a || $e95ce96b80fe8388$var$Na) return "";
    $e95ce96b80fe8388$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e95ce96b80fe8388$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e95ce96b80fe8388$var$Ma(a) : "";
}
function $e95ce96b80fe8388$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e95ce96b80fe8388$var$Ma(a.type);
        case 16:
            return $e95ce96b80fe8388$var$Ma("Lazy");
        case 13:
            return $e95ce96b80fe8388$var$Ma("Suspense");
        case 19:
            return $e95ce96b80fe8388$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e95ce96b80fe8388$var$Oa(a.type, !1), a;
        case 11:
            return a = $e95ce96b80fe8388$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e95ce96b80fe8388$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e95ce96b80fe8388$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e95ce96b80fe8388$var$ya:
            return "Fragment";
        case $e95ce96b80fe8388$var$wa:
            return "Portal";
        case $e95ce96b80fe8388$var$Aa:
            return "Profiler";
        case $e95ce96b80fe8388$var$za:
            return "StrictMode";
        case $e95ce96b80fe8388$var$Ea:
            return "Suspense";
        case $e95ce96b80fe8388$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e95ce96b80fe8388$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e95ce96b80fe8388$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e95ce96b80fe8388$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e95ce96b80fe8388$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e95ce96b80fe8388$var$Qa(a.type) || "Memo";
        case $e95ce96b80fe8388$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e95ce96b80fe8388$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e95ce96b80fe8388$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e95ce96b80fe8388$var$Qa(b);
        case 8:
            return b === $e95ce96b80fe8388$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e95ce96b80fe8388$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e95ce96b80fe8388$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e95ce96b80fe8388$var$Ua(a) {
    var b = $e95ce96b80fe8388$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e95ce96b80fe8388$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e95ce96b80fe8388$var$Ua(a));
}
function $e95ce96b80fe8388$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e95ce96b80fe8388$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e95ce96b80fe8388$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e95ce96b80fe8388$var$Ya(a, b) {
    var c = b.checked;
    return $e95ce96b80fe8388$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e95ce96b80fe8388$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e95ce96b80fe8388$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e95ce96b80fe8388$var$ab(a, b) {
    b = b.checked;
    null != b && $e95ce96b80fe8388$var$ta(a, "checked", b, !1);
}
function $e95ce96b80fe8388$var$bb(a, b) {
    $e95ce96b80fe8388$var$ab(a, b);
    var c = $e95ce96b80fe8388$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e95ce96b80fe8388$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e95ce96b80fe8388$var$cb(a, b.type, $e95ce96b80fe8388$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e95ce96b80fe8388$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e95ce96b80fe8388$var$cb(a, b, c) {
    if ("number" !== b || $e95ce96b80fe8388$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e95ce96b80fe8388$var$eb = Array.isArray;
function $e95ce96b80fe8388$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e95ce96b80fe8388$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e95ce96b80fe8388$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e95ce96b80fe8388$var$p(91));
    return $e95ce96b80fe8388$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e95ce96b80fe8388$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e95ce96b80fe8388$var$p(92));
            if ($e95ce96b80fe8388$var$eb(c)) {
                if (1 < c.length) throw Error($e95ce96b80fe8388$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e95ce96b80fe8388$var$Sa(c)
    };
}
function $e95ce96b80fe8388$var$ib(a, b) {
    var c = $e95ce96b80fe8388$var$Sa(b.value), d = $e95ce96b80fe8388$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e95ce96b80fe8388$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e95ce96b80fe8388$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e95ce96b80fe8388$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e95ce96b80fe8388$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e95ce96b80fe8388$var$mb, $e95ce96b80fe8388$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e95ce96b80fe8388$var$mb = $e95ce96b80fe8388$var$mb || document.createElement("div");
        $e95ce96b80fe8388$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e95ce96b80fe8388$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e95ce96b80fe8388$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e95ce96b80fe8388$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e95ce96b80fe8388$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e95ce96b80fe8388$var$pb).forEach(function(a) {
    $e95ce96b80fe8388$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e95ce96b80fe8388$var$pb[b] = $e95ce96b80fe8388$var$pb[a];
    });
});
function $e95ce96b80fe8388$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e95ce96b80fe8388$var$pb.hasOwnProperty(a) && $e95ce96b80fe8388$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e95ce96b80fe8388$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e95ce96b80fe8388$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e95ce96b80fe8388$var$tb = $e95ce96b80fe8388$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e95ce96b80fe8388$var$ub(a, b) {
    if (b) {
        if ($e95ce96b80fe8388$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e95ce96b80fe8388$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e95ce96b80fe8388$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e95ce96b80fe8388$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e95ce96b80fe8388$var$p(62));
    }
}
function $e95ce96b80fe8388$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e95ce96b80fe8388$var$wb = null;
function $e95ce96b80fe8388$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e95ce96b80fe8388$var$yb = null, $e95ce96b80fe8388$var$zb = null, $e95ce96b80fe8388$var$Ab = null;
function $e95ce96b80fe8388$var$Bb(a) {
    if (a = $e95ce96b80fe8388$var$Cb(a)) {
        if ("function" !== typeof $e95ce96b80fe8388$var$yb) throw Error($e95ce96b80fe8388$var$p(280));
        var b = a.stateNode;
        b && (b = $e95ce96b80fe8388$var$Db(b), $e95ce96b80fe8388$var$yb(a.stateNode, a.type, b));
    }
}
function $e95ce96b80fe8388$var$Eb(a) {
    $e95ce96b80fe8388$var$zb ? $e95ce96b80fe8388$var$Ab ? $e95ce96b80fe8388$var$Ab.push(a) : $e95ce96b80fe8388$var$Ab = [
        a
    ] : $e95ce96b80fe8388$var$zb = a;
}
function $e95ce96b80fe8388$var$Fb() {
    if ($e95ce96b80fe8388$var$zb) {
        var a = $e95ce96b80fe8388$var$zb, b = $e95ce96b80fe8388$var$Ab;
        $e95ce96b80fe8388$var$Ab = $e95ce96b80fe8388$var$zb = null;
        $e95ce96b80fe8388$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e95ce96b80fe8388$var$Bb(b[a]);
    }
}
function $e95ce96b80fe8388$var$Gb(a, b) {
    return a(b);
}
function $e95ce96b80fe8388$var$Hb() {}
var $e95ce96b80fe8388$var$Ib = !1;
function $e95ce96b80fe8388$var$Jb(a, b, c) {
    if ($e95ce96b80fe8388$var$Ib) return a(b, c);
    $e95ce96b80fe8388$var$Ib = !0;
    try {
        return $e95ce96b80fe8388$var$Gb(a, b, c);
    } finally{
        if ($e95ce96b80fe8388$var$Ib = !1, null !== $e95ce96b80fe8388$var$zb || null !== $e95ce96b80fe8388$var$Ab) $e95ce96b80fe8388$var$Hb(), $e95ce96b80fe8388$var$Fb();
    }
}
function $e95ce96b80fe8388$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e95ce96b80fe8388$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e95ce96b80fe8388$var$p(231, b, typeof c));
    return c;
}
var $e95ce96b80fe8388$var$Lb = !1;
if ($e95ce96b80fe8388$var$ia) try {
    var $e95ce96b80fe8388$var$Mb = {};
    Object.defineProperty($e95ce96b80fe8388$var$Mb, "passive", {
        get: function() {
            $e95ce96b80fe8388$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e95ce96b80fe8388$var$Mb, $e95ce96b80fe8388$var$Mb);
    window.removeEventListener("test", $e95ce96b80fe8388$var$Mb, $e95ce96b80fe8388$var$Mb);
} catch (a) {
    $e95ce96b80fe8388$var$Lb = !1;
}
function $e95ce96b80fe8388$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e95ce96b80fe8388$var$Ob = !1, $e95ce96b80fe8388$var$Pb = null, $e95ce96b80fe8388$var$Qb = !1, $e95ce96b80fe8388$var$Rb = null, $e95ce96b80fe8388$var$Sb = {
    onError: function(a) {
        $e95ce96b80fe8388$var$Ob = !0;
        $e95ce96b80fe8388$var$Pb = a;
    }
};
function $e95ce96b80fe8388$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e95ce96b80fe8388$var$Ob = !1;
    $e95ce96b80fe8388$var$Pb = null;
    $e95ce96b80fe8388$var$Nb.apply($e95ce96b80fe8388$var$Sb, arguments);
}
function $e95ce96b80fe8388$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e95ce96b80fe8388$var$Tb.apply(this, arguments);
    if ($e95ce96b80fe8388$var$Ob) {
        if ($e95ce96b80fe8388$var$Ob) {
            var l = $e95ce96b80fe8388$var$Pb;
            $e95ce96b80fe8388$var$Ob = !1;
            $e95ce96b80fe8388$var$Pb = null;
        } else throw Error($e95ce96b80fe8388$var$p(198));
        $e95ce96b80fe8388$var$Qb || ($e95ce96b80fe8388$var$Qb = !0, $e95ce96b80fe8388$var$Rb = l);
    }
}
function $e95ce96b80fe8388$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e95ce96b80fe8388$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e95ce96b80fe8388$var$Xb(a) {
    if ($e95ce96b80fe8388$var$Vb(a) !== a) throw Error($e95ce96b80fe8388$var$p(188));
}
function $e95ce96b80fe8388$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e95ce96b80fe8388$var$Vb(a);
        if (null === b) throw Error($e95ce96b80fe8388$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e95ce96b80fe8388$var$Xb(e), a;
                if (f === d) return $e95ce96b80fe8388$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e95ce96b80fe8388$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e95ce96b80fe8388$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e95ce96b80fe8388$var$p(190));
    }
    if (3 !== c.tag) throw Error($e95ce96b80fe8388$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e95ce96b80fe8388$var$Zb(a) {
    a = $e95ce96b80fe8388$var$Yb(a);
    return null !== a ? $e95ce96b80fe8388$var$$b(a) : null;
}
function $e95ce96b80fe8388$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e95ce96b80fe8388$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e95ce96b80fe8388$var$ac = $7P9w1.unstable_scheduleCallback, $e95ce96b80fe8388$var$bc = $7P9w1.unstable_cancelCallback, $e95ce96b80fe8388$var$cc = $7P9w1.unstable_shouldYield, $e95ce96b80fe8388$var$dc = $7P9w1.unstable_requestPaint, $e95ce96b80fe8388$var$B = $7P9w1.unstable_now, $e95ce96b80fe8388$var$ec = $7P9w1.unstable_getCurrentPriorityLevel, $e95ce96b80fe8388$var$fc = $7P9w1.unstable_ImmediatePriority, $e95ce96b80fe8388$var$gc = $7P9w1.unstable_UserBlockingPriority, $e95ce96b80fe8388$var$hc = $7P9w1.unstable_NormalPriority, $e95ce96b80fe8388$var$ic = $7P9w1.unstable_LowPriority, $e95ce96b80fe8388$var$jc = $7P9w1.unstable_IdlePriority, $e95ce96b80fe8388$var$kc = null, $e95ce96b80fe8388$var$lc = null;
function $e95ce96b80fe8388$var$mc(a) {
    if ($e95ce96b80fe8388$var$lc && "function" === typeof $e95ce96b80fe8388$var$lc.onCommitFiberRoot) try {
        $e95ce96b80fe8388$var$lc.onCommitFiberRoot($e95ce96b80fe8388$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e95ce96b80fe8388$var$oc = Math.clz32 ? Math.clz32 : $e95ce96b80fe8388$var$nc, $e95ce96b80fe8388$var$pc = Math.log, $e95ce96b80fe8388$var$qc = Math.LN2;
function $e95ce96b80fe8388$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e95ce96b80fe8388$var$pc(a) / $e95ce96b80fe8388$var$qc | 0) | 0;
}
var $e95ce96b80fe8388$var$rc = 64, $e95ce96b80fe8388$var$sc = 4194304;
function $e95ce96b80fe8388$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e95ce96b80fe8388$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e95ce96b80fe8388$var$tc(h) : (f &= g, 0 !== f && (d = $e95ce96b80fe8388$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e95ce96b80fe8388$var$tc(g) : 0 !== f && (d = $e95ce96b80fe8388$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e95ce96b80fe8388$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e95ce96b80fe8388$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e95ce96b80fe8388$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e95ce96b80fe8388$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e95ce96b80fe8388$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e95ce96b80fe8388$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e95ce96b80fe8388$var$yc() {
    var a = $e95ce96b80fe8388$var$rc;
    $e95ce96b80fe8388$var$rc <<= 1;
    0 === ($e95ce96b80fe8388$var$rc & 4194240) && ($e95ce96b80fe8388$var$rc = 64);
    return a;
}
function $e95ce96b80fe8388$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e95ce96b80fe8388$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e95ce96b80fe8388$var$oc(b);
    a[b] = c;
}
function $e95ce96b80fe8388$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e95ce96b80fe8388$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e95ce96b80fe8388$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e95ce96b80fe8388$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e95ce96b80fe8388$var$C = 0;
function $e95ce96b80fe8388$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e95ce96b80fe8388$var$Ec, $e95ce96b80fe8388$var$Fc, $e95ce96b80fe8388$var$Gc, $e95ce96b80fe8388$var$Hc, $e95ce96b80fe8388$var$Ic, $e95ce96b80fe8388$var$Jc = !1, $e95ce96b80fe8388$var$Kc = [], $e95ce96b80fe8388$var$Lc = null, $e95ce96b80fe8388$var$Mc = null, $e95ce96b80fe8388$var$Nc = null, $e95ce96b80fe8388$var$Oc = new Map, $e95ce96b80fe8388$var$Pc = new Map, $e95ce96b80fe8388$var$Qc = [], $e95ce96b80fe8388$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e95ce96b80fe8388$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e95ce96b80fe8388$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e95ce96b80fe8388$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e95ce96b80fe8388$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e95ce96b80fe8388$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e95ce96b80fe8388$var$Pc.delete(b.pointerId);
    }
}
function $e95ce96b80fe8388$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e95ce96b80fe8388$var$Cb(b), null !== b && $e95ce96b80fe8388$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e95ce96b80fe8388$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e95ce96b80fe8388$var$Lc = $e95ce96b80fe8388$var$Tc($e95ce96b80fe8388$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e95ce96b80fe8388$var$Mc = $e95ce96b80fe8388$var$Tc($e95ce96b80fe8388$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e95ce96b80fe8388$var$Nc = $e95ce96b80fe8388$var$Tc($e95ce96b80fe8388$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e95ce96b80fe8388$var$Oc.set(f, $e95ce96b80fe8388$var$Tc($e95ce96b80fe8388$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e95ce96b80fe8388$var$Pc.set(f, $e95ce96b80fe8388$var$Tc($e95ce96b80fe8388$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e95ce96b80fe8388$var$Vc(a) {
    var b = $e95ce96b80fe8388$var$Wc(a.target);
    if (null !== b) {
        var c = $e95ce96b80fe8388$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e95ce96b80fe8388$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e95ce96b80fe8388$var$Ic(a.priority, function() {
                        $e95ce96b80fe8388$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e95ce96b80fe8388$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e95ce96b80fe8388$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e95ce96b80fe8388$var$wb = d;
            c.target.dispatchEvent(d);
            $e95ce96b80fe8388$var$wb = null;
        } else return b = $e95ce96b80fe8388$var$Cb(c), null !== b && $e95ce96b80fe8388$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e95ce96b80fe8388$var$Zc(a, b, c) {
    $e95ce96b80fe8388$var$Xc(a) && c.delete(b);
}
function $e95ce96b80fe8388$var$$c() {
    $e95ce96b80fe8388$var$Jc = !1;
    null !== $e95ce96b80fe8388$var$Lc && $e95ce96b80fe8388$var$Xc($e95ce96b80fe8388$var$Lc) && ($e95ce96b80fe8388$var$Lc = null);
    null !== $e95ce96b80fe8388$var$Mc && $e95ce96b80fe8388$var$Xc($e95ce96b80fe8388$var$Mc) && ($e95ce96b80fe8388$var$Mc = null);
    null !== $e95ce96b80fe8388$var$Nc && $e95ce96b80fe8388$var$Xc($e95ce96b80fe8388$var$Nc) && ($e95ce96b80fe8388$var$Nc = null);
    $e95ce96b80fe8388$var$Oc.forEach($e95ce96b80fe8388$var$Zc);
    $e95ce96b80fe8388$var$Pc.forEach($e95ce96b80fe8388$var$Zc);
}
function $e95ce96b80fe8388$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e95ce96b80fe8388$var$Jc || ($e95ce96b80fe8388$var$Jc = !0, $7P9w1.unstable_scheduleCallback($7P9w1.unstable_NormalPriority, $e95ce96b80fe8388$var$$c)));
}
function $e95ce96b80fe8388$var$bd(a) {
    function b(b) {
        return $e95ce96b80fe8388$var$ad(b, a);
    }
    if (0 < $e95ce96b80fe8388$var$Kc.length) {
        $e95ce96b80fe8388$var$ad($e95ce96b80fe8388$var$Kc[0], a);
        for(var c = 1; c < $e95ce96b80fe8388$var$Kc.length; c++){
            var d = $e95ce96b80fe8388$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e95ce96b80fe8388$var$Lc && $e95ce96b80fe8388$var$ad($e95ce96b80fe8388$var$Lc, a);
    null !== $e95ce96b80fe8388$var$Mc && $e95ce96b80fe8388$var$ad($e95ce96b80fe8388$var$Mc, a);
    null !== $e95ce96b80fe8388$var$Nc && $e95ce96b80fe8388$var$ad($e95ce96b80fe8388$var$Nc, a);
    $e95ce96b80fe8388$var$Oc.forEach(b);
    $e95ce96b80fe8388$var$Pc.forEach(b);
    for(c = 0; c < $e95ce96b80fe8388$var$Qc.length; c++)d = $e95ce96b80fe8388$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e95ce96b80fe8388$var$Qc.length && (c = $e95ce96b80fe8388$var$Qc[0], null === c.blockedOn);)$e95ce96b80fe8388$var$Vc(c), null === c.blockedOn && $e95ce96b80fe8388$var$Qc.shift();
}
var $e95ce96b80fe8388$var$cd = $e95ce96b80fe8388$var$ua.ReactCurrentBatchConfig, $e95ce96b80fe8388$var$dd = !0;
function $e95ce96b80fe8388$var$ed(a, b, c, d) {
    var e = $e95ce96b80fe8388$var$C, f = $e95ce96b80fe8388$var$cd.transition;
    $e95ce96b80fe8388$var$cd.transition = null;
    try {
        $e95ce96b80fe8388$var$C = 1, $e95ce96b80fe8388$var$fd(a, b, c, d);
    } finally{
        $e95ce96b80fe8388$var$C = e, $e95ce96b80fe8388$var$cd.transition = f;
    }
}
function $e95ce96b80fe8388$var$gd(a, b, c, d) {
    var e = $e95ce96b80fe8388$var$C, f = $e95ce96b80fe8388$var$cd.transition;
    $e95ce96b80fe8388$var$cd.transition = null;
    try {
        $e95ce96b80fe8388$var$C = 4, $e95ce96b80fe8388$var$fd(a, b, c, d);
    } finally{
        $e95ce96b80fe8388$var$C = e, $e95ce96b80fe8388$var$cd.transition = f;
    }
}
function $e95ce96b80fe8388$var$fd(a, b, c, d) {
    if ($e95ce96b80fe8388$var$dd) {
        var e = $e95ce96b80fe8388$var$Yc(a, b, c, d);
        if (null === e) $e95ce96b80fe8388$var$hd(a, b, d, $e95ce96b80fe8388$var$id, c), $e95ce96b80fe8388$var$Sc(a, d);
        else if ($e95ce96b80fe8388$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e95ce96b80fe8388$var$Sc(a, d), b & 4 && -1 < $e95ce96b80fe8388$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e95ce96b80fe8388$var$Cb(e);
                null !== f && $e95ce96b80fe8388$var$Ec(f);
                f = $e95ce96b80fe8388$var$Yc(a, b, c, d);
                null === f && $e95ce96b80fe8388$var$hd(a, b, d, $e95ce96b80fe8388$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e95ce96b80fe8388$var$hd(a, b, d, null, c);
    }
}
var $e95ce96b80fe8388$var$id = null;
function $e95ce96b80fe8388$var$Yc(a, b, c, d) {
    $e95ce96b80fe8388$var$id = null;
    a = $e95ce96b80fe8388$var$xb(d);
    a = $e95ce96b80fe8388$var$Wc(a);
    if (null !== a) {
        if (b = $e95ce96b80fe8388$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e95ce96b80fe8388$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e95ce96b80fe8388$var$id = a;
    return null;
}
function $e95ce96b80fe8388$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e95ce96b80fe8388$var$ec()){
                case $e95ce96b80fe8388$var$fc:
                    return 1;
                case $e95ce96b80fe8388$var$gc:
                    return 4;
                case $e95ce96b80fe8388$var$hc:
                case $e95ce96b80fe8388$var$ic:
                    return 16;
                case $e95ce96b80fe8388$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e95ce96b80fe8388$var$kd = null, $e95ce96b80fe8388$var$ld = null, $e95ce96b80fe8388$var$md = null;
function $e95ce96b80fe8388$var$nd() {
    if ($e95ce96b80fe8388$var$md) return $e95ce96b80fe8388$var$md;
    var a, b = $e95ce96b80fe8388$var$ld, c = b.length, d, e = "value" in $e95ce96b80fe8388$var$kd ? $e95ce96b80fe8388$var$kd.value : $e95ce96b80fe8388$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e95ce96b80fe8388$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e95ce96b80fe8388$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e95ce96b80fe8388$var$pd() {
    return !0;
}
function $e95ce96b80fe8388$var$qd() {
    return !1;
}
function $e95ce96b80fe8388$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e95ce96b80fe8388$var$pd : $e95ce96b80fe8388$var$qd;
        this.isPropagationStopped = $e95ce96b80fe8388$var$qd;
        return this;
    }
    $e95ce96b80fe8388$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e95ce96b80fe8388$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e95ce96b80fe8388$var$pd);
        },
        persist: function() {},
        isPersistent: $e95ce96b80fe8388$var$pd
    });
    return b;
}
var $e95ce96b80fe8388$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e95ce96b80fe8388$var$td = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$sd), $e95ce96b80fe8388$var$ud = $e95ce96b80fe8388$var$A({}, $e95ce96b80fe8388$var$sd, {
    view: 0,
    detail: 0
}), $e95ce96b80fe8388$var$vd = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$ud), $e95ce96b80fe8388$var$wd, $e95ce96b80fe8388$var$xd, $e95ce96b80fe8388$var$yd, $e95ce96b80fe8388$var$Ad = $e95ce96b80fe8388$var$A({}, $e95ce96b80fe8388$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e95ce96b80fe8388$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e95ce96b80fe8388$var$yd && ($e95ce96b80fe8388$var$yd && "mousemove" === a.type ? ($e95ce96b80fe8388$var$wd = a.screenX - $e95ce96b80fe8388$var$yd.screenX, $e95ce96b80fe8388$var$xd = a.screenY - $e95ce96b80fe8388$var$yd.screenY) : $e95ce96b80fe8388$var$xd = $e95ce96b80fe8388$var$wd = 0, $e95ce96b80fe8388$var$yd = a);
        return $e95ce96b80fe8388$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e95ce96b80fe8388$var$xd;
    }
}), $e95ce96b80fe8388$var$Bd = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$Ad), $e95ce96b80fe8388$var$Cd = $e95ce96b80fe8388$var$A({}, $e95ce96b80fe8388$var$Ad, {
    dataTransfer: 0
}), $e95ce96b80fe8388$var$Dd = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$Cd), $e95ce96b80fe8388$var$Ed = $e95ce96b80fe8388$var$A({}, $e95ce96b80fe8388$var$ud, {
    relatedTarget: 0
}), $e95ce96b80fe8388$var$Fd = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$Ed), $e95ce96b80fe8388$var$Gd = $e95ce96b80fe8388$var$A({}, $e95ce96b80fe8388$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e95ce96b80fe8388$var$Hd = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$Gd), $e95ce96b80fe8388$var$Id = $e95ce96b80fe8388$var$A({}, $e95ce96b80fe8388$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e95ce96b80fe8388$var$Jd = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$Id), $e95ce96b80fe8388$var$Kd = $e95ce96b80fe8388$var$A({}, $e95ce96b80fe8388$var$sd, {
    data: 0
}), $e95ce96b80fe8388$var$Ld = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$Kd), $e95ce96b80fe8388$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e95ce96b80fe8388$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e95ce96b80fe8388$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e95ce96b80fe8388$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e95ce96b80fe8388$var$Od[a]) ? !!b[a] : !1;
}
function $e95ce96b80fe8388$var$zd() {
    return $e95ce96b80fe8388$var$Pd;
}
var $e95ce96b80fe8388$var$Qd = $e95ce96b80fe8388$var$A({}, $e95ce96b80fe8388$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e95ce96b80fe8388$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e95ce96b80fe8388$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e95ce96b80fe8388$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e95ce96b80fe8388$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e95ce96b80fe8388$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e95ce96b80fe8388$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e95ce96b80fe8388$var$Rd = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$Qd), $e95ce96b80fe8388$var$Sd = $e95ce96b80fe8388$var$A({}, $e95ce96b80fe8388$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e95ce96b80fe8388$var$Td = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$Sd), $e95ce96b80fe8388$var$Ud = $e95ce96b80fe8388$var$A({}, $e95ce96b80fe8388$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e95ce96b80fe8388$var$zd
}), $e95ce96b80fe8388$var$Vd = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$Ud), $e95ce96b80fe8388$var$Wd = $e95ce96b80fe8388$var$A({}, $e95ce96b80fe8388$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e95ce96b80fe8388$var$Xd = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$Wd), $e95ce96b80fe8388$var$Yd = $e95ce96b80fe8388$var$A({}, $e95ce96b80fe8388$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e95ce96b80fe8388$var$Zd = $e95ce96b80fe8388$var$rd($e95ce96b80fe8388$var$Yd), $e95ce96b80fe8388$var$$d = [
    9,
    13,
    27,
    32
], $e95ce96b80fe8388$var$ae = $e95ce96b80fe8388$var$ia && "CompositionEvent" in window, $e95ce96b80fe8388$var$be = null;
$e95ce96b80fe8388$var$ia && "documentMode" in document && ($e95ce96b80fe8388$var$be = document.documentMode);
var $e95ce96b80fe8388$var$ce = $e95ce96b80fe8388$var$ia && "TextEvent" in window && !$e95ce96b80fe8388$var$be, $e95ce96b80fe8388$var$de = $e95ce96b80fe8388$var$ia && (!$e95ce96b80fe8388$var$ae || $e95ce96b80fe8388$var$be && 8 < $e95ce96b80fe8388$var$be && 11 >= $e95ce96b80fe8388$var$be), $e95ce96b80fe8388$var$ee = String.fromCharCode(32), $e95ce96b80fe8388$var$fe = !1;
function $e95ce96b80fe8388$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e95ce96b80fe8388$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e95ce96b80fe8388$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e95ce96b80fe8388$var$ie = !1;
function $e95ce96b80fe8388$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e95ce96b80fe8388$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e95ce96b80fe8388$var$fe = !0;
            return $e95ce96b80fe8388$var$ee;
        case "textInput":
            return a = b.data, a === $e95ce96b80fe8388$var$ee && $e95ce96b80fe8388$var$fe ? null : a;
        default:
            return null;
    }
}
function $e95ce96b80fe8388$var$ke(a, b) {
    if ($e95ce96b80fe8388$var$ie) return "compositionend" === a || !$e95ce96b80fe8388$var$ae && $e95ce96b80fe8388$var$ge(a, b) ? (a = $e95ce96b80fe8388$var$nd(), $e95ce96b80fe8388$var$md = $e95ce96b80fe8388$var$ld = $e95ce96b80fe8388$var$kd = null, $e95ce96b80fe8388$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e95ce96b80fe8388$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e95ce96b80fe8388$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e95ce96b80fe8388$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e95ce96b80fe8388$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e95ce96b80fe8388$var$ne(a, b, c, d) {
    $e95ce96b80fe8388$var$Eb(d);
    b = $e95ce96b80fe8388$var$oe(b, "onChange");
    0 < b.length && (c = new $e95ce96b80fe8388$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e95ce96b80fe8388$var$pe = null, $e95ce96b80fe8388$var$qe = null;
function $e95ce96b80fe8388$var$re(a) {
    $e95ce96b80fe8388$var$se(a, 0);
}
function $e95ce96b80fe8388$var$te(a) {
    var b = $e95ce96b80fe8388$var$ue(a);
    if ($e95ce96b80fe8388$var$Wa(b)) return a;
}
function $e95ce96b80fe8388$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e95ce96b80fe8388$var$we = !1;
if ($e95ce96b80fe8388$var$ia) {
    var $e95ce96b80fe8388$var$xe;
    if ($e95ce96b80fe8388$var$ia) {
        var $e95ce96b80fe8388$var$ye = "oninput" in document;
        if (!$e95ce96b80fe8388$var$ye) {
            var $e95ce96b80fe8388$var$ze = document.createElement("div");
            $e95ce96b80fe8388$var$ze.setAttribute("oninput", "return;");
            $e95ce96b80fe8388$var$ye = "function" === typeof $e95ce96b80fe8388$var$ze.oninput;
        }
        $e95ce96b80fe8388$var$xe = $e95ce96b80fe8388$var$ye;
    } else $e95ce96b80fe8388$var$xe = !1;
    $e95ce96b80fe8388$var$we = $e95ce96b80fe8388$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e95ce96b80fe8388$var$Ae() {
    $e95ce96b80fe8388$var$pe && ($e95ce96b80fe8388$var$pe.detachEvent("onpropertychange", $e95ce96b80fe8388$var$Be), $e95ce96b80fe8388$var$qe = $e95ce96b80fe8388$var$pe = null);
}
function $e95ce96b80fe8388$var$Be(a) {
    if ("value" === a.propertyName && $e95ce96b80fe8388$var$te($e95ce96b80fe8388$var$qe)) {
        var b = [];
        $e95ce96b80fe8388$var$ne(b, $e95ce96b80fe8388$var$qe, a, $e95ce96b80fe8388$var$xb(a));
        $e95ce96b80fe8388$var$Jb($e95ce96b80fe8388$var$re, b);
    }
}
function $e95ce96b80fe8388$var$Ce(a, b, c) {
    "focusin" === a ? ($e95ce96b80fe8388$var$Ae(), $e95ce96b80fe8388$var$pe = b, $e95ce96b80fe8388$var$qe = c, $e95ce96b80fe8388$var$pe.attachEvent("onpropertychange", $e95ce96b80fe8388$var$Be)) : "focusout" === a && $e95ce96b80fe8388$var$Ae();
}
function $e95ce96b80fe8388$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e95ce96b80fe8388$var$te($e95ce96b80fe8388$var$qe);
}
function $e95ce96b80fe8388$var$Ee(a, b) {
    if ("click" === a) return $e95ce96b80fe8388$var$te(b);
}
function $e95ce96b80fe8388$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e95ce96b80fe8388$var$te(b);
}
function $e95ce96b80fe8388$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e95ce96b80fe8388$var$He = "function" === typeof Object.is ? Object.is : $e95ce96b80fe8388$var$Ge;
function $e95ce96b80fe8388$var$Ie(a, b) {
    if ($e95ce96b80fe8388$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e95ce96b80fe8388$var$ja.call(b, e) || !$e95ce96b80fe8388$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e95ce96b80fe8388$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e95ce96b80fe8388$var$Ke(a, b) {
    var c = $e95ce96b80fe8388$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e95ce96b80fe8388$var$Je(c);
    }
}
function $e95ce96b80fe8388$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e95ce96b80fe8388$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e95ce96b80fe8388$var$Me() {
    for(var a = window, b = $e95ce96b80fe8388$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e95ce96b80fe8388$var$Xa(a.document);
    }
    return b;
}
function $e95ce96b80fe8388$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e95ce96b80fe8388$var$Oe(a) {
    var b = $e95ce96b80fe8388$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e95ce96b80fe8388$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e95ce96b80fe8388$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e95ce96b80fe8388$var$Ke(c, f);
                var g = $e95ce96b80fe8388$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e95ce96b80fe8388$var$Pe = $e95ce96b80fe8388$var$ia && "documentMode" in document && 11 >= document.documentMode, $e95ce96b80fe8388$var$Qe = null, $e95ce96b80fe8388$var$Re = null, $e95ce96b80fe8388$var$Se = null, $e95ce96b80fe8388$var$Te = !1;
function $e95ce96b80fe8388$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e95ce96b80fe8388$var$Te || null == $e95ce96b80fe8388$var$Qe || $e95ce96b80fe8388$var$Qe !== $e95ce96b80fe8388$var$Xa(d) || (d = $e95ce96b80fe8388$var$Qe, "selectionStart" in d && $e95ce96b80fe8388$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e95ce96b80fe8388$var$Se && $e95ce96b80fe8388$var$Ie($e95ce96b80fe8388$var$Se, d) || ($e95ce96b80fe8388$var$Se = d, d = $e95ce96b80fe8388$var$oe($e95ce96b80fe8388$var$Re, "onSelect"), 0 < d.length && (b = new $e95ce96b80fe8388$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e95ce96b80fe8388$var$Qe)));
}
function $e95ce96b80fe8388$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e95ce96b80fe8388$var$We = {
    animationend: $e95ce96b80fe8388$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e95ce96b80fe8388$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e95ce96b80fe8388$var$Ve("Animation", "AnimationStart"),
    transitionend: $e95ce96b80fe8388$var$Ve("Transition", "TransitionEnd")
}, $e95ce96b80fe8388$var$Xe = {}, $e95ce96b80fe8388$var$Ye = {};
$e95ce96b80fe8388$var$ia && ($e95ce96b80fe8388$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e95ce96b80fe8388$var$We.animationend.animation, delete $e95ce96b80fe8388$var$We.animationiteration.animation, delete $e95ce96b80fe8388$var$We.animationstart.animation), "TransitionEvent" in window || delete $e95ce96b80fe8388$var$We.transitionend.transition);
function $e95ce96b80fe8388$var$Ze(a) {
    if ($e95ce96b80fe8388$var$Xe[a]) return $e95ce96b80fe8388$var$Xe[a];
    if (!$e95ce96b80fe8388$var$We[a]) return a;
    var b = $e95ce96b80fe8388$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e95ce96b80fe8388$var$Ye) return $e95ce96b80fe8388$var$Xe[a] = b[c];
    return a;
}
var $e95ce96b80fe8388$var$$e = $e95ce96b80fe8388$var$Ze("animationend"), $e95ce96b80fe8388$var$af = $e95ce96b80fe8388$var$Ze("animationiteration"), $e95ce96b80fe8388$var$bf = $e95ce96b80fe8388$var$Ze("animationstart"), $e95ce96b80fe8388$var$cf = $e95ce96b80fe8388$var$Ze("transitionend"), $e95ce96b80fe8388$var$df = new Map, $e95ce96b80fe8388$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e95ce96b80fe8388$var$ff(a, b) {
    $e95ce96b80fe8388$var$df.set(a, b);
    $e95ce96b80fe8388$var$fa(b, [
        a
    ]);
}
for(var $e95ce96b80fe8388$var$gf = 0; $e95ce96b80fe8388$var$gf < $e95ce96b80fe8388$var$ef.length; $e95ce96b80fe8388$var$gf++){
    var $e95ce96b80fe8388$var$hf = $e95ce96b80fe8388$var$ef[$e95ce96b80fe8388$var$gf], $e95ce96b80fe8388$var$jf = $e95ce96b80fe8388$var$hf.toLowerCase(), $e95ce96b80fe8388$var$kf = $e95ce96b80fe8388$var$hf[0].toUpperCase() + $e95ce96b80fe8388$var$hf.slice(1);
    $e95ce96b80fe8388$var$ff($e95ce96b80fe8388$var$jf, "on" + $e95ce96b80fe8388$var$kf);
}
$e95ce96b80fe8388$var$ff($e95ce96b80fe8388$var$$e, "onAnimationEnd");
$e95ce96b80fe8388$var$ff($e95ce96b80fe8388$var$af, "onAnimationIteration");
$e95ce96b80fe8388$var$ff($e95ce96b80fe8388$var$bf, "onAnimationStart");
$e95ce96b80fe8388$var$ff("dblclick", "onDoubleClick");
$e95ce96b80fe8388$var$ff("focusin", "onFocus");
$e95ce96b80fe8388$var$ff("focusout", "onBlur");
$e95ce96b80fe8388$var$ff($e95ce96b80fe8388$var$cf, "onTransitionEnd");
$e95ce96b80fe8388$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e95ce96b80fe8388$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e95ce96b80fe8388$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e95ce96b80fe8388$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e95ce96b80fe8388$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e95ce96b80fe8388$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e95ce96b80fe8388$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e95ce96b80fe8388$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e95ce96b80fe8388$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e95ce96b80fe8388$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e95ce96b80fe8388$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e95ce96b80fe8388$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e95ce96b80fe8388$var$lf));
function $e95ce96b80fe8388$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e95ce96b80fe8388$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e95ce96b80fe8388$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e95ce96b80fe8388$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e95ce96b80fe8388$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e95ce96b80fe8388$var$Qb) throw a = $e95ce96b80fe8388$var$Rb, $e95ce96b80fe8388$var$Qb = !1, $e95ce96b80fe8388$var$Rb = null, a;
}
function $e95ce96b80fe8388$var$D(a, b) {
    var c = b[$e95ce96b80fe8388$var$of];
    void 0 === c && (c = b[$e95ce96b80fe8388$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e95ce96b80fe8388$var$pf(b, a, 2, !1), c.add(d));
}
function $e95ce96b80fe8388$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e95ce96b80fe8388$var$pf(c, a, d, b);
}
var $e95ce96b80fe8388$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e95ce96b80fe8388$var$sf(a) {
    if (!a[$e95ce96b80fe8388$var$rf]) {
        a[$e95ce96b80fe8388$var$rf] = !0;
        $e95ce96b80fe8388$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e95ce96b80fe8388$var$mf.has(b) || $e95ce96b80fe8388$var$qf(b, !1, a), $e95ce96b80fe8388$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e95ce96b80fe8388$var$rf] || (b[$e95ce96b80fe8388$var$rf] = !0, $e95ce96b80fe8388$var$qf("selectionchange", !1, b));
    }
}
function $e95ce96b80fe8388$var$pf(a, b, c, d) {
    switch($e95ce96b80fe8388$var$jd(b)){
        case 1:
            var e = $e95ce96b80fe8388$var$ed;
            break;
        case 4:
            e = $e95ce96b80fe8388$var$gd;
            break;
        default:
            e = $e95ce96b80fe8388$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e95ce96b80fe8388$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e95ce96b80fe8388$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e95ce96b80fe8388$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e95ce96b80fe8388$var$Jb(function() {
        var d = f, e = $e95ce96b80fe8388$var$xb(c), g = [];
        a: {
            var h = $e95ce96b80fe8388$var$df.get(a);
            if (void 0 !== h) {
                var k = $e95ce96b80fe8388$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e95ce96b80fe8388$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e95ce96b80fe8388$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e95ce96b80fe8388$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e95ce96b80fe8388$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e95ce96b80fe8388$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e95ce96b80fe8388$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e95ce96b80fe8388$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e95ce96b80fe8388$var$Vd;
                        break;
                    case $e95ce96b80fe8388$var$$e:
                    case $e95ce96b80fe8388$var$af:
                    case $e95ce96b80fe8388$var$bf:
                        k = $e95ce96b80fe8388$var$Hd;
                        break;
                    case $e95ce96b80fe8388$var$cf:
                        k = $e95ce96b80fe8388$var$Xd;
                        break;
                    case "scroll":
                        k = $e95ce96b80fe8388$var$vd;
                        break;
                    case "wheel":
                        k = $e95ce96b80fe8388$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e95ce96b80fe8388$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e95ce96b80fe8388$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e95ce96b80fe8388$var$Kb(w, x), null != F && t.push($e95ce96b80fe8388$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e95ce96b80fe8388$var$wb && (n = c.relatedTarget || c.fromElement) && ($e95ce96b80fe8388$var$Wc(n) || n[$e95ce96b80fe8388$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e95ce96b80fe8388$var$Wc(n) : null, null !== n && (J = $e95ce96b80fe8388$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e95ce96b80fe8388$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e95ce96b80fe8388$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e95ce96b80fe8388$var$ue(k);
                        u = null == n ? h : $e95ce96b80fe8388$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e95ce96b80fe8388$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e95ce96b80fe8388$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e95ce96b80fe8388$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e95ce96b80fe8388$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e95ce96b80fe8388$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e95ce96b80fe8388$var$vf(t);
                                x = $e95ce96b80fe8388$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e95ce96b80fe8388$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e95ce96b80fe8388$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e95ce96b80fe8388$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e95ce96b80fe8388$var$ve;
                else if ($e95ce96b80fe8388$var$me(h)) {
                    if ($e95ce96b80fe8388$var$we) na = $e95ce96b80fe8388$var$Fe;
                    else {
                        na = $e95ce96b80fe8388$var$De;
                        var xa = $e95ce96b80fe8388$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e95ce96b80fe8388$var$Ee);
                if (na && (na = na(a, d))) {
                    $e95ce96b80fe8388$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e95ce96b80fe8388$var$cb(h, "number", h.value);
            }
            xa = d ? $e95ce96b80fe8388$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e95ce96b80fe8388$var$me(xa) || "true" === xa.contentEditable) $e95ce96b80fe8388$var$Qe = xa, $e95ce96b80fe8388$var$Re = d, $e95ce96b80fe8388$var$Se = null;
                    break;
                case "focusout":
                    $e95ce96b80fe8388$var$Se = $e95ce96b80fe8388$var$Re = $e95ce96b80fe8388$var$Qe = null;
                    break;
                case "mousedown":
                    $e95ce96b80fe8388$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e95ce96b80fe8388$var$Te = !1;
                    $e95ce96b80fe8388$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e95ce96b80fe8388$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e95ce96b80fe8388$var$Ue(g, c, e);
            }
            var $a;
            if ($e95ce96b80fe8388$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e95ce96b80fe8388$var$ie ? $e95ce96b80fe8388$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e95ce96b80fe8388$var$de && "ko" !== c.locale && ($e95ce96b80fe8388$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e95ce96b80fe8388$var$ie && ($a = $e95ce96b80fe8388$var$nd()) : ($e95ce96b80fe8388$var$kd = e, $e95ce96b80fe8388$var$ld = "value" in $e95ce96b80fe8388$var$kd ? $e95ce96b80fe8388$var$kd.value : $e95ce96b80fe8388$var$kd.textContent, $e95ce96b80fe8388$var$ie = !0)), xa = $e95ce96b80fe8388$var$oe(d, ba), 0 < xa.length && (ba = new $e95ce96b80fe8388$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e95ce96b80fe8388$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e95ce96b80fe8388$var$ce ? $e95ce96b80fe8388$var$je(a, c) : $e95ce96b80fe8388$var$ke(a, c)) d = $e95ce96b80fe8388$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e95ce96b80fe8388$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e95ce96b80fe8388$var$se(g, b);
    });
}
function $e95ce96b80fe8388$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e95ce96b80fe8388$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e95ce96b80fe8388$var$Kb(a, c), null != f && d.unshift($e95ce96b80fe8388$var$tf(a, f, e)), f = $e95ce96b80fe8388$var$Kb(a, b), null != f && d.push($e95ce96b80fe8388$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e95ce96b80fe8388$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e95ce96b80fe8388$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e95ce96b80fe8388$var$Kb(c, f), null != k && g.unshift($e95ce96b80fe8388$var$tf(c, k, h))) : e || (k = $e95ce96b80fe8388$var$Kb(c, f), null != k && g.push($e95ce96b80fe8388$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e95ce96b80fe8388$var$xf = /\r\n?/g, $e95ce96b80fe8388$var$yf = /\u0000|\uFFFD/g;
function $e95ce96b80fe8388$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e95ce96b80fe8388$var$xf, "\n").replace($e95ce96b80fe8388$var$yf, "");
}
function $e95ce96b80fe8388$var$Af(a, b, c) {
    b = $e95ce96b80fe8388$var$zf(b);
    if ($e95ce96b80fe8388$var$zf(a) !== b && c) throw Error($e95ce96b80fe8388$var$p(425));
}
function $e95ce96b80fe8388$var$Bf() {}
var $e95ce96b80fe8388$var$Cf = null, $e95ce96b80fe8388$var$Df = null;
function $e95ce96b80fe8388$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e95ce96b80fe8388$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e95ce96b80fe8388$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e95ce96b80fe8388$var$Hf = "function" === typeof Promise ? Promise : void 0, $e95ce96b80fe8388$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e95ce96b80fe8388$var$Hf ? function(a) {
    return $e95ce96b80fe8388$var$Hf.resolve(null).then(a).catch($e95ce96b80fe8388$var$If);
} : $e95ce96b80fe8388$var$Ff;
function $e95ce96b80fe8388$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e95ce96b80fe8388$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e95ce96b80fe8388$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e95ce96b80fe8388$var$bd(b);
}
function $e95ce96b80fe8388$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e95ce96b80fe8388$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e95ce96b80fe8388$var$Nf = Math.random().toString(36).slice(2), $e95ce96b80fe8388$var$Of = "__reactFiber$" + $e95ce96b80fe8388$var$Nf, $e95ce96b80fe8388$var$Pf = "__reactProps$" + $e95ce96b80fe8388$var$Nf, $e95ce96b80fe8388$var$uf = "__reactContainer$" + $e95ce96b80fe8388$var$Nf, $e95ce96b80fe8388$var$of = "__reactEvents$" + $e95ce96b80fe8388$var$Nf, $e95ce96b80fe8388$var$Qf = "__reactListeners$" + $e95ce96b80fe8388$var$Nf, $e95ce96b80fe8388$var$Rf = "__reactHandles$" + $e95ce96b80fe8388$var$Nf;
function $e95ce96b80fe8388$var$Wc(a) {
    var b = a[$e95ce96b80fe8388$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e95ce96b80fe8388$var$uf] || c[$e95ce96b80fe8388$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e95ce96b80fe8388$var$Mf(a); null !== a;){
                if (c = a[$e95ce96b80fe8388$var$Of]) return c;
                a = $e95ce96b80fe8388$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e95ce96b80fe8388$var$Cb(a) {
    a = a[$e95ce96b80fe8388$var$Of] || a[$e95ce96b80fe8388$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e95ce96b80fe8388$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e95ce96b80fe8388$var$p(33));
}
function $e95ce96b80fe8388$var$Db(a) {
    return a[$e95ce96b80fe8388$var$Pf] || null;
}
var $e95ce96b80fe8388$var$Sf = [], $e95ce96b80fe8388$var$Tf = -1;
function $e95ce96b80fe8388$var$Uf(a) {
    return {
        current: a
    };
}
function $e95ce96b80fe8388$var$E(a) {
    0 > $e95ce96b80fe8388$var$Tf || (a.current = $e95ce96b80fe8388$var$Sf[$e95ce96b80fe8388$var$Tf], $e95ce96b80fe8388$var$Sf[$e95ce96b80fe8388$var$Tf] = null, $e95ce96b80fe8388$var$Tf--);
}
function $e95ce96b80fe8388$var$G(a, b) {
    $e95ce96b80fe8388$var$Tf++;
    $e95ce96b80fe8388$var$Sf[$e95ce96b80fe8388$var$Tf] = a.current;
    a.current = b;
}
var $e95ce96b80fe8388$var$Vf = {}, $e95ce96b80fe8388$var$H = $e95ce96b80fe8388$var$Uf($e95ce96b80fe8388$var$Vf), $e95ce96b80fe8388$var$Wf = $e95ce96b80fe8388$var$Uf(!1), $e95ce96b80fe8388$var$Xf = $e95ce96b80fe8388$var$Vf;
function $e95ce96b80fe8388$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e95ce96b80fe8388$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e95ce96b80fe8388$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e95ce96b80fe8388$var$$f() {
    $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$Wf);
    $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$H);
}
function $e95ce96b80fe8388$var$ag(a, b, c) {
    if ($e95ce96b80fe8388$var$H.current !== $e95ce96b80fe8388$var$Vf) throw Error($e95ce96b80fe8388$var$p(168));
    $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$H, b);
    $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$Wf, c);
}
function $e95ce96b80fe8388$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e95ce96b80fe8388$var$p(108, $e95ce96b80fe8388$var$Ra(a) || "Unknown", e));
    return $e95ce96b80fe8388$var$A({}, c, d);
}
function $e95ce96b80fe8388$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e95ce96b80fe8388$var$Vf;
    $e95ce96b80fe8388$var$Xf = $e95ce96b80fe8388$var$H.current;
    $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$H, a);
    $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$Wf, $e95ce96b80fe8388$var$Wf.current);
    return !0;
}
function $e95ce96b80fe8388$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e95ce96b80fe8388$var$p(169));
    c ? (a = $e95ce96b80fe8388$var$bg(a, b, $e95ce96b80fe8388$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$Wf), $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$H), $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$H, a)) : $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$Wf);
    $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$Wf, c);
}
var $e95ce96b80fe8388$var$eg = null, $e95ce96b80fe8388$var$fg = !1, $e95ce96b80fe8388$var$gg = !1;
function $e95ce96b80fe8388$var$hg(a) {
    null === $e95ce96b80fe8388$var$eg ? $e95ce96b80fe8388$var$eg = [
        a
    ] : $e95ce96b80fe8388$var$eg.push(a);
}
function $e95ce96b80fe8388$var$ig(a) {
    $e95ce96b80fe8388$var$fg = !0;
    $e95ce96b80fe8388$var$hg(a);
}
function $e95ce96b80fe8388$var$jg() {
    if (!$e95ce96b80fe8388$var$gg && null !== $e95ce96b80fe8388$var$eg) {
        $e95ce96b80fe8388$var$gg = !0;
        var a = 0, b = $e95ce96b80fe8388$var$C;
        try {
            var c = $e95ce96b80fe8388$var$eg;
            for($e95ce96b80fe8388$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e95ce96b80fe8388$var$eg = null;
            $e95ce96b80fe8388$var$fg = !1;
        } catch (e) {
            throw null !== $e95ce96b80fe8388$var$eg && ($e95ce96b80fe8388$var$eg = $e95ce96b80fe8388$var$eg.slice(a + 1)), $e95ce96b80fe8388$var$ac($e95ce96b80fe8388$var$fc, $e95ce96b80fe8388$var$jg), e;
        } finally{
            $e95ce96b80fe8388$var$C = b, $e95ce96b80fe8388$var$gg = !1;
        }
    }
    return null;
}
var $e95ce96b80fe8388$var$kg = [], $e95ce96b80fe8388$var$lg = 0, $e95ce96b80fe8388$var$mg = null, $e95ce96b80fe8388$var$ng = 0, $e95ce96b80fe8388$var$og = [], $e95ce96b80fe8388$var$pg = 0, $e95ce96b80fe8388$var$qg = null, $e95ce96b80fe8388$var$rg = 1, $e95ce96b80fe8388$var$sg = "";
function $e95ce96b80fe8388$var$tg(a, b) {
    $e95ce96b80fe8388$var$kg[$e95ce96b80fe8388$var$lg++] = $e95ce96b80fe8388$var$ng;
    $e95ce96b80fe8388$var$kg[$e95ce96b80fe8388$var$lg++] = $e95ce96b80fe8388$var$mg;
    $e95ce96b80fe8388$var$mg = a;
    $e95ce96b80fe8388$var$ng = b;
}
function $e95ce96b80fe8388$var$ug(a, b, c) {
    $e95ce96b80fe8388$var$og[$e95ce96b80fe8388$var$pg++] = $e95ce96b80fe8388$var$rg;
    $e95ce96b80fe8388$var$og[$e95ce96b80fe8388$var$pg++] = $e95ce96b80fe8388$var$sg;
    $e95ce96b80fe8388$var$og[$e95ce96b80fe8388$var$pg++] = $e95ce96b80fe8388$var$qg;
    $e95ce96b80fe8388$var$qg = a;
    var d = $e95ce96b80fe8388$var$rg;
    a = $e95ce96b80fe8388$var$sg;
    var e = 32 - $e95ce96b80fe8388$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e95ce96b80fe8388$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e95ce96b80fe8388$var$rg = 1 << 32 - $e95ce96b80fe8388$var$oc(b) + e | c << e | d;
        $e95ce96b80fe8388$var$sg = f + a;
    } else $e95ce96b80fe8388$var$rg = 1 << f | c << e | d, $e95ce96b80fe8388$var$sg = a;
}
function $e95ce96b80fe8388$var$vg(a) {
    null !== a.return && ($e95ce96b80fe8388$var$tg(a, 1), $e95ce96b80fe8388$var$ug(a, 1, 0));
}
function $e95ce96b80fe8388$var$wg(a) {
    for(; a === $e95ce96b80fe8388$var$mg;)$e95ce96b80fe8388$var$mg = $e95ce96b80fe8388$var$kg[--$e95ce96b80fe8388$var$lg], $e95ce96b80fe8388$var$kg[$e95ce96b80fe8388$var$lg] = null, $e95ce96b80fe8388$var$ng = $e95ce96b80fe8388$var$kg[--$e95ce96b80fe8388$var$lg], $e95ce96b80fe8388$var$kg[$e95ce96b80fe8388$var$lg] = null;
    for(; a === $e95ce96b80fe8388$var$qg;)$e95ce96b80fe8388$var$qg = $e95ce96b80fe8388$var$og[--$e95ce96b80fe8388$var$pg], $e95ce96b80fe8388$var$og[$e95ce96b80fe8388$var$pg] = null, $e95ce96b80fe8388$var$sg = $e95ce96b80fe8388$var$og[--$e95ce96b80fe8388$var$pg], $e95ce96b80fe8388$var$og[$e95ce96b80fe8388$var$pg] = null, $e95ce96b80fe8388$var$rg = $e95ce96b80fe8388$var$og[--$e95ce96b80fe8388$var$pg], $e95ce96b80fe8388$var$og[$e95ce96b80fe8388$var$pg] = null;
}
var $e95ce96b80fe8388$var$xg = null, $e95ce96b80fe8388$var$yg = null, $e95ce96b80fe8388$var$I = !1, $e95ce96b80fe8388$var$zg = null;
function $e95ce96b80fe8388$var$Ag(a, b) {
    var c = $e95ce96b80fe8388$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e95ce96b80fe8388$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e95ce96b80fe8388$var$xg = a, $e95ce96b80fe8388$var$yg = $e95ce96b80fe8388$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e95ce96b80fe8388$var$xg = a, $e95ce96b80fe8388$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e95ce96b80fe8388$var$qg ? {
                id: $e95ce96b80fe8388$var$rg,
                overflow: $e95ce96b80fe8388$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e95ce96b80fe8388$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e95ce96b80fe8388$var$xg = a, $e95ce96b80fe8388$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e95ce96b80fe8388$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e95ce96b80fe8388$var$Eg(a) {
    if ($e95ce96b80fe8388$var$I) {
        var b = $e95ce96b80fe8388$var$yg;
        if (b) {
            var c = b;
            if (!$e95ce96b80fe8388$var$Cg(a, b)) {
                if ($e95ce96b80fe8388$var$Dg(a)) throw Error($e95ce96b80fe8388$var$p(418));
                b = $e95ce96b80fe8388$var$Lf(c.nextSibling);
                var d = $e95ce96b80fe8388$var$xg;
                b && $e95ce96b80fe8388$var$Cg(a, b) ? $e95ce96b80fe8388$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e95ce96b80fe8388$var$I = !1, $e95ce96b80fe8388$var$xg = a);
            }
        } else {
            if ($e95ce96b80fe8388$var$Dg(a)) throw Error($e95ce96b80fe8388$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e95ce96b80fe8388$var$I = !1;
            $e95ce96b80fe8388$var$xg = a;
        }
    }
}
function $e95ce96b80fe8388$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e95ce96b80fe8388$var$xg = a;
}
function $e95ce96b80fe8388$var$Gg(a) {
    if (a !== $e95ce96b80fe8388$var$xg) return !1;
    if (!$e95ce96b80fe8388$var$I) return $e95ce96b80fe8388$var$Fg(a), $e95ce96b80fe8388$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e95ce96b80fe8388$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e95ce96b80fe8388$var$yg)) {
        if ($e95ce96b80fe8388$var$Dg(a)) throw $e95ce96b80fe8388$var$Hg(), Error($e95ce96b80fe8388$var$p(418));
        for(; b;)$e95ce96b80fe8388$var$Ag(a, b), b = $e95ce96b80fe8388$var$Lf(b.nextSibling);
    }
    $e95ce96b80fe8388$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e95ce96b80fe8388$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e95ce96b80fe8388$var$yg = $e95ce96b80fe8388$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e95ce96b80fe8388$var$yg = null;
        }
    } else $e95ce96b80fe8388$var$yg = $e95ce96b80fe8388$var$xg ? $e95ce96b80fe8388$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e95ce96b80fe8388$var$Hg() {
    for(var a = $e95ce96b80fe8388$var$yg; a;)a = $e95ce96b80fe8388$var$Lf(a.nextSibling);
}
function $e95ce96b80fe8388$var$Ig() {
    $e95ce96b80fe8388$var$yg = $e95ce96b80fe8388$var$xg = null;
    $e95ce96b80fe8388$var$I = !1;
}
function $e95ce96b80fe8388$var$Jg(a) {
    null === $e95ce96b80fe8388$var$zg ? $e95ce96b80fe8388$var$zg = [
        a
    ] : $e95ce96b80fe8388$var$zg.push(a);
}
var $e95ce96b80fe8388$var$Kg = $e95ce96b80fe8388$var$ua.ReactCurrentBatchConfig;
function $e95ce96b80fe8388$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e95ce96b80fe8388$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e95ce96b80fe8388$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e95ce96b80fe8388$var$p(284));
        if (!c._owner) throw Error($e95ce96b80fe8388$var$p(290, a));
    }
    return a;
}
function $e95ce96b80fe8388$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e95ce96b80fe8388$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e95ce96b80fe8388$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $e95ce96b80fe8388$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e95ce96b80fe8388$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e95ce96b80fe8388$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e95ce96b80fe8388$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e95ce96b80fe8388$var$Ha && $e95ce96b80fe8388$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $e95ce96b80fe8388$var$Lg(a, b, c), d.return = a, d;
        d = $e95ce96b80fe8388$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e95ce96b80fe8388$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e95ce96b80fe8388$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e95ce96b80fe8388$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e95ce96b80fe8388$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e95ce96b80fe8388$var$va:
                    return c = $e95ce96b80fe8388$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $e95ce96b80fe8388$var$Lg(a, null, b), c.return = a, c;
                case $e95ce96b80fe8388$var$wa:
                    return b = $e95ce96b80fe8388$var$Sg(b, a.mode, c), b.return = a, b;
                case $e95ce96b80fe8388$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e95ce96b80fe8388$var$eb(b) || $e95ce96b80fe8388$var$Ka(b)) return b = $e95ce96b80fe8388$var$Tg(b, a.mode, c, null), b.return = a, b;
            $e95ce96b80fe8388$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e95ce96b80fe8388$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e95ce96b80fe8388$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e95ce96b80fe8388$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e95ce96b80fe8388$var$eb(c) || $e95ce96b80fe8388$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e95ce96b80fe8388$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e95ce96b80fe8388$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e95ce96b80fe8388$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e95ce96b80fe8388$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e95ce96b80fe8388$var$eb(d) || $e95ce96b80fe8388$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e95ce96b80fe8388$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e95ce96b80fe8388$var$I && $e95ce96b80fe8388$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e95ce96b80fe8388$var$I && $e95ce96b80fe8388$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e95ce96b80fe8388$var$I && $e95ce96b80fe8388$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e95ce96b80fe8388$var$Ka(h);
        if ("function" !== typeof l) throw Error($e95ce96b80fe8388$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e95ce96b80fe8388$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e95ce96b80fe8388$var$I && $e95ce96b80fe8388$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e95ce96b80fe8388$var$I && $e95ce96b80fe8388$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e95ce96b80fe8388$var$I && $e95ce96b80fe8388$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e95ce96b80fe8388$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e95ce96b80fe8388$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e95ce96b80fe8388$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e95ce96b80fe8388$var$Ha && $e95ce96b80fe8388$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e95ce96b80fe8388$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e95ce96b80fe8388$var$ya ? (d = $e95ce96b80fe8388$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e95ce96b80fe8388$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $e95ce96b80fe8388$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e95ce96b80fe8388$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e95ce96b80fe8388$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e95ce96b80fe8388$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e95ce96b80fe8388$var$eb(f)) return n(a, d, f, h);
            if ($e95ce96b80fe8388$var$Ka(f)) return t(a, d, f, h);
            $e95ce96b80fe8388$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e95ce96b80fe8388$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e95ce96b80fe8388$var$Ug = $e95ce96b80fe8388$var$Og(!0), $e95ce96b80fe8388$var$Vg = $e95ce96b80fe8388$var$Og(!1), $e95ce96b80fe8388$var$Wg = $e95ce96b80fe8388$var$Uf(null), $e95ce96b80fe8388$var$Xg = null, $e95ce96b80fe8388$var$Yg = null, $e95ce96b80fe8388$var$Zg = null;
function $e95ce96b80fe8388$var$$g() {
    $e95ce96b80fe8388$var$Zg = $e95ce96b80fe8388$var$Yg = $e95ce96b80fe8388$var$Xg = null;
}
function $e95ce96b80fe8388$var$ah(a) {
    var b = $e95ce96b80fe8388$var$Wg.current;
    $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$Wg);
    a._currentValue = b;
}
function $e95ce96b80fe8388$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e95ce96b80fe8388$var$ch(a, b) {
    $e95ce96b80fe8388$var$Xg = a;
    $e95ce96b80fe8388$var$Zg = $e95ce96b80fe8388$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e95ce96b80fe8388$var$dh = !0), a.firstContext = null);
}
function $e95ce96b80fe8388$var$eh(a) {
    var b = a._currentValue;
    if ($e95ce96b80fe8388$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e95ce96b80fe8388$var$Yg) {
            if (null === $e95ce96b80fe8388$var$Xg) throw Error($e95ce96b80fe8388$var$p(308));
            $e95ce96b80fe8388$var$Yg = a;
            $e95ce96b80fe8388$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e95ce96b80fe8388$var$Yg = $e95ce96b80fe8388$var$Yg.next = a;
    }
    return b;
}
var $e95ce96b80fe8388$var$fh = null;
function $e95ce96b80fe8388$var$gh(a) {
    null === $e95ce96b80fe8388$var$fh ? $e95ce96b80fe8388$var$fh = [
        a
    ] : $e95ce96b80fe8388$var$fh.push(a);
}
function $e95ce96b80fe8388$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e95ce96b80fe8388$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e95ce96b80fe8388$var$ih(a, d);
}
function $e95ce96b80fe8388$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e95ce96b80fe8388$var$jh = !1;
function $e95ce96b80fe8388$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e95ce96b80fe8388$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e95ce96b80fe8388$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e95ce96b80fe8388$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e95ce96b80fe8388$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e95ce96b80fe8388$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e95ce96b80fe8388$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e95ce96b80fe8388$var$ih(a, c);
}
function $e95ce96b80fe8388$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e95ce96b80fe8388$var$Cc(a, c);
    }
}
function $e95ce96b80fe8388$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e95ce96b80fe8388$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $e95ce96b80fe8388$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e95ce96b80fe8388$var$A({}, q, r);
                            break a;
                        case 2:
                            $e95ce96b80fe8388$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e95ce96b80fe8388$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e95ce96b80fe8388$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e95ce96b80fe8388$var$p(191, e));
            e.call(d);
        }
    }
}
var $e95ce96b80fe8388$var$th = {}, $e95ce96b80fe8388$var$uh = $e95ce96b80fe8388$var$Uf($e95ce96b80fe8388$var$th), $e95ce96b80fe8388$var$vh = $e95ce96b80fe8388$var$Uf($e95ce96b80fe8388$var$th), $e95ce96b80fe8388$var$wh = $e95ce96b80fe8388$var$Uf($e95ce96b80fe8388$var$th);
function $e95ce96b80fe8388$var$xh(a) {
    if (a === $e95ce96b80fe8388$var$th) throw Error($e95ce96b80fe8388$var$p(174));
    return a;
}
function $e95ce96b80fe8388$var$yh(a, b) {
    $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$wh, b);
    $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$vh, a);
    $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$uh, $e95ce96b80fe8388$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e95ce96b80fe8388$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e95ce96b80fe8388$var$lb(b, a);
    }
    $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$uh);
    $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$uh, b);
}
function $e95ce96b80fe8388$var$zh() {
    $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$uh);
    $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$vh);
    $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$wh);
}
function $e95ce96b80fe8388$var$Ah(a) {
    $e95ce96b80fe8388$var$xh($e95ce96b80fe8388$var$wh.current);
    var b = $e95ce96b80fe8388$var$xh($e95ce96b80fe8388$var$uh.current);
    var c = $e95ce96b80fe8388$var$lb(b, a.type);
    b !== c && ($e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$vh, a), $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$uh, c));
}
function $e95ce96b80fe8388$var$Bh(a) {
    $e95ce96b80fe8388$var$vh.current === a && ($e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$uh), $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$vh));
}
var $e95ce96b80fe8388$var$L = $e95ce96b80fe8388$var$Uf(0);
function $e95ce96b80fe8388$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e95ce96b80fe8388$var$Dh = [];
function $e95ce96b80fe8388$var$Eh() {
    for(var a = 0; a < $e95ce96b80fe8388$var$Dh.length; a++)$e95ce96b80fe8388$var$Dh[a]._workInProgressVersionPrimary = null;
    $e95ce96b80fe8388$var$Dh.length = 0;
}
var $e95ce96b80fe8388$var$Fh = $e95ce96b80fe8388$var$ua.ReactCurrentDispatcher, $e95ce96b80fe8388$var$Gh = $e95ce96b80fe8388$var$ua.ReactCurrentBatchConfig, $e95ce96b80fe8388$var$Hh = 0, $e95ce96b80fe8388$var$M = null, $e95ce96b80fe8388$var$N = null, $e95ce96b80fe8388$var$O = null, $e95ce96b80fe8388$var$Ih = !1, $e95ce96b80fe8388$var$Jh = !1, $e95ce96b80fe8388$var$Kh = 0, $e95ce96b80fe8388$var$Lh = 0;
function $e95ce96b80fe8388$var$P() {
    throw Error($e95ce96b80fe8388$var$p(321));
}
function $e95ce96b80fe8388$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e95ce96b80fe8388$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e95ce96b80fe8388$var$Nh(a, b, c, d, e, f) {
    $e95ce96b80fe8388$var$Hh = f;
    $e95ce96b80fe8388$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e95ce96b80fe8388$var$Fh.current = null === a || null === a.memoizedState ? $e95ce96b80fe8388$var$Oh : $e95ce96b80fe8388$var$Ph;
    a = c(d, e);
    if ($e95ce96b80fe8388$var$Jh) {
        f = 0;
        do {
            $e95ce96b80fe8388$var$Jh = !1;
            $e95ce96b80fe8388$var$Kh = 0;
            if (25 <= f) throw Error($e95ce96b80fe8388$var$p(301));
            f += 1;
            $e95ce96b80fe8388$var$O = $e95ce96b80fe8388$var$N = null;
            b.updateQueue = null;
            $e95ce96b80fe8388$var$Fh.current = $e95ce96b80fe8388$var$Qh;
            a = c(d, e);
        }while ($e95ce96b80fe8388$var$Jh);
    }
    $e95ce96b80fe8388$var$Fh.current = $e95ce96b80fe8388$var$Rh;
    b = null !== $e95ce96b80fe8388$var$N && null !== $e95ce96b80fe8388$var$N.next;
    $e95ce96b80fe8388$var$Hh = 0;
    $e95ce96b80fe8388$var$O = $e95ce96b80fe8388$var$N = $e95ce96b80fe8388$var$M = null;
    $e95ce96b80fe8388$var$Ih = !1;
    if (b) throw Error($e95ce96b80fe8388$var$p(300));
    return a;
}
function $e95ce96b80fe8388$var$Sh() {
    var a = 0 !== $e95ce96b80fe8388$var$Kh;
    $e95ce96b80fe8388$var$Kh = 0;
    return a;
}
function $e95ce96b80fe8388$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e95ce96b80fe8388$var$O ? $e95ce96b80fe8388$var$M.memoizedState = $e95ce96b80fe8388$var$O = a : $e95ce96b80fe8388$var$O = $e95ce96b80fe8388$var$O.next = a;
    return $e95ce96b80fe8388$var$O;
}
function $e95ce96b80fe8388$var$Uh() {
    if (null === $e95ce96b80fe8388$var$N) {
        var a = $e95ce96b80fe8388$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e95ce96b80fe8388$var$N.next;
    var b = null === $e95ce96b80fe8388$var$O ? $e95ce96b80fe8388$var$M.memoizedState : $e95ce96b80fe8388$var$O.next;
    if (null !== b) $e95ce96b80fe8388$var$O = b, $e95ce96b80fe8388$var$N = a;
    else {
        if (null === a) throw Error($e95ce96b80fe8388$var$p(310));
        $e95ce96b80fe8388$var$N = a;
        a = {
            memoizedState: $e95ce96b80fe8388$var$N.memoizedState,
            baseState: $e95ce96b80fe8388$var$N.baseState,
            baseQueue: $e95ce96b80fe8388$var$N.baseQueue,
            queue: $e95ce96b80fe8388$var$N.queue,
            next: null
        };
        null === $e95ce96b80fe8388$var$O ? $e95ce96b80fe8388$var$M.memoizedState = $e95ce96b80fe8388$var$O = a : $e95ce96b80fe8388$var$O = $e95ce96b80fe8388$var$O.next = a;
    }
    return $e95ce96b80fe8388$var$O;
}
function $e95ce96b80fe8388$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e95ce96b80fe8388$var$Wh(a) {
    var b = $e95ce96b80fe8388$var$Uh(), c = b.queue;
    if (null === c) throw Error($e95ce96b80fe8388$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e95ce96b80fe8388$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e95ce96b80fe8388$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e95ce96b80fe8388$var$M.lanes |= m;
                $e95ce96b80fe8388$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e95ce96b80fe8388$var$He(d, b.memoizedState) || ($e95ce96b80fe8388$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e95ce96b80fe8388$var$M.lanes |= f, $e95ce96b80fe8388$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e95ce96b80fe8388$var$Xh(a) {
    var b = $e95ce96b80fe8388$var$Uh(), c = b.queue;
    if (null === c) throw Error($e95ce96b80fe8388$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e95ce96b80fe8388$var$He(f, b.memoizedState) || ($e95ce96b80fe8388$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e95ce96b80fe8388$var$Yh() {}
function $e95ce96b80fe8388$var$Zh(a, b) {
    var c = $e95ce96b80fe8388$var$M, d = $e95ce96b80fe8388$var$Uh(), e = b(), f = !$e95ce96b80fe8388$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e95ce96b80fe8388$var$dh = !0);
    d = d.queue;
    $e95ce96b80fe8388$var$$h($e95ce96b80fe8388$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e95ce96b80fe8388$var$O && $e95ce96b80fe8388$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e95ce96b80fe8388$var$bi(9, $e95ce96b80fe8388$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $e95ce96b80fe8388$var$Q) throw Error($e95ce96b80fe8388$var$p(349));
        0 !== ($e95ce96b80fe8388$var$Hh & 30) || $e95ce96b80fe8388$var$di(c, b, e);
    }
    return e;
}
function $e95ce96b80fe8388$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e95ce96b80fe8388$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e95ce96b80fe8388$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e95ce96b80fe8388$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e95ce96b80fe8388$var$ei(b) && $e95ce96b80fe8388$var$fi(a);
}
function $e95ce96b80fe8388$var$ai(a, b, c) {
    return c(function() {
        $e95ce96b80fe8388$var$ei(b) && $e95ce96b80fe8388$var$fi(a);
    });
}
function $e95ce96b80fe8388$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e95ce96b80fe8388$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e95ce96b80fe8388$var$fi(a) {
    var b = $e95ce96b80fe8388$var$ih(a, 1);
    null !== b && $e95ce96b80fe8388$var$gi(b, a, 1, -1);
}
function $e95ce96b80fe8388$var$hi(a) {
    var b = $e95ce96b80fe8388$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e95ce96b80fe8388$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e95ce96b80fe8388$var$ii.bind(null, $e95ce96b80fe8388$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e95ce96b80fe8388$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e95ce96b80fe8388$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e95ce96b80fe8388$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e95ce96b80fe8388$var$ji() {
    return $e95ce96b80fe8388$var$Uh().memoizedState;
}
function $e95ce96b80fe8388$var$ki(a, b, c, d) {
    var e = $e95ce96b80fe8388$var$Th();
    $e95ce96b80fe8388$var$M.flags |= a;
    e.memoizedState = $e95ce96b80fe8388$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e95ce96b80fe8388$var$li(a, b, c, d) {
    var e = $e95ce96b80fe8388$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e95ce96b80fe8388$var$N) {
        var g = $e95ce96b80fe8388$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $e95ce96b80fe8388$var$Mh(d, g.deps)) {
            e.memoizedState = $e95ce96b80fe8388$var$bi(b, c, f, d);
            return;
        }
    }
    $e95ce96b80fe8388$var$M.flags |= a;
    e.memoizedState = $e95ce96b80fe8388$var$bi(1 | b, c, f, d);
}
function $e95ce96b80fe8388$var$mi(a, b) {
    return $e95ce96b80fe8388$var$ki(8390656, 8, a, b);
}
function $e95ce96b80fe8388$var$$h(a, b) {
    return $e95ce96b80fe8388$var$li(2048, 8, a, b);
}
function $e95ce96b80fe8388$var$ni(a, b) {
    return $e95ce96b80fe8388$var$li(4, 2, a, b);
}
function $e95ce96b80fe8388$var$oi(a, b) {
    return $e95ce96b80fe8388$var$li(4, 4, a, b);
}
function $e95ce96b80fe8388$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e95ce96b80fe8388$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e95ce96b80fe8388$var$li(4, 4, $e95ce96b80fe8388$var$pi.bind(null, b, a), c);
}
function $e95ce96b80fe8388$var$ri() {}
function $e95ce96b80fe8388$var$si(a, b) {
    var c = $e95ce96b80fe8388$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e95ce96b80fe8388$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e95ce96b80fe8388$var$ti(a, b) {
    var c = $e95ce96b80fe8388$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e95ce96b80fe8388$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e95ce96b80fe8388$var$ui(a, b, c) {
    if (0 === ($e95ce96b80fe8388$var$Hh & 21)) return a.baseState && (a.baseState = !1, $e95ce96b80fe8388$var$dh = !0), a.memoizedState = c;
    $e95ce96b80fe8388$var$He(c, b) || (c = $e95ce96b80fe8388$var$yc(), $e95ce96b80fe8388$var$M.lanes |= c, $e95ce96b80fe8388$var$rh |= c, a.baseState = !0);
    return b;
}
function $e95ce96b80fe8388$var$vi(a, b) {
    var c = $e95ce96b80fe8388$var$C;
    $e95ce96b80fe8388$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e95ce96b80fe8388$var$Gh.transition;
    $e95ce96b80fe8388$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e95ce96b80fe8388$var$C = c, $e95ce96b80fe8388$var$Gh.transition = d;
    }
}
function $e95ce96b80fe8388$var$wi() {
    return $e95ce96b80fe8388$var$Uh().memoizedState;
}
function $e95ce96b80fe8388$var$xi(a, b, c) {
    var d = $e95ce96b80fe8388$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e95ce96b80fe8388$var$zi(a)) $e95ce96b80fe8388$var$Ai(b, c);
    else if (c = $e95ce96b80fe8388$var$hh(a, b, c, d), null !== c) {
        var e = $e95ce96b80fe8388$var$R();
        $e95ce96b80fe8388$var$gi(c, a, d, e);
        $e95ce96b80fe8388$var$Bi(c, b, d);
    }
}
function $e95ce96b80fe8388$var$ii(a, b, c) {
    var d = $e95ce96b80fe8388$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e95ce96b80fe8388$var$zi(a)) $e95ce96b80fe8388$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e95ce96b80fe8388$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e95ce96b80fe8388$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e95ce96b80fe8388$var$hh(a, b, e, d);
        null !== c && (e = $e95ce96b80fe8388$var$R(), $e95ce96b80fe8388$var$gi(c, a, d, e), $e95ce96b80fe8388$var$Bi(c, b, d));
    }
}
function $e95ce96b80fe8388$var$zi(a) {
    var b = a.alternate;
    return a === $e95ce96b80fe8388$var$M || null !== b && b === $e95ce96b80fe8388$var$M;
}
function $e95ce96b80fe8388$var$Ai(a, b) {
    $e95ce96b80fe8388$var$Jh = $e95ce96b80fe8388$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e95ce96b80fe8388$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e95ce96b80fe8388$var$Cc(a, c);
    }
}
var $e95ce96b80fe8388$var$Rh = {
    readContext: $e95ce96b80fe8388$var$eh,
    useCallback: $e95ce96b80fe8388$var$P,
    useContext: $e95ce96b80fe8388$var$P,
    useEffect: $e95ce96b80fe8388$var$P,
    useImperativeHandle: $e95ce96b80fe8388$var$P,
    useInsertionEffect: $e95ce96b80fe8388$var$P,
    useLayoutEffect: $e95ce96b80fe8388$var$P,
    useMemo: $e95ce96b80fe8388$var$P,
    useReducer: $e95ce96b80fe8388$var$P,
    useRef: $e95ce96b80fe8388$var$P,
    useState: $e95ce96b80fe8388$var$P,
    useDebugValue: $e95ce96b80fe8388$var$P,
    useDeferredValue: $e95ce96b80fe8388$var$P,
    useTransition: $e95ce96b80fe8388$var$P,
    useMutableSource: $e95ce96b80fe8388$var$P,
    useSyncExternalStore: $e95ce96b80fe8388$var$P,
    useId: $e95ce96b80fe8388$var$P,
    unstable_isNewReconciler: !1
}, $e95ce96b80fe8388$var$Oh = {
    readContext: $e95ce96b80fe8388$var$eh,
    useCallback: function(a, b) {
        $e95ce96b80fe8388$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e95ce96b80fe8388$var$eh,
    useEffect: $e95ce96b80fe8388$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e95ce96b80fe8388$var$ki(4194308, 4, $e95ce96b80fe8388$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e95ce96b80fe8388$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e95ce96b80fe8388$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e95ce96b80fe8388$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e95ce96b80fe8388$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e95ce96b80fe8388$var$xi.bind(null, $e95ce96b80fe8388$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e95ce96b80fe8388$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e95ce96b80fe8388$var$hi,
    useDebugValue: $e95ce96b80fe8388$var$ri,
    useDeferredValue: function(a) {
        return $e95ce96b80fe8388$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $e95ce96b80fe8388$var$hi(!1), b = a[0];
        a = $e95ce96b80fe8388$var$vi.bind(null, a[1]);
        $e95ce96b80fe8388$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e95ce96b80fe8388$var$M, e = $e95ce96b80fe8388$var$Th();
        if ($e95ce96b80fe8388$var$I) {
            if (void 0 === c) throw Error($e95ce96b80fe8388$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e95ce96b80fe8388$var$Q) throw Error($e95ce96b80fe8388$var$p(349));
            0 !== ($e95ce96b80fe8388$var$Hh & 30) || $e95ce96b80fe8388$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e95ce96b80fe8388$var$mi($e95ce96b80fe8388$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e95ce96b80fe8388$var$bi(9, $e95ce96b80fe8388$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e95ce96b80fe8388$var$Th(), b = $e95ce96b80fe8388$var$Q.identifierPrefix;
        if ($e95ce96b80fe8388$var$I) {
            var c = $e95ce96b80fe8388$var$sg;
            var d = $e95ce96b80fe8388$var$rg;
            c = (d & ~(1 << 32 - $e95ce96b80fe8388$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e95ce96b80fe8388$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e95ce96b80fe8388$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e95ce96b80fe8388$var$Ph = {
    readContext: $e95ce96b80fe8388$var$eh,
    useCallback: $e95ce96b80fe8388$var$si,
    useContext: $e95ce96b80fe8388$var$eh,
    useEffect: $e95ce96b80fe8388$var$$h,
    useImperativeHandle: $e95ce96b80fe8388$var$qi,
    useInsertionEffect: $e95ce96b80fe8388$var$ni,
    useLayoutEffect: $e95ce96b80fe8388$var$oi,
    useMemo: $e95ce96b80fe8388$var$ti,
    useReducer: $e95ce96b80fe8388$var$Wh,
    useRef: $e95ce96b80fe8388$var$ji,
    useState: function() {
        return $e95ce96b80fe8388$var$Wh($e95ce96b80fe8388$var$Vh);
    },
    useDebugValue: $e95ce96b80fe8388$var$ri,
    useDeferredValue: function(a) {
        var b = $e95ce96b80fe8388$var$Uh();
        return $e95ce96b80fe8388$var$ui(b, $e95ce96b80fe8388$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e95ce96b80fe8388$var$Wh($e95ce96b80fe8388$var$Vh)[0], b = $e95ce96b80fe8388$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e95ce96b80fe8388$var$Yh,
    useSyncExternalStore: $e95ce96b80fe8388$var$Zh,
    useId: $e95ce96b80fe8388$var$wi,
    unstable_isNewReconciler: !1
}, $e95ce96b80fe8388$var$Qh = {
    readContext: $e95ce96b80fe8388$var$eh,
    useCallback: $e95ce96b80fe8388$var$si,
    useContext: $e95ce96b80fe8388$var$eh,
    useEffect: $e95ce96b80fe8388$var$$h,
    useImperativeHandle: $e95ce96b80fe8388$var$qi,
    useInsertionEffect: $e95ce96b80fe8388$var$ni,
    useLayoutEffect: $e95ce96b80fe8388$var$oi,
    useMemo: $e95ce96b80fe8388$var$ti,
    useReducer: $e95ce96b80fe8388$var$Xh,
    useRef: $e95ce96b80fe8388$var$ji,
    useState: function() {
        return $e95ce96b80fe8388$var$Xh($e95ce96b80fe8388$var$Vh);
    },
    useDebugValue: $e95ce96b80fe8388$var$ri,
    useDeferredValue: function(a) {
        var b = $e95ce96b80fe8388$var$Uh();
        return null === $e95ce96b80fe8388$var$N ? b.memoizedState = a : $e95ce96b80fe8388$var$ui(b, $e95ce96b80fe8388$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e95ce96b80fe8388$var$Xh($e95ce96b80fe8388$var$Vh)[0], b = $e95ce96b80fe8388$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e95ce96b80fe8388$var$Yh,
    useSyncExternalStore: $e95ce96b80fe8388$var$Zh,
    useId: $e95ce96b80fe8388$var$wi,
    unstable_isNewReconciler: !1
};
function $e95ce96b80fe8388$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $e95ce96b80fe8388$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $e95ce96b80fe8388$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e95ce96b80fe8388$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e95ce96b80fe8388$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e95ce96b80fe8388$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e95ce96b80fe8388$var$R(), e = $e95ce96b80fe8388$var$yi(a), f = $e95ce96b80fe8388$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e95ce96b80fe8388$var$nh(a, f, e);
        null !== b && ($e95ce96b80fe8388$var$gi(b, a, e, d), $e95ce96b80fe8388$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e95ce96b80fe8388$var$R(), e = $e95ce96b80fe8388$var$yi(a), f = $e95ce96b80fe8388$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e95ce96b80fe8388$var$nh(a, f, e);
        null !== b && ($e95ce96b80fe8388$var$gi(b, a, e, d), $e95ce96b80fe8388$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e95ce96b80fe8388$var$R(), d = $e95ce96b80fe8388$var$yi(a), e = $e95ce96b80fe8388$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e95ce96b80fe8388$var$nh(a, e, d);
        null !== b && ($e95ce96b80fe8388$var$gi(b, a, d, c), $e95ce96b80fe8388$var$oh(b, a, d));
    }
};
function $e95ce96b80fe8388$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e95ce96b80fe8388$var$Ie(c, d) || !$e95ce96b80fe8388$var$Ie(e, f) : !0;
}
function $e95ce96b80fe8388$var$Gi(a, b, c) {
    var d = !1, e = $e95ce96b80fe8388$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e95ce96b80fe8388$var$eh(f) : (e = $e95ce96b80fe8388$var$Zf(b) ? $e95ce96b80fe8388$var$Xf : $e95ce96b80fe8388$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e95ce96b80fe8388$var$Yf(a, e) : $e95ce96b80fe8388$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e95ce96b80fe8388$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e95ce96b80fe8388$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e95ce96b80fe8388$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $e95ce96b80fe8388$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $e95ce96b80fe8388$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e95ce96b80fe8388$var$eh(f) : (f = $e95ce96b80fe8388$var$Zf(b) ? $e95ce96b80fe8388$var$Xf : $e95ce96b80fe8388$var$H.current, e.context = $e95ce96b80fe8388$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e95ce96b80fe8388$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e95ce96b80fe8388$var$Ei.enqueueReplaceState(e, e.state, null), $e95ce96b80fe8388$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e95ce96b80fe8388$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $e95ce96b80fe8388$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e95ce96b80fe8388$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e95ce96b80fe8388$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e95ce96b80fe8388$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $e95ce96b80fe8388$var$Ni(a, b, c) {
    c = $e95ce96b80fe8388$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e95ce96b80fe8388$var$Oi || ($e95ce96b80fe8388$var$Oi = !0, $e95ce96b80fe8388$var$Pi = d);
        $e95ce96b80fe8388$var$Li(a, b);
    };
    return c;
}
function $e95ce96b80fe8388$var$Qi(a, b, c) {
    c = $e95ce96b80fe8388$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e95ce96b80fe8388$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e95ce96b80fe8388$var$Li(a, b);
        "function" !== typeof d && (null === $e95ce96b80fe8388$var$Ri ? $e95ce96b80fe8388$var$Ri = new Set([
            this
        ]) : $e95ce96b80fe8388$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e95ce96b80fe8388$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e95ce96b80fe8388$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e95ce96b80fe8388$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $e95ce96b80fe8388$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e95ce96b80fe8388$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e95ce96b80fe8388$var$mh(-1, 1), b.tag = 2, $e95ce96b80fe8388$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e95ce96b80fe8388$var$Wi = $e95ce96b80fe8388$var$ua.ReactCurrentOwner, $e95ce96b80fe8388$var$dh = !1;
function $e95ce96b80fe8388$var$Xi(a, b, c, d) {
    b.child = null === a ? $e95ce96b80fe8388$var$Vg(b, null, c, d) : $e95ce96b80fe8388$var$Ug(b, a.child, c, d);
}
function $e95ce96b80fe8388$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e95ce96b80fe8388$var$ch(b, e);
    d = $e95ce96b80fe8388$var$Nh(a, b, c, d, f, e);
    c = $e95ce96b80fe8388$var$Sh();
    if (null !== a && !$e95ce96b80fe8388$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e95ce96b80fe8388$var$Zi(a, b, e);
    $e95ce96b80fe8388$var$I && c && $e95ce96b80fe8388$var$vg(b);
    b.flags |= 1;
    $e95ce96b80fe8388$var$Xi(a, b, d, e);
    return b.child;
}
function $e95ce96b80fe8388$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e95ce96b80fe8388$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e95ce96b80fe8388$var$bj(a, b, f, d, e);
        a = $e95ce96b80fe8388$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e95ce96b80fe8388$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e95ce96b80fe8388$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $e95ce96b80fe8388$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e95ce96b80fe8388$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e95ce96b80fe8388$var$Ie(f, d) && a.ref === b.ref) {
            if ($e95ce96b80fe8388$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e95ce96b80fe8388$var$dh = !0);
            else return b.lanes = a.lanes, $e95ce96b80fe8388$var$Zi(a, b, e);
        }
    }
    return $e95ce96b80fe8388$var$cj(a, b, c, d, e);
}
function $e95ce96b80fe8388$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$ej, $e95ce96b80fe8388$var$fj), $e95ce96b80fe8388$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$ej, $e95ce96b80fe8388$var$fj), $e95ce96b80fe8388$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$ej, $e95ce96b80fe8388$var$fj);
            $e95ce96b80fe8388$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$ej, $e95ce96b80fe8388$var$fj), $e95ce96b80fe8388$var$fj |= d;
    $e95ce96b80fe8388$var$Xi(a, b, e, c);
    return b.child;
}
function $e95ce96b80fe8388$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e95ce96b80fe8388$var$cj(a, b, c, d, e) {
    var f = $e95ce96b80fe8388$var$Zf(c) ? $e95ce96b80fe8388$var$Xf : $e95ce96b80fe8388$var$H.current;
    f = $e95ce96b80fe8388$var$Yf(b, f);
    $e95ce96b80fe8388$var$ch(b, e);
    c = $e95ce96b80fe8388$var$Nh(a, b, c, d, f, e);
    d = $e95ce96b80fe8388$var$Sh();
    if (null !== a && !$e95ce96b80fe8388$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e95ce96b80fe8388$var$Zi(a, b, e);
    $e95ce96b80fe8388$var$I && d && $e95ce96b80fe8388$var$vg(b);
    b.flags |= 1;
    $e95ce96b80fe8388$var$Xi(a, b, c, e);
    return b.child;
}
function $e95ce96b80fe8388$var$hj(a, b, c, d, e) {
    if ($e95ce96b80fe8388$var$Zf(c)) {
        var f = !0;
        $e95ce96b80fe8388$var$cg(b);
    } else f = !1;
    $e95ce96b80fe8388$var$ch(b, e);
    if (null === b.stateNode) $e95ce96b80fe8388$var$ij(a, b), $e95ce96b80fe8388$var$Gi(b, c, d), $e95ce96b80fe8388$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e95ce96b80fe8388$var$eh(l) : (l = $e95ce96b80fe8388$var$Zf(c) ? $e95ce96b80fe8388$var$Xf : $e95ce96b80fe8388$var$H.current, l = $e95ce96b80fe8388$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e95ce96b80fe8388$var$Hi(b, g, d, l);
        $e95ce96b80fe8388$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $e95ce96b80fe8388$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e95ce96b80fe8388$var$Wf.current || $e95ce96b80fe8388$var$jh ? ("function" === typeof m && ($e95ce96b80fe8388$var$Di(b, c, m, d), k = b.memoizedState), (h = $e95ce96b80fe8388$var$jh || $e95ce96b80fe8388$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e95ce96b80fe8388$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e95ce96b80fe8388$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e95ce96b80fe8388$var$eh(k) : (k = $e95ce96b80fe8388$var$Zf(c) ? $e95ce96b80fe8388$var$Xf : $e95ce96b80fe8388$var$H.current, k = $e95ce96b80fe8388$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e95ce96b80fe8388$var$Hi(b, g, d, k);
        $e95ce96b80fe8388$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $e95ce96b80fe8388$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e95ce96b80fe8388$var$Wf.current || $e95ce96b80fe8388$var$jh ? ("function" === typeof y && ($e95ce96b80fe8388$var$Di(b, c, y, d), n = b.memoizedState), (l = $e95ce96b80fe8388$var$jh || $e95ce96b80fe8388$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e95ce96b80fe8388$var$jj(a, b, c, d, f, e);
}
function $e95ce96b80fe8388$var$jj(a, b, c, d, e, f) {
    $e95ce96b80fe8388$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e95ce96b80fe8388$var$dg(b, c, !1), $e95ce96b80fe8388$var$Zi(a, b, f);
    d = b.stateNode;
    $e95ce96b80fe8388$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e95ce96b80fe8388$var$Ug(b, a.child, null, f), b.child = $e95ce96b80fe8388$var$Ug(b, null, h, f)) : $e95ce96b80fe8388$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e95ce96b80fe8388$var$dg(b, c, !0);
    return b.child;
}
function $e95ce96b80fe8388$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e95ce96b80fe8388$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e95ce96b80fe8388$var$ag(a, b.context, !1);
    $e95ce96b80fe8388$var$yh(a, b.containerInfo);
}
function $e95ce96b80fe8388$var$lj(a, b, c, d, e) {
    $e95ce96b80fe8388$var$Ig();
    $e95ce96b80fe8388$var$Jg(e);
    b.flags |= 256;
    $e95ce96b80fe8388$var$Xi(a, b, c, d);
    return b.child;
}
var $e95ce96b80fe8388$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e95ce96b80fe8388$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e95ce96b80fe8388$var$oj(a, b, c) {
    var d = b.pendingProps, e = $e95ce96b80fe8388$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$L, e & 1);
    if (null === a) {
        $e95ce96b80fe8388$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e95ce96b80fe8388$var$pj(g, d, 0, null), a = $e95ce96b80fe8388$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e95ce96b80fe8388$var$nj(c), b.memoizedState = $e95ce96b80fe8388$var$mj, a) : $e95ce96b80fe8388$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e95ce96b80fe8388$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e95ce96b80fe8388$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e95ce96b80fe8388$var$Pg(h, f) : (f = $e95ce96b80fe8388$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e95ce96b80fe8388$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e95ce96b80fe8388$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e95ce96b80fe8388$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e95ce96b80fe8388$var$qj(a, b) {
    b = $e95ce96b80fe8388$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e95ce96b80fe8388$var$sj(a, b, c, d) {
    null !== d && $e95ce96b80fe8388$var$Jg(d);
    $e95ce96b80fe8388$var$Ug(b, a.child, null, c);
    a = $e95ce96b80fe8388$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e95ce96b80fe8388$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e95ce96b80fe8388$var$Ki(Error($e95ce96b80fe8388$var$p(422))), $e95ce96b80fe8388$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e95ce96b80fe8388$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e95ce96b80fe8388$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e95ce96b80fe8388$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $e95ce96b80fe8388$var$nj(g);
        b.memoizedState = $e95ce96b80fe8388$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e95ce96b80fe8388$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e95ce96b80fe8388$var$p(419));
        d = $e95ce96b80fe8388$var$Ki(f, d, void 0);
        return $e95ce96b80fe8388$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e95ce96b80fe8388$var$dh || h) {
        d = $e95ce96b80fe8388$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e95ce96b80fe8388$var$ih(a, e), $e95ce96b80fe8388$var$gi(d, a, e, -1));
        }
        $e95ce96b80fe8388$var$tj();
        d = $e95ce96b80fe8388$var$Ki(Error($e95ce96b80fe8388$var$p(421)));
        return $e95ce96b80fe8388$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e95ce96b80fe8388$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e95ce96b80fe8388$var$yg = $e95ce96b80fe8388$var$Lf(e.nextSibling);
    $e95ce96b80fe8388$var$xg = b;
    $e95ce96b80fe8388$var$I = !0;
    $e95ce96b80fe8388$var$zg = null;
    null !== a && ($e95ce96b80fe8388$var$og[$e95ce96b80fe8388$var$pg++] = $e95ce96b80fe8388$var$rg, $e95ce96b80fe8388$var$og[$e95ce96b80fe8388$var$pg++] = $e95ce96b80fe8388$var$sg, $e95ce96b80fe8388$var$og[$e95ce96b80fe8388$var$pg++] = $e95ce96b80fe8388$var$qg, $e95ce96b80fe8388$var$rg = a.id, $e95ce96b80fe8388$var$sg = a.overflow, $e95ce96b80fe8388$var$qg = b);
    b = $e95ce96b80fe8388$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e95ce96b80fe8388$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e95ce96b80fe8388$var$bh(a.return, b, c);
}
function $e95ce96b80fe8388$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e95ce96b80fe8388$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e95ce96b80fe8388$var$Xi(a, b, d.children, c);
    d = $e95ce96b80fe8388$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e95ce96b80fe8388$var$vj(a, c, b);
            else if (19 === a.tag) $e95ce96b80fe8388$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e95ce96b80fe8388$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e95ce96b80fe8388$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e95ce96b80fe8388$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e95ce96b80fe8388$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $e95ce96b80fe8388$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e95ce96b80fe8388$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e95ce96b80fe8388$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e95ce96b80fe8388$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e95ce96b80fe8388$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e95ce96b80fe8388$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e95ce96b80fe8388$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e95ce96b80fe8388$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $e95ce96b80fe8388$var$kj(b);
            $e95ce96b80fe8388$var$Ig();
            break;
        case 5:
            $e95ce96b80fe8388$var$Ah(b);
            break;
        case 1:
            $e95ce96b80fe8388$var$Zf(b.type) && $e95ce96b80fe8388$var$cg(b);
            break;
        case 4:
            $e95ce96b80fe8388$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$L, $e95ce96b80fe8388$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e95ce96b80fe8388$var$oj(a, b, c);
                $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$L, $e95ce96b80fe8388$var$L.current & 1);
                a = $e95ce96b80fe8388$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$L, $e95ce96b80fe8388$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e95ce96b80fe8388$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$L, $e95ce96b80fe8388$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e95ce96b80fe8388$var$dj(a, b, c);
    }
    return $e95ce96b80fe8388$var$Zi(a, b, c);
}
var $e95ce96b80fe8388$var$zj, $e95ce96b80fe8388$var$Aj, $e95ce96b80fe8388$var$Bj, $e95ce96b80fe8388$var$Cj;
$e95ce96b80fe8388$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e95ce96b80fe8388$var$Aj = function() {};
$e95ce96b80fe8388$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e95ce96b80fe8388$var$xh($e95ce96b80fe8388$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e95ce96b80fe8388$var$Ya(a, e);
                d = $e95ce96b80fe8388$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e95ce96b80fe8388$var$A({}, e, {
                    value: void 0
                });
                d = $e95ce96b80fe8388$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e95ce96b80fe8388$var$gb(a, e);
                d = $e95ce96b80fe8388$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e95ce96b80fe8388$var$Bf);
        }
        $e95ce96b80fe8388$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e95ce96b80fe8388$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e95ce96b80fe8388$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e95ce96b80fe8388$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e95ce96b80fe8388$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e95ce96b80fe8388$var$Dj(a, b) {
    if (!$e95ce96b80fe8388$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e95ce96b80fe8388$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e95ce96b80fe8388$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $e95ce96b80fe8388$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e95ce96b80fe8388$var$S(b), null;
        case 1:
            return $e95ce96b80fe8388$var$Zf(b.type) && $e95ce96b80fe8388$var$$f(), $e95ce96b80fe8388$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e95ce96b80fe8388$var$zh();
            $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$Wf);
            $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$H);
            $e95ce96b80fe8388$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e95ce96b80fe8388$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e95ce96b80fe8388$var$zg && ($e95ce96b80fe8388$var$Fj($e95ce96b80fe8388$var$zg), $e95ce96b80fe8388$var$zg = null));
            $e95ce96b80fe8388$var$Aj(a, b);
            $e95ce96b80fe8388$var$S(b);
            return null;
        case 5:
            $e95ce96b80fe8388$var$Bh(b);
            var e = $e95ce96b80fe8388$var$xh($e95ce96b80fe8388$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e95ce96b80fe8388$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e95ce96b80fe8388$var$p(166));
                    $e95ce96b80fe8388$var$S(b);
                    return null;
                }
                a = $e95ce96b80fe8388$var$xh($e95ce96b80fe8388$var$uh.current);
                if ($e95ce96b80fe8388$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e95ce96b80fe8388$var$Of] = b;
                    d[$e95ce96b80fe8388$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e95ce96b80fe8388$var$D("cancel", d);
                            $e95ce96b80fe8388$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e95ce96b80fe8388$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e95ce96b80fe8388$var$lf.length; e++)$e95ce96b80fe8388$var$D($e95ce96b80fe8388$var$lf[e], d);
                            break;
                        case "source":
                            $e95ce96b80fe8388$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e95ce96b80fe8388$var$D("error", d);
                            $e95ce96b80fe8388$var$D("load", d);
                            break;
                        case "details":
                            $e95ce96b80fe8388$var$D("toggle", d);
                            break;
                        case "input":
                            $e95ce96b80fe8388$var$Za(d, f);
                            $e95ce96b80fe8388$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e95ce96b80fe8388$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e95ce96b80fe8388$var$hb(d, f), $e95ce96b80fe8388$var$D("invalid", d);
                    }
                    $e95ce96b80fe8388$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e95ce96b80fe8388$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e95ce96b80fe8388$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e95ce96b80fe8388$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e95ce96b80fe8388$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e95ce96b80fe8388$var$Va(d);
                            $e95ce96b80fe8388$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e95ce96b80fe8388$var$Va(d);
                            $e95ce96b80fe8388$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e95ce96b80fe8388$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e95ce96b80fe8388$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e95ce96b80fe8388$var$Of] = b;
                    a[$e95ce96b80fe8388$var$Pf] = d;
                    $e95ce96b80fe8388$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e95ce96b80fe8388$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e95ce96b80fe8388$var$D("cancel", a);
                                $e95ce96b80fe8388$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e95ce96b80fe8388$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e95ce96b80fe8388$var$lf.length; e++)$e95ce96b80fe8388$var$D($e95ce96b80fe8388$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e95ce96b80fe8388$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e95ce96b80fe8388$var$D("error", a);
                                $e95ce96b80fe8388$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e95ce96b80fe8388$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e95ce96b80fe8388$var$Za(a, d);
                                e = $e95ce96b80fe8388$var$Ya(a, d);
                                $e95ce96b80fe8388$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e95ce96b80fe8388$var$A({}, d, {
                                    value: void 0
                                });
                                $e95ce96b80fe8388$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e95ce96b80fe8388$var$hb(a, d);
                                e = $e95ce96b80fe8388$var$gb(a, d);
                                $e95ce96b80fe8388$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e95ce96b80fe8388$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e95ce96b80fe8388$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e95ce96b80fe8388$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e95ce96b80fe8388$var$ob(a, k) : "number" === typeof k && $e95ce96b80fe8388$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e95ce96b80fe8388$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e95ce96b80fe8388$var$D("scroll", a) : null != k && $e95ce96b80fe8388$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e95ce96b80fe8388$var$Va(a);
                                $e95ce96b80fe8388$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e95ce96b80fe8388$var$Va(a);
                                $e95ce96b80fe8388$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e95ce96b80fe8388$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e95ce96b80fe8388$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e95ce96b80fe8388$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e95ce96b80fe8388$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e95ce96b80fe8388$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e95ce96b80fe8388$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e95ce96b80fe8388$var$p(166));
                c = $e95ce96b80fe8388$var$xh($e95ce96b80fe8388$var$wh.current);
                $e95ce96b80fe8388$var$xh($e95ce96b80fe8388$var$uh.current);
                if ($e95ce96b80fe8388$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e95ce96b80fe8388$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e95ce96b80fe8388$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e95ce96b80fe8388$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e95ce96b80fe8388$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e95ce96b80fe8388$var$Of] = b, b.stateNode = d;
            }
            $e95ce96b80fe8388$var$S(b);
            return null;
        case 13:
            $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e95ce96b80fe8388$var$I && null !== $e95ce96b80fe8388$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e95ce96b80fe8388$var$Hg(), $e95ce96b80fe8388$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e95ce96b80fe8388$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e95ce96b80fe8388$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e95ce96b80fe8388$var$p(317));
                        f[$e95ce96b80fe8388$var$Of] = b;
                    } else $e95ce96b80fe8388$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e95ce96b80fe8388$var$S(b);
                    f = !1;
                } else null !== $e95ce96b80fe8388$var$zg && ($e95ce96b80fe8388$var$Fj($e95ce96b80fe8388$var$zg), $e95ce96b80fe8388$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e95ce96b80fe8388$var$L.current & 1) ? 0 === $e95ce96b80fe8388$var$T && ($e95ce96b80fe8388$var$T = 3) : $e95ce96b80fe8388$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e95ce96b80fe8388$var$S(b);
            return null;
        case 4:
            return $e95ce96b80fe8388$var$zh(), $e95ce96b80fe8388$var$Aj(a, b), null === a && $e95ce96b80fe8388$var$sf(b.stateNode.containerInfo), $e95ce96b80fe8388$var$S(b), null;
        case 10:
            return $e95ce96b80fe8388$var$ah(b.type._context), $e95ce96b80fe8388$var$S(b), null;
        case 17:
            return $e95ce96b80fe8388$var$Zf(b.type) && $e95ce96b80fe8388$var$$f(), $e95ce96b80fe8388$var$S(b), null;
        case 19:
            $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$L);
            f = b.memoizedState;
            if (null === f) return $e95ce96b80fe8388$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e95ce96b80fe8388$var$Dj(f, !1);
                else {
                    if (0 !== $e95ce96b80fe8388$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e95ce96b80fe8388$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e95ce96b80fe8388$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$L, $e95ce96b80fe8388$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e95ce96b80fe8388$var$B() > $e95ce96b80fe8388$var$Gj && (b.flags |= 128, d = !0, $e95ce96b80fe8388$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e95ce96b80fe8388$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e95ce96b80fe8388$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e95ce96b80fe8388$var$I) return $e95ce96b80fe8388$var$S(b), null;
                    } else 2 * $e95ce96b80fe8388$var$B() - f.renderingStartTime > $e95ce96b80fe8388$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $e95ce96b80fe8388$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e95ce96b80fe8388$var$B(), b.sibling = null, c = $e95ce96b80fe8388$var$L.current, $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$L, d ? c & 1 | 2 : c & 1), b;
            $e95ce96b80fe8388$var$S(b);
            return null;
        case 22:
        case 23:
            return $e95ce96b80fe8388$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e95ce96b80fe8388$var$fj & 1073741824) && ($e95ce96b80fe8388$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e95ce96b80fe8388$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e95ce96b80fe8388$var$p(156, b.tag));
}
function $e95ce96b80fe8388$var$Ij(a, b) {
    $e95ce96b80fe8388$var$wg(b);
    switch(b.tag){
        case 1:
            return $e95ce96b80fe8388$var$Zf(b.type) && $e95ce96b80fe8388$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e95ce96b80fe8388$var$zh(), $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$Wf), $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$H), $e95ce96b80fe8388$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e95ce96b80fe8388$var$Bh(b), null;
        case 13:
            $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e95ce96b80fe8388$var$p(340));
                $e95ce96b80fe8388$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$L), null;
        case 4:
            return $e95ce96b80fe8388$var$zh(), null;
        case 10:
            return $e95ce96b80fe8388$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $e95ce96b80fe8388$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e95ce96b80fe8388$var$Jj = !1, $e95ce96b80fe8388$var$U = !1, $e95ce96b80fe8388$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $e95ce96b80fe8388$var$V = null;
function $e95ce96b80fe8388$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e95ce96b80fe8388$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e95ce96b80fe8388$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e95ce96b80fe8388$var$W(a, b, d);
    }
}
var $e95ce96b80fe8388$var$Nj = !1;
function $e95ce96b80fe8388$var$Oj(a, b) {
    $e95ce96b80fe8388$var$Cf = $e95ce96b80fe8388$var$dd;
    a = $e95ce96b80fe8388$var$Me();
    if ($e95ce96b80fe8388$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e95ce96b80fe8388$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e95ce96b80fe8388$var$dd = !1;
    for($e95ce96b80fe8388$var$V = b; null !== $e95ce96b80fe8388$var$V;)if (b = $e95ce96b80fe8388$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e95ce96b80fe8388$var$V = a;
    else for(; null !== $e95ce96b80fe8388$var$V;){
        b = $e95ce96b80fe8388$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e95ce96b80fe8388$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e95ce96b80fe8388$var$p(163));
            }
        } catch (F) {
            $e95ce96b80fe8388$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e95ce96b80fe8388$var$V = a;
            break;
        }
        $e95ce96b80fe8388$var$V = b.return;
    }
    n = $e95ce96b80fe8388$var$Nj;
    $e95ce96b80fe8388$var$Nj = !1;
    return n;
}
function $e95ce96b80fe8388$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e95ce96b80fe8388$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e95ce96b80fe8388$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e95ce96b80fe8388$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e95ce96b80fe8388$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e95ce96b80fe8388$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e95ce96b80fe8388$var$Of], delete b[$e95ce96b80fe8388$var$Pf], delete b[$e95ce96b80fe8388$var$of], delete b[$e95ce96b80fe8388$var$Qf], delete b[$e95ce96b80fe8388$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e95ce96b80fe8388$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e95ce96b80fe8388$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e95ce96b80fe8388$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e95ce96b80fe8388$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e95ce96b80fe8388$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e95ce96b80fe8388$var$Vj(a, b, c), a = a.sibling; null !== a;)$e95ce96b80fe8388$var$Vj(a, b, c), a = a.sibling;
}
function $e95ce96b80fe8388$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e95ce96b80fe8388$var$Wj(a, b, c), a = a.sibling; null !== a;)$e95ce96b80fe8388$var$Wj(a, b, c), a = a.sibling;
}
var $e95ce96b80fe8388$var$X = null, $e95ce96b80fe8388$var$Xj = !1;
function $e95ce96b80fe8388$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$e95ce96b80fe8388$var$Zj(a, b, c), c = c.sibling;
}
function $e95ce96b80fe8388$var$Zj(a, b, c) {
    if ($e95ce96b80fe8388$var$lc && "function" === typeof $e95ce96b80fe8388$var$lc.onCommitFiberUnmount) try {
        $e95ce96b80fe8388$var$lc.onCommitFiberUnmount($e95ce96b80fe8388$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e95ce96b80fe8388$var$U || $e95ce96b80fe8388$var$Lj(c, b);
        case 6:
            var d = $e95ce96b80fe8388$var$X, e = $e95ce96b80fe8388$var$Xj;
            $e95ce96b80fe8388$var$X = null;
            $e95ce96b80fe8388$var$Yj(a, b, c);
            $e95ce96b80fe8388$var$X = d;
            $e95ce96b80fe8388$var$Xj = e;
            null !== $e95ce96b80fe8388$var$X && ($e95ce96b80fe8388$var$Xj ? (a = $e95ce96b80fe8388$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e95ce96b80fe8388$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e95ce96b80fe8388$var$X && ($e95ce96b80fe8388$var$Xj ? (a = $e95ce96b80fe8388$var$X, c = c.stateNode, 8 === a.nodeType ? $e95ce96b80fe8388$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e95ce96b80fe8388$var$Kf(a, c), $e95ce96b80fe8388$var$bd(a)) : $e95ce96b80fe8388$var$Kf($e95ce96b80fe8388$var$X, c.stateNode));
            break;
        case 4:
            d = $e95ce96b80fe8388$var$X;
            e = $e95ce96b80fe8388$var$Xj;
            $e95ce96b80fe8388$var$X = c.stateNode.containerInfo;
            $e95ce96b80fe8388$var$Xj = !0;
            $e95ce96b80fe8388$var$Yj(a, b, c);
            $e95ce96b80fe8388$var$X = d;
            $e95ce96b80fe8388$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e95ce96b80fe8388$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e95ce96b80fe8388$var$Mj(c, b, g) : 0 !== (f & 4) && $e95ce96b80fe8388$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e95ce96b80fe8388$var$Yj(a, b, c);
            break;
        case 1:
            if (!$e95ce96b80fe8388$var$U && ($e95ce96b80fe8388$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e95ce96b80fe8388$var$W(c, b, h);
            }
            $e95ce96b80fe8388$var$Yj(a, b, c);
            break;
        case 21:
            $e95ce96b80fe8388$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e95ce96b80fe8388$var$U = (d = $e95ce96b80fe8388$var$U) || null !== c.memoizedState, $e95ce96b80fe8388$var$Yj(a, b, c), $e95ce96b80fe8388$var$U = d) : $e95ce96b80fe8388$var$Yj(a, b, c);
            break;
        default:
            $e95ce96b80fe8388$var$Yj(a, b, c);
    }
}
function $e95ce96b80fe8388$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e95ce96b80fe8388$var$Kj);
        b.forEach(function(b) {
            var d = $e95ce96b80fe8388$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e95ce96b80fe8388$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e95ce96b80fe8388$var$X = h.stateNode;
                        $e95ce96b80fe8388$var$Xj = !1;
                        break a;
                    case 3:
                        $e95ce96b80fe8388$var$X = h.stateNode.containerInfo;
                        $e95ce96b80fe8388$var$Xj = !0;
                        break a;
                    case 4:
                        $e95ce96b80fe8388$var$X = h.stateNode.containerInfo;
                        $e95ce96b80fe8388$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e95ce96b80fe8388$var$X) throw Error($e95ce96b80fe8388$var$p(160));
            $e95ce96b80fe8388$var$Zj(f, g, e);
            $e95ce96b80fe8388$var$X = null;
            $e95ce96b80fe8388$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e95ce96b80fe8388$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e95ce96b80fe8388$var$dk(b, a), b = b.sibling;
}
function $e95ce96b80fe8388$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e95ce96b80fe8388$var$ck(b, a);
            $e95ce96b80fe8388$var$ek(a);
            if (d & 4) {
                try {
                    $e95ce96b80fe8388$var$Pj(3, a, a.return), $e95ce96b80fe8388$var$Qj(3, a);
                } catch (t) {
                    $e95ce96b80fe8388$var$W(a, a.return, t);
                }
                try {
                    $e95ce96b80fe8388$var$Pj(5, a, a.return);
                } catch (t) {
                    $e95ce96b80fe8388$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e95ce96b80fe8388$var$ck(b, a);
            $e95ce96b80fe8388$var$ek(a);
            d & 512 && null !== c && $e95ce96b80fe8388$var$Lj(c, c.return);
            break;
        case 5:
            $e95ce96b80fe8388$var$ck(b, a);
            $e95ce96b80fe8388$var$ek(a);
            d & 512 && null !== c && $e95ce96b80fe8388$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e95ce96b80fe8388$var$ob(e, "");
                } catch (t) {
                    $e95ce96b80fe8388$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e95ce96b80fe8388$var$ab(e, f);
                    $e95ce96b80fe8388$var$vb(h, g);
                    var l = $e95ce96b80fe8388$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e95ce96b80fe8388$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e95ce96b80fe8388$var$nb(e, q) : "children" === m ? $e95ce96b80fe8388$var$ob(e, q) : $e95ce96b80fe8388$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e95ce96b80fe8388$var$bb(e, f);
                            break;
                        case "textarea":
                            $e95ce96b80fe8388$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e95ce96b80fe8388$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e95ce96b80fe8388$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e95ce96b80fe8388$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e95ce96b80fe8388$var$Pf] = f;
                } catch (t) {
                    $e95ce96b80fe8388$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e95ce96b80fe8388$var$ck(b, a);
            $e95ce96b80fe8388$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e95ce96b80fe8388$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e95ce96b80fe8388$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e95ce96b80fe8388$var$ck(b, a);
            $e95ce96b80fe8388$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e95ce96b80fe8388$var$bd(b.containerInfo);
            } catch (t) {
                $e95ce96b80fe8388$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e95ce96b80fe8388$var$ck(b, a);
            $e95ce96b80fe8388$var$ek(a);
            break;
        case 13:
            $e95ce96b80fe8388$var$ck(b, a);
            $e95ce96b80fe8388$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e95ce96b80fe8388$var$fk = $e95ce96b80fe8388$var$B()));
            d & 4 && $e95ce96b80fe8388$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e95ce96b80fe8388$var$U = (l = $e95ce96b80fe8388$var$U) || m, $e95ce96b80fe8388$var$ck(b, a), $e95ce96b80fe8388$var$U = l) : $e95ce96b80fe8388$var$ck(b, a);
            $e95ce96b80fe8388$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e95ce96b80fe8388$var$V = a, m = a.child; null !== m;){
                    for(q = $e95ce96b80fe8388$var$V = m; null !== $e95ce96b80fe8388$var$V;){
                        r = $e95ce96b80fe8388$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e95ce96b80fe8388$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $e95ce96b80fe8388$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e95ce96b80fe8388$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e95ce96b80fe8388$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e95ce96b80fe8388$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e95ce96b80fe8388$var$V = y) : $e95ce96b80fe8388$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e95ce96b80fe8388$var$rb("display", g));
                            } catch (t) {
                                $e95ce96b80fe8388$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e95ce96b80fe8388$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e95ce96b80fe8388$var$ck(b, a);
            $e95ce96b80fe8388$var$ek(a);
            d & 4 && $e95ce96b80fe8388$var$ak(a);
            break;
        case 21:
            break;
        default:
            $e95ce96b80fe8388$var$ck(b, a), $e95ce96b80fe8388$var$ek(a);
    }
}
function $e95ce96b80fe8388$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e95ce96b80fe8388$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e95ce96b80fe8388$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e95ce96b80fe8388$var$ob(e, ""), d.flags &= -33);
                    var f = $e95ce96b80fe8388$var$Uj(a);
                    $e95ce96b80fe8388$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e95ce96b80fe8388$var$Uj(a);
                    $e95ce96b80fe8388$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($e95ce96b80fe8388$var$p(161));
            }
        } catch (k) {
            $e95ce96b80fe8388$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e95ce96b80fe8388$var$hk(a, b, c) {
    $e95ce96b80fe8388$var$V = a;
    $e95ce96b80fe8388$var$ik(a, b, c);
}
function $e95ce96b80fe8388$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e95ce96b80fe8388$var$V;){
        var e = $e95ce96b80fe8388$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e95ce96b80fe8388$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e95ce96b80fe8388$var$U;
                h = $e95ce96b80fe8388$var$Jj;
                var l = $e95ce96b80fe8388$var$U;
                $e95ce96b80fe8388$var$Jj = g;
                if (($e95ce96b80fe8388$var$U = k) && !l) for($e95ce96b80fe8388$var$V = e; null !== $e95ce96b80fe8388$var$V;)g = $e95ce96b80fe8388$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e95ce96b80fe8388$var$jk(e) : null !== k ? (k.return = g, $e95ce96b80fe8388$var$V = k) : $e95ce96b80fe8388$var$jk(e);
                for(; null !== f;)$e95ce96b80fe8388$var$V = f, $e95ce96b80fe8388$var$ik(f, b, c), f = f.sibling;
                $e95ce96b80fe8388$var$V = e;
                $e95ce96b80fe8388$var$Jj = h;
                $e95ce96b80fe8388$var$U = l;
            }
            $e95ce96b80fe8388$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e95ce96b80fe8388$var$V = f) : $e95ce96b80fe8388$var$kk(a, b, c);
    }
}
function $e95ce96b80fe8388$var$kk(a) {
    for(; null !== $e95ce96b80fe8388$var$V;){
        var b = $e95ce96b80fe8388$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e95ce96b80fe8388$var$U || $e95ce96b80fe8388$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e95ce96b80fe8388$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e95ce96b80fe8388$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e95ce96b80fe8388$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e95ce96b80fe8388$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e95ce96b80fe8388$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e95ce96b80fe8388$var$p(163));
                }
                $e95ce96b80fe8388$var$U || b.flags & 512 && $e95ce96b80fe8388$var$Rj(b);
            } catch (r) {
                $e95ce96b80fe8388$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e95ce96b80fe8388$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e95ce96b80fe8388$var$V = c;
            break;
        }
        $e95ce96b80fe8388$var$V = b.return;
    }
}
function $e95ce96b80fe8388$var$gk(a) {
    for(; null !== $e95ce96b80fe8388$var$V;){
        var b = $e95ce96b80fe8388$var$V;
        if (b === a) {
            $e95ce96b80fe8388$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e95ce96b80fe8388$var$V = c;
            break;
        }
        $e95ce96b80fe8388$var$V = b.return;
    }
}
function $e95ce96b80fe8388$var$jk(a) {
    for(; null !== $e95ce96b80fe8388$var$V;){
        var b = $e95ce96b80fe8388$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e95ce96b80fe8388$var$Qj(4, b);
                    } catch (k) {
                        $e95ce96b80fe8388$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e95ce96b80fe8388$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e95ce96b80fe8388$var$Rj(b);
                    } catch (k) {
                        $e95ce96b80fe8388$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e95ce96b80fe8388$var$Rj(b);
                    } catch (k) {
                        $e95ce96b80fe8388$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e95ce96b80fe8388$var$W(b, b.return, k);
        }
        if (b === a) {
            $e95ce96b80fe8388$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e95ce96b80fe8388$var$V = h;
            break;
        }
        $e95ce96b80fe8388$var$V = b.return;
    }
}
var $e95ce96b80fe8388$var$lk = Math.ceil, $e95ce96b80fe8388$var$mk = $e95ce96b80fe8388$var$ua.ReactCurrentDispatcher, $e95ce96b80fe8388$var$nk = $e95ce96b80fe8388$var$ua.ReactCurrentOwner, $e95ce96b80fe8388$var$ok = $e95ce96b80fe8388$var$ua.ReactCurrentBatchConfig, $e95ce96b80fe8388$var$K = 0, $e95ce96b80fe8388$var$Q = null, $e95ce96b80fe8388$var$Y = null, $e95ce96b80fe8388$var$Z = 0, $e95ce96b80fe8388$var$fj = 0, $e95ce96b80fe8388$var$ej = $e95ce96b80fe8388$var$Uf(0), $e95ce96b80fe8388$var$T = 0, $e95ce96b80fe8388$var$pk = null, $e95ce96b80fe8388$var$rh = 0, $e95ce96b80fe8388$var$qk = 0, $e95ce96b80fe8388$var$rk = 0, $e95ce96b80fe8388$var$sk = null, $e95ce96b80fe8388$var$tk = null, $e95ce96b80fe8388$var$fk = 0, $e95ce96b80fe8388$var$Gj = Infinity, $e95ce96b80fe8388$var$uk = null, $e95ce96b80fe8388$var$Oi = !1, $e95ce96b80fe8388$var$Pi = null, $e95ce96b80fe8388$var$Ri = null, $e95ce96b80fe8388$var$vk = !1, $e95ce96b80fe8388$var$wk = null, $e95ce96b80fe8388$var$xk = 0, $e95ce96b80fe8388$var$yk = 0, $e95ce96b80fe8388$var$zk = null, $e95ce96b80fe8388$var$Ak = -1, $e95ce96b80fe8388$var$Bk = 0;
function $e95ce96b80fe8388$var$R() {
    return 0 !== ($e95ce96b80fe8388$var$K & 6) ? $e95ce96b80fe8388$var$B() : -1 !== $e95ce96b80fe8388$var$Ak ? $e95ce96b80fe8388$var$Ak : $e95ce96b80fe8388$var$Ak = $e95ce96b80fe8388$var$B();
}
function $e95ce96b80fe8388$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e95ce96b80fe8388$var$K & 2) && 0 !== $e95ce96b80fe8388$var$Z) return $e95ce96b80fe8388$var$Z & -$e95ce96b80fe8388$var$Z;
    if (null !== $e95ce96b80fe8388$var$Kg.transition) return 0 === $e95ce96b80fe8388$var$Bk && ($e95ce96b80fe8388$var$Bk = $e95ce96b80fe8388$var$yc()), $e95ce96b80fe8388$var$Bk;
    a = $e95ce96b80fe8388$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e95ce96b80fe8388$var$jd(a.type);
    return a;
}
function $e95ce96b80fe8388$var$gi(a, b, c, d) {
    if (50 < $e95ce96b80fe8388$var$yk) throw $e95ce96b80fe8388$var$yk = 0, $e95ce96b80fe8388$var$zk = null, Error($e95ce96b80fe8388$var$p(185));
    $e95ce96b80fe8388$var$Ac(a, c, d);
    if (0 === ($e95ce96b80fe8388$var$K & 2) || a !== $e95ce96b80fe8388$var$Q) a === $e95ce96b80fe8388$var$Q && (0 === ($e95ce96b80fe8388$var$K & 2) && ($e95ce96b80fe8388$var$qk |= c), 4 === $e95ce96b80fe8388$var$T && $e95ce96b80fe8388$var$Ck(a, $e95ce96b80fe8388$var$Z)), $e95ce96b80fe8388$var$Dk(a, d), 1 === c && 0 === $e95ce96b80fe8388$var$K && 0 === (b.mode & 1) && ($e95ce96b80fe8388$var$Gj = $e95ce96b80fe8388$var$B() + 500, $e95ce96b80fe8388$var$fg && $e95ce96b80fe8388$var$jg());
}
function $e95ce96b80fe8388$var$Dk(a, b) {
    var c = a.callbackNode;
    $e95ce96b80fe8388$var$wc(a, b);
    var d = $e95ce96b80fe8388$var$uc(a, a === $e95ce96b80fe8388$var$Q ? $e95ce96b80fe8388$var$Z : 0);
    if (0 === d) null !== c && $e95ce96b80fe8388$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e95ce96b80fe8388$var$bc(c);
        if (1 === b) 0 === a.tag ? $e95ce96b80fe8388$var$ig($e95ce96b80fe8388$var$Ek.bind(null, a)) : $e95ce96b80fe8388$var$hg($e95ce96b80fe8388$var$Ek.bind(null, a)), $e95ce96b80fe8388$var$Jf(function() {
            0 === ($e95ce96b80fe8388$var$K & 6) && $e95ce96b80fe8388$var$jg();
        }), c = null;
        else {
            switch($e95ce96b80fe8388$var$Dc(d)){
                case 1:
                    c = $e95ce96b80fe8388$var$fc;
                    break;
                case 4:
                    c = $e95ce96b80fe8388$var$gc;
                    break;
                case 16:
                    c = $e95ce96b80fe8388$var$hc;
                    break;
                case 536870912:
                    c = $e95ce96b80fe8388$var$jc;
                    break;
                default:
                    c = $e95ce96b80fe8388$var$hc;
            }
            c = $e95ce96b80fe8388$var$Fk(c, $e95ce96b80fe8388$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e95ce96b80fe8388$var$Gk(a, b) {
    $e95ce96b80fe8388$var$Ak = -1;
    $e95ce96b80fe8388$var$Bk = 0;
    if (0 !== ($e95ce96b80fe8388$var$K & 6)) throw Error($e95ce96b80fe8388$var$p(327));
    var c = a.callbackNode;
    if ($e95ce96b80fe8388$var$Hk() && a.callbackNode !== c) return null;
    var d = $e95ce96b80fe8388$var$uc(a, a === $e95ce96b80fe8388$var$Q ? $e95ce96b80fe8388$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e95ce96b80fe8388$var$Ik(a, d);
    else {
        b = d;
        var e = $e95ce96b80fe8388$var$K;
        $e95ce96b80fe8388$var$K |= 2;
        var f = $e95ce96b80fe8388$var$Jk();
        if ($e95ce96b80fe8388$var$Q !== a || $e95ce96b80fe8388$var$Z !== b) $e95ce96b80fe8388$var$uk = null, $e95ce96b80fe8388$var$Gj = $e95ce96b80fe8388$var$B() + 500, $e95ce96b80fe8388$var$Kk(a, b);
        for(;;)try {
            $e95ce96b80fe8388$var$Lk();
            break;
        } catch (h) {
            $e95ce96b80fe8388$var$Mk(a, h);
        }
        $e95ce96b80fe8388$var$$g();
        $e95ce96b80fe8388$var$mk.current = f;
        $e95ce96b80fe8388$var$K = e;
        null !== $e95ce96b80fe8388$var$Y ? b = 0 : ($e95ce96b80fe8388$var$Q = null, $e95ce96b80fe8388$var$Z = 0, b = $e95ce96b80fe8388$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e95ce96b80fe8388$var$xc(a), 0 !== e && (d = e, b = $e95ce96b80fe8388$var$Nk(a, e)));
        if (1 === b) throw c = $e95ce96b80fe8388$var$pk, $e95ce96b80fe8388$var$Kk(a, 0), $e95ce96b80fe8388$var$Ck(a, d), $e95ce96b80fe8388$var$Dk(a, $e95ce96b80fe8388$var$B()), c;
        if (6 === b) $e95ce96b80fe8388$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e95ce96b80fe8388$var$Ok(e) && (b = $e95ce96b80fe8388$var$Ik(a, d), 2 === b && (f = $e95ce96b80fe8388$var$xc(a), 0 !== f && (d = f, b = $e95ce96b80fe8388$var$Nk(a, f))), 1 === b)) throw c = $e95ce96b80fe8388$var$pk, $e95ce96b80fe8388$var$Kk(a, 0), $e95ce96b80fe8388$var$Ck(a, d), $e95ce96b80fe8388$var$Dk(a, $e95ce96b80fe8388$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e95ce96b80fe8388$var$p(345));
                case 2:
                    $e95ce96b80fe8388$var$Pk(a, $e95ce96b80fe8388$var$tk, $e95ce96b80fe8388$var$uk);
                    break;
                case 3:
                    $e95ce96b80fe8388$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $e95ce96b80fe8388$var$fk + 500 - $e95ce96b80fe8388$var$B(), 10 < b)) {
                        if (0 !== $e95ce96b80fe8388$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e95ce96b80fe8388$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e95ce96b80fe8388$var$Ff($e95ce96b80fe8388$var$Pk.bind(null, a, $e95ce96b80fe8388$var$tk, $e95ce96b80fe8388$var$uk), b);
                        break;
                    }
                    $e95ce96b80fe8388$var$Pk(a, $e95ce96b80fe8388$var$tk, $e95ce96b80fe8388$var$uk);
                    break;
                case 4:
                    $e95ce96b80fe8388$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e95ce96b80fe8388$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e95ce96b80fe8388$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e95ce96b80fe8388$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e95ce96b80fe8388$var$Ff($e95ce96b80fe8388$var$Pk.bind(null, a, $e95ce96b80fe8388$var$tk, $e95ce96b80fe8388$var$uk), d);
                        break;
                    }
                    $e95ce96b80fe8388$var$Pk(a, $e95ce96b80fe8388$var$tk, $e95ce96b80fe8388$var$uk);
                    break;
                case 5:
                    $e95ce96b80fe8388$var$Pk(a, $e95ce96b80fe8388$var$tk, $e95ce96b80fe8388$var$uk);
                    break;
                default:
                    throw Error($e95ce96b80fe8388$var$p(329));
            }
        }
    }
    $e95ce96b80fe8388$var$Dk(a, $e95ce96b80fe8388$var$B());
    return a.callbackNode === c ? $e95ce96b80fe8388$var$Gk.bind(null, a) : null;
}
function $e95ce96b80fe8388$var$Nk(a, b) {
    var c = $e95ce96b80fe8388$var$sk;
    a.current.memoizedState.isDehydrated && ($e95ce96b80fe8388$var$Kk(a, b).flags |= 256);
    a = $e95ce96b80fe8388$var$Ik(a, b);
    2 !== a && (b = $e95ce96b80fe8388$var$tk, $e95ce96b80fe8388$var$tk = c, null !== b && $e95ce96b80fe8388$var$Fj(b));
    return a;
}
function $e95ce96b80fe8388$var$Fj(a) {
    null === $e95ce96b80fe8388$var$tk ? $e95ce96b80fe8388$var$tk = a : $e95ce96b80fe8388$var$tk.push.apply($e95ce96b80fe8388$var$tk, a);
}
function $e95ce96b80fe8388$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e95ce96b80fe8388$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e95ce96b80fe8388$var$Ck(a, b) {
    b &= ~$e95ce96b80fe8388$var$rk;
    b &= ~$e95ce96b80fe8388$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e95ce96b80fe8388$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e95ce96b80fe8388$var$Ek(a) {
    if (0 !== ($e95ce96b80fe8388$var$K & 6)) throw Error($e95ce96b80fe8388$var$p(327));
    $e95ce96b80fe8388$var$Hk();
    var b = $e95ce96b80fe8388$var$uc(a, 0);
    if (0 === (b & 1)) return $e95ce96b80fe8388$var$Dk(a, $e95ce96b80fe8388$var$B()), null;
    var c = $e95ce96b80fe8388$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e95ce96b80fe8388$var$xc(a);
        0 !== d && (b = d, c = $e95ce96b80fe8388$var$Nk(a, d));
    }
    if (1 === c) throw c = $e95ce96b80fe8388$var$pk, $e95ce96b80fe8388$var$Kk(a, 0), $e95ce96b80fe8388$var$Ck(a, b), $e95ce96b80fe8388$var$Dk(a, $e95ce96b80fe8388$var$B()), c;
    if (6 === c) throw Error($e95ce96b80fe8388$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e95ce96b80fe8388$var$Pk(a, $e95ce96b80fe8388$var$tk, $e95ce96b80fe8388$var$uk);
    $e95ce96b80fe8388$var$Dk(a, $e95ce96b80fe8388$var$B());
    return null;
}
function $e95ce96b80fe8388$var$Qk(a, b) {
    var c = $e95ce96b80fe8388$var$K;
    $e95ce96b80fe8388$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e95ce96b80fe8388$var$K = c, 0 === $e95ce96b80fe8388$var$K && ($e95ce96b80fe8388$var$Gj = $e95ce96b80fe8388$var$B() + 500, $e95ce96b80fe8388$var$fg && $e95ce96b80fe8388$var$jg());
    }
}
function $e95ce96b80fe8388$var$Rk(a) {
    null !== $e95ce96b80fe8388$var$wk && 0 === $e95ce96b80fe8388$var$wk.tag && 0 === ($e95ce96b80fe8388$var$K & 6) && $e95ce96b80fe8388$var$Hk();
    var b = $e95ce96b80fe8388$var$K;
    $e95ce96b80fe8388$var$K |= 1;
    var c = $e95ce96b80fe8388$var$ok.transition, d = $e95ce96b80fe8388$var$C;
    try {
        if ($e95ce96b80fe8388$var$ok.transition = null, $e95ce96b80fe8388$var$C = 1, a) return a();
    } finally{
        $e95ce96b80fe8388$var$C = d, $e95ce96b80fe8388$var$ok.transition = c, $e95ce96b80fe8388$var$K = b, 0 === ($e95ce96b80fe8388$var$K & 6) && $e95ce96b80fe8388$var$jg();
    }
}
function $e95ce96b80fe8388$var$Hj() {
    $e95ce96b80fe8388$var$fj = $e95ce96b80fe8388$var$ej.current;
    $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$ej);
}
function $e95ce96b80fe8388$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e95ce96b80fe8388$var$Gf(c));
    if (null !== $e95ce96b80fe8388$var$Y) for(c = $e95ce96b80fe8388$var$Y.return; null !== c;){
        var d = c;
        $e95ce96b80fe8388$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e95ce96b80fe8388$var$$f();
                break;
            case 3:
                $e95ce96b80fe8388$var$zh();
                $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$Wf);
                $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$H);
                $e95ce96b80fe8388$var$Eh();
                break;
            case 5:
                $e95ce96b80fe8388$var$Bh(d);
                break;
            case 4:
                $e95ce96b80fe8388$var$zh();
                break;
            case 13:
                $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$L);
                break;
            case 19:
                $e95ce96b80fe8388$var$E($e95ce96b80fe8388$var$L);
                break;
            case 10:
                $e95ce96b80fe8388$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $e95ce96b80fe8388$var$Hj();
        }
        c = c.return;
    }
    $e95ce96b80fe8388$var$Q = a;
    $e95ce96b80fe8388$var$Y = a = $e95ce96b80fe8388$var$Pg(a.current, null);
    $e95ce96b80fe8388$var$Z = $e95ce96b80fe8388$var$fj = b;
    $e95ce96b80fe8388$var$T = 0;
    $e95ce96b80fe8388$var$pk = null;
    $e95ce96b80fe8388$var$rk = $e95ce96b80fe8388$var$qk = $e95ce96b80fe8388$var$rh = 0;
    $e95ce96b80fe8388$var$tk = $e95ce96b80fe8388$var$sk = null;
    if (null !== $e95ce96b80fe8388$var$fh) {
        for(b = 0; b < $e95ce96b80fe8388$var$fh.length; b++)if (c = $e95ce96b80fe8388$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e95ce96b80fe8388$var$fh = null;
    }
    return a;
}
function $e95ce96b80fe8388$var$Mk(a, b) {
    do {
        var c = $e95ce96b80fe8388$var$Y;
        try {
            $e95ce96b80fe8388$var$$g();
            $e95ce96b80fe8388$var$Fh.current = $e95ce96b80fe8388$var$Rh;
            if ($e95ce96b80fe8388$var$Ih) {
                for(var d = $e95ce96b80fe8388$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e95ce96b80fe8388$var$Ih = !1;
            }
            $e95ce96b80fe8388$var$Hh = 0;
            $e95ce96b80fe8388$var$O = $e95ce96b80fe8388$var$N = $e95ce96b80fe8388$var$M = null;
            $e95ce96b80fe8388$var$Jh = !1;
            $e95ce96b80fe8388$var$Kh = 0;
            $e95ce96b80fe8388$var$nk.current = null;
            if (null === c || null === c.return) {
                $e95ce96b80fe8388$var$T = 1;
                $e95ce96b80fe8388$var$pk = b;
                $e95ce96b80fe8388$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e95ce96b80fe8388$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e95ce96b80fe8388$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e95ce96b80fe8388$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $e95ce96b80fe8388$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e95ce96b80fe8388$var$Si(f, l, b);
                            $e95ce96b80fe8388$var$tj();
                            break a;
                        }
                        k = Error($e95ce96b80fe8388$var$p(426));
                    }
                } else if ($e95ce96b80fe8388$var$I && h.mode & 1) {
                    var J = $e95ce96b80fe8388$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e95ce96b80fe8388$var$Vi(J, g, h, f, b);
                        $e95ce96b80fe8388$var$Jg($e95ce96b80fe8388$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $e95ce96b80fe8388$var$Ji(k, h);
                4 !== $e95ce96b80fe8388$var$T && ($e95ce96b80fe8388$var$T = 2);
                null === $e95ce96b80fe8388$var$sk ? $e95ce96b80fe8388$var$sk = [
                    f
                ] : $e95ce96b80fe8388$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e95ce96b80fe8388$var$Ni(f, k, b);
                            $e95ce96b80fe8388$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e95ce96b80fe8388$var$Ri || !$e95ce96b80fe8388$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e95ce96b80fe8388$var$Qi(f, h, b);
                                $e95ce96b80fe8388$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e95ce96b80fe8388$var$Sk(c);
        } catch (na) {
            b = na;
            $e95ce96b80fe8388$var$Y === c && null !== c && ($e95ce96b80fe8388$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e95ce96b80fe8388$var$Jk() {
    var a = $e95ce96b80fe8388$var$mk.current;
    $e95ce96b80fe8388$var$mk.current = $e95ce96b80fe8388$var$Rh;
    return null === a ? $e95ce96b80fe8388$var$Rh : a;
}
function $e95ce96b80fe8388$var$tj() {
    if (0 === $e95ce96b80fe8388$var$T || 3 === $e95ce96b80fe8388$var$T || 2 === $e95ce96b80fe8388$var$T) $e95ce96b80fe8388$var$T = 4;
    null === $e95ce96b80fe8388$var$Q || 0 === ($e95ce96b80fe8388$var$rh & 268435455) && 0 === ($e95ce96b80fe8388$var$qk & 268435455) || $e95ce96b80fe8388$var$Ck($e95ce96b80fe8388$var$Q, $e95ce96b80fe8388$var$Z);
}
function $e95ce96b80fe8388$var$Ik(a, b) {
    var c = $e95ce96b80fe8388$var$K;
    $e95ce96b80fe8388$var$K |= 2;
    var d = $e95ce96b80fe8388$var$Jk();
    if ($e95ce96b80fe8388$var$Q !== a || $e95ce96b80fe8388$var$Z !== b) $e95ce96b80fe8388$var$uk = null, $e95ce96b80fe8388$var$Kk(a, b);
    for(;;)try {
        $e95ce96b80fe8388$var$Tk();
        break;
    } catch (e) {
        $e95ce96b80fe8388$var$Mk(a, e);
    }
    $e95ce96b80fe8388$var$$g();
    $e95ce96b80fe8388$var$K = c;
    $e95ce96b80fe8388$var$mk.current = d;
    if (null !== $e95ce96b80fe8388$var$Y) throw Error($e95ce96b80fe8388$var$p(261));
    $e95ce96b80fe8388$var$Q = null;
    $e95ce96b80fe8388$var$Z = 0;
    return $e95ce96b80fe8388$var$T;
}
function $e95ce96b80fe8388$var$Tk() {
    for(; null !== $e95ce96b80fe8388$var$Y;)$e95ce96b80fe8388$var$Uk($e95ce96b80fe8388$var$Y);
}
function $e95ce96b80fe8388$var$Lk() {
    for(; null !== $e95ce96b80fe8388$var$Y && !$e95ce96b80fe8388$var$cc();)$e95ce96b80fe8388$var$Uk($e95ce96b80fe8388$var$Y);
}
function $e95ce96b80fe8388$var$Uk(a) {
    var b = $e95ce96b80fe8388$var$Vk(a.alternate, a, $e95ce96b80fe8388$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e95ce96b80fe8388$var$Sk(a) : $e95ce96b80fe8388$var$Y = b;
    $e95ce96b80fe8388$var$nk.current = null;
}
function $e95ce96b80fe8388$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e95ce96b80fe8388$var$Ej(c, b, $e95ce96b80fe8388$var$fj), null !== c) {
                $e95ce96b80fe8388$var$Y = c;
                return;
            }
        } else {
            c = $e95ce96b80fe8388$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e95ce96b80fe8388$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e95ce96b80fe8388$var$T = 6;
                $e95ce96b80fe8388$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e95ce96b80fe8388$var$Y = b;
            return;
        }
        $e95ce96b80fe8388$var$Y = b = a;
    }while (null !== b);
    0 === $e95ce96b80fe8388$var$T && ($e95ce96b80fe8388$var$T = 5);
}
function $e95ce96b80fe8388$var$Pk(a, b, c) {
    var d = $e95ce96b80fe8388$var$C, e = $e95ce96b80fe8388$var$ok.transition;
    try {
        $e95ce96b80fe8388$var$ok.transition = null, $e95ce96b80fe8388$var$C = 1, $e95ce96b80fe8388$var$Wk(a, b, c, d);
    } finally{
        $e95ce96b80fe8388$var$ok.transition = e, $e95ce96b80fe8388$var$C = d;
    }
    return null;
}
function $e95ce96b80fe8388$var$Wk(a, b, c, d) {
    do $e95ce96b80fe8388$var$Hk();
    while (null !== $e95ce96b80fe8388$var$wk);
    if (0 !== ($e95ce96b80fe8388$var$K & 6)) throw Error($e95ce96b80fe8388$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e95ce96b80fe8388$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e95ce96b80fe8388$var$Bc(a, f);
    a === $e95ce96b80fe8388$var$Q && ($e95ce96b80fe8388$var$Y = $e95ce96b80fe8388$var$Q = null, $e95ce96b80fe8388$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e95ce96b80fe8388$var$vk || ($e95ce96b80fe8388$var$vk = !0, $e95ce96b80fe8388$var$Fk($e95ce96b80fe8388$var$hc, function() {
        $e95ce96b80fe8388$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e95ce96b80fe8388$var$ok.transition;
        $e95ce96b80fe8388$var$ok.transition = null;
        var g = $e95ce96b80fe8388$var$C;
        $e95ce96b80fe8388$var$C = 1;
        var h = $e95ce96b80fe8388$var$K;
        $e95ce96b80fe8388$var$K |= 4;
        $e95ce96b80fe8388$var$nk.current = null;
        $e95ce96b80fe8388$var$Oj(a, c);
        $e95ce96b80fe8388$var$dk(c, a);
        $e95ce96b80fe8388$var$Oe($e95ce96b80fe8388$var$Df);
        $e95ce96b80fe8388$var$dd = !!$e95ce96b80fe8388$var$Cf;
        $e95ce96b80fe8388$var$Df = $e95ce96b80fe8388$var$Cf = null;
        a.current = c;
        $e95ce96b80fe8388$var$hk(c, a, e);
        $e95ce96b80fe8388$var$dc();
        $e95ce96b80fe8388$var$K = h;
        $e95ce96b80fe8388$var$C = g;
        $e95ce96b80fe8388$var$ok.transition = f;
    } else a.current = c;
    $e95ce96b80fe8388$var$vk && ($e95ce96b80fe8388$var$vk = !1, $e95ce96b80fe8388$var$wk = a, $e95ce96b80fe8388$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($e95ce96b80fe8388$var$Ri = null);
    $e95ce96b80fe8388$var$mc(c.stateNode, d);
    $e95ce96b80fe8388$var$Dk(a, $e95ce96b80fe8388$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e95ce96b80fe8388$var$Oi) throw $e95ce96b80fe8388$var$Oi = !1, a = $e95ce96b80fe8388$var$Pi, $e95ce96b80fe8388$var$Pi = null, a;
    0 !== ($e95ce96b80fe8388$var$xk & 1) && 0 !== a.tag && $e95ce96b80fe8388$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e95ce96b80fe8388$var$zk ? $e95ce96b80fe8388$var$yk++ : ($e95ce96b80fe8388$var$yk = 0, $e95ce96b80fe8388$var$zk = a) : $e95ce96b80fe8388$var$yk = 0;
    $e95ce96b80fe8388$var$jg();
    return null;
}
function $e95ce96b80fe8388$var$Hk() {
    if (null !== $e95ce96b80fe8388$var$wk) {
        var a = $e95ce96b80fe8388$var$Dc($e95ce96b80fe8388$var$xk), b = $e95ce96b80fe8388$var$ok.transition, c = $e95ce96b80fe8388$var$C;
        try {
            $e95ce96b80fe8388$var$ok.transition = null;
            $e95ce96b80fe8388$var$C = 16 > a ? 16 : a;
            if (null === $e95ce96b80fe8388$var$wk) var d = !1;
            else {
                a = $e95ce96b80fe8388$var$wk;
                $e95ce96b80fe8388$var$wk = null;
                $e95ce96b80fe8388$var$xk = 0;
                if (0 !== ($e95ce96b80fe8388$var$K & 6)) throw Error($e95ce96b80fe8388$var$p(331));
                var e = $e95ce96b80fe8388$var$K;
                $e95ce96b80fe8388$var$K |= 4;
                for($e95ce96b80fe8388$var$V = a.current; null !== $e95ce96b80fe8388$var$V;){
                    var f = $e95ce96b80fe8388$var$V, g = f.child;
                    if (0 !== ($e95ce96b80fe8388$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e95ce96b80fe8388$var$V = l; null !== $e95ce96b80fe8388$var$V;){
                                    var m = $e95ce96b80fe8388$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e95ce96b80fe8388$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e95ce96b80fe8388$var$V = q;
                                    else for(; null !== $e95ce96b80fe8388$var$V;){
                                        m = $e95ce96b80fe8388$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e95ce96b80fe8388$var$Sj(m);
                                        if (m === l) {
                                            $e95ce96b80fe8388$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e95ce96b80fe8388$var$V = r;
                                            break;
                                        }
                                        $e95ce96b80fe8388$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e95ce96b80fe8388$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e95ce96b80fe8388$var$V = g;
                    else b: for(; null !== $e95ce96b80fe8388$var$V;){
                        f = $e95ce96b80fe8388$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e95ce96b80fe8388$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e95ce96b80fe8388$var$V = x;
                            break b;
                        }
                        $e95ce96b80fe8388$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e95ce96b80fe8388$var$V = w; null !== $e95ce96b80fe8388$var$V;){
                    g = $e95ce96b80fe8388$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e95ce96b80fe8388$var$V = u;
                    else b: for(g = w; null !== $e95ce96b80fe8388$var$V;){
                        h = $e95ce96b80fe8388$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e95ce96b80fe8388$var$Qj(9, h);
                            }
                        } catch (na) {
                            $e95ce96b80fe8388$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e95ce96b80fe8388$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e95ce96b80fe8388$var$V = F;
                            break b;
                        }
                        $e95ce96b80fe8388$var$V = h.return;
                    }
                }
                $e95ce96b80fe8388$var$K = e;
                $e95ce96b80fe8388$var$jg();
                if ($e95ce96b80fe8388$var$lc && "function" === typeof $e95ce96b80fe8388$var$lc.onPostCommitFiberRoot) try {
                    $e95ce96b80fe8388$var$lc.onPostCommitFiberRoot($e95ce96b80fe8388$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e95ce96b80fe8388$var$C = c, $e95ce96b80fe8388$var$ok.transition = b;
        }
    }
    return !1;
}
function $e95ce96b80fe8388$var$Xk(a, b, c) {
    b = $e95ce96b80fe8388$var$Ji(c, b);
    b = $e95ce96b80fe8388$var$Ni(a, b, 1);
    a = $e95ce96b80fe8388$var$nh(a, b, 1);
    b = $e95ce96b80fe8388$var$R();
    null !== a && ($e95ce96b80fe8388$var$Ac(a, 1, b), $e95ce96b80fe8388$var$Dk(a, b));
}
function $e95ce96b80fe8388$var$W(a, b, c) {
    if (3 === a.tag) $e95ce96b80fe8388$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e95ce96b80fe8388$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e95ce96b80fe8388$var$Ri || !$e95ce96b80fe8388$var$Ri.has(d))) {
                a = $e95ce96b80fe8388$var$Ji(c, a);
                a = $e95ce96b80fe8388$var$Qi(b, a, 1);
                b = $e95ce96b80fe8388$var$nh(b, a, 1);
                a = $e95ce96b80fe8388$var$R();
                null !== b && ($e95ce96b80fe8388$var$Ac(b, 1, a), $e95ce96b80fe8388$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e95ce96b80fe8388$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e95ce96b80fe8388$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $e95ce96b80fe8388$var$Q === a && ($e95ce96b80fe8388$var$Z & c) === c && (4 === $e95ce96b80fe8388$var$T || 3 === $e95ce96b80fe8388$var$T && ($e95ce96b80fe8388$var$Z & 130023424) === $e95ce96b80fe8388$var$Z && 500 > $e95ce96b80fe8388$var$B() - $e95ce96b80fe8388$var$fk ? $e95ce96b80fe8388$var$Kk(a, 0) : $e95ce96b80fe8388$var$rk |= c);
    $e95ce96b80fe8388$var$Dk(a, b);
}
function $e95ce96b80fe8388$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e95ce96b80fe8388$var$sc, $e95ce96b80fe8388$var$sc <<= 1, 0 === ($e95ce96b80fe8388$var$sc & 130023424) && ($e95ce96b80fe8388$var$sc = 4194304)));
    var c = $e95ce96b80fe8388$var$R();
    a = $e95ce96b80fe8388$var$ih(a, b);
    null !== a && ($e95ce96b80fe8388$var$Ac(a, b, c), $e95ce96b80fe8388$var$Dk(a, c));
}
function $e95ce96b80fe8388$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e95ce96b80fe8388$var$Yk(a, c);
}
function $e95ce96b80fe8388$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e95ce96b80fe8388$var$p(314));
    }
    null !== d && d.delete(b);
    $e95ce96b80fe8388$var$Yk(a, c);
}
var $e95ce96b80fe8388$var$Vk;
$e95ce96b80fe8388$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e95ce96b80fe8388$var$Wf.current) $e95ce96b80fe8388$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e95ce96b80fe8388$var$dh = !1, $e95ce96b80fe8388$var$yj(a, b, c);
            $e95ce96b80fe8388$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e95ce96b80fe8388$var$dh = !1, $e95ce96b80fe8388$var$I && 0 !== (b.flags & 1048576) && $e95ce96b80fe8388$var$ug(b, $e95ce96b80fe8388$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e95ce96b80fe8388$var$ij(a, b);
            a = b.pendingProps;
            var e = $e95ce96b80fe8388$var$Yf(b, $e95ce96b80fe8388$var$H.current);
            $e95ce96b80fe8388$var$ch(b, c);
            e = $e95ce96b80fe8388$var$Nh(null, b, d, a, e, c);
            var f = $e95ce96b80fe8388$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e95ce96b80fe8388$var$Zf(d) ? (f = !0, $e95ce96b80fe8388$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e95ce96b80fe8388$var$kh(b), e.updater = $e95ce96b80fe8388$var$Ei, b.stateNode = e, e._reactInternals = b, $e95ce96b80fe8388$var$Ii(b, d, a, c), b = $e95ce96b80fe8388$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $e95ce96b80fe8388$var$I && f && $e95ce96b80fe8388$var$vg(b), $e95ce96b80fe8388$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e95ce96b80fe8388$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e95ce96b80fe8388$var$Zk(d);
                a = $e95ce96b80fe8388$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $e95ce96b80fe8388$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e95ce96b80fe8388$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e95ce96b80fe8388$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e95ce96b80fe8388$var$$i(null, b, d, $e95ce96b80fe8388$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($e95ce96b80fe8388$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e95ce96b80fe8388$var$Ci(d, e), $e95ce96b80fe8388$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e95ce96b80fe8388$var$Ci(d, e), $e95ce96b80fe8388$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $e95ce96b80fe8388$var$kj(b);
                if (null === a) throw Error($e95ce96b80fe8388$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e95ce96b80fe8388$var$lh(a, b);
                $e95ce96b80fe8388$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e95ce96b80fe8388$var$Ji(Error($e95ce96b80fe8388$var$p(423)), b);
                        b = $e95ce96b80fe8388$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e95ce96b80fe8388$var$Ji(Error($e95ce96b80fe8388$var$p(424)), b);
                        b = $e95ce96b80fe8388$var$lj(a, b, d, c, e);
                        break a;
                    } else for($e95ce96b80fe8388$var$yg = $e95ce96b80fe8388$var$Lf(b.stateNode.containerInfo.firstChild), $e95ce96b80fe8388$var$xg = b, $e95ce96b80fe8388$var$I = !0, $e95ce96b80fe8388$var$zg = null, c = $e95ce96b80fe8388$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e95ce96b80fe8388$var$Ig();
                    if (d === e) {
                        b = $e95ce96b80fe8388$var$Zi(a, b, c);
                        break a;
                    }
                    $e95ce96b80fe8388$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e95ce96b80fe8388$var$Ah(b), null === a && $e95ce96b80fe8388$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e95ce96b80fe8388$var$Ef(d, e) ? g = null : null !== f && $e95ce96b80fe8388$var$Ef(d, f) && (b.flags |= 32), $e95ce96b80fe8388$var$gj(a, b), $e95ce96b80fe8388$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $e95ce96b80fe8388$var$Eg(b), null;
        case 13:
            return $e95ce96b80fe8388$var$oj(a, b, c);
        case 4:
            return $e95ce96b80fe8388$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e95ce96b80fe8388$var$Ug(b, null, d, c) : $e95ce96b80fe8388$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e95ce96b80fe8388$var$Ci(d, e), $e95ce96b80fe8388$var$Yi(a, b, d, e, c);
        case 7:
            return $e95ce96b80fe8388$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e95ce96b80fe8388$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e95ce96b80fe8388$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e95ce96b80fe8388$var$G($e95ce96b80fe8388$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e95ce96b80fe8388$var$He(f.value, g)) {
                        if (f.children === e.children && !$e95ce96b80fe8388$var$Wf.current) {
                            b = $e95ce96b80fe8388$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e95ce96b80fe8388$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e95ce96b80fe8388$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e95ce96b80fe8388$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e95ce96b80fe8388$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e95ce96b80fe8388$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e95ce96b80fe8388$var$ch(b, c), e = $e95ce96b80fe8388$var$eh(e), d = d(e), b.flags |= 1, $e95ce96b80fe8388$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e95ce96b80fe8388$var$Ci(d, b.pendingProps), e = $e95ce96b80fe8388$var$Ci(d.type, e), $e95ce96b80fe8388$var$$i(a, b, d, e, c);
        case 15:
            return $e95ce96b80fe8388$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e95ce96b80fe8388$var$Ci(d, e), $e95ce96b80fe8388$var$ij(a, b), b.tag = 1, $e95ce96b80fe8388$var$Zf(d) ? (a = !0, $e95ce96b80fe8388$var$cg(b)) : a = !1, $e95ce96b80fe8388$var$ch(b, c), $e95ce96b80fe8388$var$Gi(b, d, e), $e95ce96b80fe8388$var$Ii(b, d, e, c), $e95ce96b80fe8388$var$jj(null, b, d, !0, a, c);
        case 19:
            return $e95ce96b80fe8388$var$xj(a, b, c);
        case 22:
            return $e95ce96b80fe8388$var$dj(a, b, c);
    }
    throw Error($e95ce96b80fe8388$var$p(156, b.tag));
};
function $e95ce96b80fe8388$var$Fk(a, b) {
    return $e95ce96b80fe8388$var$ac(a, b);
}
function $e95ce96b80fe8388$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e95ce96b80fe8388$var$Bg(a, b, c, d) {
    return new $e95ce96b80fe8388$var$$k(a, b, c, d);
}
function $e95ce96b80fe8388$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e95ce96b80fe8388$var$Zk(a) {
    if ("function" === typeof a) return $e95ce96b80fe8388$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e95ce96b80fe8388$var$Da) return 11;
        if (a === $e95ce96b80fe8388$var$Ga) return 14;
    }
    return 2;
}
function $e95ce96b80fe8388$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $e95ce96b80fe8388$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e95ce96b80fe8388$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e95ce96b80fe8388$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e95ce96b80fe8388$var$ya:
            return $e95ce96b80fe8388$var$Tg(c.children, e, f, b);
        case $e95ce96b80fe8388$var$za:
            g = 8;
            e |= 8;
            break;
        case $e95ce96b80fe8388$var$Aa:
            return a = $e95ce96b80fe8388$var$Bg(12, c, b, e | 2), a.elementType = $e95ce96b80fe8388$var$Aa, a.lanes = f, a;
        case $e95ce96b80fe8388$var$Ea:
            return a = $e95ce96b80fe8388$var$Bg(13, c, b, e), a.elementType = $e95ce96b80fe8388$var$Ea, a.lanes = f, a;
        case $e95ce96b80fe8388$var$Fa:
            return a = $e95ce96b80fe8388$var$Bg(19, c, b, e), a.elementType = $e95ce96b80fe8388$var$Fa, a.lanes = f, a;
        case $e95ce96b80fe8388$var$Ia:
            return $e95ce96b80fe8388$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e95ce96b80fe8388$var$Ba:
                    g = 10;
                    break a;
                case $e95ce96b80fe8388$var$Ca:
                    g = 9;
                    break a;
                case $e95ce96b80fe8388$var$Da:
                    g = 11;
                    break a;
                case $e95ce96b80fe8388$var$Ga:
                    g = 14;
                    break a;
                case $e95ce96b80fe8388$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e95ce96b80fe8388$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e95ce96b80fe8388$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e95ce96b80fe8388$var$Tg(a, b, c, d) {
    a = $e95ce96b80fe8388$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e95ce96b80fe8388$var$pj(a, b, c, d) {
    a = $e95ce96b80fe8388$var$Bg(22, a, d, b);
    a.elementType = $e95ce96b80fe8388$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e95ce96b80fe8388$var$Qg(a, b, c) {
    a = $e95ce96b80fe8388$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e95ce96b80fe8388$var$Sg(a, b, c) {
    b = $e95ce96b80fe8388$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e95ce96b80fe8388$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e95ce96b80fe8388$var$zc(0);
    this.expirationTimes = $e95ce96b80fe8388$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e95ce96b80fe8388$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e95ce96b80fe8388$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $e95ce96b80fe8388$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e95ce96b80fe8388$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e95ce96b80fe8388$var$kh(f);
    return a;
}
function $e95ce96b80fe8388$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e95ce96b80fe8388$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e95ce96b80fe8388$var$dl(a) {
    if (!a) return $e95ce96b80fe8388$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e95ce96b80fe8388$var$Vb(a) !== a || 1 !== a.tag) throw Error($e95ce96b80fe8388$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e95ce96b80fe8388$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e95ce96b80fe8388$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e95ce96b80fe8388$var$Zf(c)) return $e95ce96b80fe8388$var$bg(a, c, b);
    }
    return b;
}
function $e95ce96b80fe8388$var$el(a, b, c, d, e, f, g, h, k) {
    a = $e95ce96b80fe8388$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $e95ce96b80fe8388$var$dl(null);
    c = a.current;
    d = $e95ce96b80fe8388$var$R();
    e = $e95ce96b80fe8388$var$yi(c);
    f = $e95ce96b80fe8388$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e95ce96b80fe8388$var$nh(c, f, e);
    a.current.lanes = e;
    $e95ce96b80fe8388$var$Ac(a, e, d);
    $e95ce96b80fe8388$var$Dk(a, d);
    return a;
}
function $e95ce96b80fe8388$var$fl(a, b, c, d) {
    var e = b.current, f = $e95ce96b80fe8388$var$R(), g = $e95ce96b80fe8388$var$yi(e);
    c = $e95ce96b80fe8388$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e95ce96b80fe8388$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e95ce96b80fe8388$var$nh(e, b, g);
    null !== a && ($e95ce96b80fe8388$var$gi(a, e, g, f), $e95ce96b80fe8388$var$oh(a, e, g));
    return g;
}
function $e95ce96b80fe8388$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e95ce96b80fe8388$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e95ce96b80fe8388$var$il(a, b) {
    $e95ce96b80fe8388$var$hl(a, b);
    (a = a.alternate) && $e95ce96b80fe8388$var$hl(a, b);
}
function $e95ce96b80fe8388$var$jl() {
    return null;
}
var $e95ce96b80fe8388$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e95ce96b80fe8388$var$ll(a) {
    this._internalRoot = a;
}
$e95ce96b80fe8388$var$ml.prototype.render = $e95ce96b80fe8388$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e95ce96b80fe8388$var$p(409));
    $e95ce96b80fe8388$var$fl(a, b, null, null);
};
$e95ce96b80fe8388$var$ml.prototype.unmount = $e95ce96b80fe8388$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e95ce96b80fe8388$var$Rk(function() {
            $e95ce96b80fe8388$var$fl(null, a, null, null);
        });
        b[$e95ce96b80fe8388$var$uf] = null;
    }
};
function $e95ce96b80fe8388$var$ml(a) {
    this._internalRoot = a;
}
$e95ce96b80fe8388$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e95ce96b80fe8388$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e95ce96b80fe8388$var$Qc.length && 0 !== b && b < $e95ce96b80fe8388$var$Qc[c].priority; c++);
        $e95ce96b80fe8388$var$Qc.splice(c, 0, a);
        0 === c && $e95ce96b80fe8388$var$Vc(a);
    }
};
function $e95ce96b80fe8388$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e95ce96b80fe8388$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e95ce96b80fe8388$var$pl() {}
function $e95ce96b80fe8388$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e95ce96b80fe8388$var$gl(g);
                f.call(a);
            };
        }
        var g = $e95ce96b80fe8388$var$el(b, d, a, 0, null, !1, !1, "", $e95ce96b80fe8388$var$pl);
        a._reactRootContainer = g;
        a[$e95ce96b80fe8388$var$uf] = g.current;
        $e95ce96b80fe8388$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e95ce96b80fe8388$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e95ce96b80fe8388$var$gl(k);
            h.call(a);
        };
    }
    var k = $e95ce96b80fe8388$var$bl(a, 0, !1, null, null, !1, !1, "", $e95ce96b80fe8388$var$pl);
    a._reactRootContainer = k;
    a[$e95ce96b80fe8388$var$uf] = k.current;
    $e95ce96b80fe8388$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e95ce96b80fe8388$var$Rk(function() {
        $e95ce96b80fe8388$var$fl(b, k, c, d);
    });
    return k;
}
function $e95ce96b80fe8388$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e95ce96b80fe8388$var$gl(g);
                h.call(a);
            };
        }
        $e95ce96b80fe8388$var$fl(b, g, a, e);
    } else g = $e95ce96b80fe8388$var$ql(c, b, a, e, d);
    return $e95ce96b80fe8388$var$gl(g);
}
$e95ce96b80fe8388$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e95ce96b80fe8388$var$tc(b.pendingLanes);
                0 !== c && ($e95ce96b80fe8388$var$Cc(b, c | 1), $e95ce96b80fe8388$var$Dk(b, $e95ce96b80fe8388$var$B()), 0 === ($e95ce96b80fe8388$var$K & 6) && ($e95ce96b80fe8388$var$Gj = $e95ce96b80fe8388$var$B() + 500, $e95ce96b80fe8388$var$jg()));
            }
            break;
        case 13:
            $e95ce96b80fe8388$var$Rk(function() {
                var b = $e95ce96b80fe8388$var$ih(a, 1);
                if (null !== b) {
                    var c = $e95ce96b80fe8388$var$R();
                    $e95ce96b80fe8388$var$gi(b, a, 1, c);
                }
            }), $e95ce96b80fe8388$var$il(a, 1);
    }
};
$e95ce96b80fe8388$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e95ce96b80fe8388$var$ih(a, 134217728);
        if (null !== b) {
            var c = $e95ce96b80fe8388$var$R();
            $e95ce96b80fe8388$var$gi(b, a, 134217728, c);
        }
        $e95ce96b80fe8388$var$il(a, 134217728);
    }
};
$e95ce96b80fe8388$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e95ce96b80fe8388$var$yi(a), c = $e95ce96b80fe8388$var$ih(a, b);
        if (null !== c) {
            var d = $e95ce96b80fe8388$var$R();
            $e95ce96b80fe8388$var$gi(c, a, b, d);
        }
        $e95ce96b80fe8388$var$il(a, b);
    }
};
$e95ce96b80fe8388$var$Hc = function() {
    return $e95ce96b80fe8388$var$C;
};
$e95ce96b80fe8388$var$Ic = function(a, b) {
    var c = $e95ce96b80fe8388$var$C;
    try {
        return $e95ce96b80fe8388$var$C = a, b();
    } finally{
        $e95ce96b80fe8388$var$C = c;
    }
};
$e95ce96b80fe8388$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e95ce96b80fe8388$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e95ce96b80fe8388$var$Db(d);
                        if (!e) throw Error($e95ce96b80fe8388$var$p(90));
                        $e95ce96b80fe8388$var$Wa(d);
                        $e95ce96b80fe8388$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e95ce96b80fe8388$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e95ce96b80fe8388$var$fb(a, !!c.multiple, b, !1);
    }
};
$e95ce96b80fe8388$var$Gb = $e95ce96b80fe8388$var$Qk;
$e95ce96b80fe8388$var$Hb = $e95ce96b80fe8388$var$Rk;
var $e95ce96b80fe8388$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $e95ce96b80fe8388$var$Cb,
        $e95ce96b80fe8388$var$ue,
        $e95ce96b80fe8388$var$Db,
        $e95ce96b80fe8388$var$Eb,
        $e95ce96b80fe8388$var$Fb,
        $e95ce96b80fe8388$var$Qk
    ]
}, $e95ce96b80fe8388$var$tl = {
    findFiberByHostInstance: $e95ce96b80fe8388$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $e95ce96b80fe8388$var$ul = {
    bundleType: $e95ce96b80fe8388$var$tl.bundleType,
    version: $e95ce96b80fe8388$var$tl.version,
    rendererPackageName: $e95ce96b80fe8388$var$tl.rendererPackageName,
    rendererConfig: $e95ce96b80fe8388$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e95ce96b80fe8388$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e95ce96b80fe8388$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e95ce96b80fe8388$var$tl.findFiberByHostInstance || $e95ce96b80fe8388$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e95ce96b80fe8388$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e95ce96b80fe8388$var$vl.isDisabled && $e95ce96b80fe8388$var$vl.supportsFiber) try {
        $e95ce96b80fe8388$var$kc = $e95ce96b80fe8388$var$vl.inject($e95ce96b80fe8388$var$ul), $e95ce96b80fe8388$var$lc = $e95ce96b80fe8388$var$vl;
    } catch (a) {}
}
$e95ce96b80fe8388$export$ae55be85d98224ed = $e95ce96b80fe8388$var$sl;
$e95ce96b80fe8388$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e95ce96b80fe8388$var$nl(b)) throw Error($e95ce96b80fe8388$var$p(200));
    return $e95ce96b80fe8388$var$cl(a, b, null, c);
};
$e95ce96b80fe8388$export$882461b6382ed46c = function(a, b) {
    if (!$e95ce96b80fe8388$var$nl(a)) throw Error($e95ce96b80fe8388$var$p(299));
    var c = !1, d = "", e = $e95ce96b80fe8388$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e95ce96b80fe8388$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$e95ce96b80fe8388$var$uf] = b.current;
    $e95ce96b80fe8388$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e95ce96b80fe8388$var$ll(b);
};
$e95ce96b80fe8388$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e95ce96b80fe8388$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e95ce96b80fe8388$var$p(268, a));
    }
    a = $e95ce96b80fe8388$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e95ce96b80fe8388$export$cd75ccfd720a3cd4 = function(a) {
    return $e95ce96b80fe8388$var$Rk(a);
};
$e95ce96b80fe8388$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e95ce96b80fe8388$var$ol(b)) throw Error($e95ce96b80fe8388$var$p(200));
    return $e95ce96b80fe8388$var$rl(null, a, b, !0, c);
};
$e95ce96b80fe8388$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e95ce96b80fe8388$var$nl(a)) throw Error($e95ce96b80fe8388$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e95ce96b80fe8388$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e95ce96b80fe8388$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e95ce96b80fe8388$var$uf] = b.current;
    $e95ce96b80fe8388$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e95ce96b80fe8388$var$ml(b);
};
$e95ce96b80fe8388$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e95ce96b80fe8388$var$ol(b)) throw Error($e95ce96b80fe8388$var$p(200));
    return $e95ce96b80fe8388$var$rl(null, a, b, !1, c);
};
$e95ce96b80fe8388$export$502457920280e6be = function(a) {
    if (!$e95ce96b80fe8388$var$ol(a)) throw Error($e95ce96b80fe8388$var$p(40));
    return a._reactRootContainer ? ($e95ce96b80fe8388$var$Rk(function() {
        $e95ce96b80fe8388$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e95ce96b80fe8388$var$uf] = null;
        });
    }), !0) : !1;
};
$e95ce96b80fe8388$export$c78a37762a8d58e1 = $e95ce96b80fe8388$var$Qk;
$e95ce96b80fe8388$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e95ce96b80fe8388$var$ol(c)) throw Error($e95ce96b80fe8388$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e95ce96b80fe8388$var$p(38));
    return $e95ce96b80fe8388$var$rl(a, b, c, !1, d);
};
$e95ce96b80fe8388$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("7P9w1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8nXiC"));

});
parcelRegister("8nXiC", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $61ae78510f77d96a$export$c4744153514ff05d; }, function (v) { return $61ae78510f77d96a$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $61ae78510f77d96a$export$3e506c1ccc9cc1a7; }, function (v) { return $61ae78510f77d96a$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $61ae78510f77d96a$export$e26fe2ed2fa76875; }, function (v) { return $61ae78510f77d96a$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $61ae78510f77d96a$export$502329bbf4b505b1; }, function (v) { return $61ae78510f77d96a$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $61ae78510f77d96a$export$6e3807111c4874c4; }, function (v) { return $61ae78510f77d96a$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $61ae78510f77d96a$export$c27134553091fb3a; }, function (v) { return $61ae78510f77d96a$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $61ae78510f77d96a$export$33ee1acdc04fd2a2; }, function (v) { return $61ae78510f77d96a$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $61ae78510f77d96a$export$b00a404bbd5edef2; }, function (v) { return $61ae78510f77d96a$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $61ae78510f77d96a$export$8352ce38b91d0c62; }, function (v) { return $61ae78510f77d96a$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $61ae78510f77d96a$export$d66a1c1c77bd778b; }, function (v) { return $61ae78510f77d96a$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $61ae78510f77d96a$export$d3dfb8e4810cb555; }, function (v) { return $61ae78510f77d96a$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $61ae78510f77d96a$export$839f9183b0465a69; }, function (v) { return $61ae78510f77d96a$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $61ae78510f77d96a$export$72fdf0e06517287b; }, function (v) { return $61ae78510f77d96a$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $61ae78510f77d96a$export$4b844e58a3e414b4; }, function (v) { return $61ae78510f77d96a$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $61ae78510f77d96a$export$816d2913ae6b83b1; }, function (v) { return $61ae78510f77d96a$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $61ae78510f77d96a$export$61bcfe829111a1d0; }, function (v) { return $61ae78510f77d96a$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $61ae78510f77d96a$export$7ee8c9beb337bc3f; }, function (v) { return $61ae78510f77d96a$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $61ae78510f77d96a$export$b5836b71941fa3ed; }, function (v) { return $61ae78510f77d96a$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $61ae78510f77d96a$export$cf845f2c119da08a; }, function (v) { return $61ae78510f77d96a$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $61ae78510f77d96a$export$c4744153514ff05d;
var $61ae78510f77d96a$export$3e506c1ccc9cc1a7;
var $61ae78510f77d96a$export$e26fe2ed2fa76875;
var $61ae78510f77d96a$export$502329bbf4b505b1;
var $61ae78510f77d96a$export$6e3807111c4874c4;
var $61ae78510f77d96a$export$c27134553091fb3a;
var $61ae78510f77d96a$export$33ee1acdc04fd2a2;
var $61ae78510f77d96a$export$b00a404bbd5edef2;
var $61ae78510f77d96a$export$8352ce38b91d0c62;
var $61ae78510f77d96a$export$d66a1c1c77bd778b;
var $61ae78510f77d96a$export$d3dfb8e4810cb555;
var $61ae78510f77d96a$export$839f9183b0465a69;
var $61ae78510f77d96a$export$72fdf0e06517287b;
var $61ae78510f77d96a$export$4b844e58a3e414b4;
var $61ae78510f77d96a$export$816d2913ae6b83b1;
var $61ae78510f77d96a$export$61bcfe829111a1d0;
var $61ae78510f77d96a$export$7ee8c9beb337bc3f;
var $61ae78510f77d96a$export$b5836b71941fa3ed;
var $61ae78510f77d96a$export$cf845f2c119da08a;
'use strict';
function $61ae78510f77d96a$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $61ae78510f77d96a$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $61ae78510f77d96a$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $61ae78510f77d96a$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $61ae78510f77d96a$var$g(C, c)) n < e && 0 > $61ae78510f77d96a$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $61ae78510f77d96a$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $61ae78510f77d96a$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $61ae78510f77d96a$var$l = performance;
    $61ae78510f77d96a$export$c4744153514ff05d = function() {
        return $61ae78510f77d96a$var$l.now();
    };
} else {
    var $61ae78510f77d96a$var$p = Date, $61ae78510f77d96a$var$q = $61ae78510f77d96a$var$p.now();
    $61ae78510f77d96a$export$c4744153514ff05d = function() {
        return $61ae78510f77d96a$var$p.now() - $61ae78510f77d96a$var$q;
    };
}
var $61ae78510f77d96a$var$r = [], $61ae78510f77d96a$var$t = [], $61ae78510f77d96a$var$u = 1, $61ae78510f77d96a$var$v = null, $61ae78510f77d96a$var$y = 3, $61ae78510f77d96a$var$z = !1, $61ae78510f77d96a$var$A = !1, $61ae78510f77d96a$var$B = !1, $61ae78510f77d96a$var$D = "function" === typeof setTimeout ? setTimeout : null, $61ae78510f77d96a$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $61ae78510f77d96a$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $61ae78510f77d96a$var$G(a) {
    for(var b = $61ae78510f77d96a$var$h($61ae78510f77d96a$var$t); null !== b;){
        if (null === b.callback) $61ae78510f77d96a$var$k($61ae78510f77d96a$var$t);
        else if (b.startTime <= a) $61ae78510f77d96a$var$k($61ae78510f77d96a$var$t), b.sortIndex = b.expirationTime, $61ae78510f77d96a$var$f($61ae78510f77d96a$var$r, b);
        else break;
        b = $61ae78510f77d96a$var$h($61ae78510f77d96a$var$t);
    }
}
function $61ae78510f77d96a$var$H(a) {
    $61ae78510f77d96a$var$B = !1;
    $61ae78510f77d96a$var$G(a);
    if (!$61ae78510f77d96a$var$A) {
        if (null !== $61ae78510f77d96a$var$h($61ae78510f77d96a$var$r)) $61ae78510f77d96a$var$A = !0, $61ae78510f77d96a$var$I($61ae78510f77d96a$var$J);
        else {
            var b = $61ae78510f77d96a$var$h($61ae78510f77d96a$var$t);
            null !== b && $61ae78510f77d96a$var$K($61ae78510f77d96a$var$H, b.startTime - a);
        }
    }
}
function $61ae78510f77d96a$var$J(a, b) {
    $61ae78510f77d96a$var$A = !1;
    $61ae78510f77d96a$var$B && ($61ae78510f77d96a$var$B = !1, $61ae78510f77d96a$var$E($61ae78510f77d96a$var$L), $61ae78510f77d96a$var$L = -1);
    $61ae78510f77d96a$var$z = !0;
    var c = $61ae78510f77d96a$var$y;
    try {
        $61ae78510f77d96a$var$G(b);
        for($61ae78510f77d96a$var$v = $61ae78510f77d96a$var$h($61ae78510f77d96a$var$r); null !== $61ae78510f77d96a$var$v && (!($61ae78510f77d96a$var$v.expirationTime > b) || a && !$61ae78510f77d96a$var$M());){
            var d = $61ae78510f77d96a$var$v.callback;
            if ("function" === typeof d) {
                $61ae78510f77d96a$var$v.callback = null;
                $61ae78510f77d96a$var$y = $61ae78510f77d96a$var$v.priorityLevel;
                var e = d($61ae78510f77d96a$var$v.expirationTime <= b);
                b = $61ae78510f77d96a$export$c4744153514ff05d();
                "function" === typeof e ? $61ae78510f77d96a$var$v.callback = e : $61ae78510f77d96a$var$v === $61ae78510f77d96a$var$h($61ae78510f77d96a$var$r) && $61ae78510f77d96a$var$k($61ae78510f77d96a$var$r);
                $61ae78510f77d96a$var$G(b);
            } else $61ae78510f77d96a$var$k($61ae78510f77d96a$var$r);
            $61ae78510f77d96a$var$v = $61ae78510f77d96a$var$h($61ae78510f77d96a$var$r);
        }
        if (null !== $61ae78510f77d96a$var$v) var w = !0;
        else {
            var m = $61ae78510f77d96a$var$h($61ae78510f77d96a$var$t);
            null !== m && $61ae78510f77d96a$var$K($61ae78510f77d96a$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $61ae78510f77d96a$var$v = null, $61ae78510f77d96a$var$y = c, $61ae78510f77d96a$var$z = !1;
    }
}
var $61ae78510f77d96a$var$N = !1, $61ae78510f77d96a$var$O = null, $61ae78510f77d96a$var$L = -1, $61ae78510f77d96a$var$P = 5, $61ae78510f77d96a$var$Q = -1;
function $61ae78510f77d96a$var$M() {
    return $61ae78510f77d96a$export$c4744153514ff05d() - $61ae78510f77d96a$var$Q < $61ae78510f77d96a$var$P ? !1 : !0;
}
function $61ae78510f77d96a$var$R() {
    if (null !== $61ae78510f77d96a$var$O) {
        var a = $61ae78510f77d96a$export$c4744153514ff05d();
        $61ae78510f77d96a$var$Q = a;
        var b = !0;
        try {
            b = $61ae78510f77d96a$var$O(!0, a);
        } finally{
            b ? $61ae78510f77d96a$var$S() : ($61ae78510f77d96a$var$N = !1, $61ae78510f77d96a$var$O = null);
        }
    } else $61ae78510f77d96a$var$N = !1;
}
var $61ae78510f77d96a$var$S;
if ("function" === typeof $61ae78510f77d96a$var$F) $61ae78510f77d96a$var$S = function() {
    $61ae78510f77d96a$var$F($61ae78510f77d96a$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $61ae78510f77d96a$var$T = new MessageChannel, $61ae78510f77d96a$var$U = $61ae78510f77d96a$var$T.port2;
    $61ae78510f77d96a$var$T.port1.onmessage = $61ae78510f77d96a$var$R;
    $61ae78510f77d96a$var$S = function() {
        $61ae78510f77d96a$var$U.postMessage(null);
    };
} else $61ae78510f77d96a$var$S = function() {
    $61ae78510f77d96a$var$D($61ae78510f77d96a$var$R, 0);
};
function $61ae78510f77d96a$var$I(a) {
    $61ae78510f77d96a$var$O = a;
    $61ae78510f77d96a$var$N || ($61ae78510f77d96a$var$N = !0, $61ae78510f77d96a$var$S());
}
function $61ae78510f77d96a$var$K(a, b) {
    $61ae78510f77d96a$var$L = $61ae78510f77d96a$var$D(function() {
        a($61ae78510f77d96a$export$c4744153514ff05d());
    }, b);
}
$61ae78510f77d96a$export$3e506c1ccc9cc1a7 = 5;
$61ae78510f77d96a$export$e26fe2ed2fa76875 = 1;
$61ae78510f77d96a$export$502329bbf4b505b1 = 4;
$61ae78510f77d96a$export$6e3807111c4874c4 = 3;
$61ae78510f77d96a$export$c27134553091fb3a = null;
$61ae78510f77d96a$export$33ee1acdc04fd2a2 = 2;
$61ae78510f77d96a$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$61ae78510f77d96a$export$8352ce38b91d0c62 = function() {
    $61ae78510f77d96a$var$A || $61ae78510f77d96a$var$z || ($61ae78510f77d96a$var$A = !0, $61ae78510f77d96a$var$I($61ae78510f77d96a$var$J));
};
$61ae78510f77d96a$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $61ae78510f77d96a$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$61ae78510f77d96a$export$d3dfb8e4810cb555 = function() {
    return $61ae78510f77d96a$var$y;
};
$61ae78510f77d96a$export$839f9183b0465a69 = function() {
    return $61ae78510f77d96a$var$h($61ae78510f77d96a$var$r);
};
$61ae78510f77d96a$export$72fdf0e06517287b = function(a) {
    switch($61ae78510f77d96a$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $61ae78510f77d96a$var$y;
    }
    var c = $61ae78510f77d96a$var$y;
    $61ae78510f77d96a$var$y = b;
    try {
        return a();
    } finally{
        $61ae78510f77d96a$var$y = c;
    }
};
$61ae78510f77d96a$export$4b844e58a3e414b4 = function() {};
$61ae78510f77d96a$export$816d2913ae6b83b1 = function() {};
$61ae78510f77d96a$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $61ae78510f77d96a$var$y;
    $61ae78510f77d96a$var$y = a;
    try {
        return b();
    } finally{
        $61ae78510f77d96a$var$y = c;
    }
};
$61ae78510f77d96a$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $61ae78510f77d96a$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $61ae78510f77d96a$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $61ae78510f77d96a$var$f($61ae78510f77d96a$var$t, a), null === $61ae78510f77d96a$var$h($61ae78510f77d96a$var$r) && a === $61ae78510f77d96a$var$h($61ae78510f77d96a$var$t) && ($61ae78510f77d96a$var$B ? ($61ae78510f77d96a$var$E($61ae78510f77d96a$var$L), $61ae78510f77d96a$var$L = -1) : $61ae78510f77d96a$var$B = !0, $61ae78510f77d96a$var$K($61ae78510f77d96a$var$H, c - d))) : (a.sortIndex = e, $61ae78510f77d96a$var$f($61ae78510f77d96a$var$r, a), $61ae78510f77d96a$var$A || $61ae78510f77d96a$var$z || ($61ae78510f77d96a$var$A = !0, $61ae78510f77d96a$var$I($61ae78510f77d96a$var$J)));
    return a;
};
$61ae78510f77d96a$export$b5836b71941fa3ed = $61ae78510f77d96a$var$M;
$61ae78510f77d96a$export$cf845f2c119da08a = function(a) {
    var b = $61ae78510f77d96a$var$y;
    return function() {
        var c = $61ae78510f77d96a$var$y;
        $61ae78510f77d96a$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $61ae78510f77d96a$var$y = c;
        }
    };
};

});




parcelRegister("j5YGc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $de6d8da53f1e7547$export$71511d61b312f219; });

var $2yHhd = parcelRequire("2yHhd");

var $1kkP8 = parcelRequire("1kkP8");
function $de6d8da53f1e7547$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $1kkP8._)(receiver, privateMap, "get");
    return (0, $2yHhd._)(receiver, descriptor);
}

});
parcelRegister("2yHhd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1dd05397bae54296$export$71511d61b312f219; });
function $1dd05397bae54296$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

});

parcelRegister("1kkP8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0f77cfdcb0122e5a$export$71511d61b312f219; });
function $0f77cfdcb0122e5a$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

});


parcelRegister("iIj9i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d9fb30a4360c2cc2$export$71511d61b312f219; });

var $3GSCU = parcelRequire("3GSCU");
function $d9fb30a4360c2cc2$export$71511d61b312f219(obj, privateMap, value) {
    (0, $3GSCU._)(obj, privateMap);
    privateMap.set(obj, value);
}

});
parcelRegister("3GSCU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2affab10bac18c76$export$71511d61b312f219; });
function $2affab10bac18c76$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

});


parcelRegister("dDvrN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9ed74faa1bb54825$export$71511d61b312f219; });

var $5Vtvp = parcelRequire("5Vtvp");

var $1kkP8 = parcelRequire("1kkP8");
function $9ed74faa1bb54825$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $1kkP8._)(receiver, privateMap, "set");
    (0, $5Vtvp._)(receiver, descriptor, value);
    return value;
}

});
parcelRegister("5Vtvp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $450929d6494f3d6f$export$71511d61b312f219; });
function $450929d6494f3d6f$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

});


parcelRegister("dok7x", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9bfd1fcab7a61772$export$71511d61b312f219; });

var $faevN = parcelRequire("faevN");
function $9bfd1fcab7a61772$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $faevN._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("faevN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b0a30bf431d6a049$export$71511d61b312f219; });
function $b0a30bf431d6a049$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("cNnl8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $950c2a6e69bec535$export$71511d61b312f219; });
function $950c2a6e69bec535$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $950c2a6e69bec535$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $950c2a6e69bec535$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("49ckD", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $3051918962d429e3$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $3051918962d429e3$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $3051918962d429e3$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $3051918962d429e3$export$e539f754e934e270; });
$parcel$export(module.exports, "timeUntilStale", function () { return $3051918962d429e3$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "resolveStaleTime", function () { return $3051918962d429e3$export$cb3145f011bda3ac; });
$parcel$export(module.exports, "resolveQueryBoolean", function () { return $3051918962d429e3$export$d7ee3961208f79c1; });
$parcel$export(module.exports, "matchQuery", function () { return $3051918962d429e3$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $3051918962d429e3$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $3051918962d429e3$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $3051918962d429e3$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashKey", function () { return $3051918962d429e3$export$1e87d19d4aab5805; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $3051918962d429e3$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $3051918962d429e3$export$e772c8ff12451969; });
$parcel$export(module.exports, "replaceData", function () { return $3051918962d429e3$export$17619bac5b909b23; });
$parcel$export(module.exports, "addToEnd", function () { return $3051918962d429e3$export$ccce65a22a26f2bc; });
$parcel$export(module.exports, "addToStart", function () { return $3051918962d429e3$export$8c6246b73dd61f4a; });
$parcel$export(module.exports, "skipToken", function () { return $3051918962d429e3$export$1aa5a89531b7670d; });
$parcel$export(module.exports, "ensureQueryFn", function () { return $3051918962d429e3$export$c71c44209368a3bc; });
$parcel$export(module.exports, "shouldThrowError", function () { return $3051918962d429e3$export$2072f68e6c3507cf; });
$parcel$export(module.exports, "addConsumeAwareSignal", function () { return $3051918962d429e3$export$83f813cd1f8a4973; });
// src/utils.ts

var $jzve1 = parcelRequire("jzve1");
var $3051918962d429e3$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $3051918962d429e3$export$8793edee2d425525() {}
function $3051918962d429e3$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $3051918962d429e3$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $3051918962d429e3$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $3051918962d429e3$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $3051918962d429e3$export$d7ee3961208f79c1(option, query) {
    return typeof option === "function" ? option(query) : option;
}
function $3051918962d429e3$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $3051918962d429e3$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$3051918962d429e3$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $3051918962d429e3$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($3051918962d429e3$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $3051918962d429e3$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$3051918962d429e3$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $3051918962d429e3$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options === null || options === void 0 ? void 0 : options.queryKeyHashFn) || $3051918962d429e3$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $3051918962d429e3$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$3051918962d429e3$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $3051918962d429e3$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$3051918962d429e3$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
var $3051918962d429e3$var$hasOwn = Object.prototype.hasOwnProperty;
function $3051918962d429e3$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $3051918962d429e3$export$7a8558113332b71e(a) && $3051918962d429e3$export$7a8558113332b71e(b);
    if (!array && !($3051918962d429e3$export$53b83ca8eaab0383(a) && $3051918962d429e3$export$53b83ca8eaab0383(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $3051918962d429e3$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $3051918962d429e3$export$77a71fc411098696(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function $3051918962d429e3$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $3051918962d429e3$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $3051918962d429e3$export$53b83ca8eaab0383(o) {
    if (!$3051918962d429e3$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$3051918962d429e3$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $3051918962d429e3$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $3051918962d429e3$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $jzve1.timeoutManager).setTimeout(resolve, timeout);
    });
}
function $3051918962d429e3$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $3051918962d429e3$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $3051918962d429e3$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $3051918962d429e3$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $3051918962d429e3$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $3051918962d429e3$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol();
function $3051918962d429e3$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $3051918962d429e3$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $3051918962d429e3$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
function $3051918962d429e3$export$83f813cd1f8a4973(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal !== null && signal !== void 0 ? signal : signal = getSignal();
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}

});
parcelRegister("jzve1", function(module, exports) {

$parcel$export(module.exports, "timeoutManager", function () { return $e3f981de14c76a8c$export$94a2700736e69372; });
$parcel$export(module.exports, "systemSetTimeoutZero", function () { return $e3f981de14c76a8c$export$5086591e51e32a18; });
// src/timeoutManager.ts

var $j5YGc = parcelRequire("j5YGc");

var $iIj9i = parcelRequire("iIj9i");

var $dDvrN = parcelRequire("dDvrN");
var // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
// type at app boot; and if we leave that type, then any new timer provider
// would need to support the default provider's concrete timer ID, which is
// infeasible across environments.
//
// We settle for type safety for the TimeoutProvider type, and accept that
// this class is unsafe internally to allow for extension.
$e3f981de14c76a8c$var$_provider, $e3f981de14c76a8c$var$_providerCalled;
var $e3f981de14c76a8c$export$d235812f9125bf47 = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $e3f981de14c76a8c$export$6336d90323f0ab52 = ($e3f981de14c76a8c$var$_provider = /*#__PURE__*/ new WeakMap(), $e3f981de14c76a8c$var$_providerCalled = /*#__PURE__*/ new WeakMap(), class {
    setTimeoutProvider(provider) {
        (0, $dDvrN._)(this, $e3f981de14c76a8c$var$_provider, provider);
    }
    setTimeout(callback, delay) {
        return (0, $j5YGc._)(this, $e3f981de14c76a8c$var$_provider).setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        (0, $j5YGc._)(this, $e3f981de14c76a8c$var$_provider).clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return (0, $j5YGc._)(this, $e3f981de14c76a8c$var$_provider).setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        (0, $j5YGc._)(this, $e3f981de14c76a8c$var$_provider).clearInterval(intervalId);
    }
    constructor(){
        (0, $iIj9i._)(this, $e3f981de14c76a8c$var$_provider, {
            writable: true,
            value: $e3f981de14c76a8c$export$d235812f9125bf47
        });
        (0, $iIj9i._)(this, $e3f981de14c76a8c$var$_providerCalled, {
            writable: true,
            value: false
        });
    }
});
var $e3f981de14c76a8c$export$94a2700736e69372 = new $e3f981de14c76a8c$export$6336d90323f0ab52();
function $e3f981de14c76a8c$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}

});


parcelRegister("biQO8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $83aa56a74636d05e$export$71511d61b312f219; });
function $83aa56a74636d05e$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}

});

parcelRegister("kJ06L", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f168181159bea4a8$export$71511d61b312f219; });

var $3GSCU = parcelRequire("3GSCU");
function $f168181159bea4a8$export$71511d61b312f219(obj, privateSet) {
    (0, $3GSCU._)(obj, privateSet);
    privateSet.add(obj);
}

});

parcelRegister("csodM", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $911ae360534255e8$export$520687f44db6e1ab; });
// src/notifyManager.ts

var $jzve1 = parcelRequire("jzve1");
var $911ae360534255e8$export$7c76da44185e6090 = (0, $jzve1.systemSetTimeoutZero);
function $911ae360534255e8$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $911ae360534255e8$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $911ae360534255e8$export$520687f44db6e1ab = $911ae360534255e8$export$316a8efd03cd1458();

});

parcelRegister("efvjD", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $a5fac210ac3d2cb3$export$d26086b469ecdbcc; });
// src/subscribable.ts
var $a5fac210ac3d2cb3$export$d26086b469ecdbcc = class {
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
};

});

parcelRegister("h3w18", function(module, exports) {

$parcel$export(module.exports, "Mutation", function () { return $c6ab8d75d3a9e7b9$export$17b8b19c814bcf56; });
$parcel$export(module.exports, "getDefaultState", function () { return $c6ab8d75d3a9e7b9$export$a1659b54bac3252a; });
// src/mutation.ts

var $j5YGc = parcelRequire("j5YGc");

var $iIj9i = parcelRequire("iIj9i");

var $dDvrN = parcelRequire("dDvrN");

var $biQO8 = parcelRequire("biQO8");

var $kJ06L = parcelRequire("kJ06L");

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $csodM = parcelRequire("csodM");

var $3bmlv = parcelRequire("3bmlv");

var $c1hkl = parcelRequire("c1hkl");
var $c6ab8d75d3a9e7b9$var$_client, $c6ab8d75d3a9e7b9$var$_observers, $c6ab8d75d3a9e7b9$var$_mutationCache, $c6ab8d75d3a9e7b9$var$_retryer, $c6ab8d75d3a9e7b9$var$_dispatch, $c6ab8d75d3a9e7b9$var$_class;
var $c6ab8d75d3a9e7b9$export$17b8b19c814bcf56 = ($c6ab8d75d3a9e7b9$var$_client = /*#__PURE__*/ new WeakMap(), $c6ab8d75d3a9e7b9$var$_observers = /*#__PURE__*/ new WeakMap(), $c6ab8d75d3a9e7b9$var$_mutationCache = /*#__PURE__*/ new WeakMap(), $c6ab8d75d3a9e7b9$var$_retryer = /*#__PURE__*/ new WeakMap(), $c6ab8d75d3a9e7b9$var$_dispatch = /*#__PURE__*/ new WeakSet(), $c6ab8d75d3a9e7b9$var$_class = class extends (0, $3bmlv.Removable) {
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_observers).includes(observer)) {
            (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $dDvrN._)(this, $c6ab8d75d3a9e7b9$var$_observers, (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _class_private_field_get1;
        var _class_private_field_get_continue;
        return (_class_private_field_get_continue = (_class_private_field_get1 = (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_retryer)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.continue()) !== null && _class_private_field_get_continue !== void 0 ? _class_private_field_get_continue : // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        const onContinue = ()=>{
            (0, $biQO8._)(this, $c6ab8d75d3a9e7b9$var$_dispatch, $c6ab8d75d3a9e7b9$var$dispatch).call(this, {
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_client),
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        var _this_options_retry;
        (0, $dDvrN._)(this, $c6ab8d75d3a9e7b9$var$_retryer, (0, $c1hkl.createRetryer)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                (0, $biQO8._)(this, $c6ab8d75d3a9e7b9$var$_dispatch, $c6ab8d75d3a9e7b9$var$dispatch).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $biQO8._)(this, $c6ab8d75d3a9e7b9$var$_dispatch, $c6ab8d75d3a9e7b9$var$dispatch).call(this, {
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: (_this_options_retry = this.options.retry) !== null && _this_options_retry !== void 0 ? _this_options_retry : 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_retryer).canStart();
        try {
            var _class_private_field_get_config_onSuccess, _class_private_field_get_config, _this_options_onSuccess, _this_options, _class_private_field_get_config_onSettled, _class_private_field_get_config1, _this_options_onSettled, _this_options1;
            if (restored) onContinue();
            else {
                var _this_options_onMutate, _this_options2;
                (0, $biQO8._)(this, $c6ab8d75d3a9e7b9$var$_dispatch, $c6ab8d75d3a9e7b9$var$dispatch).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                if ((0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache).config.onMutate) await (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache).config.onMutate(variables, this, mutationFnContext);
                const context = await ((_this_options_onMutate = (_this_options2 = this.options).onMutate) === null || _this_options_onMutate === void 0 ? void 0 : _this_options_onMutate.call(_this_options2, variables, mutationFnContext));
                if (context !== this.state.context) (0, $biQO8._)(this, $c6ab8d75d3a9e7b9$var$_dispatch, $c6ab8d75d3a9e7b9$var$dispatch).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_retryer).start();
            await ((_class_private_field_get_config_onSuccess = (_class_private_field_get_config = (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache).config).onSuccess) === null || _class_private_field_get_config_onSuccess === void 0 ? void 0 : _class_private_field_get_config_onSuccess.call(_class_private_field_get_config, data, variables, this.state.context, this, mutationFnContext));
            await ((_this_options_onSuccess = (_this_options = this.options).onSuccess) === null || _this_options_onSuccess === void 0 ? void 0 : _this_options_onSuccess.call(_this_options, data, variables, this.state.context, mutationFnContext));
            await ((_class_private_field_get_config_onSettled = (_class_private_field_get_config1 = (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache).config).onSettled) === null || _class_private_field_get_config_onSettled === void 0 ? void 0 : _class_private_field_get_config_onSettled.call(_class_private_field_get_config1, data, null, this.state.variables, this.state.context, this, mutationFnContext));
            await ((_this_options_onSettled = (_this_options1 = this.options).onSettled) === null || _this_options_onSettled === void 0 ? void 0 : _this_options_onSettled.call(_this_options1, data, null, variables, this.state.context, mutationFnContext));
            (0, $biQO8._)(this, $c6ab8d75d3a9e7b9$var$_dispatch, $c6ab8d75d3a9e7b9$var$dispatch).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _class_private_field_get_config_onError, _class_private_field_get_config2;
                await ((_class_private_field_get_config_onError = (_class_private_field_get_config2 = (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache).config).onError) === null || _class_private_field_get_config_onError === void 0 ? void 0 : _class_private_field_get_config_onError.call(_class_private_field_get_config2, error, variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _this_options_onError, _this_options3;
                await ((_this_options_onError = (_this_options3 = this.options).onError) === null || _this_options_onError === void 0 ? void 0 : _this_options_onError.call(_this_options3, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _class_private_field_get_config_onSettled1, _class_private_field_get_config3;
                await ((_class_private_field_get_config_onSettled1 = (_class_private_field_get_config3 = (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache).config).onSettled) === null || _class_private_field_get_config_onSettled1 === void 0 ? void 0 : _class_private_field_get_config_onSettled1.call(_class_private_field_get_config3, void 0, error, this.state.variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _this_options_onSettled1, _this_options4;
                await ((_this_options_onSettled1 = (_this_options4 = this.options).onSettled) === null || _this_options_onSettled1 === void 0 ? void 0 : _this_options_onSettled1.call(_this_options4, void 0, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            (0, $biQO8._)(this, $c6ab8d75d3a9e7b9$var$_dispatch, $c6ab8d75d3a9e7b9$var$dispatch).call(this, {
                type: "error",
                error: error
            });
            throw error;
        } finally{
            (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache).runNext(this);
        }
    }
    constructor(config){
        super(), (0, $kJ06L._)(this, $c6ab8d75d3a9e7b9$var$_dispatch), (0, $iIj9i._)(this, $c6ab8d75d3a9e7b9$var$_client, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $c6ab8d75d3a9e7b9$var$_observers, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $c6ab8d75d3a9e7b9$var$_retryer, {
            writable: true,
            value: void 0
        });
        (0, $dDvrN._)(this, $c6ab8d75d3a9e7b9$var$_client, config.client);
        this.mutationId = config.mutationId;
        (0, $dDvrN._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache, config.mutationCache);
        (0, $dDvrN._)(this, $c6ab8d75d3a9e7b9$var$_observers, []);
        this.state = config.state || $c6ab8d75d3a9e7b9$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
}, $c6ab8d75d3a9e7b9$var$_class);
function $c6ab8d75d3a9e7b9$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}
function $c6ab8d75d3a9e7b9$var$dispatch(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return (0, $cNnl8._)((0, $dok7x._)({}, state), {
                    failureCount: action.failureCount,
                    failureReason: action.error
                });
            case "pause":
                return (0, $cNnl8._)((0, $dok7x._)({}, state), {
                    isPaused: true
                });
            case "continue":
                return (0, $cNnl8._)((0, $dok7x._)({}, state), {
                    isPaused: false
                });
            case "pending":
                return (0, $cNnl8._)((0, $dok7x._)({}, state), {
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                });
            case "success":
                return (0, $cNnl8._)((0, $dok7x._)({}, state), {
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                });
            case "error":
                return (0, $cNnl8._)((0, $dok7x._)({}, state), {
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                });
        }
    };
    this.state = reducer(this.state);
    (0, $csodM.notifyManager).batch(()=>{
        (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $j5YGc._)(this, $c6ab8d75d3a9e7b9$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
}

});
parcelRegister("3bmlv", function(module, exports) {

$parcel$export(module.exports, "Removable", function () { return $2513bb98ccd63c84$export$e09608847fcc8c59; });
// src/removable.ts

var $j5YGc = parcelRequire("j5YGc");

var $iIj9i = parcelRequire("iIj9i");

var $dDvrN = parcelRequire("dDvrN");

var $jzve1 = parcelRequire("jzve1");

var $307Gi = parcelRequire("307Gi");

var $49ckD = parcelRequire("49ckD");
var $2513bb98ccd63c84$var$_gcTimeout;
var $2513bb98ccd63c84$export$e09608847fcc8c59 = ($2513bb98ccd63c84$var$_gcTimeout = /*#__PURE__*/ new WeakMap(), class {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $49ckD.isValidTimeout)(this.gcTime)) (0, $dDvrN._)(this, $2513bb98ccd63c84$var$_gcTimeout, (0, $jzve1.timeoutManager).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime !== null && newGcTime !== void 0 ? newGcTime : (0, $307Gi.environmentManager).isServer() ? Infinity : 300000);
    }
    clearGcTimeout() {
        if ((0, $j5YGc._)(this, $2513bb98ccd63c84$var$_gcTimeout) !== void 0) {
            (0, $jzve1.timeoutManager).clearTimeout((0, $j5YGc._)(this, $2513bb98ccd63c84$var$_gcTimeout));
            (0, $dDvrN._)(this, $2513bb98ccd63c84$var$_gcTimeout, void 0);
        }
    }
    constructor(){
        (0, $iIj9i._)(this, $2513bb98ccd63c84$var$_gcTimeout, {
            writable: true,
            value: void 0
        });
    }
});

});
parcelRegister("307Gi", function(module, exports) {

$parcel$export(module.exports, "environmentManager", function () { return $22f75486200ee1f2$export$2d935f1a9c9d3f3e; });
// src/environmentManager.ts

var $49ckD = parcelRequire("49ckD");
var $22f75486200ee1f2$export$2d935f1a9c9d3f3e = /* @__PURE__ */ (()=>{
    let isServerFn = ()=>(0, $49ckD.isServer);
    return {
        /**
     * Returns whether the current runtime should be treated as a server environment.
     */ isServer () {
            return isServerFn();
        },
        /**
     * Overrides the server check globally.
     */ setIsServer (isServerValue) {
            isServerFn = isServerValue;
        }
    };
})();

});


parcelRegister("c1hkl", function(module, exports) {

$parcel$export(module.exports, "canFetch", function () { return $8c0304d283352d7c$export$61b92f63f30245cf; });
$parcel$export(module.exports, "CancelledError", function () { return $8c0304d283352d7c$export$a8430ed4188f35a9; });
$parcel$export(module.exports, "createRetryer", function () { return $8c0304d283352d7c$export$2cbd00fe8a2c8d85; });
// src/retryer.ts

var $jVNuv = parcelRequire("jVNuv");

var $gsfBp = parcelRequire("gsfBp");

var $kc6BE = parcelRequire("kc6BE");

var $307Gi = parcelRequire("307Gi");

var $49ckD = parcelRequire("49ckD");
function $8c0304d283352d7c$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $8c0304d283352d7c$export$61b92f63f30245cf(networkMode) {
    return (networkMode !== null && networkMode !== void 0 ? networkMode : "online") === "online" ? (0, $gsfBp.onlineManager).isOnline() : true;
}
var $8c0304d283352d7c$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options === null || options === void 0 ? void 0 : options.revert;
        this.silent = options === null || options === void 0 ? void 0 : options.silent;
    }
};
function $8c0304d283352d7c$export$986cc6445c1d323(value) {
    return value instanceof $8c0304d283352d7c$export$a8430ed4188f35a9;
}
function $8c0304d283352d7c$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, $kc6BE.pendingThenable)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        if (!isResolved()) {
            var _config_onCancel;
            const error = new $8c0304d283352d7c$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            (_config_onCancel = config.onCancel) === null || _config_onCancel === void 0 ? void 0 : _config_onCancel.call(config, error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $jVNuv.focusManager).isFocused() && (config.networkMode === "always" || (0, $gsfBp.onlineManager).isOnline()) && config.canRun();
    const canStart = ()=>$8c0304d283352d7c$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn === null || continueFn === void 0 ? void 0 : continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn === null || continueFn === void 0 ? void 0 : continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _config_onPause;
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            (_config_onPause = config.onPause) === null || _config_onPause === void 0 ? void 0 : _config_onPause.call(config);
        }).then(()=>{
            var _config_onContinue;
            continueFn = void 0;
            if (!isResolved()) (_config_onContinue = config.onContinue) === null || _config_onContinue === void 0 ? void 0 : _config_onContinue.call(config);
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise !== null && initialPromise !== void 0 ? initialPromise : config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config_onFail;
            if (isResolved()) return;
            var _config_retry;
            const retry = (_config_retry = config.retry) !== null && _config_retry !== void 0 ? _config_retry : (0, $307Gi.environmentManager).isServer() ? 0 : 3;
            var _config_retryDelay;
            const retryDelay = (_config_retryDelay = config.retryDelay) !== null && _config_retryDelay !== void 0 ? _config_retryDelay : $8c0304d283352d7c$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_config_onFail = config.onFail) === null || _config_onFail === void 0 ? void 0 : _config_onFail.call(config, failureCount, error);
            (0, $49ckD.sleep)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel: cancel,
        continue: ()=>{
            continueFn === null || continueFn === void 0 ? void 0 : continueFn();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}

});
parcelRegister("jVNuv", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $e829bb12a94b2ff8$export$6bf54661be5b02cf; });
// src/focusManager.ts

var $j5YGc = parcelRequire("j5YGc");

var $iIj9i = parcelRequire("iIj9i");

var $dDvrN = parcelRequire("dDvrN");

var $efvjD = parcelRequire("efvjD");
var $e829bb12a94b2ff8$var$_focused, $e829bb12a94b2ff8$var$_cleanup, $e829bb12a94b2ff8$var$_setup;
var $e829bb12a94b2ff8$export$86f1af424b2ca4de = ($e829bb12a94b2ff8$var$_focused = /*#__PURE__*/ new WeakMap(), $e829bb12a94b2ff8$var$_cleanup = /*#__PURE__*/ new WeakMap(), $e829bb12a94b2ff8$var$_setup = /*#__PURE__*/ new WeakMap(), class extends (0, $efvjD.Subscribable) {
    onSubscribe() {
        if (!(0, $j5YGc._)(this, $e829bb12a94b2ff8$var$_cleanup)) this.setEventListener((0, $j5YGc._)(this, $e829bb12a94b2ff8$var$_setup));
    }
    onUnsubscribe() {
        var _this, _this1, _ref;
        if (!this.hasListeners()) {
            (_this = (0, $j5YGc._)(_ref = _this1 = this, $e829bb12a94b2ff8$var$_cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
            (0, $dDvrN._)(this, $e829bb12a94b2ff8$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _this, _this1, _ref;
        (0, $dDvrN._)(this, $e829bb12a94b2ff8$var$_setup, setup);
        (_this = (0, $j5YGc._)(_ref = _this1 = this, $e829bb12a94b2ff8$var$_cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
        (0, $dDvrN._)(this, $e829bb12a94b2ff8$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $j5YGc._)(this, $e829bb12a94b2ff8$var$_focused) !== focused;
        if (changed) {
            (0, $dDvrN._)(this, $e829bb12a94b2ff8$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _globalThis_document;
        if (typeof (0, $j5YGc._)(this, $e829bb12a94b2ff8$var$_focused) === "boolean") return (0, $j5YGc._)(this, $e829bb12a94b2ff8$var$_focused);
        return ((_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.visibilityState) !== "hidden";
    }
    constructor(){
        super(), (0, $iIj9i._)(this, $e829bb12a94b2ff8$var$_focused, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $e829bb12a94b2ff8$var$_cleanup, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $e829bb12a94b2ff8$var$_setup, {
            writable: true,
            value: void 0
        });
        (0, $dDvrN._)(this, $e829bb12a94b2ff8$var$_setup, (onFocus)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
});
var $e829bb12a94b2ff8$export$6bf54661be5b02cf = new $e829bb12a94b2ff8$export$86f1af424b2ca4de();

});

parcelRegister("gsfBp", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $bfab5d29633edc80$export$b113e788b2dd3fdc; });
// src/onlineManager.ts

var $j5YGc = parcelRequire("j5YGc");

var $iIj9i = parcelRequire("iIj9i");

var $dDvrN = parcelRequire("dDvrN");

var $efvjD = parcelRequire("efvjD");
var $bfab5d29633edc80$var$_online, $bfab5d29633edc80$var$_cleanup, $bfab5d29633edc80$var$_setup;
var $bfab5d29633edc80$export$58774fb55d5ff7fc = ($bfab5d29633edc80$var$_online = /*#__PURE__*/ new WeakMap(), $bfab5d29633edc80$var$_cleanup = /*#__PURE__*/ new WeakMap(), $bfab5d29633edc80$var$_setup = /*#__PURE__*/ new WeakMap(), class extends (0, $efvjD.Subscribable) {
    onSubscribe() {
        if (!(0, $j5YGc._)(this, $bfab5d29633edc80$var$_cleanup)) this.setEventListener((0, $j5YGc._)(this, $bfab5d29633edc80$var$_setup));
    }
    onUnsubscribe() {
        var _this, _this1, _ref;
        if (!this.hasListeners()) {
            (_this = (0, $j5YGc._)(_ref = _this1 = this, $bfab5d29633edc80$var$_cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
            (0, $dDvrN._)(this, $bfab5d29633edc80$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _this, _this1, _ref;
        (0, $dDvrN._)(this, $bfab5d29633edc80$var$_setup, setup);
        (_this = (0, $j5YGc._)(_ref = _this1 = this, $bfab5d29633edc80$var$_cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
        (0, $dDvrN._)(this, $bfab5d29633edc80$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $j5YGc._)(this, $bfab5d29633edc80$var$_online) !== online;
        if (changed) {
            (0, $dDvrN._)(this, $bfab5d29633edc80$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $j5YGc._)(this, $bfab5d29633edc80$var$_online);
    }
    constructor(){
        super(), (0, $iIj9i._)(this, $bfab5d29633edc80$var$_online, {
            writable: true,
            value: true
        }), (0, $iIj9i._)(this, $bfab5d29633edc80$var$_cleanup, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $bfab5d29633edc80$var$_setup, {
            writable: true,
            value: void 0
        });
        (0, $dDvrN._)(this, $bfab5d29633edc80$var$_setup, (onOnline)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
});
var $bfab5d29633edc80$export$b113e788b2dd3fdc = new $bfab5d29633edc80$export$58774fb55d5ff7fc();

});

parcelRegister("kc6BE", function(module, exports) {

$parcel$export(module.exports, "pendingThenable", function () { return $eb3a0d821ac7f36b$export$d54630db02a12b72; });
// src/thenable.ts

var $49ckD = parcelRequire("49ckD");
function $eb3a0d821ac7f36b$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $eb3a0d821ac7f36b$export$216296c47a9d1275(promise) {
    var _promise_then;
    let data;
    (_promise_then = promise.then((result)=>{
        data = result;
        return result;
    }, (0, $49ckD.noop))) === null || _promise_then === void 0 ? void 0 : _promise_then.catch((0, $49ckD.noop));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}

});



parcelRegister("a0iaM", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $748800360dfbe94f$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $748800360dfbe94f$export$45604f0cc8ae667b; });

var $7hhBq = parcelRequire("7hhBq");

var $iHpLz = parcelRequire("iHpLz");
"use client";
var $748800360dfbe94f$export$da112d31b0149f31 = $7hhBq.createContext(void 0);
var $748800360dfbe94f$export$22e77b9572c4fded = (queryClient)=>{
    const client = $7hhBq.useContext($748800360dfbe94f$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $748800360dfbe94f$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $7hhBq.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $iHpLz.jsx)($748800360dfbe94f$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};

});

parcelRegister("b5Oyq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81376062849443f4$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");

var $eET99 = parcelRequire("eET99");

var $1k0SI = parcelRequire("1k0SI");
var $18TeW = parcelRequire("18TeW");

var $1zv4u = parcelRequire("1zv4u");

var $4ZZLe = parcelRequire("4ZZLe");

var $bUnnb = parcelRequire("bUnnb");

var $3CtK9 = parcelRequire("3CtK9");

var $ei3fZ = parcelRequire("ei3fZ");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $81376062849443f4$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $81376062849443f4$var$extendSxProp = (0, $1k0SI.internal_createExtendSxProp)();
const $81376062849443f4$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $bUnnb.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $eET99.default)(slots, (0, $ei3fZ.getTypographyUtilityClass), classes);
};
const $81376062849443f4$export$140e2f5526d3cad8 = (0, $18TeW.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $bUnnb.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $1zv4u.default)(({ theme: theme })=>{
    var _theme_palette;
    return {
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $3CtK9.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(((_theme_palette = theme.palette) === null || _theme_palette === void 0 ? void 0 : _theme_palette.text) || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $bUnnb.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    };
}));
const $81376062849443f4$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $81376062849443f4$var$Typography = /*#__PURE__*/ $7hhBq.forwardRef(function Typography(inProps, ref) {
    const _useDefaultProps = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    }), { color: color } = _useDefaultProps, themeProps = (0, $6pkKu._)(_useDefaultProps, [
        "color"
    ]);
    const isSxColor = !$81376062849443f4$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $81376062849443f4$var$extendSxProp((0, $dok7x._)({}, themeProps, isSxColor && {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $81376062849443f4$var$defaultVariantMapping } = props, other = (0, $6pkKu._)(props, [
        "align",
        "className",
        "component",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $81376062849443f4$var$defaultVariantMapping[variant]) || 'span';
    const classes = $81376062849443f4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iHpLz.jsx)($81376062849443f4$export$140e2f5526d3cad8, (0, $cNnl8._)((0, $dok7x._)({
        as: Component,
        ref: ref,
        className: (0, $5vmbh.default)(classes.root, className)
    }, other), {
        ownerState: ownerState,
        style: (0, $dok7x._)({}, align !== 'inherit' && {
            '--Typography-textAlign': align
        }, other.style)
    }));
});
var $81376062849443f4$export$2e2bcd8739ae039 = $81376062849443f4$var$Typography;

});
parcelRegister("6pkKu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4aa52c2fde1eb741$export$71511d61b312f219; });

var $gS8UC = parcelRequire("gS8UC");
function $4aa52c2fde1eb741$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $gS8UC._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("gS8UC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c4889a4103d8029c$export$71511d61b312f219; });
function $c4889a4103d8029c$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("5vmbh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9f2fdb7700978c7$export$2e2bcd8739ae039; });
function $b9f2fdb7700978c7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $b9f2fdb7700978c7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $b9f2fdb7700978c7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $b9f2fdb7700978c7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $b9f2fdb7700978c7$export$2e2bcd8739ae039 = $b9f2fdb7700978c7$export$4f5d2d50c9deca37;

});

parcelRegister("eET99", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aabf9418de47ba9e$export$2e2bcd8739ae039; });
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $aabf9418de47ba9e$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("1k0SI", function(module, exports) {

$parcel$export(module.exports, "globalCss", function () { return $0f6857c1ab89348b$export$db53682eef82cc11; });
$parcel$export(module.exports, "internal_createExtendSxProp", function () { return $0f6857c1ab89348b$export$7e7f5719ff4debb1; });

var $dok7x = parcelRequire("dok7x");
parcelRequire("7hhBq");

var $gt1Df = parcelRequire("gt1Df");

var $eGBcx = parcelRequire("eGBcx");

var $11JKH = parcelRequire("11JKH");

var $iHpLz = parcelRequire("iHpLz");

var $38swY = parcelRequire("38swY");

var $18TeW = parcelRequire("18TeW");
function $0f6857c1ab89348b$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $iHpLz.jsx)((0, $11JKH.default), {
            styles: typeof styles === 'function' ? (theme)=>styles((0, $dok7x._)({
                    theme: theme
                }, props)) : styles
        }));
    };
}
function $0f6857c1ab89348b$export$7e7f5719ff4debb1() {
    return 0, $gt1Df.default;
}

});
parcelRegister("gt1Df", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfd09ed8088b55d0$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $f6ZlQ = parcelRequire("f6ZlQ");

var $4AV1f = parcelRequire("4AV1f");
const $bfd09ed8088b55d0$var$splitProps = (props)=>{
    var _props_theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    var _props_theme_unstable_sxConfig;
    const config = (_props_theme_unstable_sxConfig = props === null || props === void 0 ? void 0 : (_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : _props_theme.unstable_sxConfig) !== null && _props_theme_unstable_sxConfig !== void 0 ? _props_theme_unstable_sxConfig : (0, $4AV1f.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $bfd09ed8088b55d0$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $6pkKu._)(props, [
        "sx"
    ]);
    const { systemProps: systemProps, otherProps: otherProps } = $bfd09ed8088b55d0$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $f6ZlQ.isPlainObject)(result)) return systemProps;
        return (0, $dok7x._)({}, systemProps, result);
    };
    else finalSx = (0, $dok7x._)({}, systemProps, inSx);
    return (0, $cNnl8._)((0, $dok7x._)({}, otherProps), {
        sx: finalSx
    });
}

});
parcelRegister("f6ZlQ", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $b00701a3bfc5ebc3$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $b00701a3bfc5ebc3$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $7hhBq = parcelRequire("7hhBq");

var $8Iy2x = parcelRequire("8Iy2x");
function $b00701a3bfc5ebc3$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $b00701a3bfc5ebc3$var$deepClone(source) {
    if (/*#__PURE__*/ $7hhBq.isValidElement(source) || (0, $8Iy2x.isValidElementType)(source) || !$b00701a3bfc5ebc3$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $b00701a3bfc5ebc3$var$deepClone(source[key]);
    });
    return output;
}
function $b00701a3bfc5ebc3$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $dok7x._)({}, target) : target;
    if ($b00701a3bfc5ebc3$export$53b83ca8eaab0383(target) && $b00701a3bfc5ebc3$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $7hhBq.isValidElement(source[key]) || (0, $8Iy2x.isValidElementType)(source[key])) output[key] = source[key];
        else if ($b00701a3bfc5ebc3$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $b00701a3bfc5ebc3$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $b00701a3bfc5ebc3$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $b00701a3bfc5ebc3$export$53b83ca8eaab0383(source[key]) ? $b00701a3bfc5ebc3$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("8Iy2x", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g9duj"));

});
parcelRegister("g9duj", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $bc17f30063f5df3c$export$a7c73072b1a182ae; }, function (v) { return $bc17f30063f5df3c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $bc17f30063f5df3c$export$9f27bc3417b4524d; }, function (v) { return $bc17f30063f5df3c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $bc17f30063f5df3c$export$db77ccec0bb4ccac; }, function (v) { return $bc17f30063f5df3c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $bc17f30063f5df3c$export$8392c0c9d3dcbd35; }, function (v) { return $bc17f30063f5df3c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bc17f30063f5df3c$export$ffb0004e005737fa; }, function (v) { return $bc17f30063f5df3c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $bc17f30063f5df3c$export$b624eff549462981; }, function (v) { return $bc17f30063f5df3c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $bc17f30063f5df3c$export$7897aa7841a5380c; }, function (v) { return $bc17f30063f5df3c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $bc17f30063f5df3c$export$602eac185826482c; }, function (v) { return $bc17f30063f5df3c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $bc17f30063f5df3c$export$e2c29f18771995cb; }, function (v) { return $bc17f30063f5df3c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bc17f30063f5df3c$export$5f8d39834fd61797; }, function (v) { return $bc17f30063f5df3c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bc17f30063f5df3c$export$74bf444e3cd11ea5; }, function (v) { return $bc17f30063f5df3c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $bc17f30063f5df3c$export$998bcd577473dd93; }, function (v) { return $bc17f30063f5df3c$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $bc17f30063f5df3c$export$b706b080d889d2c9; }, function (v) { return $bc17f30063f5df3c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $bc17f30063f5df3c$export$5be5a87408f70ddc; }, function (v) { return $bc17f30063f5df3c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $bc17f30063f5df3c$export$45a5e7f76e0caa8d; }, function (v) { return $bc17f30063f5df3c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $bc17f30063f5df3c$export$455c2e768291efa6; }, function (v) { return $bc17f30063f5df3c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $bc17f30063f5df3c$export$9522e17588c12572; }, function (v) { return $bc17f30063f5df3c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $bc17f30063f5df3c$export$2110ac352bb060b9; }, function (v) { return $bc17f30063f5df3c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $bc17f30063f5df3c$export$56885ab8b9c456ab; }, function (v) { return $bc17f30063f5df3c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $bc17f30063f5df3c$export$d927fcb6adf8f9de; }, function (v) { return $bc17f30063f5df3c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $bc17f30063f5df3c$export$b82d16f27459e05a; }, function (v) { return $bc17f30063f5df3c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $bc17f30063f5df3c$export$522c17b4f5e123e8; }, function (v) { return $bc17f30063f5df3c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $bc17f30063f5df3c$export$1aabd8a0274ecfd6; }, function (v) { return $bc17f30063f5df3c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $bc17f30063f5df3c$export$3d6c20d97e46b957; }, function (v) { return $bc17f30063f5df3c$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $bc17f30063f5df3c$export$9b621391a187a31a; }, function (v) { return $bc17f30063f5df3c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $bc17f30063f5df3c$export$f5bbd400c2f4426f; }, function (v) { return $bc17f30063f5df3c$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc17f30063f5df3c$export$a7c73072b1a182ae;
var $bc17f30063f5df3c$export$9f27bc3417b4524d;
var $bc17f30063f5df3c$export$db77ccec0bb4ccac;
var $bc17f30063f5df3c$export$8392c0c9d3dcbd35;
var $bc17f30063f5df3c$export$ffb0004e005737fa;
var $bc17f30063f5df3c$export$b624eff549462981;
var $bc17f30063f5df3c$export$7897aa7841a5380c;
var $bc17f30063f5df3c$export$602eac185826482c;
var $bc17f30063f5df3c$export$e2c29f18771995cb;
var $bc17f30063f5df3c$export$5f8d39834fd61797;
var $bc17f30063f5df3c$export$74bf444e3cd11ea5;
var $bc17f30063f5df3c$export$998bcd577473dd93;
var $bc17f30063f5df3c$export$b706b080d889d2c9;
var $bc17f30063f5df3c$export$5be5a87408f70ddc;
var $bc17f30063f5df3c$export$45a5e7f76e0caa8d;
var $bc17f30063f5df3c$export$455c2e768291efa6;
var $bc17f30063f5df3c$export$9522e17588c12572;
var $bc17f30063f5df3c$export$2110ac352bb060b9;
var $bc17f30063f5df3c$export$56885ab8b9c456ab;
var $bc17f30063f5df3c$export$d927fcb6adf8f9de;
var $bc17f30063f5df3c$export$b82d16f27459e05a;
var $bc17f30063f5df3c$export$522c17b4f5e123e8;
var $bc17f30063f5df3c$export$1aabd8a0274ecfd6;
var $bc17f30063f5df3c$export$3d6c20d97e46b957;
var $bc17f30063f5df3c$export$9b621391a187a31a;
var $bc17f30063f5df3c$export$f5bbd400c2f4426f;
"use strict";
var $bc17f30063f5df3c$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bc17f30063f5df3c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $bc17f30063f5df3c$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $bc17f30063f5df3c$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $bc17f30063f5df3c$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $bc17f30063f5df3c$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $bc17f30063f5df3c$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $bc17f30063f5df3c$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $bc17f30063f5df3c$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $bc17f30063f5df3c$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $bc17f30063f5df3c$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $bc17f30063f5df3c$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $bc17f30063f5df3c$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $bc17f30063f5df3c$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $bc17f30063f5df3c$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $bc17f30063f5df3c$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $bc17f30063f5df3c$var$REACT_FRAGMENT_TYPE:
                    case $bc17f30063f5df3c$var$REACT_PROFILER_TYPE:
                    case $bc17f30063f5df3c$var$REACT_STRICT_MODE_TYPE:
                    case $bc17f30063f5df3c$var$REACT_SUSPENSE_TYPE:
                    case $bc17f30063f5df3c$var$REACT_SUSPENSE_LIST_TYPE:
                    case $bc17f30063f5df3c$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $bc17f30063f5df3c$var$REACT_CONTEXT_TYPE:
                            case $bc17f30063f5df3c$var$REACT_FORWARD_REF_TYPE:
                            case $bc17f30063f5df3c$var$REACT_LAZY_TYPE:
                            case $bc17f30063f5df3c$var$REACT_MEMO_TYPE:
                                return object;
                            case $bc17f30063f5df3c$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $bc17f30063f5df3c$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$bc17f30063f5df3c$export$a7c73072b1a182ae = $bc17f30063f5df3c$var$REACT_CONSUMER_TYPE;
$bc17f30063f5df3c$export$9f27bc3417b4524d = $bc17f30063f5df3c$var$REACT_CONTEXT_TYPE;
$bc17f30063f5df3c$export$db77ccec0bb4ccac = $bc17f30063f5df3c$var$REACT_ELEMENT_TYPE;
$bc17f30063f5df3c$export$8392c0c9d3dcbd35 = $bc17f30063f5df3c$var$REACT_FORWARD_REF_TYPE;
$bc17f30063f5df3c$export$ffb0004e005737fa = $bc17f30063f5df3c$var$REACT_FRAGMENT_TYPE;
$bc17f30063f5df3c$export$b624eff549462981 = $bc17f30063f5df3c$var$REACT_LAZY_TYPE;
$bc17f30063f5df3c$export$7897aa7841a5380c = $bc17f30063f5df3c$var$REACT_MEMO_TYPE;
$bc17f30063f5df3c$export$602eac185826482c = $bc17f30063f5df3c$var$REACT_PORTAL_TYPE;
$bc17f30063f5df3c$export$e2c29f18771995cb = $bc17f30063f5df3c$var$REACT_PROFILER_TYPE;
$bc17f30063f5df3c$export$5f8d39834fd61797 = $bc17f30063f5df3c$var$REACT_STRICT_MODE_TYPE;
$bc17f30063f5df3c$export$74bf444e3cd11ea5 = $bc17f30063f5df3c$var$REACT_SUSPENSE_TYPE;
$bc17f30063f5df3c$export$998bcd577473dd93 = $bc17f30063f5df3c$var$REACT_SUSPENSE_LIST_TYPE;
$bc17f30063f5df3c$export$b706b080d889d2c9 = function(object) {
    return $bc17f30063f5df3c$var$typeOf(object) === $bc17f30063f5df3c$var$REACT_CONSUMER_TYPE;
};
$bc17f30063f5df3c$export$5be5a87408f70ddc = function(object) {
    return $bc17f30063f5df3c$var$typeOf(object) === $bc17f30063f5df3c$var$REACT_CONTEXT_TYPE;
};
$bc17f30063f5df3c$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $bc17f30063f5df3c$var$REACT_ELEMENT_TYPE;
};
$bc17f30063f5df3c$export$455c2e768291efa6 = function(object) {
    return $bc17f30063f5df3c$var$typeOf(object) === $bc17f30063f5df3c$var$REACT_FORWARD_REF_TYPE;
};
$bc17f30063f5df3c$export$9522e17588c12572 = function(object) {
    return $bc17f30063f5df3c$var$typeOf(object) === $bc17f30063f5df3c$var$REACT_FRAGMENT_TYPE;
};
$bc17f30063f5df3c$export$2110ac352bb060b9 = function(object) {
    return $bc17f30063f5df3c$var$typeOf(object) === $bc17f30063f5df3c$var$REACT_LAZY_TYPE;
};
$bc17f30063f5df3c$export$56885ab8b9c456ab = function(object) {
    return $bc17f30063f5df3c$var$typeOf(object) === $bc17f30063f5df3c$var$REACT_MEMO_TYPE;
};
$bc17f30063f5df3c$export$d927fcb6adf8f9de = function(object) {
    return $bc17f30063f5df3c$var$typeOf(object) === $bc17f30063f5df3c$var$REACT_PORTAL_TYPE;
};
$bc17f30063f5df3c$export$b82d16f27459e05a = function(object) {
    return $bc17f30063f5df3c$var$typeOf(object) === $bc17f30063f5df3c$var$REACT_PROFILER_TYPE;
};
$bc17f30063f5df3c$export$522c17b4f5e123e8 = function(object) {
    return $bc17f30063f5df3c$var$typeOf(object) === $bc17f30063f5df3c$var$REACT_STRICT_MODE_TYPE;
};
$bc17f30063f5df3c$export$1aabd8a0274ecfd6 = function(object) {
    return $bc17f30063f5df3c$var$typeOf(object) === $bc17f30063f5df3c$var$REACT_SUSPENSE_TYPE;
};
$bc17f30063f5df3c$export$3d6c20d97e46b957 = function(object) {
    return $bc17f30063f5df3c$var$typeOf(object) === $bc17f30063f5df3c$var$REACT_SUSPENSE_LIST_TYPE;
};
$bc17f30063f5df3c$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $bc17f30063f5df3c$var$REACT_FRAGMENT_TYPE || type === $bc17f30063f5df3c$var$REACT_PROFILER_TYPE || type === $bc17f30063f5df3c$var$REACT_STRICT_MODE_TYPE || type === $bc17f30063f5df3c$var$REACT_SUSPENSE_TYPE || type === $bc17f30063f5df3c$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $bc17f30063f5df3c$var$REACT_LAZY_TYPE || type.$$typeof === $bc17f30063f5df3c$var$REACT_MEMO_TYPE || type.$$typeof === $bc17f30063f5df3c$var$REACT_CONTEXT_TYPE || type.$$typeof === $bc17f30063f5df3c$var$REACT_CONSUMER_TYPE || type.$$typeof === $bc17f30063f5df3c$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $bc17f30063f5df3c$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$bc17f30063f5df3c$export$f5bbd400c2f4426f = $bc17f30063f5df3c$var$typeOf;

});



parcelRegister("4AV1f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3586c109693dafd4$export$2e2bcd8739ae039; });

var $bBmNN = parcelRequire("bBmNN");

var $er0qK = parcelRequire("er0qK");

var $2m2Yl = parcelRequire("2m2Yl");

var $jejWx = parcelRequire("jejWx");

var $lQpEn = parcelRequire("lQpEn");
const $3586c109693dafd4$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $er0qK.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $er0qK.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $er0qK.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $er0qK.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $er0qK.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $er0qK.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $er0qK.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $jejWx.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $jejWx.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $jejWx.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $bBmNN.padding)
    },
    pt: {
        style: (0, $bBmNN.padding)
    },
    pr: {
        style: (0, $bBmNN.padding)
    },
    pb: {
        style: (0, $bBmNN.padding)
    },
    pl: {
        style: (0, $bBmNN.padding)
    },
    px: {
        style: (0, $bBmNN.padding)
    },
    py: {
        style: (0, $bBmNN.padding)
    },
    padding: {
        style: (0, $bBmNN.padding)
    },
    paddingTop: {
        style: (0, $bBmNN.padding)
    },
    paddingRight: {
        style: (0, $bBmNN.padding)
    },
    paddingBottom: {
        style: (0, $bBmNN.padding)
    },
    paddingLeft: {
        style: (0, $bBmNN.padding)
    },
    paddingX: {
        style: (0, $bBmNN.padding)
    },
    paddingY: {
        style: (0, $bBmNN.padding)
    },
    paddingInline: {
        style: (0, $bBmNN.padding)
    },
    paddingInlineStart: {
        style: (0, $bBmNN.padding)
    },
    paddingInlineEnd: {
        style: (0, $bBmNN.padding)
    },
    paddingBlock: {
        style: (0, $bBmNN.padding)
    },
    paddingBlockStart: {
        style: (0, $bBmNN.padding)
    },
    paddingBlockEnd: {
        style: (0, $bBmNN.padding)
    },
    m: {
        style: (0, $bBmNN.margin)
    },
    mt: {
        style: (0, $bBmNN.margin)
    },
    mr: {
        style: (0, $bBmNN.margin)
    },
    mb: {
        style: (0, $bBmNN.margin)
    },
    ml: {
        style: (0, $bBmNN.margin)
    },
    mx: {
        style: (0, $bBmNN.margin)
    },
    my: {
        style: (0, $bBmNN.margin)
    },
    margin: {
        style: (0, $bBmNN.margin)
    },
    marginTop: {
        style: (0, $bBmNN.margin)
    },
    marginRight: {
        style: (0, $bBmNN.margin)
    },
    marginBottom: {
        style: (0, $bBmNN.margin)
    },
    marginLeft: {
        style: (0, $bBmNN.margin)
    },
    marginX: {
        style: (0, $bBmNN.margin)
    },
    marginY: {
        style: (0, $bBmNN.margin)
    },
    marginInline: {
        style: (0, $bBmNN.margin)
    },
    marginInlineStart: {
        style: (0, $bBmNN.margin)
    },
    marginInlineEnd: {
        style: (0, $bBmNN.margin)
    },
    marginBlock: {
        style: (0, $bBmNN.margin)
    },
    marginBlockStart: {
        style: (0, $bBmNN.margin)
    },
    marginBlockEnd: {
        style: (0, $bBmNN.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $2m2Yl.gap)
    },
    rowGap: {
        style: (0, $2m2Yl.rowGap)
    },
    columnGap: {
        style: (0, $2m2Yl.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $lQpEn.sizingTransform)
    },
    maxWidth: {
        style: (0, $lQpEn.maxWidth)
    },
    minWidth: {
        transform: (0, $lQpEn.sizingTransform)
    },
    height: {
        transform: (0, $lQpEn.sizingTransform)
    },
    maxHeight: {
        transform: (0, $lQpEn.sizingTransform)
    },
    minHeight: {
        transform: (0, $lQpEn.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $3586c109693dafd4$export$2e2bcd8739ae039 = $3586c109693dafd4$var$defaultSxConfig;

});
parcelRegister("bBmNN", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $8724d6735ffb33e7$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $8724d6735ffb33e7$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $8724d6735ffb33e7$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $8724d6735ffb33e7$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $8724d6735ffb33e7$export$6f98e8eaf0be1996; });


var $641Kf = parcelRequire("641Kf");

var $88OpF = parcelRequire("88OpF");

var $bDoD0 = parcelRequire("bDoD0");

var $d3F2B = parcelRequire("d3F2B");
const $8724d6735ffb33e7$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $8724d6735ffb33e7$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $8724d6735ffb33e7$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $8724d6735ffb33e7$var$getCssProperties = (0, $d3F2B.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($8724d6735ffb33e7$var$aliases[prop]) prop = $8724d6735ffb33e7$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $8724d6735ffb33e7$var$properties[a];
    const direction = $8724d6735ffb33e7$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $8724d6735ffb33e7$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $8724d6735ffb33e7$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $8724d6735ffb33e7$var$spacingKeys = [
    ...$8724d6735ffb33e7$export$aab52a0dde05ad8a,
    ...$8724d6735ffb33e7$export$f8397d44f03ab6ad
];
function $8724d6735ffb33e7$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $88OpF.getPath)(theme, themeKey, true)) !== null && _getPath !== void 0 ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $8724d6735ffb33e7$export$1def6f833384e3d1(theme) {
    return $8724d6735ffb33e7$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $8724d6735ffb33e7$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $8724d6735ffb33e7$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $8724d6735ffb33e7$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $8724d6735ffb33e7$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $8724d6735ffb33e7$var$getCssProperties(prop);
    const styleFromPropValue = $8724d6735ffb33e7$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $641Kf.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $8724d6735ffb33e7$var$style(props, keys) {
    const transformer = $8724d6735ffb33e7$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$8724d6735ffb33e7$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $bDoD0.default), {});
}
function $8724d6735ffb33e7$export$7ede87f9b603dd3c(props) {
    return $8724d6735ffb33e7$var$style(props, $8724d6735ffb33e7$export$aab52a0dde05ad8a);
}
$8724d6735ffb33e7$export$7ede87f9b603dd3c.propTypes = {};
$8724d6735ffb33e7$export$7ede87f9b603dd3c.filterProps = $8724d6735ffb33e7$export$aab52a0dde05ad8a;
function $8724d6735ffb33e7$export$6f98e8eaf0be1996(props) {
    return $8724d6735ffb33e7$var$style(props, $8724d6735ffb33e7$export$f8397d44f03ab6ad);
}
$8724d6735ffb33e7$export$6f98e8eaf0be1996.propTypes = {};
$8724d6735ffb33e7$export$6f98e8eaf0be1996.filterProps = $8724d6735ffb33e7$export$f8397d44f03ab6ad;
function $8724d6735ffb33e7$var$spacing(props) {
    return $8724d6735ffb33e7$var$style(props, $8724d6735ffb33e7$var$spacingKeys);
}
$8724d6735ffb33e7$var$spacing.propTypes = {};
$8724d6735ffb33e7$var$spacing.filterProps = $8724d6735ffb33e7$var$spacingKeys;
var $8724d6735ffb33e7$export$2e2bcd8739ae039 = $8724d6735ffb33e7$var$spacing;

});
parcelRegister("641Kf", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $46a478502d95a3af$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $46a478502d95a3af$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $46a478502d95a3af$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $46a478502d95a3af$export$8922c90b6e020726; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $46a478502d95a3af$export$980e6a259d807490; });

var $dok7x = parcelRequire("dok7x");


var $f6ZlQ = parcelRequire("f6ZlQ");

var $bDoD0 = parcelRequire("bDoD0");

var $ktUsx = parcelRequire("ktUsx");
const $46a478502d95a3af$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $46a478502d95a3af$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$46a478502d95a3af$export$68c286be0e7e55b7[key]}px)`
};
const $46a478502d95a3af$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $46a478502d95a3af$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $46a478502d95a3af$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $46a478502d95a3af$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $46a478502d95a3af$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $ktUsx.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $ktUsx.getContainerQuery)(theme.containerQueries ? theme : $46a478502d95a3af$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $46a478502d95a3af$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $46a478502d95a3af$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $46a478502d95a3af$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $dok7x._)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $bDoD0.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $46a478502d95a3af$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput_keys;
    const breakpointsInOrder = (_breakpointsInput_keys = breakpointsInput.keys) === null || _breakpointsInput_keys === void 0 ? void 0 : _breakpointsInput_keys.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $46a478502d95a3af$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $46a478502d95a3af$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $46a478502d95a3af$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $f6ZlQ.default)(prev, next), {});
    return $46a478502d95a3af$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $46a478502d95a3af$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $46a478502d95a3af$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $46a478502d95a3af$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $46a478502d95a3af$export$2e2bcd8739ae039 = $46a478502d95a3af$var$breakpoints;

});
parcelRegister("bDoD0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $878670de40e29b42$export$2e2bcd8739ae039; });

var $f6ZlQ = parcelRequire("f6ZlQ");
function $878670de40e29b42$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $f6ZlQ.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $878670de40e29b42$export$2e2bcd8739ae039 = $878670de40e29b42$var$merge;

});

parcelRegister("ktUsx", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", function () { return $ee924fb93547a30f$export$456f6c1142f990db; });
$parcel$export(module.exports, "isCqShorthand", function () { return $ee924fb93547a30f$export$77c7c3e357f440e7; });
$parcel$export(module.exports, "getContainerQuery", function () { return $ee924fb93547a30f$export$10a9745dfa00d15; });
$parcel$export(module.exports, "default", function () { return $ee924fb93547a30f$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

function $ee924fb93547a30f$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        var _a_match, _b_match;
        const regex = /min-width:\s*([0-9.]+)/;
        return +(((_a_match = a.match(regex)) === null || _a_match === void 0 ? void 0 : _a_match[1]) || 0) - +(((_b_match = b.match(regex)) === null || _b_match === void 0 ? void 0 : _b_match[1]) || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, (0, $dok7x._)({}, css));
}
function $ee924fb93547a30f$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $ee924fb93547a30f$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $ee924fb93547a30f$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return (0, $cNnl8._)((0, $dok7x._)({}, themeInput), {
        containerQueries: containerQueries
    });
}

});


parcelRegister("88OpF", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $5ed62d1347c8862f$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $5ed62d1347c8862f$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $5ed62d1347c8862f$export$2e2bcd8739ae039; });

var $31bjE = parcelRequire("31bjE");


var $641Kf = parcelRequire("641Kf");
function $5ed62d1347c8862f$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $5ed62d1347c8862f$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $5ed62d1347c8862f$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $5ed62d1347c8862f$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $5ed62d1347c8862f$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $5ed62d1347c8862f$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $5ed62d1347c8862f$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $31bjE.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $641Kf.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $5ed62d1347c8862f$export$2e2bcd8739ae039 = $5ed62d1347c8862f$var$style;

});
parcelRegister("31bjE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $232a3e38937e49cd$export$2e2bcd8739ae039; });

var $iJT96 = parcelRequire("iJT96");
function $232a3e38937e49cd$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $iJT96.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("iJT96", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da4734c7e8551fe8$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $da4734c7e8551fe8$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});



parcelRegister("d3F2B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $981b64146599796c$export$2e2bcd8739ae039; });
function $981b64146599796c$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("er0qK", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $02b641bcfb2599cd$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $02b641bcfb2599cd$export$7a57f79000377ca2; });


var $88OpF = parcelRequire("88OpF");

var $d93Qv = parcelRequire("d93Qv");

var $bBmNN = parcelRequire("bBmNN");

var $641Kf = parcelRequire("641Kf");
function $02b641bcfb2599cd$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $02b641bcfb2599cd$var$createBorderStyle(prop, transform) {
    return (0, $88OpF.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $02b641bcfb2599cd$export$1edee58a52776cd9 = $02b641bcfb2599cd$var$createBorderStyle('border', $02b641bcfb2599cd$export$34e2febe53ae29cc);
const $02b641bcfb2599cd$export$f9a7b6bd24892946 = $02b641bcfb2599cd$var$createBorderStyle('borderTop', $02b641bcfb2599cd$export$34e2febe53ae29cc);
const $02b641bcfb2599cd$export$5abca33e6be905d2 = $02b641bcfb2599cd$var$createBorderStyle('borderRight', $02b641bcfb2599cd$export$34e2febe53ae29cc);
const $02b641bcfb2599cd$export$e2ce9f12a980a822 = $02b641bcfb2599cd$var$createBorderStyle('borderBottom', $02b641bcfb2599cd$export$34e2febe53ae29cc);
const $02b641bcfb2599cd$export$47658cca1a909427 = $02b641bcfb2599cd$var$createBorderStyle('borderLeft', $02b641bcfb2599cd$export$34e2febe53ae29cc);
const $02b641bcfb2599cd$export$e7fb0694ba2404fc = $02b641bcfb2599cd$var$createBorderStyle('borderColor');
const $02b641bcfb2599cd$export$126a92c968acdb85 = $02b641bcfb2599cd$var$createBorderStyle('borderTopColor');
const $02b641bcfb2599cd$export$85cc51cb8fbb8c0e = $02b641bcfb2599cd$var$createBorderStyle('borderRightColor');
const $02b641bcfb2599cd$export$340b0327727f6d1a = $02b641bcfb2599cd$var$createBorderStyle('borderBottomColor');
const $02b641bcfb2599cd$export$60beef91a985b4bf = $02b641bcfb2599cd$var$createBorderStyle('borderLeftColor');
const $02b641bcfb2599cd$export$f9258c55612cbed7 = $02b641bcfb2599cd$var$createBorderStyle('outline', $02b641bcfb2599cd$export$34e2febe53ae29cc);
const $02b641bcfb2599cd$export$621fe586efeb64b9 = $02b641bcfb2599cd$var$createBorderStyle('outlineColor');
const $02b641bcfb2599cd$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $bBmNN.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $bBmNN.getValue)(transformer, propValue)
            });
        return (0, $641Kf.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$02b641bcfb2599cd$export$7a57f79000377ca2.propTypes = {};
$02b641bcfb2599cd$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $02b641bcfb2599cd$var$borders = (0, $d93Qv.default)($02b641bcfb2599cd$export$1edee58a52776cd9, $02b641bcfb2599cd$export$f9a7b6bd24892946, $02b641bcfb2599cd$export$5abca33e6be905d2, $02b641bcfb2599cd$export$e2ce9f12a980a822, $02b641bcfb2599cd$export$47658cca1a909427, $02b641bcfb2599cd$export$e7fb0694ba2404fc, $02b641bcfb2599cd$export$126a92c968acdb85, $02b641bcfb2599cd$export$85cc51cb8fbb8c0e, $02b641bcfb2599cd$export$340b0327727f6d1a, $02b641bcfb2599cd$export$60beef91a985b4bf, $02b641bcfb2599cd$export$7a57f79000377ca2, $02b641bcfb2599cd$export$f9258c55612cbed7, $02b641bcfb2599cd$export$621fe586efeb64b9);
var $02b641bcfb2599cd$export$2e2bcd8739ae039 = $02b641bcfb2599cd$var$borders;

});
parcelRegister("d93Qv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $991f195136f2ed34$export$2e2bcd8739ae039; });

var $bDoD0 = parcelRequire("bDoD0");
function $991f195136f2ed34$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $bDoD0.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $991f195136f2ed34$export$2e2bcd8739ae039 = $991f195136f2ed34$var$compose;

});


parcelRegister("2m2Yl", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $1b6ff10f6c889ab0$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $1b6ff10f6c889ab0$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $1b6ff10f6c889ab0$export$8a833ffa5f5dbeda; });

var $88OpF = parcelRequire("88OpF");

var $d93Qv = parcelRequire("d93Qv");

var $bBmNN = parcelRequire("bBmNN");

var $641Kf = parcelRequire("641Kf");

const $1b6ff10f6c889ab0$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $bBmNN.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $bBmNN.getValue)(transformer, propValue)
            });
        return (0, $641Kf.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$1b6ff10f6c889ab0$export$5df9adcb0db95e1e.propTypes = {};
$1b6ff10f6c889ab0$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $1b6ff10f6c889ab0$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $bBmNN.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $bBmNN.getValue)(transformer, propValue)
            });
        return (0, $641Kf.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$1b6ff10f6c889ab0$export$ec60d70ff941a580.propTypes = {};
$1b6ff10f6c889ab0$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $1b6ff10f6c889ab0$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $bBmNN.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $bBmNN.getValue)(transformer, propValue)
            });
        return (0, $641Kf.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$1b6ff10f6c889ab0$export$8a833ffa5f5dbeda.propTypes = {};
$1b6ff10f6c889ab0$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $1b6ff10f6c889ab0$export$baf44164ca3a34e8 = (0, $88OpF.default)({
    prop: 'gridColumn'
});
const $1b6ff10f6c889ab0$export$8f7213a1cd01e832 = (0, $88OpF.default)({
    prop: 'gridRow'
});
const $1b6ff10f6c889ab0$export$b0e0abbc49ba668 = (0, $88OpF.default)({
    prop: 'gridAutoFlow'
});
const $1b6ff10f6c889ab0$export$bcd8b929d4b4142 = (0, $88OpF.default)({
    prop: 'gridAutoColumns'
});
const $1b6ff10f6c889ab0$export$e5039a674e14c828 = (0, $88OpF.default)({
    prop: 'gridAutoRows'
});
const $1b6ff10f6c889ab0$export$42bd9088661ffb03 = (0, $88OpF.default)({
    prop: 'gridTemplateColumns'
});
const $1b6ff10f6c889ab0$export$920682ae05b999bc = (0, $88OpF.default)({
    prop: 'gridTemplateRows'
});
const $1b6ff10f6c889ab0$export$1b88fbdd482fd33a = (0, $88OpF.default)({
    prop: 'gridTemplateAreas'
});
const $1b6ff10f6c889ab0$export$bdb486e40d52d26f = (0, $88OpF.default)({
    prop: 'gridArea'
});
const $1b6ff10f6c889ab0$var$grid = (0, $d93Qv.default)($1b6ff10f6c889ab0$export$5df9adcb0db95e1e, $1b6ff10f6c889ab0$export$ec60d70ff941a580, $1b6ff10f6c889ab0$export$8a833ffa5f5dbeda, $1b6ff10f6c889ab0$export$baf44164ca3a34e8, $1b6ff10f6c889ab0$export$8f7213a1cd01e832, $1b6ff10f6c889ab0$export$b0e0abbc49ba668, $1b6ff10f6c889ab0$export$bcd8b929d4b4142, $1b6ff10f6c889ab0$export$e5039a674e14c828, $1b6ff10f6c889ab0$export$42bd9088661ffb03, $1b6ff10f6c889ab0$export$920682ae05b999bc, $1b6ff10f6c889ab0$export$1b88fbdd482fd33a, $1b6ff10f6c889ab0$export$bdb486e40d52d26f);
var $1b6ff10f6c889ab0$export$2e2bcd8739ae039 = $1b6ff10f6c889ab0$var$grid;

});

parcelRegister("jejWx", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $dffecb70952c88b4$export$dbaffd4420ea0ac6; });

var $88OpF = parcelRequire("88OpF");

var $d93Qv = parcelRequire("d93Qv");
function $dffecb70952c88b4$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $dffecb70952c88b4$export$35e9368ef982300f = (0, $88OpF.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $dffecb70952c88b4$export$dbaffd4420ea0ac6
});
const $dffecb70952c88b4$export$2506f56c10355b33 = (0, $88OpF.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $dffecb70952c88b4$export$dbaffd4420ea0ac6
});
const $dffecb70952c88b4$export$8c5a050822fd698c = (0, $88OpF.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $dffecb70952c88b4$export$dbaffd4420ea0ac6
});
const $dffecb70952c88b4$var$palette = (0, $d93Qv.default)($dffecb70952c88b4$export$35e9368ef982300f, $dffecb70952c88b4$export$2506f56c10355b33, $dffecb70952c88b4$export$8c5a050822fd698c);
var $dffecb70952c88b4$export$2e2bcd8739ae039 = $dffecb70952c88b4$var$palette;

});

parcelRegister("lQpEn", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $fe7259e6b3e8ecfa$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $fe7259e6b3e8ecfa$export$488fda99655ff65a; });

var $88OpF = parcelRequire("88OpF");

var $d93Qv = parcelRequire("d93Qv");

var $641Kf = parcelRequire("641Kf");
function $fe7259e6b3e8ecfa$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $fe7259e6b3e8ecfa$export$7e3df82ee760448c = (0, $88OpF.default)({
    prop: 'width',
    transform: $fe7259e6b3e8ecfa$export$8afece71750ec241
});
const $fe7259e6b3e8ecfa$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props_theme_breakpoints_values, _props_theme_breakpoints, _props_theme, _props_theme_breakpoints1, _props_theme1;
            const breakpoint = ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_breakpoints = _props_theme.breakpoints) === null || _props_theme_breakpoints === void 0 ? void 0 : (_props_theme_breakpoints_values = _props_theme_breakpoints.values) === null || _props_theme_breakpoints_values === void 0 ? void 0 : _props_theme_breakpoints_values[propValue]) || (0, $641Kf.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $fe7259e6b3e8ecfa$export$8afece71750ec241(propValue)
            };
            if (((_props_theme1 = props.theme) === null || _props_theme1 === void 0 ? void 0 : (_props_theme_breakpoints1 = _props_theme1.breakpoints) === null || _props_theme_breakpoints1 === void 0 ? void 0 : _props_theme_breakpoints1.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $641Kf.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$fe7259e6b3e8ecfa$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $fe7259e6b3e8ecfa$export$ee148fbbe8357dd2 = (0, $88OpF.default)({
    prop: 'minWidth',
    transform: $fe7259e6b3e8ecfa$export$8afece71750ec241
});
const $fe7259e6b3e8ecfa$export$ac607276a8fe9f0a = (0, $88OpF.default)({
    prop: 'height',
    transform: $fe7259e6b3e8ecfa$export$8afece71750ec241
});
const $fe7259e6b3e8ecfa$export$dc0d8bd0b94f8570 = (0, $88OpF.default)({
    prop: 'maxHeight',
    transform: $fe7259e6b3e8ecfa$export$8afece71750ec241
});
const $fe7259e6b3e8ecfa$export$a43cf604e12f3b17 = (0, $88OpF.default)({
    prop: 'minHeight',
    transform: $fe7259e6b3e8ecfa$export$8afece71750ec241
});
const $fe7259e6b3e8ecfa$export$ffed9f14fb65e276 = (0, $88OpF.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $fe7259e6b3e8ecfa$export$8afece71750ec241
});
const $fe7259e6b3e8ecfa$export$905076ed6620e671 = (0, $88OpF.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $fe7259e6b3e8ecfa$export$8afece71750ec241
});
const $fe7259e6b3e8ecfa$export$6ccc93f785106a58 = (0, $88OpF.default)({
    prop: 'boxSizing'
});
const $fe7259e6b3e8ecfa$var$sizing = (0, $d93Qv.default)($fe7259e6b3e8ecfa$export$7e3df82ee760448c, $fe7259e6b3e8ecfa$export$488fda99655ff65a, $fe7259e6b3e8ecfa$export$ee148fbbe8357dd2, $fe7259e6b3e8ecfa$export$ac607276a8fe9f0a, $fe7259e6b3e8ecfa$export$dc0d8bd0b94f8570, $fe7259e6b3e8ecfa$export$a43cf604e12f3b17, $fe7259e6b3e8ecfa$export$6ccc93f785106a58);
var $fe7259e6b3e8ecfa$export$2e2bcd8739ae039 = $fe7259e6b3e8ecfa$var$sizing;

});



parcelRegister("eGBcx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab11d855c6f63d4b$export$2e2bcd8739ae039; });
parcelRequire("7hhBq");

var $8NzGK = parcelRequire("8NzGK");

var $aaaIb = parcelRequire("aaaIb");

var $9D8Xe = parcelRequire("9D8Xe");
'use client';
function $ab11d855c6f63d4b$export$2e2bcd8739ae039() {
    const theme = (0, $8NzGK.default)((0, $aaaIb.default));
    return theme[0, $9D8Xe.default] || theme;
}

});
parcelRegister("8NzGK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $667e9558821c4ec2$export$2e2bcd8739ae039; });

var $hKGA1 = parcelRequire("hKGA1");

var $7cBTh = parcelRequire("7cBTh");
'use client';
const $667e9558821c4ec2$export$35e57303dbd8a66 = (0, $hKGA1.default)();
function $667e9558821c4ec2$var$useTheme(defaultTheme = $667e9558821c4ec2$export$35e57303dbd8a66) {
    return (0, $7cBTh.default)(defaultTheme);
}
var $667e9558821c4ec2$export$2e2bcd8739ae039 = $667e9558821c4ec2$var$useTheme;

});
parcelRegister("hKGA1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cec7c311849c816c$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $6pkKu = parcelRequire("6pkKu");

var $f6ZlQ = parcelRequire("f6ZlQ");

var $1vfWR = parcelRequire("1vfWR");

var $ktUsx = parcelRequire("ktUsx");

var $bGfzE = parcelRequire("bGfzE");

var $MJIDm = parcelRequire("MJIDm");

var $ahHCI = parcelRequire("ahHCI");

var $4AV1f = parcelRequire("4AV1f");

var $kDCJF = parcelRequire("kDCJF");
function $cec7c311849c816c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $6pkKu._)(options, [
        "breakpoints",
        "palette",
        "spacing",
        "shape"
    ]);
    const breakpoints = (0, $1vfWR.default)(breakpointsInput);
    const spacing = (0, $MJIDm.default)(spacingInput);
    let muiTheme = (0, $f6ZlQ.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $dok7x._)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $dok7x._)({}, (0, $bGfzE.default), shapeInput)
    }, other);
    muiTheme = (0, $ktUsx.default)(muiTheme);
    muiTheme.applyStyles = (0, $kDCJF.default);
    muiTheme = args.reduce((acc, argument)=>(0, $f6ZlQ.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $dok7x._)({}, (0, $4AV1f.default), other === null || other === void 0 ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $ahHCI.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $cec7c311849c816c$export$2e2bcd8739ae039 = $cec7c311849c816c$var$createTheme;

});
parcelRegister("1vfWR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11850eb5673dc92e$export$2e2bcd8739ae039; });
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");
const $11850eb5673dc92e$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $11850eb5673dc92e$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $cNnl8._)((0, $dok7x._)({}, acc), {
            [obj.key]: obj.val
        });
    }, {});
};
function $11850eb5673dc92e$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $6pkKu._)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    const sortedValues = $11850eb5673dc92e$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $dok7x._)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("bGfzE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $880fb2a41dca1b6d$export$2e2bcd8739ae039; });
const $880fb2a41dca1b6d$var$shape = {
    borderRadius: 4
};
var $880fb2a41dca1b6d$export$2e2bcd8739ae039 = $880fb2a41dca1b6d$var$shape;

});

parcelRegister("MJIDm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0927f2a18749909c$export$2e2bcd8739ae039; });

var $bBmNN = parcelRequire("bBmNN");
function $0927f2a18749909c$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $bBmNN.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("ahHCI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77cd54a533e29319$export$2e2bcd8739ae039; });

var $31bjE = parcelRequire("31bjE");

var $bDoD0 = parcelRequire("bDoD0");

var $88OpF = parcelRequire("88OpF");

var $641Kf = parcelRequire("641Kf");

var $ktUsx = parcelRequire("ktUsx");

var $4AV1f = parcelRequire("4AV1f");
function $77cd54a533e29319$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $77cd54a533e29319$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $77cd54a533e29319$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $88OpF.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $88OpF.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $88OpF.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $31bjE.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $641Kf.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        var _theme_unstable_sxConfig;
        const config = (_theme_unstable_sxConfig = theme.unstable_sxConfig) !== null && _theme_unstable_sxConfig !== void 0 ? _theme_unstable_sxConfig : (0, $4AV1f.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $641Kf.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $77cd54a533e29319$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $bDoD0.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $641Kf.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($77cd54a533e29319$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $bDoD0.default)(css, breakpointsValues);
                        }
                    } else css = (0, $bDoD0.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $ktUsx.sortContainerQueries)(theme, (0, $641Kf.removeUnusedBreakpoints)(breakpointsKeys, css))
            };
            return (0, $ktUsx.sortContainerQueries)(theme, (0, $641Kf.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $77cd54a533e29319$var$styleFunctionSx = $77cd54a533e29319$export$7d53d8bf2911e013();
$77cd54a533e29319$var$styleFunctionSx.filterProps = [
    'sx'
];
var $77cd54a533e29319$export$2e2bcd8739ae039 = $77cd54a533e29319$var$styleFunctionSx;

});

parcelRegister("kDCJF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0657f3aa81a8895$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $f0657f3aa81a8895$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        var _theme_colorSchemes;
        if (!((_theme_colorSchemes = theme.colorSchemes) === null || _theme_colorSchemes === void 0 ? void 0 : _theme_colorSchemes[key]) || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("7cBTh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53e70baab32a7d94$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
parcelRequire("38swY");
var $jns69 = parcelRequire("jns69");
'use client';
function $53e70baab32a7d94$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $53e70baab32a7d94$var$useTheme(defaultTheme = null) {
    const contextTheme = $7hhBq.useContext((0, $jns69.T));
    return !contextTheme || $53e70baab32a7d94$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $53e70baab32a7d94$export$2e2bcd8739ae039 = $53e70baab32a7d94$var$useTheme;

});
parcelRegister("38swY", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $2488400e5df205a3$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $2488400e5df205a3$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $2488400e5df205a3$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("jns69")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("jns69")).w; });

var $jns69 = parcelRequire("jns69");

var $7hhBq = parcelRequire("7hhBq");

var $b21vB = parcelRequire("b21vB");

var $9ezTb = parcelRequire("9ezTb");

var $iJWIa = parcelRequire("iJWIa");
parcelRequire("6klt3");
parcelRequire("jamvR");
parcelRequire("ayVFI");

parcelRequire("4o8qq");
var $2488400e5df205a3$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $jns69.h).call(props, 'css')) return $7hhBq.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $jns69.E);
    createElementArgArray[1] = (0, $jns69.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $7hhBq.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($2488400e5df205a3$export$c8a8987d4410bf2d || ($2488400e5df205a3$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $2488400e5df205a3$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $jns69.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $iJWIa.serializeStyles)([
        styles
    ], undefined, $7hhBq.useContext((0, $jns69.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7hhBq.useRef();
    (0, $9ezTb.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $9ezTb.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $b21vB.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $2488400e5df205a3$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $iJWIa.serializeStyles)(args);
}
function $2488400e5df205a3$export$d25ddfdf17c3ad3e() {
    var insertable = $2488400e5df205a3$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $2488400e5df205a3$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $2488400e5df205a3$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $b21vB.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $2488400e5df205a3$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $9ezTb.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $b21vB.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $2488400e5df205a3$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $jns69.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $jns69.i)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $iJWIa.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $b21vB.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $jns69.i)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $2488400e5df205a3$var$merge(cache.registered, css, $2488400e5df205a3$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7hhBq.useContext((0, $jns69.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7hhBq.createElement($7hhBq.Fragment, null, /*#__PURE__*/ $7hhBq.createElement($2488400e5df205a3$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("jns69", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $e1b5f609db7f7d81$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $e1b5f609db7f7d81$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $e1b5f609db7f7d81$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $e1b5f609db7f7d81$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $e1b5f609db7f7d81$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $e1b5f609db7f7d81$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $e1b5f609db7f7d81$export$a9c23c6ac3fc3eca; });

var $7hhBq = parcelRequire("7hhBq");

var $6klt3 = parcelRequire("6klt3");

var $jamvR = parcelRequire("jamvR");

var $ayVFI = parcelRequire("ayVFI");

var $fkn0h = parcelRequire("fkn0h");

var $b21vB = parcelRequire("b21vB");

var $iJWIa = parcelRequire("iJWIa");

var $9ezTb = parcelRequire("9ezTb");
var $e1b5f609db7f7d81$export$23f2a1d2818174ef = false;
var $e1b5f609db7f7d81$var$EmotionCacheContext = /* #__PURE__ */ $7hhBq.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $6klt3.default)({
    key: 'css'
}) : null);
var $e1b5f609db7f7d81$export$e7094788287c5e9b = $e1b5f609db7f7d81$var$EmotionCacheContext.Provider;
var $e1b5f609db7f7d81$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7hhBq.useContext)($e1b5f609db7f7d81$var$EmotionCacheContext);
};
var $e1b5f609db7f7d81$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $7hhBq.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7hhBq.useContext)($e1b5f609db7f7d81$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $e1b5f609db7f7d81$export$971d5caa766a69d7 = /* #__PURE__ */ $7hhBq.createContext({});
var $e1b5f609db7f7d81$export$3b14a55fb2447963 = function useTheme() {
    return $7hhBq.useContext($e1b5f609db7f7d81$export$971d5caa766a69d7);
};
var $e1b5f609db7f7d81$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $jamvR.default)({}, outerTheme, theme);
};
var $e1b5f609db7f7d81$var$createCacheWithTheme = /* #__PURE__ */ (0, $ayVFI.default)(function(outerTheme) {
    return (0, $ayVFI.default)(function(theme) {
        return $e1b5f609db7f7d81$var$getTheme(outerTheme, theme);
    });
});
var $e1b5f609db7f7d81$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $7hhBq.useContext($e1b5f609db7f7d81$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $e1b5f609db7f7d81$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7hhBq.createElement($e1b5f609db7f7d81$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $e1b5f609db7f7d81$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $7hhBq.forwardRef(function render(props, ref) {
        var theme = $7hhBq.useContext($e1b5f609db7f7d81$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7hhBq.createElement(Component, (0, $jamvR.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $fkn0h.default)(WithTheme, Component);
}
var $e1b5f609db7f7d81$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $e1b5f609db7f7d81$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $e1b5f609db7f7d81$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($e1b5f609db7f7d81$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$e1b5f609db7f7d81$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $e1b5f609db7f7d81$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $b21vB.registerStyles)(cache, serialized, isStringTag);
    (0, $9ezTb.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $b21vB.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $e1b5f609db7f7d81$var$Emotion = /* #__PURE__ */ $e1b5f609db7f7d81$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$e1b5f609db7f7d81$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $b21vB.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $iJWIa.serializeStyles)(registeredStyles, undefined, $7hhBq.useContext($e1b5f609db7f7d81$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($e1b5f609db7f7d81$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $e1b5f609db7f7d81$var$typePropName && !$e1b5f609db7f7d81$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $7hhBq.createElement($7hhBq.Fragment, null, /*#__PURE__*/ $7hhBq.createElement($e1b5f609db7f7d81$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7hhBq.createElement(WrappedComponent, newProps));
});
var $e1b5f609db7f7d81$export$a9c23c6ac3fc3eca = $e1b5f609db7f7d81$var$Emotion;

});
parcelRegister("6klt3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49b54358052161f2$export$2e2bcd8739ae039; });

var $jNaYn = parcelRequire("jNaYn");

var $i86HN = parcelRequire("i86HN");
var $3L5mc = parcelRequire("3L5mc");
var $9Y0t9 = parcelRequire("9Y0t9");
var $lWghZ = parcelRequire("lWghZ");
var $gVRIM = parcelRequire("gVRIM");
var $hXIOf = parcelRequire("hXIOf");
parcelRequire("ayVFI");
parcelRequire("65JfS");
var $49b54358052161f2$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $i86HN.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $i86HN.token)(character)) break;
        (0, $i86HN.next)();
    }
    return (0, $i86HN.slice)(begin, (0, $i86HN.position));
};
var $49b54358052161f2$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $i86HN.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $i86HN.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $49b54358052161f2$var$identifierWithPointTracking((0, $i86HN.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $i86HN.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $i86HN.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $3L5mc.from)(character);
    }
    while (character = (0, $i86HN.next)());
    return parsed;
};
var $49b54358052161f2$var$getRules = function getRules(value, points) {
    return (0, $i86HN.dealloc)($49b54358052161f2$var$toRules((0, $i86HN.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $49b54358052161f2$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $49b54358052161f2$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$49b54358052161f2$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $49b54358052161f2$var$fixedElements.set(element, true);
    var points = [];
    var rules = $49b54358052161f2$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $49b54358052161f2$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $49b54358052161f2$var$prefix(value, length) {
    switch((0, $3L5mc.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $lWghZ.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $lWghZ.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MOZ) + value + (0, $lWghZ.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + value + value;
        // order
        case 6165:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $lWghZ.WEBKIT) + value + (0, $3L5mc.replace)(value, /(\w+).+(:[^]+)/, (0, $lWghZ.WEBKIT) + 'box-$1$2' + (0, $lWghZ.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + 'flex-item-' + (0, $3L5mc.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + 'flex-line-pack' + (0, $3L5mc.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $lWghZ.WEBKIT) + 'box-' + (0, $3L5mc.replace)(value, '-grow', '') + (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $lWghZ.WEBKIT) + (0, $3L5mc.replace)(value, /([^-])(transform)/g, '$1' + (0, $lWghZ.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $3L5mc.replace)((0, $3L5mc.replace)((0, $3L5mc.replace)(value, /(zoom-|grab)/, (0, $lWghZ.WEBKIT) + '$1'), /(image-set)/, (0, $lWghZ.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $3L5mc.replace)(value, /(image-set\([^]*)/, (0, $lWghZ.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $3L5mc.replace)((0, $3L5mc.replace)(value, /(.+:)(flex-)?(.*)/, (0, $lWghZ.WEBKIT) + 'box-pack:$3' + (0, $lWghZ.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $lWghZ.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $3L5mc.replace)(value, /(.+)-inline(.+)/, (0, $lWghZ.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $3L5mc.strlen)(value) - 1 - length > 6) switch((0, $3L5mc.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $3L5mc.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $3L5mc.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $lWghZ.WEBKIT) + '$2-$3' + '$1' + (0, $lWghZ.MOZ) + ((0, $3L5mc.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $3L5mc.indexof)(value, 'stretch') ? $49b54358052161f2$var$prefix((0, $3L5mc.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $3L5mc.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $3L5mc.charat)(value, (0, $3L5mc.strlen)(value) - 3 - (~(0, $3L5mc.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $3L5mc.replace)(value, ':', ':' + (0, $lWghZ.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $3L5mc.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $lWghZ.WEBKIT) + ((0, $3L5mc.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $lWghZ.WEBKIT) + '$2$3' + '$1' + (0, $lWghZ.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $3L5mc.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + value + value;
    }
    return value;
}
var $49b54358052161f2$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $lWghZ.DECLARATION:
                element["return"] = $49b54358052161f2$var$prefix(element.value, element.length);
                break;
            case 0, $lWghZ.KEYFRAMES:
                return (0, $hXIOf.serialize)([
                    (0, $i86HN.copy)(element, {
                        value: (0, $3L5mc.replace)(element.value, '@', '@' + (0, $lWghZ.WEBKIT))
                    })
                ], callback);
            case 0, $lWghZ.RULESET:
                if (element.length) return (0, $3L5mc.combine)(element.props, function(value) {
                    switch((0, $3L5mc.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $hXIOf.serialize)([
                                (0, $i86HN.copy)(element, {
                                    props: [
                                        (0, $3L5mc.replace)(value, /:(read-\w+)/, ':' + (0, $lWghZ.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $hXIOf.serialize)([
                                (0, $i86HN.copy)(element, {
                                    props: [
                                        (0, $3L5mc.replace)(value, /:(plac\w+)/, ':' + (0, $lWghZ.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $i86HN.copy)(element, {
                                    props: [
                                        (0, $3L5mc.replace)(value, /:(plac\w+)/, ':' + (0, $lWghZ.MOZ) + '$1')
                                    ]
                                }),
                                (0, $i86HN.copy)(element, {
                                    props: [
                                        (0, $3L5mc.replace)(value, /:(plac\w+)/, (0, $lWghZ.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $49b54358052161f2$var$defaultStylisPlugins = [
    $49b54358052161f2$var$prefixer
];
var $49b54358052161f2$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $49b54358052161f2$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $49b54358052161f2$var$compat,
        $49b54358052161f2$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $hXIOf.stringify),
        (0, $gVRIM.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $gVRIM.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $hXIOf.serialize)((0, $9Y0t9.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $jNaYn.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jNaYn", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $e68b1ae447ec021b$export$9d753cd7ae895cce; });
var $e68b1ae447ec021b$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e68b1ae447ec021b$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e68b1ae447ec021b$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e68b1ae447ec021b$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e68b1ae447ec021b$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e68b1ae447ec021b$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e68b1ae447ec021b$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("i86HN", function(module, exports) {

$parcel$export(module.exports, "position", function () { return $d32e2ce054bf2ce0$export$5880b8b5730aff45; });
$parcel$export(module.exports, "node", function () { return $d32e2ce054bf2ce0$export$35059013cd4a06db; });
$parcel$export(module.exports, "copy", function () { return $d32e2ce054bf2ce0$export$784d13d8ee351f07; });
$parcel$export(module.exports, "char", function () { return $d32e2ce054bf2ce0$export$eba6f6f03b0a92e7; });
$parcel$export(module.exports, "prev", function () { return $d32e2ce054bf2ce0$export$232faf9add678146; });
$parcel$export(module.exports, "next", function () { return $d32e2ce054bf2ce0$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $d32e2ce054bf2ce0$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "caret", function () { return $d32e2ce054bf2ce0$export$e88cb2efb12ae807; });
$parcel$export(module.exports, "slice", function () { return $d32e2ce054bf2ce0$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $d32e2ce054bf2ce0$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $d32e2ce054bf2ce0$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $d32e2ce054bf2ce0$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $d32e2ce054bf2ce0$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "tokenize", function () { return $d32e2ce054bf2ce0$export$660b2ee2d4fb4eff; });
$parcel$export(module.exports, "whitespace", function () { return $d32e2ce054bf2ce0$export$7af1228ff777d175; });
$parcel$export(module.exports, "identifier", function () { return $d32e2ce054bf2ce0$export$c2ab62c7bf24634; });
$parcel$export(module.exports, "escaping", function () { return $d32e2ce054bf2ce0$export$955ba06d119e085e; });
$parcel$export(module.exports, "commenter", function () { return $d32e2ce054bf2ce0$export$4254d4e2b3745c4c; });

var $3L5mc = parcelRequire("3L5mc");
var $d32e2ce054bf2ce0$export$53f1d5ea8de3d7c = 1;
var $d32e2ce054bf2ce0$export$4e0c71f277ca26b3 = 1;
var $d32e2ce054bf2ce0$export$f24224f1c91d8156 = 0;
var $d32e2ce054bf2ce0$export$5880b8b5730aff45 = 0;
var $d32e2ce054bf2ce0$export$c0306caf338ac095 = 0;
var $d32e2ce054bf2ce0$export$30a86d91af8ff6e6 = '';
function $d32e2ce054bf2ce0$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $d32e2ce054bf2ce0$export$53f1d5ea8de3d7c,
        column: $d32e2ce054bf2ce0$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $d32e2ce054bf2ce0$export$784d13d8ee351f07(root, props) {
    return (0, $3L5mc.assign)($d32e2ce054bf2ce0$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $d32e2ce054bf2ce0$export$eba6f6f03b0a92e7() {
    return $d32e2ce054bf2ce0$export$c0306caf338ac095;
}
function $d32e2ce054bf2ce0$export$232faf9add678146() {
    $d32e2ce054bf2ce0$export$c0306caf338ac095 = $d32e2ce054bf2ce0$export$5880b8b5730aff45 > 0 ? (0, $3L5mc.charat)($d32e2ce054bf2ce0$export$30a86d91af8ff6e6, --$d32e2ce054bf2ce0$export$5880b8b5730aff45) : 0;
    if ($d32e2ce054bf2ce0$export$4e0c71f277ca26b3--, $d32e2ce054bf2ce0$export$c0306caf338ac095 === 10) $d32e2ce054bf2ce0$export$4e0c71f277ca26b3 = 1, $d32e2ce054bf2ce0$export$53f1d5ea8de3d7c--;
    return $d32e2ce054bf2ce0$export$c0306caf338ac095;
}
function $d32e2ce054bf2ce0$export$48cfd1e771a65c4f() {
    $d32e2ce054bf2ce0$export$c0306caf338ac095 = $d32e2ce054bf2ce0$export$5880b8b5730aff45 < $d32e2ce054bf2ce0$export$f24224f1c91d8156 ? (0, $3L5mc.charat)($d32e2ce054bf2ce0$export$30a86d91af8ff6e6, $d32e2ce054bf2ce0$export$5880b8b5730aff45++) : 0;
    if ($d32e2ce054bf2ce0$export$4e0c71f277ca26b3++, $d32e2ce054bf2ce0$export$c0306caf338ac095 === 10) $d32e2ce054bf2ce0$export$4e0c71f277ca26b3 = 1, $d32e2ce054bf2ce0$export$53f1d5ea8de3d7c++;
    return $d32e2ce054bf2ce0$export$c0306caf338ac095;
}
function $d32e2ce054bf2ce0$export$4d3fb11e950abb9e() {
    return (0, $3L5mc.charat)($d32e2ce054bf2ce0$export$30a86d91af8ff6e6, $d32e2ce054bf2ce0$export$5880b8b5730aff45);
}
function $d32e2ce054bf2ce0$export$e88cb2efb12ae807() {
    return $d32e2ce054bf2ce0$export$5880b8b5730aff45;
}
function $d32e2ce054bf2ce0$export$58adb3bec8346d0f(begin, end) {
    return (0, $3L5mc.substr)($d32e2ce054bf2ce0$export$30a86d91af8ff6e6, begin, end);
}
function $d32e2ce054bf2ce0$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $d32e2ce054bf2ce0$export$2de70f21292aac9e(value) {
    return $d32e2ce054bf2ce0$export$53f1d5ea8de3d7c = $d32e2ce054bf2ce0$export$4e0c71f277ca26b3 = 1, $d32e2ce054bf2ce0$export$f24224f1c91d8156 = (0, $3L5mc.strlen)($d32e2ce054bf2ce0$export$30a86d91af8ff6e6 = value), $d32e2ce054bf2ce0$export$5880b8b5730aff45 = 0, [];
}
function $d32e2ce054bf2ce0$export$45918ac1574455b1(value) {
    return $d32e2ce054bf2ce0$export$30a86d91af8ff6e6 = '', value;
}
function $d32e2ce054bf2ce0$export$410ac95b9ec204b8(type) {
    return (0, $3L5mc.trim)($d32e2ce054bf2ce0$export$58adb3bec8346d0f($d32e2ce054bf2ce0$export$5880b8b5730aff45 - 1, $d32e2ce054bf2ce0$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $d32e2ce054bf2ce0$export$660b2ee2d4fb4eff(value) {
    return $d32e2ce054bf2ce0$export$45918ac1574455b1($d32e2ce054bf2ce0$export$5f8c09e3ae6f64e1($d32e2ce054bf2ce0$export$2de70f21292aac9e(value)));
}
function $d32e2ce054bf2ce0$export$7af1228ff777d175(type) {
    while($d32e2ce054bf2ce0$export$c0306caf338ac095 = $d32e2ce054bf2ce0$export$4d3fb11e950abb9e())if ($d32e2ce054bf2ce0$export$c0306caf338ac095 < 33) $d32e2ce054bf2ce0$export$48cfd1e771a65c4f();
    else break;
    return $d32e2ce054bf2ce0$export$9e1725a4cfeada27(type) > 2 || $d32e2ce054bf2ce0$export$9e1725a4cfeada27($d32e2ce054bf2ce0$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $d32e2ce054bf2ce0$export$5f8c09e3ae6f64e1(children) {
    while($d32e2ce054bf2ce0$export$48cfd1e771a65c4f())switch($d32e2ce054bf2ce0$export$9e1725a4cfeada27($d32e2ce054bf2ce0$export$c0306caf338ac095)){
        case 0:
            (0, $3L5mc.append)($d32e2ce054bf2ce0$export$c2ab62c7bf24634($d32e2ce054bf2ce0$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $3L5mc.append)($d32e2ce054bf2ce0$export$410ac95b9ec204b8($d32e2ce054bf2ce0$export$c0306caf338ac095), children);
            break;
        default:
            (0, $3L5mc.append)((0, $3L5mc.from)($d32e2ce054bf2ce0$export$c0306caf338ac095), children);
    }
    return children;
}
function $d32e2ce054bf2ce0$export$955ba06d119e085e(index, count) {
    while(--count && $d32e2ce054bf2ce0$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($d32e2ce054bf2ce0$export$c0306caf338ac095 < 48 || $d32e2ce054bf2ce0$export$c0306caf338ac095 > 102 || $d32e2ce054bf2ce0$export$c0306caf338ac095 > 57 && $d32e2ce054bf2ce0$export$c0306caf338ac095 < 65 || $d32e2ce054bf2ce0$export$c0306caf338ac095 > 70 && $d32e2ce054bf2ce0$export$c0306caf338ac095 < 97) break;
    return $d32e2ce054bf2ce0$export$58adb3bec8346d0f(index, $d32e2ce054bf2ce0$export$e88cb2efb12ae807() + (count < 6 && $d32e2ce054bf2ce0$export$4d3fb11e950abb9e() == 32 && $d32e2ce054bf2ce0$export$48cfd1e771a65c4f() == 32));
}
function $d32e2ce054bf2ce0$export$c889f2fcc19dbf12(type) {
    while($d32e2ce054bf2ce0$export$48cfd1e771a65c4f())switch($d32e2ce054bf2ce0$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $d32e2ce054bf2ce0$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $d32e2ce054bf2ce0$export$c889f2fcc19dbf12($d32e2ce054bf2ce0$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $d32e2ce054bf2ce0$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $d32e2ce054bf2ce0$export$48cfd1e771a65c4f();
            break;
    }
    return $d32e2ce054bf2ce0$export$5880b8b5730aff45;
}
function $d32e2ce054bf2ce0$export$4254d4e2b3745c4c(type, index) {
    while($d32e2ce054bf2ce0$export$48cfd1e771a65c4f())// //
    if (type + $d32e2ce054bf2ce0$export$c0306caf338ac095 === 57) break;
    else if (type + $d32e2ce054bf2ce0$export$c0306caf338ac095 === 84 && $d32e2ce054bf2ce0$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $d32e2ce054bf2ce0$export$58adb3bec8346d0f(index, $d32e2ce054bf2ce0$export$5880b8b5730aff45 - 1) + '*' + (0, $3L5mc.from)(type === 47 ? type : $d32e2ce054bf2ce0$export$48cfd1e771a65c4f());
}
function $d32e2ce054bf2ce0$export$c2ab62c7bf24634(index) {
    while(!$d32e2ce054bf2ce0$export$9e1725a4cfeada27($d32e2ce054bf2ce0$export$4d3fb11e950abb9e()))$d32e2ce054bf2ce0$export$48cfd1e771a65c4f();
    return $d32e2ce054bf2ce0$export$58adb3bec8346d0f(index, $d32e2ce054bf2ce0$export$5880b8b5730aff45);
}

});
parcelRegister("3L5mc", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $2bc9eaae458a6717$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "from", function () { return $2bc9eaae458a6717$export$6788812c4e6611e6; });
$parcel$export(module.exports, "assign", function () { return $2bc9eaae458a6717$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "hash", function () { return $2bc9eaae458a6717$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $2bc9eaae458a6717$export$a9db5e087081082d; });
$parcel$export(module.exports, "trim", function () { return $2bc9eaae458a6717$export$87c2784dc9fc4ab; });
$parcel$export(module.exports, "match", function () { return $2bc9eaae458a6717$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $2bc9eaae458a6717$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $2bc9eaae458a6717$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "substr", function () { return $2bc9eaae458a6717$export$2f35ab04d2335697; });
$parcel$export(module.exports, "strlen", function () { return $2bc9eaae458a6717$export$36776f635604f274; });
$parcel$export(module.exports, "sizeof", function () { return $2bc9eaae458a6717$export$f9084667e487ed46; });
$parcel$export(module.exports, "append", function () { return $2bc9eaae458a6717$export$10d8903dec122b9d; });
$parcel$export(module.exports, "combine", function () { return $2bc9eaae458a6717$export$1be1fc439b849fdf; });
/**
 * @param {number}
 * @return {number}
 */ var $2bc9eaae458a6717$export$2335f513bbd82c6d = Math.abs;
var $2bc9eaae458a6717$export$6788812c4e6611e6 = String.fromCharCode;
var $2bc9eaae458a6717$export$e6e34fd1f2686227 = Object.assign;
function $2bc9eaae458a6717$export$d6af199866bfb566(value, length) {
    return $2bc9eaae458a6717$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $2bc9eaae458a6717$export$a9db5e087081082d(value, 0)) << 2 ^ $2bc9eaae458a6717$export$a9db5e087081082d(value, 1)) << 2 ^ $2bc9eaae458a6717$export$a9db5e087081082d(value, 2)) << 2 ^ $2bc9eaae458a6717$export$a9db5e087081082d(value, 3) : 0;
}
function $2bc9eaae458a6717$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $2bc9eaae458a6717$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $2bc9eaae458a6717$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $2bc9eaae458a6717$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $2bc9eaae458a6717$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $2bc9eaae458a6717$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $2bc9eaae458a6717$export$36776f635604f274(value) {
    return value.length;
}
function $2bc9eaae458a6717$export$f9084667e487ed46(value) {
    return value.length;
}
function $2bc9eaae458a6717$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $2bc9eaae458a6717$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("9Y0t9", function(module, exports) {

$parcel$export(module.exports, "compile", function () { return $741a14cd5b9fa122$export$ef7acd7185315e22; });

var $lWghZ = parcelRequire("lWghZ");

var $3L5mc = parcelRequire("3L5mc");

var $i86HN = parcelRequire("i86HN");
function $741a14cd5b9fa122$export$ef7acd7185315e22(value) {
    return (0, $i86HN.dealloc)($741a14cd5b9fa122$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $i86HN.alloc)(value), 0, [
        0
    ], value));
}
function $741a14cd5b9fa122$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $i86HN.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $3L5mc.charat)(characters, length - 1) == 58) {
                if ((0, $3L5mc.indexof)(characters += (0, $3L5mc.replace)((0, $i86HN.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $i86HN.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $i86HN.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $i86HN.escaping)((0, $i86HN.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $i86HN.peek)()){
                case 42:
                case 47:
                    (0, $3L5mc.append)($741a14cd5b9fa122$export$4a34f930e789283c((0, $i86HN.commenter)((0, $i86HN.next)(), (0, $i86HN.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $3L5mc.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $3L5mc.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $3L5mc.strlen)(characters) - length) (0, $3L5mc.append)(property > 32 ? $741a14cd5b9fa122$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $741a14cd5b9fa122$export$f8483753829ec8f3((0, $3L5mc.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $3L5mc.append)(reference = $741a14cd5b9fa122$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $741a14cd5b9fa122$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $3L5mc.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $741a14cd5b9fa122$export$98e6a39c04603d36(value, reference, reference, rule && (0, $3L5mc.append)($741a14cd5b9fa122$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $741a14cd5b9fa122$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $3L5mc.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $i86HN.prev)() == 125) continue;
            }
            switch(characters += (0, $3L5mc.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $3L5mc.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $i86HN.peek)() === 45) characters += (0, $i86HN.delimit)((0, $i86HN.next)());
                    atrule = (0, $i86HN.peek)(), offset = length = (0, $3L5mc.strlen)(type = characters += (0, $i86HN.identifier)((0, $i86HN.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $3L5mc.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $741a14cd5b9fa122$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $3L5mc.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $3L5mc.substr)(value, post + 1, post = (0, $3L5mc.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $3L5mc.trim)(j > 0 ? rule[x] + ' ' + y : (0, $3L5mc.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $i86HN.node)(value, root, parent, offset === 0 ? (0, $lWghZ.RULESET) : type, props, children, length);
}
function $741a14cd5b9fa122$export$4a34f930e789283c(value, root, parent) {
    return (0, $i86HN.node)(value, root, parent, (0, $lWghZ.COMMENT), (0, $3L5mc.from)((0, $i86HN.char)()), (0, $3L5mc.substr)(value, 2, -2), 0);
}
function $741a14cd5b9fa122$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $i86HN.node)(value, root, parent, (0, $lWghZ.DECLARATION), (0, $3L5mc.substr)(value, 0, length), (0, $3L5mc.substr)(value, length + 1, -1), length);
}

});
parcelRegister("lWghZ", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $ff8ba67655898214$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $ff8ba67655898214$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $ff8ba67655898214$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "COMMENT", function () { return $ff8ba67655898214$export$a29989082612d0d9; });
$parcel$export(module.exports, "RULESET", function () { return $ff8ba67655898214$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $ff8ba67655898214$export$527d108ccf083c2b; });
$parcel$export(module.exports, "IMPORT", function () { return $ff8ba67655898214$export$a763edbf796b780a; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $ff8ba67655898214$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "LAYER", function () { return $ff8ba67655898214$export$d773506282b3cfe6; });
var $ff8ba67655898214$export$71ad59f2e432cfe8 = '-ms-';
var $ff8ba67655898214$export$2c0f367103c8d01c = '-moz-';
var $ff8ba67655898214$export$39dfd62a25e0fe93 = '-webkit-';
var $ff8ba67655898214$export$a29989082612d0d9 = 'comm';
var $ff8ba67655898214$export$aa3a2e812ca8570d = 'rule';
var $ff8ba67655898214$export$527d108ccf083c2b = 'decl';
var $ff8ba67655898214$export$d3d35020fa5b54f0 = '@page';
var $ff8ba67655898214$export$500415a86c544f73 = '@media';
var $ff8ba67655898214$export$a763edbf796b780a = '@import';
var $ff8ba67655898214$export$2790aeb8b4e5c826 = '@charset';
var $ff8ba67655898214$export$1cc683e23b84b133 = '@viewport';
var $ff8ba67655898214$export$9447a5efea57e862 = '@supports';
var $ff8ba67655898214$export$ef011b4e114b1fba = '@document';
var $ff8ba67655898214$export$6aad947bda0f3f46 = '@namespace';
var $ff8ba67655898214$export$b44a8529a35fcb60 = '@keyframes';
var $ff8ba67655898214$export$2c16de31893252e6 = '@font-face';
var $ff8ba67655898214$export$3d846dd52e150c6f = '@counter-style';
var $ff8ba67655898214$export$22314bfbb57653fe = '@font-feature-values';
var $ff8ba67655898214$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("gVRIM", function(module, exports) {

$parcel$export(module.exports, "middleware", function () { return $c53ba4246fdccd34$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $c53ba4246fdccd34$export$38bcb760f1d4871c; });

var $lWghZ = parcelRequire("lWghZ");

var $3L5mc = parcelRequire("3L5mc");

var $i86HN = parcelRequire("i86HN");

var $hXIOf = parcelRequire("hXIOf");

var $9poig = parcelRequire("9poig");
function $c53ba4246fdccd34$export$5a7767152ae0305f(collection) {
    var length = (0, $3L5mc.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $c53ba4246fdccd34$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $c53ba4246fdccd34$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $lWghZ.DECLARATION:
                element.return = (0, $9poig.prefix)(element.value, element.length, children);
                return;
            case 0, $lWghZ.KEYFRAMES:
                return (0, $hXIOf.serialize)([
                    (0, $i86HN.copy)(element, {
                        value: (0, $3L5mc.replace)(element.value, '@', '@' + (0, $lWghZ.WEBKIT))
                    })
                ], callback);
            case 0, $lWghZ.RULESET:
                if (element.length) return (0, $3L5mc.combine)(element.props, function(value) {
                    switch((0, $3L5mc.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $hXIOf.serialize)([
                                (0, $i86HN.copy)(element, {
                                    props: [
                                        (0, $3L5mc.replace)(value, /:(read-\w+)/, ':' + (0, $lWghZ.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $hXIOf.serialize)([
                                (0, $i86HN.copy)(element, {
                                    props: [
                                        (0, $3L5mc.replace)(value, /:(plac\w+)/, ':' + (0, $lWghZ.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $i86HN.copy)(element, {
                                    props: [
                                        (0, $3L5mc.replace)(value, /:(plac\w+)/, ':' + (0, $lWghZ.MOZ) + '$1')
                                    ]
                                }),
                                (0, $i86HN.copy)(element, {
                                    props: [
                                        (0, $3L5mc.replace)(value, /:(plac\w+)/, (0, $lWghZ.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $c53ba4246fdccd34$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $lWghZ.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $3L5mc.combine)((0, $i86HN.tokenize)(value), function(value, index, children) {
                    switch((0, $3L5mc.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $3L5mc.substr)(value, 1, (0, $3L5mc.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $3L5mc.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $3L5mc.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $3L5mc.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("hXIOf", function(module, exports) {

$parcel$export(module.exports, "serialize", function () { return $d13ab48f45351dbc$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $d13ab48f45351dbc$export$fac44ee5b035f737; });

var $lWghZ = parcelRequire("lWghZ");

var $3L5mc = parcelRequire("3L5mc");
function $d13ab48f45351dbc$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $3L5mc.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $d13ab48f45351dbc$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $lWghZ.LAYER:
            if (element.children.length) break;
        case 0, $lWghZ.IMPORT:
        case 0, $lWghZ.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $lWghZ.COMMENT:
            return '';
        case 0, $lWghZ.KEYFRAMES:
            return element.return = element.value + '{' + $d13ab48f45351dbc$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $lWghZ.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $3L5mc.strlen)(children = $d13ab48f45351dbc$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("9poig", function(module, exports) {

$parcel$export(module.exports, "prefix", function () { return $6d994b11fbe0a4e8$export$82e9f45cca5ba907; });

var $lWghZ = parcelRequire("lWghZ");

var $3L5mc = parcelRequire("3L5mc");
function $6d994b11fbe0a4e8$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $3L5mc.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $lWghZ.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $lWghZ.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $lWghZ.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MOZ) + value + (0, $lWghZ.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $3L5mc.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + value + value;
        // order
        case 6165:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $lWghZ.WEBKIT) + value + (0, $3L5mc.replace)(value, /(\w+).+(:[^]+)/, (0, $lWghZ.WEBKIT) + 'box-$1$2' + (0, $lWghZ.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + 'flex-item-' + (0, $3L5mc.replace)(value, /flex-|-self/g, '') + (!(0, $3L5mc.match)(value, /flex-|baseline/) ? (0, $lWghZ.MS) + 'grid-row-' + (0, $3L5mc.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + 'flex-line-pack' + (0, $3L5mc.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $lWghZ.WEBKIT) + 'box-' + (0, $3L5mc.replace)(value, '-grow', '') + (0, $lWghZ.WEBKIT) + value + (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $lWghZ.WEBKIT) + (0, $3L5mc.replace)(value, /([^-])(transform)/g, '$1' + (0, $lWghZ.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $3L5mc.replace)((0, $3L5mc.replace)((0, $3L5mc.replace)(value, /(zoom-|grab)/, (0, $lWghZ.WEBKIT) + '$1'), /(image-set)/, (0, $lWghZ.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $3L5mc.replace)(value, /(image-set\([^]*)/, (0, $lWghZ.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $3L5mc.replace)((0, $3L5mc.replace)(value, /(.+:)(flex-)?(.*)/, (0, $lWghZ.WEBKIT) + 'box-pack:$3' + (0, $lWghZ.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $lWghZ.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $3L5mc.match)(value, /flex-|baseline/)) return (0, $lWghZ.MS) + 'grid-column-align' + (0, $3L5mc.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $3L5mc.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $3L5mc.indexof)(value + (children = children[length].value), 'span') ? value : (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, '-start', '') + value + (0, $lWghZ.MS) + 'grid-row-span:' + (~(0, $3L5mc.indexof)(children, 'span') ? (0, $3L5mc.match)(children, /\d+/) : +(0, $3L5mc.match)(children, /\d+/) - +(0, $3L5mc.match)(value, /\d+/)) + ';';
            return (0, $lWghZ.MS) + (0, $3L5mc.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $3L5mc.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $lWghZ.MS) + (0, $3L5mc.replace)((0, $3L5mc.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $3L5mc.replace)(value, /(.+)-inline(.+)/, (0, $lWghZ.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $3L5mc.strlen)(value) - 1 - length > 6) switch((0, $3L5mc.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $3L5mc.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $3L5mc.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $lWghZ.WEBKIT) + '$2-$3' + '$1' + (0, $lWghZ.MOZ) + ((0, $3L5mc.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $3L5mc.indexof)(value, 'stretch') ? $6d994b11fbe0a4e8$export$82e9f45cca5ba907((0, $3L5mc.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $3L5mc.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $lWghZ.MS) + a + ':' + b + f + (c ? (0, $lWghZ.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $3L5mc.charat)(value, length + 6) === 121) return (0, $3L5mc.replace)(value, ':', ':' + (0, $lWghZ.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $3L5mc.charat)(value, (0, $3L5mc.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $3L5mc.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $lWghZ.WEBKIT) + ((0, $3L5mc.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $lWghZ.WEBKIT) + '$2$3' + '$1' + (0, $lWghZ.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $3L5mc.replace)(value, ':', ':' + (0, $lWghZ.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $3L5mc.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("ayVFI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b09d0c88fd5bd74$export$2e2bcd8739ae039; });
var $7b09d0c88fd5bd74$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("65JfS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46f650713161908d$export$2e2bcd8739ae039; });
function $46f650713161908d$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("jamvR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df406a0f8c8c59f0$export$2e2bcd8739ae039; });
function $df406a0f8c8c59f0$export$2e2bcd8739ae039() {
    return $df406a0f8c8c59f0$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $df406a0f8c8c59f0$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("fkn0h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b28a914ec96b6efc$export$2e2bcd8739ae039; });

var $4o8qq = parcelRequire("4o8qq");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $b28a914ec96b6efc$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4o8qq)))(targetComponent, sourceComponent);
};

});
parcelRegister("4o8qq", function(module, exports) {
'use strict';

var $gXuPf = parcelRequire("gXuPf");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $331ff06918b848b8$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $331ff06918b848b8$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $331ff06918b848b8$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $331ff06918b848b8$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $331ff06918b848b8$var$TYPE_STATICS = {};
$331ff06918b848b8$var$TYPE_STATICS[$gXuPf.ForwardRef] = $331ff06918b848b8$var$FORWARD_REF_STATICS;
$331ff06918b848b8$var$TYPE_STATICS[$gXuPf.Memo] = $331ff06918b848b8$var$MEMO_STATICS;
function $331ff06918b848b8$var$getStatics(component) {
    // React v16.11 and below
    if ($gXuPf.isMemo(component)) return $331ff06918b848b8$var$MEMO_STATICS;
     // React v16.12 and above
    return $331ff06918b848b8$var$TYPE_STATICS[component['$$typeof']] || $331ff06918b848b8$var$REACT_STATICS;
}
var $331ff06918b848b8$var$defineProperty = Object.defineProperty;
var $331ff06918b848b8$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $331ff06918b848b8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $331ff06918b848b8$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $331ff06918b848b8$var$getPrototypeOf = Object.getPrototypeOf;
var $331ff06918b848b8$var$objectPrototype = Object.prototype;
function $331ff06918b848b8$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($331ff06918b848b8$var$objectPrototype) {
            var inheritedComponent = $331ff06918b848b8$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $331ff06918b848b8$var$objectPrototype) $331ff06918b848b8$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $331ff06918b848b8$var$getOwnPropertyNames(sourceComponent);
        if ($331ff06918b848b8$var$getOwnPropertySymbols) keys = keys.concat($331ff06918b848b8$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $331ff06918b848b8$var$getStatics(targetComponent);
        var sourceStatics = $331ff06918b848b8$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$331ff06918b848b8$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $331ff06918b848b8$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $331ff06918b848b8$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $331ff06918b848b8$var$hoistNonReactStatics;

});
parcelRegister("gXuPf", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kvfmP"));

});
parcelRegister("kvfmP", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $eed29f7c106d1213$export$2b8d127b894957b9; }, function (v) { return $eed29f7c106d1213$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $eed29f7c106d1213$export$cea3a54a6425200c; }, function (v) { return $eed29f7c106d1213$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $eed29f7c106d1213$export$a7c73072b1a182ae; }, function (v) { return $eed29f7c106d1213$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $eed29f7c106d1213$export$9f27bc3417b4524d; }, function (v) { return $eed29f7c106d1213$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $eed29f7c106d1213$export$db77ccec0bb4ccac; }, function (v) { return $eed29f7c106d1213$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $eed29f7c106d1213$export$8392c0c9d3dcbd35; }, function (v) { return $eed29f7c106d1213$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $eed29f7c106d1213$export$ffb0004e005737fa; }, function (v) { return $eed29f7c106d1213$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $eed29f7c106d1213$export$b624eff549462981; }, function (v) { return $eed29f7c106d1213$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $eed29f7c106d1213$export$7897aa7841a5380c; }, function (v) { return $eed29f7c106d1213$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $eed29f7c106d1213$export$602eac185826482c; }, function (v) { return $eed29f7c106d1213$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $eed29f7c106d1213$export$e2c29f18771995cb; }, function (v) { return $eed29f7c106d1213$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $eed29f7c106d1213$export$5f8d39834fd61797; }, function (v) { return $eed29f7c106d1213$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $eed29f7c106d1213$export$74bf444e3cd11ea5; }, function (v) { return $eed29f7c106d1213$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $eed29f7c106d1213$export$92387174baf9b227; }, function (v) { return $eed29f7c106d1213$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $eed29f7c106d1213$export$ec112efeb987d9c6; }, function (v) { return $eed29f7c106d1213$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $eed29f7c106d1213$export$b706b080d889d2c9; }, function (v) { return $eed29f7c106d1213$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $eed29f7c106d1213$export$5be5a87408f70ddc; }, function (v) { return $eed29f7c106d1213$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $eed29f7c106d1213$export$45a5e7f76e0caa8d; }, function (v) { return $eed29f7c106d1213$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $eed29f7c106d1213$export$455c2e768291efa6; }, function (v) { return $eed29f7c106d1213$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $eed29f7c106d1213$export$9522e17588c12572; }, function (v) { return $eed29f7c106d1213$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $eed29f7c106d1213$export$2110ac352bb060b9; }, function (v) { return $eed29f7c106d1213$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $eed29f7c106d1213$export$56885ab8b9c456ab; }, function (v) { return $eed29f7c106d1213$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $eed29f7c106d1213$export$d927fcb6adf8f9de; }, function (v) { return $eed29f7c106d1213$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $eed29f7c106d1213$export$b82d16f27459e05a; }, function (v) { return $eed29f7c106d1213$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $eed29f7c106d1213$export$522c17b4f5e123e8; }, function (v) { return $eed29f7c106d1213$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $eed29f7c106d1213$export$1aabd8a0274ecfd6; }, function (v) { return $eed29f7c106d1213$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $eed29f7c106d1213$export$9b621391a187a31a; }, function (v) { return $eed29f7c106d1213$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $eed29f7c106d1213$export$f5bbd400c2f4426f; }, function (v) { return $eed29f7c106d1213$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eed29f7c106d1213$export$2b8d127b894957b9;
var $eed29f7c106d1213$export$cea3a54a6425200c;
var $eed29f7c106d1213$export$a7c73072b1a182ae;
var $eed29f7c106d1213$export$9f27bc3417b4524d;
var $eed29f7c106d1213$export$db77ccec0bb4ccac;
var $eed29f7c106d1213$export$8392c0c9d3dcbd35;
var $eed29f7c106d1213$export$ffb0004e005737fa;
var $eed29f7c106d1213$export$b624eff549462981;
var $eed29f7c106d1213$export$7897aa7841a5380c;
var $eed29f7c106d1213$export$602eac185826482c;
var $eed29f7c106d1213$export$e2c29f18771995cb;
var $eed29f7c106d1213$export$5f8d39834fd61797;
var $eed29f7c106d1213$export$74bf444e3cd11ea5;
var $eed29f7c106d1213$export$92387174baf9b227;
var $eed29f7c106d1213$export$ec112efeb987d9c6;
var $eed29f7c106d1213$export$b706b080d889d2c9;
var $eed29f7c106d1213$export$5be5a87408f70ddc;
var $eed29f7c106d1213$export$45a5e7f76e0caa8d;
var $eed29f7c106d1213$export$455c2e768291efa6;
var $eed29f7c106d1213$export$9522e17588c12572;
var $eed29f7c106d1213$export$2110ac352bb060b9;
var $eed29f7c106d1213$export$56885ab8b9c456ab;
var $eed29f7c106d1213$export$d927fcb6adf8f9de;
var $eed29f7c106d1213$export$b82d16f27459e05a;
var $eed29f7c106d1213$export$522c17b4f5e123e8;
var $eed29f7c106d1213$export$1aabd8a0274ecfd6;
var $eed29f7c106d1213$export$9b621391a187a31a;
var $eed29f7c106d1213$export$f5bbd400c2f4426f;
'use strict';
var $eed29f7c106d1213$var$b = "function" === typeof Symbol && Symbol.for, $eed29f7c106d1213$var$c = $eed29f7c106d1213$var$b ? Symbol.for("react.element") : 60103, $eed29f7c106d1213$var$d = $eed29f7c106d1213$var$b ? Symbol.for("react.portal") : 60106, $eed29f7c106d1213$var$e = $eed29f7c106d1213$var$b ? Symbol.for("react.fragment") : 60107, $eed29f7c106d1213$var$f = $eed29f7c106d1213$var$b ? Symbol.for("react.strict_mode") : 60108, $eed29f7c106d1213$var$g = $eed29f7c106d1213$var$b ? Symbol.for("react.profiler") : 60114, $eed29f7c106d1213$var$h = $eed29f7c106d1213$var$b ? Symbol.for("react.provider") : 60109, $eed29f7c106d1213$var$k = $eed29f7c106d1213$var$b ? Symbol.for("react.context") : 60110, $eed29f7c106d1213$var$l = $eed29f7c106d1213$var$b ? Symbol.for("react.async_mode") : 60111, $eed29f7c106d1213$var$m = $eed29f7c106d1213$var$b ? Symbol.for("react.concurrent_mode") : 60111, $eed29f7c106d1213$var$n = $eed29f7c106d1213$var$b ? Symbol.for("react.forward_ref") : 60112, $eed29f7c106d1213$var$p = $eed29f7c106d1213$var$b ? Symbol.for("react.suspense") : 60113, $eed29f7c106d1213$var$q = $eed29f7c106d1213$var$b ? Symbol.for("react.suspense_list") : 60120, $eed29f7c106d1213$var$r = $eed29f7c106d1213$var$b ? Symbol.for("react.memo") : 60115, $eed29f7c106d1213$var$t = $eed29f7c106d1213$var$b ? Symbol.for("react.lazy") : 60116, $eed29f7c106d1213$var$v = $eed29f7c106d1213$var$b ? Symbol.for("react.block") : 60121, $eed29f7c106d1213$var$w = $eed29f7c106d1213$var$b ? Symbol.for("react.fundamental") : 60117, $eed29f7c106d1213$var$x = $eed29f7c106d1213$var$b ? Symbol.for("react.responder") : 60118, $eed29f7c106d1213$var$y = $eed29f7c106d1213$var$b ? Symbol.for("react.scope") : 60119;
function $eed29f7c106d1213$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $eed29f7c106d1213$var$c:
                switch(a = a.type, a){
                    case $eed29f7c106d1213$var$l:
                    case $eed29f7c106d1213$var$m:
                    case $eed29f7c106d1213$var$e:
                    case $eed29f7c106d1213$var$g:
                    case $eed29f7c106d1213$var$f:
                    case $eed29f7c106d1213$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $eed29f7c106d1213$var$k:
                            case $eed29f7c106d1213$var$n:
                            case $eed29f7c106d1213$var$t:
                            case $eed29f7c106d1213$var$r:
                            case $eed29f7c106d1213$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $eed29f7c106d1213$var$d:
                return u;
        }
    }
}
function $eed29f7c106d1213$var$A(a) {
    return $eed29f7c106d1213$var$z(a) === $eed29f7c106d1213$var$m;
}
$eed29f7c106d1213$export$2b8d127b894957b9 = $eed29f7c106d1213$var$l;
$eed29f7c106d1213$export$cea3a54a6425200c = $eed29f7c106d1213$var$m;
$eed29f7c106d1213$export$a7c73072b1a182ae = $eed29f7c106d1213$var$k;
$eed29f7c106d1213$export$9f27bc3417b4524d = $eed29f7c106d1213$var$h;
$eed29f7c106d1213$export$db77ccec0bb4ccac = $eed29f7c106d1213$var$c;
$eed29f7c106d1213$export$8392c0c9d3dcbd35 = $eed29f7c106d1213$var$n;
$eed29f7c106d1213$export$ffb0004e005737fa = $eed29f7c106d1213$var$e;
$eed29f7c106d1213$export$b624eff549462981 = $eed29f7c106d1213$var$t;
$eed29f7c106d1213$export$7897aa7841a5380c = $eed29f7c106d1213$var$r;
$eed29f7c106d1213$export$602eac185826482c = $eed29f7c106d1213$var$d;
$eed29f7c106d1213$export$e2c29f18771995cb = $eed29f7c106d1213$var$g;
$eed29f7c106d1213$export$5f8d39834fd61797 = $eed29f7c106d1213$var$f;
$eed29f7c106d1213$export$74bf444e3cd11ea5 = $eed29f7c106d1213$var$p;
$eed29f7c106d1213$export$92387174baf9b227 = function(a) {
    return $eed29f7c106d1213$var$A(a) || $eed29f7c106d1213$var$z(a) === $eed29f7c106d1213$var$l;
};
$eed29f7c106d1213$export$ec112efeb987d9c6 = $eed29f7c106d1213$var$A;
$eed29f7c106d1213$export$b706b080d889d2c9 = function(a) {
    return $eed29f7c106d1213$var$z(a) === $eed29f7c106d1213$var$k;
};
$eed29f7c106d1213$export$5be5a87408f70ddc = function(a) {
    return $eed29f7c106d1213$var$z(a) === $eed29f7c106d1213$var$h;
};
$eed29f7c106d1213$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $eed29f7c106d1213$var$c;
};
$eed29f7c106d1213$export$455c2e768291efa6 = function(a) {
    return $eed29f7c106d1213$var$z(a) === $eed29f7c106d1213$var$n;
};
$eed29f7c106d1213$export$9522e17588c12572 = function(a) {
    return $eed29f7c106d1213$var$z(a) === $eed29f7c106d1213$var$e;
};
$eed29f7c106d1213$export$2110ac352bb060b9 = function(a) {
    return $eed29f7c106d1213$var$z(a) === $eed29f7c106d1213$var$t;
};
$eed29f7c106d1213$export$56885ab8b9c456ab = function(a) {
    return $eed29f7c106d1213$var$z(a) === $eed29f7c106d1213$var$r;
};
$eed29f7c106d1213$export$d927fcb6adf8f9de = function(a) {
    return $eed29f7c106d1213$var$z(a) === $eed29f7c106d1213$var$d;
};
$eed29f7c106d1213$export$b82d16f27459e05a = function(a) {
    return $eed29f7c106d1213$var$z(a) === $eed29f7c106d1213$var$g;
};
$eed29f7c106d1213$export$522c17b4f5e123e8 = function(a) {
    return $eed29f7c106d1213$var$z(a) === $eed29f7c106d1213$var$f;
};
$eed29f7c106d1213$export$1aabd8a0274ecfd6 = function(a) {
    return $eed29f7c106d1213$var$z(a) === $eed29f7c106d1213$var$p;
};
$eed29f7c106d1213$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $eed29f7c106d1213$var$e || a === $eed29f7c106d1213$var$m || a === $eed29f7c106d1213$var$g || a === $eed29f7c106d1213$var$f || a === $eed29f7c106d1213$var$p || a === $eed29f7c106d1213$var$q || "object" === typeof a && null !== a && (a.$$typeof === $eed29f7c106d1213$var$t || a.$$typeof === $eed29f7c106d1213$var$r || a.$$typeof === $eed29f7c106d1213$var$h || a.$$typeof === $eed29f7c106d1213$var$k || a.$$typeof === $eed29f7c106d1213$var$n || a.$$typeof === $eed29f7c106d1213$var$w || a.$$typeof === $eed29f7c106d1213$var$x || a.$$typeof === $eed29f7c106d1213$var$y || a.$$typeof === $eed29f7c106d1213$var$v);
};
$eed29f7c106d1213$export$f5bbd400c2f4426f = $eed29f7c106d1213$var$z;

});




parcelRegister("b21vB", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $80810d355f813c9b$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $80810d355f813c9b$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $80810d355f813c9b$export$6f077d94b33a01aa; });
var $80810d355f813c9b$var$isBrowser = true;
function $80810d355f813c9b$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $80810d355f813c9b$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $80810d355f813c9b$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $80810d355f813c9b$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $80810d355f813c9b$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("iJWIa", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $da49f8cb66baab11$export$6321afa313b251b5; });

var $jFcbH = parcelRequire("jFcbH");

var $4RA0X = parcelRequire("4RA0X");

var $65JfS = parcelRequire("65JfS");
var $da49f8cb66baab11$var$isDevelopment = false;
var $da49f8cb66baab11$var$hyphenateRegex = /[A-Z]|^ms/g;
var $da49f8cb66baab11$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $da49f8cb66baab11$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $da49f8cb66baab11$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $da49f8cb66baab11$var$processStyleName = /* #__PURE__ */ (0, $65JfS.default)(function(styleName) {
    return $da49f8cb66baab11$var$isCustomProperty(styleName) ? styleName : styleName.replace($da49f8cb66baab11$var$hyphenateRegex, '-$&').toLowerCase();
});
var $da49f8cb66baab11$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($da49f8cb66baab11$var$animationRegex, function(match, p1, p2) {
                $da49f8cb66baab11$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $da49f8cb66baab11$var$cursor
                };
                return p1;
            });
    }
    if ((0, $4RA0X.default)[key] !== 1 && !$da49f8cb66baab11$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $da49f8cb66baab11$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $da49f8cb66baab11$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $da49f8cb66baab11$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $da49f8cb66baab11$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $da49f8cb66baab11$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $da49f8cb66baab11$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $da49f8cb66baab11$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $da49f8cb66baab11$var$cursor;
                var result = interpolation(mergedProps);
                $da49f8cb66baab11$var$cursor = previousCursor;
                return $da49f8cb66baab11$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $da49f8cb66baab11$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $da49f8cb66baab11$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($da49f8cb66baab11$var$isProcessableValue(asString)) string += $da49f8cb66baab11$var$processStyleName(key) + ":" + $da49f8cb66baab11$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $da49f8cb66baab11$var$isDevelopment) throw new Error($da49f8cb66baab11$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($da49f8cb66baab11$var$isProcessableValue(value[_i])) string += $da49f8cb66baab11$var$processStyleName(key) + ":" + $da49f8cb66baab11$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $da49f8cb66baab11$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $da49f8cb66baab11$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $da49f8cb66baab11$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $da49f8cb66baab11$var$cursor;
function $da49f8cb66baab11$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $da49f8cb66baab11$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $da49f8cb66baab11$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $da49f8cb66baab11$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $da49f8cb66baab11$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $da49f8cb66baab11$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $jFcbH.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $da49f8cb66baab11$var$cursor
    };
}

});
parcelRegister("jFcbH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e50b4ce6fc131456$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $e50b4ce6fc131456$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("4RA0X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38a80c67461cb36f$export$2e2bcd8739ae039; });
var $38a80c67461cb36f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("9ezTb", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $6b9142ae5d741421$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $6b9142ae5d741421$export$811a713a7276cb9d; });

var $7hhBq = parcelRequire("7hhBq");
var $6b9142ae5d741421$var$syncFallback = function syncFallback(create) {
    return create();
};
var $6b9142ae5d741421$var$useInsertionEffect = $7hhBq.useInsertionEffect ? $7hhBq.useInsertionEffect : false;
var $6b9142ae5d741421$export$db21c7ffa21794e7 = $6b9142ae5d741421$var$useInsertionEffect || $6b9142ae5d741421$var$syncFallback;
var $6b9142ae5d741421$export$811a713a7276cb9d = $6b9142ae5d741421$var$useInsertionEffect || $7hhBq.useLayoutEffect;

});





parcelRegister("aaaIb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $766325aaa9ea36a9$export$2e2bcd8739ae039; });

var $f5flw = parcelRequire("f5flw");
'use client';
const $766325aaa9ea36a9$var$defaultTheme = (0, $f5flw.default)();
var $766325aaa9ea36a9$export$2e2bcd8739ae039 = $766325aaa9ea36a9$var$defaultTheme;

});
parcelRegister("f5flw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afb33a0ecf35316b$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $UfwTM = parcelRequire("UfwTM");

var $luE6b = parcelRequire("luE6b");

var $ii535 = parcelRequire("ii535");
// eslint-disable-next-line consistent-return
function $afb33a0ecf35316b$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = (0, $cNnl8._)((0, $dok7x._)({}, colorScheme !== true && colorScheme), {
        palette: (0, $UfwTM.default)((0, $cNnl8._)((0, $dok7x._)({}, colorScheme === true ? {} : colorScheme.palette), {
            mode: scheme
        })) // cast type to skip module augmentation test
    });
}
function $afb33a0ecf35316b$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette === null || palette === void 0 ? void 0 : palette.mode } = options, rest = (0, $6pkKu._)(options, [
        "palette",
        "cssVariables",
        "colorSchemes",
        "defaultColorScheme"
    ]);
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes === null || initialColorSchemes === void 0 ? void 0 : initialColorSchemes[defaultColorSchemeInput];
    const colorSchemesInput = (0, $dok7x._)({}, initialColorSchemes, palette ? {
        [defaultColorSchemeInput]: (0, $cNnl8._)((0, $dok7x._)({}, typeof defaultScheme !== 'boolean' && defaultScheme), {
            palette: palette
        })
    } : undefined);
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $ii535.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $ii535.default)((0, $cNnl8._)((0, $dok7x._)({}, options), {
            palette: paletteOptions
        }), ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = (0, $cNnl8._)((0, $dok7x._)({}, colorSchemesInput.light !== true && colorSchemesInput.light), {
                palette: theme.palette
            });
            $afb33a0ecf35316b$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = (0, $cNnl8._)((0, $dok7x._)({}, colorSchemesInput.dark !== true && colorSchemesInput.dark), {
                palette: theme.palette
            });
            $afb33a0ecf35316b$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $luE6b.default)((0, $dok7x._)((0, $cNnl8._)((0, $dok7x._)({}, rest), {
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput
    }), typeof cssVariables !== 'boolean' && cssVariables), ...args);
}

});
parcelRegister("UfwTM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a9146efeb243616$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $6pkKu = parcelRequire("6pkKu");

var $iJT96 = parcelRequire("iJT96");

var $f6ZlQ = parcelRequire("f6ZlQ");

var $cqwHw = parcelRequire("cqwHw");

var $6GsAi = parcelRequire("6GsAi");

var $ixYiN = parcelRequire("ixYiN");

var $9rn0V = parcelRequire("9rn0V");

var $1U7MY = parcelRequire("1U7MY");

var $2Vq6p = parcelRequire("2Vq6p");

var $aHV2E = parcelRequire("aHV2E");

var $8yRmJ = parcelRequire("8yRmJ");

var $69E9b = parcelRequire("69E9b");
function $0a9146efeb243616$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $6GsAi.default).white,
            default: (0, $6GsAi.default).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $0a9146efeb243616$export$a43af521ac8c3202 = $0a9146efeb243616$var$getLight();
function $0a9146efeb243616$var$getDark() {
    return {
        text: {
            primary: (0, $6GsAi.default).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $6GsAi.default).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $0a9146efeb243616$export$55ce6f3a06c59543 = $0a9146efeb243616$var$getDark();
function $0a9146efeb243616$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $cqwHw.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $cqwHw.darken)(intent.main, tonalOffsetDark);
    }
}
function $0a9146efeb243616$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $aHV2E.default)[200],
        light: (0, $aHV2E.default)[50],
        dark: (0, $aHV2E.default)[400]
    };
    return {
        main: (0, $aHV2E.default)[700],
        light: (0, $aHV2E.default)[400],
        dark: (0, $aHV2E.default)[800]
    };
}
function $0a9146efeb243616$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9rn0V.default)[200],
        light: (0, $9rn0V.default)[50],
        dark: (0, $9rn0V.default)[400]
    };
    return {
        main: (0, $9rn0V.default)[500],
        light: (0, $9rn0V.default)[300],
        dark: (0, $9rn0V.default)[700]
    };
}
function $0a9146efeb243616$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $1U7MY.default)[500],
        light: (0, $1U7MY.default)[300],
        dark: (0, $1U7MY.default)[700]
    };
    return {
        main: (0, $1U7MY.default)[700],
        light: (0, $1U7MY.default)[400],
        dark: (0, $1U7MY.default)[800]
    };
}
function $0a9146efeb243616$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $8yRmJ.default)[400],
        light: (0, $8yRmJ.default)[300],
        dark: (0, $8yRmJ.default)[700]
    };
    return {
        main: (0, $8yRmJ.default)[700],
        light: (0, $8yRmJ.default)[500],
        dark: (0, $8yRmJ.default)[900]
    };
}
function $0a9146efeb243616$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $69E9b.default)[400],
        light: (0, $69E9b.default)[300],
        dark: (0, $69E9b.default)[700]
    };
    return {
        main: (0, $69E9b.default)[800],
        light: (0, $69E9b.default)[500],
        dark: (0, $69E9b.default)[900]
    };
}
function $0a9146efeb243616$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $2Vq6p.default)[400],
        light: (0, $2Vq6p.default)[300],
        dark: (0, $2Vq6p.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $2Vq6p.default)[500],
        dark: (0, $2Vq6p.default)[900]
    };
}
function $0a9146efeb243616$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $6pkKu._)(palette, [
        "mode",
        "contrastThreshold",
        "tonalOffset"
    ]);
    const primary = palette.primary || $0a9146efeb243616$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $0a9146efeb243616$var$getDefaultSecondary(mode);
    const error = palette.error || $0a9146efeb243616$var$getDefaultError(mode);
    const info = palette.info || $0a9146efeb243616$var$getDefaultInfo(mode);
    const success = palette.success || $0a9146efeb243616$var$getDefaultSuccess(mode);
    const warning = palette.warning || $0a9146efeb243616$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $cqwHw.getContrastRatio)(background, $0a9146efeb243616$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $0a9146efeb243616$export$55ce6f3a06c59543.text.primary : $0a9146efeb243616$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $dok7x._)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $iJT96.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $iJT96.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $0a9146efeb243616$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $0a9146efeb243616$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $0a9146efeb243616$var$getLight();
    else if (mode === 'dark') modeHydrated = $0a9146efeb243616$var$getDark();
    const paletteOutput = (0, $f6ZlQ.default)((0, $dok7x._)({
        // A collection of common colors.
        common: (0, $dok7x._)({}, (0, $6GsAi.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $ixYiN.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modeHydrated), other);
    return paletteOutput;
}

});
parcelRegister("cqwHw", function(module, exports) {

$parcel$export(module.exports, "private_safeColorChannel", function () { return $90c1477daa3e7b48$export$427365fc3db6fc5e; });
$parcel$export(module.exports, "hslToRgb", function () { return $90c1477daa3e7b48$export$29fb7152bd3f781a; });
$parcel$export(module.exports, "getContrastRatio", function () { return $90c1477daa3e7b48$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $90c1477daa3e7b48$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "private_safeAlpha", function () { return $90c1477daa3e7b48$export$34109543fc7f43f8; });
$parcel$export(module.exports, "darken", function () { return $90c1477daa3e7b48$export$4b073707ff63303; });
$parcel$export(module.exports, "private_safeDarken", function () { return $90c1477daa3e7b48$export$eaaef2dca3e9e512; });
$parcel$export(module.exports, "lighten", function () { return $90c1477daa3e7b48$export$c0816ed86df316af; });
$parcel$export(module.exports, "private_safeLighten", function () { return $90c1477daa3e7b48$export$aeeda94ef1d01275; });
$parcel$export(module.exports, "private_safeEmphasize", function () { return $90c1477daa3e7b48$export$11bb74ba10c85505; });

var $iJT96 = parcelRequire("iJT96");

var $juiiy = parcelRequire("juiiy");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $90c1477daa3e7b48$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $juiiy.default)(value, min, max);
}
function $90c1477daa3e7b48$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $90c1477daa3e7b48$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $90c1477daa3e7b48$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $90c1477daa3e7b48$export$677b39864803984e($90c1477daa3e7b48$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $iJT96.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $iJT96.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $90c1477daa3e7b48$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $90c1477daa3e7b48$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $90c1477daa3e7b48$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $90c1477daa3e7b48$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $90c1477daa3e7b48$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $90c1477daa3e7b48$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $90c1477daa3e7b48$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$90c1477daa3e7b48$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $90c1477daa3e7b48$export$29fb7152bd3f781a(color) {
    color = $90c1477daa3e7b48$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $90c1477daa3e7b48$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $90c1477daa3e7b48$export$c852d90bf7403b62(color) {
    color = $90c1477daa3e7b48$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $90c1477daa3e7b48$export$677b39864803984e($90c1477daa3e7b48$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $90c1477daa3e7b48$export$d061e26956a60b0a(foreground, background) {
    const lumA = $90c1477daa3e7b48$export$c852d90bf7403b62(foreground);
    const lumB = $90c1477daa3e7b48$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $90c1477daa3e7b48$export$58f0f39f63f3cf42(color, value) {
    color = $90c1477daa3e7b48$export$677b39864803984e(color);
    value = $90c1477daa3e7b48$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $90c1477daa3e7b48$export$211a73f2b8c10ce4(color);
}
function $90c1477daa3e7b48$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $90c1477daa3e7b48$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $90c1477daa3e7b48$export$4b073707ff63303(color, coefficient) {
    color = $90c1477daa3e7b48$export$677b39864803984e(color);
    coefficient = $90c1477daa3e7b48$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $90c1477daa3e7b48$export$211a73f2b8c10ce4(color);
}
function $90c1477daa3e7b48$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $90c1477daa3e7b48$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $90c1477daa3e7b48$export$c0816ed86df316af(color, coefficient) {
    color = $90c1477daa3e7b48$export$677b39864803984e(color);
    coefficient = $90c1477daa3e7b48$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $90c1477daa3e7b48$export$211a73f2b8c10ce4(color);
}
function $90c1477daa3e7b48$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $90c1477daa3e7b48$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $90c1477daa3e7b48$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $90c1477daa3e7b48$export$c852d90bf7403b62(color) > 0.5 ? $90c1477daa3e7b48$export$4b073707ff63303(color, coefficient) : $90c1477daa3e7b48$export$c0816ed86df316af(color, coefficient);
}
function $90c1477daa3e7b48$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $90c1477daa3e7b48$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $90c1477daa3e7b48$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $90c1477daa3e7b48$export$677b39864803984e(background);
    const overlayColor = $90c1477daa3e7b48$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $90c1477daa3e7b48$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("juiiy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2ff0356656ad000$export$2e2bcd8739ae039; });
function $e2ff0356656ad000$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $e2ff0356656ad000$export$2e2bcd8739ae039 = $e2ff0356656ad000$var$clamp;

});


parcelRegister("6GsAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ddcd6950a6fd746$export$2e2bcd8739ae039; });
const $4ddcd6950a6fd746$var$common = {
    black: '#000',
    white: '#fff'
};
var $4ddcd6950a6fd746$export$2e2bcd8739ae039 = $4ddcd6950a6fd746$var$common;

});

parcelRegister("ixYiN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d80a15ce076eb775$export$2e2bcd8739ae039; });
const $d80a15ce076eb775$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $d80a15ce076eb775$export$2e2bcd8739ae039 = $d80a15ce076eb775$var$grey;

});

parcelRegister("9rn0V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6df87cc17834d1b2$export$2e2bcd8739ae039; });
const $6df87cc17834d1b2$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $6df87cc17834d1b2$export$2e2bcd8739ae039 = $6df87cc17834d1b2$var$purple;

});

parcelRegister("1U7MY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16311020d3140e26$export$2e2bcd8739ae039; });
const $16311020d3140e26$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $16311020d3140e26$export$2e2bcd8739ae039 = $16311020d3140e26$var$red;

});

parcelRegister("2Vq6p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2215270daef011e9$export$2e2bcd8739ae039; });
const $2215270daef011e9$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $2215270daef011e9$export$2e2bcd8739ae039 = $2215270daef011e9$var$orange;

});

parcelRegister("aHV2E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cba2adcfbc31047$export$2e2bcd8739ae039; });
const $7cba2adcfbc31047$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $7cba2adcfbc31047$export$2e2bcd8739ae039 = $7cba2adcfbc31047$var$blue;

});

parcelRegister("8yRmJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63bae50108006c87$export$2e2bcd8739ae039; });
const $63bae50108006c87$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $63bae50108006c87$export$2e2bcd8739ae039 = $63bae50108006c87$var$lightBlue;

});

parcelRegister("69E9b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47b2b9b64c542e20$export$2e2bcd8739ae039; });
const $47b2b9b64c542e20$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $47b2b9b64c542e20$export$2e2bcd8739ae039 = $47b2b9b64c542e20$var$green;

});


parcelRegister("luE6b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa5b81104ed05f6f$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $jOIUG = parcelRequire("jOIUG");

var $iJT96 = parcelRequire("iJT96");

var $f6ZlQ = parcelRequire("f6ZlQ");

var $MJIDm = parcelRequire("MJIDm");
var $2ZNil = parcelRequire("2ZNil");

var $bBmNN = parcelRequire("bBmNN");

var $5B5l1 = parcelRequire("5B5l1");
var $drupO = parcelRequire("drupO");
var $7QagW = parcelRequire("7QagW");

var $ahHCI = parcelRequire("ahHCI");
var $4AV1f = parcelRequire("4AV1f");

var $cqwHw = parcelRequire("cqwHw");

var $ii535 = parcelRequire("ii535");

var $6ayWQ = parcelRequire("6ayWQ");

var $2x1oa = parcelRequire("2x1oa");

var $g3jto = parcelRequire("g3jto");

var $kum6j = parcelRequire("kum6j");
function $fa5b81104ed05f6f$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $fa5b81104ed05f6f$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $fa5b81104ed05f6f$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $cqwHw.hslToRgb)(color);
}
function $fa5b81104ed05f6f$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $cqwHw.private_safeColorChannel)($fa5b81104ed05f6f$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $fa5b81104ed05f6f$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $fa5b81104ed05f6f$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $fa5b81104ed05f6f$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $2ZNil.default)(cssVarPrefix);
function $fa5b81104ed05f6f$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $6ayWQ.default)((0, $cNnl8._)((0, $dok7x._)({}, scheme), {
            palette: (0, $dok7x._)({
                mode: mode
            }, scheme === null || scheme === void 0 ? void 0 : scheme.palette)
        }));
        return undefined;
    }
    const _createThemeNoVars = (0, $ii535.default)((0, $cNnl8._)((0, $dok7x._)({}, restTheme), {
        palette: (0, $dok7x._)({
            mode: mode
        }, scheme === null || scheme === void 0 ? void 0 : scheme.palette)
    })), { palette: palette } = _createThemeNoVars, muiTheme = (0, $6pkKu._)(_createThemeNoVars, [
        "palette"
    ]);
    colorSchemes[colorScheme] = (0, $cNnl8._)((0, $dok7x._)({}, scheme), {
        palette: palette,
        opacity: (0, $dok7x._)({}, (0, $6ayWQ.getOpacity)(mode), scheme === null || scheme === void 0 ? void 0 : scheme.opacity),
        overlays: (scheme === null || scheme === void 0 ? void 0 : scheme.overlays) || (0, $6ayWQ.getOverlays)(mode)
    });
    return muiTheme;
}
function $fa5b81104ed05f6f$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $2x1oa.default), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root' } = options, input = (0, $6pkKu._)(options, [
        "colorSchemes",
        "defaultColorScheme",
        "disableCssColorScheme",
        "cssVarPrefix",
        "shouldSkipGeneratingVar",
        "colorSchemeSelector",
        "rootSelector"
    ]);
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $fa5b81104ed05f6f$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark } = colorSchemesInput, customColorSchemes = (0, $6pkKu._)(colorSchemesInput, [
        defaultColorScheme,
        "light",
        "dark"
    ].map((0, $jOIUG._)));
    const colorSchemes = (0, $dok7x._)({}, customColorSchemes);
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $iJT96.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $fa5b81104ed05f6f$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $fa5b81104ed05f6f$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $fa5b81104ed05f6f$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = (0, $cNnl8._)((0, $dok7x._)({
        defaultColorScheme: defaultColorScheme
    }, muiTheme), {
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: (0, $dok7x._)({}, (0, $7QagW.default)(muiTheme.typography), muiTheme.font),
        spacing: $fa5b81104ed05f6f$var$getSpacingVal(input.spacing)
    });
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $fa5b81104ed05f6f$var$setColor(palette.common, 'background', '#fff');
            $fa5b81104ed05f6f$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $fa5b81104ed05f6f$var$setColor(palette.common, 'background', '#000');
            $fa5b81104ed05f6f$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $fa5b81104ed05f6f$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'errorColor', (0, $cqwHw.private_safeDarken)(palette.error.light, 0.6));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'infoColor', (0, $cqwHw.private_safeDarken)(palette.info.light, 0.6));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'successColor', (0, $cqwHw.private_safeDarken)(palette.success.light, 0.6));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'warningColor', (0, $cqwHw.private_safeDarken)(palette.warning.light, 0.6));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'errorFilledColor', $fa5b81104ed05f6f$var$silent(()=>palette.getContrastText(palette.error.main)));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'infoFilledColor', $fa5b81104ed05f6f$var$silent(()=>palette.getContrastText(palette.info.main)));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'successFilledColor', $fa5b81104ed05f6f$var$silent(()=>palette.getContrastText(palette.success.main)));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'warningFilledColor', $fa5b81104ed05f6f$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'errorStandardBg', (0, $cqwHw.private_safeLighten)(palette.error.light, 0.9));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'infoStandardBg', (0, $cqwHw.private_safeLighten)(palette.info.light, 0.9));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'successStandardBg', (0, $cqwHw.private_safeLighten)(palette.success.light, 0.9));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'warningStandardBg', (0, $cqwHw.private_safeLighten)(palette.warning.light, 0.9));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $fa5b81104ed05f6f$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $fa5b81104ed05f6f$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $fa5b81104ed05f6f$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $fa5b81104ed05f6f$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $fa5b81104ed05f6f$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $fa5b81104ed05f6f$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $fa5b81104ed05f6f$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $fa5b81104ed05f6f$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $fa5b81104ed05f6f$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $fa5b81104ed05f6f$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $fa5b81104ed05f6f$var$setColor(palette.LinearProgress, 'primaryBg', (0, $cqwHw.private_safeLighten)(palette.primary.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $cqwHw.private_safeLighten)(palette.secondary.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.LinearProgress, 'errorBg', (0, $cqwHw.private_safeLighten)(palette.error.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.LinearProgress, 'infoBg', (0, $cqwHw.private_safeLighten)(palette.info.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.LinearProgress, 'successBg', (0, $cqwHw.private_safeLighten)(palette.success.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.LinearProgress, 'warningBg', (0, $cqwHw.private_safeLighten)(palette.warning.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $fa5b81104ed05f6f$var$setColor(palette.Slider, 'primaryTrack', (0, $cqwHw.private_safeLighten)(palette.primary.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.Slider, 'secondaryTrack', (0, $cqwHw.private_safeLighten)(palette.secondary.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.Slider, 'errorTrack', (0, $cqwHw.private_safeLighten)(palette.error.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.Slider, 'infoTrack', (0, $cqwHw.private_safeLighten)(palette.info.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.Slider, 'successTrack', (0, $cqwHw.private_safeLighten)(palette.success.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.Slider, 'warningTrack', (0, $cqwHw.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $cqwHw.private_safeEmphasize)(palette.background.default, 0.8);
            $fa5b81104ed05f6f$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $fa5b81104ed05f6f$var$setColor(palette.SnackbarContent, 'color', $fa5b81104ed05f6f$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $fa5b81104ed05f6f$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $cqwHw.private_safeEmphasize)(palette.background.paper, 0.15));
            $fa5b81104ed05f6f$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $fa5b81104ed05f6f$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $cqwHw.private_safeLighten)(palette.primary.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $cqwHw.private_safeLighten)(palette.secondary.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'errorDisabledColor', (0, $cqwHw.private_safeLighten)(palette.error.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'infoDisabledColor', (0, $cqwHw.private_safeLighten)(palette.info.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'successDisabledColor', (0, $cqwHw.private_safeLighten)(palette.success.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'warningDisabledColor', (0, $cqwHw.private_safeLighten)(palette.warning.main, 0.62));
            $fa5b81104ed05f6f$var$setColor(palette.TableCell, 'border', (0, $cqwHw.private_safeLighten)((0, $cqwHw.private_safeAlpha)(palette.divider, 1), 0.88));
            $fa5b81104ed05f6f$var$setColor(palette.Tooltip, 'bg', (0, $cqwHw.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'errorColor', (0, $cqwHw.private_safeLighten)(palette.error.light, 0.6));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'infoColor', (0, $cqwHw.private_safeLighten)(palette.info.light, 0.6));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'successColor', (0, $cqwHw.private_safeLighten)(palette.success.light, 0.6));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'warningColor', (0, $cqwHw.private_safeLighten)(palette.warning.light, 0.6));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'errorFilledColor', $fa5b81104ed05f6f$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'infoFilledColor', $fa5b81104ed05f6f$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'successFilledColor', $fa5b81104ed05f6f$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'warningFilledColor', $fa5b81104ed05f6f$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'errorStandardBg', (0, $cqwHw.private_safeDarken)(palette.error.light, 0.9));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'infoStandardBg', (0, $cqwHw.private_safeDarken)(palette.info.light, 0.9));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'successStandardBg', (0, $cqwHw.private_safeDarken)(palette.success.light, 0.9));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'warningStandardBg', (0, $cqwHw.private_safeDarken)(palette.warning.light, 0.9));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $fa5b81104ed05f6f$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $fa5b81104ed05f6f$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $fa5b81104ed05f6f$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $fa5b81104ed05f6f$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $fa5b81104ed05f6f$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $fa5b81104ed05f6f$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $fa5b81104ed05f6f$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $fa5b81104ed05f6f$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $fa5b81104ed05f6f$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $fa5b81104ed05f6f$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $fa5b81104ed05f6f$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $fa5b81104ed05f6f$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $fa5b81104ed05f6f$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $fa5b81104ed05f6f$var$setColor(palette.LinearProgress, 'primaryBg', (0, $cqwHw.private_safeDarken)(palette.primary.main, 0.5));
            $fa5b81104ed05f6f$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $cqwHw.private_safeDarken)(palette.secondary.main, 0.5));
            $fa5b81104ed05f6f$var$setColor(palette.LinearProgress, 'errorBg', (0, $cqwHw.private_safeDarken)(palette.error.main, 0.5));
            $fa5b81104ed05f6f$var$setColor(palette.LinearProgress, 'infoBg', (0, $cqwHw.private_safeDarken)(palette.info.main, 0.5));
            $fa5b81104ed05f6f$var$setColor(palette.LinearProgress, 'successBg', (0, $cqwHw.private_safeDarken)(palette.success.main, 0.5));
            $fa5b81104ed05f6f$var$setColor(palette.LinearProgress, 'warningBg', (0, $cqwHw.private_safeDarken)(palette.warning.main, 0.5));
            $fa5b81104ed05f6f$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $fa5b81104ed05f6f$var$setColor(palette.Slider, 'primaryTrack', (0, $cqwHw.private_safeDarken)(palette.primary.main, 0.5));
            $fa5b81104ed05f6f$var$setColor(palette.Slider, 'secondaryTrack', (0, $cqwHw.private_safeDarken)(palette.secondary.main, 0.5));
            $fa5b81104ed05f6f$var$setColor(palette.Slider, 'errorTrack', (0, $cqwHw.private_safeDarken)(palette.error.main, 0.5));
            $fa5b81104ed05f6f$var$setColor(palette.Slider, 'infoTrack', (0, $cqwHw.private_safeDarken)(palette.info.main, 0.5));
            $fa5b81104ed05f6f$var$setColor(palette.Slider, 'successTrack', (0, $cqwHw.private_safeDarken)(palette.success.main, 0.5));
            $fa5b81104ed05f6f$var$setColor(palette.Slider, 'warningTrack', (0, $cqwHw.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $cqwHw.private_safeEmphasize)(palette.background.default, 0.98);
            $fa5b81104ed05f6f$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $fa5b81104ed05f6f$var$setColor(palette.SnackbarContent, 'color', $fa5b81104ed05f6f$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $fa5b81104ed05f6f$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $cqwHw.private_safeEmphasize)(palette.background.paper, 0.15));
            $fa5b81104ed05f6f$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $fa5b81104ed05f6f$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $cqwHw.private_safeDarken)(palette.primary.main, 0.55));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $cqwHw.private_safeDarken)(palette.secondary.main, 0.55));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'errorDisabledColor', (0, $cqwHw.private_safeDarken)(palette.error.main, 0.55));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'infoDisabledColor', (0, $cqwHw.private_safeDarken)(palette.info.main, 0.55));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'successDisabledColor', (0, $cqwHw.private_safeDarken)(palette.success.main, 0.55));
            $fa5b81104ed05f6f$var$setColor(palette.Switch, 'warningDisabledColor', (0, $cqwHw.private_safeDarken)(palette.warning.main, 0.55));
            $fa5b81104ed05f6f$var$setColor(palette.TableCell, 'border', (0, $cqwHw.private_safeDarken)((0, $cqwHw.private_safeAlpha)(palette.divider, 1), 0.68));
            $fa5b81104ed05f6f$var$setColor(palette.Tooltip, 'bg', (0, $cqwHw.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $fa5b81104ed05f6f$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $fa5b81104ed05f6f$var$setColorChannel(palette.background, 'paper');
        $fa5b81104ed05f6f$var$setColorChannel(palette.common, 'background');
        $fa5b81104ed05f6f$var$setColorChannel(palette.common, 'onBackground');
        $fa5b81104ed05f6f$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $fa5b81104ed05f6f$var$setColor(palette[color], 'mainChannel', (0, $cqwHw.private_safeColorChannel)($fa5b81104ed05f6f$var$toRgb(colors.main)));
                if (colors.light) $fa5b81104ed05f6f$var$setColor(palette[color], 'lightChannel', (0, $cqwHw.private_safeColorChannel)($fa5b81104ed05f6f$var$toRgb(colors.light)));
                if (colors.dark) $fa5b81104ed05f6f$var$setColor(palette[color], 'darkChannel', (0, $cqwHw.private_safeColorChannel)($fa5b81104ed05f6f$var$toRgb(colors.dark)));
                if (colors.contrastText) $fa5b81104ed05f6f$var$setColor(palette[color], 'contrastTextChannel', (0, $cqwHw.private_safeColorChannel)($fa5b81104ed05f6f$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $fa5b81104ed05f6f$var$setColorChannel(palette[color], 'primary');
                    $fa5b81104ed05f6f$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $fa5b81104ed05f6f$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $fa5b81104ed05f6f$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $f6ZlQ.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $g3jto.default)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $drupO.default)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $MJIDm.default)(input.spacing, (0, $bBmNN.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $5B5l1.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = (0, $dok7x._)({}, (0, $4AV1f.default), input === null || input === void 0 ? void 0 : input.unstable_sxConfig);
    theme.unstable_sx = function sx(props) {
        return (0, $ahHCI.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $kum6j.stringifyTheme); // for Pigment CSS integration
    return theme;
}

});
parcelRegister("jOIUG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e6d586a88ca1a273$export$71511d61b312f219; });

var $cuuc2 = parcelRequire("cuuc2");

var $93Eiy = parcelRequire("93Eiy");
function $e6d586a88ca1a273$export$71511d61b312f219(arg) {
    var key = (0, $cuuc2._)(arg, "string");
    return (0, $93Eiy._)(key) === "symbol" ? key : String(key);
}

});
parcelRegister("cuuc2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $917fb51876c678b5$export$71511d61b312f219; });

var $93Eiy = parcelRequire("93Eiy");
function $917fb51876c678b5$export$71511d61b312f219(input, hint) {
    if ((0, $93Eiy._)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $93Eiy._)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});
parcelRegister("93Eiy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6983a73e0b40976a$export$71511d61b312f219; });
function $6983a73e0b40976a$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("2ZNil", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22e78438ef0e031f$export$2e2bcd8739ae039; });
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $22e78438ef0e031f$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("5B5l1", function(module, exports) {

$parcel$export(module.exports, "createGetColorSchemeSelector", function () { return $41348c75b9598086$export$858538ff6c0d421d; });
/* eslint-disable import/prefer-default-export */ function $41348c75b9598086$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});

parcelRegister("drupO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c9563d3ce2fc02e$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $6pkKu = parcelRequire("6pkKu");

var $jOIUG = parcelRequire("jOIUG");

var $f6ZlQ = parcelRequire("f6ZlQ");

var $cpsLm = parcelRequire("cpsLm");
function $9c9563d3ce2fc02e$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light' } = theme, otherTheme = (0, $6pkKu._)(theme, [
        "colorSchemes",
        "components",
        "defaultColorScheme"
    ]);
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $cpsLm.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme } = colorSchemes, otherColorSchemes = (0, $6pkKu._)(colorSchemes, [
        defaultColorScheme
    ].map((0, $jOIUG._)));
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $cpsLm.default)(scheme, parserConfig);
        themeVars = (0, $f6ZlQ.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $cpsLm.default)(defaultScheme, parserConfig);
        themeVars = (0, $f6ZlQ.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if ((selector === null || selector === void 0 ? void 0 : selector.startsWith('data-')) && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                var _colorSchemes_colorScheme_palette, _colorSchemes_colorScheme;
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = ((_colorSchemes_colorScheme = colorSchemes[colorScheme]) === null || _colorSchemes_colorScheme === void 0 ? void 0 : (_colorSchemes_colorScheme_palette = _colorSchemes_colorScheme.palette) === null || _colorSchemes_colorScheme_palette === void 0 ? void 0 : _colorSchemes_colorScheme_palette.mode) || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = (0, $dok7x._)({}, rootVars);
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $f6ZlQ.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: (0, $dok7x._)({}, css)
            } : key);
        }
        insertStyleSheet(getSelector(undefined, (0, $dok7x._)({}, rootCss)), rootCss);
        const { [colorScheme]: defaultSchemeVal } = colorSchemesMap, other = (0, $6pkKu._)(colorSchemesMap, [
            colorScheme
        ].map((0, $jOIUG._)));
        if (defaultSchemeVal) {
            var _colorSchemes_colorScheme_palette, _colorSchemes_colorScheme;
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = (_colorSchemes_colorScheme = colorSchemes[colorScheme]) === null || _colorSchemes_colorScheme === void 0 ? void 0 : (_colorSchemes_colorScheme_palette = _colorSchemes_colorScheme.palette) === null || _colorSchemes_colorScheme_palette === void 0 ? void 0 : _colorSchemes_colorScheme_palette.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? (0, $dok7x._)({
                colorScheme: cssColorSheme
            }, css) : (0, $dok7x._)({}, css);
            insertStyleSheet(getSelector(colorScheme, (0, $dok7x._)({}, finalCss)), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            var _colorSchemes_key_palette, _colorSchemes_key;
            const cssColorSheme = (_colorSchemes_key = colorSchemes[key]) === null || _colorSchemes_key === void 0 ? void 0 : (_colorSchemes_key_palette = _colorSchemes_key.palette) === null || _colorSchemes_key_palette === void 0 ? void 0 : _colorSchemes_key_palette.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? (0, $dok7x._)({
                colorScheme: cssColorSheme
            }, css) : (0, $dok7x._)({}, css);
            insertStyleSheet(getSelector(key, (0, $dok7x._)({}, finalCss)), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $9c9563d3ce2fc02e$export$2e2bcd8739ae039 = $9c9563d3ce2fc02e$var$prepareCssVars;

});
parcelRegister("cpsLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $908e218e9aacf3dc$export$2e2bcd8739ae039; });
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $908e218e9aacf3dc$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $908e218e9aacf3dc$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $908e218e9aacf3dc$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $908e218e9aacf3dc$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $908e218e9aacf3dc$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $908e218e9aacf3dc$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $908e218e9aacf3dc$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $908e218e9aacf3dc$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("7QagW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b555b8fb242981a$export$2e2bcd8739ae039; });
function $5b555b8fb242981a$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("ii535", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d50dd309421da1b3$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $6pkKu = parcelRequire("6pkKu");

var $iJT96 = parcelRequire("iJT96");

var $f6ZlQ = parcelRequire("f6ZlQ");

var $ahHCI = parcelRequire("ahHCI");
var $4AV1f = parcelRequire("4AV1f");

var $hKGA1 = parcelRequire("hKGA1");


var $ksIKY = parcelRequire("ksIKY");

var $UfwTM = parcelRequire("UfwTM");

var $9wBcw = parcelRequire("9wBcw");

var $irNn8 = parcelRequire("irNn8");

var $6NMGQ = parcelRequire("6NMGQ");

var $gYMHX = parcelRequire("gYMHX");

var $kum6j = parcelRequire("kum6j");
function $d50dd309421da1b3$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput } = options, other = (0, $6pkKu._)(options, [
        "breakpoints",
        "mixins",
        "spacing",
        "palette",
        "transitions",
        "typography",
        "shape"
    ]);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $iJT96.default)(20));
    const palette = (0, $UfwTM.default)(paletteInput);
    const systemTheme = (0, $hKGA1.default)(options);
    let muiTheme = (0, $f6ZlQ.default)(systemTheme, {
        mixins: (0, $ksIKY.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $irNn8.default).slice(),
        typography: (0, $9wBcw.default)(palette, typographyInput),
        transitions: (0, $6NMGQ.default)(transitionsInput),
        zIndex: (0, $dok7x._)({}, (0, $gYMHX.default))
    });
    muiTheme = (0, $f6ZlQ.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $f6ZlQ.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $dok7x._)({}, (0, $4AV1f.default), other === null || other === void 0 ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $ahHCI.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $kum6j.stringifyTheme); // for Pigment CSS integration
    return muiTheme;
}
let $d50dd309421da1b3$var$warnedOnce = false;
function $d50dd309421da1b3$export$c469355549431d9b(...args) {
    return $d50dd309421da1b3$var$createThemeNoVars(...args);
}
var $d50dd309421da1b3$export$2e2bcd8739ae039 = $d50dd309421da1b3$var$createThemeNoVars;

});
parcelRegister("ksIKY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee5923e46c2b1d86$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");
function $ee5923e46c2b1d86$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $dok7x._)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("9wBcw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ef3f590166ef78c$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $6pkKu = parcelRequire("6pkKu");

var $f6ZlQ = parcelRequire("f6ZlQ");
function $6ef3f590166ef78c$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $6ef3f590166ef78c$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $6ef3f590166ef78c$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $6ef3f590166ef78c$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $6ef3f590166ef78c$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $6pkKu._)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $dok7x._)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $6ef3f590166ef78c$var$defaultFontFamily ? {
            letterSpacing: `${$6ef3f590166ef78c$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $6ef3f590166ef78c$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $6ef3f590166ef78c$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $f6ZlQ.default)((0, $dok7x._)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("irNn8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6e10be5a1ebe41c$export$2e2bcd8739ae039; });
const $d6e10be5a1ebe41c$var$shadowKeyUmbraOpacity = 0.2;
const $d6e10be5a1ebe41c$var$shadowKeyPenumbraOpacity = 0.14;
const $d6e10be5a1ebe41c$var$shadowAmbientShadowOpacity = 0.12;
function $d6e10be5a1ebe41c$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$d6e10be5a1ebe41c$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$d6e10be5a1ebe41c$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$d6e10be5a1ebe41c$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $d6e10be5a1ebe41c$var$shadows = [
    'none',
    $d6e10be5a1ebe41c$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $d6e10be5a1ebe41c$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $d6e10be5a1ebe41c$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $d6e10be5a1ebe41c$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $d6e10be5a1ebe41c$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $d6e10be5a1ebe41c$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $d6e10be5a1ebe41c$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $d6e10be5a1ebe41c$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $d6e10be5a1ebe41c$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $d6e10be5a1ebe41c$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $d6e10be5a1ebe41c$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $d6e10be5a1ebe41c$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $d6e10be5a1ebe41c$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $d6e10be5a1ebe41c$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $d6e10be5a1ebe41c$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $d6e10be5a1ebe41c$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $d6e10be5a1ebe41c$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $d6e10be5a1ebe41c$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $d6e10be5a1ebe41c$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $d6e10be5a1ebe41c$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $d6e10be5a1ebe41c$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $d6e10be5a1ebe41c$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $d6e10be5a1ebe41c$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $d6e10be5a1ebe41c$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $d6e10be5a1ebe41c$export$2e2bcd8739ae039 = $d6e10be5a1ebe41c$var$shadows;

});

parcelRegister("6NMGQ", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $4f3d168014774edf$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $4f3d168014774edf$export$2e2bcd8739ae039; });
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");
const $4f3d168014774edf$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $4f3d168014774edf$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $4f3d168014774edf$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $4f3d168014774edf$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $4f3d168014774edf$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $dok7x._)({}, $4f3d168014774edf$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $dok7x._)({}, $4f3d168014774edf$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $6pkKu._)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $4f3d168014774edf$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $4f3d168014774edf$var$formatMs(delay)}`).join(',');
    };
    return (0, $cNnl8._)((0, $dok7x._)({
        getAutoHeightDuration: $4f3d168014774edf$var$getAutoHeightDuration,
        create: create
    }, inputTransitions), {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("gYMHX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5c808559aebab4e$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $c5c808559aebab4e$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $c5c808559aebab4e$export$2e2bcd8739ae039 = $c5c808559aebab4e$var$zIndex;

});

parcelRegister("kum6j", function(module, exports) {

$parcel$export(module.exports, "stringifyTheme", function () { return $eea7c0bf0336c217$export$32c2afa5f91892aa; });
/* eslint-disable import/prefer-default-export */ 
var $dok7x = parcelRequire("dok7x");

var $f6ZlQ = parcelRequire("f6ZlQ");
function $eea7c0bf0336c217$var$isSerializable(val) {
    return (0, $f6ZlQ.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $eea7c0bf0336c217$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = (0, $dok7x._)({}, baseTheme);
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$eea7c0bf0336c217$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $f6ZlQ.isPlainObject)(value)) {
                object[key] = (0, $dok7x._)({}, value);
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("6ayWQ", function(module, exports) {

$parcel$export(module.exports, "getOpacity", function () { return $47dec93b85312030$export$c85e0347fceb69ba; });
$parcel$export(module.exports, "getOverlays", function () { return $47dec93b85312030$export$dd191566510330d3; });
$parcel$export(module.exports, "default", function () { return $47dec93b85312030$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $6pkKu = parcelRequire("6pkKu");

var $UfwTM = parcelRequire("UfwTM");

var $1zr8O = parcelRequire("1zr8O");
const $47dec93b85312030$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $1zr8O.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $47dec93b85312030$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $47dec93b85312030$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $47dec93b85312030$var$defaultDarkOverlays : [];
}
function $47dec93b85312030$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays } = options, rest = (0, $6pkKu._)(options, [
        "palette",
        "opacity",
        "overlays"
    ]);
    const palette = (0, $UfwTM.default)(paletteInput);
    return (0, $dok7x._)({
        palette: palette,
        opacity: (0, $dok7x._)({}, $47dec93b85312030$export$c85e0347fceb69ba(palette.mode), opacity),
        overlays: overlays || $47dec93b85312030$export$dd191566510330d3(palette.mode)
    }, rest);
}

});
parcelRegister("1zr8O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $124e1cf83cf43fc0$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $124e1cf83cf43fc0$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("2x1oa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d7fbda352c23ca7$export$2e2bcd8739ae039; });
function $1d7fbda352c23ca7$export$2e2bcd8739ae039(keys) {
    var _keys_;
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!((_keys_ = keys[1]) === null || _keys_ === void 0 ? void 0 : _keys_.match(/(mode|contrastThreshold|tonalOffset)/));
}

});

parcelRegister("g3jto", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bafc081842c9bc97$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $bpwfx = parcelRequire("bpwfx");
var $bafc081842c9bc97$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if ((selector === null || selector === void 0 ? void 0 : selector.startsWith('data-')) && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $bpwfx.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: (0, $dok7x._)({}, css, excludedVariables)
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };

});
parcelRegister("bpwfx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84eb0ba2aa435f6b$export$2e2bcd8739ae039; });
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $84eb0ba2aa435f6b$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $84eb0ba2aa435f6b$export$2e2bcd8739ae039 = $84eb0ba2aa435f6b$var$excludeVariablesFromRoot;

});





parcelRegister("9D8Xe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $702eb3bc5a39a819$export$2e2bcd8739ae039; });
var $702eb3bc5a39a819$export$2e2bcd8739ae039 = '$$material';

});


parcelRegister("11JKH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bf95fda865987fd$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");
parcelRequire("7hhBq");


var $bzzmP = parcelRequire("bzzmP");

var $aaaIb = parcelRequire("aaaIb");

var $9D8Xe = parcelRequire("9D8Xe");

var $iHpLz = parcelRequire("iHpLz");
'use client';
function $0bf95fda865987fd$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $bzzmP.default), (0, $cNnl8._)((0, $dok7x._)({}, props), {
        defaultTheme: (0, $aaaIb.default),
        themeId: (0, $9D8Xe.default)
    }));
}
var $0bf95fda865987fd$export$2e2bcd8739ae039 = $0bf95fda865987fd$var$GlobalStyles;

});
parcelRegister("bzzmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86ce65c8a432d34b$export$2e2bcd8739ae039; });
parcelRequire("7hhBq");


var $f7ngh = parcelRequire("f7ngh");
var $jLopz = parcelRequire("jLopz");

var $8NzGK = parcelRequire("8NzGK");

var $iHpLz = parcelRequire("iHpLz");
'use client';
function $86ce65c8a432d34b$var$wrapGlobalLayer(styles) {
    const serialized = (0, $jLopz.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $86ce65c8a432d34b$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $8NzGK.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $86ce65c8a432d34b$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $86ce65c8a432d34b$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $86ce65c8a432d34b$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $f7ngh.default), {
        styles: globalStyles
    });
}
var $86ce65c8a432d34b$export$2e2bcd8739ae039 = $86ce65c8a432d34b$var$GlobalStyles;

});
parcelRegister("f7ngh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0198dc012a5c41d$export$2e2bcd8739ae039; });
parcelRequire("7hhBq");


var $38swY = parcelRequire("38swY");

var $iHpLz = parcelRequire("iHpLz");
'use client';
function $b0198dc012a5c41d$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $b0198dc012a5c41d$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($b0198dc012a5c41d$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $38swY.Global), {
        styles: globalStyles
    });
}

});

parcelRegister("jLopz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e63557b7af6ae552$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_mutateStyles", function () { return $e63557b7af6ae552$export$592c7226e4cb0171; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $e63557b7af6ae552$export$13a2d3ef13012b32; });
/**
 * @mui/styled-engine v6.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $eglJg = parcelRequire("eglJg");

var $iJWIa = parcelRequire("iJWIa");

var $38swY = parcelRequire("38swY");
var $jns69 = parcelRequire("jns69");

var $k2lc8 = parcelRequire("k2lc8");

var $f7ngh = parcelRequire("f7ngh");
function $e63557b7af6ae552$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $eglJg.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $e63557b7af6ae552$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $e63557b7af6ae552$var$wrapper = [];
function $e63557b7af6ae552$export$13a2d3ef13012b32(styles) {
    $e63557b7af6ae552$var$wrapper[0] = styles;
    return (0, $iJWIa.serializeStyles)($e63557b7af6ae552$var$wrapper);
}

});
parcelRegister("eglJg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6236a45a389117b$export$2e2bcd8739ae039; });

var $jduBz = parcelRequire("jduBz");
parcelRequire("jamvR");

parcelRequire("iJWIa");
parcelRequire("9ezTb");
parcelRequire("b21vB");
parcelRequire("7hhBq");
parcelRequire("2XtCw");
var $a6236a45a389117b$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $a6236a45a389117b$export$2e2bcd8739ae039 = (0, $jduBz.default).bind(null);
$a6236a45a389117b$var$tags.forEach(function(tagName) {
    $a6236a45a389117b$export$2e2bcd8739ae039[tagName] = $a6236a45a389117b$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("jduBz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfd6f8b7916786ff$export$2e2bcd8739ae039; });

var $jamvR = parcelRequire("jamvR");
parcelRequire("38swY");
var $jns69 = parcelRequire("jns69");

var $iJWIa = parcelRequire("iJWIa");

var $9ezTb = parcelRequire("9ezTb");

var $b21vB = parcelRequire("b21vB");

var $7hhBq = parcelRequire("7hhBq");

var $2XtCw = parcelRequire("2XtCw");
var $dfd6f8b7916786ff$var$isDevelopment = false;
var $dfd6f8b7916786ff$var$testOmitPropsOnStringTag = (0, $2XtCw.default);
var $dfd6f8b7916786ff$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $dfd6f8b7916786ff$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $dfd6f8b7916786ff$var$testOmitPropsOnStringTag : $dfd6f8b7916786ff$var$testOmitPropsOnComponent;
};
var $dfd6f8b7916786ff$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $dfd6f8b7916786ff$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $b21vB.registerStyles)(cache, serialized, isStringTag);
    (0, $9ezTb.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $b21vB.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $dfd6f8b7916786ff$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $dfd6f8b7916786ff$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $dfd6f8b7916786ff$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $jns69.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $7hhBq.useContext((0, $jns69.T));
            }
            if (typeof props.className === 'string') className = (0, $b21vB.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $iJWIa.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $dfd6f8b7916786ff$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $7hhBq.createElement($7hhBq.Fragment, null, /*#__PURE__*/ $7hhBq.createElement($dfd6f8b7916786ff$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $7hhBq.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $dfd6f8b7916786ff$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $jamvR.default)({}, options, nextOptions, {
                shouldForwardProp: $dfd6f8b7916786ff$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("2XtCw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2278116b09190b05$export$2e2bcd8739ae039; });

var $65JfS = parcelRequire("65JfS");
// eslint-disable-next-line no-undef
var $2278116b09190b05$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $2278116b09190b05$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $65JfS.default)(function(prop) {
    return $2278116b09190b05$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("k2lc8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9646f5d6d2d5bfe$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");


var $jns69 = parcelRequire("jns69");

var $6klt3 = parcelRequire("6klt3");

var $jNaYn = parcelRequire("jNaYn");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $e9646f5d6d2d5bfe$var$cacheMap = new Map();
const $e9646f5d6d2d5bfe$export$5a3f4e255fc47e86 = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $e9646f5d6d2d5bfe$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $6klt3.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $e9646f5d6d2d5bfe$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $e9646f5d6d2d5bfe$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$e9646f5d6d2d5bfe$var$insertionPoint) {
        $e9646f5d6d2d5bfe$var$insertionPoint = document.createElement('meta');
        $e9646f5d6d2d5bfe$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $e9646f5d6d2d5bfe$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($e9646f5d6d2d5bfe$var$insertionPoint);
    }
}
function $e9646f5d6d2d5bfe$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends (0, $jNaYn.StyleSheet) {
            insert(rule, options) {
                if ($e9646f5d6d2d5bfe$export$5a3f4e255fc47e86.insert) return $e9646f5d6d2d5bfe$export$5a3f4e255fc47e86.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $e9646f5d6d2d5bfe$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $e9646f5d6d2d5bfe$var$createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? $e9646f5d6d2d5bfe$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $e9646f5d6d2d5bfe$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $7hhBq.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $e9646f5d6d2d5bfe$var$cacheMap.has(cacheKey)) return $e9646f5d6d2d5bfe$var$cacheMap.get(cacheKey);
        const fresh = $e9646f5d6d2d5bfe$var$getCache(injectFirst, enableCssLayer);
        $e9646f5d6d2d5bfe$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $iHpLz.jsx)((0, $jns69.C), {
        value: cache,
        children: children
    }) : children;
}

});




parcelRegister("18TeW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d51634cecc7f381$export$2e2bcd8739ae039; });

var $6gSim = parcelRequire("6gSim");

var $aaaIb = parcelRequire("aaaIb");

var $9D8Xe = parcelRequire("9D8Xe");

var $2fhVh = parcelRequire("2fhVh");

'use client';
const $0d51634cecc7f381$var$styled = (0, $6gSim.default)({
    themeId: (0, $9D8Xe.default),
    defaultTheme: $aaaIb.default,
    rootShouldForwardProp: $2fhVh.default
});
var $0d51634cecc7f381$export$2e2bcd8739ae039 = $0d51634cecc7f381$var$styled;

});
parcelRegister("6gSim", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $490e5a9abd9f0ef6$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $jLopz = parcelRequire("jLopz");

var $f6ZlQ = parcelRequire("f6ZlQ");

var $31bjE = parcelRequire("31bjE");

var $kUzoR = parcelRequire("kUzoR");

var $hKGA1 = parcelRequire("hKGA1");

var $ahHCI = parcelRequire("ahHCI");

var $5hNUg = parcelRequire("5hNUg");
const $490e5a9abd9f0ef6$export$35e57303dbd8a66 = (0, $hKGA1.default)();
function $490e5a9abd9f0ef6$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $490e5a9abd9f0ef6$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $490e5a9abd9f0ef6$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $490e5a9abd9f0ef6$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $490e5a9abd9f0ef6$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $490e5a9abd9f0ef6$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$490e5a9abd9f0ef6$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle === null || resolvedStyle === void 0 ? void 0 : resolvedStyle.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $490e5a9abd9f0ef6$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants } = resolvedStyle, otherStyles = (0, $6pkKu._)(resolvedStyle, [
                "variants"
            ]);
            rootStyle = layerName ? $490e5a9abd9f0ef6$var$shallowLayer((0, $jLopz.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $490e5a9abd9f0ef6$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle === null || resolvedStyle === void 0 ? void 0 : resolvedStyle.isProcessed) return layerName ? $490e5a9abd9f0ef6$var$shallowLayer((0, $jLopz.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $490e5a9abd9f0ef6$var$shallowLayer((0, $jLopz.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $490e5a9abd9f0ef6$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState !== null && mergedState !== void 0 ? mergedState : mergedState = (0, $cNnl8._)((0, $dok7x._)({}, props, props.ownerState), {
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            var _props_ownerState;
            if (props[key] !== variant.props[key] && ((_props_ownerState = props.ownerState) === null || _props_ownerState === void 0 ? void 0 : _props_ownerState[key]) !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState !== null && mergedState !== void 0 ? mergedState : mergedState = (0, $cNnl8._)((0, $dok7x._)({}, props, props.ownerState), {
                ownerState: props.ownerState
            });
            results.push(layerName ? $490e5a9abd9f0ef6$var$shallowLayer((0, $jLopz.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $490e5a9abd9f0ef6$var$shallowLayer((0, $jLopz.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $490e5a9abd9f0ef6$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $490e5a9abd9f0ef6$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $490e5a9abd9f0ef6$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $490e5a9abd9f0ef6$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $490e5a9abd9f0ef6$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $jLopz.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $ahHCI.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $490e5a9abd9f0ef6$var$defaultOverridesResolver($490e5a9abd9f0ef6$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $6pkKu._)(inputOptions, [
            "name",
            "slot",
            "skipVariantsResolver",
            "skipSx",
            "overridesResolver"
        ]);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $490e5a9abd9f0ef6$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($490e5a9abd9f0ef6$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $jLopz.default)(tag, (0, $dok7x._)({
            shouldForwardProp: shouldForwardPropOption,
            label: $490e5a9abd9f0ef6$var$generateStyledLabel(componentName, componentSlot)
        }, options));
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $490e5a9abd9f0ef6$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $f6ZlQ.isPlainObject)(style)) {
                const serialized = (0, $5hNUg.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $490e5a9abd9f0ef6$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $490e5a9abd9f0ef6$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                var _theme_components_componentName, _theme_components;
                const theme = props.theme;
                const styleOverrides = (_theme_components = theme.components) === null || _theme_components === void 0 ? void 0 : (_theme_components_componentName = _theme_components[componentName]) === null || _theme_components_componentName === void 0 ? void 0 : _theme_components_componentName.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $490e5a9abd9f0ef6$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                var _theme_components_componentName, _theme_components;
                const theme = props.theme;
                const themeVariants = theme === null || theme === void 0 ? void 0 : (_theme_components = theme.components) === null || _theme_components === void 0 ? void 0 : (_theme_components_componentName = _theme_components[componentName]) === null || _theme_components_componentName === void 0 ? void 0 : _theme_components_componentName.variants;
                if (!themeVariants) return null;
                return $490e5a9abd9f0ef6$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $ahHCI.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $490e5a9abd9f0ef6$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $31bjE.default)(componentSlot || '')}`;
    return `Styled(${(0, $kUzoR.default)(tag)})`;
}
function $490e5a9abd9f0ef6$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $490e5a9abd9f0ef6$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $490e5a9abd9f0ef6$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $490e5a9abd9f0ef6$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("kUzoR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3947f4eb8ae10a4$export$2e2bcd8739ae039; });

var $8Iy2x = parcelRequire("8Iy2x");
function $f3947f4eb8ae10a4$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $f3947f4eb8ae10a4$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $f3947f4eb8ae10a4$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $f3947f4eb8ae10a4$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $f3947f4eb8ae10a4$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $8Iy2x.ForwardRef:
            return $f3947f4eb8ae10a4$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $8Iy2x.Memo:
            return $f3947f4eb8ae10a4$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});

parcelRegister("5hNUg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d9540b0253ca9f2$export$2e2bcd8739ae039; });

var $6pkKu = parcelRequire("6pkKu");

var $jLopz = parcelRequire("jLopz");
function $3d9540b0253ca9f2$export$2e2bcd8739ae039(input) {
    const { variants: variants } = input, style = (0, $6pkKu._)(input, [
        "variants"
    ]);
    const result = {
        variants: variants,
        style: (0, $jLopz.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $jLopz.internal_serializeStyles)(variant.style);
    });
    return result;
}

});


parcelRegister("2fhVh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a2ae293d558c53c$export$2e2bcd8739ae039; });

var $9AKij = parcelRequire("9AKij");
const $1a2ae293d558c53c$var$rootShouldForwardProp = (prop)=>(0, $9AKij.default)(prop) && prop !== 'classes';
var $1a2ae293d558c53c$export$2e2bcd8739ae039 = $1a2ae293d558c53c$var$rootShouldForwardProp;

});
parcelRegister("9AKij", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fbb62ed2e1ad4d3$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $6fbb62ed2e1ad4d3$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $6fbb62ed2e1ad4d3$export$2e2bcd8739ae039 = $6fbb62ed2e1ad4d3$var$slotShouldForwardProp;

});




parcelRegister("1zv4u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1251297311261bde$export$2e2bcd8739ae039; });

var $bMBv1 = parcelRequire("bMBv1");
const $1251297311261bde$var$memoTheme = (0, $bMBv1.default);
var $1251297311261bde$export$2e2bcd8739ae039 = $1251297311261bde$var$memoTheme;

});
parcelRegister("bMBv1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89414400b88cf2d0$export$2e2bcd8739ae039; });

var $5hNUg = parcelRequire("5hNUg");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $89414400b88cf2d0$var$arg = {
    theme: undefined
};
function $89414400b88cf2d0$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $89414400b88cf2d0$var$arg.theme = props.theme;
            value = (0, $5hNUg.default)(styleFn($89414400b88cf2d0$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});


parcelRegister("4ZZLe", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $3a3cc4550b2ec9e1$export$2440da353cedad43; });

var $dok7x = parcelRequire("dok7x");
parcelRequire("7hhBq");


var $iK4u8 = parcelRequire("iK4u8");

var $iHpLz = parcelRequire("iHpLz");
'use client';
function $3a3cc4550b2ec9e1$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iK4u8.default), (0, $dok7x._)({}, props));
}
var $3a3cc4550b2ec9e1$export$2e2bcd8739ae039 = $3a3cc4550b2ec9e1$var$DefaultPropsProvider;
function $3a3cc4550b2ec9e1$export$2440da353cedad43(params) {
    return (0, $iK4u8.useDefaultProps)(params);
}

});
parcelRegister("iK4u8", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $da500082511be35b$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $da500082511be35b$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");


var $ks1yv = parcelRequire("ks1yv");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $da500082511be35b$var$PropsContext = /*#__PURE__*/ $7hhBq.createContext(undefined);
function $da500082511be35b$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $iHpLz.jsx)($da500082511be35b$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $da500082511be35b$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $ks1yv.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $ks1yv.default)(config, props);
    return props;
}
function $da500082511be35b$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $7hhBq.useContext($da500082511be35b$var$PropsContext);
    return $da500082511be35b$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $da500082511be35b$export$2e2bcd8739ae039 = $da500082511be35b$var$DefaultPropsProvider;

});
parcelRegister("ks1yv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee37a1112ffa1e31$export$2e2bcd8739ae039; });
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ 
var $dok7x = parcelRequire("dok7x");
function $ee37a1112ffa1e31$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $dok7x._)({}, props);
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = (0, $dok7x._)({}, defaultProps[propName], output[propName]);
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = (0, $dok7x._)({}, slotProps);
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $ee37a1112ffa1e31$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});



parcelRegister("bUnnb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ab70e1028addba6$export$2e2bcd8739ae039; });

var $31bjE = parcelRequire("31bjE");
var $8ab70e1028addba6$export$2e2bcd8739ae039 = (0, $31bjE.default);

});

parcelRegister("3CtK9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a2bfe1e8a79a4cc$export$2e2bcd8739ae039; });
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $2a2bfe1e8a79a4cc$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $2a2bfe1e8a79a4cc$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$2a2bfe1e8a79a4cc$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $2a2bfe1e8a79a4cc$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $2a2bfe1e8a79a4cc$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

});

parcelRegister("ei3fZ", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $a67545e6e33de29b$export$24c1f8f60cbac79e; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $a67545e6e33de29b$export$24c1f8f60cbac79e(slot) {
    return (0, $200uu.default)('MuiTypography', slot);
}
const $a67545e6e33de29b$var$typographyClasses = (0, $5blE7.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $a67545e6e33de29b$export$2e2bcd8739ae039 = $a67545e6e33de29b$var$typographyClasses;

});
parcelRegister("5blE7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c5ec547981b1115$export$2e2bcd8739ae039; });

var $200uu = parcelRequire("200uu");
function $3c5ec547981b1115$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $200uu.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("200uu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $174bf652d74054ad$export$2e2bcd8739ae039; });

var $1wld5 = parcelRequire("1wld5");
const $174bf652d74054ad$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $174bf652d74054ad$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $174bf652d74054ad$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $1wld5.default).generate(componentName)}-${slot}`;
}
function $174bf652d74054ad$export$34c0130b1f3e8ae3(slot) {
    return $174bf652d74054ad$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("1wld5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11b93b77dbca3624$export$2e2bcd8739ae039; });
const $11b93b77dbca3624$var$defaultGenerator = (componentName)=>componentName;
const $11b93b77dbca3624$var$createClassNameGenerator = ()=>{
    let generate = $11b93b77dbca3624$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $11b93b77dbca3624$var$defaultGenerator;
        }
    };
};
const $11b93b77dbca3624$var$ClassNameGenerator = $11b93b77dbca3624$var$createClassNameGenerator();
var $11b93b77dbca3624$export$2e2bcd8739ae039 = $11b93b77dbca3624$var$ClassNameGenerator;

});





parcelRegister("edeoK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a58d72c1fb7eabe5$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");

var $ebFzZ = parcelRequire("ebFzZ");

var $fTZbL = parcelRequire("fTZbL");

var $9D8Xe = parcelRequire("9D8Xe");

var $iHpLz = parcelRequire("iHpLz");
'use client';
function $a58d72c1fb7eabe5$export$2e2bcd8739ae039(_param) {
    var { theme: theme } = _param, props = (0, $6pkKu._)(_param, [
        "theme"
    ]);
    const noVarsTheme = $7hhBq.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = (0, $9D8Xe.default) in theme ? theme[0, $9D8Xe.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return (0, $cNnl8._)((0, $dok7x._)({}, theme), {
                vars: null
            });
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $ebFzZ.default), (0, $dok7x._)({
        theme: noVarsTheme
    }, props));
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $fTZbL.CssVarsProvider), (0, $dok7x._)({
        theme: theme
    }, props));
}

});
parcelRegister("ebFzZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a542589baaa47726$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");
parcelRequire("7hhBq");

var $iVhWN = parcelRequire("iVhWN");

var $9D8Xe = parcelRequire("9D8Xe");

var $iHpLz = parcelRequire("iHpLz");
'use client';
function $a542589baaa47726$export$2e2bcd8739ae039(_param) {
    var { theme: themeInput } = _param, props = (0, $6pkKu._)(_param, [
        "theme"
    ]);
    const scopedTheme = (0, $9D8Xe.default) in themeInput ? themeInput[0, $9D8Xe.default] : undefined;
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iVhWN.default), (0, $cNnl8._)((0, $dok7x._)({}, props), {
        themeId: scopedTheme ? (0, $9D8Xe.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}

});
parcelRegister("iVhWN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc6b78d467e46660$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $7hhBq = parcelRequire("7hhBq");


var $akWPG = parcelRequire("akWPG");
var $buEo5 = parcelRequire("buEo5");

parcelRequire("38swY");
var $jns69 = parcelRequire("jns69");

var $7cBTh = parcelRequire("7cBTh");

var $6PpZS = parcelRequire("6PpZS");

var $iK4u8 = parcelRequire("iK4u8");

var $1TBNq = parcelRequire("1TBNq");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $dc6b78d467e46660$var$EMPTY_THEME = {};
function $dc6b78d467e46660$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $7hhBq.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $cNnl8._)((0, $dok7x._)({}, upperTheme), {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $cNnl8._)((0, $dok7x._)({}, upperTheme), {
            [themeId]: localTheme
        }) : (0, $dok7x._)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $dc6b78d467e46660$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $7cBTh.default)($dc6b78d467e46660$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $buEo5.default)() || $dc6b78d467e46660$var$EMPTY_THEME;
    const engineTheme = $dc6b78d467e46660$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $dc6b78d467e46660$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $1TBNq.default)(engineTheme);
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $akWPG.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $jns69.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $6PpZS.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $iK4u8.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $dc6b78d467e46660$export$2e2bcd8739ae039 = $dc6b78d467e46660$var$ThemeProvider;

});
parcelRegister("akWPG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7869688e8c7cb185$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $7hhBq = parcelRequire("7hhBq");



var $48MOO = parcelRequire("48MOO");

var $buEo5 = parcelRequire("buEo5");

var $byty1 = parcelRequire("byty1");

var $iHpLz = parcelRequire("iHpLz");
function $7869688e8c7cb185$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $dok7x._)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $7869688e8c7cb185$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $buEo5.default)();
    const theme = $7hhBq.useMemo(()=>{
        const output = outerTheme === null ? (0, $dok7x._)({}, localTheme) : $7869688e8c7cb185$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $byty1.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $48MOO.default).Provider, {
        value: theme,
        children: children
    });
}
var $7869688e8c7cb185$export$2e2bcd8739ae039 = $7869688e8c7cb185$var$ThemeProvider;

});
parcelRegister("48MOO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $303dc71b3c7a2d36$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
'use client';
const $303dc71b3c7a2d36$var$ThemeContext = /*#__PURE__*/ $7hhBq.createContext(null);
var $303dc71b3c7a2d36$export$2e2bcd8739ae039 = $303dc71b3c7a2d36$var$ThemeContext;

});

parcelRegister("buEo5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85e1d329e2a4e1f3$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");

var $48MOO = parcelRequire("48MOO");
function $85e1d329e2a4e1f3$export$2e2bcd8739ae039() {
    const theme = $7hhBq.useContext((0, $48MOO.default));
    return theme;
}

});

parcelRegister("byty1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8699ca3ad7a1c4c7$export$2e2bcd8739ae039; });
const $8699ca3ad7a1c4c7$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $8699ca3ad7a1c4c7$export$2e2bcd8739ae039 = $8699ca3ad7a1c4c7$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("6PpZS", function(module, exports) {

$parcel$export(module.exports, "useRtl", function () { return $4f8babfa0bb27973$export$b2dd014b6c321cb; });
$parcel$export(module.exports, "default", function () { return $4f8babfa0bb27973$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $iHpLz = parcelRequire("iHpLz");
'use client';
const $4f8babfa0bb27973$var$RtlContext = /*#__PURE__*/ $7hhBq.createContext();
function $4f8babfa0bb27973$var$RtlProvider(_param) {
    var { value: value } = _param, props = (0, $6pkKu._)(_param, [
        "value"
    ]);
    return /*#__PURE__*/ (0, $iHpLz.jsx)($4f8babfa0bb27973$var$RtlContext.Provider, (0, $dok7x._)({
        value: value !== null && value !== void 0 ? value : true
    }, props));
}
const $4f8babfa0bb27973$export$b2dd014b6c321cb = ()=>{
    const value = $7hhBq.useContext($4f8babfa0bb27973$var$RtlContext);
    return value !== null && value !== void 0 ? value : false;
};
var $4f8babfa0bb27973$export$2e2bcd8739ae039 = $4f8babfa0bb27973$var$RtlProvider;

});

parcelRegister("1TBNq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16183f0e9c7f9176$export$2e2bcd8739ae039; });
parcelRequire("7hhBq");

var $bWfnw = parcelRequire("bWfnw");

var $l0Krq = parcelRequire("l0Krq");

var $bzzmP = parcelRequire("bzzmP");

var $7cBTh = parcelRequire("7cBTh");

var $iHpLz = parcelRequire("iHpLz");
function $16183f0e9c7f9176$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $7cBTh.default)();
    const id = (0, $l0Krq.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $bWfnw.default)(()=>{
        var _head_querySelector;
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild_hasAttribute;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && ((_firstChild_hasAttribute = firstChild.hasAttribute) === null || _firstChild_hasAttribute === void 0 ? void 0 : _firstChild_hasAttribute.call(firstChild, 'data-mui-layer-order')) && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else (_head_querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) === null || _head_querySelector === void 0 ? void 0 : _head_querySelector.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $bzzmP.default), {
        styles: layerOrder
    });
}

});
parcelRegister("bWfnw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b110a4c5ce194bd$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $8b110a4c5ce194bd$var$useEnhancedEffect = typeof window !== 'undefined' ? $7hhBq.useLayoutEffect : $7hhBq.useEffect;
var $8b110a4c5ce194bd$export$2e2bcd8739ae039 = $8b110a4c5ce194bd$var$useEnhancedEffect;

});

parcelRegister("l0Krq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4bd9f51a9520318$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $7hhBq = parcelRequire("7hhBq");
'use client';
let $f4bd9f51a9520318$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $f4bd9f51a9520318$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $7hhBq.useState(idOverride);
    const id = idOverride || defaultId;
    $7hhBq.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $f4bd9f51a9520318$var$globalId += 1;
            setDefaultId(`mui-${$f4bd9f51a9520318$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $f4bd9f51a9520318$var$safeReact = (0, $dok7x._)({}, $7hhBq);
const $f4bd9f51a9520318$var$maybeReactUseId = $f4bd9f51a9520318$var$safeReact.useId;
function $f4bd9f51a9520318$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($f4bd9f51a9520318$var$maybeReactUseId !== undefined) {
        const reactId = $f4bd9f51a9520318$var$maybeReactUseId();
        return idOverride !== null && idOverride !== void 0 ? idOverride : reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $f4bd9f51a9520318$var$useGlobalId(idOverride);
}

});




parcelRegister("fTZbL", function(module, exports) {

$parcel$export(module.exports, "CssVarsProvider", function () { return $b93b74e50563345f$export$50ec01b133c61652; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");
parcelRequire("7hhBq");

var $ahHCI = parcelRequire("ahHCI");

var $f8wjm = parcelRequire("f8wjm");

var $f5flw = parcelRequire("f5flw");

var $9wBcw = parcelRequire("9wBcw");

var $9D8Xe = parcelRequire("9D8Xe");

var $8QRDs = parcelRequire("8QRDs");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const { CssVarsProvider: $b93b74e50563345f$var$InternalCssVarsProvider, useColorScheme: $b93b74e50563345f$export$6343629ee1b29116, getInitColorSchemeScript: $b93b74e50563345f$var$deprecatedGetInitColorSchemeScript } = (0, $f8wjm.default)({
    themeId: (0, $9D8Xe.default),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $f5flw.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $8QRDs.defaultConfig).colorSchemeStorageKey,
    modeStorageKey: (0, $8QRDs.defaultConfig).modeStorageKey,
    defaultColorScheme: {
        light: (0, $8QRDs.defaultConfig).defaultLightColorScheme,
        dark: (0, $8QRDs.defaultConfig).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = (0, $cNnl8._)((0, $dok7x._)({}, theme), {
            typography: (0, $9wBcw.default)(theme.palette, theme.typography)
        });
        newTheme.unstable_sx = function sx(props) {
            return (0, $ahHCI.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $b93b74e50563345f$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $b93b74e50563345f$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $iHpLz.jsx)($b93b74e50563345f$var$InternalCssVarsProvider, (0, $dok7x._)({}, props));
}
let $b93b74e50563345f$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $b93b74e50563345f$export$f9a57b4a2abf8ed = (params)=>{
    if (!$b93b74e50563345f$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $b93b74e50563345f$var$warnedInitScriptOnce = true;
    }
    return $b93b74e50563345f$var$deprecatedGetInitColorSchemeScript(params);
};
const $b93b74e50563345f$export$50ec01b133c61652 = $b93b74e50563345f$var$InternalCssVarsProvider;

});
parcelRegister("f8wjm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b050aab26c902601$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $7hhBq = parcelRequire("7hhBq");


var $f7ngh = parcelRequire("f7ngh");

var $buEo5 = parcelRequire("buEo5");

var $bWfnw = parcelRequire("bWfnw");

var $iVhWN = parcelRequire("iVhWN");

var $2E7OY = parcelRequire("2E7OY");

var $4HbKv = parcelRequire("4HbKv");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $b050aab26c902601$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $b050aab26c902601$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $2E7OY.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $2E7OY.DEFAULT_COLOR_SCHEME_STORAGE_KEY), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $7hhBq.createContext(undefined);
    const useColorScheme = ()=>$7hhBq.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        var _colorSchemes_restThemeProp_defaultColorScheme_palette, _colorSchemes_restThemeProp_defaultColorScheme, _restThemeProp_palette, _memoTheme_generateStyleSheets;
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', noSsr: noSsr } = props;
        const hasMounted = $7hhBq.useRef(false);
        const upperTheme = (0, $buEo5.default)();
        const ctx = $7hhBq.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $7hhBq.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $7hhBq.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : ((_colorSchemes_restThemeProp_defaultColorScheme = colorSchemes[restThemeProp.defaultColorScheme]) === null || _colorSchemes_restThemeProp_defaultColorScheme === void 0 ? void 0 : (_colorSchemes_restThemeProp_defaultColorScheme_palette = _colorSchemes_restThemeProp_defaultColorScheme.palette) === null || _colorSchemes_restThemeProp_defaultColorScheme_palette === void 0 ? void 0 : _colorSchemes_restThemeProp_defaultColorScheme_palette.mode) || ((_restThemeProp_palette = restThemeProp.palette) === null || _restThemeProp_palette === void 0 ? void 0 : _restThemeProp_palette.mode);
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $4HbKv.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        const memoTheme = $7hhBq.useMemo(()=>{
            var _restThemeProp_generateThemeVars;
            // `colorScheme` is undefined on the server and hydration phase
            const calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = ((_restThemeProp_generateThemeVars = restThemeProp.generateThemeVars) === null || _restThemeProp_generateThemeVars === void 0 ? void 0 : _restThemeProp_generateThemeVars.call(restThemeProp)) || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = (0, $cNnl8._)((0, $dok7x._)({}, restThemeProp), {
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            });
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = (0, $dok7x._)({}, theme[schemeKey], scheme[schemeKey]);
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            colorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $bWfnw.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if ((selector === null || selector === void 0 ? void 0 : selector.startsWith('data-')) && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $7hhBq.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($b050aab26c902601$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $7hhBq.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $7hhBq.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && (upperTheme === null || upperTheme === void 0 ? void 0 : upperTheme.cssVarPrefix) === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $iHpLz.jsxs)($7hhBq.Fragment, {
            children: [
                /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iVhWN.default), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $iHpLz.jsx)((0, $f7ngh.default), {
                    styles: ((_memoTheme_generateStyleSheets = memoTheme.generateStyleSheets) === null || _memoTheme_generateStyleSheets === void 0 ? void 0 : _memoTheme_generateStyleSheets.call(memoTheme)) || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $iHpLz.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $2E7OY.default)((0, $dok7x._)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey
        }, params));
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("2E7OY", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MODE_STORAGE_KEY", function () { return $1ed5624ac70d8788$export$ff0fa3047d11164c; });
$parcel$export(module.exports, "DEFAULT_COLOR_SCHEME_STORAGE_KEY", function () { return $1ed5624ac70d8788$export$665054ea9d94dab9; });
$parcel$export(module.exports, "default", function () { return $1ed5624ac70d8788$export$2e2bcd8739ae039; });
/**
 * Split this component for RSC import
 */ parcelRequire("7hhBq");

var $iHpLz = parcelRequire("iHpLz");
const $1ed5624ac70d8788$export$ff0fa3047d11164c = 'mode';
const $1ed5624ac70d8788$export$665054ea9d94dab9 = 'color-scheme';
const $1ed5624ac70d8788$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $1ed5624ac70d8788$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $1ed5624ac70d8788$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $1ed5624ac70d8788$export$665054ea9d94dab9, attribute: initialAttribute = $1ed5624ac70d8788$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $iHpLz.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("4HbKv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36b44aae63df7717$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $7hhBq = parcelRequire("7hhBq");

var $2E7OY = parcelRequire("2E7OY");

var $1E6FY = parcelRequire("1E6FY");
'use client';
function $36b44aae63df7717$var$noop() {}
function $36b44aae63df7717$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $36b44aae63df7717$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $36b44aae63df7717$export$3caa7590cc1987bd(state) {
    return $36b44aae63df7717$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $36b44aae63df7717$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $2E7OY.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: colorSchemeStorageKey = (0, $2E7OY.DEFAULT_COLOR_SCHEME_STORAGE_KEY), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $1E6FY.default), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $7hhBq.useMemo(()=>storageManager === null || storageManager === void 0 ? void 0 : storageManager({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $7hhBq.useMemo(()=>storageManager === null || storageManager === void 0 ? void 0 : storageManager({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $7hhBq.useMemo(()=>storageManager === null || storageManager === void 0 ? void 0 : storageManager({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $7hhBq.useState(()=>{
        const initialMode = (modeStorage === null || modeStorage === void 0 ? void 0 : modeStorage.get(defaultMode)) || defaultMode;
        const lightColorScheme = (lightStorage === null || lightStorage === void 0 ? void 0 : lightStorage.get(defaultLightColorScheme)) || defaultLightColorScheme;
        const darkColorScheme = (darkStorage === null || darkStorage === void 0 ? void 0 : darkStorage.get(defaultDarkColorScheme)) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $36b44aae63df7717$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $7hhBq.useState(noSsr || !isMultiSchemes);
    $7hhBq.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $36b44aae63df7717$export$3caa7590cc1987bd(state);
    const setMode = $7hhBq.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode !== null && mode !== void 0 ? mode : defaultMode;
            modeStorage === null || modeStorage === void 0 ? void 0 : modeStorage.set(newMode);
            return (0, $cNnl8._)((0, $dok7x._)({}, currentState), {
                mode: newMode,
                systemMode: $36b44aae63df7717$export$ab3d447356dfa3e5(newMode)
            });
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $7hhBq.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage === null || lightStorage === void 0 ? void 0 : lightStorage.set(defaultLightColorScheme);
            darkStorage === null || darkStorage === void 0 ? void 0 : darkStorage.set(defaultDarkColorScheme);
            return (0, $cNnl8._)((0, $dok7x._)({}, currentState), {
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            });
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = (0, $dok7x._)({}, currentState);
                $36b44aae63df7717$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage === null || lightStorage === void 0 ? void 0 : lightStorage.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage === null || darkStorage === void 0 ? void 0 : darkStorage.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = (0, $dok7x._)({}, currentState);
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage === null || lightStorage === void 0 ? void 0 : lightStorage.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage === null || darkStorage === void 0 ? void 0 : darkStorage.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $7hhBq.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = (event === null || event === void 0 ? void 0 : event.matches) ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return (0, $cNnl8._)((0, $dok7x._)({}, currentState), {
                systemMode: systemMode
            });
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $7hhBq.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $7hhBq.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $7hhBq.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = (modeStorage === null || modeStorage === void 0 ? void 0 : modeStorage.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            })) || $36b44aae63df7717$var$noop;
            const unsubscribeLight = (lightStorage === null || lightStorage === void 0 ? void 0 : lightStorage.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            })) || $36b44aae63df7717$var$noop;
            const unsubscribeDark = (darkStorage === null || darkStorage === void 0 ? void 0 : darkStorage.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            })) || $36b44aae63df7717$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return (0, $cNnl8._)((0, $dok7x._)({}, state), {
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    });
}

});
parcelRegister("1E6FY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $132eb49261b17fbc$export$2e2bcd8739ae039; });
function $132eb49261b17fbc$var$noop() {}
const $132eb49261b17fbc$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch (e) {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch (e) {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $132eb49261b17fbc$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $132eb49261b17fbc$export$2e2bcd8739ae039 = $132eb49261b17fbc$var$localStorageManager;

});



parcelRegister("8QRDs", function(module, exports) {

$parcel$export(module.exports, "defaultConfig", function () { return $671cc8f389b3f17a$export$f84bd70098573c5c; });

var $dok7x = parcelRequire("dok7x");
parcelRequire("7hhBq");

var $2E7OY = parcelRequire("2E7OY");

var $iHpLz = parcelRequire("iHpLz");
const $671cc8f389b3f17a$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
var $671cc8f389b3f17a$export$2e2bcd8739ae039 = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $2E7OY.default), (0, $dok7x._)({}, $671cc8f389b3f17a$export$f84bd70098573c5c, props));
};

});



parcelRegister("aw1H1", function(module, exports) {

$parcel$export(module.exports, "useLocation", function () { return $7c6a1aaf94a1ce95$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $7c6a1aaf94a1ce95$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $7c6a1aaf94a1ce95$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "Navigate", function () { return $7c6a1aaf94a1ce95$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Route", function () { return $7c6a1aaf94a1ce95$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $7c6a1aaf94a1ce95$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "BrowserRouter", function () { return $7c6a1aaf94a1ce95$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $7c6a1aaf94a1ce95$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $7c6a1aaf94a1ce95$export$f1a78c17382fe22a; });
/**
 * react-router v7.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");
var $7c6a1aaf94a1ce95$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-6CSD65Y2.mjs"
});
var $7c6a1aaf94a1ce95$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $7c6a1aaf94a1ce95$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $7c6a1aaf94a1ce95$var$__typeError("Cannot " + msg);
var $7c6a1aaf94a1ce95$var$__privateGet = (obj, member, getter)=>($7c6a1aaf94a1ce95$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $7c6a1aaf94a1ce95$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $7c6a1aaf94a1ce95$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $7c6a1aaf94a1ce95$var$__privateSet = (obj, member, value, setter)=>($7c6a1aaf94a1ce95$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/history.ts
var $7c6a1aaf94a1ce95$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($7c6a1aaf94a1ce95$export$e19cd5f9376f8cee || {});
var $7c6a1aaf94a1ce95$var$PopStateEventType = "popstate";
function $7c6a1aaf94a1ce95$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $7c6a1aaf94a1ce95$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $7c6a1aaf94a1ce95$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $7c6a1aaf94a1ce95$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $7c6a1aaf94a1ce95$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $7c6a1aaf94a1ce95$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $7c6a1aaf94a1ce95$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $7c6a1aaf94a1ce95$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        var _globalHistory_state;
        let maskedLocation = (_globalHistory_state = globalHistory.state) === null || _globalHistory_state === void 0 ? void 0 : _globalHistory_state.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $7c6a1aaf94a1ce95$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $7c6a1aaf94a1ce95$export$fe53371bee54353d(to);
    }
    return $7c6a1aaf94a1ce95$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $7c6a1aaf94a1ce95$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $7c6a1aaf94a1ce95$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $7c6a1aaf94a1ce95$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $7c6a1aaf94a1ce95$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $7c6a1aaf94a1ce95$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $7c6a1aaf94a1ce95$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $7c6a1aaf94a1ce95$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $7c6a1aaf94a1ce95$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $7c6a1aaf94a1ce95$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $7c6a1aaf94a1ce95$var$createLocation(current, to, state = null, key, mask) {
    let location = (0, $cNnl8._)((0, $dok7x._)({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(to) : to), {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $7c6a1aaf94a1ce95$var$createKey(),
        mask: mask
    });
    return location;
}
function $7c6a1aaf94a1ce95$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $7c6a1aaf94a1ce95$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $cNnl8._)((0, $dok7x._)({}, globalHistory.state), {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $7c6a1aaf94a1ce95$var$isLocation(to) ? to : $7c6a1aaf94a1ce95$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $7c6a1aaf94a1ce95$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $7c6a1aaf94a1ce95$var$isLocation(to) ? to : $7c6a1aaf94a1ce95$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $7c6a1aaf94a1ce95$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $7c6a1aaf94a1ce95$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($7c6a1aaf94a1ce95$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($7c6a1aaf94a1ce95$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $7c6a1aaf94a1ce95$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $7c6a1aaf94a1ce95$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $7c6a1aaf94a1ce95$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $7c6a1aaf94a1ce95$var$_map;
var $7c6a1aaf94a1ce95$export$b8d3e69d4b3eff04 = class {
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($7c6a1aaf94a1ce95$var$__privateGet(this, $7c6a1aaf94a1ce95$var$_map).has(context)) return $7c6a1aaf94a1ce95$var$__privateGet(this, $7c6a1aaf94a1ce95$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $7c6a1aaf94a1ce95$var$__privateGet(this, $7c6a1aaf94a1ce95$var$_map).set(context, value);
    }
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $7c6a1aaf94a1ce95$var$__privateAdd(this, $7c6a1aaf94a1ce95$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
};
$7c6a1aaf94a1ce95$var$_map = new WeakMap();
var $7c6a1aaf94a1ce95$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $7c6a1aaf94a1ce95$var$isUnsupportedLazyRouteObjectKey(key) {
    return $7c6a1aaf94a1ce95$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $7c6a1aaf94a1ce95$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $7c6a1aaf94a1ce95$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $7c6a1aaf94a1ce95$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $7c6a1aaf94a1ce95$var$isIndexRoute(route) {
    return route.index === true;
}
function $7c6a1aaf94a1ce95$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($7c6a1aaf94a1ce95$var$isIndexRoute(route)) {
            let indexRoute = (0, $cNnl8._)((0, $dok7x._)({}, route), {
                id: id
            });
            manifest[id] = $7c6a1aaf94a1ce95$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = (0, $cNnl8._)((0, $dok7x._)({}, route), {
                id: id,
                children: void 0
            });
            manifest[id] = $7c6a1aaf94a1ce95$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $7c6a1aaf94a1ce95$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $7c6a1aaf94a1ce95$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, (0, $dok7x._)({}, updates, typeof updates.lazy === "object" && updates.lazy != null ? {
        lazy: (0, $dok7x._)({}, route.lazy, updates.lazy)
    } : {}));
}
function $7c6a1aaf94a1ce95$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $7c6a1aaf94a1ce95$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $7c6a1aaf94a1ce95$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches !== null && precomputedBranches !== void 0 ? precomputedBranches : $7c6a1aaf94a1ce95$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $7c6a1aaf94a1ce95$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $7c6a1aaf94a1ce95$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $7c6a1aaf94a1ce95$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $7c6a1aaf94a1ce95$var$flattenAndRankRoutes(routes) {
    let branches = $7c6a1aaf94a1ce95$var$flattenRoutes(routes);
    $7c6a1aaf94a1ce95$var$rankRouteBranches(branches);
    return branches;
}
function $7c6a1aaf94a1ce95$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $7c6a1aaf94a1ce95$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $7c6a1aaf94a1ce95$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $7c6a1aaf94a1ce95$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $7c6a1aaf94a1ce95$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $7c6a1aaf94a1ce95$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route_path;
        if (route.path === "" || !((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $7c6a1aaf94a1ce95$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $7c6a1aaf94a1ce95$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $7c6a1aaf94a1ce95$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $7c6a1aaf94a1ce95$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $7c6a1aaf94a1ce95$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $7c6a1aaf94a1ce95$var$paramRe = /^:[\w-]+$/;
var $7c6a1aaf94a1ce95$var$dynamicSegmentValue = 3;
var $7c6a1aaf94a1ce95$var$indexRouteValue = 2;
var $7c6a1aaf94a1ce95$var$emptySegmentValue = 1;
var $7c6a1aaf94a1ce95$var$staticSegmentValue = 10;
var $7c6a1aaf94a1ce95$var$splatPenalty = -2;
var $7c6a1aaf94a1ce95$var$isSplat = (s)=>s === "*";
function $7c6a1aaf94a1ce95$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($7c6a1aaf94a1ce95$var$isSplat)) initialScore += $7c6a1aaf94a1ce95$var$splatPenalty;
    if (index) initialScore += $7c6a1aaf94a1ce95$var$indexRouteValue;
    return segments.filter((s)=>!$7c6a1aaf94a1ce95$var$isSplat(s)).reduce((score, segment)=>score + ($7c6a1aaf94a1ce95$var$paramRe.test(segment) ? $7c6a1aaf94a1ce95$var$dynamicSegmentValue : segment === "" ? $7c6a1aaf94a1ce95$var$emptySegmentValue : $7c6a1aaf94a1ce95$var$staticSegmentValue), initialScore);
}
function $7c6a1aaf94a1ce95$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $7c6a1aaf94a1ce95$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $7c6a1aaf94a1ce95$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $7c6a1aaf94a1ce95$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $7c6a1aaf94a1ce95$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $7c6a1aaf94a1ce95$var$normalizePathname($7c6a1aaf94a1ce95$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $7c6a1aaf94a1ce95$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $7c6a1aaf94a1ce95$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $7c6a1aaf94a1ce95$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $7c6a1aaf94a1ce95$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $7c6a1aaf94a1ce95$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $7c6a1aaf94a1ce95$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $7c6a1aaf94a1ce95$var$compilePath(path, caseSensitive = false, end = true) {
    $7c6a1aaf94a1ce95$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $7c6a1aaf94a1ce95$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $7c6a1aaf94a1ce95$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $7c6a1aaf94a1ce95$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $7c6a1aaf94a1ce95$var$joinPaths([
        basename,
        pathname
    ]);
}
var $7c6a1aaf94a1ce95$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $7c6a1aaf94a1ce95$var$isAbsoluteUrl = (url)=>$7c6a1aaf94a1ce95$var$ABSOLUTE_URL_REGEX.test(url);
function $7c6a1aaf94a1ce95$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $7c6a1aaf94a1ce95$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $7c6a1aaf94a1ce95$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $7c6a1aaf94a1ce95$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $7c6a1aaf94a1ce95$var$normalizeSearch(search),
        hash: $7c6a1aaf94a1ce95$var$normalizeHash(hash)
    };
}
function $7c6a1aaf94a1ce95$var$resolvePathname(relativePath, fromPathname) {
    let segments = $7c6a1aaf94a1ce95$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $7c6a1aaf94a1ce95$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $7c6a1aaf94a1ce95$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $7c6a1aaf94a1ce95$var$getResolveToMatches(matches) {
    let pathMatches = $7c6a1aaf94a1ce95$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $7c6a1aaf94a1ce95$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(toArg);
    else {
        to = (0, $dok7x._)({}, toArg);
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $7c6a1aaf94a1ce95$var$getInvalidPathError("?", "pathname", "search", to));
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $7c6a1aaf94a1ce95$var$getInvalidPathError("#", "pathname", "hash", to));
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $7c6a1aaf94a1ce95$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $7c6a1aaf94a1ce95$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $7c6a1aaf94a1ce95$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
var $7c6a1aaf94a1ce95$var$joinPaths = (paths)=>$7c6a1aaf94a1ce95$var$removeDoubleSlashes(paths.join("/"));
var $7c6a1aaf94a1ce95$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $7c6a1aaf94a1ce95$var$normalizePathname = (pathname)=>$7c6a1aaf94a1ce95$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $7c6a1aaf94a1ce95$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $7c6a1aaf94a1ce95$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $7c6a1aaf94a1ce95$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $7c6a1aaf94a1ce95$export$4051a07651545597(data2, init) {
    return new $7c6a1aaf94a1ce95$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $7c6a1aaf94a1ce95$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, (0, $cNnl8._)((0, $dok7x._)({}, responseInit), {
        headers: headers
    }));
};
var $7c6a1aaf94a1ce95$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $7c6a1aaf94a1ce95$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $7c6a1aaf94a1ce95$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $7c6a1aaf94a1ce95$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $7c6a1aaf94a1ce95$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $7c6a1aaf94a1ce95$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $7c6a1aaf94a1ce95$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $7c6a1aaf94a1ce95$var$joinPaths(parts) || "/";
}
var $7c6a1aaf94a1ce95$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $7c6a1aaf94a1ce95$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$7c6a1aaf94a1ce95$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($7c6a1aaf94a1ce95$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $7c6a1aaf94a1ce95$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $7c6a1aaf94a1ce95$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $7c6a1aaf94a1ce95$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $7c6a1aaf94a1ce95$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $7c6a1aaf94a1ce95$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            var _handler_UninstrumentedSymbol;
            let original = (_handler_UninstrumentedSymbol = handler[$7c6a1aaf94a1ce95$var$UninstrumentedSymbol]) !== null && _handler_UninstrumentedSymbol !== void 0 ? _handler_UninstrumentedSymbol : handler;
            let instrumented = $7c6a1aaf94a1ce95$var$wrapImpl(aggregated[key], original, (...args)=>$7c6a1aaf94a1ce95$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$7c6a1aaf94a1ce95$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        var _middleware_UninstrumentedSymbol;
        let original = (_middleware_UninstrumentedSymbol = middleware[$7c6a1aaf94a1ce95$var$UninstrumentedSymbol]) !== null && _middleware_UninstrumentedSymbol !== void 0 ? _middleware_UninstrumentedSymbol : middleware;
        let instrumented = $7c6a1aaf94a1ce95$var$wrapImpl(aggregated.middleware, original, (...args)=>$7c6a1aaf94a1ce95$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$7c6a1aaf94a1ce95$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $7c6a1aaf94a1ce95$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        var _router_navigate_UninstrumentedSymbol;
        let navigate = (_router_navigate_UninstrumentedSymbol = router.navigate[$7c6a1aaf94a1ce95$var$UninstrumentedSymbol]) !== null && _router_navigate_UninstrumentedSymbol !== void 0 ? _router_navigate_UninstrumentedSymbol : router.navigate;
        let instrumentedNavigate = $7c6a1aaf94a1ce95$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return (0, $dok7x._)({
                to: typeof to === "number" || typeof to === "string" ? to : to ? $7c6a1aaf94a1ce95$export$fe53371bee54353d(to) : "."
            }, $7c6a1aaf94a1ce95$var$getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {}));
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$7c6a1aaf94a1ce95$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        var _router_fetch_UninstrumentedSymbol;
        let fetch2 = (_router_fetch_UninstrumentedSymbol = router.fetch[$7c6a1aaf94a1ce95$var$UninstrumentedSymbol]) !== null && _router_fetch_UninstrumentedSymbol !== void 0 ? _router_fetch_UninstrumentedSymbol : router.fetch;
        let instrumentedFetch = $7c6a1aaf94a1ce95$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return (0, $dok7x._)({
                href: href !== null && href !== void 0 ? href : ".",
                fetcherKey: key
            }, $7c6a1aaf94a1ce95$var$getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {}));
        });
        if (instrumentedFetch) {
            instrumentedFetch[$7c6a1aaf94a1ce95$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $7c6a1aaf94a1ce95$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $7c6a1aaf94a1ce95$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $7c6a1aaf94a1ce95$var$getReadonlyRequest(request),
            context: context != null ? $7c6a1aaf94a1ce95$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $7c6a1aaf94a1ce95$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $7c6a1aaf94a1ce95$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $7c6a1aaf94a1ce95$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $7c6a1aaf94a1ce95$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $7c6a1aaf94a1ce95$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $7c6a1aaf94a1ce95$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $7c6a1aaf94a1ce95$var$getReadonlyRequest(request),
        params: (0, $dok7x._)({}, params),
        pattern: pattern,
        context: $7c6a1aaf94a1ce95$var$getReadonlyContext(context)
    };
}
function $7c6a1aaf94a1ce95$var$getRouterInfo(router, opts) {
    return (0, $dok7x._)({
        currentUrl: $7c6a1aaf94a1ce95$export$fe53371bee54353d(router.state.location)
    }, "formMethod" in opts ? {
        formMethod: opts.formMethod
    } : {}, "formEncType" in opts ? {
        formEncType: opts.formEncType
    } : {}, "formData" in opts ? {
        formData: opts.formData
    } : {}, "body" in opts ? {
        body: opts.body
    } : {});
}
function $7c6a1aaf94a1ce95$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $7c6a1aaf94a1ce95$var$getReadonlyContext(context) {
    if ($7c6a1aaf94a1ce95$var$isPlainObject(context)) {
        let frozen = (0, $dok7x._)({}, context);
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $7c6a1aaf94a1ce95$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $7c6a1aaf94a1ce95$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $7c6a1aaf94a1ce95$var$objectProtoNames;
}
// lib/router/router.ts
var $7c6a1aaf94a1ce95$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $7c6a1aaf94a1ce95$var$validMutationMethods = new Set($7c6a1aaf94a1ce95$var$validMutationMethodsArr);
var $7c6a1aaf94a1ce95$var$validRequestMethodsArr = [
    "GET",
    ...$7c6a1aaf94a1ce95$var$validMutationMethodsArr
];
var $7c6a1aaf94a1ce95$var$validRequestMethods = new Set($7c6a1aaf94a1ce95$var$validRequestMethodsArr);
var $7c6a1aaf94a1ce95$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $7c6a1aaf94a1ce95$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $7c6a1aaf94a1ce95$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $7c6a1aaf94a1ce95$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $7c6a1aaf94a1ce95$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $7c6a1aaf94a1ce95$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $7c6a1aaf94a1ce95$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $7c6a1aaf94a1ce95$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $7c6a1aaf94a1ce95$var$_routes, $7c6a1aaf94a1ce95$var$_branches, $7c6a1aaf94a1ce95$var$_hmrRoutes, $7c6a1aaf94a1ce95$var$_hmrBranches;
var $7c6a1aaf94a1ce95$var$DataRoutes = class {
    /** The stable route tree */ get stableRoutes() {
        return $7c6a1aaf94a1ce95$var$__privateGet(this, $7c6a1aaf94a1ce95$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        var __privateGet1;
        return (__privateGet1 = $7c6a1aaf94a1ce95$var$__privateGet(this, $7c6a1aaf94a1ce95$var$_hmrRoutes)) !== null && __privateGet1 !== void 0 ? __privateGet1 : $7c6a1aaf94a1ce95$var$__privateGet(this, $7c6a1aaf94a1ce95$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        var __privateGet1;
        return (__privateGet1 = $7c6a1aaf94a1ce95$var$__privateGet(this, $7c6a1aaf94a1ce95$var$_hmrBranches)) !== null && __privateGet1 !== void 0 ? __privateGet1 : $7c6a1aaf94a1ce95$var$__privateGet(this, $7c6a1aaf94a1ce95$var$_branches);
    }
    get hasHMRRoutes() {
        return $7c6a1aaf94a1ce95$var$__privateGet(this, $7c6a1aaf94a1ce95$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $7c6a1aaf94a1ce95$var$__privateSet(this, $7c6a1aaf94a1ce95$var$_routes, routes);
        $7c6a1aaf94a1ce95$var$__privateSet(this, $7c6a1aaf94a1ce95$var$_branches, $7c6a1aaf94a1ce95$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $7c6a1aaf94a1ce95$var$__privateSet(this, $7c6a1aaf94a1ce95$var$_hmrRoutes, routes);
        $7c6a1aaf94a1ce95$var$__privateSet(this, $7c6a1aaf94a1ce95$var$_hmrBranches, $7c6a1aaf94a1ce95$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($7c6a1aaf94a1ce95$var$__privateGet(this, $7c6a1aaf94a1ce95$var$_hmrRoutes)) {
            $7c6a1aaf94a1ce95$var$__privateSet(this, $7c6a1aaf94a1ce95$var$_routes, $7c6a1aaf94a1ce95$var$__privateGet(this, $7c6a1aaf94a1ce95$var$_hmrRoutes));
            $7c6a1aaf94a1ce95$var$__privateSet(this, $7c6a1aaf94a1ce95$var$_branches, $7c6a1aaf94a1ce95$var$__privateGet(this, $7c6a1aaf94a1ce95$var$_hmrBranches));
            $7c6a1aaf94a1ce95$var$__privateSet(this, $7c6a1aaf94a1ce95$var$_hmrRoutes, void 0);
            $7c6a1aaf94a1ce95$var$__privateSet(this, $7c6a1aaf94a1ce95$var$_hmrBranches, void 0);
        }
    }
    constructor(routes){
        $7c6a1aaf94a1ce95$var$__privateAdd(this, $7c6a1aaf94a1ce95$var$_routes);
        $7c6a1aaf94a1ce95$var$__privateAdd(this, $7c6a1aaf94a1ce95$var$_branches);
        $7c6a1aaf94a1ce95$var$__privateAdd(this, $7c6a1aaf94a1ce95$var$_hmrRoutes);
        $7c6a1aaf94a1ce95$var$__privateAdd(this, $7c6a1aaf94a1ce95$var$_hmrBranches);
        $7c6a1aaf94a1ce95$var$__privateSet(this, $7c6a1aaf94a1ce95$var$_routes, routes);
        $7c6a1aaf94a1ce95$var$__privateSet(this, $7c6a1aaf94a1ce95$var$_branches, $7c6a1aaf94a1ce95$var$flattenAndRankRoutes(routes));
    }
};
$7c6a1aaf94a1ce95$var$_routes = new WeakMap();
$7c6a1aaf94a1ce95$var$_branches = new WeakMap();
$7c6a1aaf94a1ce95$var$_hmrRoutes = new WeakMap();
$7c6a1aaf94a1ce95$var$_hmrBranches = new WeakMap();
function $7c6a1aaf94a1ce95$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $7c6a1aaf94a1ce95$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return (0, $dok7x._)({}, _mapRouteProperties(route), $7c6a1aaf94a1ce95$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route));
        };
    }
    let manifest = {};
    let dataRoutes = new $7c6a1aaf94a1ce95$var$DataRoutes($7c6a1aaf94a1ce95$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $7c6a1aaf94a1ce95$var$defaultDataStrategyWithMiddleware;
    let future = (0, $dok7x._)({}, init.future);
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $7c6a1aaf94a1ce95$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $7c6a1aaf94a1ce95$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $7c6a1aaf94a1ce95$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$7c6a1aaf94a1ce95$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $7c6a1aaf94a1ce95$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $7c6a1aaf94a1ce95$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $7c6a1aaf94a1ce95$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $7c6a1aaf94a1ce95$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $7c6a1aaf94a1ce95$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$7c6a1aaf94a1ce95$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return (0, $cNnl8._)((0, $dok7x._)({}, m), {
                route: route
            });
            return m;
        });
        state = (0, $dok7x._)({}, state, newState);
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        var _newState_errors;
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>{
            var _newState_errors;
            return subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        var _location_state, _location_state1;
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $7c6a1aaf94a1ce95$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $7c6a1aaf94a1ce95$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $7c6a1aaf94a1ce95$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $7c6a1aaf94a1ce95$export$cbae47800eb95bc3(state.navigation.formMethod) && ((_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1._isRedirect) !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState((0, $cNnl8._)((0, $dok7x._)({}, newState), {
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $7c6a1aaf94a1ce95$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd === null || pendingRevalidationDfd === void 0 ? void 0 : pendingRevalidationDfd.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $7c6a1aaf94a1ce95$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $7c6a1aaf94a1ce95$var$normalizeTo(state.location, state.matches, basename, to, opts === null || opts === void 0 ? void 0 : opts.fromRouteId, opts === null || opts === void 0 ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $7c6a1aaf94a1ce95$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts === null || opts === void 0 ? void 0 : opts.mask) {
            let partialPath = typeof opts.mask === "string" ? $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(opts.mask) : (0, $dok7x._)({}, state.location.mask, opts.mask);
            maskPath = (0, $dok7x._)({
                pathname: "",
                search: "",
                hash: ""
            }, partialPath);
        }
        let currentLocation = state.location;
        let nextLocation = $7c6a1aaf94a1ce95$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = (0, $dok7x._)({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $7c6a1aaf94a1ce95$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $7c6a1aaf94a1ce95$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $7c6a1aaf94a1ce95$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = (opts === null || opts === void 0 ? void 0 : opts.initialHydration) && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $7c6a1aaf94a1ce95$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $7c6a1aaf94a1ce95$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $7c6a1aaf94a1ce95$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? (0, $cNnl8._)((0, $dok7x._)({}, opts.overrideNavigation), {
            matches: matches,
            historyAction: historyAction
        }) : void 0;
        pendingNavigationController = new AbortController();
        let request = $7c6a1aaf94a1ce95$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $7c6a1aaf94a1ce95$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $7c6a1aaf94a1ce95$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $7c6a1aaf94a1ce95$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($7c6a1aaf94a1ce95$var$isErrorResult(result) && $7c6a1aaf94a1ce95$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $7c6a1aaf94a1ce95$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $7c6a1aaf94a1ce95$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, (0, $dok7x._)((0, $cNnl8._)((0, $dok7x._)({
            matches: updatedMatches || matches
        }, $7c6a1aaf94a1ce95$var$getActionDataForCommit(pendingActionResult)), {
            loaderData: loaderData,
            errors: errors
        }), workingFetchers ? {
            fetchers: workingFetchers
        } : {}));
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $7c6a1aaf94a1ce95$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $7c6a1aaf94a1ce95$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $7c6a1aaf94a1ce95$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $7c6a1aaf94a1ce95$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $7c6a1aaf94a1ce95$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $7c6a1aaf94a1ce95$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($7c6a1aaf94a1ce95$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $7c6a1aaf94a1ce95$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($7c6a1aaf94a1ce95$var$isErrorResult(result)) {
            let boundaryMatch = $7c6a1aaf94a1ce95$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $7c6a1aaf94a1ce95$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $7c6a1aaf94a1ce95$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState((0, $dok7x._)({
                    navigation: loadingNavigation
                }, actionData !== void 0 ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $7c6a1aaf94a1ce95$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $7c6a1aaf94a1ce95$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $7c6a1aaf94a1ce95$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, (0, $dok7x._)({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $7c6a1aaf94a1ce95$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $7c6a1aaf94a1ce95$var$getActionDataForCommit(pendingActionResult), didUpdateFetcherRedirects2 ? {
                fetchers: workingFetchers2
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $7c6a1aaf94a1ce95$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $7c6a1aaf94a1ce95$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $7c6a1aaf94a1ce95$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = (0, $dok7x._)({}, state.errors, errors);
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return (0, $dok7x._)({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            workingFetchers: workingFetchers
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$7c6a1aaf94a1ce95$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $7c6a1aaf94a1ce95$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $7c6a1aaf94a1ce95$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts === null || opts === void 0 ? void 0 : opts.relative);
        let matches = $7c6a1aaf94a1ce95$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $7c6a1aaf94a1ce95$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $7c6a1aaf94a1ce95$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $7c6a1aaf94a1ce95$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $7c6a1aaf94a1ce95$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $7c6a1aaf94a1ce95$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $7c6a1aaf94a1ce95$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $7c6a1aaf94a1ce95$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $7c6a1aaf94a1ce95$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $7c6a1aaf94a1ce95$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $7c6a1aaf94a1ce95$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($7c6a1aaf94a1ce95$var$isRedirectResult(actionResult) || $7c6a1aaf94a1ce95$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $7c6a1aaf94a1ce95$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($7c6a1aaf94a1ce95$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $7c6a1aaf94a1ce95$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $7c6a1aaf94a1ce95$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($7c6a1aaf94a1ce95$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $7c6a1aaf94a1ce95$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $7c6a1aaf94a1ce95$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $7c6a1aaf94a1ce95$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $7c6a1aaf94a1ce95$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $7c6a1aaf94a1ce95$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $7c6a1aaf94a1ce95$var$getDoneFetcher(actionResult.data));
            return (0, $cNnl8._)((0, $dok7x._)({}, s), {
                fetchers: workingFetchers2
            });
        };
        let redirect2 = $7c6a1aaf94a1ce95$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $7c6a1aaf94a1ce95$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $7c6a1aaf94a1ce95$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $7c6a1aaf94a1ce95$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $7c6a1aaf94a1ce95$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $7c6a1aaf94a1ce95$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $7c6a1aaf94a1ce95$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $7c6a1aaf94a1ce95$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $7c6a1aaf94a1ce95$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $7c6a1aaf94a1ce95$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $7c6a1aaf94a1ce95$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $7c6a1aaf94a1ce95$var$getDoneFetcher(void 0));
            return;
        }
        if ($7c6a1aaf94a1ce95$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $7c6a1aaf94a1ce95$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($7c6a1aaf94a1ce95$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $7c6a1aaf94a1ce95$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $7c6a1aaf94a1ce95$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $7c6a1aaf94a1ce95$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($7c6a1aaf94a1ce95$var$isAbsoluteUrl(location)) {
                const url = $7c6a1aaf94a1ce95$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $7c6a1aaf94a1ce95$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($7c6a1aaf94a1ce95$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $7c6a1aaf94a1ce95$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: (0, $cNnl8._)((0, $dok7x._)({}, activeSubmission), {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $7c6a1aaf94a1ce95$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $7c6a1aaf94a1ce95$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$7c6a1aaf94a1ce95$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            var _results_match_route_id;
            if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.type) === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($7c6a1aaf94a1ce95$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $7c6a1aaf94a1ce95$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $7c6a1aaf94a1ce95$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $7c6a1aaf94a1ce95$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $7c6a1aaf94a1ce95$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $7c6a1aaf94a1ce95$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts === null || opts === void 0 ? void 0 : opts.reason);
        updateFetcherState(key, $7c6a1aaf94a1ce95$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $7c6a1aaf94a1ce95$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $7c6a1aaf94a1ce95$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $7c6a1aaf94a1ce95$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $7c6a1aaf94a1ce95$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $7c6a1aaf94a1ce95$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $7c6a1aaf94a1ce95$export$386d57f03f0b2883;
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $7c6a1aaf94a1ce95$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $7c6a1aaf94a1ce95$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $7c6a1aaf94a1ce95$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $7c6a1aaf94a1ce95$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$7c6a1aaf94a1ce95$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $7c6a1aaf94a1ce95$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $7c6a1aaf94a1ce95$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $7c6a1aaf94a1ce95$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $7c6a1aaf94a1ce95$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $7c6a1aaf94a1ce95$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $7c6a1aaf94a1ce95$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($7c6a1aaf94a1ce95$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $7c6a1aaf94a1ce95$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $7c6a1aaf94a1ce95$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $7c6a1aaf94a1ce95$export$3336b097a6fbc59a(routes, opts) {
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = (opts === null || opts === void 0 ? void 0 : opts.mapRouteProperties) || $7c6a1aaf94a1ce95$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = (0, $dok7x._)({}, opts === null || opts === void 0 ? void 0 : opts.future);
    if (opts === null || opts === void 0 ? void 0 : opts.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return (0, $dok7x._)({}, _mapRouteProperties(route), $7c6a1aaf94a1ce95$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route));
        };
    }
    let dataRoutes = $7c6a1aaf94a1ce95$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $7c6a1aaf94a1ce95$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $7c6a1aaf94a1ce95$var$defaultNormalizePath;
        let method = request.method;
        let location = $7c6a1aaf94a1ce95$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $7c6a1aaf94a1ce95$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $7c6a1aaf94a1ce95$export$b8d3e69d4b3eff04();
        if (!$7c6a1aaf94a1ce95$var$isValidMethod(method) && method !== "HEAD") {
            let error = $7c6a1aaf94a1ce95$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $7c6a1aaf94a1ce95$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $7c6a1aaf94a1ce95$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $7c6a1aaf94a1ce95$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $7c6a1aaf94a1ce95$export$f5708dca728d7177(requestContext instanceof $7c6a1aaf94a1ce95$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $7c6a1aaf94a1ce95$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $7c6a1aaf94a1ce95$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $7c6a1aaf94a1ce95$var$createDataFunctionUrl(request, location),
                    pattern: $7c6a1aaf94a1ce95$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        var _opts2_filterMatchesToLoad;
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? (_opts2_filterMatchesToLoad = opts2.filterMatchesToLoad) !== null && _opts2_filterMatchesToLoad !== void 0 ? _opts2_filterMatchesToLoad : null : filterMatchesToLoad !== null && filterMatchesToLoad !== void 0 ? filterMatchesToLoad : null, skipRevalidation === true);
                        if ($7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = (0, $dok7x._)({
                            location: location,
                            basename: basename
                        }, result2);
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($7c6a1aaf94a1ce95$export$6e80290866a84dd4(error)) return error;
                    if ($7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $7c6a1aaf94a1ce95$export$f2680fa305b734ca(error.status, error.statusText, await $7c6a1aaf94a1ce95$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($7c6a1aaf94a1ce95$export$e0163cfdf7bc9cfa(error)) error = $7c6a1aaf94a1ce95$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $7c6a1aaf94a1ce95$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $7c6a1aaf94a1ce95$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        var _matches_find;
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $7c6a1aaf94a1ce95$var$findNearestBoundary(matches, ((_matches_find = matches.find((m)=>m.route.id === routeId || m.route.loader)) === null || _matches_find === void 0 ? void 0 : _matches_find.route.id) || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $7c6a1aaf94a1ce95$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $7c6a1aaf94a1ce95$export$f5708dca728d7177($7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(result)) return result;
        return (0, $dok7x._)({
            location: location,
            basename: basename
        }, result);
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $7c6a1aaf94a1ce95$var$defaultNormalizePath;
        let method = request.method;
        let location = $7c6a1aaf94a1ce95$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $7c6a1aaf94a1ce95$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $7c6a1aaf94a1ce95$export$b8d3e69d4b3eff04();
        if (!$7c6a1aaf94a1ce95$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $7c6a1aaf94a1ce95$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $7c6a1aaf94a1ce95$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $7c6a1aaf94a1ce95$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $7c6a1aaf94a1ce95$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $7c6a1aaf94a1ce95$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $7c6a1aaf94a1ce95$export$f5708dca728d7177(requestContext instanceof $7c6a1aaf94a1ce95$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $7c6a1aaf94a1ce95$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $7c6a1aaf94a1ce95$var$runServerMiddlewarePipeline({
                request: request,
                url: $7c6a1aaf94a1ce95$var$createDataFunctionUrl(request, location),
                pattern: $7c6a1aaf94a1ce95$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($7c6a1aaf94a1ce95$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($7c6a1aaf94a1ce95$var$dataWithResponseInitToResponse(error));
                if ($7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($7c6a1aaf94a1ce95$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $7c6a1aaf94a1ce95$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(result) ? result : (0, $cNnl8._)((0, $dok7x._)({}, result), {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            if ($7c6a1aaf94a1ce95$var$isDataStrategyResult(e) && $7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($7c6a1aaf94a1ce95$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $7c6a1aaf94a1ce95$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $7c6a1aaf94a1ce95$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $7c6a1aaf94a1ce95$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($7c6a1aaf94a1ce95$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($7c6a1aaf94a1ce95$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($7c6a1aaf94a1ce95$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $7c6a1aaf94a1ce95$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $7c6a1aaf94a1ce95$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: (0, $dok7x._)({}, result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}),
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($7c6a1aaf94a1ce95$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $7c6a1aaf94a1ce95$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return (0, $cNnl8._)((0, $dok7x._)({}, handlerContext2), {
                statusCode: $7c6a1aaf94a1ce95$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: (0, $dok7x._)({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return (0, $cNnl8._)((0, $dok7x._)((0, $cNnl8._)((0, $dok7x._)({}, handlerContext), {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }), result.statusCode ? {
            statusCode: result.statusCode
        } : {}), {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.loader) && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.lazy)) throw $7c6a1aaf94a1ce95$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $7c6a1aaf94a1ce95$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $7c6a1aaf94a1ce95$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $7c6a1aaf94a1ce95$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $7c6a1aaf94a1ce95$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $7c6a1aaf94a1ce95$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $7c6a1aaf94a1ce95$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $7c6a1aaf94a1ce95$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $7c6a1aaf94a1ce95$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return (0, $cNnl8._)((0, $dok7x._)({}, handlerContext), {
            matches: matches
        });
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $7c6a1aaf94a1ce95$var$callDataStrategyImpl(dataStrategy || $7c6a1aaf94a1ce95$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($7c6a1aaf94a1ce95$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $7c6a1aaf94a1ce95$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($7c6a1aaf94a1ce95$export$e0163cfdf7bc9cfa(result.result)) throw $7c6a1aaf94a1ce95$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $7c6a1aaf94a1ce95$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $7c6a1aaf94a1ce95$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return (0, $cNnl8._)((0, $dok7x._)({}, handlerContext), {
        statusCode: $7c6a1aaf94a1ce95$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    });
}
function $7c6a1aaf94a1ce95$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $7c6a1aaf94a1ce95$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $7c6a1aaf94a1ce95$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $7c6a1aaf94a1ce95$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $7c6a1aaf94a1ce95$var$resolveTo(to ? to : ".", $7c6a1aaf94a1ce95$var$getResolveToMatches(contextualMatches), $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $7c6a1aaf94a1ce95$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $7c6a1aaf94a1ce95$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $7c6a1aaf94a1ce95$export$fe53371bee54353d(path);
}
function $7c6a1aaf94a1ce95$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$7c6a1aaf94a1ce95$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$7c6a1aaf94a1ce95$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $7c6a1aaf94a1ce95$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $7c6a1aaf94a1ce95$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $7c6a1aaf94a1ce95$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$7c6a1aaf94a1ce95$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$7c6a1aaf94a1ce95$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $7c6a1aaf94a1ce95$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $7c6a1aaf94a1ce95$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $7c6a1aaf94a1ce95$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $7c6a1aaf94a1ce95$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($7c6a1aaf94a1ce95$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $7c6a1aaf94a1ce95$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $7c6a1aaf94a1ce95$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $7c6a1aaf94a1ce95$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    var _state_matches_;
    let actionResult = pendingActionResult ? $7c6a1aaf94a1ce95$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $7c6a1aaf94a1ce95$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = (0, $cNnl8._)((0, $dok7x._)({
        currentUrl: currentUrl,
        currentParams: ((_state_matches_ = state.matches[0]) === null || _state_matches_ === void 0 ? void 0 : _state_matches_.params) || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params
    }, submission), {
        actionResult: actionResult,
        actionStatus: actionStatus
    });
    let pattern = $7c6a1aaf94a1ce95$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$7c6a1aaf94a1ce95$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $7c6a1aaf94a1ce95$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($7c6a1aaf94a1ce95$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $7c6a1aaf94a1ce95$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($7c6a1aaf94a1ce95$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = (0, $cNnl8._)((0, $dok7x._)({}, baseShouldRevalidateArgs), {
            defaultShouldRevalidate: defaultShouldRevalidate
        });
        let shouldLoad = $7c6a1aaf94a1ce95$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $7c6a1aaf94a1ce95$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $7c6a1aaf94a1ce95$export$5c7b09132f833c25(routesToUse, f.path, basename !== null && basename !== void 0 ? basename : "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $7c6a1aaf94a1ce95$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $7c6a1aaf94a1ce95$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $7c6a1aaf94a1ce95$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $7c6a1aaf94a1ce95$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = (0, $cNnl8._)((0, $dok7x._)({}, baseShouldRevalidateArgs), {
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            if ($7c6a1aaf94a1ce95$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $7c6a1aaf94a1ce95$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $7c6a1aaf94a1ce95$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $7c6a1aaf94a1ce95$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$7c6a1aaf94a1ce95$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $7c6a1aaf94a1ce95$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $7c6a1aaf94a1ce95$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $7c6a1aaf94a1ce95$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $7c6a1aaf94a1ce95$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$7c6a1aaf94a1ce95$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $7c6a1aaf94a1ce95$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String((childrenToPatch === null || childrenToPatch === void 0 ? void 0 : childrenToPatch.length) || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $7c6a1aaf94a1ce95$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $7c6a1aaf94a1ce95$var$isSameRoute(newRoute, existingRoute) {
    var _newRoute_children;
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    var _newRoute_children_every;
    return (_newRoute_children_every = (_newRoute_children = newRoute.children) === null || _newRoute_children === void 0 ? void 0 : _newRoute_children.every((aChild, i)=>{
        var _existingRoute_children;
        return (_existingRoute_children = existingRoute.children) === null || _existingRoute_children === void 0 ? void 0 : _existingRoute_children.some((bChild)=>$7c6a1aaf94a1ce95$var$isSameRoute(aChild, bChild));
    })) !== null && _newRoute_children_every !== void 0 ? _newRoute_children_every : false;
}
var $7c6a1aaf94a1ce95$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $7c6a1aaf94a1ce95$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $7c6a1aaf94a1ce95$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $7c6a1aaf94a1ce95$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $7c6a1aaf94a1ce95$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $7c6a1aaf94a1ce95$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $7c6a1aaf94a1ce95$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $7c6a1aaf94a1ce95$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $7c6a1aaf94a1ce95$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $7c6a1aaf94a1ce95$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $7c6a1aaf94a1ce95$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $7c6a1aaf94a1ce95$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $7c6a1aaf94a1ce95$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $7c6a1aaf94a1ce95$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, (0, $cNnl8._)((0, $dok7x._)({}, mapRouteProperties2(routeToUpdate)), {
                lazy: void 0
            }));
        })();
        $7c6a1aaf94a1ce95$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $7c6a1aaf94a1ce95$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise === null || lazyRoutePromise === void 0 ? void 0 : lazyRoutePromise.catch(()=>{});
    lazyHandlerPromise === null || lazyHandlerPromise === void 0 ? void 0 : lazyHandlerPromise.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $7c6a1aaf94a1ce95$var$isNonNullable(value) {
    return value !== void 0;
}
function $7c6a1aaf94a1ce95$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $7c6a1aaf94a1ce95$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($7c6a1aaf94a1ce95$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $7c6a1aaf94a1ce95$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $7c6a1aaf94a1ce95$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $7c6a1aaf94a1ce95$var$defaultDataStrategy(args);
    return $7c6a1aaf94a1ce95$var$runClientMiddlewarePipeline(args, ()=>$7c6a1aaf94a1ce95$var$defaultDataStrategy(args));
}
function $7c6a1aaf94a1ce95$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $7c6a1aaf94a1ce95$var$runMiddlewarePipeline(args, handler, processResult, $7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $7c6a1aaf94a1ce95$export$e0163cfdf7bc9cfa(result) ? $7c6a1aaf94a1ce95$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $7c6a1aaf94a1ce95$var$runClientMiddlewarePipeline(args, handler) {
    return $7c6a1aaf94a1ce95$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($7c6a1aaf94a1ce95$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $7c6a1aaf94a1ce95$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $7c6a1aaf94a1ce95$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $7c6a1aaf94a1ce95$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches } = args, dataFnArgs = (0, $6pkKu._)(args, [
        "matches"
    ]);
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $7c6a1aaf94a1ce95$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $7c6a1aaf94a1ce95$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    var _request_signal_reason;
    if (request.signal.aborted) throw (_request_signal_reason = request.signal.reason) !== null && _request_signal_reason !== void 0 ? _request_signal_reason : new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $7c6a1aaf94a1ce95$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result !== null && result !== void 0 ? result : nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $7c6a1aaf94a1ce95$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $7c6a1aaf94a1ce95$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $7c6a1aaf94a1ce95$var$loadLazyRoute(match.route, $7c6a1aaf94a1ce95$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $7c6a1aaf94a1ce95$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $7c6a1aaf94a1ce95$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return (0, $cNnl8._)((0, $dok7x._)({}, match), {
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $7c6a1aaf94a1ce95$var$shouldRevalidateLoader(match, (0, $cNnl8._)((0, $dok7x._)({}, shouldRevalidateArgs), {
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            }));
            if (typeof defaultShouldRevalidate === "boolean") return $7c6a1aaf94a1ce95$var$shouldRevalidateLoader(match, (0, $cNnl8._)((0, $dok7x._)({}, shouldRevalidateArgs), {
                defaultShouldRevalidate: defaultShouldRevalidate
            }));
            return $7c6a1aaf94a1ce95$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$7c6a1aaf94a1ce95$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($7c6a1aaf94a1ce95$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $7c6a1aaf94a1ce95$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.handler,
                lazyRoutePromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    });
}
function $7c6a1aaf94a1ce95$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return (0, $cNnl8._)((0, $dok7x._)({}, match), {
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $7c6a1aaf94a1ce95$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        });
        return $7c6a1aaf94a1ce95$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $7c6a1aaf94a1ce95$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $7c6a1aaf94a1ce95$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>{
        var _m__lazyPromises;
        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
    })) await Promise.all(matches.map((m)=>{
        var _m__lazyPromises;
        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
    }));
    let dataStrategyArgs = {
        request: request,
        url: $7c6a1aaf94a1ce95$var$createDataFunctionUrl(request, path),
        pattern: $7c6a1aaf94a1ce95$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $7c6a1aaf94a1ce95$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb((0, $cNnl8._)((0, $dok7x._)({}, typedDataStrategyArgs), {
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            }));
        });
    };
    let results = await dataStrategyImpl((0, $cNnl8._)((0, $dok7x._)({}, dataStrategyArgs), {
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    }));
    try {
        await Promise.all(matches.flatMap((m)=>{
            var _m__lazyPromises, _m__lazyPromises1;
            return [
                (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.handler,
                (_m__lazyPromises1 = m._lazyPromises) === null || _m__lazyPromises1 === void 0 ? void 0 : _m__lazyPromises1.route
            ];
        }));
    } catch (e) {}
    return results;
}
async function $7c6a1aaf94a1ce95$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $7c6a1aaf94a1ce95$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $7c6a1aaf94a1ce95$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $7c6a1aaf94a1ce95$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $7c6a1aaf94a1ce95$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $7c6a1aaf94a1ce95$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $7c6a1aaf94a1ce95$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    var _result_init, _result_init1;
    let { result: result, type: type } = dataStrategyResult;
    if ($7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $7c6a1aaf94a1ce95$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $7c6a1aaf94a1ce95$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($7c6a1aaf94a1ce95$export$e0163cfdf7bc9cfa(result)) {
            var _result_init2, _result_init3, _result_init4;
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: (_result_init2 = result.init) === null || _result_init2 === void 0 ? void 0 : _result_init2.status,
                headers: ((_result_init3 = result.init) === null || _result_init3 === void 0 ? void 0 : _result_init3.headers) ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $7c6a1aaf94a1ce95$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $7c6a1aaf94a1ce95$export$972111febbeef05b(result) ? result.status : void 0,
                headers: ((_result_init4 = result.init) === null || _result_init4 === void 0 ? void 0 : _result_init4.headers) ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $7c6a1aaf94a1ce95$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($7c6a1aaf94a1ce95$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: (_result_init = result.init) === null || _result_init === void 0 ? void 0 : _result_init.status,
        headers: ((_result_init1 = result.init) === null || _result_init1 === void 0 ? void 0 : _result_init1.headers) ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $7c6a1aaf94a1ce95$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$7c6a1aaf94a1ce95$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $7c6a1aaf94a1ce95$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $7c6a1aaf94a1ce95$export$30ab200a1a0a2def = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $7c6a1aaf94a1ce95$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($7c6a1aaf94a1ce95$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if ($7c6a1aaf94a1ce95$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $7c6a1aaf94a1ce95$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($7c6a1aaf94a1ce95$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $7c6a1aaf94a1ce95$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($7c6a1aaf94a1ce95$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $7c6a1aaf94a1ce95$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $7c6a1aaf94a1ce95$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $7c6a1aaf94a1ce95$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $7c6a1aaf94a1ce95$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $7c6a1aaf94a1ce95$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $7c6a1aaf94a1ce95$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $7c6a1aaf94a1ce95$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(!$7c6a1aaf94a1ce95$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($7c6a1aaf94a1ce95$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $7c6a1aaf94a1ce95$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $7c6a1aaf94a1ce95$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $7c6a1aaf94a1ce95$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $7c6a1aaf94a1ce95$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $7c6a1aaf94a1ce95$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($7c6a1aaf94a1ce95$var$isErrorResult(result)) {
            let boundaryMatch = $7c6a1aaf94a1ce95$var$findNearestBoundary(state.matches, match === null || match === void 0 ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = (0, $cNnl8._)((0, $dok7x._)({}, errors), {
                [boundaryMatch.route.id]: result.error
            });
            workingFetchers.delete(key);
        } else if ($7c6a1aaf94a1ce95$var$isRedirectResult(result)) $7c6a1aaf94a1ce95$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $7c6a1aaf94a1ce95$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $7c6a1aaf94a1ce95$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $7c6a1aaf94a1ce95$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $7c6a1aaf94a1ce95$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $7c6a1aaf94a1ce95$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $7c6a1aaf94a1ce95$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $7c6a1aaf94a1ce95$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $7c6a1aaf94a1ce95$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $7c6a1aaf94a1ce95$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $7c6a1aaf94a1ce95$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($7c6a1aaf94a1ce95$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $7c6a1aaf94a1ce95$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(path) : path;
    return $7c6a1aaf94a1ce95$export$fe53371bee54353d((0, $cNnl8._)((0, $dok7x._)({}, parsedPath), {
        hash: ""
    }));
}
function $7c6a1aaf94a1ce95$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $7c6a1aaf94a1ce95$var$dataWithResponseInitToResponse(data2) {
    var _data2_init;
    return Response.json(data2.data, (_data2_init = data2.init) !== null && _data2_init !== void 0 ? _data2_init : void 0);
}
function $7c6a1aaf94a1ce95$var$dataWithResponseInitToErrorResponse(data2) {
    var _data2_init, _data2_init1;
    var _data2_init_status, _data2_init_statusText;
    return new $7c6a1aaf94a1ce95$export$f2680fa305b734ca((_data2_init_status = (_data2_init = data2.init) === null || _data2_init === void 0 ? void 0 : _data2_init.status) !== null && _data2_init_status !== void 0 ? _data2_init_status : 500, (_data2_init_statusText = (_data2_init1 = data2.init) === null || _data2_init1 === void 0 ? void 0 : _data2_init1.statusText) !== null && _data2_init_statusText !== void 0 ? _data2_init_statusText : "Internal Server Error", data2.data);
}
function $7c6a1aaf94a1ce95$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $7c6a1aaf94a1ce95$var$isDataStrategyResult(value));
}
function $7c6a1aaf94a1ce95$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $7c6a1aaf94a1ce95$var$isRedirectDataStrategyResult(result) {
    return $7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(result.result) && $7c6a1aaf94a1ce95$var$redirectStatusCodes.has(result.result.status);
}
function $7c6a1aaf94a1ce95$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $7c6a1aaf94a1ce95$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $7c6a1aaf94a1ce95$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $7c6a1aaf94a1ce95$export$794b2760043cf8cd(statusCode) {
    return $7c6a1aaf94a1ce95$var$redirectStatusCodes.has(statusCode);
}
function $7c6a1aaf94a1ce95$export$6e80290866a84dd4(result) {
    return $7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(result) && $7c6a1aaf94a1ce95$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $7c6a1aaf94a1ce95$var$isValidMethod(method) {
    return $7c6a1aaf94a1ce95$var$validRequestMethods.has(method.toUpperCase());
}
function $7c6a1aaf94a1ce95$export$cbae47800eb95bc3(method) {
    return $7c6a1aaf94a1ce95$var$validMutationMethods.has(method.toUpperCase());
}
function $7c6a1aaf94a1ce95$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $7c6a1aaf94a1ce95$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $7c6a1aaf94a1ce95$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $7c6a1aaf94a1ce95$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $7c6a1aaf94a1ce95$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $7c6a1aaf94a1ce95$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $7c6a1aaf94a1ce95$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $7c6a1aaf94a1ce95$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $7c6a1aaf94a1ce95$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $7c6a1aaf94a1ce95$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $7c6a1aaf94a1ce95$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($7c6a1aaf94a1ce95$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $7c6a1aaf94a1ce95$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($7c6a1aaf94a1ce95$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $7c6a1aaf94a1ce95$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $7c6a1aaf94a1ce95$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $7c6a1aaf94a1ce95$export$2eeee58951ff3c1c = $7hhBq.createContext(null);
$7c6a1aaf94a1ce95$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $7c6a1aaf94a1ce95$export$315e3ffb01f217 = $7hhBq.createContext(null);
$7c6a1aaf94a1ce95$export$315e3ffb01f217.displayName = "DataRouterState";
var $7c6a1aaf94a1ce95$export$717f757c655223f1 = $7hhBq.createContext(false);
function $7c6a1aaf94a1ce95$var$useIsRSCRouterContext() {
    return $7hhBq.useContext($7c6a1aaf94a1ce95$export$717f757c655223f1);
}
var $7c6a1aaf94a1ce95$export$3681f408decb40d1 = $7hhBq.createContext({
    isTransitioning: false
});
$7c6a1aaf94a1ce95$export$3681f408decb40d1.displayName = "ViewTransition";
var $7c6a1aaf94a1ce95$export$cb3f1df1bef00a39 = $7hhBq.createContext(/* @__PURE__ */ new Map());
$7c6a1aaf94a1ce95$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $7c6a1aaf94a1ce95$var$AwaitContext = $7hhBq.createContext(null);
$7c6a1aaf94a1ce95$var$AwaitContext.displayName = "Await";
var $7c6a1aaf94a1ce95$export$2666c20e15407622 = (props)=>$7hhBq.createElement($7c6a1aaf94a1ce95$var$AwaitContext.Provider, props);
var $7c6a1aaf94a1ce95$export$3044ab7fdabeaee6 = $7hhBq.createContext(null);
$7c6a1aaf94a1ce95$export$3044ab7fdabeaee6.displayName = "Navigation";
var $7c6a1aaf94a1ce95$export$e6a44b110a0c44d3 = $7hhBq.createContext(null);
$7c6a1aaf94a1ce95$export$e6a44b110a0c44d3.displayName = "Location";
var $7c6a1aaf94a1ce95$export$aac280ed165a4397 = $7hhBq.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$7c6a1aaf94a1ce95$export$aac280ed165a4397.displayName = "Route";
var $7c6a1aaf94a1ce95$var$RouteErrorContext = $7hhBq.createContext(null);
$7c6a1aaf94a1ce95$var$RouteErrorContext.displayName = "RouteError";
var $7c6a1aaf94a1ce95$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $7c6a1aaf94a1ce95$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $7c6a1aaf94a1ce95$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $7c6a1aaf94a1ce95$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $7c6a1aaf94a1ce95$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$7c6a1aaf94a1ce95$var$ERROR_DIGEST_BASE}:${$7c6a1aaf94a1ce95$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch (e) {}
}
function $7c6a1aaf94a1ce95$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$7c6a1aaf94a1ce95$var$ERROR_DIGEST_BASE}:${$7c6a1aaf94a1ce95$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $7c6a1aaf94a1ce95$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch (e) {}
}
// lib/hooks.tsx
function $7c6a1aaf94a1ce95$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $7c6a1aaf94a1ce95$export$f5708dca728d7177($7c6a1aaf94a1ce95$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $7c6a1aaf94a1ce95$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $7c6a1aaf94a1ce95$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $7c6a1aaf94a1ce95$export$9c954a9d03d32f4a() {
    return $7hhBq.useContext($7c6a1aaf94a1ce95$export$e6a44b110a0c44d3) != null;
}
function $7c6a1aaf94a1ce95$export$45d76561a5302f2b() {
    $7c6a1aaf94a1ce95$export$f5708dca728d7177($7c6a1aaf94a1ce95$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $7hhBq.useContext($7c6a1aaf94a1ce95$export$e6a44b110a0c44d3).location;
}
function $7c6a1aaf94a1ce95$export$1b3f31771c5d07c() {
    return $7hhBq.useContext($7c6a1aaf94a1ce95$export$e6a44b110a0c44d3).navigationType;
}
function $7c6a1aaf94a1ce95$export$6c330e8992e8a295(pattern) {
    $7c6a1aaf94a1ce95$export$f5708dca728d7177($7c6a1aaf94a1ce95$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    return $7hhBq.useMemo(()=>$7c6a1aaf94a1ce95$export$81336c211d5ff295(pattern, $7c6a1aaf94a1ce95$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $7c6a1aaf94a1ce95$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $7c6a1aaf94a1ce95$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6).static;
    if (!isStatic) $7hhBq.useLayoutEffect(cb);
}
function $7c6a1aaf94a1ce95$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$aac280ed165a4397);
    return isDataRoute ? $7c6a1aaf94a1ce95$var$useNavigateStable() : $7c6a1aaf94a1ce95$var$useNavigateUnstable();
}
function $7c6a1aaf94a1ce95$var$useNavigateUnstable() {
    $7c6a1aaf94a1ce95$export$f5708dca728d7177($7c6a1aaf94a1ce95$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $7hhBq.useContext($7c6a1aaf94a1ce95$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6);
    let { matches: matches } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$aac280ed165a4397);
    let { pathname: locationPathname } = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($7c6a1aaf94a1ce95$var$getResolveToMatches(matches));
    let activeRef = $7hhBq.useRef(false);
    $7c6a1aaf94a1ce95$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7hhBq.useCallback((to, options = {})=>{
        $7c6a1aaf94a1ce95$var$warning(activeRef.current, $7c6a1aaf94a1ce95$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $7c6a1aaf94a1ce95$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $7c6a1aaf94a1ce95$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $7c6a1aaf94a1ce95$var$OutletContext = $7hhBq.createContext(null);
function $7c6a1aaf94a1ce95$export$4138103a3ae699cc() {
    return $7hhBq.useContext($7c6a1aaf94a1ce95$var$OutletContext);
}
function $7c6a1aaf94a1ce95$export$a3be3530d8e40d0b(context) {
    let outlet = $7hhBq.useContext($7c6a1aaf94a1ce95$export$aac280ed165a4397).outlet;
    return $7hhBq.useMemo(()=>outlet && /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $7c6a1aaf94a1ce95$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    var _routeMatch_params;
    return (_routeMatch_params = routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.params) !== null && _routeMatch_params !== void 0 ? _routeMatch_params : {};
}
function $7c6a1aaf94a1ce95$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$aac280ed165a4397);
    let { pathname: locationPathname } = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($7c6a1aaf94a1ce95$var$getResolveToMatches(matches));
    return $7hhBq.useMemo(()=>$7c6a1aaf94a1ce95$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $7c6a1aaf94a1ce95$export$5d3fca4a98652595(routes, locationArg) {
    return $7c6a1aaf94a1ce95$var$useRoutesImpl(routes, locationArg);
}
function $7c6a1aaf94a1ce95$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $7c6a1aaf94a1ce95$export$f5708dca728d7177($7c6a1aaf94a1ce95$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($7c6a1aaf94a1ce95$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $7c6a1aaf94a1ce95$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg_pathname;
        let parsedLocationArg = typeof locationArg === "string" ? $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(parentPathnameBase === "/" || ((_parsedLocationArg_pathname = parsedLocationArg.pathname) === null || _parsedLocationArg_pathname === void 0 ? void 0 : _parsedLocationArg_pathname.startsWith(parentPathnameBase)), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $7c6a1aaf94a1ce95$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($7c6a1aaf94a1ce95$export$945fecf35a8ef089) {
        $7c6a1aaf94a1ce95$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $7c6a1aaf94a1ce95$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $7c6a1aaf94a1ce95$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $7c6a1aaf94a1ce95$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $7c6a1aaf94a1ce95$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: (0, $dok7x._)({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0
            }, location),
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7c6a1aaf94a1ce95$var$DefaultErrorComponent() {
    let error = $7c6a1aaf94a1ce95$export$ed527bf60f6e05f2();
    let message = $7c6a1aaf94a1ce95$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($7c6a1aaf94a1ce95$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, /* @__PURE__ */ $7hhBq.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $7hhBq.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $7hhBq.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $7hhBq.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, /* @__PURE__ */ $7hhBq.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $7hhBq.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $7hhBq.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $7c6a1aaf94a1ce95$var$defaultErrorElement = /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$DefaultErrorComponent, null);
var $7c6a1aaf94a1ce95$var$RenderErrorBoundary = class extends $7hhBq.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $7c6a1aaf94a1ce95$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
};
$7c6a1aaf94a1ce95$var$RenderErrorBoundary.contextType = $7c6a1aaf94a1ce95$export$717f757c655223f1;
var $7c6a1aaf94a1ce95$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $7c6a1aaf94a1ce95$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $7c6a1aaf94a1ce95$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $7c6a1aaf94a1ce95$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $7c6a1aaf94a1ce95$var$parseToInfo(redirect2.location, basename);
            if ($7c6a1aaf94a1ce95$var$isBrowser && !$7c6a1aaf94a1ce95$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $7c6a1aaf94a1ce95$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $7hhBq.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $7c6a1aaf94a1ce95$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $7hhBq.useContext($7c6a1aaf94a1ce95$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $7c6a1aaf94a1ce95$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts === null || dataRouterOpts === void 0 ? void 0 : dataRouterOpts.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState === null || dataRouterState === void 0 ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors === null || errors === void 0 ? void 0 : errors[m.route.id]) !== void 0);
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts === null || dataRouterOpts === void 0 ? void 0 : dataRouterOpts.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        var _dataRouterState_matches_, _dataRouterState_matches;
        var _dataRouterState_matches__params;
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: (_dataRouterState_matches__params = (_dataRouterState_matches = dataRouterState.matches) === null || _dataRouterState_matches === void 0 ? void 0 : (_dataRouterState_matches_ = _dataRouterState_matches[0]) === null || _dataRouterState_matches_ === void 0 ? void 0 : _dataRouterState_matches_.params) !== null && _dataRouterState_matches__params !== void 0 ? _dataRouterState_matches__params : {},
            pattern: $7c6a1aaf94a1ce95$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $7c6a1aaf94a1ce95$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7c6a1aaf94a1ce95$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $7hhBq.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $7c6a1aaf94a1ce95$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $7c6a1aaf94a1ce95$var$useDataRouterContext(hookName) {
    let ctx = $7hhBq.useContext($7c6a1aaf94a1ce95$export$2eeee58951ff3c1c);
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(ctx, $7c6a1aaf94a1ce95$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $7c6a1aaf94a1ce95$var$useDataRouterState(hookName) {
    let state = $7hhBq.useContext($7c6a1aaf94a1ce95$export$315e3ffb01f217);
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(state, $7c6a1aaf94a1ce95$var$getDataRouterConsoleError(hookName));
    return state;
}
function $7c6a1aaf94a1ce95$var$useRouteContext(hookName) {
    let route = $7hhBq.useContext($7c6a1aaf94a1ce95$export$aac280ed165a4397);
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(route, $7c6a1aaf94a1ce95$var$getDataRouterConsoleError(hookName));
    return route;
}
function $7c6a1aaf94a1ce95$var$useCurrentRouteId(hookName) {
    let route = $7c6a1aaf94a1ce95$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $7c6a1aaf94a1ce95$var$useRouteId() {
    return $7c6a1aaf94a1ce95$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $7c6a1aaf94a1ce95$export$d0fd4b7106de2769() {
    let state = $7c6a1aaf94a1ce95$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $7hhBq.useMemo(()=>{
        let _state_navigation = state.navigation, { matches: matches, historyAction: historyAction } = _state_navigation, rest = (0, $6pkKu._)(_state_navigation, [
            "matches",
            "historyAction"
        ]);
        return rest;
    }, [
        state.navigation
    ]);
}
function $7c6a1aaf94a1ce95$export$600dc272ed516c15() {
    let dataRouterContext = $7c6a1aaf94a1ce95$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $7c6a1aaf94a1ce95$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $7hhBq.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $7hhBq.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $7c6a1aaf94a1ce95$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7c6a1aaf94a1ce95$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $7hhBq.useMemo(()=>matches.map((m)=>$7c6a1aaf94a1ce95$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $7c6a1aaf94a1ce95$export$1448a5050d252c4d() {
    let state = $7c6a1aaf94a1ce95$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $7c6a1aaf94a1ce95$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $7c6a1aaf94a1ce95$export$fd5d37484eab868d(routeId) {
    let state = $7c6a1aaf94a1ce95$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $7c6a1aaf94a1ce95$export$fdc00f3f26066d5e() {
    let state = $7c6a1aaf94a1ce95$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $7c6a1aaf94a1ce95$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $7c6a1aaf94a1ce95$export$ed527bf60f6e05f2() {
    var _state_errors;
    let error = $7hhBq.useContext($7c6a1aaf94a1ce95$var$RouteErrorContext);
    let state = $7c6a1aaf94a1ce95$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $7c6a1aaf94a1ce95$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return (_state_errors = state.errors) === null || _state_errors === void 0 ? void 0 : _state_errors[routeId];
}
function $7c6a1aaf94a1ce95$export$78a72ddb39bdd145() {
    let value = $7hhBq.useContext($7c6a1aaf94a1ce95$var$AwaitContext);
    return value === null || value === void 0 ? void 0 : value._data;
}
function $7c6a1aaf94a1ce95$export$17f53340677d5831() {
    let value = $7hhBq.useContext($7c6a1aaf94a1ce95$var$AwaitContext);
    return value === null || value === void 0 ? void 0 : value._error;
}
var $7c6a1aaf94a1ce95$var$blockerId = 0;
function $7c6a1aaf94a1ce95$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7c6a1aaf94a1ce95$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $7c6a1aaf94a1ce95$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $7hhBq.useState("");
    let blockerFunction = $7hhBq.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: (0, $cNnl8._)((0, $dok7x._)({}, currentLocation), {
                pathname: $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: (0, $cNnl8._)((0, $dok7x._)({}, nextLocation), {
                pathname: $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $7hhBq.useEffect(()=>{
        let key = String(++$7c6a1aaf94a1ce95$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $7hhBq.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $7c6a1aaf94a1ce95$export$386d57f03f0b2883;
}
function $7c6a1aaf94a1ce95$var$useNavigateStable() {
    let { router: router } = $7c6a1aaf94a1ce95$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $7c6a1aaf94a1ce95$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $7hhBq.useRef(false);
    $7c6a1aaf94a1ce95$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7hhBq.useCallback(async (to, options = {})=>{
        $7c6a1aaf94a1ce95$var$warning(activeRef.current, $7c6a1aaf94a1ce95$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, (0, $dok7x._)({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $7c6a1aaf94a1ce95$var$alreadyWarned = {};
function $7c6a1aaf94a1ce95$var$warningOnce(key, cond, message) {
    if (!cond && !$7c6a1aaf94a1ce95$var$alreadyWarned[key]) {
        $7c6a1aaf94a1ce95$var$alreadyWarned[key] = true;
        $7c6a1aaf94a1ce95$var$warning(false, message);
    }
}
function $7c6a1aaf94a1ce95$export$3f79f0b98112cf57(...args) {
    var _state_actionData;
    const currentRouteId = $7c6a1aaf94a1ce95$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    var _args_;
    const id = (_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : currentRouteId;
    const state = $7c6a1aaf94a1ce95$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: (_state_actionData = state.actionData) === null || _state_actionData === void 0 ? void 0 : _state_actionData[id]
    };
}
function $7c6a1aaf94a1ce95$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $7c6a1aaf94a1ce95$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $7c6a1aaf94a1ce95$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $7hhBq.useMemo(()=>{
        var _matches_;
        var _matches__params;
        return {
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: (_matches__params = (_matches_ = matches[matches.length - 1]) === null || _matches_ === void 0 ? void 0 : _matches_.params) !== null && _matches__params !== void 0 ? _matches__params : {},
            matches: matches.map((m)=>$7c6a1aaf94a1ce95$var$toRouterStateMatch(m))
        };
    }, [
        location,
        matches,
        type
    ]);
    let pending = $7hhBq.useMemo(()=>{
        var _navigation_matches_;
        if (navigation.state === "idle") return null;
        var _navigation_matches__params;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: (_navigation_matches__params = (_navigation_matches_ = navigation.matches[navigation.matches.length - 1]) === null || _navigation_matches_ === void 0 ? void 0 : _navigation_matches_.params) !== null && _navigation_matches__params !== void 0 ? _navigation_matches__params : {},
            matches: navigation.matches.map((m)=>$7c6a1aaf94a1ce95$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? (0, $cNnl8._)((0, $dok7x._)({}, shared), {
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        }) : (0, $cNnl8._)((0, $dok7x._)({}, shared), {
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        });
    }, [
        navigation
    ]);
    return $7hhBq.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $7c6a1aaf94a1ce95$var$alreadyWarned2 = {};
function $7c6a1aaf94a1ce95$export$5b28268982f175ba(condition, message) {
    if (!condition && !$7c6a1aaf94a1ce95$var$alreadyWarned2[message]) {
        $7c6a1aaf94a1ce95$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $7c6a1aaf94a1ce95$var$USE_OPTIMISTIC = "useOptimistic";
var $7c6a1aaf94a1ce95$var$useOptimisticImpl = $7hhBq[$7c6a1aaf94a1ce95$var$USE_OPTIMISTIC];
var $7c6a1aaf94a1ce95$var$stableUseOptimisticSetter = ()=>void 0;
function $7c6a1aaf94a1ce95$var$useOptimisticSafe(val) {
    if ($7c6a1aaf94a1ce95$var$useOptimisticImpl) return $7c6a1aaf94a1ce95$var$useOptimisticImpl(val);
    else return [
        val,
        $7c6a1aaf94a1ce95$var$stableUseOptimisticSetter
    ];
}
function $7c6a1aaf94a1ce95$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($7c6a1aaf94a1ce95$export$945fecf35a8ef089) {
            if (route.element) $7c6a1aaf94a1ce95$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $7hhBq.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($7c6a1aaf94a1ce95$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $7c6a1aaf94a1ce95$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $7hhBq.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($7c6a1aaf94a1ce95$export$945fecf35a8ef089) {
            if (route.errorElement) $7c6a1aaf94a1ce95$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $7hhBq.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $7c6a1aaf94a1ce95$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $7c6a1aaf94a1ce95$export$f30f7e456d254e83(routes, opts) {
    return $7c6a1aaf94a1ce95$export$baddd0131ee8c05b({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: $7c6a1aaf94a1ce95$export$2b76ad033c6e6d08({
            initialEntries: opts === null || opts === void 0 ? void 0 : opts.initialEntries,
            initialIndex: opts === null || opts === void 0 ? void 0 : opts.initialIndex
        }),
        hydrationData: opts === null || opts === void 0 ? void 0 : opts.hydrationData,
        routes: routes,
        hydrationRouteProperties: $7c6a1aaf94a1ce95$export$e2fd2c03906469db,
        mapRouteProperties: $7c6a1aaf94a1ce95$export$9269a41d8c4635e,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
var $7c6a1aaf94a1ce95$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $7c6a1aaf94a1ce95$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $7c6a1aaf94a1ce95$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $7hhBq.useState(router.state);
    let [state, setOptimisticState] = $7c6a1aaf94a1ce95$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $7hhBq.useState();
    let [vtContext, setVtContext] = $7hhBq.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7hhBq.useState();
    let [transition, setTransition] = $7hhBq.useState();
    let [interruption, setInterruption] = $7hhBq.useState();
    let fetcherData = $7hhBq.useRef(/* @__PURE__ */ new Map());
    let setState = $7hhBq.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>{
            var _newState_matches_;
            var _newState_matches__params;
            return onError(error, {
                location: newState.location,
                params: (_newState_matches__params = (_newState_matches_ = newState.matches[0]) === null || _newState_matches_ === void 0 ? void 0 : _newState_matches_.params) !== null && _newState_matches__params !== void 0 ? _newState_matches__params : {},
                pattern: $7c6a1aaf94a1ce95$var$getRoutePattern(newState.matches)
            });
        });
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $7c6a1aaf94a1ce95$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $7c6a1aaf94a1ce95$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $7hhBq.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$7c6a1aaf94a1ce95$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $7hhBq.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7hhBq.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $7c6a1aaf94a1ce95$var$Deferred());
    }, [
        vtContext
    ]);
    $7hhBq.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $7hhBq.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$7c6a1aaf94a1ce95$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $7hhBq.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $7hhBq.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $7hhBq.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7hhBq.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $7c6a1aaf94a1ce95$var$getOptimisticRouterState(currentState, newState) {
    return (0, $cNnl8._)((0, $dok7x._)({}, currentState), {
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    });
}
var $7c6a1aaf94a1ce95$var$MemoizedDataRoutes = $7hhBq.memo($7c6a1aaf94a1ce95$var$DataRoutes2);
function $7c6a1aaf94a1ce95$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $7c6a1aaf94a1ce95$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $7c6a1aaf94a1ce95$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $7hhBq.useRef();
    if (historyRef.current == null) historyRef.current = $7c6a1aaf94a1ce95$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7hhBq.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7hhBq.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7hhBq.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7hhBq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $7c6a1aaf94a1ce95$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $7c6a1aaf94a1ce95$export$f5708dca728d7177($7c6a1aaf94a1ce95$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6);
    $7c6a1aaf94a1ce95$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$aac280ed165a4397);
    let { pathname: locationPathname } = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let navigate = $7c6a1aaf94a1ce95$export$9770f232ac06a008();
    let path = $7c6a1aaf94a1ce95$var$resolveTo(to, $7c6a1aaf94a1ce95$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7hhBq.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $7c6a1aaf94a1ce95$export$910ae8079b2c2852(props) {
    return $7c6a1aaf94a1ce95$export$a3be3530d8e40d0b(props.context);
}
function $7c6a1aaf94a1ce95$export$e7b0ac011bb776c6(props) {
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $7c6a1aaf94a1ce95$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(!$7c6a1aaf94a1ce95$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7hhBq.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $7hhBq.useMemo(()=>{
        let trailingPathname = $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $7c6a1aaf94a1ce95$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $7c6a1aaf94a1ce95$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $7c6a1aaf94a1ce95$export$5d3fca4a98652595($7c6a1aaf94a1ce95$export$16da398f5434bdec(children), location);
}
function $7c6a1aaf94a1ce95$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $7hhBq.useContext($7c6a1aaf94a1ce95$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $7hhBq.useContext($7c6a1aaf94a1ce95$export$315e3ffb01f217);
    let onError = $7hhBq.useCallback((error, errorInfo)=>{
        var _dataRouterStateContext_matches_;
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: ((_dataRouterStateContext_matches_ = dataRouterStateContext.matches[0]) === null || _dataRouterStateContext_matches_ === void 0 ? void 0 : _dataRouterStateContext_matches_.params) || {},
            pattern: $7c6a1aaf94a1ce95$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$ResolveAwait, null, children));
}
var $7c6a1aaf94a1ce95$var$AwaitErrorBoundary = class extends $7hhBq.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                var _this_props_onError, _this_props;
                (_this_props_onError = (_this_props = this.props).onError) === null || _this_props_onError === void 0 ? void 0 : _this_props_onError.call(_this_props, error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
};
function $7c6a1aaf94a1ce95$var$ResolveAwait({ children: children }) {
    let data2 = $7c6a1aaf94a1ce95$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, toRender);
}
function $7c6a1aaf94a1ce95$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $7hhBq.Children.forEach(children, (element, index)=>{
        if (!$7hhBq.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7hhBq.Fragment) {
            routes.push.apply(routes, $7c6a1aaf94a1ce95$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(element.type === $7c6a1aaf94a1ce95$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7c6a1aaf94a1ce95$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $7c6a1aaf94a1ce95$export$9b5b6d122dea0c88 = $7c6a1aaf94a1ce95$export$16da398f5434bdec;
function $7c6a1aaf94a1ce95$export$daf73786167a7f72(matches) {
    return $7c6a1aaf94a1ce95$var$_renderMatches(matches);
}
function $7c6a1aaf94a1ce95$var$useRouteComponentProps() {
    return {
        params: $7c6a1aaf94a1ce95$export$99eaa27ddbbb95ef(),
        loaderData: $7c6a1aaf94a1ce95$export$1448a5050d252c4d(),
        actionData: $7c6a1aaf94a1ce95$export$fdc00f3f26066d5e(),
        matches: $7c6a1aaf94a1ce95$export$2378eb7f5ff86053()
    };
}
function $7c6a1aaf94a1ce95$export$6c4f3826290c37af({ children: children }) {
    const props = $7c6a1aaf94a1ce95$var$useRouteComponentProps();
    return $7hhBq.cloneElement(children, props);
}
function $7c6a1aaf94a1ce95$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $7c6a1aaf94a1ce95$var$useRouteComponentProps();
        return $7hhBq.createElement(Component4, props);
    };
}
function $7c6a1aaf94a1ce95$var$useHydrateFallbackProps() {
    return {
        params: $7c6a1aaf94a1ce95$export$99eaa27ddbbb95ef(),
        loaderData: $7c6a1aaf94a1ce95$export$1448a5050d252c4d(),
        actionData: $7c6a1aaf94a1ce95$export$fdc00f3f26066d5e()
    };
}
function $7c6a1aaf94a1ce95$export$f8cff34f39c1932a({ children: children }) {
    const props = $7c6a1aaf94a1ce95$var$useHydrateFallbackProps();
    return $7hhBq.cloneElement(children, props);
}
function $7c6a1aaf94a1ce95$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $7c6a1aaf94a1ce95$var$useHydrateFallbackProps();
        return $7hhBq.createElement(HydrateFallback, props);
    };
}
function $7c6a1aaf94a1ce95$var$useErrorBoundaryProps() {
    return {
        params: $7c6a1aaf94a1ce95$export$99eaa27ddbbb95ef(),
        loaderData: $7c6a1aaf94a1ce95$export$1448a5050d252c4d(),
        actionData: $7c6a1aaf94a1ce95$export$fdc00f3f26066d5e(),
        error: $7c6a1aaf94a1ce95$export$ed527bf60f6e05f2()
    };
}
function $7c6a1aaf94a1ce95$export$e5afde5c4b6d747b({ children: children }) {
    const props = $7c6a1aaf94a1ce95$var$useErrorBoundaryProps();
    return $7hhBq.cloneElement(children, props);
}
function $7c6a1aaf94a1ce95$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $7c6a1aaf94a1ce95$var$useErrorBoundaryProps();
        return $7hhBq.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $7c6a1aaf94a1ce95$var$defaultMethod = "get";
var $7c6a1aaf94a1ce95$var$defaultEncType = "application/x-www-form-urlencoded";
function $7c6a1aaf94a1ce95$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $7c6a1aaf94a1ce95$var$isButtonElement(object) {
    return $7c6a1aaf94a1ce95$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $7c6a1aaf94a1ce95$var$isFormElement(object) {
    return $7c6a1aaf94a1ce95$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $7c6a1aaf94a1ce95$var$isInputElement(object) {
    return $7c6a1aaf94a1ce95$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $7c6a1aaf94a1ce95$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $7c6a1aaf94a1ce95$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$7c6a1aaf94a1ce95$var$isModifiedEvent(event);
}
function $7c6a1aaf94a1ce95$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $7c6a1aaf94a1ce95$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $7c6a1aaf94a1ce95$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $7c6a1aaf94a1ce95$var$_formDataSupportsSubmitter = null;
function $7c6a1aaf94a1ce95$var$isFormDataSubmitterSupported() {
    if ($7c6a1aaf94a1ce95$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $7c6a1aaf94a1ce95$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $7c6a1aaf94a1ce95$var$_formDataSupportsSubmitter = true;
    }
    return $7c6a1aaf94a1ce95$var$_formDataSupportsSubmitter;
}
var $7c6a1aaf94a1ce95$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $7c6a1aaf94a1ce95$var$getFormEncType(encType) {
    if (encType != null && !$7c6a1aaf94a1ce95$var$supportedFormEncTypes.has(encType)) {
        $7c6a1aaf94a1ce95$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$7c6a1aaf94a1ce95$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $7c6a1aaf94a1ce95$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($7c6a1aaf94a1ce95$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $7c6a1aaf94a1ce95$var$defaultMethod;
        encType = $7c6a1aaf94a1ce95$var$getFormEncType(target.getAttribute("enctype")) || $7c6a1aaf94a1ce95$var$defaultEncType;
        formData = new FormData(target);
    } else if ($7c6a1aaf94a1ce95$var$isButtonElement(target) || $7c6a1aaf94a1ce95$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $7c6a1aaf94a1ce95$var$defaultMethod;
        encType = $7c6a1aaf94a1ce95$var$getFormEncType(target.getAttribute("formenctype")) || $7c6a1aaf94a1ce95$var$getFormEncType(form.getAttribute("enctype")) || $7c6a1aaf94a1ce95$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$7c6a1aaf94a1ce95$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($7c6a1aaf94a1ce95$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $7c6a1aaf94a1ce95$var$defaultMethod;
        action = null;
        encType = $7c6a1aaf94a1ce95$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $7c6a1aaf94a1ce95$var$HOLE = -1;
var $7c6a1aaf94a1ce95$var$NAN = -2;
var $7c6a1aaf94a1ce95$var$NEGATIVE_INFINITY = -3;
var $7c6a1aaf94a1ce95$var$NEGATIVE_ZERO = -4;
var $7c6a1aaf94a1ce95$var$NULL = -5;
var $7c6a1aaf94a1ce95$var$POSITIVE_INFINITY = -6;
var $7c6a1aaf94a1ce95$var$UNDEFINED = -7;
var $7c6a1aaf94a1ce95$var$TYPE_BIGINT = "B";
var $7c6a1aaf94a1ce95$var$TYPE_DATE = "D";
var $7c6a1aaf94a1ce95$var$TYPE_ERROR = "E";
var $7c6a1aaf94a1ce95$var$TYPE_MAP = "M";
var $7c6a1aaf94a1ce95$var$TYPE_NULL_OBJECT = "N";
var $7c6a1aaf94a1ce95$var$TYPE_PROMISE = "P";
var $7c6a1aaf94a1ce95$var$TYPE_REGEXP = "R";
var $7c6a1aaf94a1ce95$var$TYPE_SET = "S";
var $7c6a1aaf94a1ce95$var$TYPE_SYMBOL = "Y";
var $7c6a1aaf94a1ce95$var$TYPE_URL = "U";
var $7c6a1aaf94a1ce95$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $7c6a1aaf94a1ce95$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $7c6a1aaf94a1ce95$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $7c6a1aaf94a1ce95$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $7c6a1aaf94a1ce95$var$TIME_LIMIT_MS = 1;
var $7c6a1aaf94a1ce95$var$getNow = ()=>Date.now();
var $7c6a1aaf94a1ce95$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $7c6a1aaf94a1ce95$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $7c6a1aaf94a1ce95$var$UNDEFINED;
    if (input === null) return $7c6a1aaf94a1ce95$var$NULL;
    if (Number.isNaN(input)) return $7c6a1aaf94a1ce95$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $7c6a1aaf94a1ce95$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $7c6a1aaf94a1ce95$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $7c6a1aaf94a1ce95$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $7c6a1aaf94a1ce95$var$stringify.call(this, stack);
    return index;
}
async function $7c6a1aaf94a1ce95$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $7c6a1aaf94a1ce95$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $7c6a1aaf94a1ce95$var$UNDEFINED;
        if (value === null) return $7c6a1aaf94a1ce95$var$NULL;
        if (Number.isNaN(value)) return $7c6a1aaf94a1ce95$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $7c6a1aaf94a1ce95$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $7c6a1aaf94a1ce95$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $7c6a1aaf94a1ce95$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $7c6a1aaf94a1ce95$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $7c6a1aaf94a1ce95$var$TIME_LIMIT_MS) {
            await $7c6a1aaf94a1ce95$var$yieldToMain();
            lastYieldTime = $7c6a1aaf94a1ce95$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$7c6a1aaf94a1ce95$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$7c6a1aaf94a1ce95$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$7c6a1aaf94a1ce95$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $7c6a1aaf94a1ce95$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$7c6a1aaf94a1ce95$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$7c6a1aaf94a1ce95$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$7c6a1aaf94a1ce95$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$7c6a1aaf94a1ce95$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$7c6a1aaf94a1ce95$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$7c6a1aaf94a1ce95$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$7c6a1aaf94a1ce95$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$7c6a1aaf94a1ce95$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$7c6a1aaf94a1ce95$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$7c6a1aaf94a1ce95$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($7c6a1aaf94a1ce95$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $7c6a1aaf94a1ce95$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $7c6a1aaf94a1ce95$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $7c6a1aaf94a1ce95$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $7c6a1aaf94a1ce95$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $7c6a1aaf94a1ce95$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $7c6a1aaf94a1ce95$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $7c6a1aaf94a1ce95$var$hydrate.call(this, startIndex);
}
function $7c6a1aaf94a1ce95$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $7c6a1aaf94a1ce95$var$UNDEFINED:
                set(void 0);
                continue;
            case $7c6a1aaf94a1ce95$var$NULL:
                set(null);
                continue;
            case $7c6a1aaf94a1ce95$var$NAN:
                set(NaN);
                continue;
            case $7c6a1aaf94a1ce95$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $7c6a1aaf94a1ce95$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $7c6a1aaf94a1ce95$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $7c6a1aaf94a1ce95$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $7c6a1aaf94a1ce95$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $7c6a1aaf94a1ce95$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $7c6a1aaf94a1ce95$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $7c6a1aaf94a1ce95$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $7c6a1aaf94a1ce95$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $7c6a1aaf94a1ce95$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $7c6a1aaf94a1ce95$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $7c6a1aaf94a1ce95$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $7c6a1aaf94a1ce95$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $7c6a1aaf94a1ce95$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $7c6a1aaf94a1ce95$var$globalObj && $7c6a1aaf94a1ce95$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $7c6a1aaf94a1ce95$var$globalObj && typeof $7c6a1aaf94a1ce95$var$globalObj[errorType] === "function" ? new $7c6a1aaf94a1ce95$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $7c6a1aaf94a1ce95$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $7c6a1aaf94a1ce95$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $7c6a1aaf94a1ce95$var$decode(readable, options) {
    const { plugins: plugins } = options !== null && options !== void 0 ? options : {};
    const done = new $7c6a1aaf94a1ce95$var$Deferred2();
    const reader = readable.pipeThrough($7c6a1aaf94a1ce95$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $7c6a1aaf94a1ce95$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $7c6a1aaf94a1ce95$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $7c6a1aaf94a1ce95$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $7c6a1aaf94a1ce95$var$unflatten.call(this, line)
    };
}
async function $7c6a1aaf94a1ce95$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $7c6a1aaf94a1ce95$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $7c6a1aaf94a1ce95$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $7c6a1aaf94a1ce95$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $7c6a1aaf94a1ce95$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $7c6a1aaf94a1ce95$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options !== null && options !== void 0 ? options : {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $7c6a1aaf94a1ce95$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $7c6a1aaf94a1ce95$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$7c6a1aaf94a1ce95$var$TYPE_PROMISE}${deferredId}:[["${$7c6a1aaf94a1ce95$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$7c6a1aaf94a1ce95$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$7c6a1aaf94a1ce95$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $7c6a1aaf94a1ce95$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$7c6a1aaf94a1ce95$var$TYPE_ERROR}${deferredId}:[["${$7c6a1aaf94a1ce95$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$7c6a1aaf94a1ce95$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$7c6a1aaf94a1ce95$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $7c6a1aaf94a1ce95$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $7c6a1aaf94a1ce95$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $7c6a1aaf94a1ce95$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $7c6a1aaf94a1ce95$export$4cf11838cdc2a8a8(html) {
    return html.replace($7c6a1aaf94a1ce95$var$ESCAPE_REGEX, (match)=>$7c6a1aaf94a1ce95$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $7c6a1aaf94a1ce95$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $7c6a1aaf94a1ce95$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $7c6a1aaf94a1ce95$var$SingleFetchNoResultError = class extends Error {
};
var $7c6a1aaf94a1ce95$export$ae9272e641ead836 = 202;
var $7c6a1aaf94a1ce95$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $7c6a1aaf94a1ce95$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $7hhBq.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$7c6a1aaf94a1ce95$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, scriptTag, /* @__PURE__ */ $7hhBq.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, scriptTag, /* @__PURE__ */ $7hhBq.createElement($7hhBq.Suspense, null, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $7c6a1aaf94a1ce95$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $7c6a1aaf94a1ce95$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $7c6a1aaf94a1ce95$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $7c6a1aaf94a1ce95$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $7c6a1aaf94a1ce95$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $7c6a1aaf94a1ce95$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $7c6a1aaf94a1ce95$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $7c6a1aaf94a1ce95$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $7c6a1aaf94a1ce95$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $7c6a1aaf94a1ce95$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $7c6a1aaf94a1ce95$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $7c6a1aaf94a1ce95$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($7c6a1aaf94a1ce95$export$3f1eb41d9a6a6a27(result.result) || $7c6a1aaf94a1ce95$export$972111febbeef05b(result.result) || $7c6a1aaf94a1ce95$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $7c6a1aaf94a1ce95$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $7c6a1aaf94a1ce95$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $7c6a1aaf94a1ce95$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $7c6a1aaf94a1ce95$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$7c6a1aaf94a1ce95$var$createDeferred2());
    let singleFetchDfd = $7c6a1aaf94a1ce95$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $7c6a1aaf94a1ce95$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $7c6a1aaf94a1ce95$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $7c6a1aaf94a1ce95$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $7c6a1aaf94a1ce95$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    var _results_match_route_id;
                    middlewareError = routeResult.error;
                    if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.result) == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $7c6a1aaf94a1ce95$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $7c6a1aaf94a1ce95$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $7c6a1aaf94a1ce95$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $7c6a1aaf94a1ce95$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $7c6a1aaf94a1ce95$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $7c6a1aaf94a1ce95$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$7c6a1aaf94a1ce95$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$7c6a1aaf94a1ce95$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $7c6a1aaf94a1ce95$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $7c6a1aaf94a1ce95$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $7c6a1aaf94a1ce95$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $7c6a1aaf94a1ce95$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $7c6a1aaf94a1ce95$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $7c6a1aaf94a1ce95$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($7c6a1aaf94a1ce95$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $7c6a1aaf94a1ce95$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $7c6a1aaf94a1ce95$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($7c6a1aaf94a1ce95$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$7c6a1aaf94a1ce95$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes === null || targetRoutes === void 0 ? void 0 : targetRoutes[0];
            $7c6a1aaf94a1ce95$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $7c6a1aaf94a1ce95$export$4023ad4ecd4126a2(body, global) {
    return $7c6a1aaf94a1ce95$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $7c6a1aaf94a1ce95$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $7c6a1aaf94a1ce95$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$7c6a1aaf94a1ce95$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $7c6a1aaf94a1ce95$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $7c6a1aaf94a1ce95$export$89e12c5b50f7529d(location, {
            status: status,
            headers: (0, $dok7x._)({}, revalidate ? {
                "X-Remix-Revalidate": "yes"
            } : null, reload ? {
                "X-Remix-Reload-Document": "yes"
            } : null, replace2 ? {
                "X-Remix-Replace": "yes"
            } : null)
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $7c6a1aaf94a1ce95$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $7c6a1aaf94a1ce95$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $7c6a1aaf94a1ce95$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $7c6a1aaf94a1ce95$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $7c6a1aaf94a1ce95$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        var _module_links;
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            (module === null || module === void 0 ? void 0 : (_module_links = module.links) === null || _module_links === void 0 ? void 0 : _module_links.call(module)) || []
        ];
    }).flat(2);
    let preloads = $7c6a1aaf94a1ce95$var$getModuleLinkHrefs(matches, manifest);
    return $7c6a1aaf94a1ce95$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $7c6a1aaf94a1ce95$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $7c6a1aaf94a1ce95$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $7c6a1aaf94a1ce95$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($7c6a1aaf94a1ce95$var$prefetchStyleLink));
}
async function $7c6a1aaf94a1ce95$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$7c6a1aaf94a1ce95$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$7c6a1aaf94a1ce95$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$7c6a1aaf94a1ce95$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push((0, $cNnl8._)((0, $dok7x._)({}, descriptor), {
        rel: "preload",
        as: "style"
    }));
    await Promise.all(styleLinks.map($7c6a1aaf94a1ce95$var$prefetchStyleLink));
}
async function $7c6a1aaf94a1ce95$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $7c6a1aaf94a1ce95$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $7c6a1aaf94a1ce95$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $7c6a1aaf94a1ce95$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $7c6a1aaf94a1ce95$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $7c6a1aaf94a1ce95$var$dedupeLinkDescriptors(links.flat(1).filter($7c6a1aaf94a1ce95$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? (0, $cNnl8._)((0, $dok7x._)({}, link), {
            rel: "prefetch",
            as: "style"
        }) : (0, $cNnl8._)((0, $dok7x._)({}, link), {
            rel: "prefetch"
        })));
}
function $7c6a1aaf94a1ce95$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        var // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        _currentMatches_index_route_path;
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || ((_currentMatches_index_route_path = currentMatches[index].route.path) === null || _currentMatches_index_route_path === void 0 ? void 0 : _currentMatches_index_route_path.endsWith("*")) && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            var _currentMatches_;
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: ((_currentMatches_ = currentMatches[0]) === null || _currentMatches_ === void 0 ? void 0 : _currentMatches_.params) || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $7c6a1aaf94a1ce95$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $7c6a1aaf94a1ce95$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $7c6a1aaf94a1ce95$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $7c6a1aaf94a1ce95$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $7c6a1aaf94a1ce95$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$7c6a1aaf94a1ce95$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($7c6a1aaf94a1ce95$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $7c6a1aaf94a1ce95$var$_isPreloadSupported;
function $7c6a1aaf94a1ce95$var$isPreloadSupported() {
    if ($7c6a1aaf94a1ce95$var$_isPreloadSupported !== void 0) return $7c6a1aaf94a1ce95$var$_isPreloadSupported;
    let el = document.createElement("link");
    $7c6a1aaf94a1ce95$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $7c6a1aaf94a1ce95$var$_isPreloadSupported;
}
function $7c6a1aaf94a1ce95$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $7c6a1aaf94a1ce95$export$945fecf35a8ef089 ? /* @__PURE__ */ $7hhBq.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $7c6a1aaf94a1ce95$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $7c6a1aaf94a1ce95$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $7c6a1aaf94a1ce95$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $7c6a1aaf94a1ce95$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$RemixRootDefaultErrorBoundary, {
            error: $7c6a1aaf94a1ce95$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return (0, $dok7x._)({}, Component4 ? {
        element: /* @__PURE__ */ $7hhBq.createElement(routeModule.Layout, null, /* @__PURE__ */ $7hhBq.createElement(Component4, null))
    } : {
        Component: Component4
    }, ErrorBoundary ? {
        errorElement: /* @__PURE__ */ $7hhBq.createElement(routeModule.Layout, null, /* @__PURE__ */ $7hhBq.createElement(ErrorBoundary, null))
    } : {
        ErrorBoundary: ErrorBoundary
    }, HydrateFallback ? {
        hydrateFallbackElement: /* @__PURE__ */ $7hhBq.createElement(routeModule.Layout, null, /* @__PURE__ */ $7hhBq.createElement(HydrateFallback, null))
    } : {
        HydrateFallback: HydrateFallback
    });
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $7c6a1aaf94a1ce95$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $7c6a1aaf94a1ce95$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $7c6a1aaf94a1ce95$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = (0, $cNnl8._)((0, $dok7x._)({}, $7c6a1aaf94a1ce95$var$getRouteComponents(route, routeModule, isSpaMode)), {
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        });
        let children = $7c6a1aaf94a1ce95$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $7c6a1aaf94a1ce95$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $7c6a1aaf94a1ce95$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $7c6a1aaf94a1ce95$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $7c6a1aaf94a1ce95$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $7c6a1aaf94a1ce95$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $7c6a1aaf94a1ce95$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $7c6a1aaf94a1ce95$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $7c6a1aaf94a1ce95$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $7c6a1aaf94a1ce95$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $7c6a1aaf94a1ce95$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $7c6a1aaf94a1ce95$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $7c6a1aaf94a1ce95$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            var _initialState_loaderData, _initialState_errors, _routeModule_clientLoader;
            Object.assign(dataRoute, (0, $cNnl8._)((0, $dok7x._)({}, dataRoute, $7c6a1aaf94a1ce95$var$getRouteComponents(route, routeModule, isSpaMode)), {
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $7c6a1aaf94a1ce95$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            }));
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState === null || initialState === void 0 ? void 0 : (_initialState_loaderData = initialState.loaderData) === null || _initialState_loaderData === void 0 ? void 0 : _initialState_loaderData[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState === null || initialState === void 0 ? void 0 : (_initialState_errors = initialState.errors) === null || _initialState_errors === void 0 ? void 0 : _initialState_errors[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (((_routeModule_clientLoader = routeModule.clientLoader) === null || _routeModule_clientLoader === void 0 ? void 0 : _routeModule_clientLoader.hydrate) === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $7c6a1aaf94a1ce95$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $7c6a1aaf94a1ce95$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $7c6a1aaf94a1ce95$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $7c6a1aaf94a1ce95$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $7c6a1aaf94a1ce95$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $7c6a1aaf94a1ce95$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $7c6a1aaf94a1ce95$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $7c6a1aaf94a1ce95$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $7c6a1aaf94a1ce95$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader((0, $cNnl8._)((0, $dok7x._)({}, args), {
                            async serverLoader () {
                                $7c6a1aaf94a1ce95$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        }));
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $7c6a1aaf94a1ce95$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction((0, $cNnl8._)((0, $dok7x._)({}, args), {
                            async serverAction () {
                                $7c6a1aaf94a1ce95$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        }));
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $7c6a1aaf94a1ce95$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $7c6a1aaf94a1ce95$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $7c6a1aaf94a1ce95$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $7c6a1aaf94a1ce95$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $7c6a1aaf94a1ce95$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $7c6a1aaf94a1ce95$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn((0, $cNnl8._)((0, $dok7x._)({}, opts), {
                    defaultShouldRevalidate: didParamsChange(opts)
                }));
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $7c6a1aaf94a1ce95$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $7c6a1aaf94a1ce95$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $7c6a1aaf94a1ce95$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $7c6a1aaf94a1ce95$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $7c6a1aaf94a1ce95$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $7c6a1aaf94a1ce95$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $7c6a1aaf94a1ce95$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $7c6a1aaf94a1ce95$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $7c6a1aaf94a1ce95$var$nextPaths = /* @__PURE__ */ new Set();
var $7c6a1aaf94a1ce95$var$discoveredPathsMaxSize = 1e3;
var $7c6a1aaf94a1ce95$var$discoveredPaths = /* @__PURE__ */ new Set();
var $7c6a1aaf94a1ce95$export$b5915cf27fa06b9f = 7680;
function $7c6a1aaf94a1ce95$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $7c6a1aaf94a1ce95$var$getPartialManifest(_param, router) {
    var { sri: sri } = _param, manifest = (0, $6pkKu._)(_param, [
        "sri"
    ]);
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $7c6a1aaf94a1ce95$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return (0, $cNnl8._)((0, $dok7x._)({}, manifest), {
        routes: initialRoutes,
        sri: sri ? true : void 0
    });
}
function $7c6a1aaf94a1ce95$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$7c6a1aaf94a1ce95$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($7c6a1aaf94a1ce95$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $7c6a1aaf94a1ce95$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $7c6a1aaf94a1ce95$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $7c6a1aaf94a1ce95$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $7hhBq.useEffect(()=>{
        var // @ts-expect-error - TS doesn't know about this yet
        _window_navigator_connection, _window_navigator;
        if (!$7c6a1aaf94a1ce95$var$isFogOfWarEnabled(routeDiscovery, ssr) || ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_connection = _window_navigator.connection) === null || _window_navigator_connection === void 0 ? void 0 : _window_navigator_connection.saveData) === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$7c6a1aaf94a1ce95$var$discoveredPaths.has(pathname)) $7c6a1aaf94a1ce95$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($7c6a1aaf94a1ce95$var$nextPaths.keys()).filter((path)=>{
                if ($7c6a1aaf94a1ce95$var$discoveredPaths.has(path)) {
                    $7c6a1aaf94a1ce95$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $7c6a1aaf94a1ce95$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $7c6a1aaf94a1ce95$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $7c6a1aaf94a1ce95$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $7c6a1aaf94a1ce95$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $7c6a1aaf94a1ce95$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $7c6a1aaf94a1ce95$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($7c6a1aaf94a1ce95$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $7c6a1aaf94a1ce95$export$b5915cf27fa06b9f) {
        $7c6a1aaf94a1ce95$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($7c6a1aaf94a1ce95$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($7c6a1aaf94a1ce95$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch (e) {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($7c6a1aaf94a1ce95$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch (e) {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$7c6a1aaf94a1ce95$var$addToFifoQueue(p, $7c6a1aaf94a1ce95$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $7c6a1aaf94a1ce95$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $7c6a1aaf94a1ce95$var$addToFifoQueue(path, queue) {
    if (queue.size >= $7c6a1aaf94a1ce95$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $7c6a1aaf94a1ce95$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $7c6a1aaf94a1ce95$var$useDataRouterContext2() {
    let context = $7hhBq.useContext($7c6a1aaf94a1ce95$export$2eeee58951ff3c1c);
    $7c6a1aaf94a1ce95$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $7c6a1aaf94a1ce95$var$useDataRouterStateContext() {
    let context = $7hhBq.useContext($7c6a1aaf94a1ce95$export$315e3ffb01f217);
    $7c6a1aaf94a1ce95$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $7c6a1aaf94a1ce95$export$208d6a3bc3aa62bd = $7hhBq.createContext(void 0);
$7c6a1aaf94a1ce95$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $7c6a1aaf94a1ce95$var$useFrameworkContext() {
    let context = $7hhBq.useContext($7c6a1aaf94a1ce95$export$208d6a3bc3aa62bd);
    $7c6a1aaf94a1ce95$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $7c6a1aaf94a1ce95$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $7hhBq.useContext($7c6a1aaf94a1ce95$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $7hhBq.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $7hhBq.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $7hhBq.useRef(null);
    $7hhBq.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $7hhBq.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $7c6a1aaf94a1ce95$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $7c6a1aaf94a1ce95$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $7c6a1aaf94a1ce95$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $7c6a1aaf94a1ce95$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $7c6a1aaf94a1ce95$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $7c6a1aaf94a1ce95$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $7c6a1aaf94a1ce95$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$7c6a1aaf94a1ce95$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $7c6a1aaf94a1ce95$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $7c6a1aaf94a1ce95$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $7c6a1aaf94a1ce95$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $7c6a1aaf94a1ce95$var$useDataRouterStateContext();
    let matches = $7c6a1aaf94a1ce95$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $7hhBq.useMemo(()=>$7c6a1aaf94a1ce95$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $7hhBq.createElement("style", {
        [$7c6a1aaf94a1ce95$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $7hhBq.createElement("link", {
        [$7c6a1aaf94a1ce95$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>{
        var _link_crossOrigin, _link_crossOrigin1;
        return $7c6a1aaf94a1ce95$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$60dcec93e67386bd, (0, $cNnl8._)((0, $dok7x._)({
            key: key,
            nonce: nonce
        }, link), {
            crossOrigin: (_link_crossOrigin = link.crossOrigin) !== null && _link_crossOrigin !== void 0 ? _link_crossOrigin : crossOrigin
        })) : /* @__PURE__ */ $7hhBq.createElement("link", (0, $cNnl8._)((0, $dok7x._)({
            key: key,
            nonce: nonce
        }, link), {
            crossOrigin: (_link_crossOrigin1 = link.crossOrigin) !== null && _link_crossOrigin1 !== void 0 ? _link_crossOrigin1 : crossOrigin
        }));
    }));
}
function $7c6a1aaf94a1ce95$export$60dcec93e67386bd(_param) {
    var { page: page } = _param, linkProps = (0, $6pkKu._)(_param, [
        "page"
    ]);
    let rsc = $7c6a1aaf94a1ce95$var$useIsRSCRouterContext();
    let { router: router } = $7c6a1aaf94a1ce95$var$useDataRouterContext2();
    let matches = $7hhBq.useMemo(()=>$7c6a1aaf94a1ce95$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (rsc) return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$RSCPrefetchPageLinksImpl, (0, $dok7x._)({
        page: page,
        matches: matches
    }, linkProps));
    return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$PrefetchPageLinksImpl, (0, $dok7x._)({
        page: page,
        matches: matches
    }, linkProps));
}
function $7c6a1aaf94a1ce95$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $7c6a1aaf94a1ce95$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $7hhBq.useState([]);
    $7hhBq.useEffect(()=>{
        let interrupted = false;
        $7c6a1aaf94a1ce95$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $7c6a1aaf94a1ce95$var$RSCPrefetchPageLinksImpl(_param) {
    var { page: page, matches: nextMatches } = _param, linkProps = (0, $6pkKu._)(_param, [
        "page",
        "matches"
    ]);
    let location = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let { future: future } = $7c6a1aaf94a1ce95$var$useFrameworkContext();
    let { basename: basename } = $7c6a1aaf94a1ce95$var$useDataRouterContext2();
    let dataHrefs = $7hhBq.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $7c6a1aaf94a1ce95$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7hhBq.createElement("link", (0, $dok7x._)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps))));
}
function $7c6a1aaf94a1ce95$var$PrefetchPageLinksImpl(_param) {
    var { page: page, matches: nextMatches } = _param, linkProps = (0, $6pkKu._)(_param, [
        "page",
        "matches"
    ]);
    let location = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $7c6a1aaf94a1ce95$var$useFrameworkContext();
    let { basename: basename } = $7c6a1aaf94a1ce95$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $7c6a1aaf94a1ce95$var$useDataRouterStateContext();
    let newMatchesForData = $7hhBq.useMemo(()=>$7c6a1aaf94a1ce95$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $7hhBq.useMemo(()=>$7c6a1aaf94a1ce95$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $7hhBq.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            var _routeModules_m_route_id;
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && ((_routeModules_m_route_id = routeModules[m.route.id]) === null || _routeModules_m_route_id === void 0 ? void 0 : _routeModules_m_route_id.shouldRevalidate)) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $7c6a1aaf94a1ce95$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $7hhBq.useMemo(()=>$7c6a1aaf94a1ce95$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $7c6a1aaf94a1ce95$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7hhBq.createElement("link", (0, $dok7x._)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps))), moduleHrefs.map((href)=>/* @__PURE__ */ $7hhBq.createElement("link", (0, $dok7x._)({
            key: href,
            rel: "modulepreload",
            href: href
        }, linkProps))), keyedPrefetchLinks.map(({ key: key, link: link })=>{
        var _link_crossOrigin;
        return(// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $7hhBq.createElement("link", (0, $cNnl8._)((0, $dok7x._)({
            key: key,
            nonce: linkProps.nonce
        }, link), {
            crossOrigin: (_link_crossOrigin = link.crossOrigin) !== null && _link_crossOrigin !== void 0 ? _link_crossOrigin : linkProps.crossOrigin
        })));
    }));
}
function $7c6a1aaf94a1ce95$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $7c6a1aaf94a1ce95$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $7c6a1aaf94a1ce95$var$useDataRouterStateContext();
    let location = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let _matches = $7c6a1aaf94a1ce95$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule === null || routeModule === void 0 ? void 0 : routeModule.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName } = metaProps, rest = (0, $6pkKu._)(metaProps, [
                "tagName"
            ]);
            if (!$7c6a1aaf94a1ce95$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $7hhBq.createElement(Comp, (0, $dok7x._)({
                key: JSON.stringify(rest)
            }, rest));
        }
        if ("title" in metaProps) return /* @__PURE__ */ $7hhBq.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            var _metaProps_charSet;
            (_metaProps_charSet = metaProps.charSet) !== null && _metaProps_charSet !== void 0 ? _metaProps_charSet : metaProps.charSet = metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $7hhBq.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $7hhBq.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $7c6a1aaf94a1ce95$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $7hhBq.createElement("meta", (0, $dok7x._)({
            key: JSON.stringify(metaProps)
        }, metaProps));
    }));
}
function $7c6a1aaf94a1ce95$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $7c6a1aaf94a1ce95$var$isHydrated = false;
function $7c6a1aaf94a1ce95$export$3be068dde909e563() {
    $7c6a1aaf94a1ce95$var$isHydrated = true;
}
function $7c6a1aaf94a1ce95$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $7c6a1aaf94a1ce95$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $7c6a1aaf94a1ce95$var$useDataRouterContext2();
    let { matches: routerMatches } = $7c6a1aaf94a1ce95$var$useDataRouterStateContext();
    let isRSCRouterContext = $7c6a1aaf94a1ce95$var$useIsRSCRouterContext();
    let enableFogOfWar = $7c6a1aaf94a1ce95$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $7c6a1aaf94a1ce95$var$getActiveMatches(routerMatches, null, isSpaMode);
    $7hhBq.useEffect(()=>{
        $7c6a1aaf94a1ce95$export$3be068dde909e563();
    }, []);
    let initialScripts = $7hhBq.useMemo(()=>{
        var _manifest_hmr;
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${((_manifest_hmr = manifest.hmr) === null || _manifest_hmr === void 0 ? void 0 : _manifest_hmr.runtime) ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $7c6a1aaf94a1ce95$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($7c6a1aaf94a1ce95$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, /* @__PURE__ */ $7hhBq.createElement("script", (0, $cNnl8._)((0, $dok7x._)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        })), /* @__PURE__ */ $7hhBq.createElement("script", (0, $cNnl8._)((0, $dok7x._)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        })));
    }, []);
    let preloads = $7c6a1aaf94a1ce95$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($7c6a1aaf94a1ce95$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $7c6a1aaf94a1ce95$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $7c6a1aaf94a1ce95$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $7hhBq.createElement("script", (0, $cNnl8._)((0, $dok7x._)({}, scriptProps), {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    })) : null, !enableFogOfWar ? /* @__PURE__ */ $7hhBq.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $7hhBq.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $7hhBq.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $7c6a1aaf94a1ce95$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $7c6a1aaf94a1ce95$export$32e57f52df4b6e34 = class extends $7hhBq.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
};
function $7c6a1aaf94a1ce95$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $7hhBq.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($7c6a1aaf94a1ce95$export$972111febbeef05b(error)) return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $7hhBq.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $7c6a1aaf94a1ce95$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $7hhBq.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $7hhBq.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $7c6a1aaf94a1ce95$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    var _routeModules_root;
    let { routeModules: routeModules } = $7c6a1aaf94a1ce95$var$useFrameworkContext();
    if (((_routeModules_root = routeModules.root) === null || _routeModules_root === void 0 ? void 0 : _routeModules_root.Layout) && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $7hhBq.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $7hhBq.createElement("head", null, /* @__PURE__ */ $7hhBq.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $7hhBq.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $7hhBq.createElement("title", null, title)), /* @__PURE__ */ $7hhBq.createElement("body", null, /* @__PURE__ */ $7hhBq.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$ff0bf87698939488, null) : null)));
}
var $7c6a1aaf94a1ce95$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($7c6a1aaf94a1ce95$var$isBrowser2) window.__reactRouterVersion = "7.17.0";
} catch (e) {}
function $7c6a1aaf94a1ce95$export$1f3f55432a00e06d(routes, opts) {
    return $7c6a1aaf94a1ce95$export$baddd0131ee8c05b({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: $7c6a1aaf94a1ce95$export$719fc203c4e16dee({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || $7c6a1aaf94a1ce95$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $7c6a1aaf94a1ce95$export$9269a41d8c4635e,
        hydrationRouteProperties: $7c6a1aaf94a1ce95$export$e2fd2c03906469db,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
function $7c6a1aaf94a1ce95$export$1ba7ed8a3a7b3765(routes, opts) {
    return $7c6a1aaf94a1ce95$export$baddd0131ee8c05b({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: $7c6a1aaf94a1ce95$export$b71fdd3798280242({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || $7c6a1aaf94a1ce95$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $7c6a1aaf94a1ce95$export$9269a41d8c4635e,
        hydrationRouteProperties: $7c6a1aaf94a1ce95$export$e2fd2c03906469db,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
function $7c6a1aaf94a1ce95$var$parseHydrationData() {
    var _window;
    let state = (_window = window) === null || _window === void 0 ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = (0, $cNnl8._)((0, $dok7x._)({}, state), {
        errors: $7c6a1aaf94a1ce95$var$deserializeErrors(state.errors)
    });
    return state;
}
function $7c6a1aaf94a1ce95$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $7c6a1aaf94a1ce95$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $7c6a1aaf94a1ce95$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $7hhBq.useRef();
    if (historyRef.current == null) historyRef.current = $7c6a1aaf94a1ce95$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7hhBq.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7hhBq.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7hhBq.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7hhBq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $7c6a1aaf94a1ce95$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $7hhBq.useRef();
    if (historyRef.current == null) historyRef.current = $7c6a1aaf94a1ce95$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7hhBq.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7hhBq.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7hhBq.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7hhBq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $7c6a1aaf94a1ce95$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $7hhBq.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7hhBq.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7hhBq.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7hhBq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$7c6a1aaf94a1ce95$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $7c6a1aaf94a1ce95$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $7c6a1aaf94a1ce95$export$a6c7ac8248d6e38a = $7hhBq.forwardRef(function LinkWithRef(_param, forwardedRef) {
    var { onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate } = _param, rest = (0, $6pkKu._)(_param, [
        "onClick",
        "discover",
        "prefetch",
        "relative",
        "reloadDocument",
        "replace",
        "mask",
        "state",
        "target",
        "to",
        "preventScrollReset",
        "viewTransition",
        "defaultShouldRevalidate"
    ]);
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $7c6a1aaf94a1ce95$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $7c6a1aaf94a1ce95$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $7c6a1aaf94a1ce95$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $7c6a1aaf94a1ce95$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $7c6a1aaf94a1ce95$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $7c6a1aaf94a1ce95$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $7c6a1aaf94a1ce95$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $7hhBq.createElement("a", (0, $cNnl8._)((0, $dok7x._)({}, rest, prefetchHandlers), {
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $7c6a1aaf94a1ce95$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, link, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$7c6a1aaf94a1ce95$export$a6c7ac8248d6e38a.displayName = "Link";
var $7c6a1aaf94a1ce95$export$b0d92dbee9b5b60d = $7hhBq.forwardRef(function NavLinkWithRef(_param, ref) {
    var { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _param, rest = (0, $6pkKu._)(_param, [
        "aria-current",
        "caseSensitive",
        "className",
        "end",
        "style",
        "to",
        "viewTransition",
        "children"
    ]);
    let path = $7c6a1aaf94a1ce95$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let routerState = $7hhBq.useContext($7c6a1aaf94a1ce95$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7c6a1aaf94a1ce95$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$a6c7ac8248d6e38a, (0, $cNnl8._)((0, $dok7x._)({}, rest), {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
$7c6a1aaf94a1ce95$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $7c6a1aaf94a1ce95$export$a7fed597f4b8afd8 = $7hhBq.forwardRef((_param, forwardedRef)=>{
    var { discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $7c6a1aaf94a1ce95$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate } = _param, props = (0, $6pkKu._)(_param, [
        "discover",
        "fetcherKey",
        "navigate",
        "reloadDocument",
        "replace",
        "state",
        "method",
        "action",
        "onSubmit",
        "relative",
        "preventScrollReset",
        "viewTransition",
        "defaultShouldRevalidate"
    ]);
    let { useTransitions: useTransitions } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6);
    let submit = $7c6a1aaf94a1ce95$export$47c85c6e3a081d3();
    let formAction = $7c6a1aaf94a1ce95$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $7c6a1aaf94a1ce95$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $7hhBq.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $7hhBq.createElement("form", (0, $cNnl8._)((0, $dok7x._)({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props), {
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
});
$7c6a1aaf94a1ce95$export$a7fed597f4b8afd8.displayName = "Form";
function $7c6a1aaf94a1ce95$export$11aac1aab828f1fa(_param) {
    var { getKey: getKey, storageKey: storageKey } = _param, props = (0, $6pkKu._)(_param, [
        "getKey",
        "storageKey"
    ]);
    let remixContext = $7hhBq.useContext($7c6a1aaf94a1ce95$export$208d6a3bc3aa62bd);
    let { basename: basename } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6);
    let location = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let matches = $7c6a1aaf94a1ce95$export$2378eb7f5ff86053();
    $7c6a1aaf94a1ce95$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $7hhBq.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $7c6a1aaf94a1ce95$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $7hhBq.createElement("script", (0, $cNnl8._)((0, $dok7x._)({}, props), {
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$7c6a1aaf94a1ce95$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $7c6a1aaf94a1ce95$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$7c6a1aaf94a1ce95$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    }));
}
$7c6a1aaf94a1ce95$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $7c6a1aaf94a1ce95$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $7c6a1aaf94a1ce95$var$useDataRouterContext3(hookName) {
    let ctx = $7hhBq.useContext($7c6a1aaf94a1ce95$export$2eeee58951ff3c1c);
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(ctx, $7c6a1aaf94a1ce95$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $7c6a1aaf94a1ce95$var$useDataRouterState2(hookName) {
    let state = $7hhBq.useContext($7c6a1aaf94a1ce95$export$315e3ffb01f217);
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(state, $7c6a1aaf94a1ce95$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $7c6a1aaf94a1ce95$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $7c6a1aaf94a1ce95$export$9770f232ac06a008();
    let location = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let path = $7c6a1aaf94a1ce95$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $7hhBq.useCallback((event)=>{
        if ($7c6a1aaf94a1ce95$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $7c6a1aaf94a1ce95$export$fe53371bee54353d(location) === $7c6a1aaf94a1ce95$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $7hhBq.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $7c6a1aaf94a1ce95$export$f1a78c17382fe22a(defaultInit) {
    $7c6a1aaf94a1ce95$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $7hhBq.useRef($7c6a1aaf94a1ce95$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7hhBq.useRef(false);
    let location = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let searchParams = $7hhBq.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $7c6a1aaf94a1ce95$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $7c6a1aaf94a1ce95$export$9770f232ac06a008();
    let setSearchParams = $7hhBq.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $7c6a1aaf94a1ce95$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $7c6a1aaf94a1ce95$var$fetcherId = 0;
var $7c6a1aaf94a1ce95$var$getUniqueFetcherId = ()=>`__${String(++$7c6a1aaf94a1ce95$var$fetcherId)}__`;
function $7c6a1aaf94a1ce95$export$47c85c6e3a081d3() {
    let { router: router } = $7c6a1aaf94a1ce95$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6);
    let currentRouteId = $7c6a1aaf94a1ce95$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $7hhBq.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $7c6a1aaf94a1ce95$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $7c6a1aaf94a1ce95$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $7c6a1aaf94a1ce95$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6);
    let routeContext = $7hhBq.useContext($7c6a1aaf94a1ce95$export$aac280ed165a4397);
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = (0, $dok7x._)({}, $7c6a1aaf94a1ce95$export$e75d2a2d1b3c245b(action ? action : ".", {
        relative: relative
    }));
    let location = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $7c6a1aaf94a1ce95$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $7c6a1aaf94a1ce95$export$fe53371bee54353d(path);
}
function $7c6a1aaf94a1ce95$export$5b0d2d9a9921565a({ key: key } = {}) {
    var _route_matches_;
    let { router: router } = $7c6a1aaf94a1ce95$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $7c6a1aaf94a1ce95$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $7hhBq.useContext($7c6a1aaf94a1ce95$export$cb3f1df1bef00a39);
    let route = $7hhBq.useContext($7c6a1aaf94a1ce95$export$aac280ed165a4397);
    let routeId = (_route_matches_ = route.matches[route.matches.length - 1]) === null || _route_matches_ === void 0 ? void 0 : _route_matches_.route.id;
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $7hhBq.useId();
    let [fetcherKey, setFetcherKey] = $7hhBq.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $7hhBq.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $7hhBq.useCallback(async (href, opts)=>{
        $7c6a1aaf94a1ce95$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $7c6a1aaf94a1ce95$export$47c85c6e3a081d3();
    let submit = $7hhBq.useCallback(async (target, opts)=>{
        await submitImpl(target, (0, $cNnl8._)((0, $dok7x._)({}, opts), {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $7hhBq.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $7hhBq.useMemo(()=>{
        let FetcherForm2 = $7hhBq.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$a7fed597f4b8afd8, (0, $cNnl8._)((0, $dok7x._)({}, props), {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $7c6a1aaf94a1ce95$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7hhBq.useMemo(()=>(0, $cNnl8._)((0, $dok7x._)({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset
        }, fetcher), {
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $7c6a1aaf94a1ce95$export$fa996778a3a31087() {
    let state = $7c6a1aaf94a1ce95$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $7hhBq.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>(0, $cNnl8._)((0, $dok7x._)({}, fetcher), {
                key: key
            })), [
        state.fetchers
    ]);
}
var $7c6a1aaf94a1ce95$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $7c6a1aaf94a1ce95$var$savedScrollPositions = {};
function $7c6a1aaf94a1ce95$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey((0, $cNnl8._)((0, $dok7x._)({}, location), {
            pathname: $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }), matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $7c6a1aaf94a1ce95$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $7c6a1aaf94a1ce95$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $7c6a1aaf94a1ce95$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3044ab7fdabeaee6);
    let location = $7c6a1aaf94a1ce95$export$45d76561a5302f2b();
    let matches = $7c6a1aaf94a1ce95$export$2378eb7f5ff86053();
    let navigation = $7c6a1aaf94a1ce95$export$d0fd4b7106de2769();
    $7hhBq.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $7c6a1aaf94a1ce95$var$usePageHide($7hhBq.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $7c6a1aaf94a1ce95$var$getScrollRestorationKey(location, matches, basename, getKey);
            $7c6a1aaf94a1ce95$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $7c6a1aaf94a1ce95$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($7c6a1aaf94a1ce95$var$savedScrollPositions));
        } catch (error) {
            $7c6a1aaf94a1ce95$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $7hhBq.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $7c6a1aaf94a1ce95$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $7c6a1aaf94a1ce95$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $7hhBq.useLayoutEffect(()=>{
            let disableScrollRestoration = router === null || router === void 0 ? void 0 : router.enableScrollRestoration($7c6a1aaf94a1ce95$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$7c6a1aaf94a1ce95$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $7hhBq.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch (e) {
                $7c6a1aaf94a1ce95$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $7c6a1aaf94a1ce95$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7hhBq.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $7c6a1aaf94a1ce95$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7hhBq.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $7c6a1aaf94a1ce95$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $7c6a1aaf94a1ce95$export$b273b3273281a049(when);
    $7hhBq.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7hhBq.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $7c6a1aaf94a1ce95$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $7hhBq.useContext($7c6a1aaf94a1ce95$export$3681f408decb40d1);
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $7c6a1aaf94a1ce95$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $7c6a1aaf94a1ce95$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $7c6a1aaf94a1ce95$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $7c6a1aaf94a1ce95$export$81336c211d5ff295(path.pathname, nextPath) != null || $7c6a1aaf94a1ce95$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $7c6a1aaf94a1ce95$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $7c6a1aaf94a1ce95$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $7c6a1aaf94a1ce95$var$getStatelessNavigator();
    return /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $7c6a1aaf94a1ce95$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $7c6a1aaf94a1ce95$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $7c6a1aaf94a1ce95$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $7c6a1aaf94a1ce95$var$serializeErrors(context.errors)
        };
        let json = $7c6a1aaf94a1ce95$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $7hhBq.createElement($7hhBq.Fragment, null, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $7hhBq.createElement($7c6a1aaf94a1ce95$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $7hhBq.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $7c6a1aaf94a1ce95$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($7c6a1aaf94a1ce95$export$972111febbeef05b(val)) serialized[key] = (0, $cNnl8._)((0, $dok7x._)({}, val), {
            __type: "RouteErrorResponse"
        });
        else if (val instanceof Error) serialized[key] = (0, $dok7x._)({
            message: val.message,
            __type: "Error"
        }, val.name !== "Error" ? {
            __subType: val.name
        } : {});
        else serialized[key] = val;
    }
    return serialized;
}
function $7c6a1aaf94a1ce95$var$getStatelessNavigator() {
    return {
        createHref: $7c6a1aaf94a1ce95$var$createHref,
        encodeLocation: $7c6a1aaf94a1ce95$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $7c6a1aaf94a1ce95$export$69163f0b72ec60d9(routes, opts) {
    return $7c6a1aaf94a1ce95$export$3336b097a6fbc59a(routes, (0, $cNnl8._)((0, $dok7x._)({}, opts), {
        mapRouteProperties: $7c6a1aaf94a1ce95$export$9269a41d8c4635e
    }));
}
function $7c6a1aaf94a1ce95$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $7c6a1aaf94a1ce95$export$87cb1a9238dc3fba(routes, $7c6a1aaf94a1ce95$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return (0, $cNnl8._)((0, $dok7x._)({}, match), {
            route: route
        });
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return (0, $dok7x._)({
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false
            }, opts === null || opts === void 0 ? void 0 : opts.future);
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $7c6a1aaf94a1ce95$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $7c6a1aaf94a1ce95$var$createHref,
        encodeLocation: $7c6a1aaf94a1ce95$var$encodeLocation,
        getFetcher () {
            return $7c6a1aaf94a1ce95$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $7c6a1aaf94a1ce95$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $7c6a1aaf94a1ce95$var$createHref(to) {
    return typeof to === "string" ? to : $7c6a1aaf94a1ce95$export$fe53371bee54353d(to);
}
function $7c6a1aaf94a1ce95$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $7c6a1aaf94a1ce95$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $7c6a1aaf94a1ce95$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $7c6a1aaf94a1ce95$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;

});

parcelRegister("d0uAT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $978301d00eaacbec$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");


var $eET99 = parcelRequire("eET99");

var $38swY = parcelRequire("38swY");
var $18TeW = parcelRequire("18TeW");

var $1zv4u = parcelRequire("1zv4u");

var $4ZZLe = parcelRequire("4ZZLe");

var $bUnnb = parcelRequire("bUnnb");

var $3CtK9 = parcelRequire("3CtK9");

var $96Mll = parcelRequire("96Mll");

var $iHpLz = parcelRequire("iHpLz");
'use client';
let $978301d00eaacbec$var$_ = (t)=>t, $978301d00eaacbec$var$t, $978301d00eaacbec$var$t1, $978301d00eaacbec$var$t2, $978301d00eaacbec$var$t3;
const $978301d00eaacbec$var$SIZE = 44;
const $978301d00eaacbec$var$circularRotateKeyframe = (0, $38swY.keyframes)($978301d00eaacbec$var$t || ($978301d00eaacbec$var$t = $978301d00eaacbec$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $978301d00eaacbec$var$circularDashKeyframe = (0, $38swY.keyframes)($978301d00eaacbec$var$t1 || ($978301d00eaacbec$var$t1 = $978301d00eaacbec$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`));
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $978301d00eaacbec$var$rotateAnimation = typeof $978301d00eaacbec$var$circularRotateKeyframe !== 'string' ? (0, $38swY.css)($978301d00eaacbec$var$t2 || ($978301d00eaacbec$var$t2 = $978301d00eaacbec$var$_`
        animation: ${0} 1.4s linear infinite;
      `), $978301d00eaacbec$var$circularRotateKeyframe) : null;
const $978301d00eaacbec$var$dashAnimation = typeof $978301d00eaacbec$var$circularDashKeyframe !== 'string' ? (0, $38swY.css)($978301d00eaacbec$var$t3 || ($978301d00eaacbec$var$t3 = $978301d00eaacbec$var$_`
        animation: ${0} 1.4s ease-in-out infinite;
      `), $978301d00eaacbec$var$circularDashKeyframe) : null;
const $978301d00eaacbec$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $bUnnb.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $bUnnb.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $eET99.default)(slots, (0, $96Mll.getCircularProgressUtilityClass), classes);
};
const $978301d00eaacbec$var$CircularProgressRoot = (0, $18TeW.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $bUnnb.default)(ownerState.color)}`]
        ];
    }
})((0, $1zv4u.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $978301d00eaacbec$var$rotateAnimation || {
                    animation: `${$978301d00eaacbec$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $3CtK9.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $978301d00eaacbec$var$CircularProgressSVG = (0, $18TeW.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $978301d00eaacbec$var$CircularProgressCircle = (0, $18TeW.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $bUnnb.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $1zv4u.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $978301d00eaacbec$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$978301d00eaacbec$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $978301d00eaacbec$var$CircularProgress = /*#__PURE__*/ $7hhBq.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $6pkKu._)(props, [
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $978301d00eaacbec$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($978301d00eaacbec$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $iHpLz.jsx)($978301d00eaacbec$var$CircularProgressRoot, (0, $cNnl8._)((0, $dok7x._)({
        className: (0, $5vmbh.default)(classes.root, className),
        style: (0, $dok7x._)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other), {
        children: /*#__PURE__*/ (0, $iHpLz.jsx)($978301d00eaacbec$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$978301d00eaacbec$var$SIZE / 2} ${$978301d00eaacbec$var$SIZE / 2} ${$978301d00eaacbec$var$SIZE} ${$978301d00eaacbec$var$SIZE}`,
            children: /*#__PURE__*/ (0, $iHpLz.jsx)($978301d00eaacbec$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $978301d00eaacbec$var$SIZE,
                cy: $978301d00eaacbec$var$SIZE,
                r: ($978301d00eaacbec$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $978301d00eaacbec$export$2e2bcd8739ae039 = $978301d00eaacbec$var$CircularProgress;

});
parcelRegister("96Mll", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", function () { return $6a1a2c90b7111681$export$29cad1383b3f235d; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $6a1a2c90b7111681$export$29cad1383b3f235d(slot) {
    return (0, $200uu.default)('MuiCircularProgress', slot);
}
const $6a1a2c90b7111681$var$circularProgressClasses = (0, $5blE7.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $6a1a2c90b7111681$export$2e2bcd8739ae039 = $6a1a2c90b7111681$var$circularProgressClasses;

});


parcelRegister("dmsNZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ba3ac9647d7550a$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");

var $641Kf = parcelRequire("641Kf");

var $gt1Df = parcelRequire("gt1Df");

var $eET99 = parcelRequire("eET99");


var $18TeW = parcelRequire("18TeW");

var $4ZZLe = parcelRequire("4ZZLe");

var $eGBcx = parcelRequire("eGBcx");

var $4WYTK = parcelRequire("4WYTK");

var $5vihd = parcelRequire("5vihd");

var $iHpLz = parcelRequire("iHpLz");
'use client';
function $9ba3ac9647d7550a$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $641Kf.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${themeSpacing})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $dok7x._)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $9ba3ac9647d7550a$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $641Kf.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $641Kf.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.startsWith('column')) output[`& > .${(0, $5vihd.default).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $9ba3ac9647d7550a$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $9ba3ac9647d7550a$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $641Kf.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $9ba3ac9647d7550a$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $641Kf.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `calc(-1 * ${themeSpacing})`,
                [`& > .${(0, $5vihd.default).item}`]: {
                    paddingTop: themeSpacing
                }
            };
            if (zeroValueBreakpointKeys === null || zeroValueBreakpointKeys === void 0 ? void 0 : zeroValueBreakpointKeys.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $5vihd.default).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $9ba3ac9647d7550a$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $641Kf.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $9ba3ac9647d7550a$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $641Kf.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') {
                const negativeValue = `calc(-1 * ${themeSpacing})`;
                return {
                    width: `calc(100% + ${themeSpacing})`,
                    marginLeft: negativeValue,
                    [`& > .${(0, $5vihd.default).item}`]: {
                        paddingLeft: themeSpacing
                    }
                };
            }
            if (zeroValueBreakpointKeys === null || zeroValueBreakpointKeys === void 0 ? void 0 : zeroValueBreakpointKeys.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $5vihd.default).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $9ba3ac9647d7550a$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $9ba3ac9647d7550a$var$GridRoot = (0, $18TeW.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $9ba3ac9647d7550a$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(// FIXME(romgrk): Can't use memoTheme here
({ ownerState: ownerState })=>(0, $dok7x._)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $9ba3ac9647d7550a$export$71d4225eeb1bc13e, $9ba3ac9647d7550a$export$380604d7c79f9e8f, $9ba3ac9647d7550a$export$4315fba5128fb4a1, $9ba3ac9647d7550a$export$ca2a698f6020fda);
function $9ba3ac9647d7550a$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $9ba3ac9647d7550a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $9ba3ac9647d7550a$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $eET99.default)(slots, (0, $5vihd.getGridUtilityClass), classes);
};
/**
 * @deprecated Use the [`Grid2`](https://mui.com/material-ui/react-grid2/) component instead.
 */ const $9ba3ac9647d7550a$var$Grid = /*#__PURE__*/ $7hhBq.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $eGBcx.default)();
    const props = (0, $gt1Df.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $6pkKu._)(props, [
        "className",
        "columns",
        "columnSpacing",
        "component",
        "container",
        "direction",
        "item",
        "rowSpacing",
        "spacing",
        "wrap",
        "zeroMinWidth"
    ]);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $7hhBq.useContext((0, $4WYTK.default));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $dok7x._)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $cNnl8._)((0, $dok7x._)((0, $cNnl8._)((0, $dok7x._)({}, props), {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }), breakpointsValues), {
        breakpoints: breakpoints.keys
    });
    const classes = $9ba3ac9647d7550a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $4WYTK.default).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $iHpLz.jsx)($9ba3ac9647d7550a$var$GridRoot, (0, $dok7x._)({
            ownerState: ownerState,
            className: (0, $5vmbh.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $9ba3ac9647d7550a$export$2e2bcd8739ae039 = $9ba3ac9647d7550a$var$Grid;

});
parcelRegister("4WYTK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39abd14dc9c12783$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
'use client';
/**
 * @ignore - internal component.
 */ const $39abd14dc9c12783$var$GridContext = /*#__PURE__*/ $7hhBq.createContext();
var $39abd14dc9c12783$export$2e2bcd8739ae039 = $39abd14dc9c12783$var$GridContext;

});

parcelRegister("5vihd", function(module, exports) {

$parcel$export(module.exports, "getGridUtilityClass", function () { return $401e065b21234dd9$export$9973ac5fd0181f33; });
$parcel$export(module.exports, "default", function () { return $401e065b21234dd9$export$2e2bcd8739ae039; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $401e065b21234dd9$export$9973ac5fd0181f33(slot) {
    return (0, $200uu.default)('MuiGrid', slot);
}
const $401e065b21234dd9$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $401e065b21234dd9$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $401e065b21234dd9$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $401e065b21234dd9$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $401e065b21234dd9$var$gridClasses = (0, $5blE7.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$401e065b21234dd9$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$401e065b21234dd9$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$401e065b21234dd9$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$401e065b21234dd9$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$401e065b21234dd9$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$401e065b21234dd9$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$401e065b21234dd9$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$401e065b21234dd9$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $401e065b21234dd9$export$2e2bcd8739ae039 = $401e065b21234dd9$var$gridClasses;

});


parcelRegister("ddi3l", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $99ea7e32a0fd7d7c$export$dd0a697e1782aedd; });

var $6ToT1 = parcelRequire("6ToT1");

var $6a4wT = parcelRequire("6a4wT");
"use client";
function $99ea7e32a0fd7d7c$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $6a4wT.useBaseQuery)(options, (0, $6ToT1.QueryObserver), queryClient);
}

});
parcelRegister("6ToT1", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", function () { return $504b2f146ecbde1d$export$a06cf8c0066f0d4c; });
// src/queryObserver.ts

var $j5YGc = parcelRequire("j5YGc");

var $iIj9i = parcelRequire("iIj9i");

var $dDvrN = parcelRequire("dDvrN");

var $biQO8 = parcelRequire("biQO8");

var $kJ06L = parcelRequire("kJ06L");

var $ji069 = parcelRequire("ji069");

var $4MpWb = parcelRequire("4MpWb");

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $jVNuv = parcelRequire("jVNuv");

var $307Gi = parcelRequire("307Gi");

var $csodM = parcelRequire("csodM");

var $hRF8n = parcelRequire("hRF8n");

var $efvjD = parcelRequire("efvjD");

var $kc6BE = parcelRequire("kc6BE");

var $49ckD = parcelRequire("49ckD");

var $jzve1 = parcelRequire("jzve1");
var $504b2f146ecbde1d$var$_client, $504b2f146ecbde1d$var$_currentQuery, $504b2f146ecbde1d$var$_currentQueryInitialState, $504b2f146ecbde1d$var$_currentResult, $504b2f146ecbde1d$var$_currentResultState, $504b2f146ecbde1d$var$_currentResultOptions, $504b2f146ecbde1d$var$_currentThenable, $504b2f146ecbde1d$var$_selectError, $504b2f146ecbde1d$var$_selectFn, $504b2f146ecbde1d$var$_selectResult, // This property keeps track of the last query with defined data.
// It will be used to pass the previous data and query to the placeholder function between renders.
$504b2f146ecbde1d$var$_lastQueryWithDefinedData, $504b2f146ecbde1d$var$_staleTimeoutId, $504b2f146ecbde1d$var$_refetchIntervalId, $504b2f146ecbde1d$var$_currentRefetchInterval, $504b2f146ecbde1d$var$_trackedProps, $504b2f146ecbde1d$var$_executeFetch, $504b2f146ecbde1d$var$_updateStaleTimeout, $504b2f146ecbde1d$var$_computeRefetchInterval, $504b2f146ecbde1d$var$_updateRefetchInterval, $504b2f146ecbde1d$var$_updateTimers, $504b2f146ecbde1d$var$_clearStaleTimeout, $504b2f146ecbde1d$var$_clearRefetchInterval, $504b2f146ecbde1d$var$_updateQuery, $504b2f146ecbde1d$var$_notify, $504b2f146ecbde1d$var$_class;
var $504b2f146ecbde1d$export$a06cf8c0066f0d4c = ($504b2f146ecbde1d$var$_client = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_currentQuery = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_currentQueryInitialState = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_currentResult = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_currentResultState = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_currentResultOptions = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_currentThenable = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_selectError = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_selectFn = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_selectResult = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_lastQueryWithDefinedData = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_staleTimeoutId = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_refetchIntervalId = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_currentRefetchInterval = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_trackedProps = /*#__PURE__*/ new WeakMap(), $504b2f146ecbde1d$var$_executeFetch = /*#__PURE__*/ new WeakSet(), $504b2f146ecbde1d$var$_updateStaleTimeout = /*#__PURE__*/ new WeakSet(), $504b2f146ecbde1d$var$_computeRefetchInterval = /*#__PURE__*/ new WeakSet(), $504b2f146ecbde1d$var$_updateRefetchInterval = /*#__PURE__*/ new WeakSet(), $504b2f146ecbde1d$var$_updateTimers = /*#__PURE__*/ new WeakSet(), $504b2f146ecbde1d$var$_clearStaleTimeout = /*#__PURE__*/ new WeakSet(), $504b2f146ecbde1d$var$_clearRefetchInterval = /*#__PURE__*/ new WeakSet(), $504b2f146ecbde1d$var$_updateQuery = /*#__PURE__*/ new WeakSet(), $504b2f146ecbde1d$var$_notify = /*#__PURE__*/ new WeakSet(), $504b2f146ecbde1d$var$_class = class extends (0, $efvjD.Subscribable) {
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery).addObserver(this);
            if ($504b2f146ecbde1d$var$shouldFetchOnMount((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery), this.options)) (0, $biQO8._)(this, $504b2f146ecbde1d$var$_executeFetch, $504b2f146ecbde1d$var$executeFetch).call(this);
            else this.updateResult();
            (0, $biQO8._)(this, $504b2f146ecbde1d$var$_updateTimers, $504b2f146ecbde1d$var$updateTimers).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $504b2f146ecbde1d$var$shouldFetchOn((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $504b2f146ecbde1d$var$shouldFetchOn((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $biQO8._)(this, $504b2f146ecbde1d$var$_clearStaleTimeout, $504b2f146ecbde1d$var$clearStaleTimeout).call(this);
        (0, $biQO8._)(this, $504b2f146ecbde1d$var$_clearRefetchInterval, $504b2f146ecbde1d$var$clearRefetchInterval).call(this);
        (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery).removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery);
        this.options = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $49ckD.resolveQueryBoolean)(this.options.enabled, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $biQO8._)(this, $504b2f146ecbde1d$var$_updateQuery, $504b2f146ecbde1d$var$updateQuery).call(this);
        (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $49ckD.shallowEqualObjects)(this.options, prevOptions)) (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $504b2f146ecbde1d$var$shouldFetchOptionally((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $biQO8._)(this, $504b2f146ecbde1d$var$_executeFetch, $504b2f146ecbde1d$var$executeFetch).call(this);
        this.updateResult();
        if (mounted && ((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery) !== prevQuery || (0, $49ckD.resolveQueryBoolean)(this.options.enabled, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery)) !== (0, $49ckD.resolveQueryBoolean)(prevOptions.enabled, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery)) || (0, $49ckD.resolveStaleTime)(this.options.staleTime, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery)) !== (0, $49ckD.resolveStaleTime)(prevOptions.staleTime, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery)))) (0, $biQO8._)(this, $504b2f146ecbde1d$var$_updateStaleTimeout, $504b2f146ecbde1d$var$updateStaleTimeout).call(this);
        const nextRefetchInterval = (0, $biQO8._)(this, $504b2f146ecbde1d$var$_computeRefetchInterval, $504b2f146ecbde1d$var$computeRefetchInterval).call(this);
        if (mounted && ((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery) !== prevQuery || (0, $49ckD.resolveQueryBoolean)(this.options.enabled, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery)) !== (0, $49ckD.resolveQueryBoolean)(prevOptions.enabled, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery)) || nextRefetchInterval !== (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentRefetchInterval))) (0, $biQO8._)(this, $504b2f146ecbde1d$var$_updateRefetchInterval, $504b2f146ecbde1d$var$updateRefetchInterval).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_client).getQueryCache().build((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_client), options);
        const result = this.createResult(query, options);
        if ($504b2f146ecbde1d$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_currentResult, result);
            (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_currentResultOptions, this.options);
            (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_currentResultState, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked === null || onPropTracked === void 0 ? void 0 : onPropTracked(key);
                if (key === "promise") {
                    this.trackProp("data");
                    if (!this.options.experimental_prefetchInRender && (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentThenable).status === "pending") (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                }
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery);
    }
    refetch(_param = {}) {
        var options = (0, $ji069._)({}, (0, $4MpWb._)(_param));
        return this.fetch((0, $dok7x._)({}, options));
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_client).defaultQueryOptions(options);
        const query = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_client).getQueryCache().build((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions_cancelRefetch;
        return (0, $biQO8._)(this, $504b2f146ecbde1d$var$_executeFetch, $504b2f146ecbde1d$var$executeFetch).call(this, (0, $cNnl8._)((0, $dok7x._)({}, fetchOptions), {
            cancelRefetch: (_fetchOptions_cancelRefetch = fetchOptions.cancelRefetch) !== null && _fetchOptions_cancelRefetch !== void 0 ? _fetchOptions_cancelRefetch : true
        })).then(()=>{
            this.updateResult();
            return (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResult);
        });
    }
    createResult(query, options) {
        const prevQuery = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResult);
        const prevResultState = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResultState);
        const prevResultOptions = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = (0, $dok7x._)({}, state);
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $504b2f146ecbde1d$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $504b2f146ecbde1d$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = (0, $dok7x._)({}, newState, (0, $hRF8n.fetchState)(state.data, query.options));
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            var _class_private_field_get1;
            let placeholderData;
            if ((prevResult === null || prevResult === void 0 ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions === null || prevResultOptions === void 0 ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_class_private_field_get1 = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_lastQueryWithDefinedData)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.state.data, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_lastQueryWithDefinedData)) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $49ckD.replaceData)(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState === null || prevResultState === void 0 ? void 0 : prevResultState.data) && options.select === (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_selectFn)) data = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_selectResult);
            else try {
                (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_selectFn, options.select);
                data = options.select(data);
                data = (0, $49ckD.replaceData)(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, data, options);
                (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_selectResult, data);
                (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_selectError, null);
            } catch (selectError) {
                (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_selectError, selectError);
            }
        }
        if ((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_selectError)) {
            error = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_selectError);
            data = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: query.isFetched(),
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $504b2f146ecbde1d$var$isStale(query, options),
            refetch: this.refetch,
            promise: (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentThenable),
            isEnabled: (0, $49ckD.resolveQueryBoolean)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const hasResultData = nextResult.data !== void 0;
            const isErrorWithoutData = nextResult.status === "error" && !hasResultData;
            const finalizeThenableIfPossible = (thenable)=>{
                if (isErrorWithoutData) thenable.reject(nextResult.error);
                else if (hasResultData) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_currentThenable, nextResult.promise = (0, $kc6BE.pendingThenable)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (isErrorWithoutData || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (!isErrorWithoutData || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResult);
        const nextResult = this.createResult((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery), this.options);
        (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_currentResultState, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery).state);
        (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_currentResultOptions, this.options);
        if ((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResultState).data !== void 0) (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_lastQueryWithDefinedData, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery));
        if ((0, $49ckD.shallowEqualObjects)(nextResult, prevResult)) return;
        (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_currentResult, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $j5YGc._)(this, $504b2f146ecbde1d$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue !== null && notifyOnChangePropsValue !== void 0 ? notifyOnChangePropsValue : (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        (0, $biQO8._)(this, $504b2f146ecbde1d$var$_notify, $504b2f146ecbde1d$var$notify).call(this, {
            listeners: shouldNotifyListeners()
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $biQO8._)(this, $504b2f146ecbde1d$var$_updateTimers, $504b2f146ecbde1d$var$updateTimers).call(this);
    }
    constructor(client, options){
        super(), (0, $kJ06L._)(this, $504b2f146ecbde1d$var$_executeFetch), (0, $kJ06L._)(this, $504b2f146ecbde1d$var$_updateStaleTimeout), (0, $kJ06L._)(this, $504b2f146ecbde1d$var$_computeRefetchInterval), (0, $kJ06L._)(this, $504b2f146ecbde1d$var$_updateRefetchInterval), (0, $kJ06L._)(this, $504b2f146ecbde1d$var$_updateTimers), (0, $kJ06L._)(this, $504b2f146ecbde1d$var$_clearStaleTimeout), (0, $kJ06L._)(this, $504b2f146ecbde1d$var$_clearRefetchInterval), (0, $kJ06L._)(this, $504b2f146ecbde1d$var$_updateQuery), (0, $kJ06L._)(this, $504b2f146ecbde1d$var$_notify), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_client, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_currentQuery, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_currentQueryInitialState, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_currentResult, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_currentResultState, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_currentResultOptions, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_currentThenable, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_selectError, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_selectFn, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_selectResult, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_lastQueryWithDefinedData, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_staleTimeoutId, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_refetchIntervalId, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_currentRefetchInterval, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $504b2f146ecbde1d$var$_trackedProps, {
            writable: true,
            value: /* @__PURE__ */ new Set()
        });
        this.options = options;
        (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_client, client);
        (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_selectError, null);
        (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_currentThenable, (0, $kc6BE.pendingThenable)());
        this.bindMethods();
        this.setOptions(options);
    }
}, $504b2f146ecbde1d$var$_class);
function $504b2f146ecbde1d$var$shouldLoadOnMount(query, options) {
    return (0, $49ckD.resolveQueryBoolean)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && (0, $49ckD.resolveQueryBoolean)(options.retryOnMount, query) === false);
}
function $504b2f146ecbde1d$var$shouldFetchOnMount(query, options) {
    return $504b2f146ecbde1d$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $504b2f146ecbde1d$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $504b2f146ecbde1d$var$shouldFetchOn(query, options, field) {
    if ((0, $49ckD.resolveQueryBoolean)(options.enabled, query) !== false && (0, $49ckD.resolveStaleTime)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $504b2f146ecbde1d$var$isStale(query, options);
    }
    return false;
}
function $504b2f146ecbde1d$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $49ckD.resolveQueryBoolean)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $504b2f146ecbde1d$var$isStale(query, options);
}
function $504b2f146ecbde1d$var$isStale(query, options) {
    return (0, $49ckD.resolveQueryBoolean)(options.enabled, query) !== false && query.isStaleByTime((0, $49ckD.resolveStaleTime)(options.staleTime, query));
}
function $504b2f146ecbde1d$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $49ckD.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}
function $504b2f146ecbde1d$var$executeFetch(fetchOptions) {
    (0, $biQO8._)(this, $504b2f146ecbde1d$var$_updateQuery, $504b2f146ecbde1d$var$updateQuery).call(this);
    let promise = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $49ckD.noop));
    return promise;
}
function $504b2f146ecbde1d$var$updateStaleTimeout() {
    (0, $biQO8._)(this, $504b2f146ecbde1d$var$_clearStaleTimeout, $504b2f146ecbde1d$var$clearStaleTimeout).call(this);
    const staleTime = (0, $49ckD.resolveStaleTime)(this.options.staleTime, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery));
    if ((0, $307Gi.environmentManager).isServer() || (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResult).isStale || !(0, $49ckD.isValidTimeout)(staleTime)) return;
    const time = (0, $49ckD.timeUntilStale)((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_staleTimeoutId, (0, $jzve1.timeoutManager).setTimeout(()=>{
        if (!(0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResult).isStale) this.updateResult();
    }, timeout));
}
function $504b2f146ecbde1d$var$computeRefetchInterval() {
    var _ref;
    return (_ref = typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery)) : this.options.refetchInterval) !== null && _ref !== void 0 ? _ref : false;
}
function $504b2f146ecbde1d$var$updateRefetchInterval(nextInterval) {
    (0, $biQO8._)(this, $504b2f146ecbde1d$var$_clearRefetchInterval, $504b2f146ecbde1d$var$clearRefetchInterval).call(this);
    (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_currentRefetchInterval, nextInterval);
    if ((0, $307Gi.environmentManager).isServer() || (0, $49ckD.resolveQueryBoolean)(this.options.enabled, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery)) === false || !(0, $49ckD.isValidTimeout)((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentRefetchInterval)) || (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentRefetchInterval) === 0) return;
    (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_refetchIntervalId, (0, $jzve1.timeoutManager).setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $jVNuv.focusManager).isFocused()) (0, $biQO8._)(this, $504b2f146ecbde1d$var$_executeFetch, $504b2f146ecbde1d$var$executeFetch).call(this);
    }, (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentRefetchInterval)));
}
function $504b2f146ecbde1d$var$updateTimers() {
    (0, $biQO8._)(this, $504b2f146ecbde1d$var$_updateStaleTimeout, $504b2f146ecbde1d$var$updateStaleTimeout).call(this);
    (0, $biQO8._)(this, $504b2f146ecbde1d$var$_updateRefetchInterval, $504b2f146ecbde1d$var$updateRefetchInterval).call(this, (0, $biQO8._)(this, $504b2f146ecbde1d$var$_computeRefetchInterval, $504b2f146ecbde1d$var$computeRefetchInterval).call(this));
}
function $504b2f146ecbde1d$var$clearStaleTimeout() {
    if ((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_staleTimeoutId) !== void 0) {
        (0, $jzve1.timeoutManager).clearTimeout((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_staleTimeoutId));
        (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_staleTimeoutId, void 0);
    }
}
function $504b2f146ecbde1d$var$clearRefetchInterval() {
    if ((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_refetchIntervalId) !== void 0) {
        (0, $jzve1.timeoutManager).clearInterval((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_refetchIntervalId));
        (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_refetchIntervalId, void 0);
    }
}
function $504b2f146ecbde1d$var$updateQuery() {
    const query = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_client).getQueryCache().build((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_client), this.options);
    if (query === (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery)) return;
    const prevQuery = (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery);
    (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_currentQuery, query);
    (0, $dDvrN._)(this, $504b2f146ecbde1d$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery === null || prevQuery === void 0 ? void 0 : prevQuery.removeObserver(this);
        query.addObserver(this);
    }
}
function $504b2f146ecbde1d$var$notify(notifyOptions) {
    (0, $csodM.notifyManager).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentResult));
        });
        (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_client).getQueryCache().notify({
            query: (0, $j5YGc._)(this, $504b2f146ecbde1d$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
}

});
parcelRegister("ji069", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e0afc63f70b03745$export$71511d61b312f219; });
function $e0afc63f70b03745$export$71511d61b312f219() {
    $e0afc63f70b03745$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e0afc63f70b03745$export$71511d61b312f219.apply(this, arguments);
}

});

parcelRegister("4MpWb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $37afc3bdbd7091be$export$71511d61b312f219; });
function $37afc3bdbd7091be$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}

});

parcelRegister("hRF8n", function(module, exports) {

$parcel$export(module.exports, "Query", function () { return $d0174b4947f4263f$export$62297b13309008b2; });
$parcel$export(module.exports, "fetchState", function () { return $d0174b4947f4263f$export$f3df9013f2b58bce; });
// src/query.ts

var $j5YGc = parcelRequire("j5YGc");

var $iIj9i = parcelRequire("iIj9i");

var $dDvrN = parcelRequire("dDvrN");

var $biQO8 = parcelRequire("biQO8");

var $kJ06L = parcelRequire("kJ06L");

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $49ckD = parcelRequire("49ckD");

var $csodM = parcelRequire("csodM");

var $c1hkl = parcelRequire("c1hkl");

var $3bmlv = parcelRequire("3bmlv");

var $6ezc5 = parcelRequire("6ezc5");
var $d0174b4947f4263f$var$_queryType, $d0174b4947f4263f$var$_initialState, $d0174b4947f4263f$var$_revertState, $d0174b4947f4263f$var$_cache, $d0174b4947f4263f$var$_client, $d0174b4947f4263f$var$_retryer, $d0174b4947f4263f$var$_defaultOptions, $d0174b4947f4263f$var$_abortSignalConsumed, $d0174b4947f4263f$var$_isInitialPausedFetch, $d0174b4947f4263f$var$_dispatch, $d0174b4947f4263f$var$_class;
var $d0174b4947f4263f$export$62297b13309008b2 = ($d0174b4947f4263f$var$_queryType = /*#__PURE__*/ new WeakMap(), $d0174b4947f4263f$var$_initialState = /*#__PURE__*/ new WeakMap(), $d0174b4947f4263f$var$_revertState = /*#__PURE__*/ new WeakMap(), $d0174b4947f4263f$var$_cache = /*#__PURE__*/ new WeakMap(), $d0174b4947f4263f$var$_client = /*#__PURE__*/ new WeakMap(), $d0174b4947f4263f$var$_retryer = /*#__PURE__*/ new WeakMap(), $d0174b4947f4263f$var$_defaultOptions = /*#__PURE__*/ new WeakMap(), $d0174b4947f4263f$var$_abortSignalConsumed = /*#__PURE__*/ new WeakMap(), $d0174b4947f4263f$var$_isInitialPausedFetch = /*#__PURE__*/ new WeakSet(), $d0174b4947f4263f$var$_dispatch = /*#__PURE__*/ new WeakSet(), $d0174b4947f4263f$var$_class = class extends (0, $3bmlv.Removable) {
    get meta() {
        return this.options.meta;
    }
    get queryType() {
        return (0, $j5YGc._)(this, $d0174b4947f4263f$var$_queryType);
    }
    get promise() {
        var _class_private_field_get1;
        return (_class_private_field_get1 = (0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.promise;
    }
    setOptions(options) {
        this.options = (0, $dok7x._)({}, (0, $j5YGc._)(this, $d0174b4947f4263f$var$_defaultOptions), options);
        if (options === null || options === void 0 ? void 0 : options._type) (0, $dDvrN._)(this, $d0174b4947f4263f$var$_queryType, options._type);
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $d0174b4947f4263f$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($d0174b4947f4263f$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                (0, $dDvrN._)(this, $d0174b4947f4263f$var$_initialState, defaultState);
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $j5YGc._)(this, $d0174b4947f4263f$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $49ckD.replaceData)(this.state.data, newData, this.options);
        (0, $biQO8._)(this, $d0174b4947f4263f$var$_dispatch, $d0174b4947f4263f$var$dispatch).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options === null || options === void 0 ? void 0 : options.updatedAt,
            manual: options === null || options === void 0 ? void 0 : options.manual
        });
        return data;
    }
    setState(state) {
        (0, $biQO8._)(this, $d0174b4947f4263f$var$_dispatch, $d0174b4947f4263f$var$dispatch).call(this, {
            type: "setState",
            state: state
        });
    }
    cancel(options) {
        var _class_private_field_get1, _class_private_field_get2;
        const promise = (_class_private_field_get1 = (0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.promise;
        (_class_private_field_get2 = (0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.cancel(options);
        return promise ? promise.then((0, $49ckD.noop)).catch((0, $49ckD.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    get resetState() {
        return (0, $j5YGc._)(this, $d0174b4947f4263f$var$_initialState);
    }
    reset() {
        this.destroy();
        this.setState(this.resetState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $49ckD.resolveQueryBoolean)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $49ckD.skipToken) || !this.isFetched();
    }
    isFetched() {
        return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $49ckD.resolveStaleTime)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $49ckD.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _class_private_field_get1;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer === null || observer === void 0 ? void 0 : observer.refetch({
            cancelRefetch: false
        });
        (_class_private_field_get1 = (0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.continue();
    }
    onOnline() {
        var _class_private_field_get1;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer === null || observer === void 0 ? void 0 : observer.refetch({
            cancelRefetch: false
        });
        (_class_private_field_get1 = (0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $j5YGc._)(this, $d0174b4947f4263f$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer)) {
                    if ((0, $j5YGc._)(this, $d0174b4947f4263f$var$_abortSignalConsumed) || (0, $biQO8._)(this, $d0174b4947f4263f$var$_isInitialPausedFetch, $d0174b4947f4263f$var$isInitialPausedFetch).call(this)) (0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $j5YGc._)(this, $d0174b4947f4263f$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $biQO8._)(this, $d0174b4947f4263f$var$_dispatch, $d0174b4947f4263f$var$dispatch).call(this, {
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        var _class_private_field_get1, _context_fetchOptions, _context_fetchOptions1;
        if (this.state.fetchStatus !== "idle" && // If the promise in the retryer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        ((_class_private_field_get1 = (0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer)) {
                (0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer).continueRetry();
                return (0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $dDvrN._)(this, $d0174b4947f4263f$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $49ckD.ensureQueryFn)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: (0, $j5YGc._)(this, $d0174b4947f4263f$var$_client),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            (0, $dDvrN._)(this, $d0174b4947f4263f$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, $j5YGc._)(this, $d0174b4947f4263f$var$_client),
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        const behavior = (0, $j5YGc._)(this, $d0174b4947f4263f$var$_queryType) === "infinite" ? (0, $6ezc5.infiniteQueryBehavior)(this.options.pages) : this.options.behavior;
        behavior === null || behavior === void 0 ? void 0 : behavior.onFetch(context, this);
        (0, $dDvrN._)(this, $d0174b4947f4263f$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context_fetchOptions = context.fetchOptions) === null || _context_fetchOptions === void 0 ? void 0 : _context_fetchOptions.meta)) (0, $biQO8._)(this, $d0174b4947f4263f$var$_dispatch, $d0174b4947f4263f$var$dispatch).call(this, {
            type: "fetch",
            meta: (_context_fetchOptions1 = context.fetchOptions) === null || _context_fetchOptions1 === void 0 ? void 0 : _context_fetchOptions1.meta
        });
        (0, $dDvrN._)(this, $d0174b4947f4263f$var$_retryer, (0, $c1hkl.createRetryer)({
            initialPromise: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $c1hkl.CancelledError) && error.revert) this.setState((0, $cNnl8._)((0, $dok7x._)({}, (0, $j5YGc._)(this, $d0174b4947f4263f$var$_revertState)), {
                    fetchStatus: "idle"
                }));
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                (0, $biQO8._)(this, $d0174b4947f4263f$var$_dispatch, $d0174b4947f4263f$var$dispatch).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $biQO8._)(this, $d0174b4947f4263f$var$_dispatch, $d0174b4947f4263f$var$dispatch).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $biQO8._)(this, $d0174b4947f4263f$var$_dispatch, $d0174b4947f4263f$var$dispatch).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            var _class_private_field_get_config_onSuccess, _class_private_field_get_config, _class_private_field_get_config_onSettled, _class_private_field_get_config1;
            const data = await (0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer).start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            (_class_private_field_get_config_onSuccess = (_class_private_field_get_config = (0, $j5YGc._)(this, $d0174b4947f4263f$var$_cache).config).onSuccess) === null || _class_private_field_get_config_onSuccess === void 0 ? void 0 : _class_private_field_get_config_onSuccess.call(_class_private_field_get_config, data, this);
            (_class_private_field_get_config_onSettled = (_class_private_field_get_config1 = (0, $j5YGc._)(this, $d0174b4947f4263f$var$_cache).config).onSettled) === null || _class_private_field_get_config_onSettled === void 0 ? void 0 : _class_private_field_get_config_onSettled.call(_class_private_field_get_config1, data, this.state.error, this);
            return data;
        } catch (error) {
            var _class_private_field_get_config_onError, _class_private_field_get_config2, _class_private_field_get_config_onSettled1, _class_private_field_get_config3;
            if (error instanceof (0, $c1hkl.CancelledError)) {
                if (error.silent) return (0, $j5YGc._)(this, $d0174b4947f4263f$var$_retryer).promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, $biQO8._)(this, $d0174b4947f4263f$var$_dispatch, $d0174b4947f4263f$var$dispatch).call(this, {
                type: "error",
                error: error
            });
            (_class_private_field_get_config_onError = (_class_private_field_get_config2 = (0, $j5YGc._)(this, $d0174b4947f4263f$var$_cache).config).onError) === null || _class_private_field_get_config_onError === void 0 ? void 0 : _class_private_field_get_config_onError.call(_class_private_field_get_config2, error, this);
            (_class_private_field_get_config_onSettled1 = (_class_private_field_get_config3 = (0, $j5YGc._)(this, $d0174b4947f4263f$var$_cache).config).onSettled) === null || _class_private_field_get_config_onSettled1 === void 0 ? void 0 : _class_private_field_get_config_onSettled1.call(_class_private_field_get_config3, this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
    constructor(config){
        super(), (0, $kJ06L._)(this, $d0174b4947f4263f$var$_isInitialPausedFetch), (0, $kJ06L._)(this, $d0174b4947f4263f$var$_dispatch), (0, $iIj9i._)(this, $d0174b4947f4263f$var$_queryType, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $d0174b4947f4263f$var$_initialState, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $d0174b4947f4263f$var$_revertState, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $d0174b4947f4263f$var$_cache, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $d0174b4947f4263f$var$_client, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $d0174b4947f4263f$var$_retryer, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $d0174b4947f4263f$var$_defaultOptions, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $d0174b4947f4263f$var$_abortSignalConsumed, {
            writable: true,
            value: void 0
        });
        (0, $dDvrN._)(this, $d0174b4947f4263f$var$_abortSignalConsumed, false);
        (0, $dDvrN._)(this, $d0174b4947f4263f$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $dDvrN._)(this, $d0174b4947f4263f$var$_client, config.client);
        (0, $dDvrN._)(this, $d0174b4947f4263f$var$_cache, (0, $j5YGc._)(this, $d0174b4947f4263f$var$_client).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $dDvrN._)(this, $d0174b4947f4263f$var$_initialState, $d0174b4947f4263f$var$getDefaultState(this.options));
        var _config_state;
        this.state = (_config_state = config.state) !== null && _config_state !== void 0 ? _config_state : (0, $j5YGc._)(this, $d0174b4947f4263f$var$_initialState);
        this.scheduleGc();
    }
}, $d0174b4947f4263f$var$_class);
function $d0174b4947f4263f$export$f3df9013f2b58bce(data, options) {
    return (0, $dok7x._)({
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $c1hkl.canFetch)(options.networkMode) ? "fetching" : "paused"
    }, data === void 0 && {
        error: null,
        status: "pending"
    });
}
function $d0174b4947f4263f$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt !== null && dataUpdatedAt !== void 0 ? dataUpdatedAt : Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function $d0174b4947f4263f$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt !== null && initialDataUpdatedAt !== void 0 ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}
function $d0174b4947f4263f$var$isInitialPausedFetch() {
    return this.state.fetchStatus === "paused" && this.state.status === "pending";
}
function $d0174b4947f4263f$var$dispatch(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return (0, $cNnl8._)((0, $dok7x._)({}, state), {
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                });
            case "pause":
                return (0, $cNnl8._)((0, $dok7x._)({}, state), {
                    fetchStatus: "paused"
                });
            case "continue":
                return (0, $cNnl8._)((0, $dok7x._)({}, state), {
                    fetchStatus: "fetching"
                });
            case "fetch":
                var _action_meta;
                return (0, $cNnl8._)((0, $dok7x._)({}, state, $d0174b4947f4263f$export$f3df9013f2b58bce(state.data, this.options)), {
                    fetchMeta: (_action_meta = action.meta) !== null && _action_meta !== void 0 ? _action_meta : null
                });
            case "success":
                const newState = (0, $dok7x._)((0, $cNnl8._)((0, $dok7x._)({}, state, $d0174b4947f4263f$var$successState(action.data, action.dataUpdatedAt)), {
                    dataUpdateCount: state.dataUpdateCount + 1
                }), !action.manual && {
                    fetchStatus: "idle",
                    fetchFailureCount: 0,
                    fetchFailureReason: null
                });
                (0, $dDvrN._)(this, $d0174b4947f4263f$var$_revertState, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return (0, $cNnl8._)((0, $dok7x._)({}, state), {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error",
                    // flag existing data as invalidated if we get a background error
                    // note that "no data" always means stale so we can set unconditionally here
                    isInvalidated: true
                });
            case "invalidate":
                return (0, $cNnl8._)((0, $dok7x._)({}, state), {
                    isInvalidated: true
                });
            case "setState":
                return (0, $dok7x._)({}, state, action.state);
        }
    };
    this.state = reducer(this.state);
    (0, $csodM.notifyManager).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $j5YGc._)(this, $d0174b4947f4263f$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
}

});
parcelRegister("6ezc5", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", function () { return $489f59af7b4c2904$export$84470d1367601e8d; });
// src/infiniteQueryBehavior.ts

var $49ckD = parcelRequire("49ckD");
function $489f59af7b4c2904$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _context_fetchOptions_meta_fetchMore, _context_fetchOptions_meta, _context_fetchOptions, _context_state_data, _context_state_data1;
            const options = context.options;
            const direction = (_context_fetchOptions = context.fetchOptions) === null || _context_fetchOptions === void 0 ? void 0 : (_context_fetchOptions_meta = _context_fetchOptions.meta) === null || _context_fetchOptions_meta === void 0 ? void 0 : (_context_fetchOptions_meta_fetchMore = _context_fetchOptions_meta.fetchMore) === null || _context_fetchOptions_meta_fetchMore === void 0 ? void 0 : _context_fetchOptions_meta_fetchMore.direction;
            const oldPages = ((_context_state_data = context.state.data) === null || _context_state_data === void 0 ? void 0 : _context_state_data.pages) || [];
            const oldPageParams = ((_context_state_data1 = context.state.data) === null || _context_state_data1 === void 0 ? void 0 : _context_state_data1.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, $49ckD.addConsumeAwareSignal)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, $49ckD.ensureQueryFn)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject(context.signal.reason);
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $49ckD.addToStart) : (0, $49ckD.addToEnd);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $489f59af7b4c2904$var$getPreviousPageParam : $489f59af7b4c2904$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages !== null && pages !== void 0 ? pages : oldPages.length;
                    do {
                        var _oldPageParams_;
                        const param = currentPage === 0 ? (_oldPageParams_ = oldPageParams[0]) !== null && _oldPageParams_ !== void 0 ? _oldPageParams_ : options.initialPageParam : $489f59af7b4c2904$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _context_options_persister, _context_options;
                return (_context_options_persister = (_context_options = context.options).persister) === null || _context_options_persister === void 0 ? void 0 : _context_options_persister.call(_context_options, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $489f59af7b4c2904$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $489f59af7b4c2904$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _options_getPreviousPageParam;
    return pages.length > 0 ? (_options_getPreviousPageParam = options.getPreviousPageParam) === null || _options_getPreviousPageParam === void 0 ? void 0 : _options_getPreviousPageParam.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $489f59af7b4c2904$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $489f59af7b4c2904$var$getNextPageParam(options, data) != null;
}
function $489f59af7b4c2904$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $489f59af7b4c2904$var$getPreviousPageParam(options, data) != null;
}

});



parcelRegister("6a4wT", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", function () { return $47c730b6eabad338$export$fff0865807e996c5; });

var $7hhBq = parcelRequire("7hhBq");

var $307Gi = parcelRequire("307Gi");
var $49ckD = parcelRequire("49ckD");
var $csodM = parcelRequire("csodM");

var $a0iaM = parcelRequire("a0iaM");

var $1zAWh = parcelRequire("1zAWh");

var $4g2KL = parcelRequire("4g2KL");

var $99S1k = parcelRequire("99S1k");

var $lbVMT = parcelRequire("lbVMT");
"use client";
function $47c730b6eabad338$export$fff0865807e996c5(options, Observer, queryClient) {
    var _client_getDefaultOptions_queries__experimental_beforeQuery, _client_getDefaultOptions_queries, _client_getDefaultOptions_queries__experimental_afterQuery, _client_getDefaultOptions_queries1;
    const isRestoring = (0, $99S1k.useIsRestoring)();
    const errorResetBoundary = (0, $1zAWh.useQueryErrorResetBoundary)();
    const client = (0, $a0iaM.useQueryClient)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    (_client_getDefaultOptions_queries = client.getDefaultOptions().queries) === null || _client_getDefaultOptions_queries === void 0 ? void 0 : (_client_getDefaultOptions_queries__experimental_beforeQuery = _client_getDefaultOptions_queries._experimental_beforeQuery) === null || _client_getDefaultOptions_queries__experimental_beforeQuery === void 0 ? void 0 : _client_getDefaultOptions_queries__experimental_beforeQuery.call(_client_getDefaultOptions_queries, defaultedOptions);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    const subscribed = options.subscribed !== false;
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : subscribed ? "optimistic" : void 0;
    (0, $lbVMT.ensureSuspenseTimers)(defaultedOptions);
    (0, $4g2KL.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary, query);
    (0, $4g2KL.useClearResetErrorBoundary)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $7hhBq.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && subscribed;
    $7hhBq.useSyncExternalStore($7hhBq.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $csodM.notifyManager).batchCalls(onStoreChange)) : (0, $49ckD.noop);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $7hhBq.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $lbVMT.shouldSuspend)(defaultedOptions, result)) throw (0, $lbVMT.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $4g2KL.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    (_client_getDefaultOptions_queries1 = client.getDefaultOptions().queries) === null || _client_getDefaultOptions_queries1 === void 0 ? void 0 : (_client_getDefaultOptions_queries__experimental_afterQuery = _client_getDefaultOptions_queries1._experimental_afterQuery) === null || _client_getDefaultOptions_queries__experimental_afterQuery === void 0 ? void 0 : _client_getDefaultOptions_queries__experimental_afterQuery.call(_client_getDefaultOptions_queries1, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $307Gi.environmentManager).isServer() && (0, $lbVMT.willFetch)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $lbVMT.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        query === null || query === void 0 ? void 0 : query.promise;
        promise === null || promise === void 0 ? void 0 : promise.catch((0, $49ckD.noop)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("1zAWh", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", function () { return $1255b6a454fc77e6$export$50dfac555130cafd; });

var $7hhBq = parcelRequire("7hhBq");

var $iHpLz = parcelRequire("iHpLz");
"use client";
function $1255b6a454fc77e6$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $1255b6a454fc77e6$var$QueryErrorResetBoundaryContext = $7hhBq.createContext($1255b6a454fc77e6$var$createValue());
var $1255b6a454fc77e6$export$50dfac555130cafd = ()=>$7hhBq.useContext($1255b6a454fc77e6$var$QueryErrorResetBoundaryContext);
var $1255b6a454fc77e6$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $7hhBq.useState(()=>$1255b6a454fc77e6$var$createValue());
    return /* @__PURE__ */ (0, $iHpLz.jsx)($1255b6a454fc77e6$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};

});

parcelRegister("4g2KL", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", function () { return $319acac7d0f5cb9a$export$ae8adb3de3d77633; });
$parcel$export(module.exports, "useClearResetErrorBoundary", function () { return $319acac7d0f5cb9a$export$b2b17ca3a1fb0229; });
$parcel$export(module.exports, "getHasError", function () { return $319acac7d0f5cb9a$export$1fbcf724762d607; });

var $7hhBq = parcelRequire("7hhBq");

var $49ckD = parcelRequire("49ckD");
"use client";
var $319acac7d0f5cb9a$export$ae8adb3de3d77633 = (options, errorResetBoundary, query)=>{
    const throwOnError = (query === null || query === void 0 ? void 0 : query.state.error) && typeof options.throwOnError === "function" ? (0, $49ckD.shouldThrowError)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || options.experimental_prefetchInRender || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $319acac7d0f5cb9a$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $7hhBq.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $319acac7d0f5cb9a$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $49ckD.shouldThrowError)(throwOnError, [
        result.error,
        query
    ]));
};

});

parcelRegister("99S1k", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", function () { return $6aaedba29cc20dcd$export$4da0178d6b5f553; });

var $7hhBq = parcelRequire("7hhBq");
"use client";
var $6aaedba29cc20dcd$var$IsRestoringContext = $7hhBq.createContext(false);
var $6aaedba29cc20dcd$export$4da0178d6b5f553 = ()=>$7hhBq.useContext($6aaedba29cc20dcd$var$IsRestoringContext);
var $6aaedba29cc20dcd$export$593807d4e94f9621 = $6aaedba29cc20dcd$var$IsRestoringContext.Provider;

});

parcelRegister("lbVMT", function(module, exports) {

$parcel$export(module.exports, "ensureSuspenseTimers", function () { return $f6d7737bc485580b$export$274d2a1db5a20c09; });
$parcel$export(module.exports, "willFetch", function () { return $f6d7737bc485580b$export$e0a3f29513afe430; });
$parcel$export(module.exports, "shouldSuspend", function () { return $f6d7737bc485580b$export$88d3586dfed64df9; });
$parcel$export(module.exports, "fetchOptimistic", function () { return $f6d7737bc485580b$export$defdc11a9c9acfcf; });
// src/suspense.ts
var $f6d7737bc485580b$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $f6d7737bc485580b$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value !== null && value !== void 0 ? value : MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var $f6d7737bc485580b$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $f6d7737bc485580b$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions === null || defaultedOptions === void 0 ? void 0 : defaultedOptions.suspense) && result.isPending;
var $f6d7737bc485580b$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });

});



parcelRegister("dkNUW", function(module, exports) {

$parcel$export(module.exports, "request", function () { return $5cd8a8f64fc62141$export$b5fe3f66a567bec0; });
$parcel$export(module.exports, "requestBlob", function () { return $5cd8a8f64fc62141$export$c11d9d289995b930; });

var $dok7x = parcelRequire("dok7x");
parcelRequire("cul32");
var $j80Yy = parcelRequire("j80Yy");

var $iZUkI = parcelRequire("iZUkI");
const $5cd8a8f64fc62141$var$sendRequest = async (config = {})=>(0, $j80Yy.default)(config).then((req)=>req).catch((err)=>{
        return Promise.reject(err);
    });
const $5cd8a8f64fc62141$var$rawRequest = async (method, endpoint, params, contentType = 'application/json', data = {}, conf = {})=>{
    const BASEURL = `${"https://api.thsint.se"}:${"443"}`;
    const config = (0, $dok7x._)({}, conf);
    config.headers = {
        'Content-Type': contentType
    };
    if (localStorage[0, $iZUkI.TOKEN_KEY] != null) config.headers.Authorization = `Bearer ${localStorage[0, $iZUkI.TOKEN_KEY]}`;
    config.baseURL = BASEURL;
    config.method = method;
    config.url = endpoint;
    config.params = params;
    config.data = data;
    return $5cd8a8f64fc62141$var$sendRequest(config);
};
const $5cd8a8f64fc62141$export$b5fe3f66a567bec0 = async (method, endpoint, params, data, contentType = 'application/json')=>$5cd8a8f64fc62141$var$rawRequest(method, endpoint, params, contentType, data, {});
const $5cd8a8f64fc62141$export$c11d9d289995b930 = (method, endpoint, params, data, contentType = 'application/json')=>{
    const config = {};
    config.responseType = 'blob';
    return $5cd8a8f64fc62141$var$rawRequest(method, endpoint, params, contentType, data, config);
};

});
parcelRegister("cul32", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("j80Yy")).default; });

var $j80Yy = parcelRequire("j80Yy");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $91789d187b69cd5c$export$1c00760e9e5a4e95, AxiosError: $91789d187b69cd5c$export$c1fbed17c2f6a328, CanceledError: $91789d187b69cd5c$export$1ab0c6b20d94fa14, isCancel: $91789d187b69cd5c$export$3b22524397b493c6, CancelToken: $91789d187b69cd5c$export$fd08e3cb425f0d61, VERSION: $91789d187b69cd5c$export$a4ad2735b021c132, all: $91789d187b69cd5c$export$84bf76cd7afc7469, Cancel: $91789d187b69cd5c$export$848c9b7ead0df967, isAxiosError: $91789d187b69cd5c$export$fbafdbe06a5b5a9a, spread: $91789d187b69cd5c$export$3ae0fd4797ed47c8, toFormData: $91789d187b69cd5c$export$10ae0d317ea97f8b, AxiosHeaders: $91789d187b69cd5c$export$4e7d6ff0f3e6520, HttpStatusCode: $91789d187b69cd5c$export$a972f69c851492b3, formToJSON: $91789d187b69cd5c$export$86d7c59254d6a2c9, getAdapter: $91789d187b69cd5c$export$17ddc20a97d669e2, mergeConfig: $91789d187b69cd5c$export$7ec1ebcfa9d8bd6a, create: $91789d187b69cd5c$export$185802fd694ee1f5 } = (0, $j80Yy.default);

});
parcelRegister("j80Yy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $decf856a524d7c7a$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");

var $lh0Nu = parcelRequire("lh0Nu");

var $8TLpp = parcelRequire("8TLpp");

var $1mi1M = parcelRequire("1mi1M");

var $gpsIs = parcelRequire("gpsIs");

var $1nXIl = parcelRequire("1nXIl");

var $jjxjT = parcelRequire("jjxjT");

var $amPM5 = parcelRequire("amPM5");

var $6Q15H = parcelRequire("6Q15H");

var $iYpZK = parcelRequire("iYpZK");

var $7DgGh = parcelRequire("7DgGh");

var $4on8X = parcelRequire("4on8X");

var $1lbUl = parcelRequire("1lbUl");

var $k4WyF = parcelRequire("k4WyF");

var $iFS1V = parcelRequire("iFS1V");

var $4avOL = parcelRequire("4avOL");

var $iZVkB = parcelRequire("iZVkB");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $decf856a524d7c7a$var$createInstance(defaultConfig) {
    const context = new (0, $8TLpp.default)(defaultConfig);
    const instance = (0, $lh0Nu.default)((0, $8TLpp.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $iLX88.default).extend(instance, (0, $8TLpp.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $iLX88.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $decf856a524d7c7a$var$createInstance((0, $1mi1M.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $decf856a524d7c7a$var$axios = $decf856a524d7c7a$var$createInstance((0, $gpsIs.default));
// Expose Axios class to allow class inheritance
$decf856a524d7c7a$var$axios.Axios = (0, $8TLpp.default);
// Expose Cancel & CancelToken
$decf856a524d7c7a$var$axios.CanceledError = (0, $jjxjT.default);
$decf856a524d7c7a$var$axios.CancelToken = (0, $amPM5.default);
$decf856a524d7c7a$var$axios.isCancel = (0, $6Q15H.default);
$decf856a524d7c7a$var$axios.VERSION = (0, $iYpZK.VERSION);
$decf856a524d7c7a$var$axios.toFormData = (0, $7DgGh.default);
// Expose AxiosError class
$decf856a524d7c7a$var$axios.AxiosError = (0, $4on8X.default);
// alias for CanceledError for backward compatibility
$decf856a524d7c7a$var$axios.Cancel = $decf856a524d7c7a$var$axios.CanceledError;
// Expose all/spread
$decf856a524d7c7a$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$decf856a524d7c7a$var$axios.spread = (0, $1lbUl.default);
// Expose isAxiosError
$decf856a524d7c7a$var$axios.isAxiosError = (0, $k4WyF.default);
// Expose mergeConfig
$decf856a524d7c7a$var$axios.mergeConfig = (0, $1mi1M.default);
$decf856a524d7c7a$var$axios.AxiosHeaders = (0, $iFS1V.default);
$decf856a524d7c7a$var$axios.formToJSON = (thing)=>(0, $1nXIl.default)((0, $iLX88.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$decf856a524d7c7a$var$axios.getAdapter = (0, $4avOL.default).getAdapter;
$decf856a524d7c7a$var$axios.HttpStatusCode = (0, $iZVkB.default);
$decf856a524d7c7a$var$axios.default = $decf856a524d7c7a$var$axios;
var // this module should only have a default export
$decf856a524d7c7a$export$2e2bcd8739ae039 = $decf856a524d7c7a$var$axios;

});
parcelRegister("iLX88", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $daaa7bd02b683e86$export$2e2bcd8739ae039; });

var $lh0Nu = parcelRequire("lh0Nu");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $daaa7bd02b683e86$var$toString } = Object.prototype;
const { getPrototypeOf: $daaa7bd02b683e86$var$getPrototypeOf } = Object;
const { iterator: $daaa7bd02b683e86$var$iterator, toStringTag: $daaa7bd02b683e86$var$toStringTag } = Symbol;
const $daaa7bd02b683e86$var$kindOf = ((cache)=>(thing)=>{
        const str = $daaa7bd02b683e86$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $daaa7bd02b683e86$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$daaa7bd02b683e86$var$kindOf(thing) === type;
};
const $daaa7bd02b683e86$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $daaa7bd02b683e86$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $daaa7bd02b683e86$var$isUndefined = $daaa7bd02b683e86$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $daaa7bd02b683e86$var$isBuffer(val) {
    return val !== null && !$daaa7bd02b683e86$var$isUndefined(val) && val.constructor !== null && !$daaa7bd02b683e86$var$isUndefined(val.constructor) && $daaa7bd02b683e86$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $daaa7bd02b683e86$var$isArrayBuffer = $daaa7bd02b683e86$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $daaa7bd02b683e86$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $daaa7bd02b683e86$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $daaa7bd02b683e86$var$isString = $daaa7bd02b683e86$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $daaa7bd02b683e86$var$isFunction = $daaa7bd02b683e86$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $daaa7bd02b683e86$var$isNumber = $daaa7bd02b683e86$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $daaa7bd02b683e86$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $daaa7bd02b683e86$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $daaa7bd02b683e86$var$isPlainObject = (val)=>{
    if ($daaa7bd02b683e86$var$kindOf(val) !== 'object') return false;
    const prototype = $daaa7bd02b683e86$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($daaa7bd02b683e86$var$toStringTag in val) && !($daaa7bd02b683e86$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $daaa7bd02b683e86$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$daaa7bd02b683e86$var$isObject(val) || $daaa7bd02b683e86$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $daaa7bd02b683e86$var$isDate = $daaa7bd02b683e86$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $daaa7bd02b683e86$var$isFile = $daaa7bd02b683e86$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $daaa7bd02b683e86$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $daaa7bd02b683e86$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $daaa7bd02b683e86$var$isBlob = $daaa7bd02b683e86$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $daaa7bd02b683e86$var$isFileList = $daaa7bd02b683e86$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $daaa7bd02b683e86$var$isStream = (val)=>$daaa7bd02b683e86$var$isObject(val) && $daaa7bd02b683e86$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $daaa7bd02b683e86$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $daaa7bd02b683e86$var$G = $daaa7bd02b683e86$var$getGlobal();
const $daaa7bd02b683e86$var$FormDataCtor = typeof $daaa7bd02b683e86$var$G.FormData !== 'undefined' ? $daaa7bd02b683e86$var$G.FormData : undefined;
const $daaa7bd02b683e86$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($daaa7bd02b683e86$var$FormDataCtor && thing instanceof $daaa7bd02b683e86$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $daaa7bd02b683e86$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$daaa7bd02b683e86$var$isFunction(thing.append)) return false;
    const kind = $daaa7bd02b683e86$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $daaa7bd02b683e86$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $daaa7bd02b683e86$var$isURLSearchParams = $daaa7bd02b683e86$var$kindOfTest('URLSearchParams');
const [$daaa7bd02b683e86$var$isReadableStream, $daaa7bd02b683e86$var$isRequest, $daaa7bd02b683e86$var$isResponse, $daaa7bd02b683e86$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($daaa7bd02b683e86$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $daaa7bd02b683e86$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $daaa7bd02b683e86$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($daaa7bd02b683e86$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($daaa7bd02b683e86$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $daaa7bd02b683e86$var$findKey(obj, key) {
    if ($daaa7bd02b683e86$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $daaa7bd02b683e86$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $daaa7bd02b683e86$var$isContextDefined = (context)=>!$daaa7bd02b683e86$var$isUndefined(context) && context !== $daaa7bd02b683e86$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $daaa7bd02b683e86$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $daaa7bd02b683e86$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $daaa7bd02b683e86$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $daaa7bd02b683e86$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($daaa7bd02b683e86$var$isPlainObject(existing) && $daaa7bd02b683e86$var$isPlainObject(val)) result[targetKey] = $daaa7bd02b683e86$var$merge(existing, val);
        else if ($daaa7bd02b683e86$var$isPlainObject(val)) result[targetKey] = $daaa7bd02b683e86$var$merge({}, val);
        else if ($daaa7bd02b683e86$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$daaa7bd02b683e86$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $daaa7bd02b683e86$var$isBuffer(source)) continue;
        $daaa7bd02b683e86$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $daaa7bd02b683e86$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($daaa7bd02b683e86$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $daaa7bd02b683e86$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $daaa7bd02b683e86$var$forEach(b, (val, key)=>{
        if (thisArg && $daaa7bd02b683e86$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $lh0Nu.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $daaa7bd02b683e86$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $daaa7bd02b683e86$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $daaa7bd02b683e86$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $daaa7bd02b683e86$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $daaa7bd02b683e86$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $daaa7bd02b683e86$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($daaa7bd02b683e86$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$daaa7bd02b683e86$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $daaa7bd02b683e86$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $daaa7bd02b683e86$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $daaa7bd02b683e86$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$daaa7bd02b683e86$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $daaa7bd02b683e86$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $daaa7bd02b683e86$var$isHTMLForm = $daaa7bd02b683e86$var$kindOfTest('HTMLFormElement');
const $daaa7bd02b683e86$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $daaa7bd02b683e86$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const { propertyIsEnumerable: $daaa7bd02b683e86$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $daaa7bd02b683e86$var$isRegExp = $daaa7bd02b683e86$var$kindOfTest('RegExp');
const $daaa7bd02b683e86$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $daaa7bd02b683e86$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $daaa7bd02b683e86$var$freezeMethods = (obj)=>{
    $daaa7bd02b683e86$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($daaa7bd02b683e86$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$daaa7bd02b683e86$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $daaa7bd02b683e86$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $daaa7bd02b683e86$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $daaa7bd02b683e86$var$noop = ()=>{};
const $daaa7bd02b683e86$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $daaa7bd02b683e86$var$isSpecCompliantForm(thing) {
    return !!(thing && $daaa7bd02b683e86$var$isFunction(thing.append) && thing[$daaa7bd02b683e86$var$toStringTag] === 'FormData' && thing[$daaa7bd02b683e86$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $daaa7bd02b683e86$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($daaa7bd02b683e86$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($daaa7bd02b683e86$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $daaa7bd02b683e86$var$isArray(source) ? [] : {};
                $daaa7bd02b683e86$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$daaa7bd02b683e86$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $daaa7bd02b683e86$var$isAsyncFn = $daaa7bd02b683e86$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $daaa7bd02b683e86$var$isThenable = (thing)=>thing && ($daaa7bd02b683e86$var$isObject(thing) || $daaa7bd02b683e86$var$isFunction(thing)) && $daaa7bd02b683e86$var$isFunction(thing.then) && $daaa7bd02b683e86$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $daaa7bd02b683e86$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $daaa7bd02b683e86$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $daaa7bd02b683e86$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $daaa7bd02b683e86$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $daaa7bd02b683e86$var$isFunction($daaa7bd02b683e86$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $daaa7bd02b683e86$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($daaa7bd02b683e86$var$_global) : $daaa7bd02b683e86$var$_setImmediate;
// *********************
const $daaa7bd02b683e86$var$isIterable = (thing)=>thing != null && $daaa7bd02b683e86$var$isFunction(thing[$daaa7bd02b683e86$var$iterator]);
var $daaa7bd02b683e86$export$2e2bcd8739ae039 = {
    isArray: $daaa7bd02b683e86$var$isArray,
    isArrayBuffer: $daaa7bd02b683e86$var$isArrayBuffer,
    isBuffer: $daaa7bd02b683e86$var$isBuffer,
    isFormData: $daaa7bd02b683e86$var$isFormData,
    isArrayBufferView: $daaa7bd02b683e86$var$isArrayBufferView,
    isString: $daaa7bd02b683e86$var$isString,
    isNumber: $daaa7bd02b683e86$var$isNumber,
    isBoolean: $daaa7bd02b683e86$var$isBoolean,
    isObject: $daaa7bd02b683e86$var$isObject,
    isPlainObject: $daaa7bd02b683e86$var$isPlainObject,
    isEmptyObject: $daaa7bd02b683e86$var$isEmptyObject,
    isReadableStream: $daaa7bd02b683e86$var$isReadableStream,
    isRequest: $daaa7bd02b683e86$var$isRequest,
    isResponse: $daaa7bd02b683e86$var$isResponse,
    isHeaders: $daaa7bd02b683e86$var$isHeaders,
    isUndefined: $daaa7bd02b683e86$var$isUndefined,
    isDate: $daaa7bd02b683e86$var$isDate,
    isFile: $daaa7bd02b683e86$var$isFile,
    isReactNativeBlob: $daaa7bd02b683e86$var$isReactNativeBlob,
    isReactNative: $daaa7bd02b683e86$var$isReactNative,
    isBlob: $daaa7bd02b683e86$var$isBlob,
    isRegExp: $daaa7bd02b683e86$var$isRegExp,
    isFunction: $daaa7bd02b683e86$var$isFunction,
    isStream: $daaa7bd02b683e86$var$isStream,
    isURLSearchParams: $daaa7bd02b683e86$var$isURLSearchParams,
    isTypedArray: $daaa7bd02b683e86$var$isTypedArray,
    isFileList: $daaa7bd02b683e86$var$isFileList,
    forEach: $daaa7bd02b683e86$var$forEach,
    merge: $daaa7bd02b683e86$var$merge,
    extend: $daaa7bd02b683e86$var$extend,
    trim: $daaa7bd02b683e86$var$trim,
    stripBOM: $daaa7bd02b683e86$var$stripBOM,
    inherits: $daaa7bd02b683e86$var$inherits,
    toFlatObject: $daaa7bd02b683e86$var$toFlatObject,
    kindOf: $daaa7bd02b683e86$var$kindOf,
    kindOfTest: $daaa7bd02b683e86$var$kindOfTest,
    endsWith: $daaa7bd02b683e86$var$endsWith,
    toArray: $daaa7bd02b683e86$var$toArray,
    forEachEntry: $daaa7bd02b683e86$var$forEachEntry,
    matchAll: $daaa7bd02b683e86$var$matchAll,
    isHTMLForm: $daaa7bd02b683e86$var$isHTMLForm,
    hasOwnProperty: $daaa7bd02b683e86$var$hasOwnProperty,
    hasOwnProp: $daaa7bd02b683e86$var$hasOwnProperty,
    reduceDescriptors: $daaa7bd02b683e86$var$reduceDescriptors,
    freezeMethods: $daaa7bd02b683e86$var$freezeMethods,
    toObjectSet: $daaa7bd02b683e86$var$toObjectSet,
    toCamelCase: $daaa7bd02b683e86$var$toCamelCase,
    noop: $daaa7bd02b683e86$var$noop,
    toFiniteNumber: $daaa7bd02b683e86$var$toFiniteNumber,
    findKey: $daaa7bd02b683e86$var$findKey,
    global: $daaa7bd02b683e86$var$_global,
    isContextDefined: $daaa7bd02b683e86$var$isContextDefined,
    isSpecCompliantForm: $daaa7bd02b683e86$var$isSpecCompliantForm,
    toJSONObject: $daaa7bd02b683e86$var$toJSONObject,
    isAsyncFn: $daaa7bd02b683e86$var$isAsyncFn,
    isThenable: $daaa7bd02b683e86$var$isThenable,
    setImmediate: $daaa7bd02b683e86$var$_setImmediate,
    asap: $daaa7bd02b683e86$var$asap,
    isIterable: $daaa7bd02b683e86$var$isIterable
};

});
parcelRegister("lh0Nu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7cbcdcb0b5aa1e4$export$2e2bcd8739ae039; });
'use strict';
function $f7cbcdcb0b5aa1e4$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("8TLpp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a83c2b1f857f0d$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");

var $8qdqj = parcelRequire("8qdqj");

var $5AkGi = parcelRequire("5AkGi");

var $7UqiZ = parcelRequire("7UqiZ");

var $1mi1M = parcelRequire("1mi1M");

var $4oDOM = parcelRequire("4oDOM");

var $fkgBZ = parcelRequire("fkgBZ");

var $iFS1V = parcelRequire("iFS1V");

var $ajGAB = parcelRequire("ajGAB");
'use strict';
const $67a83c2b1f857f0d$var$validators = (0, $fkgBZ.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $67a83c2b1f857f0d$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $1mi1M.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $fkgBZ.default).assertOptions(transitional, {
            silentJSONParsing: $67a83c2b1f857f0d$var$validators.transitional($67a83c2b1f857f0d$var$validators.boolean),
            forcedJSONParsing: $67a83c2b1f857f0d$var$validators.transitional($67a83c2b1f857f0d$var$validators.boolean),
            clarifyTimeoutError: $67a83c2b1f857f0d$var$validators.transitional($67a83c2b1f857f0d$var$validators.boolean),
            legacyInterceptorReqResOrdering: $67a83c2b1f857f0d$var$validators.transitional($67a83c2b1f857f0d$var$validators.boolean),
            advertiseZstdAcceptEncoding: $67a83c2b1f857f0d$var$validators.transitional($67a83c2b1f857f0d$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $iLX88.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $fkgBZ.default).assertOptions(paramsSerializer, {
                encode: $67a83c2b1f857f0d$var$validators.function,
                serialize: $67a83c2b1f857f0d$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $fkgBZ.default).assertOptions(config, {
            baseUrl: $67a83c2b1f857f0d$var$validators.spelling('baseURL'),
            withXsrfToken: $67a83c2b1f857f0d$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $iLX88.default).merge(headers.common, headers[config.method]);
        headers && (0, $iLX88.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $iFS1V.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $ajGAB.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $7UqiZ.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $7UqiZ.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $1mi1M.default)(this.defaults, config);
        const fullPath = (0, $4oDOM.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $8qdqj.default)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5AkGi.default)(),
            response: new (0, $5AkGi.default)()
        };
    }
}
// Provide aliases for supported request methods
(0, $iLX88.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $67a83c2b1f857f0d$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $1mi1M.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $iLX88.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $1mi1M.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $67a83c2b1f857f0d$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $67a83c2b1f857f0d$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $67a83c2b1f857f0d$export$2e2bcd8739ae039 = $67a83c2b1f857f0d$var$Axios;

});
parcelRegister("8qdqj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $621b2a10c65488a1$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");

var $gGNy7 = parcelRequire("gGNy7");
'use strict';
function $621b2a10c65488a1$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $621b2a10c65488a1$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $621b2a10c65488a1$export$c564cdbbe6da493;
    const _options = (0, $iLX88.default).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $iLX88.default).isURLSearchParams(params) ? params.toString() : new (0, $gGNy7.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("gGNy7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2670109c0ceb25a$export$2e2bcd8739ae039; });

var $7DgGh = parcelRequire("7DgGh");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $c2670109c0ceb25a$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $c2670109c0ceb25a$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $7DgGh.default)(params, this, options);
}
const $c2670109c0ceb25a$var$prototype = $c2670109c0ceb25a$var$AxiosURLSearchParams.prototype;
$c2670109c0ceb25a$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$c2670109c0ceb25a$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $c2670109c0ceb25a$var$encode);
    } : $c2670109c0ceb25a$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $c2670109c0ceb25a$export$2e2bcd8739ae039 = $c2670109c0ceb25a$var$AxiosURLSearchParams;

});
parcelRegister("7DgGh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58e91d62e6454d02$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");

var $4on8X = parcelRequire("4on8X");

var $kYzyS = parcelRequire("kYzyS");

var $eipj2 = parcelRequire("eipj2");
var $58e91d62e6454d02$require$Buffer = $eipj2.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $58e91d62e6454d02$var$isVisitable(thing) {
    return (0, $iLX88.default).isPlainObject(thing) || (0, $iLX88.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $58e91d62e6454d02$var$removeBrackets(key) {
    return (0, $iLX88.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $58e91d62e6454d02$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $58e91d62e6454d02$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $58e91d62e6454d02$var$isFlatArray(arr) {
    return (0, $iLX88.default).isArray(arr) && !arr.some($58e91d62e6454d02$var$isVisitable);
}
const $58e91d62e6454d02$var$predicates = (0, $iLX88.default).toFlatObject((0, $iLX88.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $58e91d62e6454d02$var$toFormData(obj, formData, options) {
    if (!(0, $iLX88.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $kYzyS.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $iLX88.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $iLX88.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    const useBlob = _Blob && (0, $iLX88.default).isSpecCompliantForm(formData);
    if (!(0, $iLX88.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $iLX88.default).isDate(value)) return value.toISOString();
        if ((0, $iLX88.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $iLX88.default).isBlob(value)) throw new (0, $4on8X.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $iLX88.default).isArrayBuffer(value) || (0, $iLX88.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $58e91d62e6454d02$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $iLX88.default).isReactNative(formData) && (0, $iLX88.default).isReactNativeBlob(value)) {
            formData.append($58e91d62e6454d02$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $iLX88.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $iLX88.default).isArray(value) && $58e91d62e6454d02$var$isFlatArray(value) || ((0, $iLX88.default).isFileList(value) || (0, $iLX88.default).endsWith(key, '[]')) && (arr = (0, $iLX88.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $58e91d62e6454d02$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $iLX88.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $58e91d62e6454d02$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($58e91d62e6454d02$var$isVisitable(value)) return true;
        formData.append($58e91d62e6454d02$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($58e91d62e6454d02$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $58e91d62e6454d02$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $iLX88.default).isUndefined(value)) return;
        if (depth > maxDepth) throw new (0, $4on8X.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $4on8X.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $iLX88.default).forEach(value, function each(el, key) {
            const result = !((0, $iLX88.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $iLX88.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $iLX88.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $58e91d62e6454d02$export$2e2bcd8739ae039 = $58e91d62e6454d02$var$toFormData;

});
parcelRegister("4on8X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $332b5b1ac0b016cd$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");

var $iFS1V = parcelRequire("iFS1V");
'use strict';
const $332b5b1ac0b016cd$var$REDACTED = '[REDACTED ****]';
function $332b5b1ac0b016cd$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $iLX88.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $iLX88.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $332b5b1ac0b016cd$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $iLX88.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $iFS1V.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $iLX88.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $iLX88.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $iLX88.default).isPlainObject(source) && $332b5b1ac0b016cd$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $332b5b1ac0b016cd$var$REDACTED : visit(value);
                if (!(0, $iLX88.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $332b5b1ac0b016cd$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $332b5b1ac0b016cd$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $iLX88.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $iLX88.default).isArray(redactKeys) && redactKeys.length > 0 ? $332b5b1ac0b016cd$var$redactConfig(config, redactKeys) : (0, $iLX88.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$332b5b1ac0b016cd$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$332b5b1ac0b016cd$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$332b5b1ac0b016cd$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$332b5b1ac0b016cd$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$332b5b1ac0b016cd$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$332b5b1ac0b016cd$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$332b5b1ac0b016cd$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$332b5b1ac0b016cd$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$332b5b1ac0b016cd$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$332b5b1ac0b016cd$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$332b5b1ac0b016cd$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$332b5b1ac0b016cd$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$332b5b1ac0b016cd$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$332b5b1ac0b016cd$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $332b5b1ac0b016cd$export$2e2bcd8739ae039 = $332b5b1ac0b016cd$var$AxiosError;

});
parcelRegister("iFS1V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d985f78f2c8250c6$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");

var $bnAEo = parcelRequire("bnAEo");

var $65R0u = parcelRequire("65R0u");
'use strict';
const $d985f78f2c8250c6$var$$internals = Symbol('internals');
function $d985f78f2c8250c6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $d985f78f2c8250c6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $iLX88.default).isArray(value) ? value.map($d985f78f2c8250c6$var$normalizeValue) : (0, $65R0u.sanitizeHeaderValue)(String(value));
}
function $d985f78f2c8250c6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $d985f78f2c8250c6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $d985f78f2c8250c6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $iLX88.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $iLX88.default).isString(value)) return;
    if ((0, $iLX88.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $iLX88.default).isRegExp(filter)) return filter.test(value);
}
function $d985f78f2c8250c6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $d985f78f2c8250c6$var$buildAccessors(obj, header) {
    const accessorName = (0, $iLX88.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $d985f78f2c8250c6$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $d985f78f2c8250c6$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $iLX88.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $d985f78f2c8250c6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $iLX88.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $iLX88.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $iLX88.default).isString(header) && (header = header.trim()) && !$d985f78f2c8250c6$var$isValidHeaderName(header)) setHeaders((0, $bnAEo.default)(header), valueOrRewrite);
        else if ((0, $iLX88.default).isObject(header) && (0, $iLX88.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $iLX88.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $iLX88.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $d985f78f2c8250c6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $iLX88.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $d985f78f2c8250c6$var$parseTokens(value);
                if ((0, $iLX88.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $iLX88.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $d985f78f2c8250c6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $iLX88.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $d985f78f2c8250c6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $d985f78f2c8250c6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $iLX88.default).findKey(self, _header);
                if (key && (!matcher || $d985f78f2c8250c6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $iLX88.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $d985f78f2c8250c6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $iLX88.default).forEach(this, (value, header)=>{
            const key = (0, $iLX88.default).findKey(headers, header);
            if (key) {
                self[key] = $d985f78f2c8250c6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $d985f78f2c8250c6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $d985f78f2c8250c6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $iLX88.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $iLX88.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$d985f78f2c8250c6$var$$internals] = this[$d985f78f2c8250c6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $d985f78f2c8250c6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $d985f78f2c8250c6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $iLX88.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$d985f78f2c8250c6$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $iLX88.default).reduceDescriptors($d985f78f2c8250c6$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $iLX88.default).freezeMethods($d985f78f2c8250c6$var$AxiosHeaders);
var $d985f78f2c8250c6$export$2e2bcd8739ae039 = $d985f78f2c8250c6$var$AxiosHeaders;

});
parcelRegister("bnAEo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $848e45bcc71a4669$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $848e45bcc71a4669$var$ignoreDuplicateOf = (0, $iLX88.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $848e45bcc71a4669$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $848e45bcc71a4669$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});

parcelRegister("65R0u", function(module, exports) {

$parcel$export(module.exports, "sanitizeHeaderValue", function () { return $46fc53c063f3d440$export$9e344cffce061a22; });
$parcel$export(module.exports, "toByteStringHeaderObject", function () { return $46fc53c063f3d440$export$c30c72bb7e677d54; });

var $iLX88 = parcelRequire("iLX88");
'use strict';
function $46fc53c063f3d440$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $46fc53c063f3d440$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $46fc53c063f3d440$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $46fc53c063f3d440$var$sanitizeValue(value, invalidChars) {
    if ((0, $iLX88.default).isArray(value)) return value.map((item)=>$46fc53c063f3d440$var$sanitizeValue(item, invalidChars));
    return $46fc53c063f3d440$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $46fc53c063f3d440$export$9e344cffce061a22 = (value)=>$46fc53c063f3d440$var$sanitizeValue(value, $46fc53c063f3d440$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $46fc53c063f3d440$export$59dd66c2a12d8f62 = (value)=>$46fc53c063f3d440$var$sanitizeValue(value, $46fc53c063f3d440$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $46fc53c063f3d440$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $iLX88.default).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $46fc53c063f3d440$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}

});



parcelRegister("kYzyS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f454ff04aed70282$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $f454ff04aed70282$export$2e2bcd8739ae039 = null;

});

parcelRegister("eipj2", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $a686606878691758$export$a143d493d941bafc; }, function (v) { return $a686606878691758$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $a686606878691758$export$f99ded8fe4b79145; }, function (v) { return $a686606878691758$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $a686606878691758$export$a143d493d941bafc;
var $a686606878691758$export$e4cf37d7f6fb9e0a;
var $a686606878691758$export$f99ded8fe4b79145;
var $a686606878691758$export$599f31c3813fae4d;
'use strict';

var $hItut = parcelRequire("hItut");

var $8GPgS = parcelRequire("8GPgS");
const $a686606878691758$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$a686606878691758$export$a143d493d941bafc = $a686606878691758$var$Buffer;
$a686606878691758$export$e4cf37d7f6fb9e0a = $a686606878691758$var$SlowBuffer;
$a686606878691758$export$f99ded8fe4b79145 = 50;
const $a686606878691758$var$K_MAX_LENGTH = 0x7fffffff;
$a686606878691758$export$599f31c3813fae4d = $a686606878691758$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a686606878691758$var$Buffer.TYPED_ARRAY_SUPPORT = $a686606878691758$var$typedArraySupport();
if (!$a686606878691758$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a686606878691758$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a686606878691758$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$a686606878691758$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a686606878691758$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$a686606878691758$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a686606878691758$var$createBuffer(length) {
    if (length > $a686606878691758$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a686606878691758$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a686606878691758$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a686606878691758$var$allocUnsafe(arg);
    }
    return $a686606878691758$var$from(arg, encodingOrOffset, length);
}
$a686606878691758$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a686606878691758$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $a686606878691758$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a686606878691758$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($a686606878691758$var$isInstance(value, ArrayBuffer) || value && $a686606878691758$var$isInstance(value.buffer, ArrayBuffer)) return $a686606878691758$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($a686606878691758$var$isInstance(value, SharedArrayBuffer) || value && $a686606878691758$var$isInstance(value.buffer, SharedArrayBuffer))) return $a686606878691758$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a686606878691758$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $a686606878691758$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $a686606878691758$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a686606878691758$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a686606878691758$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a686606878691758$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a686606878691758$var$Buffer, Uint8Array);
function $a686606878691758$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a686606878691758$var$alloc(size, fill, encoding) {
    $a686606878691758$var$assertSize(size);
    if (size <= 0) return $a686606878691758$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $a686606878691758$var$createBuffer(size).fill(fill, encoding) : $a686606878691758$var$createBuffer(size).fill(fill);
    return $a686606878691758$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a686606878691758$var$Buffer.alloc = function(size, fill, encoding) {
    return $a686606878691758$var$alloc(size, fill, encoding);
};
function $a686606878691758$var$allocUnsafe(size) {
    $a686606878691758$var$assertSize(size);
    return $a686606878691758$var$createBuffer(size < 0 ? 0 : $a686606878691758$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a686606878691758$var$Buffer.allocUnsafe = function(size) {
    return $a686606878691758$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a686606878691758$var$Buffer.allocUnsafeSlow = function(size) {
    return $a686606878691758$var$allocUnsafe(size);
};
function $a686606878691758$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$a686606878691758$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $a686606878691758$var$byteLength(string, encoding) | 0;
    let buf = $a686606878691758$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a686606878691758$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $a686606878691758$var$checked(array.length) | 0;
    const buf = $a686606878691758$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a686606878691758$var$fromArrayView(arrayView) {
    if ($a686606878691758$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $a686606878691758$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a686606878691758$var$fromArrayLike(arrayView);
}
function $a686606878691758$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a686606878691758$var$Buffer.prototype);
    return buf;
}
function $a686606878691758$var$fromObject(obj) {
    if ($a686606878691758$var$Buffer.isBuffer(obj)) {
        const len = $a686606878691758$var$checked(obj.length) | 0;
        const buf = $a686606878691758$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $a686606878691758$var$numberIsNaN(obj.length)) return $a686606878691758$var$createBuffer(0);
        return $a686606878691758$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $a686606878691758$var$fromArrayLike(obj.data);
}
function $a686606878691758$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a686606878691758$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a686606878691758$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $a686606878691758$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a686606878691758$var$Buffer.alloc(+length);
}
$a686606878691758$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a686606878691758$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a686606878691758$var$Buffer.compare = function compare(a, b) {
    if ($a686606878691758$var$isInstance(a, Uint8Array)) a = $a686606878691758$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a686606878691758$var$isInstance(b, Uint8Array)) b = $a686606878691758$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a686606878691758$var$Buffer.isBuffer(a) || !$a686606878691758$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a686606878691758$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$a686606878691758$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a686606878691758$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $a686606878691758$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($a686606878691758$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$a686606878691758$var$Buffer.isBuffer(buf)) buf = $a686606878691758$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a686606878691758$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a686606878691758$var$byteLength(string, encoding) {
    if ($a686606878691758$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a686606878691758$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $a686606878691758$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $a686606878691758$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a686606878691758$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a686606878691758$var$Buffer.byteLength = $a686606878691758$var$byteLength;
function $a686606878691758$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $a686606878691758$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $a686606878691758$var$utf8Slice(this, start, end);
        case 'ascii':
            return $a686606878691758$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $a686606878691758$var$latin1Slice(this, start, end);
        case 'base64':
            return $a686606878691758$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a686606878691758$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a686606878691758$var$Buffer.prototype._isBuffer = true;
function $a686606878691758$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a686606878691758$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$a686606878691758$var$swap(this, i, i + 1);
    return this;
};
$a686606878691758$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $a686606878691758$var$swap(this, i, i + 3);
        $a686606878691758$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a686606878691758$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $a686606878691758$var$swap(this, i, i + 7);
        $a686606878691758$var$swap(this, i + 1, i + 6);
        $a686606878691758$var$swap(this, i + 2, i + 5);
        $a686606878691758$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a686606878691758$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $a686606878691758$var$utf8Slice(this, 0, length);
    return $a686606878691758$var$slowToString.apply(this, arguments);
};
$a686606878691758$var$Buffer.prototype.toLocaleString = $a686606878691758$var$Buffer.prototype.toString;
$a686606878691758$var$Buffer.prototype.equals = function equals(b) {
    if (!$a686606878691758$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $a686606878691758$var$Buffer.compare(this, b) === 0;
};
$a686606878691758$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $a686606878691758$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($a686606878691758$var$customInspectSymbol) $a686606878691758$var$Buffer.prototype[$a686606878691758$var$customInspectSymbol] = $a686606878691758$var$Buffer.prototype.inspect;
$a686606878691758$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a686606878691758$var$isInstance(target, Uint8Array)) target = $a686606878691758$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a686606878691758$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a686606878691758$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a686606878691758$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $a686606878691758$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a686606878691758$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a686606878691758$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a686606878691758$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $a686606878691758$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a686606878691758$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a686606878691758$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a686606878691758$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a686606878691758$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a686606878691758$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a686606878691758$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a686606878691758$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a686606878691758$var$utf8Write(buf, string, offset, length) {
    return $a686606878691758$var$blitBuffer($a686606878691758$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a686606878691758$var$asciiWrite(buf, string, offset, length) {
    return $a686606878691758$var$blitBuffer($a686606878691758$var$asciiToBytes(string), buf, offset, length);
}
function $a686606878691758$var$base64Write(buf, string, offset, length) {
    return $a686606878691758$var$blitBuffer($a686606878691758$var$base64ToBytes(string), buf, offset, length);
}
function $a686606878691758$var$ucs2Write(buf, string, offset, length) {
    return $a686606878691758$var$blitBuffer($a686606878691758$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a686606878691758$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $a686606878691758$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $a686606878691758$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $a686606878691758$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $a686606878691758$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a686606878691758$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a686606878691758$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a686606878691758$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hItut.fromByteArray(buf);
    else return $hItut.fromByteArray(buf.slice(start, end));
}
function $a686606878691758$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a686606878691758$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $a686606878691758$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a686606878691758$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $a686606878691758$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a686606878691758$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a686606878691758$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a686606878691758$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a686606878691758$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $a686606878691758$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a686606878691758$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a686606878691758$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a686606878691758$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a686606878691758$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$a686606878691758$var$Buffer.prototype.readUintLE = $a686606878691758$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a686606878691758$var$Buffer.prototype.readUintBE = $a686606878691758$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a686606878691758$var$Buffer.prototype.readUint8 = $a686606878691758$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a686606878691758$var$Buffer.prototype.readUint16LE = $a686606878691758$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a686606878691758$var$Buffer.prototype.readUint16BE = $a686606878691758$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a686606878691758$var$Buffer.prototype.readUint32LE = $a686606878691758$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a686606878691758$var$Buffer.prototype.readUint32BE = $a686606878691758$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a686606878691758$var$Buffer.prototype.readBigUInt64LE = $a686606878691758$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $a686606878691758$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a686606878691758$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$a686606878691758$var$Buffer.prototype.readBigUInt64BE = $a686606878691758$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $a686606878691758$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a686606878691758$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$a686606878691758$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a686606878691758$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a686606878691758$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a686606878691758$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a686606878691758$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a686606878691758$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a686606878691758$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a686606878691758$var$Buffer.prototype.readBigInt64LE = $a686606878691758$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $a686606878691758$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a686606878691758$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$a686606878691758$var$Buffer.prototype.readBigInt64BE = $a686606878691758$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $a686606878691758$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a686606878691758$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$a686606878691758$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 4, this.length);
    return $8GPgS.read(this, offset, true, 23, 4);
};
$a686606878691758$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 4, this.length);
    return $8GPgS.read(this, offset, false, 23, 4);
};
$a686606878691758$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 8, this.length);
    return $8GPgS.read(this, offset, true, 52, 8);
};
$a686606878691758$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkOffset(offset, 8, this.length);
    return $8GPgS.read(this, offset, false, 52, 8);
};
function $a686606878691758$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a686606878691758$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$a686606878691758$var$Buffer.prototype.writeUintLE = $a686606878691758$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a686606878691758$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a686606878691758$var$Buffer.prototype.writeUintBE = $a686606878691758$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a686606878691758$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a686606878691758$var$Buffer.prototype.writeUint8 = $a686606878691758$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a686606878691758$var$Buffer.prototype.writeUint16LE = $a686606878691758$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a686606878691758$var$Buffer.prototype.writeUint16BE = $a686606878691758$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a686606878691758$var$Buffer.prototype.writeUint32LE = $a686606878691758$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a686606878691758$var$Buffer.prototype.writeUint32BE = $a686606878691758$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a686606878691758$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $a686606878691758$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $a686606878691758$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $a686606878691758$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$a686606878691758$var$Buffer.prototype.writeBigUInt64LE = $a686606878691758$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $a686606878691758$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$a686606878691758$var$Buffer.prototype.writeBigUInt64BE = $a686606878691758$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $a686606878691758$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$a686606878691758$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a686606878691758$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a686606878691758$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a686606878691758$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a686606878691758$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a686606878691758$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a686606878691758$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a686606878691758$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a686606878691758$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a686606878691758$var$Buffer.prototype.writeBigInt64LE = $a686606878691758$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $a686606878691758$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$a686606878691758$var$Buffer.prototype.writeBigInt64BE = $a686606878691758$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $a686606878691758$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $a686606878691758$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $a686606878691758$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8GPgS.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a686606878691758$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a686606878691758$var$writeFloat(this, value, offset, true, noAssert);
};
$a686606878691758$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a686606878691758$var$writeFloat(this, value, offset, false, noAssert);
};
function $a686606878691758$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a686606878691758$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8GPgS.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a686606878691758$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a686606878691758$var$writeDouble(this, value, offset, true, noAssert);
};
$a686606878691758$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a686606878691758$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a686606878691758$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a686606878691758$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a686606878691758$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$a686606878691758$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $a686606878691758$var$Buffer.isBuffer(val) ? val : $a686606878691758$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $a686606878691758$var$errors = {};
function $a686606878691758$var$E(sym, getMessage, Base) {
    $a686606878691758$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$a686606878691758$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$a686606878691758$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$a686606878691758$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $a686606878691758$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $a686606878691758$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $a686606878691758$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $a686606878691758$var$checkBounds(buf, offset, byteLength) {
    $a686606878691758$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $a686606878691758$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $a686606878691758$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $a686606878691758$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $a686606878691758$var$checkBounds(buf, offset, byteLength);
}
function $a686606878691758$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $a686606878691758$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $a686606878691758$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $a686606878691758$var$validateNumber(value, type);
        throw new $a686606878691758$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $a686606878691758$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $a686606878691758$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $a686606878691758$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a686606878691758$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a686606878691758$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $a686606878691758$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $a686606878691758$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a686606878691758$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a686606878691758$var$base64ToBytes(str) {
    return $hItut.toByteArray($a686606878691758$var$base64clean(str));
}
function $a686606878691758$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a686606878691758$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a686606878691758$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $a686606878691758$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $a686606878691758$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $a686606878691758$var$BufferBigIntNotDefined : fn;
}
function $a686606878691758$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("hItut", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $ce5d6be79bfa639a$export$d622b2ad8d90c771; }, function (v) { return $ce5d6be79bfa639a$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $ce5d6be79bfa639a$export$6100ba28696e12de; }, function (v) { return $ce5d6be79bfa639a$export$6100ba28696e12de = v; });
var $ce5d6be79bfa639a$export$a48f0734ac7c2329;
var $ce5d6be79bfa639a$export$d622b2ad8d90c771;
var $ce5d6be79bfa639a$export$6100ba28696e12de;
'use strict';
$ce5d6be79bfa639a$export$a48f0734ac7c2329 = $ce5d6be79bfa639a$var$byteLength;
$ce5d6be79bfa639a$export$d622b2ad8d90c771 = $ce5d6be79bfa639a$var$toByteArray;
$ce5d6be79bfa639a$export$6100ba28696e12de = $ce5d6be79bfa639a$var$fromByteArray;
var $ce5d6be79bfa639a$var$lookup = [];
var $ce5d6be79bfa639a$var$revLookup = [];
var $ce5d6be79bfa639a$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $ce5d6be79bfa639a$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $ce5d6be79bfa639a$var$i = 0, $ce5d6be79bfa639a$var$len = $ce5d6be79bfa639a$var$code.length; $ce5d6be79bfa639a$var$i < $ce5d6be79bfa639a$var$len; ++$ce5d6be79bfa639a$var$i){
    $ce5d6be79bfa639a$var$lookup[$ce5d6be79bfa639a$var$i] = $ce5d6be79bfa639a$var$code[$ce5d6be79bfa639a$var$i];
    $ce5d6be79bfa639a$var$revLookup[$ce5d6be79bfa639a$var$code.charCodeAt($ce5d6be79bfa639a$var$i)] = $ce5d6be79bfa639a$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$ce5d6be79bfa639a$var$revLookup['-'.charCodeAt(0)] = 62;
$ce5d6be79bfa639a$var$revLookup['_'.charCodeAt(0)] = 63;
function $ce5d6be79bfa639a$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $ce5d6be79bfa639a$var$byteLength(b64) {
    var lens = $ce5d6be79bfa639a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ce5d6be79bfa639a$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ce5d6be79bfa639a$var$toByteArray(b64) {
    var tmp;
    var lens = $ce5d6be79bfa639a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $ce5d6be79bfa639a$var$Arr($ce5d6be79bfa639a$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $ce5d6be79bfa639a$var$revLookup[b64.charCodeAt(i)] << 18 | $ce5d6be79bfa639a$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $ce5d6be79bfa639a$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $ce5d6be79bfa639a$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $ce5d6be79bfa639a$var$revLookup[b64.charCodeAt(i)] << 2 | $ce5d6be79bfa639a$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $ce5d6be79bfa639a$var$revLookup[b64.charCodeAt(i)] << 10 | $ce5d6be79bfa639a$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $ce5d6be79bfa639a$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $ce5d6be79bfa639a$var$tripletToBase64(num) {
    return $ce5d6be79bfa639a$var$lookup[num >> 18 & 0x3F] + $ce5d6be79bfa639a$var$lookup[num >> 12 & 0x3F] + $ce5d6be79bfa639a$var$lookup[num >> 6 & 0x3F] + $ce5d6be79bfa639a$var$lookup[num & 0x3F];
}
function $ce5d6be79bfa639a$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($ce5d6be79bfa639a$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $ce5d6be79bfa639a$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($ce5d6be79bfa639a$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($ce5d6be79bfa639a$var$lookup[tmp >> 2] + $ce5d6be79bfa639a$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($ce5d6be79bfa639a$var$lookup[tmp >> 10] + $ce5d6be79bfa639a$var$lookup[tmp >> 4 & 0x3F] + $ce5d6be79bfa639a$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("8GPgS", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $653a045d81ee36ad$export$aafa59e2e03f2942; }, function (v) { return $653a045d81ee36ad$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $653a045d81ee36ad$export$68d8715fc104d294; }, function (v) { return $653a045d81ee36ad$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $653a045d81ee36ad$export$aafa59e2e03f2942;
var $653a045d81ee36ad$export$68d8715fc104d294;
$653a045d81ee36ad$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$653a045d81ee36ad$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("5AkGi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41105b635611f30e$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");
'use strict';
class $41105b635611f30e$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $iLX88.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $41105b635611f30e$export$2e2bcd8739ae039 = $41105b635611f30e$var$InterceptorManager;

});

parcelRegister("7UqiZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c222b11680aaf25$export$2e2bcd8739ae039; });

var $5An9y = parcelRequire("5An9y");

var $6Q15H = parcelRequire("6Q15H");

var $gpsIs = parcelRequire("gpsIs");

var $jjxjT = parcelRequire("jjxjT");

var $iFS1V = parcelRequire("iFS1V");

var $4avOL = parcelRequire("4avOL");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $5c222b11680aaf25$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $jjxjT.default)(null, config);
}
function $5c222b11680aaf25$export$2e2bcd8739ae039(config) {
    $5c222b11680aaf25$var$throwIfCancellationRequested(config);
    config.headers = (0, $iFS1V.default).from(config.headers);
    // Transform request data
    config.data = (0, $5An9y.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $4avOL.default).getAdapter(config.adapter || (0, $gpsIs.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $5c222b11680aaf25$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $5An9y.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $iFS1V.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $6Q15H.default)(reason)) {
            $5c222b11680aaf25$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $5An9y.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $iFS1V.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("5An9y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $411246492e24efc4$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");

var $gpsIs = parcelRequire("gpsIs");

var $iFS1V = parcelRequire("iFS1V");
'use strict';
function $411246492e24efc4$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $gpsIs.default);
    const context = response || config;
    const headers = (0, $iFS1V.default).from(context.headers);
    let data = context.data;
    (0, $iLX88.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("gpsIs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf25418d5419657b$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");

var $4on8X = parcelRequire("4on8X");

var $ajGAB = parcelRequire("ajGAB");

var $7DgGh = parcelRequire("7DgGh");

var $6Ox3R = parcelRequire("6Ox3R");

var $lxQyd = parcelRequire("lxQyd");

var $1nXIl = parcelRequire("1nXIl");
'use strict';
const $bf25418d5419657b$var$own = (obj, key)=>obj != null && (0, $iLX88.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $bf25418d5419657b$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $iLX88.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $iLX88.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $bf25418d5419657b$var$defaults = {
    transitional: (0, $ajGAB.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $iLX88.default).isObject(data);
            if (isObjectPayload && (0, $iLX88.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $iLX88.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $1nXIl.default)(data)) : data;
            if ((0, $iLX88.default).isArrayBuffer(data) || (0, $iLX88.default).isBuffer(data) || (0, $iLX88.default).isStream(data) || (0, $iLX88.default).isFile(data) || (0, $iLX88.default).isBlob(data) || (0, $iLX88.default).isReadableStream(data)) return data;
            if ((0, $iLX88.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $iLX88.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $bf25418d5419657b$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $6Ox3R.default)(data, formSerializer).toString();
                if ((isFileList = (0, $iLX88.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $bf25418d5419657b$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $7DgGh.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $bf25418d5419657b$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $bf25418d5419657b$var$own(this, 'transitional') || $bf25418d5419657b$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $bf25418d5419657b$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $iLX88.default).isResponse(data) || (0, $iLX88.default).isReadableStream(data)) return data;
            if (data && (0, $iLX88.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $bf25418d5419657b$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4on8X.default).from(e, (0, $4on8X.default).ERR_BAD_RESPONSE, this, null, $bf25418d5419657b$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $lxQyd.default).classes.FormData,
        Blob: (0, $lxQyd.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $iLX88.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $bf25418d5419657b$var$defaults.headers[method] = {};
});
var $bf25418d5419657b$export$2e2bcd8739ae039 = $bf25418d5419657b$var$defaults;

});
parcelRegister("ajGAB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $782cb71bfb8b2168$export$2e2bcd8739ae039; });
'use strict';
var $782cb71bfb8b2168$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false
};

});

parcelRegister("6Ox3R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f610edd8c483ae9$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $iLX88 = parcelRequire("iLX88");

var $7DgGh = parcelRequire("7DgGh");

var $lxQyd = parcelRequire("lxQyd");
'use strict';
function $4f610edd8c483ae9$export$2e2bcd8739ae039(data, options) {
    return (0, $7DgGh.default)(data, new (0, $lxQyd.default).classes.URLSearchParams(), (0, $dok7x._)({
        visitor: function(value, key, path, helpers) {
            if ((0, $lxQyd.default).isNode && (0, $iLX88.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("lxQyd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faf57191c43bdea9$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $5FplO = parcelRequire("5FplO");

var $9LYP8 = parcelRequire("9LYP8");
var $faf57191c43bdea9$export$2e2bcd8739ae039 = (0, $dok7x._)({}, $9LYP8, (0, $5FplO.default));

});
parcelRegister("5FplO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4204723ee0f00336$export$2e2bcd8739ae039; });

var $dkaEj = parcelRequire("dkaEj");

var $Y1Nou = parcelRequire("Y1Nou");

var $cGeqI = parcelRequire("cGeqI");
var $4204723ee0f00336$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $dkaEj.default,
        FormData: $Y1Nou.default,
        Blob: $cGeqI.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("dkaEj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b35675209a5458a$export$2e2bcd8739ae039; });

var $gGNy7 = parcelRequire("gGNy7");
'use strict';
var $9b35675209a5458a$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $gGNy7.default);

});

parcelRegister("Y1Nou", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b46ff4b92ef2d38$export$2e2bcd8739ae039; });
'use strict';
var $0b46ff4b92ef2d38$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("cGeqI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93b499bb5fb92347$export$2e2bcd8739ae039; });
'use strict';
var $93b499bb5fb92347$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("9LYP8", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $71d7af29079f3711$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $71d7af29079f3711$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $71d7af29079f3711$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $71d7af29079f3711$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $71d7af29079f3711$export$f710a83a91838a36; });
const $71d7af29079f3711$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $71d7af29079f3711$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $71d7af29079f3711$export$c0bcc9250309d66 = $71d7af29079f3711$export$c4996c4b7b93b0bf && (!$71d7af29079f3711$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($71d7af29079f3711$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $71d7af29079f3711$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $71d7af29079f3711$export$f710a83a91838a36 = $71d7af29079f3711$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("1nXIl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10264270bde74422$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $10264270bde74422$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $iLX88.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $10264270bde74422$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $10264270bde74422$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $iLX88.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $iLX88.default).hasOwnProp(target, name)) target[name] = (0, $iLX88.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $iLX88.default).hasOwnProp(target, name) || !(0, $iLX88.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $iLX88.default).isArray(target[name])) target[name] = $10264270bde74422$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $iLX88.default).isFormData(formData) && (0, $iLX88.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $iLX88.default).forEachEntry(formData, (name, value)=>{
            buildPath($10264270bde74422$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $10264270bde74422$export$2e2bcd8739ae039 = $10264270bde74422$var$formDataToJSON;

});



parcelRegister("6Q15H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fa8720f3f61a33d$export$2e2bcd8739ae039; });
'use strict';
function $4fa8720f3f61a33d$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("jjxjT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0f9a34c65a28774$export$2e2bcd8739ae039; });

var $4on8X = parcelRequire("4on8X");
'use strict';
class $e0f9a34c65a28774$var$CanceledError extends (0, $4on8X.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $4on8X.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $e0f9a34c65a28774$export$2e2bcd8739ae039 = $e0f9a34c65a28774$var$CanceledError;

});

parcelRegister("4avOL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3090c6f26a824237$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");

var $kYzyS = parcelRequire("kYzyS");

var $jvErb = parcelRequire("jvErb");

var $jUUBS = parcelRequire("jUUBS");

var $4on8X = parcelRequire("4on8X");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $3090c6f26a824237$var$knownAdapters = {
    http: (0, $kYzyS.default),
    xhr: (0, $jvErb.default),
    fetch: {
        get: $jUUBS.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $iLX88.default).forEach($3090c6f26a824237$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $3090c6f26a824237$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $3090c6f26a824237$var$isResolvedHandle = (adapter)=>(0, $iLX88.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $3090c6f26a824237$var$getAdapter(adapters, config) {
    adapters = (0, $iLX88.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$3090c6f26a824237$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $3090c6f26a824237$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $4on8X.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $iLX88.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($3090c6f26a824237$var$renderReason).join('\n') : ' ' + $3090c6f26a824237$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $4on8X.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $3090c6f26a824237$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $3090c6f26a824237$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $3090c6f26a824237$var$knownAdapters
};

});
parcelRegister("jvErb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3404795b70aacc1$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");

var $5oJpl = parcelRequire("5oJpl");

var $ajGAB = parcelRequire("ajGAB");

var $4on8X = parcelRequire("4on8X");

var $jjxjT = parcelRequire("jjxjT");

var $b8VxC = parcelRequire("b8VxC");

var $lxQyd = parcelRequire("lxQyd");

var $iFS1V = parcelRequire("iFS1V");

var $7BUAA = parcelRequire("7BUAA");

var $3PSqr = parcelRequire("3PSqr");

var $65R0u = parcelRequire("65R0u");
const $e3404795b70aacc1$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $e3404795b70aacc1$export$2e2bcd8739ae039 = $e3404795b70aacc1$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $3PSqr.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $iFS1V.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $iFS1V.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $5oJpl.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4on8X.default)('Request aborted', (0, $4on8X.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $4on8X.default)(msg, (0, $4on8X.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $ajGAB.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4on8X.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4on8X.default).ETIMEDOUT : (0, $4on8X.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $iLX88.default).forEach((0, $65R0u.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $iLX88.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $7BUAA.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $7BUAA.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $jjxjT.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $b8VxC.default)(_config.url);
        if (protocol && !(0, $lxQyd.default).protocols.includes(protocol)) {
            reject(new (0, $4on8X.default)('Unsupported protocol ' + protocol + ':', (0, $4on8X.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("5oJpl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ee26ab324f44f1a$export$2e2bcd8739ae039; });

var $4on8X = parcelRequire("4on8X");
'use strict';
function $3ee26ab324f44f1a$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4on8X.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $4on8X.default).ERR_BAD_REQUEST : (0, $4on8X.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

});

parcelRegister("b8VxC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81cd1388e95c668b$export$2e2bcd8739ae039; });
'use strict';
function $81cd1388e95c668b$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("7BUAA", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $58a7e2884fee07ff$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $58a7e2884fee07ff$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $58a7e2884fee07ff$export$5d35863c355a22a9; });

var $fCkDI = parcelRequire("fCkDI");

var $1Niq4 = parcelRequire("1Niq4");

var $iLX88 = parcelRequire("iLX88");
const $58a7e2884fee07ff$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $fCkDI.default)(50, 250);
    return (0, $1Niq4.default)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $58a7e2884fee07ff$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $58a7e2884fee07ff$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $iLX88.default).asap(()=>fn(...args));

});
parcelRegister("fCkDI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5ea6a34ad9b21d0$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $b5ea6a34ad9b21d0$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $b5ea6a34ad9b21d0$export$2e2bcd8739ae039 = $b5ea6a34ad9b21d0$var$speedometer;

});

parcelRegister("1Niq4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14e8a7c924098d81$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $14e8a7c924098d81$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $14e8a7c924098d81$export$2e2bcd8739ae039 = $14e8a7c924098d81$var$throttle;

});


parcelRegister("3PSqr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cb05a449695b593$export$2e2bcd8739ae039; });

var $lxQyd = parcelRequire("lxQyd");

var $iLX88 = parcelRequire("iLX88");

var $itbRN = parcelRequire("itbRN");

var $9hPh4 = parcelRequire("9hPh4");

var $4oDOM = parcelRequire("4oDOM");

var $1mi1M = parcelRequire("1mi1M");

var $iFS1V = parcelRequire("iFS1V");

var $8qdqj = parcelRequire("8qdqj");
const $2cb05a449695b593$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $2cb05a449695b593$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders).forEach(([key, val])=>{
        if ($2cb05a449695b593$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $2cb05a449695b593$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $2cb05a449695b593$var$resolveConfig(config) {
    const newConfig = (0, $1mi1M.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $iLX88.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $iFS1V.default).from(headers);
    newConfig.url = (0, $8qdqj.default)((0, $4oDOM.default)(baseURL, url, allowAbsoluteUrls), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? $2cb05a449695b593$var$encodeUTF8(auth.password) : '')));
    if ((0, $iLX88.default).isFormData(data)) {
        if ((0, $lxQyd.default).hasStandardBrowserEnv || (0, $lxQyd.default).hasStandardBrowserWebWorkerEnv || (0, $iLX88.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $iLX88.default).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $2cb05a449695b593$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $lxQyd.default).hasStandardBrowserEnv) {
        if ((0, $iLX88.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $itbRN.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $9hPh4.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $2cb05a449695b593$export$2e2bcd8739ae039 = $2cb05a449695b593$var$resolveConfig;

});
parcelRegister("itbRN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d72423e26e77e9f8$export$2e2bcd8739ae039; });

var $lxQyd = parcelRequire("lxQyd");
var $d72423e26e77e9f8$export$2e2bcd8739ae039 = (0, $lxQyd.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $lxQyd.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $lxQyd.default).origin), (0, $lxQyd.default).navigator && /(msie|trident)/i.test((0, $lxQyd.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("9hPh4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c2d799966fa8597$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");

var $lxQyd = parcelRequire("lxQyd");
var $6c2d799966fa8597$export$2e2bcd8739ae039 = (0, $lxQyd.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $iLX88.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $iLX88.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $iLX88.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $iLX88.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return decodeURIComponent(cookie.slice(eq + 1));
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("4oDOM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33384a56dda53bb6$export$2e2bcd8739ae039; });

var $jXgl2 = parcelRequire("jXgl2");

var $b8okf = parcelRequire("b8okf");
'use strict';
function $33384a56dda53bb6$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $jXgl2.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) return (0, $b8okf.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("jXgl2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8703372d54eddb0$export$2e2bcd8739ae039; });
'use strict';
function $e8703372d54eddb0$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("b8okf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81b34f9819632cb4$export$2e2bcd8739ae039; });
'use strict';
function $81b34f9819632cb4$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("1mi1M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fd5d4748bb88591$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $iLX88 = parcelRequire("iLX88");

var $iFS1V = parcelRequire("iFS1V");
'use strict';
const $0fd5d4748bb88591$var$headersToObject = (thing)=>thing instanceof (0, $iFS1V.default) ? (0, $dok7x._)({}, thing) : thing;
function $0fd5d4748bb88591$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $iLX88.default).isPlainObject(target) && (0, $iLX88.default).isPlainObject(source)) return (0, $iLX88.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $iLX88.default).isPlainObject(source)) return (0, $iLX88.default).merge({}, source);
        else if ((0, $iLX88.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $iLX88.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $iLX88.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $iLX88.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $iLX88.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $iLX88.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $iLX88.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $iLX88.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($0fd5d4748bb88591$var$headersToObject(a), $0fd5d4748bb88591$var$headersToObject(b), prop, true)
    };
    (0, $iLX88.default).forEach(Object.keys((0, $dok7x._)({}, config1, config2)), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $iLX88.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $iLX88.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $iLX88.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $iLX88.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("jUUBS", function(module, exports) {

$parcel$export(module.exports, "getFetch", function () { return $e7ff28d5157f353f$export$3105c6651375d4fa; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $lxQyd = parcelRequire("lxQyd");

var $iLX88 = parcelRequire("iLX88");

var $4on8X = parcelRequire("4on8X");

var $3zYgK = parcelRequire("3zYgK");

var $fau7w = parcelRequire("fau7w");

var $iFS1V = parcelRequire("iFS1V");

var $7BUAA = parcelRequire("7BUAA");

var $3PSqr = parcelRequire("3PSqr");

var $5oJpl = parcelRequire("5oJpl");

var $1yBQ5 = parcelRequire("1yBQ5");

var $iYpZK = parcelRequire("iYpZK");

var $65R0u = parcelRequire("65R0u");
const $e7ff28d5157f353f$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e7ff28d5157f353f$var$isFunction } = (0, $iLX88.default);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e7ff28d5157f353f$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $e7ff28d5157f353f$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $iLX88.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $e7ff28d5157f353f$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e7ff28d5157f353f$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $e7ff28d5157f353f$var$factory = (env)=>{
    const globalObject = (0, $iLX88.default).global !== undefined && (0, $iLX88.default).global !== null ? (0, $iLX88.default).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $iLX88.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e7ff28d5157f353f$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e7ff28d5157f353f$var$isFunction(Request);
    const isResponseSupported = $e7ff28d5157f353f$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e7ff28d5157f353f$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e7ff28d5157f353f$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $lxQyd.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e7ff28d5157f353f$var$test(()=>(0, $iLX88.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $4on8X.default)(`Response type '${type}' is not supported`, (0, $4on8X.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $iLX88.default).isBlob(body)) return body.size;
        if ((0, $iLX88.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $lxQyd.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $iLX88.default).isArrayBufferView(body) || (0, $iLX88.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $iLX88.default).isURLSearchParams(body)) body = body + '';
        if ((0, $iLX88.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $iLX88.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $3PSqr.default)(config);
        const hasMaxContentLength = (0, $iLX88.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $iLX88.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $iLX88.default).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $3zYgK.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = configAuth.username || '';
                const password = configAuth.password || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($e7ff28d5157f353f$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $lxQyd.default).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $e7ff28d5157f353f$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $e7ff28d5157f353f$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($e7ff28d5157f353f$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $1yBQ5.default)(url);
                if (estimated > maxContentLength) throw new (0, $4on8X.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4on8X.default).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against the outbound request body before dispatch.
            // Mirrors http.js behavior (ERR_BAD_REQUEST / 'Request body larger than
            // maxBodyLength limit'). Skip when the body length cannot be determined
            // (e.g. a live ReadableStream supplied by the caller).
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await resolveBodyLength(headers, data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength) && outboundLength > maxBodyLength) throw new (0, $4on8X.default)('Request body larger than maxBodyLength limit', (0, $4on8X.default).ERR_BAD_REQUEST, config, request);
            }
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $iLX88.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $7BUAA.progressEventDecorator)(requestContentLength, (0, $7BUAA.progressEventReducer)((0, $7BUAA.asyncDecorator)(onUploadProgress)));
                    data = (0, $fau7w.trackStream)(_request.body, $e7ff28d5157f353f$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $iLX88.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $iLX88.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $iYpZK.VERSION), false);
            const resolvedOptions = (0, $cNnl8._)((0, $dok7x._)({}, fetchOptions), {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $65R0u.toByteStringHeaderObject)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $iLX88.default).toFiniteNumber(response.headers.get('content-length'));
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $4on8X.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4on8X.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $iLX88.default).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $7BUAA.progressEventDecorator)(responseContentLength, (0, $7BUAA.progressEventReducer)((0, $7BUAA.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $4on8X.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4on8X.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $fau7w.trackStream)(response.body, $e7ff28d5157f353f$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $iLX88.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $4on8X.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $4on8X.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $5oJpl.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $iFS1V.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $4on8X.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                err !== canceledError && (canceledError.cause = err);
                throw canceledError;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $4on8X.default)('Network Error', (0, $4on8X.default).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $4on8X.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e7ff28d5157f353f$var$seedCache = new Map();
const $e7ff28d5157f353f$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e7ff28d5157f353f$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e7ff28d5157f353f$var$factory(env));
        map = target;
    }
    return target;
};
const $e7ff28d5157f353f$var$adapter = $e7ff28d5157f353f$export$3105c6651375d4fa();
var $e7ff28d5157f353f$export$2e2bcd8739ae039 = $e7ff28d5157f353f$var$adapter;

});
parcelRegister("3zYgK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29b36430470897c8$export$2e2bcd8739ae039; });

var $jjxjT = parcelRequire("jjxjT");

var $4on8X = parcelRequire("4on8X");

var $iLX88 = parcelRequire("iLX88");
const $29b36430470897c8$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $4on8X.default) ? err : new (0, $jjxjT.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $4on8X.default)(`timeout of ${timeout}ms exceeded`, (0, $4on8X.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $iLX88.default).asap(unsubscribe);
    return signal;
};
var $29b36430470897c8$export$2e2bcd8739ae039 = $29b36430470897c8$var$composeSignals;

});

parcelRegister("fau7w", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $b0af27735a1568d1$export$b0119225647bd83; });
const $b0af27735a1568d1$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $b0af27735a1568d1$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $b0af27735a1568d1$var$readStream(iterable))yield* $b0af27735a1568d1$export$71b051935044bd5d(chunk, chunkSize);
};
const $b0af27735a1568d1$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $b0af27735a1568d1$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $b0af27735a1568d1$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});

parcelRegister("1yBQ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12265179e9021b5d$export$2e2bcd8739ae039; });
/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: use UTF-8 byteLength of the encoded body as a safe upper bound.
 *
 * @param {string} url
 * @returns {number}
 */ 
var $eipj2 = parcelRequire("eipj2");
var $12265179e9021b5d$require$Buffer = $eipj2.Buffer;
function $12265179e9021b5d$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = (a >= 48 && a <= 57 || a >= 65 && a <= 70 || a >= 97 && a <= 102) && (b >= 48 && b <= 57 || b >= 65 && b <= 70 || b >= 97 && b <= 102);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    if (typeof $12265179e9021b5d$require$Buffer !== 'undefined' && typeof $12265179e9021b5d$require$Buffer.byteLength === 'function') return $12265179e9021b5d$require$Buffer.byteLength(body, 'utf8');
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Using body.length here would undercount non-ASCII (e.g. '€' is 1 code unit
    // but 3 UTF-8 bytes).
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}

});

parcelRegister("iYpZK", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $dd01fea1fa24254f$export$a4ad2735b021c132; });
const $dd01fea1fa24254f$export$a4ad2735b021c132 = "1.17.0";

});




parcelRegister("fkgBZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2859c0338671189$export$2e2bcd8739ae039; });

var $iYpZK = parcelRequire("iYpZK");

var $4on8X = parcelRequire("4on8X");
'use strict';
const $b2859c0338671189$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $b2859c0338671189$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $b2859c0338671189$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $b2859c0338671189$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $iYpZK.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4on8X.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4on8X.default).ERR_DEPRECATED);
        if (version && !$b2859c0338671189$var$deprecatedWarnings[opt]) {
            $b2859c0338671189$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$b2859c0338671189$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $b2859c0338671189$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $4on8X.default)('options must be an object', (0, $4on8X.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4on8X.default)('option ' + opt + ' must be ' + result, (0, $4on8X.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4on8X.default)('Unknown option ' + opt, (0, $4on8X.default).ERR_BAD_OPTION);
    }
}
var $b2859c0338671189$export$2e2bcd8739ae039 = {
    assertOptions: $b2859c0338671189$var$assertOptions,
    validators: $b2859c0338671189$var$validators
};

});


parcelRegister("amPM5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78c41eca9fb5411d$export$2e2bcd8739ae039; });

var $jjxjT = parcelRequire("jjxjT");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $78c41eca9fb5411d$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $78c41eca9fb5411d$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $jjxjT.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $78c41eca9fb5411d$export$2e2bcd8739ae039 = $78c41eca9fb5411d$var$CancelToken;

});

parcelRegister("1lbUl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fa0fd398c375b4a$export$2e2bcd8739ae039; });
'use strict';
function $0fa0fd398c375b4a$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("k4WyF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9e19ac64c9ef4ff$export$2e2bcd8739ae039; });

var $iLX88 = parcelRequire("iLX88");
'use strict';
function $e9e19ac64c9ef4ff$export$2e2bcd8739ae039(payload) {
    return (0, $iLX88.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("iZVkB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd4a6553e419b7c6$export$2e2bcd8739ae039; });
const $dd4a6553e419b7c6$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($dd4a6553e419b7c6$var$HttpStatusCode).forEach(([key, value])=>{
    $dd4a6553e419b7c6$var$HttpStatusCode[value] = key;
});
var $dd4a6553e419b7c6$export$2e2bcd8739ae039 = $dd4a6553e419b7c6$var$HttpStatusCode;

});



parcelRegister("iZUkI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PROJECT", function () { return $b10dba288ea0e352$export$2c162426eea6a540; });
$parcel$export(module.exports, "DEFAULT_ROUTE", function () { return $b10dba288ea0e352$export$4eadc79233226325; });
$parcel$export(module.exports, "TOKEN_KEY", function () { return $b10dba288ea0e352$export$5fa58d0d5feabf48; });
$parcel$export(module.exports, "MSG_USER_NOT_WHITELISTED", function () { return $b10dba288ea0e352$export$d0bcb7c5d5f131a7; });
$parcel$export(module.exports, "BUDDY_PROJECTS", function () { return $b10dba288ea0e352$export$fa72f1874ddb2806; });
$parcel$export(module.exports, "CACHE_TIMES", function () { return $b10dba288ea0e352$export$4b2e8bd5cd5f0a5a; });
$parcel$export(module.exports, "COLLAPSE_BREAK_MARKER", function () { return $b10dba288ea0e352$export$a3583417f0c47b1f; });
const $b10dba288ea0e352$export$2c162426eea6a540 = 'fall26';
const $b10dba288ea0e352$export$4eadc79233226325 = `/${$b10dba288ea0e352$export$2c162426eea6a540}/`;
const $b10dba288ea0e352$export$5fa58d0d5feabf48 = `auth-${location.pathname.split('/')[1] || $b10dba288ea0e352$export$2c162426eea6a540.toString()}`;
const $b10dba288ea0e352$export$d0bcb7c5d5f131a7 = 'Use the same email we used to contact you (for example the email address your invitation was sent to).';
const $b10dba288ea0e352$export$fa72f1874ddb2806 = [
    '13',
    'buddyfall25',
    '15',
    'buddyspring26',
    '17',
    'buddyfall26'
];
const $b10dba288ea0e352$export$4b2e8bd5cd5f0a5a = {
    SHORT: 300000,
    // 5 minutes
    DEFAULT: 600000,
    // 10 minutes
    LONG: 1800000,
    // 30 minutes
    INFINITE: Infinity // never refetch
};
const $b10dba288ea0e352$export$a3583417f0c47b1f = '<!--COLLAPSE-->';

});


parcelRegister("6WeUp", function(module, exports) {

$parcel$export(module.exports, "useSubMenuContext", function () { return $6eca1efb2fed9c71$export$a2873e323c026b38; });
$parcel$export(module.exports, "SubMenuProvider", function () { return $6eca1efb2fed9c71$export$283fdf38f8a00b48; });

var $iHpLz = parcelRequire("iHpLz");

var $7hhBq = parcelRequire("7hhBq");
const $6eca1efb2fed9c71$var$defaultSubMenuContext = {
    isSubMenu: false,
    openSubMenu: ()=>{},
    closeSubMenu: ()=>{}
};
const $6eca1efb2fed9c71$export$fb8a596c8c94a588 = /*#__PURE__*/ (0, $7hhBq.createContext)($6eca1efb2fed9c71$var$defaultSubMenuContext);
const $6eca1efb2fed9c71$export$a2873e323c026b38 = ()=>(0, $7hhBq.useContext)($6eca1efb2fed9c71$export$fb8a596c8c94a588);
const $6eca1efb2fed9c71$export$283fdf38f8a00b48 = ({ children: children })=>{
    const [isSubMenu, setIsSubMenu] = (0, $7hhBq.useState)(false);
    const openSubMenu = ()=>{
        setIsSubMenu(true);
        window.scrollTo(0, 0);
    };
    const closeSubMenu = ()=>{
        setIsSubMenu(false);
    };
    const value = (0, $7hhBq.useMemo)(()=>({
            isSubMenu: isSubMenu,
            openSubMenu: openSubMenu,
            closeSubMenu: closeSubMenu
        }), [
        isSubMenu
    ]);
    return /*#__PURE__*/ (0, $iHpLz.jsx)($6eca1efb2fed9c71$export$fb8a596c8c94a588.Provider, {
        value: value,
        children: children
    });
};

});

parcelRegister("8oEKT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7542de6096b31bb2$export$2e2bcd8739ae039; });

var $iZUkI = parcelRequire("iZUkI");
const $7542de6096b31bb2$var$useProjectId = ()=>{
    const listOfPaths = location.pathname.split('/');
    return listOfPaths[1] || (0, $iZUkI.DEFAULT_PROJECT).toString();
};
var $7542de6096b31bb2$export$2e2bcd8739ae039 = $7542de6096b31bb2$var$useProjectId;

});

parcelRegister("ljlev", function(module, exports) {

$parcel$export(module.exports, "AuthProvider", function () { return $913378c528d5c623$export$87091915187a1a85; });
$parcel$export(module.exports, "default", function () { return $913378c528d5c623$export$2e2bcd8739ae039; });

var $iHpLz = parcelRequire("iHpLz");

var $7hhBq = parcelRequire("7hhBq");

var $iZUkI = parcelRequire("iZUkI");
const $913378c528d5c623$var$AuthContext = /*#__PURE__*/ (0, $7hhBq.createContext)(undefined);
const $913378c528d5c623$export$87091915187a1a85 = ({ children: children })=>{
    const [token, setToken] = (0, $7hhBq.useState)(localStorage.getItem((0, $iZUkI.TOKEN_KEY)));
    const createSession = (newToken)=>{
        localStorage.setItem((0, $iZUkI.TOKEN_KEY), newToken);
        setToken(newToken);
    };
    const destroySession = ()=>{
        localStorage.removeItem((0, $iZUkI.TOKEN_KEY));
        setToken(null);
    };
    const sessionData = (0, $7hhBq.useMemo)(()=>{
        if (token == null) return null;
        let decodedToken;
        try {
            decodedToken = JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            return null;
        }
        if (!decodedToken) return null;
        const expirationDate = new Date(decodedToken.exp * 1000);
        if (expirationDate < new Date()) {
            destroySession();
            return null;
        }
        //TODO : Remove after reception, since this is a JWT force
        if (expirationDate < new Date('2025-08-19T14:30:00Z')) {
            destroySession();
            return null;
        }
        return {
            id: decodedToken.id,
            projectId: decodedToken.projectId,
            email: decodedToken.email,
            globalRole: decodedToken.globalRole,
            projectRole: decodedToken.projectRole,
            expirationDate: expirationDate
        };
    }, [
        token
    ]);
    const isActive = token !== null;
    return /*#__PURE__*/ (0, $iHpLz.jsx)($913378c528d5c623$var$AuthContext.Provider, {
        value: {
            token: token,
            sessionData: sessionData,
            isActive: isActive,
            createSession: createSession,
            destroySession: destroySession
        },
        children: children
    });
};
const $913378c528d5c623$var$useAuthSession = ()=>{
    const context = (0, $7hhBq.useContext)($913378c528d5c623$var$AuthContext);
    if (!context) throw new Error('useAuth must be used within an AuthProvider');
    return context;
};
var $913378c528d5c623$export$2e2bcd8739ae039 = $913378c528d5c623$var$useAuthSession;

});

parcelRegister("c5JDL", function(module, exports) {

$parcel$export(module.exports, "useProjectTextContext", function () { return $3e49071a9f8cf6d0$export$7ed06f157310c82c; });
$parcel$export(module.exports, "ProjectTextProvider", function () { return $3e49071a9f8cf6d0$export$e13a110b748f66bb; });

var $iHpLz = parcelRequire("iHpLz");

var $lS6A7 = parcelRequire("lS6A7");

var $7hhBq = parcelRequire("7hhBq");
const $3e49071a9f8cf6d0$var$emptyProjectTexts = {
    PROJECT_RULES: '',
    PROJECT_NAME: '',
    FRONTPAGE_MAIN: '',
    LOGIN_BANNER: ''
};
const $3e49071a9f8cf6d0$export$5bc7d36837cbd396 = /*#__PURE__*/ (0, $7hhBq.createContext)($3e49071a9f8cf6d0$var$emptyProjectTexts);
const $3e49071a9f8cf6d0$export$7ed06f157310c82c = ()=>(0, $7hhBq.useContext)($3e49071a9f8cf6d0$export$5bc7d36837cbd396);
const $3e49071a9f8cf6d0$export$e13a110b748f66bb = ({ children: children })=>{
    const { texts: texts } = (0, $lS6A7.default)();
    return /*#__PURE__*/ (0, $iHpLz.jsx)($3e49071a9f8cf6d0$export$5bc7d36837cbd396.Provider, {
        value: texts,
        children: children
    });
};

});
parcelRegister("lS6A7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a2ea1560b4776df$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $ddi3l = parcelRequire("ddi3l");

var $8aMGX = parcelRequire("8aMGX");

var $8oEKT = parcelRequire("8oEKT");
const $2a2ea1560b4776df$var$useFetchTexts = ()=>{
    const projectId = (0, $8oEKT.default)();
    const { data: data, isLoading: isLoading } = (0, $ddi3l.useQuery)((0, $8aMGX.default)(projectId));
    const defaults = {
        PROJECT_RULES: '',
        PROJECT_NAME: '',
        FRONTPAGE_MAIN: '',
        LOGIN_BANNER: ''
    };
    if (isLoading || !data) return {
        texts: defaults,
        isLoading: true
    };
    return {
        texts: (0, $dok7x._)({}, defaults, data),
        isLoading: isLoading
    };
};
var $2a2ea1560b4776df$export$2e2bcd8739ae039 = $2a2ea1560b4776df$var$useFetchTexts;

});
parcelRegister("8aMGX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d54a73125040cb6$export$2e2bcd8739ae039; });

var $dkNUW = parcelRequire("dkNUW");
const $9d54a73125040cb6$var$fetchPublicText = async (pid)=>{
    var _result_data;
    const result = await $dkNUW.request('GET', `/content-public/${pid}/strings`);
    return (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.data;
};
const $9d54a73125040cb6$var$getPublicText = (pid)=>({
        queryKey: [
            'getPublicText',
            pid
        ],
        queryFn: ()=>$9d54a73125040cb6$var$fetchPublicText(pid),
        enabled: !!pid,
        gcTime: 86400000,
        // 1 day
        retry: 3,
        retryDelay: 500
    });
var $9d54a73125040cb6$export$2e2bcd8739ae039 = $9d54a73125040cb6$var$getPublicText;

});



parcelRegister("iVlmI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9053b0271b9a3f6$export$2e2bcd8739ae039; });

var $iHpLz = parcelRequire("iHpLz");

var $dmsNZ = parcelRequire("dmsNZ");
var $18TeW = parcelRequire("18TeW");

var $h3hKu = parcelRequire("h3hKu");
parcelRequire("7hhBq");

var $3eNYq = parcelRequire("3eNYq");

var $7uDxj = parcelRequire("7uDxj");

var $c2CkC = parcelRequire("c2CkC");
const $b9053b0271b9a3f6$var$Root = (0, $18TeW.default)((0, $dmsNZ.default), {
    shouldForwardProp: (prop)=>prop !== 'hasHeader' && prop !== 'greyBackground'
})(({ theme: theme, hasHeader: hasHeader, greyBackground: greyBackground })=>({
        alignItems: hasHeader ? 'stretch' : 'flex-start',
        maxWidth: '1280px',
        backgroundColor: greyBackground ? '#F5F5F5' : 'white',
        flexDirection: 'column',
        height: hasHeader ? '100%' : undefined,
        [theme.breakpoints.up('xs')]: {
            padding: `0 16px`
        },
        [theme.breakpoints.up('sm')]: {
            padding: `0 16px`
        },
        [theme.breakpoints.up('md')]: {
            padding: `${hasHeader ? '0' : '40px'} 24px`
        },
        [theme.breakpoints.up('lg')]: {
            padding: `${hasHeader ? '0' : '40px'} 24px`
        }
    }));
const $b9053b0271b9a3f6$var$MainContent = (0, $18TeW.default)((0, $dmsNZ.default))(()=>({
        width: '100%',
        minHeight: '100vh'
    }));
const $b9053b0271b9a3f6$var$Content = ({ children: children, sidebarComponent: sidebarComponent, greyBackground: greyBackground, header: header, sidebar: sidebar })=>{
    const isMobile = (0, $c2CkC.default)();
    const theme = (0, $h3hKu.default)();
    const sidebarExists = sidebar || sidebarComponent;
    const mainContentSize = sidebarExists ? 9 : 12;
    const shouldBeGray = Boolean(greyBackground) && !isMobile;
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iHpLz.Fragment), {
        children: /*#__PURE__*/ (0, $iHpLz.jsxs)($b9053b0271b9a3f6$var$Root, {
            container: true,
            hasHeader: !!header,
            greyBackground: shouldBeGray,
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0, $iHpLz.jsx)((0, $3eNYq.default), {
                    header: header
                }),
                /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $dmsNZ.default), {
                    container: true,
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $7uDxj.default), {
                            sidebar: sidebar,
                            sidebarComponent: sidebarComponent
                        }),
                        /*#__PURE__*/ (0, $iHpLz.jsx)($b9053b0271b9a3f6$var$MainContent, {
                            item: true,
                            xs: 12,
                            md: mainContentSize,
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};
var $b9053b0271b9a3f6$export$2e2bcd8739ae039 = $b9053b0271b9a3f6$var$Content;

});
parcelRegister("h3hKu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbb8e440a7bcc86c$export$2e2bcd8739ae039; });

var $eGBcx = parcelRequire("eGBcx");
const $cbb8e440a7bcc86c$var$useDynamicTheme = ()=>{
    const theme = (0, $eGBcx.default)();
    return theme;
};
var $cbb8e440a7bcc86c$export$2e2bcd8739ae039 = $cbb8e440a7bcc86c$var$useDynamicTheme;

});

parcelRegister("3eNYq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3da34dad2226b23$export$2e2bcd8739ae039; });

var $iHpLz = parcelRequire("iHpLz");

var $dyXu7 = parcelRequire("dyXu7");
var $dmsNZ = parcelRequire("dmsNZ");
parcelRequire("7hhBq");
const $c3da34dad2226b23$var$ContentHeader = ({ header: header })=>{
    if (!header) return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iHpLz.Fragment), {});
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $dmsNZ.default), {
        item: true,
        md: 12,
        xs: 12,
        children: /*#__PURE__*/ (0, $iHpLz.jsxs)("div", {
            style: {
                marginTop: '16px'
            },
            children: [
                header,
                /*#__PURE__*/ (0, $iHpLz.jsx)((0, $dyXu7.default), {
                    style: {
                        marginTop: '16px'
                    }
                })
            ]
        })
    });
};
var $c3da34dad2226b23$export$2e2bcd8739ae039 = $c3da34dad2226b23$var$ContentHeader;

});
parcelRegister("dyXu7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dfc97c659faba03$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");

var $eET99 = parcelRequire("eET99");

var $cqwHw = parcelRequire("cqwHw");

var $18TeW = parcelRequire("18TeW");

var $1zv4u = parcelRequire("1zv4u");

var $4ZZLe = parcelRequire("4ZZLe");

var $5L4I3 = parcelRequire("5L4I3");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $9dfc97c659faba03$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $eET99.default)(slots, (0, $5L4I3.getDividerUtilityClass), classes);
};
const $9dfc97c659faba03$var$DividerRoot = (0, $18TeW.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $1zv4u.default)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $cqwHw.alpha)(theme.palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $9dfc97c659faba03$var$DividerWrapper = (0, $18TeW.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $1zv4u.default)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $9dfc97c659faba03$var$Divider = /*#__PURE__*/ $7hhBq.forwardRef(function Divider(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $6pkKu._)(props, [
        "absolute",
        "children",
        "className",
        "orientation",
        "component",
        "flexItem",
        "light",
        "role",
        "textAlign",
        "variant"
    ]);
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $9dfc97c659faba03$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iHpLz.jsx)($9dfc97c659faba03$var$DividerRoot, (0, $cNnl8._)((0, $dok7x._)({
        as: component,
        className: (0, $5vmbh.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined
    }, other), {
        children: children ? /*#__PURE__*/ (0, $iHpLz.jsx)($9dfc97c659faba03$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($9dfc97c659faba03$var$Divider) $9dfc97c659faba03$var$Divider.muiSkipListHighlight = true;
var $9dfc97c659faba03$export$2e2bcd8739ae039 = $9dfc97c659faba03$var$Divider;

});
parcelRegister("5L4I3", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", function () { return $4314febe778eddff$export$46f01d01378ec5a2; });
$parcel$export(module.exports, "default", function () { return $4314febe778eddff$export$2e2bcd8739ae039; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $4314febe778eddff$export$46f01d01378ec5a2(slot) {
    return (0, $200uu.default)('MuiDivider', slot);
}
const $4314febe778eddff$var$dividerClasses = (0, $5blE7.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $4314febe778eddff$export$2e2bcd8739ae039 = $4314febe778eddff$var$dividerClasses;

});



parcelRegister("7uDxj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af322d52a20efd7b$export$2e2bcd8739ae039; });

var $iHpLz = parcelRequire("iHpLz");

var $dmsNZ = parcelRequire("dmsNZ");
parcelRequire("7hhBq");

var $fvnvn = parcelRequire("fvnvn");
const $af322d52a20efd7b$var$SidebarContainer = ({ sidebar: sidebar, sidebarComponent: sidebarComponent })=>{
    const sidebarExists = sidebar || sidebarComponent;
    if (!sidebarExists) return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iHpLz.Fragment), {});
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $dmsNZ.default), {
        item: true,
        md: 3,
        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $fvnvn.default), {
            items: sidebar,
            sidebarComponent: sidebarComponent
        })
    });
};
var $af322d52a20efd7b$export$2e2bcd8739ae039 = $af322d52a20efd7b$var$SidebarContainer;

});
parcelRegister("fvnvn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3482c868a1b67a9$export$2e2bcd8739ae039; });

var $iHpLz = parcelRequire("iHpLz");
parcelRequire("7hhBq");

var $bSbhr = parcelRequire("bSbhr");
// items hold value and label.
const $c3482c868a1b67a9$var$Sidebar = ({ items: items, sidebarComponent: sidebarComponent })=>{
    return /*#__PURE__*/ (0, $iHpLz.jsxs)("div", {
        style: {
            backgroundColor: 'white',
            top: '40px'
        },
        children: [
            sidebarComponent,
            /*#__PURE__*/ (0, $iHpLz.jsx)((0, $bSbhr.default), {
                items: items
            })
        ]
    });
};
var $c3482c868a1b67a9$export$2e2bcd8739ae039 = $c3482c868a1b67a9$var$Sidebar;

});
parcelRegister("bSbhr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd7d3b81e10ce5d7$export$2e2bcd8739ae039; });

var $iHpLz = parcelRequire("iHpLz");

var $1fpj1 = parcelRequire("1fpj1");

var $7hhBq = parcelRequire("7hhBq");

var $aw1H1 = parcelRequire("aw1H1");

var $8kTst = parcelRequire("8kTst");
const $cd7d3b81e10ce5d7$var$SidebarList = ({ items: items })=>{
    const [activeSideItem, setActiveSideItem] = (0, $7hhBq.useState)(0);
    const navigate = (0, $aw1H1.useNavigate)();
    const location = (0, $aw1H1.useLocation)();
    (0, $7hhBq.useEffect)(()=>{
        if (!items) return;
        Object.values(items).forEach((value, index)=>{
            if (location === null || location === void 0 ? void 0 : location.pathname.includes(value)) setActiveSideItem(index);
        });
    }, [
        location,
        location === null || location === void 0 ? void 0 : location.pathname,
        items
    ]);
    if (!items) return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iHpLz.Fragment), {});
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $1fpj1.default), {
        dense: true,
        className: "list",
        children: Object.keys(items).map((key, i)=>/*#__PURE__*/ (0, $iHpLz.jsx)((0, $8kTst.default), {
                id: i,
                name: key,
                active: activeSideItem,
                onClick: ()=>{
                    setActiveSideItem(i);
                    navigate(items[key]);
                }
            }, `sidebar-item-${key}`))
    });
};
var $cd7d3b81e10ce5d7$export$2e2bcd8739ae039 = $cd7d3b81e10ce5d7$var$SidebarList;

});
parcelRegister("1fpj1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e8ad258fa0384b9$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");

var $eET99 = parcelRequire("eET99");

var $18TeW = parcelRequire("18TeW");

var $4ZZLe = parcelRequire("4ZZLe");

var $ghvvy = parcelRequire("ghvvy");

var $allRi = parcelRequire("allRi");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $0e8ad258fa0384b9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $eET99.default)(slots, (0, $allRi.getListUtilityClass), classes);
};
const $0e8ad258fa0384b9$var$ListRoot = (0, $18TeW.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $0e8ad258fa0384b9$var$List = /*#__PURE__*/ $7hhBq.forwardRef(function List(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $6pkKu._)(props, [
        "children",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    const context = $7hhBq.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $0e8ad258fa0384b9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $ghvvy.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $iHpLz.jsxs)($0e8ad258fa0384b9$var$ListRoot, (0, $cNnl8._)((0, $dok7x._)({
            as: component,
            className: (0, $5vmbh.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other), {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $0e8ad258fa0384b9$export$2e2bcd8739ae039 = $0e8ad258fa0384b9$var$List;

});
parcelRegister("ghvvy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bda6acb47b7a61bb$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
'use client';
/**
 * @ignore - internal component.
 */ const $bda6acb47b7a61bb$var$ListContext = /*#__PURE__*/ $7hhBq.createContext({});
var $bda6acb47b7a61bb$export$2e2bcd8739ae039 = $bda6acb47b7a61bb$var$ListContext;

});

parcelRegister("allRi", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", function () { return $787cd235b0e68496$export$c6bd6795ed6e3203; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $787cd235b0e68496$export$c6bd6795ed6e3203(slot) {
    return (0, $200uu.default)('MuiList', slot);
}
const $787cd235b0e68496$var$listClasses = (0, $5blE7.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $787cd235b0e68496$export$2e2bcd8739ae039 = $787cd235b0e68496$var$listClasses;

});


parcelRegister("8kTst", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40f250fb0d9063cb$export$2e2bcd8739ae039; });

var $iHpLz = parcelRequire("iHpLz");

var $aOBHk = parcelRequire("aOBHk");
parcelRequire("7hhBq");

var $18TeW = parcelRequire("18TeW");

var $b5Oyq = parcelRequire("b5Oyq");
const $40f250fb0d9063cb$var$StyledListItem = (0, $18TeW.default)((0, $aOBHk.default), {
    shouldForwardProp: (prop)=>prop !== 'active'
})(({ theme: theme, active: active })=>({
        width: '100%',
        height: '48px',
        padding: '12px 16px',
        lineHeight: '24px',
        color: active ? `${theme.palette.primary.main}${theme.palette.other.opacityHigh}` : `${theme.palette.surface.text}${theme.palette.other.opacityHigh}`,
        transition: 'background-color 0.1s',
        borderRadius: '4px',
        cursor: !active ? 'pointer' : undefined,
        backgroundColor: active ? `${theme.palette.primary.main}30` : undefined,
        '&:hover': {
            backgroundColor: !active ? `${theme.palette.primary.main}10` : undefined
        }
    }));
/* 
  Combines two classes if active, else only show root class 
*/ const $40f250fb0d9063cb$var$SidebarItem = ({ name: name, id: id, active: active, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $iHpLz.jsx)($40f250fb0d9063cb$var$StyledListItem, {
        active: id === active,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $b5Oyq.default), {
            variant: "body1",
            children: name
        })
    });
};
var $40f250fb0d9063cb$export$2e2bcd8739ae039 = $40f250fb0d9063cb$var$SidebarItem;

});
parcelRegister("aOBHk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7dfbd0e9bcee50b4$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");

var $eET99 = parcelRequire("eET99");



var $38OMK = parcelRequire("38OMK");

var $18TeW = parcelRequire("18TeW");

var $1zv4u = parcelRequire("1zv4u");

var $4ZZLe = parcelRequire("4ZZLe");

var $92Odh = parcelRequire("92Odh");

var $drmCR = parcelRequire("drmCR");

var $ghvvy = parcelRequire("ghvvy");

var $c4Ccb = parcelRequire("c4Ccb");

var $FG59X = parcelRequire("FG59X");

var $cvqb7 = parcelRequire("cvqb7");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $7dfbd0e9bcee50b4$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $7dfbd0e9bcee50b4$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, $eET99.default)(slots, (0, $c4Ccb.getListItemUtilityClass), classes);
};
const $7dfbd0e9bcee50b4$export$aed538f7519abe89 = (0, $18TeW.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $7dfbd0e9bcee50b4$export$4334bb34c76fef24
})((0, $1zv4u.default)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $FG59X.default).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $7dfbd0e9bcee50b4$var$ListItemContainer = (0, $18TeW.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $7dfbd0e9bcee50b4$var$ListItem = /*#__PURE__*/ $7hhBq.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $6pkKu._)(props.ContainerProps, [
        "className"
    ]), other = (0, $6pkKu._)(props, [
        "alignItems",
        "children",
        "className",
        "component",
        "components",
        "componentsProps",
        "ContainerComponent",
        "ContainerProps",
        "dense",
        "disableGutters",
        "disablePadding",
        "divider",
        "secondaryAction",
        "slotProps",
        "slots"
    ]);
    const context = $7hhBq.useContext((0, $ghvvy.default));
    const childContext = $7hhBq.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $7hhBq.useRef(null);
    const children = $7hhBq.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in v7
    const hasSecondaryAction = children.length && (0, $92Odh.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    });
    const classes = $7dfbd0e9bcee50b4$var$useUtilityClasses(ownerState);
    const handleRef = (0, $drmCR.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $7dfbd0e9bcee50b4$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $dok7x._)({
        className: (0, $5vmbh.default)(classes.root, rootProps.className, className)
    }, other);
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in v7
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $ghvvy.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $iHpLz.jsxs)($7dfbd0e9bcee50b4$var$ListItemContainer, (0, $cNnl8._)((0, $dok7x._)({
                as: ContainerComponent,
                className: (0, $5vmbh.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps), {
                children: [
                    /*#__PURE__*/ (0, $iHpLz.jsx)(Root, (0, $cNnl8._)((0, $dok7x._)({}, rootProps, !(0, $38OMK.default)(Root) && {
                        as: Component,
                        ownerState: (0, $dok7x._)({}, ownerState, rootProps.ownerState)
                    }, componentProps), {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $ghvvy.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $iHpLz.jsxs)(Root, (0, $cNnl8._)((0, $dok7x._)((0, $cNnl8._)((0, $dok7x._)({}, rootProps), {
            as: Component,
            ref: handleRef
        }), !(0, $38OMK.default)(Root) && {
            ownerState: (0, $dok7x._)({}, ownerState, rootProps.ownerState)
        }, componentProps), {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $iHpLz.jsx)((0, $cvqb7.default), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $7dfbd0e9bcee50b4$export$2e2bcd8739ae039 = $7dfbd0e9bcee50b4$var$ListItem;

});
parcelRegister("38OMK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $249983585e1013bd$export$2e2bcd8739ae039; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $249983585e1013bd$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $249983585e1013bd$export$2e2bcd8739ae039 = $249983585e1013bd$var$isHostComponent;

});

parcelRegister("92Odh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $695b4042148e2c8f$export$2e2bcd8739ae039; });

var $4SNIT = parcelRequire("4SNIT");
var $695b4042148e2c8f$export$2e2bcd8739ae039 = (0, $4SNIT.default);

});
parcelRegister("4SNIT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38e2c68d5db3a6d1$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
function $38e2c68d5db3a6d1$export$2e2bcd8739ae039(element, muiNames) {
    var _element_type__payload_value, _element_type__payload, _element_type;
    var // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    _element_type_muiName;
    return /*#__PURE__*/ $7hhBq.isValidElement(element) && muiNames.indexOf((_element_type_muiName = element.type.muiName) !== null && _element_type_muiName !== void 0 ? _element_type_muiName : (_element_type = element.type) === null || _element_type === void 0 ? void 0 : (_element_type__payload = _element_type._payload) === null || _element_type__payload === void 0 ? void 0 : (_element_type__payload_value = _element_type__payload.value) === null || _element_type__payload_value === void 0 ? void 0 : _element_type__payload_value.muiName) !== -1;
}

});


parcelRegister("drmCR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c8f58fde733260b$export$2e2bcd8739ae039; });

var $8bPXz = parcelRequire("8bPXz");
'use client';
var $9c8f58fde733260b$export$2e2bcd8739ae039 = (0, $8bPXz.default);

});
parcelRegister("8bPXz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f67a7f867df326d$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
'use client';
function $5f67a7f867df326d$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $7hhBq.useRef(undefined);
    const refEffect = $7hhBq.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup === null || refCleanup === void 0 ? void 0 : refCleanup());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $7hhBq.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});


parcelRegister("c4Ccb", function(module, exports) {

$parcel$export(module.exports, "getListItemUtilityClass", function () { return $8ca37c9c2a502d05$export$5682c366c0c669d9; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $8ca37c9c2a502d05$export$5682c366c0c669d9(slot) {
    return (0, $200uu.default)('MuiListItem', slot);
}
const $8ca37c9c2a502d05$var$listItemClasses = (0, $5blE7.default)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $8ca37c9c2a502d05$export$2e2bcd8739ae039 = $8ca37c9c2a502d05$var$listItemClasses;

});

parcelRegister("FG59X", function(module, exports) {

$parcel$export(module.exports, "getListItemButtonUtilityClass", function () { return $07d4791a213c8fff$export$c09531d8563c67a5; });
$parcel$export(module.exports, "default", function () { return $07d4791a213c8fff$export$2e2bcd8739ae039; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $07d4791a213c8fff$export$c09531d8563c67a5(slot) {
    return (0, $200uu.default)('MuiListItemButton', slot);
}
const $07d4791a213c8fff$var$listItemButtonClasses = (0, $5blE7.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $07d4791a213c8fff$export$2e2bcd8739ae039 = $07d4791a213c8fff$var$listItemButtonClasses;

});

parcelRegister("cvqb7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91acafbf243132c3$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");

var $eET99 = parcelRequire("eET99");

var $18TeW = parcelRequire("18TeW");

var $4ZZLe = parcelRequire("4ZZLe");

var $ghvvy = parcelRequire("ghvvy");

var $i8rtd = parcelRequire("i8rtd");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $91acafbf243132c3$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $eET99.default)(slots, (0, $i8rtd.getListItemSecondaryActionClassesUtilityClass), classes);
};
const $91acafbf243132c3$var$ListItemSecondaryActionRoot = (0, $18TeW.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $91acafbf243132c3$var$ListItemSecondaryAction = /*#__PURE__*/ $7hhBq.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $6pkKu._)(props, [
        "className"
    ]);
    const context = $7hhBq.useContext((0, $ghvvy.default));
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        disableGutters: context.disableGutters
    });
    const classes = $91acafbf243132c3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iHpLz.jsx)($91acafbf243132c3$var$ListItemSecondaryActionRoot, (0, $dok7x._)({
        className: (0, $5vmbh.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$91acafbf243132c3$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $91acafbf243132c3$export$2e2bcd8739ae039 = $91acafbf243132c3$var$ListItemSecondaryAction;

});
parcelRegister("i8rtd", function(module, exports) {

$parcel$export(module.exports, "getListItemSecondaryActionClassesUtilityClass", function () { return $d33e485b7b673c76$export$ccdb26aeba48a86e; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $d33e485b7b673c76$export$ccdb26aeba48a86e(slot) {
    return (0, $200uu.default)('MuiListItemSecondaryAction', slot);
}
const $d33e485b7b673c76$var$listItemSecondaryActionClasses = (0, $5blE7.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $d33e485b7b673c76$export$2e2bcd8739ae039 = $d33e485b7b673c76$var$listItemSecondaryActionClasses;

});







parcelRegister("c2CkC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dff2690c898b587$export$2e2bcd8739ae039; });

var $kloRn = parcelRequire("kloRn");

var $h3hKu = parcelRequire("h3hKu");
const $5dff2690c898b587$var$useIsMobile = (breakpoint = 'md')=>{
    const theme = (0, $h3hKu.default)();
    const isMobile = (0, $kloRn.default)(theme.breakpoints.down(breakpoint));
    return isMobile;
};
var $5dff2690c898b587$export$2e2bcd8739ae039 = $5dff2690c898b587$var$useIsMobile;

});
parcelRegister("kloRn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecf90d739400f5fc$export$2e2bcd8739ae039; });

var $cr4M3 = parcelRequire("cr4M3");

var $9D8Xe = parcelRequire("9D8Xe");
const $ecf90d739400f5fc$var$useMediaQuery = (0, $cr4M3.unstable_createUseMediaQuery)({
    themeId: (0, $9D8Xe.default)
});
var $ecf90d739400f5fc$export$2e2bcd8739ae039 = $ecf90d739400f5fc$var$useMediaQuery;

});
parcelRegister("cr4M3", function(module, exports) {

$parcel$export(module.exports, "unstable_createUseMediaQuery", function () { return $90dbb5b27a29fe38$export$96d7927a982220b5; });

var $dok7x = parcelRequire("dok7x");

var $7hhBq = parcelRequire("7hhBq");

var $bWfnw = parcelRequire("bWfnw");

var $413zA = parcelRequire("413zA");

var $7cBTh = parcelRequire("7cBTh");
'use client';
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $90dbb5b27a29fe38$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $7hhBq.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $bWfnw.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $90dbb5b27a29fe38$var$safeReact = (0, $dok7x._)({}, $7hhBq);
const $90dbb5b27a29fe38$var$maybeReactUseSyncExternalStore = $90dbb5b27a29fe38$var$safeReact.useSyncExternalStore;
function $90dbb5b27a29fe38$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $7hhBq.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $7hhBq.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $7hhBq.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $90dbb5b27a29fe38$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $90dbb5b27a29fe38$export$96d7927a982220b5(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $7cBTh.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $413zA.default)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $90dbb5b27a29fe38$var$maybeReactUseSyncExternalStore !== undefined ? $90dbb5b27a29fe38$var$useMediaQueryNew : $90dbb5b27a29fe38$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $90dbb5b27a29fe38$var$useMediaQuery = $90dbb5b27a29fe38$export$96d7927a982220b5();
var $90dbb5b27a29fe38$export$2e2bcd8739ae039 = $90dbb5b27a29fe38$var$useMediaQuery;

});
parcelRegister("413zA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2eca06ee17b1aabc$export$2e2bcd8739ae039; });

var $ks1yv = parcelRequire("ks1yv");
function $2eca06ee17b1aabc$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $ks1yv.default)(theme.components[name].defaultProps, props);
}

});





parcelRegister("5cFwf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d4a59003fb7f5bf$export$2e2bcd8739ae039; });

var $ddi3l = parcelRequire("ddi3l");

var $cqAJz = parcelRequire("cqAJz");

var $8oEKT = parcelRequire("8oEKT");
const $9d4a59003fb7f5bf$var$useFetchImage = (key, logo)=>{
    const projectId = (0, $8oEKT.default)();
    const { data: data, isLoading: isLoading } = (0, $ddi3l.useQuery)((0, $cqAJz.default)(projectId, key));
    if (isLoading || !data) return logo;
    const url = URL.createObjectURL(data);
    return url;
};
var $9d4a59003fb7f5bf$export$2e2bcd8739ae039 = $9d4a59003fb7f5bf$var$useFetchImage;

});
parcelRegister("cqAJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80137abf4188f650$export$2e2bcd8739ae039; });

var $dkNUW = parcelRequire("dkNUW");
const $80137abf4188f650$var$fetchImage = async (pid, key)=>{
    const result = await $dkNUW.requestBlob('GET', `/content-public/${pid}/theme/images?key=${key}`);
    return result.data;
};
const $80137abf4188f650$var$getImage = (pid, key)=>({
        queryKey: [
            'getImage',
            pid,
            key
        ],
        queryFn: ()=>$80137abf4188f650$var$fetchImage(pid, key),
        enabled: !!pid,
        gcTime: 3600000,
        // 1 hour
        retry: 1,
        retryDelay: 20000
    });
var $80137abf4188f650$export$2e2bcd8739ae039 = $80137abf4188f650$var$getImage;

});


parcelRegister("9jigW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c740fe58f7a9962$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");

var $ks1yv = parcelRequire("ks1yv");

var $eET99 = parcelRequire("eET99");

var $cqwHw = parcelRequire("cqwHw");

var $4Jfc1 = parcelRequire("4Jfc1");

var $2fhVh = parcelRequire("2fhVh");

var $18TeW = parcelRequire("18TeW");

var $1zv4u = parcelRequire("1zv4u");

var $4ZZLe = parcelRequire("4ZZLe");

var $bJAa6 = parcelRequire("bJAa6");

var $d0uAT = parcelRequire("d0uAT");

var $bUnnb = parcelRequire("bUnnb");

var $3CtK9 = parcelRequire("3CtK9");

var $jLXvU = parcelRequire("jLXvU");

var $7izvb = parcelRequire("7izvb");

var $1thQV = parcelRequire("1thQV");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $6c740fe58f7a9962$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $bUnnb.default)(color)}`,
            `size${(0, $bUnnb.default)(size)}`,
            `${variant}Size${(0, $bUnnb.default)(size)}`,
            `color${(0, $bUnnb.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $bUnnb.default)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $bUnnb.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $bUnnb.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $eET99.default)(slots, (0, $jLXvU.getButtonUtilityClass), classes);
    return (0, $dok7x._)({}, classes, composedClasses);
};
const $6c740fe58f7a9962$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $6c740fe58f7a9962$var$ButtonRoot = (0, $18TeW.default)((0, $bJAa6.default), {
    shouldForwardProp: (prop)=>(0, $2fhVh.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $bUnnb.default)(ownerState.color)}`],
            styles[`size${(0, $bUnnb.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $bUnnb.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $1zv4u.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $cNnl8._)((0, $dok7x._)({}, theme.typography.button), {
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $jLXvU.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $jLXvU.default).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $jLXvU.default).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $jLXvU.default).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $3CtK9.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $cqwHw.alpha)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cqwHw.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cqwHw.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cqwHw.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cqwHw.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $jLXvU.default).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $jLXvU.default).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $jLXvU.default).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    });
}));
const $6c740fe58f7a9962$var$ButtonStartIcon = (0, $18TeW.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $bUnnb.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$6c740fe58f7a9962$var$commonIconStyles
        ]
    }));
const $6c740fe58f7a9962$var$ButtonEndIcon = (0, $18TeW.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $bUnnb.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$6c740fe58f7a9962$var$commonIconStyles
        ]
    }));
const $6c740fe58f7a9962$var$ButtonLoadingIndicator = (0, $18TeW.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $6c740fe58f7a9962$var$ButtonLoadingIconPlaceholder = (0, $18TeW.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder',
    overridesResolver: (props, styles)=>styles.loadingIconPlaceholder
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $6c740fe58f7a9962$var$Button = /*#__PURE__*/ $7hhBq.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $7hhBq.useContext((0, $7izvb.default));
    const buttonGroupButtonContextPositionClassName = $7hhBq.useContext((0, $1thQV.default));
    const resolvedProps = (0, $ks1yv.default)(contextProps, inProps);
    const props = (0, $4ZZLe.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $6pkKu._)(props, [
        "children",
        "color",
        "component",
        "className",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "id",
        "loading",
        "loadingIndicator",
        "loadingPosition",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    const loadingId = (0, $4Jfc1.default)(idProp);
    const loadingIndicator = loadingIndicatorProp !== null && loadingIndicatorProp !== void 0 ? loadingIndicatorProp : /*#__PURE__*/ (0, $iHpLz.jsx)((0, $d0uAT.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $6c740fe58f7a9962$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $iHpLz.jsx)($6c740fe58f7a9962$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $iHpLz.jsx)($6c740fe58f7a9962$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $iHpLz.jsx)($6c740fe58f7a9962$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $iHpLz.jsx)($6c740fe58f7a9962$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $iHpLz.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $iHpLz.jsx)($6c740fe58f7a9962$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $iHpLz.jsxs)($6c740fe58f7a9962$var$ButtonRoot, (0, $cNnl8._)((0, $dok7x._)({
        ownerState: ownerState,
        className: (0, $5vmbh.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $5vmbh.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp
    }, other), {
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    }));
});
var $6c740fe58f7a9962$export$2e2bcd8739ae039 = $6c740fe58f7a9962$var$Button;

});
parcelRegister("4Jfc1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $371726668be21ee1$export$2e2bcd8739ae039; });

var $l0Krq = parcelRequire("l0Krq");
'use client';
var $371726668be21ee1$export$2e2bcd8739ae039 = (0, $l0Krq.default);

});

parcelRegister("bJAa6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88aff2aa4ff7798d$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");



var $eET99 = parcelRequire("eET99");

var $coN4f = parcelRequire("coN4f");

var $18TeW = parcelRequire("18TeW");

var $4ZZLe = parcelRequire("4ZZLe");

var $drmCR = parcelRequire("drmCR");

var $60H1a = parcelRequire("60H1a");

var $cQttJ = parcelRequire("cQttJ");

var $dlE4d = parcelRequire("dlE4d");

var $AljKa = parcelRequire("AljKa");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $88aff2aa4ff7798d$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $eET99.default)(slots, (0, $AljKa.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $88aff2aa4ff7798d$export$7ec0dcc5e3cdcd36 = (0, $18TeW.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $AljKa.default).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $88aff2aa4ff7798d$var$ButtonBase = /*#__PURE__*/ $7hhBq.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $6pkKu._)(props, [
        "action",
        "centerRipple",
        "children",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "LinkComponent",
        "onBlur",
        "onClick",
        "onContextMenu",
        "onDragLeave",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "tabIndex",
        "TouchRippleProps",
        "touchRippleRef",
        "type"
    ]);
    const buttonRef = $7hhBq.useRef(null);
    const ripple = (0, $cQttJ.default)();
    const handleRippleRef = (0, $drmCR.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $7hhBq.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $7hhBq.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $7hhBq.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $88aff2aa4ff7798d$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $88aff2aa4ff7798d$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $88aff2aa4ff7798d$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $88aff2aa4ff7798d$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $88aff2aa4ff7798d$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $88aff2aa4ff7798d$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $88aff2aa4ff7798d$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $88aff2aa4ff7798d$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $88aff2aa4ff7798d$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $coN4f.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $60H1a.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $coN4f.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $60H1a.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $60H1a.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $drmCR.default)(ref, buttonRef);
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $88aff2aa4ff7798d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iHpLz.jsxs)($88aff2aa4ff7798d$export$7ec0dcc5e3cdcd36, (0, $cNnl8._)((0, $dok7x._)({
        as: ComponentProp,
        className: (0, $5vmbh.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other), {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $iHpLz.jsx)((0, $dlE4d.default), (0, $dok7x._)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
function $88aff2aa4ff7798d$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $60H1a.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $88aff2aa4ff7798d$export$2e2bcd8739ae039 = $88aff2aa4ff7798d$var$ButtonBase;

});
parcelRegister("coN4f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $906dc9b230b1b588$export$2e2bcd8739ae039; });
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $906dc9b230b1b588$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

});

parcelRegister("60H1a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46041c9e192eb16c$export$2e2bcd8739ae039; });

var $3Z3Qo = parcelRequire("3Z3Qo");
'use client';
var $46041c9e192eb16c$export$2e2bcd8739ae039 = (0, $3Z3Qo.default);

});
parcelRegister("3Z3Qo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e6a0ceeed7069cb$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");

var $bWfnw = parcelRequire("bWfnw");
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $2e6a0ceeed7069cb$var$useEventCallback(fn) {
    const ref = $7hhBq.useRef(fn);
    (0, $bWfnw.default)(()=>{
        ref.current = fn;
    });
    return $7hhBq.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $2e6a0ceeed7069cb$export$2e2bcd8739ae039 = $2e6a0ceeed7069cb$var$useEventCallback;

});


parcelRegister("cQttJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95a1352e1b62b24d$export$2e2bcd8739ae039; });

var $faevN = parcelRequire("faevN");

var $7hhBq = parcelRequire("7hhBq");

var $kJcBO = parcelRequire("kJcBO");
'use client';
class $95a1352e1b62b24d$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $95a1352e1b62b24d$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $kJcBO.default)($95a1352e1b62b24d$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $7hhBq.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $7hhBq.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $95a1352e1b62b24d$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    /* Ripple API */ start(...args) {
        this.mount().then(()=>{
            var _this_ref_current;
            return (_this_ref_current = this.ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.start(...args);
        });
    }
    stop(...args) {
        this.mount().then(()=>{
            var _this_ref_current;
            return (_this_ref_current = this.ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.stop(...args);
        });
    }
    pulsate(...args) {
        this.mount().then(()=>{
            var _this_ref_current;
            return (_this_ref_current = this.ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.pulsate(...args);
        });
    }
    constructor(){
        (0, $faevN._)(this, "mountEffect", ()=>{
            if (this.shouldMount && !this.didMount) {
                if (this.ref.current !== null) {
                    this.didMount = true;
                    this.mounted.resolve();
                }
            }
        });
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
}
function $95a1352e1b62b24d$export$2e2bcd8739ae039() {
    return $95a1352e1b62b24d$export$f5de0641c7db4154.use();
}
function $95a1352e1b62b24d$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

});
parcelRegister("kJcBO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f171ca7973ee4d3c$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
'use client';
const $f171ca7973ee4d3c$var$UNINITIALIZED = {};
function $f171ca7973ee4d3c$export$2e2bcd8739ae039(init, initArg) {
    const ref = $7hhBq.useRef($f171ca7973ee4d3c$var$UNINITIALIZED);
    if (ref.current === $f171ca7973ee4d3c$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});


parcelRegister("dlE4d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b7c5105129a7864$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $j37jI = parcelRequire("j37jI");

var $5vmbh = parcelRequire("5vmbh");

var $aZFw5 = parcelRequire("aZFw5");

var $38swY = parcelRequire("38swY");
var $18TeW = parcelRequire("18TeW");

var $4ZZLe = parcelRequire("4ZZLe");

var $l5kbV = parcelRequire("l5kbV");

var $5pM9w = parcelRequire("5pM9w");

var $iHpLz = parcelRequire("iHpLz");
'use client';
let $9b7c5105129a7864$var$_ = (t)=>t, $9b7c5105129a7864$var$t, $9b7c5105129a7864$var$t1, $9b7c5105129a7864$var$t2, $9b7c5105129a7864$var$t3;
const $9b7c5105129a7864$var$DURATION = 550;
const $9b7c5105129a7864$export$95d0c9356b2231a3 = 80;
const $9b7c5105129a7864$var$enterKeyframe = (0, $38swY.keyframes)($9b7c5105129a7864$var$t || ($9b7c5105129a7864$var$t = $9b7c5105129a7864$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $9b7c5105129a7864$var$exitKeyframe = (0, $38swY.keyframes)($9b7c5105129a7864$var$t1 || ($9b7c5105129a7864$var$t1 = $9b7c5105129a7864$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $9b7c5105129a7864$var$pulsateKeyframe = (0, $38swY.keyframes)($9b7c5105129a7864$var$t2 || ($9b7c5105129a7864$var$t2 = $9b7c5105129a7864$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $9b7c5105129a7864$export$f6b7418508c72c25 = (0, $18TeW.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $9b7c5105129a7864$export$676cfe7b12693c4b = (0, $18TeW.default)((0, $l5kbV.default), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($9b7c5105129a7864$var$t3 || ($9b7c5105129a7864$var$t3 = $9b7c5105129a7864$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $5pM9w.default).rippleVisible, $9b7c5105129a7864$var$enterKeyframe, $9b7c5105129a7864$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $5pM9w.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $5pM9w.default).child, (0, $5pM9w.default).childLeaving, $9b7c5105129a7864$var$exitKeyframe, $9b7c5105129a7864$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $5pM9w.default).childPulsate, $9b7c5105129a7864$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $9b7c5105129a7864$var$TouchRipple = /*#__PURE__*/ $7hhBq.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $6pkKu._)(props, [
        "center",
        "classes",
        "className"
    ]);
    const [ripples, setRipples] = $7hhBq.useState([]);
    const nextKey = $7hhBq.useRef(0);
    const rippleCallback = $7hhBq.useRef(null);
    $7hhBq.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $7hhBq.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $aZFw5.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $7hhBq.useRef(null);
    const container = $7hhBq.useRef(null);
    const startCommit = $7hhBq.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $iHpLz.jsx)($9b7c5105129a7864$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $5vmbh.default)(classes.ripple, (0, $5pM9w.default).ripple),
                        rippleVisible: (0, $5vmbh.default)(classes.rippleVisible, (0, $5pM9w.default).rippleVisible),
                        ripplePulsate: (0, $5vmbh.default)(classes.ripplePulsate, (0, $5pM9w.default).ripplePulsate),
                        child: (0, $5vmbh.default)(classes.child, (0, $5pM9w.default).child),
                        childLeaving: (0, $5vmbh.default)(classes.childLeaving, (0, $5pM9w.default).childLeaving),
                        childPulsate: (0, $5vmbh.default)(classes.childPulsate, (0, $5pM9w.default).childPulsate)
                    },
                    timeout: $9b7c5105129a7864$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $7hhBq.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event === null || event === void 0 ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event === null || event === void 0 ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event === null || event === void 0 ? void 0 : event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($9b7c5105129a7864$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $7hhBq.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $7hhBq.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event === null || event === void 0 ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $7hhBq.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $iHpLz.jsx)($9b7c5105129a7864$export$f6b7418508c72c25, (0, $cNnl8._)((0, $dok7x._)({
        className: (0, $5vmbh.default)((0, $5pM9w.default).root, classes.root, className),
        ref: container
    }, other), {
        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $j37jI.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $9b7c5105129a7864$export$2e2bcd8739ae039 = $9b7c5105129a7864$var$TouchRipple;

});
parcelRegister("j37jI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dde3f91f7ae7f2f9$export$2e2bcd8739ae039; });

var $ctw6m = parcelRequire("ctw6m");

var $jamvR = parcelRequire("jamvR");

var $6pEJ7 = parcelRequire("6pEJ7");

var $441XV = parcelRequire("441XV");


var $7hhBq = parcelRequire("7hhBq");

var $rJ5y8 = parcelRequire("rJ5y8");

var $5swRU = parcelRequire("5swRU");
var $dde3f91f7ae7f2f9$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $dde3f91f7ae7f2f9$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $dde3f91f7ae7f2f9$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $441XV.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $6pEJ7.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $5swRU.getInitialChildMapping)(nextProps, handleExited) : (0, $5swRU.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $5swRU.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $jamvR.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $ctw6m.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $dde3f91f7ae7f2f9$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement((0, $rJ5y8.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement((0, $rJ5y8.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).Component);
$dde3f91f7ae7f2f9$var$TransitionGroup.propTypes = {};
$dde3f91f7ae7f2f9$var$TransitionGroup.defaultProps = $dde3f91f7ae7f2f9$var$defaultProps;
var $dde3f91f7ae7f2f9$export$2e2bcd8739ae039 = $dde3f91f7ae7f2f9$var$TransitionGroup;

});
parcelRegister("ctw6m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91511830f9bad934$export$2e2bcd8739ae039; });
function $91511830f9bad934$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("6pEJ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ab4ab5f5ef32b24$export$2e2bcd8739ae039; });
function $4ab4ab5f5ef32b24$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("441XV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f590f72b356c45f$export$2e2bcd8739ae039; });

var $kdAXd = parcelRequire("kdAXd");
function $2f590f72b356c45f$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $kdAXd.default)(t, o);
}

});
parcelRegister("kdAXd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb81afe01e398860$export$2e2bcd8739ae039; });
function $eb81afe01e398860$export$2e2bcd8739ae039(t, e) {
    return $eb81afe01e398860$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $eb81afe01e398860$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("rJ5y8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05357f5ea9e3732b$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
var $05357f5ea9e3732b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createContext(null);

});

parcelRegister("5swRU", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $3f991041101cabb6$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $3f991041101cabb6$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $3f991041101cabb6$export$36fd1af28d383ec0; });

var $7hhBq = parcelRequire("7hhBq");
function $3f991041101cabb6$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7hhBq.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7hhBq.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $3f991041101cabb6$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $3f991041101cabb6$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $3f991041101cabb6$export$fa71e2345c31d7a2(props, onExited) {
    return $3f991041101cabb6$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7hhBq.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $3f991041101cabb6$var$getProp(child, 'appear', props),
            enter: $3f991041101cabb6$var$getProp(child, 'enter', props),
            exit: $3f991041101cabb6$var$getProp(child, 'exit', props)
        });
    });
}
function $3f991041101cabb6$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $3f991041101cabb6$export$bbc8a025727ea824(nextProps.children);
    var children = $3f991041101cabb6$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7hhBq.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7hhBq.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7hhBq.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $3f991041101cabb6$var$getProp(child, 'exit', nextProps),
            enter: $3f991041101cabb6$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7hhBq.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7hhBq.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7hhBq.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $3f991041101cabb6$var$getProp(child, 'exit', nextProps),
            enter: $3f991041101cabb6$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("aZFw5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $800fce310ef2fa15$export$2e2bcd8739ae039; });

var $faevN = parcelRequire("faevN");

var $kJcBO = parcelRequire("kJcBO");

var $atgla = parcelRequire("atgla");
'use client';
class $800fce310ef2fa15$export$786b4da70f00938b {
    static create() {
        return new $800fce310ef2fa15$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    constructor(){
        (0, $faevN._)(this, "currentId", null);
        (0, $faevN._)(this, "clear", ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        });
        (0, $faevN._)(this, "disposeEffect", ()=>{
            return this.clear;
        });
    }
}
function $800fce310ef2fa15$export$2e2bcd8739ae039() {
    const timeout = (0, $kJcBO.default)($800fce310ef2fa15$export$786b4da70f00938b.create).current;
    (0, $atgla.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("atgla", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79f949ab020d3867$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
'use client';
const $79f949ab020d3867$var$EMPTY = [];
function $79f949ab020d3867$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $7hhBq.useEffect(fn, $79f949ab020d3867$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});


parcelRegister("l5kbV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f599ba332e40efa6$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");

var $iHpLz = parcelRequire("iHpLz");
'use client';
function $f599ba332e40efa6$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $7hhBq.useState(false);
    const rippleClassName = (0, $5vmbh.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $5vmbh.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $7hhBq.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $iHpLz.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $iHpLz.jsx)("span", {
            className: childClassName
        })
    });
}
var $f599ba332e40efa6$export$2e2bcd8739ae039 = $f599ba332e40efa6$var$Ripple;

});

parcelRegister("5pM9w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f14a3a9e5f824cb$export$2e2bcd8739ae039; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $3f14a3a9e5f824cb$export$b464606f735ab902(slot) {
    return (0, $200uu.default)('MuiTouchRipple', slot);
}
const $3f14a3a9e5f824cb$var$touchRippleClasses = (0, $5blE7.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $3f14a3a9e5f824cb$export$2e2bcd8739ae039 = $3f14a3a9e5f824cb$var$touchRippleClasses;

});


parcelRegister("AljKa", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $06d3e61bba9c08ef$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $06d3e61bba9c08ef$export$2e2bcd8739ae039; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $06d3e61bba9c08ef$export$fccb0498dcd99783(slot) {
    return (0, $200uu.default)('MuiButtonBase', slot);
}
const $06d3e61bba9c08ef$var$buttonBaseClasses = (0, $5blE7.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $06d3e61bba9c08ef$export$2e2bcd8739ae039 = $06d3e61bba9c08ef$var$buttonBaseClasses;

});


parcelRegister("jLXvU", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", function () { return $e6509245205ddbd8$export$5a6f9035944c8119; });
$parcel$export(module.exports, "default", function () { return $e6509245205ddbd8$export$2e2bcd8739ae039; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $e6509245205ddbd8$export$5a6f9035944c8119(slot) {
    return (0, $200uu.default)('MuiButton', slot);
}
const $e6509245205ddbd8$var$buttonClasses = (0, $5blE7.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $e6509245205ddbd8$export$2e2bcd8739ae039 = $e6509245205ddbd8$var$buttonClasses;

});

parcelRegister("7izvb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5505c0c87c16a024$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
'use client';
/**
 * @ignore - internal component.
 */ const $5505c0c87c16a024$var$ButtonGroupContext = /*#__PURE__*/ $7hhBq.createContext({});
var $5505c0c87c16a024$export$2e2bcd8739ae039 = $5505c0c87c16a024$var$ButtonGroupContext;

});

parcelRegister("1thQV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1126590e4ea63dae$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
'use client';
/**
 * @ignore - internal component.
 */ const $1126590e4ea63dae$var$ButtonGroupButtonContext = /*#__PURE__*/ $7hhBq.createContext(undefined);
var $1126590e4ea63dae$export$2e2bcd8739ae039 = $1126590e4ea63dae$var$ButtonGroupButtonContext;

});


parcelRegister("1HEu7", function(module, exports) {

$parcel$export(module.exports, "Markdown", function () { return $13d9360eb7b89c9b$export$7460c8b7e4ce9582; });
/**
 * @import {Element, Nodes, Parents, Root} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {ComponentType, JSX, ReactElement, ReactNode} from 'react'
 * @import {Options as RemarkRehypeOptions} from 'remark-rehype'
 * @import {BuildVisitor} from 'unist-util-visit'
 * @import {PluggableList, Processor} from 'unified'
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 */ /**
 * @typedef ExtraProps
 *   Extra fields we pass.
 * @property {Element | undefined} [node]
 *   passed when `passNode` is on.
 */ /**
 * @typedef {{
 *   [Key in keyof JSX.IntrinsicElements]?: ComponentType<JSX.IntrinsicElements[Key] & ExtraProps> | keyof JSX.IntrinsicElements
 * }} Components
 *   Map tag names to components.
 */ /**
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 */ /**
 * @typedef HooksOptionsOnly
 *   Configuration specifically for {@linkcode MarkdownHooks}.
 * @property {ReactNode | null | undefined} [fallback]
 *   Content to render while the processor processing the markdown (optional).
 */ /**
 * @typedef {Options & HooksOptionsOnly} HooksOptions
 *   Configuration for {@linkcode MarkdownHooks};
 *   extends the regular {@linkcode Options} with a `fallback` prop.
 */ /**
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ 
var $dok7x = parcelRequire("dok7x");

var $jJcE6 = parcelRequire("jJcE6");

var $2Jhk0 = parcelRequire("2Jhk0");

var $7LXFT = parcelRequire("7LXFT");

var $iHpLz = parcelRequire("iHpLz");

var $7hhBq = parcelRequire("7hhBq");

var $3bfZT = parcelRequire("3bfZT");

var $l9TDx = parcelRequire("l9TDx");

var $bE3WT = parcelRequire("bE3WT");

var $01XIc = parcelRequire("01XIc");

var $744Y4 = parcelRequire("744Y4");
const $13d9360eb7b89c9b$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {PluggableList} */ const $13d9360eb7b89c9b$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ const $13d9360eb7b89c9b$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
const $13d9360eb7b89c9b$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ const $13d9360eb7b89c9b$var$deprecations = [
    {
        from: 'astPlugins',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowDangerousHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowNode',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowElement'
    },
    {
        from: 'allowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowedElements'
    },
    {
        from: 'className',
        id: 'remove-classname'
    },
    {
        from: 'disallowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'disallowedElements'
    },
    {
        from: 'escapeHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'includeElementIndex',
        id: '#remove-includeelementindex'
    },
    {
        from: 'includeNodeIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    },
    {
        from: 'linkTarget',
        id: 'remove-linktarget'
    },
    {
        from: 'plugins',
        id: 'change-plugins-to-remarkplugins',
        to: 'remarkPlugins'
    },
    {
        from: 'rawSourcePos',
        id: '#remove-rawsourcepos'
    },
    {
        from: 'renderers',
        id: 'change-renderers-to-components',
        to: 'components'
    },
    {
        from: 'source',
        id: 'change-source-to-children',
        to: 'children'
    },
    {
        from: 'sourcePos',
        id: '#remove-sourcepos'
    },
    {
        from: 'transformImageUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    },
    {
        from: 'transformLinkUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    }
];
function $13d9360eb7b89c9b$export$7460c8b7e4ce9582(options) {
    const processor = $13d9360eb7b89c9b$var$createProcessor(options);
    const file = $13d9360eb7b89c9b$var$createFile(options);
    return $13d9360eb7b89c9b$var$post(processor.runSync(processor.parse(file), file), options);
}
async function $13d9360eb7b89c9b$export$445edbd7f2c65a8c(options) {
    const processor = $13d9360eb7b89c9b$var$createProcessor(options);
    const file = $13d9360eb7b89c9b$var$createFile(options);
    const tree = await processor.run(processor.parse(file), file);
    return $13d9360eb7b89c9b$var$post(tree, options);
}
function $13d9360eb7b89c9b$export$915021c692d253a2(options) {
    const processor = $13d9360eb7b89c9b$var$createProcessor(options);
    const [error, setError] = (0, $7hhBq.useState)(/** @type {Error | undefined} */ undefined);
    const [tree, setTree] = (0, $7hhBq.useState)(/** @type {Root | undefined} */ undefined);
    (0, $7hhBq.useEffect)(function() {
        let cancelled = false;
        const file = $13d9360eb7b89c9b$var$createFile(options);
        processor.run(processor.parse(file), file, function(error, tree) {
            if (!cancelled) {
                setError(error);
                setTree(tree);
            }
        });
        /**
       * @returns {undefined}
       *   Nothing.
       */ return function() {
            cancelled = true;
        };
    }, [
        options.children,
        options.rehypePlugins,
        options.remarkPlugins,
        options.remarkRehypeOptions
    ]);
    if (error) throw error;
    return tree ? $13d9360eb7b89c9b$var$post(tree, options) : options.fallback;
}
/**
 * Set up the `unified` processor.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {Processor<MdastRoot, MdastRoot, Root, undefined, undefined>}
 *   Result.
 */ function $13d9360eb7b89c9b$var$createProcessor(options) {
    const rehypePlugins = options.rehypePlugins || $13d9360eb7b89c9b$var$emptyPlugins;
    const remarkPlugins = options.remarkPlugins || $13d9360eb7b89c9b$var$emptyPlugins;
    const remarkRehypeOptions = options.remarkRehypeOptions ? (0, $dok7x._)({}, options.remarkRehypeOptions, $13d9360eb7b89c9b$var$emptyRemarkRehypeOptions) : $13d9360eb7b89c9b$var$emptyRemarkRehypeOptions;
    const processor = (0, $bE3WT.unified)().use((0, $3bfZT.default)).use(remarkPlugins).use((0, $l9TDx.default), remarkRehypeOptions).use(rehypePlugins);
    return processor;
}
/**
 * Set up the virtual file.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {VFile}
 *   Result.
 */ function $13d9360eb7b89c9b$var$createFile(options) {
    const children = options.children || '';
    const file = new (0, $744Y4.VFile)();
    if (typeof children === 'string') file.value = children;
    else (0, $jJcE6.unreachable)('Unexpected value `' + children + '` for `children` prop, expected `string`');
    return file;
}
/**
 * Process the result from unified some more.
 *
 * @param {Nodes} tree
 *   Tree.
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {ReactElement}
 *   React element.
 */ function $13d9360eb7b89c9b$var$post(tree, options) {
    const allowedElements = options.allowedElements;
    const allowElement = options.allowElement;
    const components = options.components;
    const disallowedElements = options.disallowedElements;
    const skipHtml = options.skipHtml;
    const unwrapDisallowed = options.unwrapDisallowed;
    const urlTransform = options.urlTransform || $13d9360eb7b89c9b$export$ca5e94754123e2f3;
    for (const deprecation of $13d9360eb7b89c9b$var$deprecations)if (Object.hasOwn(options, deprecation.from)) (0, $jJcE6.unreachable)('Unexpected `' + deprecation.from + '` prop, ' + (deprecation.to ? 'use `' + deprecation.to + '` instead' : 'remove it') + ' (see <' + $13d9360eb7b89c9b$var$changelog + '#' + deprecation.id + '> for more info)');
    if (allowedElements && disallowedElements) (0, $jJcE6.unreachable)('Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other');
    (0, $01XIc.visit)(tree, transform);
    return (0, $2Jhk0.toJsxRuntime)(tree, {
        Fragment: $iHpLz.Fragment,
        components: components,
        ignoreInvalidStyle: true,
        jsx: $iHpLz.jsx,
        jsxs: $iHpLz.jsxs,
        passKeys: true,
        passNode: true
    });
    /** @type {BuildVisitor<Root>} */ function transform(node, index, parent) {
        if (node.type === 'raw' && parent && typeof index === 'number') {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: 'text',
                value: node.value
            };
            return index;
        }
        if (node.type === 'element') {
            /** @type {string} */ let key;
            for(key in 0, $7LXFT.urlAttributes)if (Object.hasOwn((0, $7LXFT.urlAttributes), key) && Object.hasOwn(node.properties, key)) {
                const value = node.properties[key];
                const test = (0, $7LXFT.urlAttributes)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ''), key, node);
            }
        }
        if (node.type === 'element') {
            let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === 'number') remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === 'number') {
                if (unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $13d9360eb7b89c9b$export$ca5e94754123e2f3(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash !== -1 && colon > slash || questionMark !== -1 && colon > questionMark || numberSign !== -1 && colon > numberSign || // It is a protocol, it should be allowed.
    $13d9360eb7b89c9b$var$safeProtocol.test(value.slice(0, colon))) return value;
    return '';
}

});
parcelRegister("jJcE6", function(module, exports) {

$parcel$export(module.exports, "ok", function () { return $e5cc077f9a49166b$export$dcb8b3f0e2de7e49; });
$parcel$export(module.exports, "unreachable", function () { return $e5cc077f9a49166b$export$565e9d9bd6b6e0d4; });
function $e5cc077f9a49166b$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $e5cc077f9a49166b$export$411ce8e5a71e3069() {}
function $e5cc077f9a49166b$export$dcb8b3f0e2de7e49() {}
function $e5cc077f9a49166b$export$565e9d9bd6b6e0d4() {}

});

parcelRegister("2Jhk0", function(module, exports) {

$parcel$export(module.exports, "toJsxRuntime", function () { return $1fcd387c9e14169e$export$59c10052b2dee561; });
/**
 * @import {Identifier, Literal, MemberExpression} from 'estree'
 * @import {Jsx, JsxDev, Options, Props} from 'hast-util-to-jsx-runtime'
 * @import {Element, Nodes, Parents, Root, Text} from 'hast'
 * @import {MdxFlowExpressionHast, MdxTextExpressionHast} from 'mdast-util-mdx-expression'
 * @import {MdxJsxFlowElementHast, MdxJsxTextElementHast} from 'mdast-util-mdx-jsx'
 * @import {MdxjsEsmHast} from 'mdast-util-mdxjs-esm'
 * @import {Position} from 'unist'
 * @import {Child, Create, Field, JsxElement, State, Style} from './types.js'
 */ 
var $ksHxf = parcelRequire("ksHxf");

var $jJcE6 = parcelRequire("jJcE6");

var $3qc69 = parcelRequire("3qc69");

var $7CJ3n = parcelRequire("7CJ3n");

var $izzbJ = parcelRequire("izzbJ");
var $TxzkS = parcelRequire("TxzkS");
var $kqAz9 = parcelRequire("kqAz9");

var $5ktT3 = parcelRequire("5ktT3");

var $3RaSV = parcelRequire("3RaSV");

var $i4y4M = parcelRequire("i4y4M");

var $1knXa = parcelRequire("1knXa");
// To do: next major: `Object.hasOwn`.
const $1fcd387c9e14169e$var$own = {}.hasOwnProperty;
/** @type {Map<string, number>} */ const $1fcd387c9e14169e$var$emptyMap = new Map();
const $1fcd387c9e14169e$var$cap = /[A-Z]/g;
// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.
// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const $1fcd387c9e14169e$var$tableElements = new Set([
    'table',
    'tbody',
    'thead',
    'tfoot',
    'tr'
]);
const $1fcd387c9e14169e$var$tableCellElement = new Set([
    'td',
    'th'
]);
const $1fcd387c9e14169e$var$docs = 'https://github.com/syntax-tree/hast-util-to-jsx-runtime';
function $1fcd387c9e14169e$export$59c10052b2dee561(tree, options) {
    if (!options || options.Fragment === undefined) throw new TypeError('Expected `Fragment` in options');
    const filePath = options.filePath || undefined;
    /** @type {Create} */ let create;
    if (options.development) {
        if (typeof options.jsxDEV !== 'function') throw new TypeError('Expected `jsxDEV` in options when `development: true`');
        create = $1fcd387c9e14169e$var$developmentCreate(filePath, options.jsxDEV);
    } else {
        if (typeof options.jsx !== 'function') throw new TypeError('Expected `jsx` in production options');
        if (typeof options.jsxs !== 'function') throw new TypeError('Expected `jsxs` in production options');
        create = $1fcd387c9e14169e$var$productionCreate(filePath, options.jsx, options.jsxs);
    }
    /** @type {State} */ const state = {
        Fragment: options.Fragment,
        ancestors: [],
        components: options.components || {},
        create: create,
        elementAttributeNameCase: options.elementAttributeNameCase || 'react',
        evaluater: options.createEvaluater ? options.createEvaluater() : undefined,
        filePath: filePath,
        ignoreInvalidStyle: options.ignoreInvalidStyle || false,
        passKeys: options.passKeys !== false,
        passNode: options.passNode || false,
        schema: options.space === 'svg' ? (0, $kqAz9.svg) : (0, $kqAz9.html),
        stylePropertyNameCase: options.stylePropertyNameCase || 'dom',
        tableCellAlignToStyle: options.tableCellAlignToStyle !== false
    };
    const result = $1fcd387c9e14169e$var$one(state, tree, undefined);
    // JSX element.
    if (result && typeof result !== 'string') return result;
    // Text node or something that turned into nothing.
    return state.create(tree, state.Fragment, {
        children: result || undefined
    }, undefined);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $1fcd387c9e14169e$var$one(state, node, key) {
    if (node.type === 'element') return $1fcd387c9e14169e$var$element(state, node, key);
    if (node.type === 'mdxFlowExpression' || node.type === 'mdxTextExpression') return $1fcd387c9e14169e$var$mdxExpression(state, node);
    if (node.type === 'mdxJsxFlowElement' || node.type === 'mdxJsxTextElement') return $1fcd387c9e14169e$var$mdxJsxElement(state, node, key);
    if (node.type === 'mdxjsEsm') return $1fcd387c9e14169e$var$mdxEsm(state, node);
    if (node.type === 'root') return $1fcd387c9e14169e$var$root(state, node, key);
    if (node.type === 'text') return $1fcd387c9e14169e$var$text(state, node);
}
/**
 * Handle element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $1fcd387c9e14169e$var$element(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') {
        schema = (0, $kqAz9.svg);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = $1fcd387c9e14169e$var$findComponentFromName(state, node.tagName, false);
    const props = $1fcd387c9e14169e$var$createElementProps(state, node);
    let children = $1fcd387c9e14169e$var$createChildren(state, node);
    if ($1fcd387c9e14169e$var$tableElements.has(node.tagName)) children = children.filter(function(child) {
        return typeof child === 'string' ? !(0, $7CJ3n.whitespace)(child) : true;
    });
    $1fcd387c9e14169e$var$addNode(state, props, type, node);
    $1fcd387c9e14169e$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle MDX expression.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxFlowExpressionHast | MdxTextExpressionHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $1fcd387c9e14169e$var$mdxExpression(state, node) {
    if (node.data && node.data.estree && state.evaluater) {
        const program = node.data.estree;
        const expression = program.body[0];
        (0, $jJcE6.ok)(expression.type === 'ExpressionStatement');
        // Assume result is a child.
        return /** @type {Child | undefined} */ state.evaluater.evaluateExpression(expression.expression);
    }
    $1fcd387c9e14169e$var$crashEstree(state, node.position);
}
/**
 * Handle MDX ESM.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxjsEsmHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $1fcd387c9e14169e$var$mdxEsm(state, node) {
    if (node.data && node.data.estree && state.evaluater) // Assume result is a child.
    return /** @type {Child | undefined} */ state.evaluater.evaluateProgram(node.data.estree);
    $1fcd387c9e14169e$var$crashEstree(state, node.position);
}
/**
 * Handle MDX JSX.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $1fcd387c9e14169e$var$mdxJsxElement(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.name === 'svg' && parentSchema.space === 'html') {
        schema = (0, $kqAz9.svg);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = node.name === null ? state.Fragment : $1fcd387c9e14169e$var$findComponentFromName(state, node.name, true);
    const props = $1fcd387c9e14169e$var$createJsxElementProps(state, node);
    const children = $1fcd387c9e14169e$var$createChildren(state, node);
    $1fcd387c9e14169e$var$addNode(state, props, type, node);
    $1fcd387c9e14169e$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Root} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $1fcd387c9e14169e$var$root(state, node, key) {
    /** @type {Props} */ const props = {};
    $1fcd387c9e14169e$var$addChildren(props, $1fcd387c9e14169e$var$createChildren(state, node));
    return state.create(node, state.Fragment, props, key);
}
/**
 * Handle text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Text} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $1fcd387c9e14169e$var$text(_, node) {
    return node.value;
}
/**
 * Add `node` to props.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Props} props
 *   Props.
 * @param {unknown} type
 *   Type.
 * @param {Element | MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Node.
 * @returns {undefined}
 *   Nothing.
 */ function $1fcd387c9e14169e$var$addNode(state, props, type, node) {
    // If this is swapped out for a component:
    if (typeof type !== 'string' && type !== state.Fragment && state.passNode) props.node = node;
}
/**
 * Add children to props.
 *
 * @param {Props} props
 *   Props.
 * @param {Array<Child>} children
 *   Children.
 * @returns {undefined}
 *   Nothing.
 */ function $1fcd387c9e14169e$var$addChildren(props, children) {
    if (children.length > 0) {
        const value = children.length > 1 ? children : children[0];
        if (value) props.children = value;
    }
}
/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */ function $1fcd387c9e14169e$var$productionCreate(_, jsx, jsxs) {
    return create;
    /** @type {Create} */ function create(_, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const fn = isStaticChildren ? jsxs : jsx;
        return key ? fn(type, props, key) : fn(type, props);
    }
}
/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */ function $1fcd387c9e14169e$var$developmentCreate(filePath, jsxDEV) {
    return create;
    /** @type {Create} */ function create(node, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const point = (0, $i4y4M.pointStart)(node);
        return jsxDEV(type, props, key, isStaticChildren, {
            columnNumber: point ? point.column - 1 : undefined,
            fileName: filePath,
            lineNumber: point ? point.line : undefined
        }, undefined);
    }
}
/**
 * Create props from an element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current element.
 * @returns {Props}
 *   Props.
 */ function $1fcd387c9e14169e$var$createElementProps(state, node) {
    /** @type {Props} */ const props = {};
    /** @type {string | undefined} */ let alignValue;
    /** @type {string} */ let prop;
    for(prop in node.properties)if (prop !== 'children' && $1fcd387c9e14169e$var$own.call(node.properties, prop)) {
        const result = $1fcd387c9e14169e$var$createProperty(state, prop, node.properties[prop]);
        if (result) {
            const [key, value] = result;
            if (state.tableCellAlignToStyle && key === 'align' && typeof value === 'string' && $1fcd387c9e14169e$var$tableCellElement.has(node.tagName)) alignValue = value;
            else props[key] = value;
        }
    }
    if (alignValue) {
        // Assume style is an object.
        const style = /** @type {Style} */ props.style || (props.style = {});
        style[state.stylePropertyNameCase === 'css' ? 'text-align' : 'textAlign'] = alignValue;
    }
    return props;
}
/**
 * Create props from a JSX element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current JSX element.
 * @returns {Props}
 *   Props.
 */ function $1fcd387c9e14169e$var$createJsxElementProps(state, node) {
    /** @type {Props} */ const props = {};
    for (const attribute of node.attributes)if (attribute.type === 'mdxJsxExpressionAttribute') {
        if (attribute.data && attribute.data.estree && state.evaluater) {
            const program = attribute.data.estree;
            const expression = program.body[0];
            (0, $jJcE6.ok)(expression.type === 'ExpressionStatement');
            const objectExpression = expression.expression;
            (0, $jJcE6.ok)(objectExpression.type === 'ObjectExpression');
            const property = objectExpression.properties[0];
            (0, $jJcE6.ok)(property.type === 'SpreadElement');
            Object.assign(props, state.evaluater.evaluateExpression(property.argument));
        } else $1fcd387c9e14169e$var$crashEstree(state, node.position);
    } else {
        // For JSX, the author is responsible of passing in the correct values.
        const name = attribute.name;
        /** @type {unknown} */ let value;
        if (attribute.value && typeof attribute.value === 'object') {
            if (attribute.value.data && attribute.value.data.estree && state.evaluater) {
                const program = attribute.value.data.estree;
                const expression = program.body[0];
                (0, $jJcE6.ok)(expression.type === 'ExpressionStatement');
                value = state.evaluater.evaluateExpression(expression.expression);
            } else $1fcd387c9e14169e$var$crashEstree(state, node.position);
        } else value = attribute.value === null ? true : attribute.value;
        // Assume a prop.
        props[name] = /** @type {Props[keyof Props]} */ value;
    }
    return props;
}
/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */ function $1fcd387c9e14169e$var$createChildren(state, node) {
    /** @type {Array<Child>} */ const children = [];
    let index = -1;
    /** @type {Map<string, number>} */ // Note: test this when Solid doesn’t want to merge my upcoming PR.
    /* c8 ignore next */ const countsByName = state.passKeys ? new Map() : $1fcd387c9e14169e$var$emptyMap;
    while(++index < node.children.length){
        const child = node.children[index];
        /** @type {string | undefined} */ let key;
        if (state.passKeys) {
            const name = child.type === 'element' ? child.tagName : child.type === 'mdxJsxFlowElement' || child.type === 'mdxJsxTextElement' ? child.name : undefined;
            if (name) {
                const count = countsByName.get(name) || 0;
                key = name + '-' + count;
                countsByName.set(name, count + 1);
            }
        }
        const result = $1fcd387c9e14169e$var$one(state, child, key);
        if (result !== undefined) children.push(result);
    }
    return children;
}
/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */ function $1fcd387c9e14169e$var$createProperty(state, prop, value) {
    const info = (0, $izzbJ.find)(state.schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === null || value === undefined || typeof value === 'number' && Number.isNaN(value)) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $ksHxf.stringify)(value) : (0, $5ktT3.stringify)(value);
    // React only accepts `style` as object.
    if (info.property === 'style') {
        let styleObject = typeof value === 'object' ? value : $1fcd387c9e14169e$var$parseStyle(state, String(value));
        if (state.stylePropertyNameCase === 'css') styleObject = $1fcd387c9e14169e$var$transformStylesToCssCasing(styleObject);
        return [
            'style',
            styleObject
        ];
    }
    return [
        state.elementAttributeNameCase === 'react' && info.space ? (0, $TxzkS.hastToReact)[info.property] || info.property : info.attribute,
        value
    ];
}
/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */ function $1fcd387c9e14169e$var$parseStyle(state, value) {
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3RaSV)))(value, {
            reactCompat: true
        });
    } catch (error) {
        if (state.ignoreInvalidStyle) return {};
        const cause = /** @type {Error} */ error;
        const message = new (0, $1knXa.VFileMessage)('Cannot parse `style` attribute', {
            ancestors: state.ancestors,
            cause: cause,
            ruleId: 'style',
            source: 'hast-util-to-jsx-runtime'
        });
        message.file = state.filePath || undefined;
        message.url = $1fcd387c9e14169e$var$docs + '#cannot-parse-style-attribute';
        throw message;
    }
}
/**
 * Create a JSX name from a string.
 *
 * @param {State} state
 *   To do.
 * @param {string} name
 *   Name.
 * @param {boolean} allowExpression
 *   Allow member expressions and identifiers.
 * @returns {unknown}
 *   To do.
 */ function $1fcd387c9e14169e$var$findComponentFromName(state, name, allowExpression) {
    /** @type {Identifier | Literal | MemberExpression} */ let result;
    if (!allowExpression) result = {
        type: 'Literal',
        value: name
    };
    else if (name.includes('.')) {
        const identifiers = name.split('.');
        let index = -1;
        /** @type {Identifier | Literal | MemberExpression | undefined} */ let node;
        while(++index < identifiers.length){
            /** @type {Identifier | Literal} */ const prop = (0, $3qc69.name)(identifiers[index]) ? {
                type: 'Identifier',
                name: identifiers[index]
            } : {
                type: 'Literal',
                value: identifiers[index]
            };
            node = node ? {
                type: 'MemberExpression',
                object: node,
                property: prop,
                computed: Boolean(index && prop.type === 'Literal'),
                optional: false
            } : prop;
        }
        (0, $jJcE6.ok)(node, 'always a result');
        result = node;
    } else result = (0, $3qc69.name)(name) && !/^[a-z]/.test(name) ? {
        type: 'Identifier',
        name: name
    } : {
        type: 'Literal',
        value: name
    };
    // Only literals can be passed in `components` currently.
    // No identifiers / member expressions.
    if (result.type === 'Literal') {
        const name = /** @type {string | number} */ result.value;
        return $1fcd387c9e14169e$var$own.call(state.components, name) ? state.components[name] : name;
    }
    // Assume component.
    if (state.evaluater) return state.evaluater.evaluateExpression(result);
    $1fcd387c9e14169e$var$crashEstree(state);
}
/**
 * @param {State} state
 * @param {Position | undefined} [place]
 * @returns {never}
 */ function $1fcd387c9e14169e$var$crashEstree(state, place) {
    const message = new (0, $1knXa.VFileMessage)('Cannot handle MDX estrees without `createEvaluater`', {
        ancestors: state.ancestors,
        place: place,
        ruleId: 'mdx-estree',
        source: 'hast-util-to-jsx-runtime'
    });
    message.file = state.filePath || undefined;
    message.url = $1fcd387c9e14169e$var$docs + '#cannot-handle-mdx-estrees-without-createevaluater';
    throw message;
}
/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */ function $1fcd387c9e14169e$var$transformStylesToCssCasing(domCasing) {
    /** @type {Style} */ const cssCasing = {};
    /** @type {string} */ let from;
    for(from in domCasing)if ($1fcd387c9e14169e$var$own.call(domCasing, from)) cssCasing[$1fcd387c9e14169e$var$transformStyleToCssCasing(from)] = domCasing[from];
    return cssCasing;
}
/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */ function $1fcd387c9e14169e$var$transformStyleToCssCasing(from) {
    let to = from.replace($1fcd387c9e14169e$var$cap, $1fcd387c9e14169e$var$toDash);
    // Handle `ms-xxx` -> `-ms-xxx`.
    if (to.slice(0, 3) === 'ms-') to = '-' + to;
    return to;
}
/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */ function $1fcd387c9e14169e$var$toDash($0) {
    return '-' + $0.toLowerCase();
}

});
parcelRegister("ksHxf", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $ee58315dd7911f79$export$fac44ee5b035f737; });
/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $ee58315dd7911f79$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $ee58315dd7911f79$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}

});

parcelRegister("3qc69", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $27dd2f4133bf6edd$export$a8ff84c12d48cfa6; });
/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */ const $27dd2f4133bf6edd$var$startRe = RegExp("[$_\\p{ID_Start}]", "u");
const $27dd2f4133bf6edd$var$contRe = RegExp("[$_\\u{200C}\\u{200D}\\p{ID_Continue}]", "u");
const $27dd2f4133bf6edd$var$contReJsx = RegExp("[-$_\\u{200C}\\u{200D}\\p{ID_Continue}]", "u");
const $27dd2f4133bf6edd$var$nameRe = RegExp("^[$_\\p{ID_Start}][$_\\u{200C}\\u{200D}\\p{ID_Continue}]*$", "u");
const $27dd2f4133bf6edd$var$nameReJsx = RegExp("^[$_\\p{ID_Start}][-$_\\u{200C}\\u{200D}\\p{ID_Continue}]*$", "u");
/** @type {Options} */ const $27dd2f4133bf6edd$var$emptyOptions = {};
function $27dd2f4133bf6edd$export$b3571188c770cc5a(code) {
    return code ? $27dd2f4133bf6edd$var$startRe.test(String.fromCodePoint(code)) : false;
}
function $27dd2f4133bf6edd$export$10eb6dc47bf009dc(code, options) {
    const settings = options || $27dd2f4133bf6edd$var$emptyOptions;
    const re = settings.jsx ? $27dd2f4133bf6edd$var$contReJsx : $27dd2f4133bf6edd$var$contRe;
    return code ? re.test(String.fromCodePoint(code)) : false;
}
function $27dd2f4133bf6edd$export$a8ff84c12d48cfa6(name, options) {
    const settings = options || $27dd2f4133bf6edd$var$emptyOptions;
    const re = settings.jsx ? $27dd2f4133bf6edd$var$nameReJsx : $27dd2f4133bf6edd$var$nameRe;
    return re.test(name);
}

});

parcelRegister("7CJ3n", function(module, exports) {

$parcel$export(module.exports, "whitespace", function () { return $58cf07ae0efe19d0$export$7af1228ff777d175; });
/**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $58cf07ae0efe19d0$var$re = /[ \t\n\f\r]/g;
function $58cf07ae0efe19d0$export$7af1228ff777d175(thing) {
    return typeof thing === 'object' ? thing.type === 'text' ? $58cf07ae0efe19d0$var$empty(thing.value) : false : $58cf07ae0efe19d0$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $58cf07ae0efe19d0$var$empty(value) {
    return value.replace($58cf07ae0efe19d0$var$re, '') === '';
}

});

parcelRegister("izzbJ", function(module, exports) {

$parcel$export(module.exports, "find", function () { return $d856ca8932227810$export$71aa6c912b956294; });
/**
 * @import {Schema} from 'property-information'
 */ 
var $hCqro = parcelRequire("hCqro");

var $7QWoe = parcelRequire("7QWoe");

var $1TRoG = parcelRequire("1TRoG");
const $d856ca8932227810$var$cap = /[A-Z]/g;
const $d856ca8932227810$var$dash = /-[a-z]/g;
const $d856ca8932227810$var$valid = /^data[-\w.:]+$/i;
function $d856ca8932227810$export$71aa6c912b956294(schema, value) {
    const normal = (0, $1TRoG.normalize)(value);
    let property = value;
    let Type = (0, $7QWoe.Info);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $d856ca8932227810$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($d856ca8932227810$var$dash, $d856ca8932227810$var$camelcase);
            property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$d856ca8932227810$var$dash.test(rest)) {
                let dashes = rest.replace($d856ca8932227810$var$cap, $d856ca8932227810$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $hCqro.DefinedInfo);
    }
    return new Type(property, value);
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */ function $d856ca8932227810$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */ function $d856ca8932227810$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

});
parcelRegister("hCqro", function(module, exports) {

$parcel$export(module.exports, "DefinedInfo", function () { return $cd3a7edbb690cbe2$export$ea6b9f0064e88c9b; });
/**
 * @import {Space} from 'property-information'
 */ 
var $7QWoe = parcelRequire("7QWoe");

var $lvW5C = parcelRequire("lvW5C");
const $cd3a7edbb690cbe2$var$checks = /** @type {ReadonlyArray<keyof typeof types>} */ Object.keys($lvW5C);
class $cd3a7edbb690cbe2$export$ea6b9f0064e88c9b extends (0, $7QWoe.Info) {
    /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $cd3a7edbb690cbe2$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $cd3a7edbb690cbe2$var$checks.length){
            const check = $cd3a7edbb690cbe2$var$checks[index];
            $cd3a7edbb690cbe2$var$mark(this, $cd3a7edbb690cbe2$var$checks[index], (mask & $lvW5C[check]) === $lvW5C[check]);
        }
    }
}
$cd3a7edbb690cbe2$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */ function $cd3a7edbb690cbe2$var$mark(values, key, value) {
    if (value) values[key] = value;
}

});
parcelRegister("7QWoe", function(module, exports) {

$parcel$export(module.exports, "Info", function () { return $5b7aaeba7eda377c$export$c4868e4a24d48fad; });
/**
 * @import {Info as InfoType} from 'property-information'
 */ /** @type {InfoType} */ class $5b7aaeba7eda377c$export$c4868e4a24d48fad {
    /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */ constructor(property, attribute){
        this.attribute = attribute;
        this.property = property;
    }
}
$5b7aaeba7eda377c$export$c4868e4a24d48fad.prototype.attribute = '';
$5b7aaeba7eda377c$export$c4868e4a24d48fad.prototype.booleanish = false;
$5b7aaeba7eda377c$export$c4868e4a24d48fad.prototype.boolean = false;
$5b7aaeba7eda377c$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$5b7aaeba7eda377c$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$5b7aaeba7eda377c$export$c4868e4a24d48fad.prototype.defined = false;
$5b7aaeba7eda377c$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$5b7aaeba7eda377c$export$c4868e4a24d48fad.prototype.number = false;
$5b7aaeba7eda377c$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$5b7aaeba7eda377c$export$c4868e4a24d48fad.prototype.property = '';
$5b7aaeba7eda377c$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$5b7aaeba7eda377c$export$c4868e4a24d48fad.prototype.space = undefined;

});

parcelRegister("lvW5C", function(module, exports) {

$parcel$export(module.exports, "boolean", function () { return $fa998d98fc2c3fbb$export$4a21f16c33752377; });
$parcel$export(module.exports, "booleanish", function () { return $fa998d98fc2c3fbb$export$55e9e1fbc638dc8f; });
$parcel$export(module.exports, "overloadedBoolean", function () { return $fa998d98fc2c3fbb$export$242ac3d3042558aa; });
$parcel$export(module.exports, "number", function () { return $fa998d98fc2c3fbb$export$98e628dec113755e; });
$parcel$export(module.exports, "spaceSeparated", function () { return $fa998d98fc2c3fbb$export$ab8645c862eb5a3e; });
$parcel$export(module.exports, "commaSeparated", function () { return $fa998d98fc2c3fbb$export$9c8d678629b3d3; });
$parcel$export(module.exports, "commaOrSpaceSeparated", function () { return $fa998d98fc2c3fbb$export$2ad25cfebf36cacd; });
let $fa998d98fc2c3fbb$var$powers = 0;
const $fa998d98fc2c3fbb$export$4a21f16c33752377 = $fa998d98fc2c3fbb$var$increment();
const $fa998d98fc2c3fbb$export$55e9e1fbc638dc8f = $fa998d98fc2c3fbb$var$increment();
const $fa998d98fc2c3fbb$export$242ac3d3042558aa = $fa998d98fc2c3fbb$var$increment();
const $fa998d98fc2c3fbb$export$98e628dec113755e = $fa998d98fc2c3fbb$var$increment();
const $fa998d98fc2c3fbb$export$ab8645c862eb5a3e = $fa998d98fc2c3fbb$var$increment();
const $fa998d98fc2c3fbb$export$9c8d678629b3d3 = $fa998d98fc2c3fbb$var$increment();
const $fa998d98fc2c3fbb$export$2ad25cfebf36cacd = $fa998d98fc2c3fbb$var$increment();
function $fa998d98fc2c3fbb$var$increment() {
    return 2 ** ++$fa998d98fc2c3fbb$var$powers;
}

});


parcelRegister("1TRoG", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $1624590af56f52e5$export$a3295358bff77e; });
/**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */ function $1624590af56f52e5$export$a3295358bff77e(value) {
    return value.toLowerCase();
}

});


parcelRegister("TxzkS", function(module, exports) {

$parcel$export(module.exports, "hastToReact", function () { return $0a6f2d427ac2c63e$export$d8abd7e5fb6871f9; });
/**
 * Special cases for React (`Record<string, string>`).
 *
 * `hast` is close to `React` but differs in a couple of cases.
 * To get a React property from a hast property,
 * check if it is in `hastToReact`.
 * If it is, use the corresponding value;
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $0a6f2d427ac2c63e$export$d8abd7e5fb6871f9 = {
    classId: 'classID',
    dataType: 'datatype',
    itemId: 'itemID',
    strokeDashArray: 'strokeDasharray',
    strokeDashOffset: 'strokeDashoffset',
    strokeLineCap: 'strokeLinecap',
    strokeLineJoin: 'strokeLinejoin',
    strokeMiterLimit: 'strokeMiterlimit',
    typeOf: 'typeof',
    xLinkActuate: 'xlinkActuate',
    xLinkArcRole: 'xlinkArcrole',
    xLinkHref: 'xlinkHref',
    xLinkRole: 'xlinkRole',
    xLinkShow: 'xlinkShow',
    xLinkTitle: 'xlinkTitle',
    xLinkType: 'xlinkType',
    xmlnsXLink: 'xmlnsXlink'
};

});

parcelRegister("kqAz9", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $edf2999c56276cb1$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "svg", function () { return $edf2999c56276cb1$export$7ed1367e7fa1ad68; });
// Note: types exposed from `index.d.ts`.

var $2JcrI = parcelRequire("2JcrI");

var $g79eF = parcelRequire("g79eF");

var $jwhZb = parcelRequire("jwhZb");

var $lfHaV = parcelRequire("lfHaV");

var $EgSeG = parcelRequire("EgSeG");

var $lnebN = parcelRequire("lnebN");

var $epc3i = parcelRequire("epc3i");

var $TxzkS = parcelRequire("TxzkS");

var $izzbJ = parcelRequire("izzbJ");

const $edf2999c56276cb1$export$c0bb0b647f701bb5 = (0, $2JcrI.merge)([
    (0, $g79eF.aria),
    (0, $jwhZb.html),
    (0, $EgSeG.xlink),
    (0, $lnebN.xmlns),
    (0, $epc3i.xml)
], 'html');
const $edf2999c56276cb1$export$7ed1367e7fa1ad68 = (0, $2JcrI.merge)([
    (0, $g79eF.aria),
    (0, $lfHaV.svg),
    (0, $EgSeG.xlink),
    (0, $lnebN.xmlns),
    (0, $epc3i.xml)
], 'svg');

});
parcelRegister("2JcrI", function(module, exports) {

$parcel$export(module.exports, "merge", function () { return $1fc97044b2654e61$export$4950aa0f605343fb; });
/**
 * @import {Info, Space} from 'property-information'
 */ 
var $4QavN = parcelRequire("4QavN");
function $1fc97044b2654e61$export$4950aa0f605343fb(definitions, space) {
    /** @type {Record<string, Info>} */ const property = {};
    /** @type {Record<string, string>} */ const normal = {};
    for (const definition of definitions){
        Object.assign(property, definition.property);
        Object.assign(normal, definition.normal);
    }
    return new (0, $4QavN.Schema)(property, normal, space);
}

});
parcelRegister("4QavN", function(module, exports) {

$parcel$export(module.exports, "Schema", function () { return $38642c2d18aa746c$export$19342e026b58ebb7; });
/**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */ /** @type {SchemaType} */ class $38642c2d18aa746c$export$19342e026b58ebb7 {
    /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */ constructor(property, normal, space){
        this.normal = normal;
        this.property = property;
        if (space) this.space = space;
    }
}
$38642c2d18aa746c$export$19342e026b58ebb7.prototype.normal = {};
$38642c2d18aa746c$export$19342e026b58ebb7.prototype.property = {};
$38642c2d18aa746c$export$19342e026b58ebb7.prototype.space = undefined;

});


parcelRegister("g79eF", function(module, exports) {

$parcel$export(module.exports, "aria", function () { return $bbb476c1ccb26260$export$4d2d26490572750a; });

var $b5411 = parcelRequire("b5411");

var $lvW5C = parcelRequire("lvW5C");
const $bbb476c1ccb26260$export$4d2d26490572750a = (0, $b5411.create)({
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $lvW5C.booleanish),
        ariaAutoComplete: null,
        ariaBusy: (0, $lvW5C.booleanish),
        ariaChecked: (0, $lvW5C.booleanish),
        ariaColCount: (0, $lvW5C.number),
        ariaColIndex: (0, $lvW5C.number),
        ariaColSpan: (0, $lvW5C.number),
        ariaControls: (0, $lvW5C.spaceSeparated),
        ariaCurrent: null,
        ariaDescribedBy: (0, $lvW5C.spaceSeparated),
        ariaDetails: null,
        ariaDisabled: (0, $lvW5C.booleanish),
        ariaDropEffect: (0, $lvW5C.spaceSeparated),
        ariaErrorMessage: null,
        ariaExpanded: (0, $lvW5C.booleanish),
        ariaFlowTo: (0, $lvW5C.spaceSeparated),
        ariaGrabbed: (0, $lvW5C.booleanish),
        ariaHasPopup: null,
        ariaHidden: (0, $lvW5C.booleanish),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $lvW5C.spaceSeparated),
        ariaLevel: (0, $lvW5C.number),
        ariaLive: null,
        ariaModal: (0, $lvW5C.booleanish),
        ariaMultiLine: (0, $lvW5C.booleanish),
        ariaMultiSelectable: (0, $lvW5C.booleanish),
        ariaOrientation: null,
        ariaOwns: (0, $lvW5C.spaceSeparated),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $lvW5C.number),
        ariaPressed: (0, $lvW5C.booleanish),
        ariaReadOnly: (0, $lvW5C.booleanish),
        ariaRelevant: null,
        ariaRequired: (0, $lvW5C.booleanish),
        ariaRoleDescription: (0, $lvW5C.spaceSeparated),
        ariaRowCount: (0, $lvW5C.number),
        ariaRowIndex: (0, $lvW5C.number),
        ariaRowSpan: (0, $lvW5C.number),
        ariaSelected: (0, $lvW5C.booleanish),
        ariaSetSize: (0, $lvW5C.number),
        ariaSort: null,
        ariaValueMax: (0, $lvW5C.number),
        ariaValueMin: (0, $lvW5C.number),
        ariaValueNow: (0, $lvW5C.number),
        ariaValueText: null,
        role: null
    },
    transform (_, property) {
        return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
    }
});

});
parcelRegister("b5411", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $811346b7aa1188df$export$185802fd694ee1f5; });
/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @typedef Definition
 *   Definition of a schema.
 * @property {Record<string, string> | undefined} [attributes]
 *   Normalzed names to special attribute case.
 * @property {ReadonlyArray<string> | undefined} [mustUseProperty]
 *   Normalized names that must be set as properties.
 * @property {Record<string, number | null>} properties
 *   Property names to their types.
 * @property {Space | undefined} [space]
 *   Space.
 * @property {Transform} transform
 *   Transform a property name.
 */ /**
 * @callback Transform
 *   Transform.
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Attribute.
 */ 
var $1TRoG = parcelRequire("1TRoG");

var $hCqro = parcelRequire("hCqro");

var $4QavN = parcelRequire("4QavN");
function $811346b7aa1188df$export$185802fd694ee1f5(definition) {
    /** @type {Record<string, Info>} */ const properties = {};
    /** @type {Record<string, string>} */ const normals = {};
    for (const [property, value] of Object.entries(definition.properties)){
        const info = new (0, $hCqro.DefinedInfo)(property, definition.transform(definition.attributes || {}, property), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) info.mustUseProperty = true;
        properties[property] = info;
        normals[(0, $1TRoG.normalize)(property)] = property;
        normals[(0, $1TRoG.normalize)(info.attribute)] = property;
    }
    return new (0, $4QavN.Schema)(properties, normals, definition.space);
}

});


parcelRegister("jwhZb", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $e35ef51c1a0630aa$export$c0bb0b647f701bb5; });

var $guFZZ = parcelRequire("guFZZ");

var $b5411 = parcelRequire("b5411");

var $lvW5C = parcelRequire("lvW5C");
const $e35ef51c1a0630aa$export$c0bb0b647f701bb5 = (0, $b5411.create)({
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $lvW5C.commaSeparated),
        acceptCharset: (0, $lvW5C.spaceSeparated),
        accessKey: (0, $lvW5C.spaceSeparated),
        action: null,
        allow: null,
        allowFullScreen: (0, $lvW5C.boolean),
        allowPaymentRequest: (0, $lvW5C.boolean),
        allowUserMedia: (0, $lvW5C.boolean),
        alpha: (0, $lvW5C.boolean),
        alt: null,
        as: null,
        async: (0, $lvW5C.boolean),
        autoCapitalize: null,
        autoComplete: (0, $lvW5C.spaceSeparated),
        autoFocus: (0, $lvW5C.boolean),
        autoPlay: (0, $lvW5C.boolean),
        blocking: (0, $lvW5C.spaceSeparated),
        capture: null,
        charSet: null,
        checked: (0, $lvW5C.boolean),
        cite: null,
        className: (0, $lvW5C.spaceSeparated),
        closedBy: null,
        colorSpace: null,
        cols: (0, $lvW5C.number),
        colSpan: (0, $lvW5C.number),
        command: null,
        commandFor: null,
        content: null,
        contentEditable: (0, $lvW5C.booleanish),
        controls: (0, $lvW5C.boolean),
        controlsList: (0, $lvW5C.spaceSeparated),
        coords: (0, $lvW5C.number) | (0, $lvW5C.commaSeparated),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $lvW5C.boolean),
        defer: (0, $lvW5C.boolean),
        dir: null,
        dirName: null,
        disabled: (0, $lvW5C.boolean),
        download: (0, $lvW5C.overloadedBoolean),
        draggable: (0, $lvW5C.booleanish),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $lvW5C.boolean),
        formTarget: null,
        headers: (0, $lvW5C.spaceSeparated),
        height: (0, $lvW5C.number),
        hidden: (0, $lvW5C.overloadedBoolean),
        high: (0, $lvW5C.number),
        href: null,
        hrefLang: null,
        htmlFor: (0, $lvW5C.spaceSeparated),
        httpEquiv: (0, $lvW5C.spaceSeparated),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $lvW5C.boolean),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $lvW5C.boolean),
        itemId: null,
        itemProp: (0, $lvW5C.spaceSeparated),
        itemRef: (0, $lvW5C.spaceSeparated),
        itemScope: (0, $lvW5C.boolean),
        itemType: (0, $lvW5C.spaceSeparated),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $lvW5C.boolean),
        low: (0, $lvW5C.number),
        manifest: null,
        max: null,
        maxLength: (0, $lvW5C.number),
        media: null,
        method: null,
        min: null,
        minLength: (0, $lvW5C.number),
        multiple: (0, $lvW5C.boolean),
        muted: (0, $lvW5C.boolean),
        name: null,
        nonce: null,
        noModule: (0, $lvW5C.boolean),
        noValidate: (0, $lvW5C.boolean),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $lvW5C.boolean),
        optimum: (0, $lvW5C.number),
        pattern: null,
        ping: (0, $lvW5C.spaceSeparated),
        placeholder: null,
        playsInline: (0, $lvW5C.boolean),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $lvW5C.boolean),
        referrerPolicy: null,
        rel: (0, $lvW5C.spaceSeparated),
        required: (0, $lvW5C.boolean),
        reversed: (0, $lvW5C.boolean),
        rows: (0, $lvW5C.number),
        rowSpan: (0, $lvW5C.number),
        sandbox: (0, $lvW5C.spaceSeparated),
        scope: null,
        scoped: (0, $lvW5C.boolean),
        seamless: (0, $lvW5C.boolean),
        selected: (0, $lvW5C.boolean),
        shadowRootClonable: (0, $lvW5C.boolean),
        shadowRootCustomElementRegistry: (0, $lvW5C.boolean),
        shadowRootDelegatesFocus: (0, $lvW5C.boolean),
        shadowRootMode: null,
        shadowRootSerializable: (0, $lvW5C.boolean),
        shape: null,
        size: (0, $lvW5C.number),
        sizes: null,
        slot: null,
        span: (0, $lvW5C.number),
        spellCheck: (0, $lvW5C.booleanish),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $lvW5C.number),
        step: null,
        style: null,
        tabIndex: (0, $lvW5C.number),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $lvW5C.boolean),
        useMap: null,
        value: (0, $lvW5C.booleanish),
        width: (0, $lvW5C.number),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $lvW5C.spaceSeparated),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $lvW5C.number),
        borderColor: null,
        bottomMargin: (0, $lvW5C.number),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $lvW5C.boolean),
        declare: (0, $lvW5C.boolean),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $lvW5C.number),
        leftMargin: (0, $lvW5C.number),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $lvW5C.number),
        marginWidth: (0, $lvW5C.number),
        noResize: (0, $lvW5C.boolean),
        noHref: (0, $lvW5C.boolean),
        noShade: (0, $lvW5C.boolean),
        noWrap: (0, $lvW5C.boolean),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $lvW5C.number),
        rules: null,
        scheme: null,
        scrolling: (0, $lvW5C.booleanish),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $lvW5C.number),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $lvW5C.number),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        credentialless: (0, $lvW5C.boolean),
        disablePictureInPicture: (0, $lvW5C.boolean),
        disableRemotePlayback: (0, $lvW5C.boolean),
        exportParts: (0, $lvW5C.commaSeparated),
        part: (0, $lvW5C.spaceSeparated),
        prefix: null,
        property: null,
        results: (0, $lvW5C.number),
        security: null,
        unselectable: null
    },
    space: 'html',
    transform: (0, $guFZZ.caseInsensitiveTransform)
});

});
parcelRegister("guFZZ", function(module, exports) {

$parcel$export(module.exports, "caseInsensitiveTransform", function () { return $c02006cc59e19872$export$32b9e4cec9c208e1; });

var $ccnB2 = parcelRequire("ccnB2");
function $c02006cc59e19872$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $ccnB2.caseSensitiveTransform)(attributes, property.toLowerCase());
}

});
parcelRegister("ccnB2", function(module, exports) {

$parcel$export(module.exports, "caseSensitiveTransform", function () { return $8e18e8c130957281$export$5b10b3bc32d7efbc; });
/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */ function $8e18e8c130957281$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}

});



parcelRegister("lfHaV", function(module, exports) {

$parcel$export(module.exports, "svg", function () { return $f78c7d680a57ad80$export$7ed1367e7fa1ad68; });

var $ccnB2 = parcelRequire("ccnB2");

var $b5411 = parcelRequire("b5411");

var $lvW5C = parcelRequire("lvW5C");
const $f78c7d680a57ad80$export$7ed1367e7fa1ad68 = (0, $b5411.create)({
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        maskType: 'mask-type',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    properties: {
        about: (0, $lvW5C.commaOrSpaceSeparated),
        accentHeight: (0, $lvW5C.number),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $lvW5C.number),
        amplitude: (0, $lvW5C.number),
        arabicForm: null,
        ascent: (0, $lvW5C.number),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $lvW5C.number),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $lvW5C.number),
        by: null,
        calcMode: null,
        capHeight: (0, $lvW5C.number),
        className: (0, $lvW5C.spaceSeparated),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $lvW5C.number),
        diffuseConstant: (0, $lvW5C.number),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $lvW5C.number),
        dominantBaseline: null,
        download: (0, $lvW5C.boolean),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $lvW5C.number),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $lvW5C.number),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $lvW5C.number),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $lvW5C.commaSeparated),
        g2: (0, $lvW5C.commaSeparated),
        glyphName: (0, $lvW5C.commaSeparated),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $lvW5C.number),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $lvW5C.number),
        horizOriginX: (0, $lvW5C.number),
        horizOriginY: (0, $lvW5C.number),
        id: null,
        ideographic: (0, $lvW5C.number),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $lvW5C.number),
        k: (0, $lvW5C.number),
        k1: (0, $lvW5C.number),
        k2: (0, $lvW5C.number),
        k3: (0, $lvW5C.number),
        k4: (0, $lvW5C.number),
        kernelMatrix: (0, $lvW5C.commaOrSpaceSeparated),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $lvW5C.number),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskType: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $lvW5C.number),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $lvW5C.number),
        overlineThickness: (0, $lvW5C.number),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $lvW5C.number),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $lvW5C.spaceSeparated),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $lvW5C.number),
        pointsAtY: (0, $lvW5C.number),
        pointsAtZ: (0, $lvW5C.number),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $lvW5C.commaOrSpaceSeparated),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $lvW5C.commaOrSpaceSeparated),
        rev: (0, $lvW5C.commaOrSpaceSeparated),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $lvW5C.commaOrSpaceSeparated),
        requiredFeatures: (0, $lvW5C.commaOrSpaceSeparated),
        requiredFonts: (0, $lvW5C.commaOrSpaceSeparated),
        requiredFormats: (0, $lvW5C.commaOrSpaceSeparated),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $lvW5C.number),
        specularExponent: (0, $lvW5C.number),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $lvW5C.number),
        strikethroughThickness: (0, $lvW5C.number),
        string: null,
        stroke: null,
        strokeDashArray: (0, $lvW5C.commaOrSpaceSeparated),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $lvW5C.number),
        strokeOpacity: (0, $lvW5C.number),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $lvW5C.number),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $lvW5C.commaOrSpaceSeparated),
        tabIndex: (0, $lvW5C.number),
        tableValues: null,
        target: null,
        targetX: (0, $lvW5C.number),
        targetY: (0, $lvW5C.number),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $lvW5C.commaOrSpaceSeparated),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $lvW5C.number),
        underlineThickness: (0, $lvW5C.number),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $lvW5C.number),
        values: null,
        vAlphabetic: (0, $lvW5C.number),
        vMathematical: (0, $lvW5C.number),
        vectorEffect: null,
        vHanging: (0, $lvW5C.number),
        vIdeographic: (0, $lvW5C.number),
        version: null,
        vertAdvY: (0, $lvW5C.number),
        vertOriginX: (0, $lvW5C.number),
        vertOriginY: (0, $lvW5C.number),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $lvW5C.number),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    },
    space: 'svg',
    transform: (0, $ccnB2.caseSensitiveTransform)
});

});

parcelRegister("EgSeG", function(module, exports) {

$parcel$export(module.exports, "xlink", function () { return $0790d3524730d2a0$export$2bd1230ec7600845; });

var $b5411 = parcelRequire("b5411");
const $0790d3524730d2a0$export$2bd1230ec7600845 = (0, $b5411.create)({
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    },
    space: 'xlink',
    transform (_, property) {
        return 'xlink:' + property.slice(5).toLowerCase();
    }
});

});

parcelRegister("lnebN", function(module, exports) {

$parcel$export(module.exports, "xmlns", function () { return $f8f6c0a503f76fbf$export$e20c24a128671213; });

var $b5411 = parcelRequire("b5411");

var $guFZZ = parcelRequire("guFZZ");
const $f8f6c0a503f76fbf$export$e20c24a128671213 = (0, $b5411.create)({
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    properties: {
        xmlnsXLink: null,
        xmlns: null
    },
    space: 'xmlns',
    transform: (0, $guFZZ.caseInsensitiveTransform)
});

});

parcelRegister("epc3i", function(module, exports) {

$parcel$export(module.exports, "xml", function () { return $a7ccbfc86eb2696b$export$f2913fe8983302e; });

var $b5411 = parcelRequire("b5411");
const $a7ccbfc86eb2696b$export$f2913fe8983302e = (0, $b5411.create)({
    properties: {
        xmlBase: null,
        xmlLang: null,
        xmlSpace: null
    },
    space: 'xml',
    transform (_, property) {
        return 'xml:' + property.slice(3).toLowerCase();
    }
});

});


parcelRegister("5ktT3", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $3e1600ea1754891f$export$fac44ee5b035f737; });
/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $3e1600ea1754891f$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $3e1600ea1754891f$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}

});

parcelRegister("3RaSV", function(module, exports) {
"use strict";
var $2ceec3d6a62e9bc9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $2ceec3d6a62e9bc9$var$style_to_object_1 = $2ceec3d6a62e9bc9$var$__importDefault((parcelRequire("jkw7H")));

var $52TFb = parcelRequire("52TFb");
/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */ function $2ceec3d6a62e9bc9$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') return output;
    (0, $2ceec3d6a62e9bc9$var$style_to_object_1.default)(style, function(property, value) {
        // skip CSS comment
        if (property && value) output[(0, $52TFb.camelCase)(property, options)] = value;
    });
    return output;
}
$2ceec3d6a62e9bc9$var$StyleToJS.default = $2ceec3d6a62e9bc9$var$StyleToJS;
module.exports = $2ceec3d6a62e9bc9$var$StyleToJS;

});
parcelRegister("jkw7H", function(module, exports) {
"use strict";
var $e128cd9548a67f94$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e128cd9548a67f94$var$StyleToObject;

const $e128cd9548a67f94$var$inline_style_parser_1 = $e128cd9548a67f94$var$__importDefault((parcelRequire("cu8Cy")));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $e128cd9548a67f94$var$StyleToObject(style, iterator) {
    let styleObject = null;
    if (!style || typeof style !== 'string') return styleObject;
    const declarations = (0, $e128cd9548a67f94$var$inline_style_parser_1.default)(style);
    const hasIterator = typeof iterator === 'function';
    declarations.forEach((declaration)=>{
        if (declaration.type !== 'declaration') return;
        const { property: property, value: value } = declaration;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}

});
parcelRegister("cu8Cy", function(module, exports) {
'use strict';
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $916ef94c1e31f1d2$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $916ef94c1e31f1d2$var$NEWLINE_REGEX = /\n/g;
var $916ef94c1e31f1d2$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $916ef94c1e31f1d2$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $916ef94c1e31f1d2$var$COLON_REGEX = /^:\s*/;
var $916ef94c1e31f1d2$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $916ef94c1e31f1d2$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $916ef94c1e31f1d2$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $916ef94c1e31f1d2$var$NEWLINE = '\n';
var $916ef94c1e31f1d2$var$FORWARD_SLASH = '/';
var $916ef94c1e31f1d2$var$ASTERISK = '*';
var $916ef94c1e31f1d2$var$EMPTY_STRING = '';
// types
var $916ef94c1e31f1d2$var$TYPE_COMMENT = 'comment';
var $916ef94c1e31f1d2$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ function $916ef94c1e31f1d2$var$index(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($916ef94c1e31f1d2$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($916ef94c1e31f1d2$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) ;
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($916ef94c1e31f1d2$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($916ef94c1e31f1d2$var$FORWARD_SLASH != style.charAt(0) || $916ef94c1e31f1d2$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($916ef94c1e31f1d2$var$EMPTY_STRING != style.charAt(i) && ($916ef94c1e31f1d2$var$ASTERISK != style.charAt(i) || $916ef94c1e31f1d2$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($916ef94c1e31f1d2$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $916ef94c1e31f1d2$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($916ef94c1e31f1d2$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($916ef94c1e31f1d2$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($916ef94c1e31f1d2$var$VALUE_REGEX);
        var ret = pos({
            type: $916ef94c1e31f1d2$var$TYPE_DECLARATION,
            property: $916ef94c1e31f1d2$var$trim(prop[0].replace($916ef94c1e31f1d2$var$COMMENT_REGEX, $916ef94c1e31f1d2$var$EMPTY_STRING)),
            value: val ? $916ef94c1e31f1d2$var$trim(val[0].replace($916ef94c1e31f1d2$var$COMMENT_REGEX, $916ef94c1e31f1d2$var$EMPTY_STRING)) : $916ef94c1e31f1d2$var$EMPTY_STRING
        });
        // ;
        match($916ef94c1e31f1d2$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
}
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $916ef94c1e31f1d2$var$trim(str) {
    return str ? str.replace($916ef94c1e31f1d2$var$TRIM_REGEX, $916ef94c1e31f1d2$var$EMPTY_STRING) : $916ef94c1e31f1d2$var$EMPTY_STRING;
}
module.exports = $916ef94c1e31f1d2$var$index;

});


parcelRegister("52TFb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.camelCase = void 0;
var $3ac8513b28e25f65$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var $3ac8513b28e25f65$var$HYPHEN_REGEX = /-([a-z])/g;
var $3ac8513b28e25f65$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $3ac8513b28e25f65$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $3ac8513b28e25f65$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */ var $3ac8513b28e25f65$var$skipCamelCase = function(property) {
    return !property || $3ac8513b28e25f65$var$NO_HYPHEN_REGEX.test(property) || $3ac8513b28e25f65$var$CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */ var $3ac8513b28e25f65$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */ var $3ac8513b28e25f65$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
/**
 * CamelCases a CSS property.
 */ var $3ac8513b28e25f65$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($3ac8513b28e25f65$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) // `-ms` vendor prefix should not be capitalized
    property = property.replace($3ac8513b28e25f65$var$MS_VENDOR_PREFIX_REGEX, $3ac8513b28e25f65$var$trimHyphen);
    else // for non-React, remove first hyphen so vendor prefix is not capitalized
    property = property.replace($3ac8513b28e25f65$var$VENDOR_PREFIX_REGEX, $3ac8513b28e25f65$var$trimHyphen);
    return property.replace($3ac8513b28e25f65$var$HYPHEN_REGEX, $3ac8513b28e25f65$var$capitalize);
};
module.exports.camelCase = $3ac8513b28e25f65$var$camelCase;

});


parcelRegister("i4y4M", function(module, exports) {

$parcel$export(module.exports, "pointEnd", function () { return $d283088b0240c886$export$da309cdce9dc2a25; });
$parcel$export(module.exports, "pointStart", function () { return $d283088b0240c886$export$771bf3e4949bfbee; });
$parcel$export(module.exports, "position", function () { return $d283088b0240c886$export$5880b8b5730aff45; });
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $d283088b0240c886$export$da309cdce9dc2a25 = $d283088b0240c886$var$point('end');
const $d283088b0240c886$export$771bf3e4949bfbee = $d283088b0240c886$var$point('start');
/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $d283088b0240c886$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        if (typeof point.line === 'number' && point.line > 0 && typeof point.column === 'number' && point.column > 0) return {
            line: point.line,
            column: point.column,
            offset: typeof point.offset === 'number' && point.offset > -1 ? point.offset : undefined
        };
    }
}
function $d283088b0240c886$export$5880b8b5730aff45(node) {
    const start = $d283088b0240c886$export$771bf3e4949bfbee(node);
    const end = $d283088b0240c886$export$da309cdce9dc2a25(node);
    if (start && end) return {
        start: start,
        end: end
    };
}

});

parcelRegister("1knXa", function(module, exports) {

$parcel$export(module.exports, "VFileMessage", function () { return $0f7a3d513b704432$export$752e5c445fe834ef; });
/**
 * @import {Node, Point, Position} from 'unist'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */ 
var $dok7x = parcelRequire("dok7x");

var $lIRvn = parcelRequire("lIRvn");
class $0f7a3d513b704432$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // eslint-disable-next-line complexity
    constructor(causeOrReason, optionsOrParentOrPlace, origin){
        super();
        if (typeof optionsOrParentOrPlace === 'string') {
            origin = optionsOrParentOrPlace;
            optionsOrParentOrPlace = undefined;
        }
        /** @type {string} */ let reason = '';
        /** @type {Options} */ let options = {};
        let legacyCause = false;
        if (optionsOrParentOrPlace) {
            // Point.
            if ('line' in optionsOrParentOrPlace && 'column' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('start' in optionsOrParentOrPlace && 'end' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('type' in optionsOrParentOrPlace) options = {
                ancestors: [
                    optionsOrParentOrPlace
                ],
                place: optionsOrParentOrPlace.position
            };
            else options = (0, $dok7x._)({}, optionsOrParentOrPlace);
        }
        if (typeof causeOrReason === 'string') reason = causeOrReason;
        else if (!options.cause && causeOrReason) {
            legacyCause = true;
            reason = causeOrReason.message;
            options.cause = causeOrReason;
        }
        if (!options.ruleId && !options.source && typeof origin === 'string') {
            const index = origin.indexOf(':');
            if (index === -1) options.ruleId = origin;
            else {
                options.source = origin.slice(0, index);
                options.ruleId = origin.slice(index + 1);
            }
        }
        if (!options.place && options.ancestors && options.ancestors) {
            const parent = options.ancestors[options.ancestors.length - 1];
            if (parent) options.place = parent.position;
        }
        const start = options.place && 'start' in options.place ? options.place.start : options.place;
        /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */ this.ancestors = options.ancestors || undefined;
        /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */ this.cause = options.cause || undefined;
        /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */ this.column = start ? start.column : undefined;
        /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */ this.fatal = undefined;
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */ this.file = '';
        // Field from `Error`.
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = reason;
        /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */ this.line = start ? start.line : undefined;
        // Field from `Error`.
        /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $lIRvn.stringifyPosition)(options.place) || '1:1';
        /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */ this.place = options.place || undefined;
        /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */ this.ruleId = options.ruleId || undefined;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */ this.source = options.source || undefined;
        // Field from `Error`.
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = legacyCause && options.cause && typeof options.cause.stack === 'string' ? options.cause.stack : '';
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */ this.actual = undefined;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */ this.expected = undefined;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */ this.note = undefined;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */ this.url = undefined;
    }
}
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.file = '';
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.name = '';
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.reason = '';
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.message = '';
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.stack = '';
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.column = undefined;
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.line = undefined;
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.ancestors = undefined;
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.cause = undefined;
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.fatal = undefined;
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.place = undefined;
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.ruleId = undefined;
$0f7a3d513b704432$export$752e5c445fe834ef.prototype.source = undefined;

});
parcelRegister("lIRvn", function(module, exports) {

$parcel$export(module.exports, "stringifyPosition", function () { return $fd07360945649b32$export$c304dd45fe166145; });
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $fd07360945649b32$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $fd07360945649b32$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $fd07360945649b32$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $fd07360945649b32$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $fd07360945649b32$var$point(point) {
    return $fd07360945649b32$var$index(point && point.line) + ':' + $fd07360945649b32$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $fd07360945649b32$var$position(pos) {
    return $fd07360945649b32$var$point(pos && pos.start) + '-' + $fd07360945649b32$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $fd07360945649b32$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}

});



parcelRegister("7LXFT", function(module, exports) {

$parcel$export(module.exports, "urlAttributes", function () { return $5a8b365a9ae52909$export$de3e062aedff083a; });
/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */ const $5a8b365a9ae52909$export$de3e062aedff083a = {
    action: [
        'form'
    ],
    cite: [
        'blockquote',
        'del',
        'ins',
        'q'
    ],
    data: [
        'object'
    ],
    formAction: [
        'button',
        'input'
    ],
    href: [
        'a',
        'area',
        'base',
        'link'
    ],
    icon: [
        'menuitem'
    ],
    itemId: null,
    manifest: [
        'html'
    ],
    ping: [
        'a',
        'area'
    ],
    poster: [
        'video'
    ],
    src: [
        'audio',
        'embed',
        'iframe',
        'img',
        'input',
        'script',
        'source',
        'track',
        'video'
    ]
};

});

parcelRegister("3bfZT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $250eceeb2cc5e17e$export$2e2bcd8739ae039; });
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {Omit<FromMarkdownOptions, 'extensions' | 'mdastExtensions'>} Options
 */ 
var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $7R97r = parcelRequire("7R97r");
function $250eceeb2cc5e17e$export$2e2bcd8739ae039(options) {
    /** @type {Processor} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    self.parser = parser;
    /**
   * @type {Parser}
   */ function parser(doc) {
        return (0, $7R97r.fromMarkdown)(doc, (0, $cNnl8._)((0, $dok7x._)({}, self.data('settings'), options), {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data('micromarkExtensions') || [],
            mdastExtensions: self.data('fromMarkdownExtensions') || []
        }));
    }
}

});
parcelRegister("7R97r", function(module, exports) {

$parcel$export(module.exports, "fromMarkdown", function () { return $5b848e82efe4f9da$export$d744d789c09bfde6; });
/**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ 
var $crpFH = parcelRequire("crpFH");
parcelRequire("5FCuk");
var $g9YQ0 = parcelRequire("g9YQ0");
var $fGfKR = parcelRequire("fGfKR");
var $hyF31 = parcelRequire("hyF31");

var $5tGUI = parcelRequire("5tGUI");

var $gwlv9 = parcelRequire("gwlv9");

var $6ZJKj = parcelRequire("6ZJKj");

var $iayRF = parcelRequire("iayRF");

var $lIRvn = parcelRequire("lIRvn");
const $5b848e82efe4f9da$var$own = {}.hasOwnProperty;
function $5b848e82efe4f9da$export$d744d789c09bfde6(value, encoding, options) {
    if (encoding && typeof encoding === 'object') {
        options = encoding;
        encoding = undefined;
    }
    return $5b848e82efe4f9da$var$compiler(options)((0, $fGfKR.postprocess)((0, $g9YQ0.parse)(options).document().write((0, $hyF31.preprocess)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $5b848e82efe4f9da$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $5b848e82efe4f9da$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($5b848e82efe4f9da$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $5b848e82efe4f9da$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $5b848e82efe4f9da$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $5b848e82efe4f9da$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $5b848e82efe4f9da$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $lIRvn.stringifyPosition)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $5b848e82efe4f9da$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $5b848e82efe4f9da$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $crpFH.toString)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $6ZJKj.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $5b848e82efe4f9da$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $5b848e82efe4f9da$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $5b848e82efe4f9da$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $gwlv9.decodeString)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $6ZJKj.normalizeIdentifier)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $6ZJKj.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $5tGUI.decodeNumericCharacterReference)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $iayRF.decodeNamedCharacterReference)(data);
            value = result;
        }
        const tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        const tail = this.stack.pop();
        tail.position.end = $5b848e82efe4f9da$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $5b848e82efe4f9da$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $5b848e82efe4f9da$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $5b848e82efe4f9da$var$configure(combined, value);
        else $5b848e82efe4f9da$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $5b848e82efe4f9da$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($5b848e82efe4f9da$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $5b848e82efe4f9da$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $lIRvn.stringifyPosition)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $lIRvn.stringifyPosition)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $lIRvn.stringifyPosition)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}

});
parcelRegister("crpFH", function(module, exports) {

$parcel$export(module.exports, "toString", function () { return $025662c3fd12f8cb$export$f84e8e69fd4488a5; });
/**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $025662c3fd12f8cb$var$emptyOptions = {};
function $025662c3fd12f8cb$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $025662c3fd12f8cb$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $025662c3fd12f8cb$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $025662c3fd12f8cb$var$one(value, includeImageAlt, includeHtml) {
    if ($025662c3fd12f8cb$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $025662c3fd12f8cb$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $025662c3fd12f8cb$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $025662c3fd12f8cb$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $025662c3fd12f8cb$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $025662c3fd12f8cb$var$node(value) {
    return Boolean(value && typeof value === 'object');
}

});

parcelRegister("5FCuk", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return (parcelRequire("g9YQ0")).parse; });
$parcel$export(module.exports, "postprocess", function () { return (parcelRequire("fGfKR")).postprocess; });
$parcel$export(module.exports, "preprocess", function () { return (parcelRequire("hyF31")).preprocess; });
/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ 
var $1p5y3 = parcelRequire("1p5y3");

var $g9YQ0 = parcelRequire("g9YQ0");

var $fGfKR = parcelRequire("fGfKR");

var $hyF31 = parcelRequire("hyF31");
function $420ea309fee2893a$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $1p5y3.compile)(options)((0, $fGfKR.postprocess)((0, $g9YQ0.parse)(options).document().write((0, $hyF31.preprocess)()(value, encoding, true))));
}

});
parcelRegister("1p5y3", function(module, exports) {

$parcel$export(module.exports, "compile", function () { return $105c6e07bf978dd1$export$ef7acd7185315e22; });
/**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ 
var $dok7x = parcelRequire("dok7x");

var $iayRF = parcelRequire("iayRF");

var $2JkHA = parcelRequire("2JkHA");

var $ebbcJ = parcelRequire("ebbcJ");

var $5tGUI = parcelRequire("5tGUI");

var $bqYPy = parcelRequire("bqYPy");

var $6ZJKj = parcelRequire("6ZJKj");

var $Uii3m = parcelRequire("Uii3m");
const $105c6e07bf978dd1$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $105c6e07bf978dd1$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $105c6e07bf978dd1$var$protocolSource = /^https?$/i;
function $105c6e07bf978dd1$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $ebbcJ.combineHtmlExtensions)([
        defaultHandlers,
        ...settings.htmlExtensions || []
    ]);
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $2JkHA.push)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $2JkHA.push)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $2JkHA.push)(head, body);
        head = (0, $2JkHA.push)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($105c6e07bf978dd1$var$hasOwnProperty.call(handles, kind) && handle) handle.call((0, $dok7x._)({
                sliceSerialize: result[index][2].sliceSerialize
            }, context), result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0; // Skip open.
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $bqYPy.encode)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1; // Skip current.
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $6ZJKj.normalizeIdentifier)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $Uii3m.sanitizeUri)(context.destination, settings.allowDangerousProtocol ? undefined : $105c6e07bf978dd1$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $Uii3m.sanitizeUri)(context.destination, settings.allowDangerousProtocol ? undefined : $105c6e07bf978dd1$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $6ZJKj.normalizeIdentifier)(media.labelId);
        resume();
        if (!$105c6e07bf978dd1$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const value = this.sliceSerialize(token);
        const decoded = getData('characterReferenceType') ? (0, $5tGUI.decodeNumericCharacterReference)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $iayRF.decodeNamedCharacterReference)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $Uii3m.sanitizeUri)(uri, settings.allowDangerousProtocol ? undefined : $105c6e07bf978dd1$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $Uii3m.sanitizeUri)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}

});
parcelRegister("iayRF", function(module, exports) {

$parcel$export(module.exports, "decodeNamedCharacterReference", function () { return $d3a4348a97c9a458$export$289b6a6320f709b4; });
/// <reference lib="dom" />
/* global document */ const $d3a4348a97c9a458$var$element = document.createElement('i');
function $d3a4348a97c9a458$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $d3a4348a97c9a458$var$element.innerHTML = characterReference;
    const character = $d3a4348a97c9a458$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    if (character.charCodeAt(character.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    return character === characterReference ? false : character;
}

});

parcelRegister("2JkHA", function(module, exports) {

$parcel$export(module.exports, "splice", function () { return $1fcfd7c0d11602ad$export$869882364835d202; });
$parcel$export(module.exports, "push", function () { return $1fcfd7c0d11602ad$export$4cbf152802aa238; });
/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $1fcfd7c0d11602ad$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $1fcfd7c0d11602ad$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $1fcfd7c0d11602ad$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}

});

parcelRegister("ebbcJ", function(module, exports) {

$parcel$export(module.exports, "combineExtensions", function () { return $a52ac8bd423b3c6a$export$86a865d89ef3c690; });
$parcel$export(module.exports, "combineHtmlExtensions", function () { return $a52ac8bd423b3c6a$export$eaf8c406dfb0a620; });
/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
var $2JkHA = parcelRequire("2JkHA");
const $a52ac8bd423b3c6a$var$hasOwnProperty = {}.hasOwnProperty;
function $a52ac8bd423b3c6a$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$a52ac8bd423b3c6a$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $a52ac8bd423b3c6a$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $a52ac8bd423b3c6a$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$a52ac8bd423b3c6a$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $a52ac8bd423b3c6a$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $a52ac8bd423b3c6a$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $2JkHA.splice)(existing, 0, 0, before);
}
function $a52ac8bd423b3c6a$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$a52ac8bd423b3c6a$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $a52ac8bd423b3c6a$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $a52ac8bd423b3c6a$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}

});

parcelRegister("5tGUI", function(module, exports) {

$parcel$export(module.exports, "decodeNumericCharacterReference", function () { return $01077fca2a6cf1cd$export$15a69557afac2c20; });
/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $01077fca2a6cf1cd$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}

});

parcelRegister("bqYPy", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $85314f165dba424e$export$c564cdbbe6da493; });
const $85314f165dba424e$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $85314f165dba424e$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $85314f165dba424e$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}

});

parcelRegister("6ZJKj", function(module, exports) {

$parcel$export(module.exports, "normalizeIdentifier", function () { return $517beccc6ea6f69c$export$806d55e226cfcd08; });
/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $517beccc6ea6f69c$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}

});

parcelRegister("Uii3m", function(module, exports) {

$parcel$export(module.exports, "sanitizeUri", function () { return $0a936b2054a74509$export$d130a2d684099e5a; });
$parcel$export(module.exports, "normalizeUri", function () { return $0a936b2054a74509$export$e42a3e39590d28b5; });

var $1oKGI = parcelRequire("1oKGI");

var $bqYPy = parcelRequire("bqYPy");
function $0a936b2054a74509$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $bqYPy.encode)($0a936b2054a74509$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $0a936b2054a74509$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $1oKGI.asciiAlphanumeric)(value.charCodeAt(index + 1)) && (0, $1oKGI.asciiAlphanumeric)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}

});
parcelRegister("1oKGI", function(module, exports) {

$parcel$export(module.exports, "asciiAlpha", function () { return $104c3f948fa95732$export$d65d6b62c24d5436; });
$parcel$export(module.exports, "asciiAlphanumeric", function () { return $104c3f948fa95732$export$75c76db11865a9f4; });
$parcel$export(module.exports, "asciiAtext", function () { return $104c3f948fa95732$export$4397998b34fe597d; });
$parcel$export(module.exports, "asciiControl", function () { return $104c3f948fa95732$export$67dbf494fc8394df; });
$parcel$export(module.exports, "asciiDigit", function () { return $104c3f948fa95732$export$ca8b5b1a6c320e6e; });
$parcel$export(module.exports, "asciiHexDigit", function () { return $104c3f948fa95732$export$eca2752363989806; });
$parcel$export(module.exports, "asciiPunctuation", function () { return $104c3f948fa95732$export$35794a7d1db99380; });
$parcel$export(module.exports, "markdownLineEnding", function () { return $104c3f948fa95732$export$34a1dff1c0936953; });
$parcel$export(module.exports, "markdownLineEndingOrSpace", function () { return $104c3f948fa95732$export$a30284361b3814b7; });
$parcel$export(module.exports, "markdownSpace", function () { return $104c3f948fa95732$export$2c6cf65c1127992a; });
$parcel$export(module.exports, "unicodePunctuation", function () { return $104c3f948fa95732$export$aa04114dd888a7a0; });
$parcel$export(module.exports, "unicodeWhitespace", function () { return $104c3f948fa95732$export$a0ff789c034ffdf4; });
/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $104c3f948fa95732$export$d65d6b62c24d5436 = $104c3f948fa95732$var$regexCheck(/[A-Za-z]/);
const $104c3f948fa95732$export$75c76db11865a9f4 = $104c3f948fa95732$var$regexCheck(/[\dA-Za-z]/);
const $104c3f948fa95732$export$4397998b34fe597d = $104c3f948fa95732$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $104c3f948fa95732$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $104c3f948fa95732$export$ca8b5b1a6c320e6e = $104c3f948fa95732$var$regexCheck(/\d/);
const $104c3f948fa95732$export$eca2752363989806 = $104c3f948fa95732$var$regexCheck(/[\dA-Fa-f]/);
const $104c3f948fa95732$export$35794a7d1db99380 = $104c3f948fa95732$var$regexCheck(/[!-/:-@[-`{-~]/);
function $104c3f948fa95732$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $104c3f948fa95732$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $104c3f948fa95732$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $104c3f948fa95732$export$aa04114dd888a7a0 = $104c3f948fa95732$var$regexCheck(RegExp("\\p{P}|\\p{S}", "u"));
const $104c3f948fa95732$export$a0ff789c034ffdf4 = $104c3f948fa95732$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $104c3f948fa95732$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}

});



parcelRegister("g9YQ0", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $bc3cadbe11139d9d$export$98e6a39c04603d36; });
/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
var $ebbcJ = parcelRequire("ebbcJ");

var $72rFu = parcelRequire("72rFu");

var $5mIIh = parcelRequire("5mIIh");

var $3SSU2 = parcelRequire("3SSU2");

var $c6YmB = parcelRequire("c6YmB");

var $31gM7 = parcelRequire("31gM7");

var $4ofeF = parcelRequire("4ofeF");
function $bc3cadbe11139d9d$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $ebbcJ.combineExtensions)([
        $31gM7,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        constructs: constructs,
        content: create((0, $72rFu.content)),
        defined: [],
        document: create((0, $5mIIh.document)),
        flow: create((0, $3SSU2.flow)),
        lazy: {},
        string: create((0, $c6YmB.string)),
        text: create((0, $c6YmB.text))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $4ofeF.createTokenizer)(parser, initial, from);
        }
    }
}

});
parcelRegister("72rFu", function(module, exports) {

$parcel$export(module.exports, "content", function () { return $51fe2e9ff2449888$export$a7db06668cad9adb; });
/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");
const $51fe2e9ff2449888$export$a7db06668cad9adb = {
    tokenize: $51fe2e9ff2449888$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $51fe2e9ff2449888$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $16fb9.factorySpace)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}

});
parcelRegister("16fb9", function(module, exports) {

$parcel$export(module.exports, "factorySpace", function () { return $0cd2202f946360c7$export$ae105c1eb063a0a2; });
/**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
var $1oKGI = parcelRequire("1oKGI");
function $0cd2202f946360c7$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $1oKGI.markdownSpace)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}

});


parcelRegister("5mIIh", function(module, exports) {

$parcel$export(module.exports, "document", function () { return $3e81b0f1fc36a96d$export$5a7bfc01df82fcd1; });
/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 
var $dok7x = parcelRequire("dok7x");

var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");

var $2JkHA = parcelRequire("2JkHA");
const $3e81b0f1fc36a96d$export$5a7bfc01df82fcd1 = {
    tokenize: $3e81b0f1fc36a96d$var$initializeDocument
};
/** @type {Construct} */ const $3e81b0f1fc36a96d$var$containerConstruct = {
    tokenize: $3e81b0f1fc36a96d$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $3e81b0f1fc36a96d$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = (0, $dok7x._)({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $2JkHA.splice)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($3e81b0f1fc36a96d$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($3e81b0f1fc36a96d$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        const stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = (0, $dok7x._)({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $2JkHA.splice)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $3e81b0f1fc36a96d$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $16fb9.factorySpace)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}

});

parcelRegister("3SSU2", function(module, exports) {

$parcel$export(module.exports, "flow", function () { return $2d4100cc701c77ed$export$ccc7b0636abaffc3; });
/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ 
var $gIDsK = parcelRequire("gIDsK");
var $8acSv = parcelRequire("8acSv");

var $16fb9 = parcelRequire("16fb9");

const $2d4100cc701c77ed$export$ccc7b0636abaffc3 = {
    tokenize: $2d4100cc701c77ed$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $2d4100cc701c77ed$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $gIDsK.blankLine), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $16fb9.factorySpace)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $8acSv.content), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}

});
parcelRegister("gIDsK", function(module, exports) {

$parcel$export(module.exports, "blankLine", function () { return $c2bf5ddcf6dfbec3$export$d50d28ce3ab2a612; });
/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");
const $c2bf5ddcf6dfbec3$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $c2bf5ddcf6dfbec3$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $c2bf5ddcf6dfbec3$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $1oKGI.markdownSpace)(code) ? (0, $16fb9.factorySpace)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $1oKGI.markdownLineEnding)(code) ? ok(code) : nok(code);
    }
}

});

parcelRegister("8acSv", function(module, exports) {

$parcel$export(module.exports, "content", function () { return $5f193f3e651a97a1$export$a7db06668cad9adb; });
/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");

var $dCkao = parcelRequire("dCkao");
const $5f193f3e651a97a1$export$a7db06668cad9adb = {
    resolve: $5f193f3e651a97a1$var$resolveContent,
    tokenize: $5f193f3e651a97a1$var$tokenizeContent
};
/** @type {Construct} */ const $5f193f3e651a97a1$var$continuationConstruct = {
    partial: true,
    tokenize: $5f193f3e651a97a1$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $5f193f3e651a97a1$var$resolveContent(events) {
    (0, $dCkao.subtokenize)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5f193f3e651a97a1$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $1oKGI.markdownLineEnding)(code)) return effects.check($5f193f3e651a97a1$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5f193f3e651a97a1$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $16fb9.factorySpace)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}

});
parcelRegister("dCkao", function(module, exports) {

$parcel$export(module.exports, "subtokenize", function () { return $9e9e779ecb577c2a$export$12949d1dd00fddf4; });
/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 
var $dok7x = parcelRequire("dok7x");

var $2JkHA = parcelRequire("2JkHA");

var $iH7gq = parcelRequire("iH7gq");
function $9e9e779ecb577c2a$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $iH7gq.SpliceBuffer)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $9e9e779ecb577c2a$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
                else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = (0, $dok7x._)({}, events.get(lineIndex)[1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $2JkHA.splice)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $9e9e779ecb577c2a$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    let tokenizer = token._tokenizer;
    if (!tokenizer) {
        tokenizer = context.parser[token.contentType](token.start);
        if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
    }
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}

});
parcelRegister("iH7gq", function(module, exports) {

$parcel$export(module.exports, "SpliceBuffer", function () { return $d9c1e09ca1007856$export$bd596157370df26e; });
/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $d9c1e09ca1007856$export$bd596157370df26e {
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $d9c1e09ca1007856$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $d9c1e09ca1007856$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $d9c1e09ca1007856$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $d9c1e09ca1007856$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $d9c1e09ca1007856$var$chunkedPush(this.left, removed.reverse());
        }
    }
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $d9c1e09ca1007856$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}

});




parcelRegister("c6YmB", function(module, exports) {

$parcel$export(module.exports, "resolver", function () { return $8d14de80ade6a8f1$export$50397835cbfdbc24; });
$parcel$export(module.exports, "string", function () { return $8d14de80ade6a8f1$export$22b082955e083ec3; });
$parcel$export(module.exports, "text", function () { return $8d14de80ade6a8f1$export$6f093cfa640b7166; });
/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ 
var $dok7x = parcelRequire("dok7x");
const $8d14de80ade6a8f1$export$50397835cbfdbc24 = {
    resolveAll: $8d14de80ade6a8f1$var$createResolver()
};
const $8d14de80ade6a8f1$export$22b082955e083ec3 = $8d14de80ade6a8f1$var$initializeFactory('string');
const $8d14de80ade6a8f1$export$6f093cfa640b7166 = $8d14de80ade6a8f1$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $8d14de80ade6a8f1$var$initializeFactory(field) {
    return {
        resolveAll: $8d14de80ade6a8f1$var$createResolver(field === 'text' ? $8d14de80ade6a8f1$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $8d14de80ade6a8f1$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $8d14de80ade6a8f1$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        // Allow final trailing whitespace.
        if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: (0, $dok7x._)({}, data.end)
            };
            data.end = (0, $dok7x._)({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}

});

parcelRegister("31gM7", function(module, exports) {

$parcel$export(module.exports, "document", function () { return $232e7a4c97a980b0$export$5a7bfc01df82fcd1; });
$parcel$export(module.exports, "contentInitial", function () { return $232e7a4c97a980b0$export$5a2181fb44b58173; });
$parcel$export(module.exports, "flowInitial", function () { return $232e7a4c97a980b0$export$cf8bead395eff824; });
$parcel$export(module.exports, "flow", function () { return $232e7a4c97a980b0$export$ccc7b0636abaffc3; });
$parcel$export(module.exports, "string", function () { return $232e7a4c97a980b0$export$22b082955e083ec3; });
$parcel$export(module.exports, "text", function () { return $232e7a4c97a980b0$export$6f093cfa640b7166; });
$parcel$export(module.exports, "insideSpan", function () { return $232e7a4c97a980b0$export$d44f260a3f9b69f5; });
$parcel$export(module.exports, "attentionMarkers", function () { return $232e7a4c97a980b0$export$b9c0b60d74426aea; });
$parcel$export(module.exports, "disable", function () { return $232e7a4c97a980b0$export$e20fbacbb41798b; });
/**
 * @import {Extension} from 'micromark-util-types'
 */ 
var $aQ8eM = parcelRequire("aQ8eM");
var $y8oWw = parcelRequire("y8oWw");
var $ekV0B = parcelRequire("ekV0B");
var $PWIlL = parcelRequire("PWIlL");
var $cyYaO = parcelRequire("cyYaO");
var $3YuBo = parcelRequire("3YuBo");
var $5wlAg = parcelRequire("5wlAg");
var $iS18n = parcelRequire("iS18n");
var $aVIJE = parcelRequire("aVIJE");
var $biRsv = parcelRequire("biRsv");
var $b0k3p = parcelRequire("b0k3p");
var $7m9nk = parcelRequire("7m9nk");
var $gm9Xs = parcelRequire("gm9Xs");
var $7bqxX = parcelRequire("7bqxX");
var $7Q7lq = parcelRequire("7Q7lq");
var $a1uvD = parcelRequire("a1uvD");
var $ajRtT = parcelRequire("ajRtT");
var $aJgU7 = parcelRequire("aJgU7");
var $8KDly = parcelRequire("8KDly");
var $cukOH = parcelRequire("cukOH");

var $c6YmB = parcelRequire("c6YmB");
const $232e7a4c97a980b0$export$5a7bfc01df82fcd1 = {
    [42]: (0, $aJgU7.list),
    [43]: (0, $aJgU7.list),
    [45]: (0, $aJgU7.list),
    [48]: (0, $aJgU7.list),
    [49]: (0, $aJgU7.list),
    [50]: (0, $aJgU7.list),
    [51]: (0, $aJgU7.list),
    [52]: (0, $aJgU7.list),
    [53]: (0, $aJgU7.list),
    [54]: (0, $aJgU7.list),
    [55]: (0, $aJgU7.list),
    [56]: (0, $aJgU7.list),
    [57]: (0, $aJgU7.list),
    [62]: (0, $ekV0B.blockQuote)
};
const $232e7a4c97a980b0$export$5a2181fb44b58173 = {
    [91]: (0, $aVIJE.definition)
};
const $232e7a4c97a980b0$export$cf8bead395eff824 = {
    [-2]: (0, $5wlAg.codeIndented),
    [-1]: (0, $5wlAg.codeIndented),
    [32]: (0, $5wlAg.codeIndented)
};
const $232e7a4c97a980b0$export$ccc7b0636abaffc3 = {
    [35]: (0, $b0k3p.headingAtx),
    [42]: (0, $cukOH.thematicBreak),
    [45]: [
        (0, $8KDly.setextUnderline),
        (0, $cukOH.thematicBreak)
    ],
    [60]: (0, $7m9nk.htmlFlow),
    [61]: (0, $8KDly.setextUnderline),
    [95]: (0, $cukOH.thematicBreak),
    [96]: (0, $3YuBo.codeFenced),
    [126]: (0, $3YuBo.codeFenced)
};
const $232e7a4c97a980b0$export$22b082955e083ec3 = {
    [38]: (0, $cyYaO.characterReference),
    [92]: (0, $PWIlL.characterEscape)
};
const $232e7a4c97a980b0$export$6f093cfa640b7166 = {
    [-5]: (0, $ajRtT.lineEnding),
    [-4]: (0, $ajRtT.lineEnding),
    [-3]: (0, $ajRtT.lineEnding),
    [33]: (0, $7Q7lq.labelStartImage),
    [38]: (0, $cyYaO.characterReference),
    [42]: (0, $aQ8eM.attention),
    [60]: [
        (0, $y8oWw.autolink),
        (0, $gm9Xs.htmlText)
    ],
    [91]: (0, $a1uvD.labelStartLink),
    [92]: [
        (0, $biRsv.hardBreakEscape),
        (0, $PWIlL.characterEscape)
    ],
    [93]: (0, $7bqxX.labelEnd),
    [95]: (0, $aQ8eM.attention),
    [96]: (0, $iS18n.codeText)
};
const $232e7a4c97a980b0$export$d44f260a3f9b69f5 = {
    null: [
        (0, $aQ8eM.attention),
        (0, $c6YmB.resolver)
    ]
};
const $232e7a4c97a980b0$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $232e7a4c97a980b0$export$e20fbacbb41798b = {
    null: []
};

});
parcelRegister("aQ8eM", function(module, exports) {

$parcel$export(module.exports, "attention", function () { return $7e4526802a8c01c4$export$45b92471da762af7; });
/**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
var $dok7x = parcelRequire("dok7x");

var $2JkHA = parcelRequire("2JkHA");

var $8jB9j = parcelRequire("8jB9j");

var $cJuDb = parcelRequire("cJuDb");
const $7e4526802a8c01c4$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $7e4526802a8c01c4$var$resolveAllAttention,
    tokenize: $7e4526802a8c01c4$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $7e4526802a8c01c4$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = (0, $dok7x._)({}, events[open][1].end);
            const end = (0, $dok7x._)({}, events[index][1].start);
            $7e4526802a8c01c4$var$movePoint(start, -use);
            $7e4526802a8c01c4$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: (0, $dok7x._)({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: (0, $dok7x._)({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: (0, $dok7x._)({}, events[open][1].end),
                end: (0, $dok7x._)({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: (0, $dok7x._)({}, openingSequence.start),
                end: (0, $dok7x._)({}, closingSequence.end)
            };
            events[open][1].end = (0, $dok7x._)({}, openingSequence.start);
            events[index][1].start = (0, $dok7x._)({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $2JkHA.push)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $2JkHA.push)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $2JkHA.push)(nextEvents, (0, $cJuDb.resolveAll)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $2JkHA.push)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $2JkHA.push)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $2JkHA.splice)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7e4526802a8c01c4$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $8jB9j.classifyCharacter)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $8jB9j.classifyCharacter)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $7e4526802a8c01c4$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

});
parcelRegister("8jB9j", function(module, exports) {

$parcel$export(module.exports, "classifyCharacter", function () { return $60dcea27ecbfa7e4$export$e3902bc0d835cad0; });
/**
 * @import {Code} from 'micromark-util-types'
 */ 
var $1oKGI = parcelRequire("1oKGI");
function $60dcea27ecbfa7e4$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $1oKGI.markdownLineEndingOrSpace)(code) || (0, $1oKGI.unicodeWhitespace)(code)) return 1;
    if ((0, $1oKGI.unicodePunctuation)(code)) return 2;
}

});

parcelRegister("cJuDb", function(module, exports) {

$parcel$export(module.exports, "resolveAll", function () { return $945172abbebab7fc$export$3ff61ec196ff408b; });
/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $945172abbebab7fc$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}

});


parcelRegister("y8oWw", function(module, exports) {

$parcel$export(module.exports, "autolink", function () { return $0669b16a1828b1de$export$17ddf85e4c916ad6; });
/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $1oKGI = parcelRequire("1oKGI");
const $0669b16a1828b1de$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $0669b16a1828b1de$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0669b16a1828b1de$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $1oKGI.asciiAlpha)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $1oKGI.asciiAlphanumeric)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $1oKGI.asciiAlphanumeric)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $1oKGI.asciiControl)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $1oKGI.asciiAtext)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $1oKGI.asciiAlphanumeric)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $1oKGI.asciiAlphanumeric)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

});

parcelRegister("ekV0B", function(module, exports) {

$parcel$export(module.exports, "blockQuote", function () { return $a6ff27acc25d9cbc$export$200dcd0a5903c968; });
/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");
const $a6ff27acc25d9cbc$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $a6ff27acc25d9cbc$var$tokenizeBlockQuoteContinuation
    },
    exit: $a6ff27acc25d9cbc$var$exit,
    name: 'blockQuote',
    tokenize: $a6ff27acc25d9cbc$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $a6ff27acc25d9cbc$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $a6ff27acc25d9cbc$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $1oKGI.markdownSpace)(code)) // Always populated by defaults.
        return (0, $16fb9.factorySpace)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($a6ff27acc25d9cbc$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $a6ff27acc25d9cbc$var$exit(effects) {
    effects.exit("blockQuote");
}

});

parcelRegister("PWIlL", function(module, exports) {

$parcel$export(module.exports, "characterEscape", function () { return $09c24ef9f8fe5637$export$2005478564e78d96; });
/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $1oKGI = parcelRequire("1oKGI");
const $09c24ef9f8fe5637$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $09c24ef9f8fe5637$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $09c24ef9f8fe5637$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $1oKGI.asciiPunctuation)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

});

parcelRegister("cyYaO", function(module, exports) {

$parcel$export(module.exports, "characterReference", function () { return $92575631b0f0caae$export$e31905600aaf3d8e; });
/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $iayRF = parcelRequire("iayRF");

var $1oKGI = parcelRequire("1oKGI");
const $92575631b0f0caae$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $92575631b0f0caae$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $92575631b0f0caae$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $1oKGI.asciiAlphanumeric);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $1oKGI.asciiHexDigit);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $1oKGI.asciiDigit);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $1oKGI.asciiAlphanumeric) && !(0, $iayRF.decodeNamedCharacterReference)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

});

parcelRegister("3YuBo", function(module, exports) {

$parcel$export(module.exports, "codeFenced", function () { return $2e4eb6a517806cae$export$c23e4921f8d87e7c; });
/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");
/** @type {Construct} */ const $2e4eb6a517806cae$var$nonLazyContinuation = {
    partial: true,
    tokenize: $2e4eb6a517806cae$var$tokenizeNonLazyContinuation
};
const $2e4eb6a517806cae$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $2e4eb6a517806cae$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2e4eb6a517806cae$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $1oKGI.markdownSpace)(code) ? (0, $16fb9.factorySpace)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($2e4eb6a517806cae$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $16fb9.factorySpace)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $1oKGI.markdownSpace)(code) ? (0, $16fb9.factorySpace)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) return effects.check($2e4eb6a517806cae$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $1oKGI.markdownSpace)(code) ? (0, $16fb9.factorySpace)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $1oKGI.markdownSpace)(code) ? (0, $16fb9.factorySpace)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $1oKGI.markdownLineEnding)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2e4eb6a517806cae$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

});

parcelRegister("5wlAg", function(module, exports) {

$parcel$export(module.exports, "codeIndented", function () { return $4050af00b53d6982$export$47910b7ab28d1853; });
/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");
const $4050af00b53d6982$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $4050af00b53d6982$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $4050af00b53d6982$var$furtherStart = {
    partial: true,
    tokenize: $4050af00b53d6982$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $4050af00b53d6982$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $16fb9.factorySpace)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $1oKGI.markdownLineEnding)(code)) return effects.attempt($4050af00b53d6982$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $4050af00b53d6982$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $16fb9.factorySpace)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $1oKGI.markdownLineEnding)(code) ? furtherStart(code) : nok(code);
    }
}

});

parcelRegister("iS18n", function(module, exports) {

$parcel$export(module.exports, "codeText", function () { return $dbce265cf3a91f03$export$d24f93e715f9df88; });
/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
var $1oKGI = parcelRequire("1oKGI");
const $dbce265cf3a91f03$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $dbce265cf3a91f03$var$previous,
    resolve: $dbce265cf3a91f03$var$resolveCodeText,
    tokenize: $dbce265cf3a91f03$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $dbce265cf3a91f03$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $dbce265cf3a91f03$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $dbce265cf3a91f03$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

});

parcelRegister("aVIJE", function(module, exports) {

$parcel$export(module.exports, "definition", function () { return $7f51edbf59b723c9$export$69f215ed977cdb73; });
/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $fM3EG = parcelRequire("fM3EG");

var $3G88B = parcelRequire("3G88B");

var $16fb9 = parcelRequire("16fb9");

var $1sygd = parcelRequire("1sygd");

var $c4V49 = parcelRequire("c4V49");

var $1oKGI = parcelRequire("1oKGI");

var $6ZJKj = parcelRequire("6ZJKj");
const $7f51edbf59b723c9$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $7f51edbf59b723c9$var$tokenizeDefinition
};
/** @type {Construct} */ const $7f51edbf59b723c9$var$titleBefore = {
    partial: true,
    tokenize: $7f51edbf59b723c9$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7f51edbf59b723c9$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $3G88B.factoryLabel).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $6ZJKj.normalizeIdentifier)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $1oKGI.markdownLineEndingOrSpace)(code) ? (0, $c4V49.factoryWhitespace)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $fM3EG.factoryDestination)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($7f51edbf59b723c9$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $1oKGI.markdownSpace)(code) ? (0, $16fb9.factorySpace)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7f51edbf59b723c9$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $1oKGI.markdownLineEndingOrSpace)(code) ? (0, $c4V49.factoryWhitespace)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $1sygd.factoryTitle)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $1oKGI.markdownSpace)(code) ? (0, $16fb9.factorySpace)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $1oKGI.markdownLineEnding)(code) ? ok(code) : nok(code);
    }
}

});
parcelRegister("fM3EG", function(module, exports) {

$parcel$export(module.exports, "factoryDestination", function () { return $b7be2c904dddc8e6$export$2e6c8deaa96af245; });
/**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
var $1oKGI = parcelRequire("1oKGI");
function $b7be2c904dddc8e6$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $1oKGI.asciiControl)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $1oKGI.markdownLineEnding)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $1oKGI.markdownLineEndingOrSpace)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $1oKGI.asciiControl)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}

});

parcelRegister("3G88B", function(module, exports) {

$parcel$export(module.exports, "factoryLabel", function () { return $2adb9b5316915b42$export$7b768614d8ba97a7; });
/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 
var $1oKGI = parcelRequire("1oKGI");
function $2adb9b5316915b42$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $1oKGI.markdownLineEnding)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $1oKGI.markdownSpace)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}

});

parcelRegister("1sygd", function(module, exports) {

$parcel$export(module.exports, "factoryTitle", function () { return $1102fb6803061e06$export$f970569cc855e483; });
/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");
function $1102fb6803061e06$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $16fb9.factorySpace)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}

});

parcelRegister("c4V49", function(module, exports) {

$parcel$export(module.exports, "factoryWhitespace", function () { return $8cb21fd773beae11$export$1f27bd1aa33ce173; });
/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");
function $8cb21fd773beae11$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $1oKGI.markdownSpace)(code)) return (0, $16fb9.factorySpace)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}

});


parcelRegister("biRsv", function(module, exports) {

$parcel$export(module.exports, "hardBreakEscape", function () { return $83aad7f8340840a2$export$86c573ab9e06f418; });
/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $1oKGI = parcelRequire("1oKGI");
const $83aad7f8340840a2$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $83aad7f8340840a2$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $83aad7f8340840a2$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

});

parcelRegister("b0k3p", function(module, exports) {

$parcel$export(module.exports, "headingAtx", function () { return $802f4018546a9369$export$3871e9deb360695c; });
/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");

var $2JkHA = parcelRequire("2JkHA");
const $802f4018546a9369$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $802f4018546a9369$var$resolveHeadingAtx,
    tokenize: $802f4018546a9369$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $802f4018546a9369$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $2JkHA.splice)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $802f4018546a9369$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $1oKGI.markdownLineEndingOrSpace)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $1oKGI.markdownSpace)(code)) return (0, $16fb9.factorySpace)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $1oKGI.markdownLineEndingOrSpace)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

});

parcelRegister("7m9nk", function(module, exports) {

$parcel$export(module.exports, "htmlFlow", function () { return $55b1dc31a362bece$export$476ac411cb7d0d8f; });
/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $1oKGI = parcelRequire("1oKGI");

var $4sTzB = parcelRequire("4sTzB");

var $gIDsK = parcelRequire("gIDsK");
const $55b1dc31a362bece$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $55b1dc31a362bece$var$resolveToHtmlFlow,
    tokenize: $55b1dc31a362bece$var$tokenizeHtmlFlow
};
/** @type {Construct} */ const $55b1dc31a362bece$var$blankLineBefore = {
    partial: true,
    tokenize: $55b1dc31a362bece$var$tokenizeBlankLineBefore
};
const $55b1dc31a362bece$var$nonLazyContinuationStart = {
    partial: true,
    tokenize: $55b1dc31a362bece$var$tokenizeNonLazyContinuationStart
};
/** @type {Resolver} */ function $55b1dc31a362bece$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $55b1dc31a362bece$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $1oKGI.asciiAlpha)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $1oKGI.asciiAlpha)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $1oKGI.asciiAlpha)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $1oKGI.markdownLineEndingOrSpace)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $4sTzB.htmlRawNames).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $4sTzB.htmlBlockNames).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $1oKGI.asciiAlphanumeric)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $1oKGI.asciiAlpha)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $1oKGI.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $1oKGI.markdownLineEndingOrSpace)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $1oKGI.markdownSpace)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $1oKGI.markdownLineEnding)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($55b1dc31a362bece$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($55b1dc31a362bece$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $4sTzB.htmlRawNames).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $1oKGI.asciiAlpha)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $55b1dc31a362bece$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $55b1dc31a362bece$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $gIDsK.blankLine), ok, nok);
    }
}

});
parcelRegister("4sTzB", function(module, exports) {

$parcel$export(module.exports, "htmlBlockNames", function () { return $3404e2a56ca0e885$export$7364aee1c59d1879; });
$parcel$export(module.exports, "htmlRawNames", function () { return $3404e2a56ca0e885$export$948e66da505d080; });
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $3404e2a56ca0e885$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $3404e2a56ca0e885$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];

});


parcelRegister("gm9Xs", function(module, exports) {

$parcel$export(module.exports, "htmlText", function () { return $be866cd9d0be0b45$export$398af27f284914fe; });
/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");
const $be866cd9d0be0b45$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $be866cd9d0be0b45$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $be866cd9d0be0b45$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $1oKGI.asciiAlpha)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $1oKGI.asciiAlpha)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $1oKGI.asciiAlpha)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $1oKGI.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $1oKGI.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $1oKGI.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $1oKGI.asciiAlpha)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $1oKGI.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $1oKGI.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $1oKGI.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $1oKGI.markdownSpace)(code) ? (0, $16fb9.factorySpace)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

});

parcelRegister("7bqxX", function(module, exports) {

$parcel$export(module.exports, "labelEnd", function () { return $53ae271f9e3ed1f4$export$470a5dafbbf62654; });
/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
var $dok7x = parcelRequire("dok7x");

var $fM3EG = parcelRequire("fM3EG");

var $3G88B = parcelRequire("3G88B");

var $1sygd = parcelRequire("1sygd");

var $c4V49 = parcelRequire("c4V49");

var $1oKGI = parcelRequire("1oKGI");

var $2JkHA = parcelRequire("2JkHA");

var $6ZJKj = parcelRequire("6ZJKj");

var $cJuDb = parcelRequire("cJuDb");
const $53ae271f9e3ed1f4$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $53ae271f9e3ed1f4$var$resolveAllLabelEnd,
    resolveTo: $53ae271f9e3ed1f4$var$resolveToLabelEnd,
    tokenize: $53ae271f9e3ed1f4$var$tokenizeLabelEnd
};
/** @type {Construct} */ const $53ae271f9e3ed1f4$var$resourceConstruct = {
    tokenize: $53ae271f9e3ed1f4$var$tokenizeResource
};
/** @type {Construct} */ const $53ae271f9e3ed1f4$var$referenceFullConstruct = {
    tokenize: $53ae271f9e3ed1f4$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $53ae271f9e3ed1f4$var$referenceCollapsedConstruct = {
    tokenize: $53ae271f9e3ed1f4$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $53ae271f9e3ed1f4$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Array<Event>} */ const newEvents = [];
    while(++index < events.length){
        const token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            const offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $2JkHA.splice)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $53ae271f9e3ed1f4$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: (0, $dok7x._)({}, events[open][1].start),
        end: (0, $dok7x._)({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: (0, $dok7x._)({}, events[open][1].start),
        end: (0, $dok7x._)({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: (0, $dok7x._)({}, events[open + offset + 2][1].end),
        end: (0, $dok7x._)({}, events[close - 2][1].start)
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $2JkHA.push)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $2JkHA.push)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $2JkHA.push)(media, (0, $cJuDb.resolveAll)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $2JkHA.push)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $2JkHA.push)(media, events.slice(close + 1));
    // Media close.
    media = (0, $2JkHA.push)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $2JkHA.splice)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $53ae271f9e3ed1f4$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $6ZJKj.normalizeIdentifier)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($53ae271f9e3ed1f4$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($53ae271f9e3ed1f4$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($53ae271f9e3ed1f4$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $53ae271f9e3ed1f4$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $1oKGI.markdownLineEndingOrSpace)(code) ? (0, $c4V49.factoryWhitespace)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $fM3EG.factoryDestination)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $1oKGI.markdownLineEndingOrSpace)(code) ? (0, $c4V49.factoryWhitespace)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $1sygd.factoryTitle)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $1oKGI.markdownLineEndingOrSpace)(code) ? (0, $c4V49.factoryWhitespace)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $53ae271f9e3ed1f4$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $3G88B.factoryLabel).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $6ZJKj.normalizeIdentifier)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $53ae271f9e3ed1f4$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

});

parcelRegister("7Q7lq", function(module, exports) {

$parcel$export(module.exports, "labelStartImage", function () { return $5b53162fc15bea65$export$3d754936e25aa5f5; });
/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $7bqxX = parcelRequire("7bqxX");
const $5b53162fc15bea65$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $7bqxX.labelEnd).resolveAll,
    tokenize: $5b53162fc15bea65$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5b53162fc15bea65$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

});

parcelRegister("a1uvD", function(module, exports) {

$parcel$export(module.exports, "labelStartLink", function () { return $74c1a9e04e6faa3d$export$5c0cee0701a3b584; });
/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $7bqxX = parcelRequire("7bqxX");
const $74c1a9e04e6faa3d$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $7bqxX.labelEnd).resolveAll,
    tokenize: $74c1a9e04e6faa3d$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $74c1a9e04e6faa3d$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

});

parcelRegister("ajRtT", function(module, exports) {

$parcel$export(module.exports, "lineEnding", function () { return $783529f9c8e93b86$export$8e62e0ad51c97b2; });
/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

const $783529f9c8e93b86$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $783529f9c8e93b86$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $783529f9c8e93b86$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $16fb9.factorySpace)(effects, ok, "linePrefix");
    }
}

});

parcelRegister("aJgU7", function(module, exports) {

$parcel$export(module.exports, "list", function () { return $7cfb3827d9342eab$export$8837f4fc672e936d; });
/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");

var $gIDsK = parcelRequire("gIDsK");

var $cukOH = parcelRequire("cukOH");
const $7cfb3827d9342eab$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $7cfb3827d9342eab$var$tokenizeListContinuation
    },
    exit: $7cfb3827d9342eab$var$tokenizeListEnd,
    name: 'list',
    tokenize: $7cfb3827d9342eab$var$tokenizeListStart
};
/** @type {Construct} */ const $7cfb3827d9342eab$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $7cfb3827d9342eab$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ const $7cfb3827d9342eab$var$indentConstruct = {
    partial: true,
    tokenize: $7cfb3827d9342eab$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7cfb3827d9342eab$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $1oKGI.asciiDigit)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $cukOH.thematicBreak), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $1oKGI.asciiDigit)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $gIDsK.blankLine), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($7cfb3827d9342eab$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $1oKGI.markdownSpace)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7cfb3827d9342eab$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $gIDsK.blankLine), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $16fb9.factorySpace)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $1oKGI.markdownSpace)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($7cfb3827d9342eab$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $16fb9.factorySpace)(effects, effects.attempt($7cfb3827d9342eab$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7cfb3827d9342eab$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $16fb9.factorySpace)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $7cfb3827d9342eab$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7cfb3827d9342eab$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $16fb9.factorySpace)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $1oKGI.markdownSpace)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

});
parcelRegister("cukOH", function(module, exports) {

$parcel$export(module.exports, "thematicBreak", function () { return $91786f29e547032c$export$ba7b13e047416c03; });
/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");
const $91786f29e547032c$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $91786f29e547032c$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $91786f29e547032c$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $1oKGI.markdownLineEnding)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $1oKGI.markdownSpace)(code) ? (0, $16fb9.factorySpace)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}

});


parcelRegister("8KDly", function(module, exports) {

$parcel$export(module.exports, "setextUnderline", function () { return $65f1240884eb2a90$export$e104e2de391dfde9; });
/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
var $dok7x = parcelRequire("dok7x");

var $16fb9 = parcelRequire("16fb9");

var $1oKGI = parcelRequire("1oKGI");
const $65f1240884eb2a90$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $65f1240884eb2a90$var$resolveToSetextUnderline,
    tokenize: $65f1240884eb2a90$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $65f1240884eb2a90$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: (0, $dok7x._)({}, events[content][1].start),
        end: (0, $dok7x._)({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = (0, $dok7x._)({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $65f1240884eb2a90$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $1oKGI.markdownSpace)(code) ? (0, $16fb9.factorySpace)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $1oKGI.markdownLineEnding)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}

});


parcelRegister("4ofeF", function(module, exports) {

$parcel$export(module.exports, "createTokenizer", function () { return $332538c1f7ca7546$export$ae34f10ee4b29837; });
/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 
var $1oKGI = parcelRequire("1oKGI");

var $2JkHA = parcelRequire("2JkHA");

var $cJuDb = parcelRequire("cJuDb");
function $332538c1f7ca7546$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $2JkHA.push)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $cJuDb.resolveAll)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $332538c1f7ca7546$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $332538c1f7ca7546$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { _bufferIndex: _bufferIndex, _index: _index, line: line, column: column, offset: offset } = point;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $1oKGI.markdownLineEnding)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const left = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(left) ? left : left ? [
                            left
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $2JkHA.splice)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $332538c1f7ca7546$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $332538c1f7ca7546$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}

});


parcelRegister("fGfKR", function(module, exports) {

$parcel$export(module.exports, "postprocess", function () { return $b6a6ffd21b56571c$export$bd0e6e1378a871d7; });
/**
 * @import {Event} from 'micromark-util-types'
 */ 
var $dCkao = parcelRequire("dCkao");
function $b6a6ffd21b56571c$export$bd0e6e1378a871d7(events) {
    while(!(0, $dCkao.subtokenize)(events));
    return events;
}

});

parcelRegister("hyF31", function(module, exports) {

$parcel$export(module.exports, "preprocess", function () { return $034c799c5600f8bc$export$fc37fe19dfda43ee; });
/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ const $034c799c5600f8bc$var$search = /[\0\t\n\r]/g;
function $034c799c5600f8bc$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $034c799c5600f8bc$var$search.lastIndex = startPosition;
            match = $034c799c5600f8bc$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}

});


parcelRegister("gwlv9", function(module, exports) {

$parcel$export(module.exports, "decodeString", function () { return $c070503813194e1e$export$a0fb664af7d0cc44; });

var $iayRF = parcelRequire("iayRF");

var $5tGUI = parcelRequire("5tGUI");
const $c070503813194e1e$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $c070503813194e1e$export$a0fb664af7d0cc44(value) {
    return value.replace($c070503813194e1e$var$characterEscapeOrReference, $c070503813194e1e$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $c070503813194e1e$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $5tGUI.decodeNumericCharacterReference)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $iayRF.decodeNamedCharacterReference)($2) || $0;
}

});



parcelRegister("l9TDx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f675988d0e4e9a4c$export$2e2bcd8739ae039; });
/**
 * @import {Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {Options as ToHastOptions} from 'mdast-util-to-hast'
 * @import {Processor} from 'unified'
 * @import {VFile} from 'vfile'
 */ /**
 * @typedef {Omit<ToHastOptions, 'file'>} Options
 *
 * @callback TransformBridge
 *   Bridge-mode.
 *
 *   Runs the destination with the new hast tree.
 *   Discards result.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {Promise<undefined>}
 *   Nothing.
 *
 * @callback TransformMutate
 *  Mutate-mode.
 *
 *  Further transformers run on the hast tree.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {HastRoot}
 *   Tree (hast).
 */ 
var $dok7x = parcelRequire("dok7x");

var $lLUMR = parcelRequire("lLUMR");
function $f675988d0e4e9a4c$export$2e2bcd8739ae039(destination, options) {
    if (destination && 'run' in destination) /**
     * @type {TransformBridge}
     */ return async function(tree, file) {
        // Cast because root in -> root out.
        const hastTree = /** @type {HastRoot} */ (0, $lLUMR.toHast)(tree, (0, $dok7x._)({
            file: file
        }, options));
        await destination.run(hastTree, file);
    };
    /**
   * @type {TransformMutate}
   */ return function(tree, file) {
        // Cast because root in -> root out.
        // To do: in the future, disallow ` || options` fallback.
        // With `unified-engine`, `destination` can be `undefined` but
        // `options` will be the file set.
        // We should not pass that as `options`.
        return /** @type {HastRoot} */ (0, $lLUMR.toHast)(tree, (0, $dok7x._)({
            file: file
        }, destination || options));
    };
}

});
parcelRegister("lLUMR", function(module, exports) {

$parcel$export(module.exports, "toHast", function () { return $fd9a097d270a275b$export$c0e4c5cf07538633; });
/**
 * @import {Nodes as HastNodes} from 'hast'
 * @import {Nodes as MdastNodes} from 'mdast'
 * @import {Options} from './state.js'
 */ 
var $jJcE6 = parcelRequire("jJcE6");

var $ePEUC = parcelRequire("ePEUC");

var $9vyP4 = parcelRequire("9vyP4");
function $fd9a097d270a275b$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $9vyP4.createState)(tree, options);
    const node = state.one(tree, undefined);
    const foot = (0, $ePEUC.footer)(state);
    /** @type {HastNodes} */ const result = Array.isArray(node) ? {
        type: 'root',
        children: node
    } : node || {
        type: 'root',
        children: []
    };
    if (foot) {
        // If there’s a footer, there were definitions, meaning block
        // content.
        // So `result` is a parent node.
        (0, $jJcE6.ok)('children' in result);
        result.children.push({
            type: 'text',
            value: '\n'
        }, foot);
    }
    return result;
}

});
parcelRegister("ePEUC", function(module, exports) {

$parcel$export(module.exports, "footer", function () { return $acc59070c16cb6f2$export$adb608be33961c98; });
/**
 * @import {ElementContent, Element} from 'hast'
 * @import {State} from './state.js'
 */ /**
 * @callback FootnoteBackContentTemplate
 *   Generate content for the backreference dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent> | ElementContent | string}
 *   Content for the backreference when linking back from definitions to their
 *   reference.
 *
 * @callback FootnoteBackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ 
var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $e44WP = parcelRequire("e44WP");

var $Uii3m = parcelRequire("Uii3m");
function $acc59070c16cb6f2$export$4a6e1c4b9e5bc5d1(_, rereferenceIndex) {
    /** @type {Array<ElementContent>} */ const result = [
        {
            type: 'text',
            value: "\u21A9"
        }
    ];
    if (rereferenceIndex > 1) result.push({
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            {
                type: 'text',
                value: String(rereferenceIndex)
            }
        ]
    });
    return result;
}
function $acc59070c16cb6f2$export$d83e66a407212d3b(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $acc59070c16cb6f2$export$adb608be33961c98(state) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const footnoteBackContent = state.options.footnoteBackContent || $acc59070c16cb6f2$export$4a6e1c4b9e5bc5d1;
    const footnoteBackLabel = state.options.footnoteBackLabel || $acc59070c16cb6f2$export$d83e66a407212d3b;
    const footnoteLabel = state.options.footnoteLabel || 'Footnotes';
    const footnoteLabelTagName = state.options.footnoteLabelTagName || 'h2';
    const footnoteLabelProperties = state.options.footnoteLabelProperties || {
        className: [
            'sr-only'
        ]
    };
    /** @type {Array<ElementContent>} */ const listItems = [];
    let referenceIndex = -1;
    while(++referenceIndex < state.footnoteOrder.length){
        const definition = state.footnoteById.get(state.footnoteOrder[referenceIndex]);
        if (!definition) continue;
        const content = state.all(definition);
        const id = String(definition.identifier).toUpperCase();
        const safeId = (0, $Uii3m.normalizeUri)(id.toLowerCase());
        let rereferenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        const counts = state.footnoteCounts.get(id);
        // eslint-disable-next-line no-unmodified-loop-condition
        while(counts !== undefined && ++rereferenceIndex <= counts){
            if (backReferences.length > 0) backReferences.push({
                type: 'text',
                value: ' '
            });
            let children = typeof footnoteBackContent === 'string' ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
            if (typeof children === 'string') children = {
                type: 'text',
                value: children
            };
            backReferences.push({
                type: 'element',
                tagName: 'a',
                properties: {
                    href: '#' + clobberPrefix + 'fnref-' + safeId + (rereferenceIndex > 1 ? '-' + rereferenceIndex : ''),
                    dataFootnoteBackref: '',
                    ariaLabel: typeof footnoteBackLabel === 'string' ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
                    className: [
                        'data-footnote-backref'
                    ]
                },
                children: Array.isArray(children) ? children : [
                    children
                ]
            });
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === 'element' && tail.tagName === 'p') {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === 'text') tailTail.value += ' ';
            else tail.children.push({
                type: 'text',
                value: ' '
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: 'element',
            tagName: 'li',
            properties: {
                id: clobberPrefix + 'fn-' + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(definition, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: 'element',
        tagName: 'section',
        properties: {
            dataFootnotes: true,
            className: [
                'footnotes'
            ]
        },
        children: [
            {
                type: 'element',
                tagName: footnoteLabelTagName,
                properties: (0, $cNnl8._)((0, $dok7x._)({}, (0, $e44WP.default)(footnoteLabelProperties)), {
                    id: 'footnote-label'
                }),
                children: [
                    {
                        type: 'text',
                        value: footnoteLabel
                    }
                ]
            },
            {
                type: 'text',
                value: '\n'
            },
            {
                type: 'element',
                tagName: 'ol',
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: 'text',
                value: '\n'
            }
        ]
    };
}

});
parcelRegister("e44WP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3d546f78d2de11a$export$2e2bcd8739ae039; });

var $5bGVb = parcelRequire("5bGVb");

var $cmmOw = parcelRequire("cmmOw");
var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $a3d546f78d2de11a$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ (any, options)=>options && ('json' in options || 'lossy' in options) ? (0, $5bGVb.deserialize)((0, $cmmOw.serialize)(any, options)) : structuredClone(any) : (any, options)=>(0, $5bGVb.deserialize)((0, $cmmOw.serialize)(any, options));

});
parcelRegister("5bGVb", function(module, exports) {

$parcel$export(module.exports, "deserialize", function () { return $3c6f461807a21308$export$efcd34ab6248d3cd; });

var $ipAyg = parcelRequire("ipAyg");
const $3c6f461807a21308$var$env = typeof self === 'object' ? self : globalThis;
const $3c6f461807a21308$var$guard = (name, init)=>{
    switch(name){
        case 'Function':
        case 'SharedWorker':
        case 'Worker':
        case 'eval':
        case 'setInterval':
        case 'setTimeout':
            throw new TypeError('unable to deserialize ' + name);
    }
    return new $3c6f461807a21308$var$env[name](init);
};
const $3c6f461807a21308$var$deserializer = ($, _)=>{
    const as = (out, index)=>{
        $.set(index, out);
        return out;
    };
    const unpair = (index)=>{
        if ($.has(index)) return $.get(index);
        const [type, value] = _[index];
        switch(type){
            case 0, $ipAyg.PRIMITIVE:
            case 0, $ipAyg.VOID:
                return as(value, index);
            case 0, $ipAyg.ARRAY:
                {
                    const arr = as([], index);
                    for (const index of value)arr.push(unpair(index));
                    return arr;
                }
            case 0, $ipAyg.OBJECT:
                {
                    const object = as({}, index);
                    for (const [key, index] of value)object[unpair(key)] = unpair(index);
                    return object;
                }
            case 0, $ipAyg.DATE:
                return as(new Date(value), index);
            case 0, $ipAyg.REGEXP:
                {
                    const { source: source, flags: flags } = value;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $ipAyg.MAP:
                {
                    const map = as(new Map, index);
                    for (const [key, index] of value)map.set(unpair(key), unpair(index));
                    return map;
                }
            case 0, $ipAyg.SET:
                {
                    const set = as(new Set, index);
                    for (const index of value)set.add(unpair(index));
                    return set;
                }
            case 0, $ipAyg.ERROR:
                {
                    const { name: name, message: message } = value;
                    return as($3c6f461807a21308$var$guard(name, message), index);
                }
            case 0, $ipAyg.BIGINT:
                return as(BigInt(value), index);
            case 'BigInt':
                return as(Object(BigInt(value)), index);
            case 'ArrayBuffer':
                return as(new Uint8Array(value).buffer, value);
            case 'DataView':
                {
                    const { buffer: buffer } = new Uint8Array(value);
                    return as(new DataView(buffer), value);
                }
        }
        return as($3c6f461807a21308$var$guard(type, value), index);
    };
    return unpair;
};
const $3c6f461807a21308$export$efcd34ab6248d3cd = (serialized)=>$3c6f461807a21308$var$deserializer(new Map, serialized)(0);

});
parcelRegister("ipAyg", function(module, exports) {

$parcel$export(module.exports, "VOID", function () { return $d676ea2c0e8a1d5a$export$1cd1943b3a73bbe8; });
$parcel$export(module.exports, "PRIMITIVE", function () { return $d676ea2c0e8a1d5a$export$a44b4f3d5b73db95; });
$parcel$export(module.exports, "ARRAY", function () { return $d676ea2c0e8a1d5a$export$b119f07080a207ba; });
$parcel$export(module.exports, "OBJECT", function () { return $d676ea2c0e8a1d5a$export$8b8a958a7f6f130c; });
$parcel$export(module.exports, "DATE", function () { return $d676ea2c0e8a1d5a$export$501a7fac1df67a49; });
$parcel$export(module.exports, "REGEXP", function () { return $d676ea2c0e8a1d5a$export$cd2b220b1ea851b2; });
$parcel$export(module.exports, "MAP", function () { return $d676ea2c0e8a1d5a$export$ce970371e0e850bc; });
$parcel$export(module.exports, "SET", function () { return $d676ea2c0e8a1d5a$export$5e8f180ef0142226; });
$parcel$export(module.exports, "ERROR", function () { return $d676ea2c0e8a1d5a$export$103bedf43ba882db; });
$parcel$export(module.exports, "BIGINT", function () { return $d676ea2c0e8a1d5a$export$9f2207c8fceeefa8; });
const $d676ea2c0e8a1d5a$export$1cd1943b3a73bbe8 = -1;
const $d676ea2c0e8a1d5a$export$a44b4f3d5b73db95 = 0;
const $d676ea2c0e8a1d5a$export$b119f07080a207ba = 1;
const $d676ea2c0e8a1d5a$export$8b8a958a7f6f130c = 2;
const $d676ea2c0e8a1d5a$export$501a7fac1df67a49 = 3;
const $d676ea2c0e8a1d5a$export$cd2b220b1ea851b2 = 4;
const $d676ea2c0e8a1d5a$export$ce970371e0e850bc = 5;
const $d676ea2c0e8a1d5a$export$5e8f180ef0142226 = 6;
const $d676ea2c0e8a1d5a$export$103bedf43ba882db = 7;
const $d676ea2c0e8a1d5a$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;

});


parcelRegister("cmmOw", function(module, exports) {

$parcel$export(module.exports, "serialize", function () { return $025278b788c1c2e4$export$dfdc1655ccc5b9cb; });

var $ipAyg = parcelRequire("ipAyg");
const $025278b788c1c2e4$var$EMPTY = '';
const { toString: $025278b788c1c2e4$var$toString } = {};
const { keys: $025278b788c1c2e4$var$keys } = Object;
const $025278b788c1c2e4$var$typeOf = (value)=>{
    const type = typeof value;
    if (type !== 'object' || !value) return [
        (0, $ipAyg.PRIMITIVE),
        type
    ];
    const asString = $025278b788c1c2e4$var$toString.call(value).slice(8, -1);
    switch(asString){
        case 'Array':
            return [
                (0, $ipAyg.ARRAY),
                $025278b788c1c2e4$var$EMPTY
            ];
        case 'Object':
            return [
                (0, $ipAyg.OBJECT),
                $025278b788c1c2e4$var$EMPTY
            ];
        case 'Date':
            return [
                (0, $ipAyg.DATE),
                $025278b788c1c2e4$var$EMPTY
            ];
        case 'RegExp':
            return [
                (0, $ipAyg.REGEXP),
                $025278b788c1c2e4$var$EMPTY
            ];
        case 'Map':
            return [
                (0, $ipAyg.MAP),
                $025278b788c1c2e4$var$EMPTY
            ];
        case 'Set':
            return [
                (0, $ipAyg.SET),
                $025278b788c1c2e4$var$EMPTY
            ];
        case 'DataView':
            return [
                (0, $ipAyg.ARRAY),
                asString
            ];
    }
    if (asString.includes('Array')) return [
        (0, $ipAyg.ARRAY),
        asString
    ];
    if (asString.includes('Error')) return [
        (0, $ipAyg.ERROR),
        asString
    ];
    return [
        (0, $ipAyg.OBJECT),
        asString
    ];
};
const $025278b788c1c2e4$var$shouldSkip = ([TYPE, type])=>TYPE === (0, $ipAyg.PRIMITIVE) && (type === 'function' || type === 'symbol');
const $025278b788c1c2e4$var$serializer = (strict, json, $, _)=>{
    const as = (out, value)=>{
        const index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    const pair = (value)=>{
        if ($.has(value)) return $.get(value);
        let [TYPE, type] = $025278b788c1c2e4$var$typeOf(value);
        switch(TYPE){
            case 0, $ipAyg.PRIMITIVE:
                {
                    let entry = value;
                    switch(type){
                        case 'bigint':
                            TYPE = (0, $ipAyg.BIGINT);
                            entry = value.toString();
                            break;
                        case 'function':
                        case 'symbol':
                            if (strict) throw new TypeError('unable to serialize ' + type);
                            entry = null;
                            break;
                        case 'undefined':
                            return as([
                                (0, $ipAyg.VOID)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $ipAyg.ARRAY:
                {
                    if (type) {
                        let spread = value;
                        if (type === 'DataView') spread = new Uint8Array(value.buffer);
                        else if (type === 'ArrayBuffer') spread = new Uint8Array(value);
                        return as([
                            type,
                            [
                                ...spread
                            ]
                        ], value);
                    }
                    const arr = [];
                    const index = as([
                        TYPE,
                        arr
                    ], value);
                    for (const entry of value)arr.push(pair(entry));
                    return index;
                }
            case 0, $ipAyg.OBJECT:
                {
                    if (type) switch(type){
                        case 'BigInt':
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case 'Boolean':
                        case 'Number':
                        case 'String':
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && 'toJSON' in value) return pair(value.toJSON());
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const key of $025278b788c1c2e4$var$keys(value))if (strict || !$025278b788c1c2e4$var$shouldSkip($025278b788c1c2e4$var$typeOf(value[key]))) entries.push([
                        pair(key),
                        pair(value[key])
                    ]);
                    return index;
                }
            case 0, $ipAyg.DATE:
                return as([
                    TYPE,
                    value.toISOString()
                ], value);
            case 0, $ipAyg.REGEXP:
                {
                    const { source: source, flags: flags } = value;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $ipAyg.MAP:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const [key, entry] of value)if (strict || !($025278b788c1c2e4$var$shouldSkip($025278b788c1c2e4$var$typeOf(key)) || $025278b788c1c2e4$var$shouldSkip($025278b788c1c2e4$var$typeOf(entry)))) entries.push([
                        pair(key),
                        pair(entry)
                    ]);
                    return index;
                }
            case 0, $ipAyg.SET:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const entry of value)if (strict || !$025278b788c1c2e4$var$shouldSkip($025278b788c1c2e4$var$typeOf(entry))) entries.push(pair(entry));
                    return index;
                }
        }
        const { message: message } = value;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
const $025278b788c1c2e4$export$dfdc1655ccc5b9cb = (value, { json: json, lossy: lossy } = {})=>{
    const _ = [];
    return $025278b788c1c2e4$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};

});



parcelRegister("9vyP4", function(module, exports) {

$parcel$export(module.exports, "createState", function () { return $6ec2055971aff55a$export$e6a0daad8304de; });
/**
 * @import {
 *   ElementContent as HastElementContent,
 *   Element as HastElement,
 *   Nodes as HastNodes,
 *   Properties as HastProperties,
 *   RootContent as HastRootContent,
 *   Text as HastText
 * } from 'hast'
 * @import {
 *   Definition as MdastDefinition,
 *   FootnoteDefinition as MdastFootnoteDefinition,
 *   Nodes as MdastNodes,
 *   Parents as MdastParents
 * } from 'mdast'
 * @import {VFile} from 'vfile'
 * @import {
 *   FootnoteBackContentTemplate,
 *   FootnoteBackLabelTemplate
 * } from './footer.js'
 */ /**
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | undefined} parent
 *   Parent of `node`.
 * @returns {Array<HastElementContent> | HastElementContent | undefined}
 *   hast node.
 *
 * @typedef {Partial<Record<MdastNodes['type'], Handler>>} Handlers
 *   Handle nodes.
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree (default:
 *   `false`).
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` property on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {VFile | null | undefined} [file]
 *   Corresponding virtual file representing the input document (optional).
 * @property {FootnoteBackContentTemplate | string | null | undefined} [footnoteBackContent]
 *   Content of the backreference back to references (default: `defaultFootnoteBackContent`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackContent(_, rereferenceIndex) {
 *     const result = [{type: 'text', value: '↩'}]
 *
 *     if (rereferenceIndex > 1) {
 *       result.push({
 *         type: 'element',
 *         tagName: 'sup',
 *         properties: {},
 *         children: [{type: 'text', value: String(rereferenceIndex)}]
 *       })
 *     }
 *
 *     return result
 *   }
 *   ```
 *
 *   This content is used in the `a` element of each backreference (the `↩`
 *   links).
 * @property {FootnoteBackLabelTemplate | string | null | undefined} [footnoteBackLabel]
 *   Label to describe the backreference back to references (default:
 *   `defaultFootnoteBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *   }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `ariaLabel` property on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (default: `{className:
 *   ['sr-only']}`).
 *
 *   Change it to show the label and add other properties.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different properties.
 *
 *   > **Note**: `id: 'footnote-label'` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes (optional).
 * @property {Array<MdastNodes['type']> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed)
 *   (optional).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes (optional).
 *
 * @typedef State
 *   Info passed around.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => HastElement | Type} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {Map<string, MdastDefinition>} definitionById
 *   Definitions by their identifier.
 * @property {Map<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Map<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {(node: MdastNodes, parent: MdastParents | undefined) => Array<HastElementContent> | HastElementContent | undefined} one
 *   Transform an mdast node to hast.
 * @property {Options} options
 *   Configuration.
 * @property {(from: MdastNodes, node: HastNodes) => undefined} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastRootContent>(nodes: Array<Type>, loose?: boolean | undefined) => Array<HastText | Type>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 */ 
var $dok7x = parcelRequire("dok7x");

var $6pkKu = parcelRequire("6pkKu");

var $e44WP = parcelRequire("e44WP");

var $01XIc = parcelRequire("01XIc");

var $i4y4M = parcelRequire("i4y4M");

var $lMizX = parcelRequire("lMizX");
const $6ec2055971aff55a$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $6ec2055971aff55a$var$emptyOptions = {};
function $6ec2055971aff55a$export$e6a0daad8304de(tree, options) {
    const settings = options || $6ec2055971aff55a$var$emptyOptions;
    /** @type {Map<string, MdastDefinition>} */ const definitionById = new Map();
    /** @type {Map<string, MdastFootnoteDefinition>} */ const footnoteById = new Map();
    /** @type {Map<string, number>} */ const footnoteCounts = new Map();
    /** @type {Handlers} */ // @ts-expect-error: the root handler returns a root.
    // Hard to type.
    const handlers = (0, $dok7x._)({}, (0, $lMizX.handlers), settings.handlers);
    /** @type {State} */ const state = {
        all: all,
        applyData: $6ec2055971aff55a$var$applyData,
        definitionById: definitionById,
        footnoteById: footnoteById,
        footnoteCounts: footnoteCounts,
        footnoteOrder: [],
        handlers: handlers,
        one: one,
        options: settings,
        patch: $6ec2055971aff55a$var$patch,
        wrap: $6ec2055971aff55a$export$4997ffc0176396a6
    };
    (0, $01XIc.visit)(tree, function(node) {
        if (node.type === 'definition' || node.type === 'footnoteDefinition') {
            const map = node.type === 'definition' ? definitionById : footnoteById;
            const id = String(node.identifier).toUpperCase();
            // Mimick CM behavior of link definitions.
            // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
            if (!map.has(id)) // @ts-expect-error: node type matches map.
            map.set(id, node);
        }
    });
    return state;
    /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */ function one(node, parent) {
        const type = node.type;
        const handle = state.handlers[type];
        if ($6ec2055971aff55a$var$own.call(state.handlers, type) && handle) return handle(state, node, parent);
        if (state.options.passThrough && state.options.passThrough.includes(type)) {
            if ('children' in node) {
                const { children: children } = node, shallow = (0, $6pkKu._)(node, [
                    "children"
                ]);
                const result = (0, $e44WP.default)(shallow);
                // @ts-expect-error: TS doesn’t understand…
                result.children = state.all(node);
                // @ts-expect-error: TS doesn’t understand…
                return result;
            }
            // @ts-expect-error: it’s custom.
            return (0, $e44WP.default)(node);
        }
        const unknown = state.options.unknownHandler || $6ec2055971aff55a$var$defaultUnknownHandler;
        return unknown(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function all(parent) {
        /** @type {Array<HastElementContent>} */ const values = [];
        if ('children' in parent) {
            const nodes = parent.children;
            let index = -1;
            while(++index < nodes.length){
                const result = state.one(nodes[index], parent);
                // To do: see if we van clean this? Can we merge texts?
                if (result) {
                    if (index && nodes[index - 1].type === 'break') {
                        if (!Array.isArray(result) && result.type === 'text') result.value = $6ec2055971aff55a$var$trimMarkdownSpaceStart(result.value);
                        if (!Array.isArray(result) && result.type === 'element') {
                            const head = result.children[0];
                            if (head && head.type === 'text') head.value = $6ec2055971aff55a$var$trimMarkdownSpaceStart(head.value);
                        }
                    }
                    if (Array.isArray(result)) values.push(...result);
                    else values.push(result);
                }
            }
        }
        return values;
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */ function $6ec2055971aff55a$var$patch(from, to) {
    if (from.position) to.position = (0, $i4y4M.position)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */ function $6ec2055971aff55a$var$applyData(from, to) {
    /** @type {HastElement | Type} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === 'string') {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === 'element') result.tagName = hName;
            else {
                /** @type {Array<HastElementContent>} */ // @ts-expect-error: assume no doctypes in `root`.
                const children = 'children' in result ? result.children : [
                    result
                ];
                result = {
                    type: 'element',
                    tagName: hName,
                    properties: {},
                    children: children
                };
            }
        }
        if (result.type === 'element' && hProperties) Object.assign(result.properties, (0, $e44WP.default)(hProperties));
        if ('children' in result && result.children && hChildren !== null && hChildren !== undefined) result.children = hChildren;
    }
    return result;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */ function $6ec2055971aff55a$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastElement | HastText} */ const result = 'value' in node && !($6ec2055971aff55a$var$own.call(data, 'hProperties') || $6ec2055971aff55a$var$own.call(data, 'hChildren')) ? {
        type: 'text',
        value: node.value
    } : {
        type: 'element',
        tagName: 'div',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $6ec2055971aff55a$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<HastText | Type>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: 'text',
        value: '\n'
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: 'text',
            value: '\n'
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: 'text',
        value: '\n'
    });
    return result;
}
/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */ function $6ec2055971aff55a$var$trimMarkdownSpaceStart(value) {
    let index = 0;
    let code = value.charCodeAt(index);
    while(code === 9 || code === 32){
        index++;
        code = value.charCodeAt(index);
    }
    return value.slice(index);
}

});
parcelRegister("01XIc", function(module, exports) {

$parcel$export(module.exports, "visit", function () { return $005e69ad51f535e9$export$bf638b60ea8b89b7; });
/**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 * @import {VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<any>
 *   ? MatchesOne<Value, Check[number]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 
var $a87uF = parcelRequire("a87uF");
function $005e69ad51f535e9$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $a87uF.visitParents)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}

});
parcelRegister("a87uF", function(module, exports) {

$parcel$export(module.exports, "visitParents", function () { return $760076cc82d62528$export$70008a21eb6de899; });
/**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<infer T>
 *   ? MatchesOne<Value, T>
 *   : Check extends Array<infer T>
 *   ? MatchesOne<Value, T>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 
var $3XMvG = parcelRequire("3XMvG");

var $da8kZ = parcelRequire("da8kZ");
/** @type {Readonly<ActionTuple>} */ const $760076cc82d62528$var$empty = [];
const $760076cc82d62528$export$f4d8133c446fe484 = true;
const $760076cc82d62528$export$7f100f842f565dc9 = false;
const $760076cc82d62528$export$8773f85c2fb2c116 = 'skip';
function $760076cc82d62528$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $3XMvG.convert)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $da8kZ.color)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $760076cc82d62528$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $760076cc82d62528$var$toResult(visitor(node, parents));
                if (result[0] === $760076cc82d62528$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $760076cc82d62528$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $760076cc82d62528$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $760076cc82d62528$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $760076cc82d62528$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $760076cc82d62528$var$empty : [
        value
    ];
}

});
parcelRegister("3XMvG", function(module, exports) {

$parcel$export(module.exports, "convert", function () { return $2e2c82d837ab2e57$export$9c68d69a4c5bbcf9; });
/**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $2e2c82d837ab2e57$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $2e2c82d837ab2e57$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$2e2c82d837ab2e57$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $2e2c82d837ab2e57$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $2e2c82d837ab2e57$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $2e2c82d837ab2e57$var$ok;
    if (typeof test === 'function') return $2e2c82d837ab2e57$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $2e2c82d837ab2e57$var$anyFactory(test) : // narrows to `Array`.
    $2e2c82d837ab2e57$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $2e2c82d837ab2e57$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $2e2c82d837ab2e57$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $2e2c82d837ab2e57$export$9c68d69a4c5bbcf9(tests[index]);
    return $2e2c82d837ab2e57$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $2e2c82d837ab2e57$var$propertiesFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $2e2c82d837ab2e57$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $2e2c82d837ab2e57$var$typeFactory(check) {
    return $2e2c82d837ab2e57$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $2e2c82d837ab2e57$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($2e2c82d837ab2e57$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $2e2c82d837ab2e57$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $2e2c82d837ab2e57$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}

});

parcelRegister("da8kZ", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $9952ad2edd2268ba$export$35e9368ef982300f; });
/**
 * @param {string} d
 * @returns {string}
 */ function $9952ad2edd2268ba$export$35e9368ef982300f(d) {
    return d;
}

});



parcelRegister("lMizX", function(module, exports) {

$parcel$export(module.exports, "handlers", function () { return $fdac7e0a0507d875$export$455ce229eb3d2472; });
/**
 * @import {Handlers} from '../state.js'
 */ 
var $bPhGT = parcelRequire("bPhGT");

var $gP6CE = parcelRequire("gP6CE");

var $7tI4h = parcelRequire("7tI4h");

var $3EMzF = parcelRequire("3EMzF");

var $52itn = parcelRequire("52itn");

var $idhd3 = parcelRequire("idhd3");

var $jwNO5 = parcelRequire("jwNO5");

var $ezYNX = parcelRequire("ezYNX");

var $iYW4G = parcelRequire("iYW4G");

var $fyrTR = parcelRequire("fyrTR");

var $ecH5F = parcelRequire("ecH5F");

var $abY8r = parcelRequire("abY8r");

var $6kyEY = parcelRequire("6kyEY");

var $2KI5b = parcelRequire("2KI5b");

var $a1s0i = parcelRequire("a1s0i");

var $4k1Jb = parcelRequire("4k1Jb");

var $dN4Hh = parcelRequire("dN4Hh");

var $apIAg = parcelRequire("apIAg");

var $ftoUP = parcelRequire("ftoUP");

var $5jNxA = parcelRequire("5jNxA");

var $hIhhO = parcelRequire("hIhhO");

var $Pqw04 = parcelRequire("Pqw04");

var $8W445 = parcelRequire("8W445");
const $fdac7e0a0507d875$export$455ce229eb3d2472 = {
    blockquote: $bPhGT.blockquote,
    break: (0, $gP6CE.hardBreak),
    code: $7tI4h.code,
    delete: (0, $3EMzF.strikethrough),
    emphasis: $52itn.emphasis,
    footnoteReference: $idhd3.footnoteReference,
    heading: $jwNO5.heading,
    html: $ezYNX.html,
    imageReference: $iYW4G.imageReference,
    image: $fyrTR.image,
    inlineCode: $ecH5F.inlineCode,
    linkReference: $abY8r.linkReference,
    link: $6kyEY.link,
    listItem: $2KI5b.listItem,
    list: $a1s0i.list,
    paragraph: $4k1Jb.paragraph,
    root: // @ts-expect-error: root is different, but hard to type.
    $dN4Hh.root,
    strong: $apIAg.strong,
    table: $ftoUP.table,
    tableCell: $hIhhO.tableCell,
    tableRow: $5jNxA.tableRow,
    text: $Pqw04.text,
    thematicBreak: $8W445.thematicBreak,
    toml: $fdac7e0a0507d875$var$ignore,
    yaml: $fdac7e0a0507d875$var$ignore,
    definition: $fdac7e0a0507d875$var$ignore,
    footnoteDefinition: $fdac7e0a0507d875$var$ignore
};
// Return nothing for nodes that are ignored.
function $fdac7e0a0507d875$var$ignore() {
    return undefined;
}

});
parcelRegister("bPhGT", function(module, exports) {

$parcel$export(module.exports, "blockquote", function () { return $89c22e2570cec8c5$export$67dc04e652a298ca; });
/**
 * @import {Element} from 'hast'
 * @import {Blockquote} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $89c22e2570cec8c5$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'blockquote',
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("gP6CE", function(module, exports) {

$parcel$export(module.exports, "hardBreak", function () { return $c3f68bcfbd43cbb5$export$371da9dd35aba193; });
/**
 * @import {Element, Text} from 'hast'
 * @import {Break} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $c3f68bcfbd43cbb5$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'br',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: 'text',
            value: '\n'
        }
    ];
}

});

parcelRegister("7tI4h", function(module, exports) {

$parcel$export(module.exports, "code", function () { return $571d6cdb334b0df9$export$6565f9f03506010b; });
/**
 * @import {Element, Properties} from 'hast'
 * @import {Code} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $571d6cdb334b0df9$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + '\n' : '';
    /** @type {Properties} */ const properties = {};
    // Someone can write `js&#x20;python&#x9;ruby`.
    const language = node.lang ? node.lang.split(/\s+/) : [];
    // GH/CM still drop the non-first languages.
    if (language.length > 0) properties.className = [
        'language-' + language[0]
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: 'element',
        tagName: 'code',
        properties: properties,
        children: [
            {
                type: 'text',
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: 'element',
        tagName: 'pre',
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}

});

parcelRegister("3EMzF", function(module, exports) {

$parcel$export(module.exports, "strikethrough", function () { return $2a9ac963b6d74257$export$19426ff118fe8be; });
/**
 * @import {Element} from 'hast'
 * @import {Delete} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $2a9ac963b6d74257$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'del',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("52itn", function(module, exports) {

$parcel$export(module.exports, "emphasis", function () { return $3aab77f433d90fcb$export$bef81ba411953b51; });
/**
 * @import {Element} from 'hast'
 * @import {Emphasis} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $3aab77f433d90fcb$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'em',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("idhd3", function(module, exports) {

$parcel$export(module.exports, "footnoteReference", function () { return $d426ca53a8a9eaec$export$7f87ee744075c1ba; });
/**
 * @import {Element} from 'hast'
 * @import {FootnoteReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
var $Uii3m = parcelRequire("Uii3m");
function $d426ca53a8a9eaec$export$7f87ee744075c1ba(state, node) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $Uii3m.normalizeUri)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    let reuseCounter = state.footnoteCounts.get(id);
    if (reuseCounter === undefined) {
        reuseCounter = 0;
        state.footnoteOrder.push(id);
        counter = state.footnoteOrder.length;
    } else counter = index + 1;
    reuseCounter += 1;
    state.footnoteCounts.set(id, reuseCounter);
    /** @type {Element} */ const link = {
        type: 'element',
        tagName: 'a',
        properties: {
            href: '#' + clobberPrefix + 'fn-' + safeId,
            id: clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : ''),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                'footnote-label'
            ]
        },
        children: [
            {
                type: 'text',
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}

});

parcelRegister("jwNO5", function(module, exports) {

$parcel$export(module.exports, "heading", function () { return $e377a411f144c65c$export$46e4a324ac90507f; });
/**
 * @import {Element} from 'hast'
 * @import {Heading} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $e377a411f144c65c$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'h' + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("ezYNX", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $a9d38028026b000a$export$c0bb0b647f701bb5; });
/**
 * @import {Element} from 'hast'
 * @import {Html} from 'mdast'
 * @import {State} from '../state.js'
 * @import {Raw} from '../../index.js'
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Element | Raw | undefined}
 *   hast node.
 */ function $a9d38028026b000a$export$c0bb0b647f701bb5(state, node) {
    if (state.options.allowDangerousHtml) {
        /** @type {Raw} */ const result = {
            type: 'raw',
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    return undefined;
}

});

parcelRegister("iYW4G", function(module, exports) {

$parcel$export(module.exports, "imageReference", function () { return $dd1ae0febe0ef982$export$f281796f6bc3b8db; });
/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {ImageReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
var $Uii3m = parcelRequire("Uii3m");

var $bfLVi = parcelRequire("bfLVi");
function $dd1ae0febe0ef982$export$f281796f6bc3b8db(state, node) {
    const id = String(node.identifier).toUpperCase();
    const definition = state.definitionById.get(id);
    if (!definition) return (0, $bfLVi.revert)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $Uii3m.normalizeUri)(definition.url || ''),
        alt: node.alt
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});
parcelRegister("bfLVi", function(module, exports) {

$parcel$export(module.exports, "revert", function () { return $831644f53e10e723$export$3fdd26f3d9e7dc78; });
/**
 * @import {ElementContent} from 'hast'
 * @import {Reference, Nodes} from 'mdast'
 * @import {State} from './state.js'
 */ /**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Extract<Nodes, Reference>} node
 *   Reference node (image, link).
 * @returns {Array<ElementContent>}
 *   hast content.
 */ function $831644f53e10e723$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = ']';
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return [
        {
            type: 'text',
            value: '![' + node.alt + suffix
        }
    ];
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift({
        type: 'text',
        value: '['
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push({
        type: 'text',
        value: suffix
    });
    return contents;
}

});


parcelRegister("fyrTR", function(module, exports) {

$parcel$export(module.exports, "image", function () { return $b52fac5db966b5af$export$5c452ff88e35e47d; });
/**
 * @import {Element, Properties} from 'hast'
 * @import {Image} from 'mdast'
 * @import {State} from '../state.js'
 */ 
var $Uii3m = parcelRequire("Uii3m");
function $b52fac5db966b5af$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $Uii3m.normalizeUri)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("ecH5F", function(module, exports) {

$parcel$export(module.exports, "inlineCode", function () { return $a5739c8e9551afca$export$91b9bee19a0d8569; });
/**
 * @import {Element, Text} from 'hast'
 * @import {InlineCode} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $a5739c8e9551afca$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: 'text',
        value: node.value.replace(/\r?\n|\r/g, ' ')
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'code',
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("abY8r", function(module, exports) {

$parcel$export(module.exports, "linkReference", function () { return $76b99409a761c7f0$export$e6c469b1b7b2bc6a; });
/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {LinkReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
var $Uii3m = parcelRequire("Uii3m");

var $bfLVi = parcelRequire("bfLVi");
function $76b99409a761c7f0$export$e6c469b1b7b2bc6a(state, node) {
    const id = String(node.identifier).toUpperCase();
    const definition = state.definitionById.get(id);
    if (!definition) return (0, $bfLVi.revert)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $Uii3m.normalizeUri)(definition.url || '')
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("6kyEY", function(module, exports) {

$parcel$export(module.exports, "link", function () { return $49bf7f15f299c205$export$9c30223ca0a664fb; });
/**
 * @import {Element, Properties} from 'hast'
 * @import {Link} from 'mdast'
 * @import {State} from '../state.js'
 */ 
var $Uii3m = parcelRequire("Uii3m");
function $49bf7f15f299c205$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $Uii3m.normalizeUri)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("2KI5b", function(module, exports) {

$parcel$export(module.exports, "listItem", function () { return $201212847b048595$export$76c7e83ecc9cdf05; });
/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {ListItem, Parents} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $201212847b048595$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $201212847b048595$var$listLoose(parent) : $201212847b048595$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === 'boolean') {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === 'element' && head.tagName === 'p') paragraph = head;
        else {
            paragraph = {
                type: 'element',
                tagName: 'p',
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: 'text',
            value: ' '
        });
        paragraph.children.unshift({
            type: 'element',
            tagName: 'input',
            properties: {
                type: 'checkbox',
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            'task-list-item'
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== 'element' || child.tagName !== 'p') children.push({
            type: 'text',
            value: '\n'
        });
        if (child.type === 'element' && child.tagName === 'p' && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) children.push({
        type: 'text',
        value: '\n'
    });
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'li',
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $201212847b048595$var$listLoose(node) {
    let loose = false;
    if (node.type === 'list') {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $201212847b048595$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $201212847b048595$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === null || spread === undefined ? node.children.length > 1 : spread;
}

});

parcelRegister("a1s0i", function(module, exports) {

$parcel$export(module.exports, "list", function () { return $74bfb854373735bf$export$8837f4fc672e936d; });
/**
 * @import {Element, Properties} from 'hast'
 * @import {List} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $74bfb854373735bf$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === 'number' && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === 'element' && child.tagName === 'li' && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes('task-list-item')) {
            properties.className = [
                'contains-task-list'
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: node.ordered ? 'ol' : 'ul',
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("4k1Jb", function(module, exports) {

$parcel$export(module.exports, "paragraph", function () { return $325a5ec87f6e6083$export$9c206ddddb32a9b; });
/**
 * @import {Element} from 'hast'
 * @import {Paragraph} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $325a5ec87f6e6083$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'p',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("dN4Hh", function(module, exports) {

$parcel$export(module.exports, "root", function () { return $a0a37eafde82eaa9$export$e8e78c978b129247; });
/**
 * @import {Parents as HastParents, Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastParents}
 *   hast node.
 */ function $a0a37eafde82eaa9$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: 'root',
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("apIAg", function(module, exports) {

$parcel$export(module.exports, "strong", function () { return $794ed29caf583a6b$export$59ae2c325a998f89; });
/**
 * @import {Element} from 'hast'
 * @import {Strong} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $794ed29caf583a6b$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'strong',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("ftoUP", function(module, exports) {

$parcel$export(module.exports, "table", function () { return $b43ce4242729dd26$export$9852986a3ec5f6a0; });
/**
 * @import {Table} from 'mdast'
 * @import {Element} from 'hast'
 * @import {State} from '../state.js'
 */ 
var $i4y4M = parcelRequire("i4y4M");
function $b43ce4242729dd26$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: 'element',
            tagName: 'thead',
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: 'element',
            tagName: 'tbody',
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $i4y4M.pointStart)(node.children[1]);
        const end = (0, $i4y4M.pointEnd)(node.children[node.children.length - 1]);
        if (start && end) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'table',
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("5jNxA", function(module, exports) {

$parcel$export(module.exports, "tableRow", function () { return $3df527d6a43c3d3b$export$ce666bf02318c957; });
/**
 * @import {Element, ElementContent, Properties} from 'hast'
 * @import {Parents, TableRow} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $3df527d6a43c3d3b$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? 'th' : 'td';
    // To do: option to use `style`?
    const align = parent && parent.type === 'table' ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: 'element',
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(cell, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'tr',
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("hIhhO", function(module, exports) {

$parcel$export(module.exports, "tableCell", function () { return $ce53f4694b9dcfd7$export$e1e720e5f4603e6a; });
/**
 * @import {Element} from 'hast'
 * @import {TableCell} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $ce53f4694b9dcfd7$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'td',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("Pqw04", function(module, exports) {

$parcel$export(module.exports, "text", function () { return $09a954e34a1b5e9c$export$6f093cfa640b7166; });
/**
 * @import {Element as HastElement, Text as HastText} from 'hast'
 * @import {Text as MdastText} from 'mdast'
 * @import {State} from '../state.js'
 */ 
var $lriX3 = parcelRequire("lriX3");
function $09a954e34a1b5e9c$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: 'text',
        value: (0, $lriX3.trimLines)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});
parcelRegister("lriX3", function(module, exports) {

$parcel$export(module.exports, "trimLines", function () { return $f9bad1f7bf6ab98f$export$a771f20bdd13def9; });
const $f9bad1f7bf6ab98f$var$tab = 9 /* `\t` */ ;
const $f9bad1f7bf6ab98f$var$space = 32 /* ` ` */ ;
function $f9bad1f7bf6ab98f$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($f9bad1f7bf6ab98f$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($f9bad1f7bf6ab98f$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $f9bad1f7bf6ab98f$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $f9bad1f7bf6ab98f$var$tab || code === $f9bad1f7bf6ab98f$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $f9bad1f7bf6ab98f$var$tab || code === $f9bad1f7bf6ab98f$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}

});


parcelRegister("8W445", function(module, exports) {

$parcel$export(module.exports, "thematicBreak", function () { return $6816e4b92400e060$export$ba7b13e047416c03; });
/**
 * @import {Element} from 'hast'
 * @import {ThematicBreak} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $6816e4b92400e060$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'hr',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});





parcelRegister("bE3WT", function(module, exports) {

$parcel$export(module.exports, "unified", function () { return $87a67e4d701c7844$export$7cc1b2fe10c52bb; });
/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */ /**
 * @typedef {CompileResultMap[keyof CompileResultMap]} CompileResults
 *   Acceptable results from compilers.
 *
 *   To register custom results, add them to
 *   {@linkcode CompileResultMap}.
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the compiler receives (default: `Node`).
 * @template {CompileResults} [Result=CompileResults]
 *   The thing that the compiler yields (default: `CompileResults`).
 * @callback Compiler
 *   A **compiler** handles the compiling of a syntax tree to something else
 *   (in most cases, text) (TypeScript type).
 *
 *   It is used in the stringify phase and called with a {@linkcode Node}
 *   and {@linkcode VFile} representation of the document to compile.
 *   It should return the textual representation of the given tree (typically
 *   `string`).
 *
 *   > **Note**: unified typically compiles by serializing: most compilers
 *   > return `string` (or `Uint8Array`).
 *   > Some compilers, such as the one configured with
 *   > [`rehype-react`][rehype-react], return other values (in this case, a
 *   > React tree).
 *   > If you’re using a compiler that doesn’t serialize, expect different
 *   > result values.
 *   >
 *   > To register custom results in TypeScript, add them to
 *   > {@linkcode CompileResultMap}.
 *
 *   [rehype-react]: https://github.com/rehypejs/rehype-react
 * @param {Tree} tree
 *   Tree to compile.
 * @param {VFile} file
 *   File associated with `tree`.
 * @returns {Result}
 *   New content: compiled text (`string` or `Uint8Array`, for `file.value`) or
 *   something else (for `file.result`).
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the parser yields (default: `Node`)
 * @callback Parser
 *   A **parser** handles the parsing of text to a syntax tree.
 *
 *   It is used in the parse phase and is called with a `string` and
 *   {@linkcode VFile} of the document to parse.
 *   It must return the syntax tree representation of the given file
 *   ({@linkcode Node}).
 * @param {string} document
 *   Document to parse.
 * @param {VFile} file
 *   File associated with `document`.
 * @returns {Tree}
 *   Node representing the given file.
 */ /**
 * @typedef {(
 *   Plugin<Array<any>, any, any> |
 *   PluginTuple<Array<any>, any, any> |
 *   Preset
 * )} Pluggable
 *   Union of the different ways to add plugins and settings.
 */ /**
 * @typedef {Array<Pluggable>} PluggableList
 *   List of plugins and presets.
 */ // Note: we can’t use `callback` yet as it messes up `this`:
//  <https://github.com/microsoft/TypeScript/issues/55197>.
/**
 * @template {Array<unknown>} [PluginParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=Node]
 *   Value that is expected as input (default: `Node`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=Input]
 *   Value that is yielded as output (default: `Input`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   (this: Processor, ...parameters: PluginParameters) =>
 *     Input extends string ? // Parser.
 *        Output extends Node | undefined ? undefined | void : never :
 *     Output extends CompileResults ? // Compiler.
 *        Input extends Node | undefined ? undefined | void : never :
 *     Transformer<
 *       Input extends Node ? Input : Node,
 *       Output extends Node ? Output : Node
 *     > | undefined | void
 * )} Plugin
 *   Single plugin.
 *
 *   Plugins configure the processors they are applied on in the following
 *   ways:
 *
 *   *   they change the processor, such as the parser, the compiler, or by
 *       configuring data
 *   *   they specify how to handle trees and files
 *
 *   In practice, they are functions that can receive options and configure the
 *   processor (`this`).
 *
 *   > **Note**: plugins are called when the processor is *frozen*, not when
 *   > they are applied.
 */ /**
 * Tuple of a plugin and its configuration.
 *
 * The first item is a plugin, the rest are its parameters.
 *
 * @template {Array<unknown>} [TupleParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=undefined]
 *   Value that is expected as input (optional).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=undefined] (optional).
 *   Value that is yielded as output.
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   [
 *     plugin: Plugin<TupleParameters, Input, Output>,
 *     ...parameters: TupleParameters
 *   ]
 * )} PluginTuple
 */ /**
 * @typedef Preset
 *   Sharable configuration.
 *
 *   They can contain plugins and settings.
 * @property {PluggableList | undefined} [plugins]
 *   List of plugins and presets (optional).
 * @property {Settings | undefined} [settings]
 *   Shared settings for parsers and compilers (optional).
 */ /**
 * @template {VFile} [File=VFile]
 *   The file that the callback receives (default: `VFile`).
 * @callback ProcessCallback
 *   Callback called when the process is done.
 *
 *   Called with either an error or a result.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {File | undefined} [file]
 *   Processed file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Tree=Node]
 *   The tree that the callback receives (default: `Node`).
 * @callback RunCallback
 *   Callback called when transformers are done.
 *
 *   Called with either an error or results.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {Tree | undefined} [tree]
 *   Transformed tree (optional).
 * @param {VFile | undefined} [file]
 *   File (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Output=Node]
 *   Node type that the transformer yields (default: `Node`).
 * @callback TransformCallback
 *   Callback passed to transforms.
 *
 *   If the signature of a `transformer` accepts a third argument, the
 *   transformer may perform asynchronous operations, and must call it.
 * @param {Error | undefined} [error]
 *   Fatal error to stop the process (optional).
 * @param {Output | undefined} [tree]
 *   New, changed, tree (optional).
 * @param {VFile | undefined} [file]
 *   New, changed, file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Input=Node]
 *   Node type that the transformer expects (default: `Node`).
 * @template {Node} [Output=Input]
 *   Node type that the transformer yields (default: `Input`).
 * @callback Transformer
 *   Transformers handle syntax trees and files.
 *
 *   They are functions that are called each time a syntax tree and file are
 *   passed through the run phase.
 *   When an error occurs in them (either because it’s thrown, returned,
 *   rejected, or passed to `next`), the process stops.
 *
 *   The run phase is handled by [`trough`][trough], see its documentation for
 *   the exact semantics of these functions.
 *
 *   > **Note**: you should likely ignore `next`: don’t accept it.
 *   > it supports callback-style async work.
 *   > But promises are likely easier to reason about.
 *
 *   [trough]: https://github.com/wooorm/trough#function-fninput-next
 * @param {Input} tree
 *   Tree to handle.
 * @param {VFile} file
 *   File to handle.
 * @param {TransformCallback<Output>} next
 *   Callback.
 * @returns {(
 *   Promise<Output | undefined | void> |
 *   Promise<never> | // For some reason this is needed separately.
 *   Output |
 *   Error |
 *   undefined |
 *   void
 * )}
 *   If you accept `next`, nothing.
 *   Otherwise:
 *
 *   *   `Error` — fatal error to stop the process
 *   *   `Promise<undefined>` or `undefined` — the next transformer keeps using
 *       same tree
 *   *   `Promise<Node>` or `Node` — new, changed, tree
 */ /**
 * @template {Node | undefined} ParseTree
 *   Output of `parse`.
 * @template {Node | undefined} HeadTree
 *   Input for `run`.
 * @template {Node | undefined} TailTree
 *   Output for `run`.
 * @template {Node | undefined} CompileTree
 *   Input of `stringify`.
 * @template {CompileResults | undefined} CompileResult
 *   Output of `stringify`.
 * @template {Node | string | undefined} Input
 *   Input of plugin.
 * @template Output
 *   Output of plugin (optional).
 * @typedef {(
 *   Input extends string
 *     ? Output extends Node | undefined
 *       ? // Parser.
 *         Processor<
 *           Output extends undefined ? ParseTree : Output,
 *           HeadTree,
 *           TailTree,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Output extends CompileResults
 *     ? Input extends Node | undefined
 *       ? // Compiler.
 *         Processor<
 *           ParseTree,
 *           HeadTree,
 *           TailTree,
 *           Input extends undefined ? CompileTree : Input,
 *           Output extends undefined ? CompileResult : Output
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Input extends Node | undefined
 *     ? Output extends Node | undefined
 *       ? // Transform.
 *         Processor<
 *           ParseTree,
 *           HeadTree extends undefined ? Input : HeadTree,
 *           Output extends undefined ? TailTree : Output,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : // Unknown.
 *       Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 * )} UsePlugin
 *   Create a processor based on the input/output of a {@link Plugin plugin}.
 */ /**
 * @template {CompileResults | undefined} Result
 *   Node type that the transformer yields.
 * @typedef {(
 *   Result extends Value | undefined ?
 *     VFile :
 *     VFile & {result: Result}
 *   )} VFileWithOutput
 *   Type to generate a {@linkcode VFile} corresponding to a compiler result.
 *
 *   If a result that is not acceptable on a `VFile` is used, that will
 *   be stored on the `result` field of {@linkcode VFile}.
 */ 
var $1as9P = parcelRequire("1as9P");

var $lLt6d = parcelRequire("lLt6d");

var $jJcE6 = parcelRequire("jJcE6");

var $4G31g = parcelRequire("4G31g");

var $8ihII = parcelRequire("8ihII");

var $744Y4 = parcelRequire("744Y4");

var $3HjTu = parcelRequire("3HjTu");
// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.
// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.
const $87a67e4d701c7844$var$own = {}.hasOwnProperty;
class $87a67e4d701c7844$export$c30cd198d731db19 extends (0, $3HjTu.CallableInstance) {
    /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */ copy() {
        // Cast as the type parameters will be the same after attaching.
        const destination = /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ new $87a67e4d701c7844$export$c30cd198d731db19();
        let index = -1;
        while(++index < this.attachers.length){
            const attacher = this.attachers[index];
            destination.use(...attacher);
        }
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($lLt6d)))(true, {}, this.namespace));
        return destination;
    }
    /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */ data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $87a67e4d701c7844$var$assertUnfrozen('data', this.frozen);
                this.namespace[key] = value;
                return this;
            }
            // Get `key`.
            return $87a67e4d701c7844$var$own.call(this.namespace, key) && this.namespace[key] || undefined;
        }
        // Set space.
        if (key) {
            $87a67e4d701c7844$var$assertUnfrozen('data', this.frozen);
            this.namespace = key;
            return this;
        }
        // Get space.
        return this.namespace;
    }
    /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */ freeze() {
        if (this.frozen) return this;
        // Cast so that we can type plugins easier.
        // Plugins are supposed to be usable on different processors, not just on
        // this exact processor.
        const self = /** @type {unknown} */ this;
        while(++this.freezeIndex < this.attachers.length){
            const [attacher, ...options] = this.attachers[this.freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            const transformer = attacher.call(self, ...options);
            if (typeof transformer === 'function') this.transformers.use(transformer);
        }
        this.frozen = true;
        this.freezeIndex = Number.POSITIVE_INFINITY;
        return this;
    }
    /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */ parse(file) {
        this.freeze();
        const realFile = $87a67e4d701c7844$var$vfile(file);
        const parser = this.parser || this.Parser;
        $87a67e4d701c7844$var$assertParser('parse', parser);
        return parser(String(realFile), realFile);
    }
    /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ process(file, done) {
        const self = this;
        this.freeze();
        $87a67e4d701c7844$var$assertParser('process', this.parser || this.Parser);
        $87a67e4d701c7844$var$assertCompiler('process', this.compiler || this.Compiler);
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            const realFile = $87a67e4d701c7844$var$vfile(file);
            // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
            // input of the first transform).
            const parseTree = /** @type {unknown} */ self.parse(realFile);
            self.run(parseTree, realFile, function(error, tree, file) {
                if (error || !tree || !file) return realDone(error);
                // Assume `TailTree` (the output of the last transform) matches
                // `CompileTree` (the input of the compiler).
                const compileTree = /** @type {unknown} */ tree;
                const compileResult = self.stringify(compileTree, file);
                if ($87a67e4d701c7844$var$looksLikeAValue(compileResult)) file.value = compileResult;
                else file.result = compileResult;
                realDone(error, /** @type {VFileWithOutput<CompileResult>} */ file);
            });
            /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */ function realDone(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else {
                    (0, $jJcE6.ok)(done, '`done` is defined if `resolve` is not');
                    done(undefined, file);
                }
            }
        }
    }
    /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ processSync(file) {
        /** @type {boolean} */ let complete = false;
        /** @type {VFileWithOutput<CompileResult> | undefined} */ let result;
        this.freeze();
        $87a67e4d701c7844$var$assertParser('processSync', this.parser || this.Parser);
        $87a67e4d701c7844$var$assertCompiler('processSync', this.compiler || this.Compiler);
        this.process(file, realDone);
        $87a67e4d701c7844$var$assertDone('processSync', 'process', complete);
        (0, $jJcE6.ok)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */ function realDone(error, file) {
            complete = true;
            (0, $1as9P.bail)(error);
            result = file;
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */ run(tree, file, done) {
        $87a67e4d701c7844$var$assertNode(tree);
        this.freeze();
        const transformers = this.transformers;
        if (!done && typeof file === 'function') {
            done = file;
            file = undefined;
        }
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            (0, $jJcE6.ok)(typeof file !== 'function', "`file` can\u2019t be a `done` anymore, we checked");
            const realFile = $87a67e4d701c7844$var$vfile(file);
            transformers.run(tree, realFile, realDone);
            /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */ function realDone(error, outputTree, file) {
                const resultingTree = /** @type {TailTree extends undefined ? Node : TailTree} */ outputTree || tree;
                if (error) reject(error);
                else if (resolve) resolve(resultingTree);
                else {
                    (0, $jJcE6.ok)(done, '`done` is defined if `resolve` is not');
                    done(undefined, resultingTree, file);
                }
            }
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */ runSync(tree, file) {
        /** @type {boolean} */ let complete = false;
        /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */ let result;
        this.run(tree, file, realDone);
        $87a67e4d701c7844$var$assertDone('runSync', 'run', complete);
        (0, $jJcE6.ok)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */ function realDone(error, tree) {
            (0, $1as9P.bail)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ stringify(tree, file) {
        this.freeze();
        const realFile = $87a67e4d701c7844$var$vfile(file);
        const compiler = this.compiler || this.Compiler;
        $87a67e4d701c7844$var$assertCompiler('stringify', compiler);
        $87a67e4d701c7844$var$assertNode(tree);
        return compiler(tree, realFile);
    }
    /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */ use(value, ...parameters) {
        const attachers = this.attachers;
        const namespace = this.namespace;
        $87a67e4d701c7844$var$assertUnfrozen('use', this.frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin(value, parameters);
        else if (typeof value === 'object') {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError('Expected usable value, not `' + value + '`');
        return this;
        /**
     * @param {Pluggable} value
     * @returns {undefined}
     */ function add(value) {
            if (typeof value === 'function') addPlugin(value, []);
            else if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    const [plugin, ...parameters] = /** @type {PluginTuple<Array<unknown>>} */ value;
                    addPlugin(plugin, parameters);
                } else addPreset(value);
            } else throw new TypeError('Expected usable value, not `' + value + '`');
        }
        /**
     * @param {Preset} result
     * @returns {undefined}
     */ function addPreset(result) {
            if (!('plugins' in result) && !('settings' in result)) throw new Error('Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither');
            addList(result.plugins);
            if (result.settings) namespace.settings = (0, (/*@__PURE__*/$parcel$interopDefault($lLt6d)))(true, namespace.settings, result.settings);
        }
        /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError('Expected a list of plugins, not `' + plugins + '`');
        }
        /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */ function addPlugin(plugin, parameters) {
            let index = -1;
            let entryIndex = -1;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entryIndex = index;
                break;
            }
            if (entryIndex === -1) attachers.push([
                plugin,
                ...parameters
            ]);
            else if (parameters.length > 0) {
                let [primary, ...rest] = parameters;
                const currentPrimary = attachers[entryIndex][1];
                if ((0, $4G31g.default)(currentPrimary) && (0, $4G31g.default)(primary)) primary = (0, (/*@__PURE__*/$parcel$interopDefault($lLt6d)))(true, currentPrimary, primary);
                attachers[entryIndex] = [
                    plugin,
                    primary,
                    ...rest
                ];
            }
        }
    }
    /**
   * Create a processor.
   */ constructor(){
        // If `Processor()` is called (w/o new), `copy` is called instead.
        super('copy');
        /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.Compiler = undefined;
        /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.Parser = undefined;
        // Note: the following fields are considered private.
        // However, they are needed for tests, and TSC generates an untyped
        // `private freezeIndex` field for, which trips `type-coverage` up.
        // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
        /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */ this.attachers = [];
        /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.compiler = undefined;
        /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */ this.freezeIndex = -1;
        /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */ this.frozen = undefined;
        /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */ this.namespace = {};
        /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.parser = undefined;
        /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */ this.transformers = (0, $8ihII.trough)();
    }
}
const $87a67e4d701c7844$export$7cc1b2fe10c52bb = new $87a67e4d701c7844$export$c30cd198d731db19().freeze();
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $87a67e4d701c7844$var$assertParser(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `parser`');
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $87a67e4d701c7844$var$assertCompiler(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `compiler`');
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $87a67e4d701c7844$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot call `' + name + '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.');
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $87a67e4d701c7844$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $4G31g.default)(node) || typeof node.type !== 'string') throw new TypeError('Expected node, got `' + node + '`');
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $87a67e4d701c7844$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */ function $87a67e4d701c7844$var$vfile(value) {
    return $87a67e4d701c7844$var$looksLikeAVFile(value) ? value : new (0, $744Y4.VFile)(value);
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */ function $87a67e4d701c7844$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === 'object' && 'message' in value && 'messages' in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */ function $87a67e4d701c7844$var$looksLikeAValue(value) {
    return typeof value === 'string' || $87a67e4d701c7844$var$isUint8Array(value);
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $87a67e4d701c7844$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}

});
parcelRegister("1as9P", function(module, exports) {

$parcel$export(module.exports, "bail", function () { return $0d9c9118c52437c3$export$dd911e13ecb11e05; });
/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $0d9c9118c52437c3$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}

});

parcelRegister("lLt6d", function(module, exports) {
'use strict';
var $fd848f497016a5fb$var$hasOwn = Object.prototype.hasOwnProperty;
var $fd848f497016a5fb$var$toStr = Object.prototype.toString;
var $fd848f497016a5fb$var$defineProperty = Object.defineProperty;
var $fd848f497016a5fb$var$gOPD = Object.getOwnPropertyDescriptor;
var $fd848f497016a5fb$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $fd848f497016a5fb$var$toStr.call(arr) === '[object Array]';
};
var $fd848f497016a5fb$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $fd848f497016a5fb$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $fd848f497016a5fb$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $fd848f497016a5fb$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $fd848f497016a5fb$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $fd848f497016a5fb$var$setProperty = function setProperty(target, options) {
    if ($fd848f497016a5fb$var$defineProperty && options.name === '__proto__') $fd848f497016a5fb$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $fd848f497016a5fb$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$fd848f497016a5fb$var$hasOwn.call(obj, name)) return void 0;
        else if ($fd848f497016a5fb$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $fd848f497016a5fb$var$gOPD(obj, name).value;
    }
    return obj[name];
};
module.exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $fd848f497016a5fb$var$getProperty(target, name);
            copy = $fd848f497016a5fb$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($fd848f497016a5fb$var$isPlainObject(copy) || (copyIsArray = $fd848f497016a5fb$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $fd848f497016a5fb$var$isArray(src) ? src : [];
                    } else clone = src && $fd848f497016a5fb$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $fd848f497016a5fb$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $fd848f497016a5fb$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};

});

parcelRegister("4G31g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $367d6d44ee6faa56$export$2e2bcd8739ae039; });
function $367d6d44ee6faa56$export$2e2bcd8739ae039(value) {
    if (typeof value !== 'object' || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

});

parcelRegister("8ihII", function(module, exports) {

$parcel$export(module.exports, "trough", function () { return $609dc009f8723cb9$export$91b56f5ca106aa43; });
// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $609dc009f8723cb9$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== 'function') throw new TypeError('Expected function as last argument, not ' + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $609dc009f8723cb9$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== 'function') throw new TypeError('Expected `middelware` to be a function, not ' + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $609dc009f8723cb9$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}

});

parcelRegister("744Y4", function(module, exports) {

$parcel$export(module.exports, "VFile", function () { return $524cc29dc8543ce4$export$93dff69eb10dc7ce; });
/**
 * @import {Node, Point, Position} from 'unist'
 * @import {Options as MessageOptions} from 'vfile-message'
 * @import {Compatible, Data, Map, Options, Value} from 'vfile'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ 
var $1knXa = parcelRequire("1knXa");

var $5hycM = parcelRequire("5hycM");

var $dNyjb = parcelRequire("dNyjb");
parcelRequire("iDkCs");
var $bqEt8 = parcelRequire("bqEt8");
var $iDkCs = parcelRequire("iDkCs");
/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */ const $524cc29dc8543ce4$var$order = /** @type {const} */ [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
class $524cc29dc8543ce4$export$93dff69eb10dc7ce {
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */ get basename() {
        return typeof this.path === 'string' ? (0, $5hycM.minpath).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */ set basename(basename) {
        $524cc29dc8543ce4$var$assertNonEmpty(basename, 'basename');
        $524cc29dc8543ce4$var$assertPart(basename, 'basename');
        this.path = (0, $5hycM.minpath).join(this.dirname || '', basename);
    }
    /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */ get dirname() {
        return typeof this.path === 'string' ? (0, $5hycM.minpath).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */ set dirname(dirname) {
        $524cc29dc8543ce4$var$assertPath(this.basename, 'dirname');
        this.path = (0, $5hycM.minpath).join(dirname || '', this.basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */ get extname() {
        return typeof this.path === 'string' ? (0, $5hycM.minpath).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */ set extname(extname) {
        $524cc29dc8543ce4$var$assertPart(extname, 'extname');
        $524cc29dc8543ce4$var$assertPath(this.dirname, 'extname');
        if (extname) {
            if (extname.codePointAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
            if (extname.includes('.', 1)) throw new Error('`extname` cannot contain multiple dots');
        }
        this.path = (0, $5hycM.minpath).join(this.dirname, this.stem + (extname || ''));
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */ set path(path) {
        if ((0, $bqEt8.isUrl)(path)) path = (0, $iDkCs.urlToPath)(path);
        $524cc29dc8543ce4$var$assertNonEmpty(path, 'path');
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */ get stem() {
        return typeof this.path === 'string' ? (0, $5hycM.minpath).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */ set stem(stem) {
        $524cc29dc8543ce4$var$assertNonEmpty(stem, 'stem');
        $524cc29dc8543ce4$var$assertPart(stem, 'stem');
        this.path = (0, $5hycM.minpath).join(this.dirname || '', stem + (this.extname || ''));
    }
    // Normal prototypal methods.
    /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */ fail(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = undefined;
        return message;
    }
    /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(causeOrReason, optionsOrParentOrPlace, origin) {
        const message = new (0, $1knXa.VFileMessage)(// @ts-expect-error: the overloads are fine.
        causeOrReason, optionsOrParentOrPlace, origin);
        if (this.path) {
            message.name = this.path + ':' + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        if (this.value === undefined) return '';
        if (typeof this.value === 'string') return this.value;
        const decoder = new TextDecoder(encoding || undefined);
        return decoder.decode(this.value);
    }
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if ((0, $bqEt8.isUrl)(value)) options = {
            path: value
        };
        else if (typeof value === 'string' || $524cc29dc8543ce4$var$isUint8Array(value)) options = {
            value: value
        };
        else options = value;
        /* eslint-disable no-unused-expressions */ /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ // Prevent calling `cwd` (which could be expensive) if it’s not needed;
        // the empty string will be overridden in the next block.
        this.cwd = 'cwd' in options ? '' : (0, $dNyjb.minproc).cwd();
        /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $524cc29dc8543ce4$var$order.length){
            const field = $524cc29dc8543ce4$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (field in options && options[field] !== undefined && options[field] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[field] = field === 'history' ? [
                ...options[field]
            ] : options[field];
        }
        /** @type {string} */ let field;
        // Set non-path related properties.
        for(field in options)// @ts-expect-error: fine to set other things.
        if (!$524cc29dc8543ce4$var$order.includes(field)) // @ts-expect-error: fine to set other things.
        this[field] = options[field];
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */ function $524cc29dc8543ce4$var$assertPart(part, name) {
    if (part && part.includes((0, $5hycM.minpath).sep)) throw new Error('`' + name + '` cannot be a path: did not expect `' + (0, $5hycM.minpath).sep + '`');
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $524cc29dc8543ce4$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $524cc29dc8543ce4$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $524cc29dc8543ce4$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}

});
parcelRegister("5hycM", function(module, exports) {

$parcel$export(module.exports, "minpath", function () { return $3d8912b0d5b24ce1$export$500c965389abde9c; });
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $3d8912b0d5b24ce1$export$500c965389abde9c = {
    basename: $3d8912b0d5b24ce1$var$basename,
    dirname: $3d8912b0d5b24ce1$var$dirname,
    extname: $3d8912b0d5b24ce1$var$extname,
    join: $3d8912b0d5b24ce1$var$join,
    sep: '/'
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [extname]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $3d8912b0d5b24ce1$var$basename(path, extname) {
    if (extname !== undefined && typeof extname !== 'string') throw new TypeError('"ext" argument must be a string');
    $3d8912b0d5b24ce1$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (extname === undefined || extname.length === 0 || extname.length > path.length) {
        while(index--){
            if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (extname === path) return '';
    let firstNonSlashEnd = -1;
    let extnameIndex = extname.length - 1;
    while(index--){
        if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extnameIndex > -1) {
                // Try to match the explicit extension.
                if (path.codePointAt(index) === extname.codePointAt(extnameIndex--)) {
                    if (extnameIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extnameIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $3d8912b0d5b24ce1$var$dirname(path) {
    $3d8912b0d5b24ce1$var$assertPath(path);
    if (path.length === 0) return '.';
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.codePointAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.codePointAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.codePointAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $3d8912b0d5b24ce1$var$extname(path) {
    $3d8912b0d5b24ce1$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.codePointAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $3d8912b0d5b24ce1$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $3d8912b0d5b24ce1$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
    return joined === undefined ? '.' : $3d8912b0d5b24ce1$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $3d8912b0d5b24ce1$var$normalize(path) {
    $3d8912b0d5b24ce1$var$assertPath(path);
    const absolute = path.codePointAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $3d8912b0d5b24ce1$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = '.';
    if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $3d8912b0d5b24ce1$var$normalizeString(path, allowAboveRoot) {
    let result = '';
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.codePointAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 /* `.` */  || result.codePointAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $3d8912b0d5b24ce1$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 

});

parcelRegister("dNyjb", function(module, exports) {

$parcel$export(module.exports, "minproc", function () { return $a0ba76e4eb8416df$export$77f0ef6e088922ec; });
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $a0ba76e4eb8416df$export$77f0ef6e088922ec = {
    cwd: $a0ba76e4eb8416df$var$cwd
};
function $a0ba76e4eb8416df$var$cwd() {
    return '/';
}

});

parcelRegister("iDkCs", function(module, exports) {

$parcel$export(module.exports, "urlToPath", function () { return $d90bdd17d4813757$export$9b2b676c902de799; });
$parcel$export(module.exports, "isUrl", function () { return (parcelRequire("bqEt8")).isUrl; });

var $bqEt8 = parcelRequire("bqEt8");
function $d90bdd17d4813757$export$9b2b676c902de799(path) {
    if (typeof path === 'string') path = new URL(path);
    else if (!(0, $bqEt8.isUrl)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + '`');
        error.code = 'ERR_INVALID_ARG_TYPE';
        throw error;
    }
    if (path.protocol !== 'file:') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The URL must be of scheme file');
        error.code = 'ERR_INVALID_URL_SCHEME';
        throw error;
    }
    return $d90bdd17d4813757$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $d90bdd17d4813757$var$getPathFromURLPosix(url) {
    if (url.hostname !== '') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = 'ERR_INVALID_FILE_URL_HOST';
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.codePointAt(index) === 37 /* `%` */  && pathname.codePointAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.codePointAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL path must not include encoded / characters');
            error.code = 'ERR_INVALID_FILE_URL_PATH';
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}

});
parcelRegister("bqEt8", function(module, exports) {

$parcel$export(module.exports, "isUrl", function () { return $852183b219bc8414$export$8304a22d431f958; });
/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function $852183b219bc8414$export$8304a22d431f958(fileUrlOrPath) {
    return Boolean(fileUrlOrPath !== null && typeof fileUrlOrPath === 'object' && 'href' in fileUrlOrPath && fileUrlOrPath.href && 'protocol' in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === undefined);
}

});



parcelRegister("3HjTu", function(module, exports) {

$parcel$export(module.exports, "CallableInstance", function () { return $2b14d1ca46f6adea$export$b7de1db558410812; });
const $2b14d1ca46f6adea$export$b7de1db558410812 = /** @type {unknown} */ /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */ function(property) {
    const self = this;
    const constr = self.constructor;
    const proto = /** @type {Record<string | symbol, Function>} */ // Prototypes do exist.
    // type-coverage:ignore-next-line
    constr.prototype;
    const value = proto[property];
    /** @type {(...parameters: Array<unknown>) => unknown} */ const apply = function() {
        return value.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    // Not needed for us in `unified`: we only call this on the `copy`
    // function,
    // and we don't need to add its fields (`length`, `name`)
    // over.
    // See also: GH-246.
    // const names = Object.getOwnPropertyNames(value)
    //
    // for (const p of names) {
    //   const descriptor = Object.getOwnPropertyDescriptor(value, p)
    //   if (descriptor) Object.defineProperty(apply, p, descriptor)
    // }
    return apply;
};

});



parcelRegister("hoDlW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63c8969e229b4a40$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $iHpLz = parcelRequire("iHpLz");

var $18TeW = parcelRequire("18TeW");

var $7hhBq = parcelRequire("7hhBq");

var $bH5bR = parcelRequire("bH5bR");
const $63c8969e229b4a40$var$TwemojiContainer = (0, $18TeW.default)('div')(()=>({
        '& img.emoji': {
            height: '1.25em',
            width: '1.25em',
            margin: '0 .05em 0 .1em',
            verticalAlign: '-0.1em'
        }
    }));
const $63c8969e229b4a40$var$Emojify = (_param)=>{
    var { children: children } = _param, props = (0, $6pkKu._)(_param, [
        "children"
    ]);
    const [ref] = (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).useState(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createRef());
    (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).useEffect(()=>{
        if (ref.current) (0, $bH5bR.default).parse(ref.current);
    }, [
        children,
        ref
    ]);
    return /*#__PURE__*/ (0, $iHpLz.jsx)($63c8969e229b4a40$var$TwemojiContainer, (0, $cNnl8._)((0, $dok7x._)({
        ref: ref
    }, props), {
        children: children
    }));
};
var $63c8969e229b4a40$export$2e2bcd8739ae039 = $63c8969e229b4a40$var$Emojify;

});
parcelRegister("bH5bR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8837bc91c52221e3$export$2e2bcd8739ae039; });
/*! Copyright Twitter Inc. and other contributors. Licensed under MIT */ var $8837bc91c52221e3$var$twemoji = function() {
    "use strict";
    var twemoji = {
        base: "https://twemoji.maxcdn.com/v/14.0.2/",
        ext: ".png",
        size: "72x72",
        className: "emoji",
        convert: {
            fromCodePoint: fromCodePoint,
            toCodePoint: toCodePoint
        },
        onerror: function onerror() {
            if (this.parentNode) this.parentNode.replaceChild(createText(this.alt, false), this);
        },
        parse: parse,
        replace: replace,
        test: test
    }, escaper = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "'": "&#39;",
        '"': "&quot;"
    }, re = /(?:\ud83d\udc68\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffc-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb\udffd-\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb-\udffd\udfff]|\ud83e\uddd1\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb-\udffe]|\ud83d\udc68\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc68\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc68\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffe]|\ud83e\uddd1\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffc-\udfff]|\ud83e\uddd1\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb\udffd-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb-\udffd\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb-\udffe]|\ud83e\uddd1\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d[\udc68\udc69]|\ud83e\udef1\ud83c\udffb\u200d\ud83e\udef2\ud83c[\udffc-\udfff]|\ud83e\udef1\ud83c\udffc\u200d\ud83e\udef2\ud83c[\udffb\udffd-\udfff]|\ud83e\udef1\ud83c\udffd\u200d\ud83e\udef2\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\udef1\ud83c\udffe\u200d\ud83e\udef2\ud83c[\udffb-\udffd\udfff]|\ud83e\udef1\ud83c\udfff\u200d\ud83e\udef2\ud83c[\udffb-\udffe]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d[\udc68\udc69]|\ud83e\uddd1\u200d\ud83e\udd1d\u200d\ud83e\uddd1|\ud83d\udc6b\ud83c[\udffb-\udfff]|\ud83d\udc6c\ud83c[\udffb-\udfff]|\ud83d\udc6d\ud83c[\udffb-\udfff]|\ud83d\udc8f\ud83c[\udffb-\udfff]|\ud83d\udc91\ud83c[\udffb-\udfff]|\ud83e\udd1d\ud83c[\udffb-\udfff]|\ud83d[\udc6b-\udc6d\udc8f\udc91]|\ud83e\udd1d)|(?:\ud83d[\udc68\udc69]|\ud83e\uddd1)(?:\ud83c[\udffb-\udfff])?\u200d(?:\u2695\ufe0f|\u2696\ufe0f|\u2708\ufe0f|\ud83c[\udf3e\udf73\udf7c\udf84\udf93\udfa4\udfa8\udfeb\udfed]|\ud83d[\udcbb\udcbc\udd27\udd2c\ude80\ude92]|\ud83e[\uddaf-\uddb3\uddbc\uddbd])|(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75]|\u26f9)((?:\ud83c[\udffb-\udfff]|\ufe0f)\u200d[\u2640\u2642]\ufe0f)|(?:\ud83c[\udfc3\udfc4\udfca]|\ud83d[\udc6e\udc70\udc71\udc73\udc77\udc81\udc82\udc86\udc87\ude45-\ude47\ude4b\ude4d\ude4e\udea3\udeb4-\udeb6]|\ud83e[\udd26\udd35\udd37-\udd39\udd3d\udd3e\uddb8\uddb9\uddcd-\uddcf\uddd4\uddd6-\udddd])(?:\ud83c[\udffb-\udfff])?\u200d[\u2640\u2642]\ufe0f|(?:\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83c\udff3\ufe0f\u200d\u26a7\ufe0f|\ud83c\udff3\ufe0f\u200d\ud83c\udf08|\ud83d\ude36\u200d\ud83c\udf2b\ufe0f|\u2764\ufe0f\u200d\ud83d\udd25|\u2764\ufe0f\u200d\ud83e\ude79|\ud83c\udff4\u200d\u2620\ufe0f|\ud83d\udc15\u200d\ud83e\uddba|\ud83d\udc3b\u200d\u2744\ufe0f|\ud83d\udc41\u200d\ud83d\udde8|\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc6f\u200d\u2640\ufe0f|\ud83d\udc6f\u200d\u2642\ufe0f|\ud83d\ude2e\u200d\ud83d\udca8|\ud83d\ude35\u200d\ud83d\udcab|\ud83e\udd3c\u200d\u2640\ufe0f|\ud83e\udd3c\u200d\u2642\ufe0f|\ud83e\uddde\u200d\u2640\ufe0f|\ud83e\uddde\u200d\u2642\ufe0f|\ud83e\udddf\u200d\u2640\ufe0f|\ud83e\udddf\u200d\u2642\ufe0f|\ud83d\udc08\u200d\u2b1b)|[#*0-9]\ufe0f?\u20e3|(?:[©®\u2122\u265f]\ufe0f)|(?:\ud83c[\udc04\udd70\udd71\udd7e\udd7f\ude02\ude1a\ude2f\ude37\udf21\udf24-\udf2c\udf36\udf7d\udf96\udf97\udf99-\udf9b\udf9e\udf9f\udfcd\udfce\udfd4-\udfdf\udff3\udff5\udff7]|\ud83d[\udc3f\udc41\udcfd\udd49\udd4a\udd6f\udd70\udd73\udd76-\udd79\udd87\udd8a-\udd8d\udda5\udda8\uddb1\uddb2\uddbc\uddc2-\uddc4\uddd1-\uddd3\udddc-\uddde\udde1\udde3\udde8\uddef\uddf3\uddfa\udecb\udecd-\udecf\udee0-\udee5\udee9\udef0\udef3]|[\u203c\u2049\u2139\u2194-\u2199\u21a9\u21aa\u231a\u231b\u2328\u23cf\u23ed-\u23ef\u23f1\u23f2\u23f8-\u23fa\u24c2\u25aa\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600-\u2604\u260e\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262a\u262e\u262f\u2638-\u263a\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267b\u267f\u2692-\u2697\u2699\u269b\u269c\u26a0\u26a1\u26a7\u26aa\u26ab\u26b0\u26b1\u26bd\u26be\u26c4\u26c5\u26c8\u26cf\u26d1\u26d3\u26d4\u26e9\u26ea\u26f0-\u26f5\u26f8\u26fa\u26fd\u2702\u2708\u2709\u270f\u2712\u2714\u2716\u271d\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u2764\u27a1\u2934\u2935\u2b05-\u2b07\u2b1b\u2b1c\u2b50\u2b55\u3030\u303d\u3297\u3299])(?:\ufe0f|(?!\ufe0e))|(?:(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75\udd90]|[\u261d\u26f7\u26f9\u270c\u270d])(?:\ufe0f|(?!\ufe0e))|(?:\ud83c[\udf85\udfc2-\udfc4\udfc7\udfca]|\ud83d[\udc42\udc43\udc46-\udc50\udc66-\udc69\udc6e\udc70-\udc78\udc7c\udc81-\udc83\udc85-\udc87\udcaa\udd7a\udd95\udd96\ude45-\ude47\ude4b-\ude4f\udea3\udeb4-\udeb6\udec0\udecc]|\ud83e[\udd0c\udd0f\udd18-\udd1c\udd1e\udd1f\udd26\udd30-\udd39\udd3d\udd3e\udd77\uddb5\uddb6\uddb8\uddb9\uddbb\uddcd-\uddcf\uddd1-\udddd\udec3-\udec5\udef0-\udef6]|[\u270a\u270b]))(?:\ud83c[\udffb-\udfff])?|(?:\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc65\udb40\udc6e\udb40\udc67\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc73\udb40\udc63\udb40\udc74\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc77\udb40\udc6c\udb40\udc73\udb40\udc7f|\ud83c\udde6\ud83c[\udde8-\uddec\uddee\uddf1\uddf2\uddf4\uddf6-\uddfa\uddfc\uddfd\uddff]|\ud83c\udde7\ud83c[\udde6\udde7\udde9-\uddef\uddf1-\uddf4\uddf6-\uddf9\uddfb\uddfc\uddfe\uddff]|\ud83c\udde8\ud83c[\udde6\udde8\udde9\uddeb-\uddee\uddf0-\uddf5\uddf7\uddfa-\uddff]|\ud83c\udde9\ud83c[\uddea\uddec\uddef\uddf0\uddf2\uddf4\uddff]|\ud83c\uddea\ud83c[\udde6\udde8\uddea\uddec\udded\uddf7-\uddfa]|\ud83c\uddeb\ud83c[\uddee-\uddf0\uddf2\uddf4\uddf7]|\ud83c\uddec\ud83c[\udde6\udde7\udde9-\uddee\uddf1-\uddf3\uddf5-\uddfa\uddfc\uddfe]|\ud83c\udded\ud83c[\uddf0\uddf2\uddf3\uddf7\uddf9\uddfa]|\ud83c\uddee\ud83c[\udde8-\uddea\uddf1-\uddf4\uddf6-\uddf9]|\ud83c\uddef\ud83c[\uddea\uddf2\uddf4\uddf5]|\ud83c\uddf0\ud83c[\uddea\uddec-\uddee\uddf2\uddf3\uddf5\uddf7\uddfc\uddfe\uddff]|\ud83c\uddf1\ud83c[\udde6-\udde8\uddee\uddf0\uddf7-\uddfb\uddfe]|\ud83c\uddf2\ud83c[\udde6\udde8-\udded\uddf0-\uddff]|\ud83c\uddf3\ud83c[\udde6\udde8\uddea-\uddec\uddee\uddf1\uddf4\uddf5\uddf7\uddfa\uddff]|\ud83c\uddf4\ud83c\uddf2|\ud83c\uddf5\ud83c[\udde6\uddea-\udded\uddf0-\uddf3\uddf7-\uddf9\uddfc\uddfe]|\ud83c\uddf6\ud83c\udde6|\ud83c\uddf7\ud83c[\uddea\uddf4\uddf8\uddfa\uddfc]|\ud83c\uddf8\ud83c[\udde6-\uddea\uddec-\uddf4\uddf7-\uddf9\uddfb\uddfd-\uddff]|\ud83c\uddf9\ud83c[\udde6\udde8\udde9\uddeb-\udded\uddef-\uddf4\uddf7\uddf9\uddfb\uddfc\uddff]|\ud83c\uddfa\ud83c[\udde6\uddec\uddf2\uddf3\uddf8\uddfe\uddff]|\ud83c\uddfb\ud83c[\udde6\udde8\uddea\uddec\uddee\uddf3\uddfa]|\ud83c\uddfc\ud83c[\uddeb\uddf8]|\ud83c\uddfd\ud83c\uddf0|\ud83c\uddfe\ud83c[\uddea\uddf9]|\ud83c\uddff\ud83c[\udde6\uddf2\uddfc]|\ud83c[\udccf\udd8e\udd91-\udd9a\udde6-\uddff\ude01\ude32-\ude36\ude38-\ude3a\ude50\ude51\udf00-\udf20\udf2d-\udf35\udf37-\udf7c\udf7e-\udf84\udf86-\udf93\udfa0-\udfc1\udfc5\udfc6\udfc8\udfc9\udfcf-\udfd3\udfe0-\udff0\udff4\udff8-\udfff]|\ud83d[\udc00-\udc3e\udc40\udc44\udc45\udc51-\udc65\udc6a\udc6f\udc79-\udc7b\udc7d-\udc80\udc84\udc88-\udc8e\udc90\udc92-\udca9\udcab-\udcfc\udcff-\udd3d\udd4b-\udd4e\udd50-\udd67\udda4\uddfb-\ude44\ude48-\ude4a\ude80-\udea2\udea4-\udeb3\udeb7-\udebf\udec1-\udec5\uded0-\uded2\uded5-\uded7\udedd-\udedf\udeeb\udeec\udef4-\udefc\udfe0-\udfeb\udff0]|\ud83e[\udd0d\udd0e\udd10-\udd17\udd20-\udd25\udd27-\udd2f\udd3a\udd3c\udd3f-\udd45\udd47-\udd76\udd78-\uddb4\uddb7\uddba\uddbc-\uddcc\uddd0\uddde-\uddff\ude70-\ude74\ude78-\ude7c\ude80-\ude86\ude90-\udeac\udeb0-\udeba\udec0-\udec2\uded0-\uded9\udee0-\udee7]|[\u23e9-\u23ec\u23f0\u23f3\u267e\u26ce\u2705\u2728\u274c\u274e\u2753-\u2755\u2795-\u2797\u27b0\u27bf\ue50a])|\ufe0f/g, UFE0Fg = /\uFE0F/g, U200D = String.fromCharCode(8205), rescaper = /[&<>'"]/g, shouldntBeParsed = /^(?:iframe|noframes|noscript|script|select|style|textarea)$/, fromCharCode = String.fromCharCode;
    return twemoji;
    function createText(text, clean) {
        return document.createTextNode(clean ? text.replace(UFE0Fg, "") : text);
    }
    function escapeHTML(s) {
        return s.replace(rescaper, replacer);
    }
    function defaultImageSrcGenerator(icon, options) {
        return "".concat(options.base, options.size, "/", icon, options.ext);
    }
    function grabAllTextNodes(node, allText) {
        var childNodes = node.childNodes, length = childNodes.length, subnode, nodeType;
        while(length--){
            subnode = childNodes[length];
            nodeType = subnode.nodeType;
            if (nodeType === 3) allText.push(subnode);
            else if (nodeType === 1 && !("ownerSVGElement" in subnode) && !shouldntBeParsed.test(subnode.nodeName.toLowerCase())) grabAllTextNodes(subnode, allText);
        }
        return allText;
    }
    function grabTheRightIcon(rawText) {
        return toCodePoint(rawText.indexOf(U200D) < 0 ? rawText.replace(UFE0Fg, "") : rawText);
    }
    function parseNode(node, options) {
        var allText = grabAllTextNodes(node, []), length = allText.length, attrib, attrname, modified, fragment, subnode, text, match, i, index, img, rawText, iconId, src;
        while(length--){
            modified = false;
            fragment = document.createDocumentFragment();
            subnode = allText[length];
            text = subnode.nodeValue;
            i = 0;
            while(match = re.exec(text)){
                index = match.index;
                if (index !== i) fragment.appendChild(createText(text.slice(i, index), true));
                rawText = match[0];
                iconId = grabTheRightIcon(rawText);
                i = index + rawText.length;
                src = options.callback(iconId, options);
                if (iconId && src) {
                    img = new Image;
                    img.onerror = options.onerror;
                    img.setAttribute("draggable", "false");
                    attrib = options.attributes(rawText, iconId);
                    for(attrname in attrib)if (attrib.hasOwnProperty(attrname) && attrname.indexOf("on") !== 0 && !img.hasAttribute(attrname)) img.setAttribute(attrname, attrib[attrname]);
                    img.className = options.className;
                    img.alt = rawText;
                    img.src = src;
                    modified = true;
                    fragment.appendChild(img);
                }
                if (!img) fragment.appendChild(createText(rawText, false));
                img = null;
            }
            if (modified) {
                if (i < text.length) fragment.appendChild(createText(text.slice(i), true));
                subnode.parentNode.replaceChild(fragment, subnode);
            }
        }
        return node;
    }
    function parseString(str, options) {
        return replace(str, function(rawText) {
            var ret = rawText, iconId = grabTheRightIcon(rawText), src = options.callback(iconId, options), attrib, attrname;
            if (iconId && src) {
                ret = "<img ".concat('class="', options.className, '" ', 'draggable="false" ', 'alt="', rawText, '"', ' src="', src, '"');
                attrib = options.attributes(rawText, iconId);
                for(attrname in attrib)if (attrib.hasOwnProperty(attrname) && attrname.indexOf("on") !== 0 && ret.indexOf(" " + attrname + "=") === -1) ret = ret.concat(" ", attrname, '="', escapeHTML(attrib[attrname]), '"');
                ret = ret.concat("/>");
            }
            return ret;
        });
    }
    function replacer(m) {
        return escaper[m];
    }
    function returnNull() {
        return null;
    }
    function toSizeSquaredAsset(value) {
        return typeof value === "number" ? value + "x" + value : value;
    }
    function fromCodePoint(codepoint) {
        var code = typeof codepoint === "string" ? parseInt(codepoint, 16) : codepoint;
        if (code < 65536) return fromCharCode(code);
        code -= 65536;
        return fromCharCode(55296 + (code >> 10), 56320 + (code & 1023));
    }
    function parse(what, how) {
        if (!how || typeof how === "function") how = {
            callback: how
        };
        return (typeof what === "string" ? parseString : parseNode)(what, {
            callback: how.callback || defaultImageSrcGenerator,
            attributes: typeof how.attributes === "function" ? how.attributes : returnNull,
            base: typeof how.base === "string" ? how.base : twemoji.base,
            ext: how.ext || twemoji.ext,
            size: how.folder || toSizeSquaredAsset(how.size || twemoji.size),
            className: how.className || twemoji.className,
            onerror: how.onerror || twemoji.onerror
        });
    }
    function replace(text, callback) {
        return String(text).replace(re, callback);
    }
    function test(text) {
        re.lastIndex = 0;
        var result = re.test(text);
        re.lastIndex = 0;
        return result;
    }
    function toCodePoint(unicodeSurrogates, sep) {
        var r = [], c = 0, p = 0, i = 0;
        while(i < unicodeSurrogates.length){
            c = unicodeSurrogates.charCodeAt(i++);
            if (p) {
                r.push((65536 + (p - 55296 << 10) + (c - 56320)).toString(16));
                p = 0;
            } else if (55296 <= c && c <= 56319) p = c;
            else r.push(c.toString(16));
        }
        return r.join(sep || "-");
    }
}();
var $8837bc91c52221e3$export$2e2bcd8739ae039 = $8837bc91c52221e3$var$twemoji;

});


parcelRegister("gSXnV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b14e27411787e90$export$2e2bcd8739ae039; });

var $iHpLz = parcelRequire("iHpLz");
parcelRequire("7hhBq");

var $kGf7k = parcelRequire("kGf7k");

var $eUGha = parcelRequire("eUGha");

var $23GMi = parcelRequire("23GMi");
const $3b14e27411787e90$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $iHpLz.jsxs)("footer", {
        style: {
            width: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $iHpLz.jsx)((0, $23GMi.default), {}),
            /*#__PURE__*/ (0, $iHpLz.jsx)((0, $eUGha.default), {}),
            /*#__PURE__*/ (0, $iHpLz.jsx)((0, $kGf7k.default), {})
        ]
    });
};
var $3b14e27411787e90$export$2e2bcd8739ae039 = $3b14e27411787e90$var$Footer;

});
parcelRegister("kGf7k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $143a58f436c3e30f$export$2e2bcd8739ae039; });

var $iHpLz = parcelRequire("iHpLz");

var $b5Oyq = parcelRequire("b5Oyq");

var $c2CkC = parcelRequire("c2CkC");
parcelRequire("7hhBq");
const $143a58f436c3e30f$var$BottomFooter = ()=>{
    const isMobile = (0, $c2CkC.default)();
    const currentYear = new Date().getFullYear();
    return /*#__PURE__*/ (0, $iHpLz.jsx)("div", {
        style: {
            backgroundColor: '#373737',
            height: '30px',
            padding: '0 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        children: /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $b5Oyq.default), {
            variant: isMobile ? 'body2' : 'body1',
            color: "white",
            children: [
                "\xa9 THS International ",
                currentYear,
                " - All rights reserved"
            ]
        })
    });
};
var $143a58f436c3e30f$export$2e2bcd8739ae039 = $143a58f436c3e30f$var$BottomFooter;

});

parcelRegister("eUGha", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b8f7d48971e5467$export$2e2bcd8739ae039; });

var $iHpLz = parcelRequire("iHpLz");

var $b5Oyq = parcelRequire("b5Oyq");

var $c2CkC = parcelRequire("c2CkC");

var $8oEKT = parcelRequire("8oEKT");
parcelRequire("7hhBq");

var $aw1H1 = parcelRequire("aw1H1");

var $dQSvw = parcelRequire("dQSvw");
const $4b8f7d48971e5467$var$MiddleFooter = ()=>{
    const isMobile = (0, $c2CkC.default)();
    const projectId = (0, $8oEKT.default)();
    return /*#__PURE__*/ (0, $iHpLz.jsxs)("div", {
        style: {
            backgroundColor: '#616161',
            height: isMobile ? 'auto' : '35px',
            padding: isMobile ? '8px 16px' : '0 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        children: [
            /*#__PURE__*/ (0, $iHpLz.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: isMobile ? 'flex-start' : 'center',
                    gap: isMobile ? '4px' : '8px',
                    flexDirection: isMobile ? 'column' : 'row'
                },
                children: [
                    /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Link), {
                        to: {
                            pathname: `/${projectId}/about/aboutus`
                        },
                        target: "_blank",
                        style: {
                            textDecoration: 'none'
                        },
                        children: /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $b5Oyq.default), {
                            variant: isMobile ? 'body2' : 'body1',
                            color: "white",
                            children: [
                                "Learn More",
                                !isMobile && /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iHpLz.Fragment), {
                                    children: "\xa0\xa0|"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Link), {
                        to: {
                            pathname: `/${projectId}/about/terms`
                        },
                        target: "_blank",
                        style: {
                            textDecoration: 'none'
                        },
                        children: /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $b5Oyq.default), {
                            variant: isMobile ? 'body2' : 'body1',
                            color: "white",
                            children: [
                                "Terms of Use",
                                !isMobile && /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iHpLz.Fragment), {
                                    children: "\xa0\xa0|"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Link), {
                        to: {
                            pathname: `/${projectId}/about/privacy`
                        },
                        target: "_blank",
                        style: {
                            textDecoration: 'none'
                        },
                        children: /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $b5Oyq.default), {
                            variant: isMobile ? 'body2' : 'body1',
                            color: "white",
                            children: [
                                "Privacy Policy",
                                !isMobile && /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iHpLz.Fragment), {
                                    children: "\xa0\xa0|"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Link), {
                        to: {
                            pathname: `/${projectId}/about/additional`
                        },
                        target: "_blank",
                        style: {
                            textDecoration: 'none'
                        },
                        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $b5Oyq.default), {
                            variant: isMobile ? 'body2' : 'body1',
                            color: "white",
                            children: "Additional Communication"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iHpLz.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($dQSvw))),
                alt: "ths-logo",
                style: {
                    width: isMobile ? '50px' : '24px',
                    height: isMobile ? '50px' : '24px'
                }
            })
        ]
    });
};
var $4b8f7d48971e5467$export$2e2bcd8739ae039 = $4b8f7d48971e5467$var$MiddleFooter;

});
parcelRegister("dQSvw", function(module, exports) {
module.exports = $parcel$resolve("8IYK3");

});


parcelRegister("23GMi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb90242f893fb279$export$2e2bcd8739ae039; });

var $iHpLz = parcelRequire("iHpLz");
parcelRequire("7hhBq");

var $aBZXJ = parcelRequire("aBZXJ");

var $31K6J = parcelRequire("31K6J");

var $bdlxK = parcelRequire("bdlxK");

var $heRa1 = parcelRequire("heRa1");
var $18TeW = parcelRequire("18TeW");
var $b5Oyq = parcelRequire("b5Oyq");

var $h3hKu = parcelRequire("h3hKu");

var $c2CkC = parcelRequire("c2CkC");

var $c5JDL = parcelRequire("c5JDL");
const $bb90242f893fb279$var$CustomIconButton = (0, $18TeW.default)((0, $heRa1.default), {
    shouldForwardProp: (prop)=>prop !== 'isMobile' && prop !== 't'
})(({ theme: theme, isMobile: isMobile })=>({
        width: isMobile ? '30px' : '24px',
        height: isMobile ? '30px' : '24px',
        padding: 0,
        color: theme.palette.primary.contrastText
    }));
const $bb90242f893fb279$var$TopFooter = ()=>{
    const theme = (0, $h3hKu.default)();
    const isMobile = (0, $c2CkC.default)();
    const { PROJECT_NAME: name } = (0, $c5JDL.useProjectTextContext)();
    return /*#__PURE__*/ (0, $iHpLz.jsxs)("div", {
        style: {
            backgroundColor: theme.palette.primary.main,
            height: isMobile ? '56px' : '45px',
            padding: isMobile ? '0 16px' : '0 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        children: [
            !isMobile && /*#__PURE__*/ (0, $iHpLz.jsx)((0, $b5Oyq.default), {
                variant: "body1",
                style: {
                    color: theme.palette.primary.contrastText
                },
                children: name
            }),
            /*#__PURE__*/ (0, $iHpLz.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: isMobile ? 0 : '80px',
                    flexGrow: isMobile ? 1 : 0,
                    justifyContent: isMobile ? 'space-between' : 'initial'
                },
                children: [
                    /*#__PURE__*/ (0, $iHpLz.jsx)($bb90242f893fb279$var$CustomIconButton, {
                        isMobile: isMobile,
                        onClick: ()=>window.open('https://www.thsint.se', '_blank'),
                        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $31K6J.default), {})
                    }),
                    /*#__PURE__*/ (0, $iHpLz.jsx)($bb90242f893fb279$var$CustomIconButton, {
                        isMobile: isMobile,
                        onClick: ()=>window.open('mailto:info@thsint.se', '_blank'),
                        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $bdlxK.default), {})
                    }),
                    /*#__PURE__*/ (0, $iHpLz.jsx)($bb90242f893fb279$var$CustomIconButton, {
                        isMobile: isMobile,
                        onClick: ()=>window.open('https://www.instagram.com/ths_international_reception', '_blank'),
                        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aBZXJ.default), {})
                    })
                ]
            })
        ]
    });
};
var $bb90242f893fb279$export$2e2bcd8739ae039 = $bb90242f893fb279$var$TopFooter;

});
parcelRegister("aBZXJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b9d6c82c141a4c8$export$2e2bcd8739ae039; });
parcelRequire("7hhBq");

var $8Q9JX = parcelRequire("8Q9JX");

var $iHpLz = parcelRequire("iHpLz");
'use client';
var $7b9d6c82c141a4c8$export$2e2bcd8739ae039 = (0, $8Q9JX.default)(/*#__PURE__*/ (0, $iHpLz.jsx)("path", {
    d: "M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
}), 'Instagram');

});
parcelRegister("8Q9JX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66fabc4b4a1b715e$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $7hhBq = parcelRequire("7hhBq");

var $Sa8Xe = parcelRequire("Sa8Xe");

var $iHpLz = parcelRequire("iHpLz");
'use client';
function $66fabc4b4a1b715e$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $Sa8Xe.default), (0, $cNnl8._)((0, $dok7x._)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props), {
            children: path
        }));
    }
    Component.muiName = (0, $Sa8Xe.default).muiName;
    return /*#__PURE__*/ $7hhBq.memo(/*#__PURE__*/ $7hhBq.forwardRef(Component));
}

});
parcelRegister("Sa8Xe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a2ce9886fad02ca$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");

var $eET99 = parcelRequire("eET99");

var $bUnnb = parcelRequire("bUnnb");

var $18TeW = parcelRequire("18TeW");

var $1zv4u = parcelRequire("1zv4u");

var $4ZZLe = parcelRequire("4ZZLe");

var $7xIdi = parcelRequire("7xIdi");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $0a2ce9886fad02ca$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $bUnnb.default)(color)}`,
            `fontSize${(0, $bUnnb.default)(fontSize)}`
        ]
    };
    return (0, $eET99.default)(slots, (0, $7xIdi.getSvgIconUtilityClass), classes);
};
const $0a2ce9886fad02ca$var$SvgIconRoot = (0, $18TeW.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $bUnnb.default)(ownerState.color)}`],
            styles[`fontSize${(0, $bUnnb.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $1zv4u.default)(({ theme: theme })=>{
    var _transitions_duration, _transitions, _theme_transitions_create, _theme_transitions, _theme_typography_pxToRem, _theme_typography, _theme_typography_pxToRem1, _theme_typography1, _theme_typography_pxToRem2, _theme_typography2, _palette_action, _palette, _palette_action1, _palette1;
    var _theme_vars, _theme_vars1, _theme_vars2, _theme_vars3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: (_theme_transitions = theme.transitions) === null || _theme_transitions === void 0 ? void 0 : (_theme_transitions_create = _theme_transitions.create) === null || _theme_transitions_create === void 0 ? void 0 : _theme_transitions_create.call(_theme_transitions, 'fill', {
            duration: (_transitions = ((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).transitions) === null || _transitions === void 0 ? void 0 : (_transitions_duration = _transitions.duration) === null || _transitions_duration === void 0 ? void 0 : _transitions_duration.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_pxToRem = _theme_typography.pxToRem) === null || _theme_typography_pxToRem === void 0 ? void 0 : _theme_typography_pxToRem.call(_theme_typography, 20)) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: ((_theme_typography1 = theme.typography) === null || _theme_typography1 === void 0 ? void 0 : (_theme_typography_pxToRem1 = _theme_typography1.pxToRem) === null || _theme_typography_pxToRem1 === void 0 ? void 0 : _theme_typography_pxToRem1.call(_theme_typography1, 24)) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: ((_theme_typography2 = theme.typography) === null || _theme_typography2 === void 0 ? void 0 : (_theme_typography_pxToRem2 = _theme_typography2.pxToRem) === null || _theme_typography_pxToRem2 === void 0 ? void 0 : _theme_typography_pxToRem2.call(_theme_typography2, 35)) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries(((_theme_vars1 = theme.vars) !== null && _theme_vars1 !== void 0 ? _theme_vars1 : theme).palette).filter(([, value])=>value && value.main).map(([color])=>{
                var _palette_color, _palette;
                var _theme_vars;
                return {
                    props: {
                        color: color
                    },
                    style: {
                        color: (_palette = ((_theme_vars = theme.vars) !== null && _theme_vars !== void 0 ? _theme_vars : theme).palette) === null || _palette === void 0 ? void 0 : (_palette_color = _palette[color]) === null || _palette_color === void 0 ? void 0 : _palette_color.main
                    }
                };
            }),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (_palette = ((_theme_vars2 = theme.vars) !== null && _theme_vars2 !== void 0 ? _theme_vars2 : theme).palette) === null || _palette === void 0 ? void 0 : (_palette_action = _palette.action) === null || _palette_action === void 0 ? void 0 : _palette_action.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (_palette1 = ((_theme_vars3 = theme.vars) !== null && _theme_vars3 !== void 0 ? _theme_vars3 : theme).palette) === null || _palette1 === void 0 ? void 0 : (_palette_action1 = _palette1.action) === null || _palette_action1 === void 0 ? void 0 : _palette_action1.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    };
}));
const $0a2ce9886fad02ca$var$SvgIcon = /*#__PURE__*/ $7hhBq.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $6pkKu._)(props, [
        "children",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "inheritViewBox",
        "titleAccess",
        "viewBox"
    ]);
    const hasSvgAsChild = /*#__PURE__*/ $7hhBq.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $0a2ce9886fad02ca$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iHpLz.jsxs)($0a2ce9886fad02ca$var$SvgIconRoot, (0, $cNnl8._)((0, $dok7x._)({
        as: component,
        className: (0, $5vmbh.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props), {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $iHpLz.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$0a2ce9886fad02ca$var$SvgIcon.muiName = 'SvgIcon';
var $0a2ce9886fad02ca$export$2e2bcd8739ae039 = $0a2ce9886fad02ca$var$SvgIcon;

});
parcelRegister("7xIdi", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $57dde9525d655cae$export$c7c50641356bdfa5; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $57dde9525d655cae$export$c7c50641356bdfa5(slot) {
    return (0, $200uu.default)('MuiSvgIcon', slot);
}
const $57dde9525d655cae$var$svgIconClasses = (0, $5blE7.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $57dde9525d655cae$export$2e2bcd8739ae039 = $57dde9525d655cae$var$svgIconClasses;

});




parcelRegister("31K6J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23453b15eae88783$export$2e2bcd8739ae039; });

var $8Q9JX = parcelRequire("8Q9JX");

var $iHpLz = parcelRequire("iHpLz");
"use client";
var $23453b15eae88783$export$2e2bcd8739ae039 = (0, $8Q9JX.default)(/*#__PURE__*/ (0, $iHpLz.jsx)("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2m6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56M12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56m2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8M12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96M14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2m.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56M16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2z"
}), 'Language');

});

parcelRegister("bdlxK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82a19eaf2a912fa1$export$2e2bcd8739ae039; });

var $8Q9JX = parcelRequire("8Q9JX");

var $iHpLz = parcelRequire("iHpLz");
"use client";
var $82a19eaf2a912fa1$export$2e2bcd8739ae039 = (0, $8Q9JX.default)(/*#__PURE__*/ (0, $iHpLz.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 4-8 5-8-5V6l8 5 8-5z"
}), 'Mail');

});

parcelRegister("heRa1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8ccfb16e1813cc4$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");


var $eET99 = parcelRequire("eET99");

var $4Jfc1 = parcelRequire("4Jfc1");

var $cqwHw = parcelRequire("cqwHw");

var $18TeW = parcelRequire("18TeW");

var $1zv4u = parcelRequire("1zv4u");

var $3CtK9 = parcelRequire("3CtK9");

var $4ZZLe = parcelRequire("4ZZLe");

var $bJAa6 = parcelRequire("bJAa6");

var $d0uAT = parcelRequire("d0uAT");

var $bUnnb = parcelRequire("bUnnb");

var $dXKlS = parcelRequire("dXKlS");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $c8ccfb16e1813cc4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $bUnnb.default)(color)}`,
            edge && `edge${(0, $bUnnb.default)(edge)}`,
            `size${(0, $bUnnb.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $eET99.default)(slots, (0, $dXKlS.getIconButtonUtilityClass), classes);
};
const $c8ccfb16e1813cc4$var$IconButtonRoot = (0, $18TeW.default)((0, $bJAa6.default), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $bUnnb.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $bUnnb.default)(ownerState.edge)}`],
            styles[`size${(0, $bUnnb.default)(ownerState.size)}`]
        ];
    }
})((0, $1zv4u.default)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cqwHw.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $1zv4u.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $3CtK9.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $3CtK9.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cqwHw.alpha)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $dXKlS.default).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $dXKlS.default).loading}`]: {
            color: 'transparent'
        }
    })));
const $c8ccfb16e1813cc4$var$IconButtonLoadingIndicator = (0, $18TeW.default)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $c8ccfb16e1813cc4$var$IconButton = /*#__PURE__*/ $7hhBq.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp } = props, other = (0, $6pkKu._)(props, [
        "edge",
        "children",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size",
        "id",
        "loading",
        "loadingIndicator"
    ]);
    const loadingId = (0, $4Jfc1.default)(idProp);
    const loadingIndicator = loadingIndicatorProp !== null && loadingIndicatorProp !== void 0 ? loadingIndicatorProp : /*#__PURE__*/ (0, $iHpLz.jsx)((0, $d0uAT.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    });
    const classes = $c8ccfb16e1813cc4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iHpLz.jsxs)($c8ccfb16e1813cc4$var$IconButtonRoot, (0, $cNnl8._)((0, $dok7x._)({
        id: loading ? loadingId : idProp,
        className: (0, $5vmbh.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref
    }, other), {
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $iHpLz.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $iHpLz.jsx)($c8ccfb16e1813cc4$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    }));
});
var $c8ccfb16e1813cc4$export$2e2bcd8739ae039 = $c8ccfb16e1813cc4$var$IconButton;

});
parcelRegister("dXKlS", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $a2a4bd906ff6f3a5$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $a2a4bd906ff6f3a5$export$2e2bcd8739ae039; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $a2a4bd906ff6f3a5$export$5e8702d71474f093(slot) {
    return (0, $200uu.default)('MuiIconButton', slot);
}
const $a2a4bd906ff6f3a5$var$iconButtonClasses = (0, $5blE7.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $a2a4bd906ff6f3a5$export$2e2bcd8739ae039 = $a2a4bd906ff6f3a5$var$iconButtonClasses;

});




parcelRegister("ir54T", function(module, exports) {

$parcel$export(module.exports, "getInProject", function () { return $5f55a93d27a9f6c5$export$908e9545beda18b9; });
$parcel$export(module.exports, "userInProject", function () { return $5f55a93d27a9f6c5$export$480560f19ac9fb3c; });

var $dkNUW = parcelRequire("dkNUW");
const $5f55a93d27a9f6c5$var$inProject = (response, projectId)=>{
    try {
        let found = false;
        response.forEach((el)=>{
            if (el.projectId === projectId || el.slug === projectId) found = true;
        });
        return found;
    } catch (e) {
        return false;
    }
};
const $5f55a93d27a9f6c5$export$908e9545beda18b9 = async ({ projectId: projectId })=>{
    const resp = await $dkNUW.request('get', '/user/project', {});
    return {
        isSigned: $5f55a93d27a9f6c5$var$inProject(resp.data.data, projectId)
    };
};
const $5f55a93d27a9f6c5$export$480560f19ac9fb3c = ({ projectId: projectId, loggedIn: loggedIn })=>({
        queryKey: [
            'userInProject',
            projectId,
            loggedIn
        ],
        queryFn: ()=>$5f55a93d27a9f6c5$export$908e9545beda18b9({
                projectId: projectId,
                loggedIn: loggedIn
            }),
        enabled: !!projectId && loggedIn
    });

});

parcelRegister("i813w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eca80709b7ce150f$export$2e2bcd8739ae039; });

var $iHpLz = parcelRequire("iHpLz");

var $8oEKT = parcelRequire("8oEKT");

var $7hhBq = parcelRequire("7hhBq");

var $aw1H1 = parcelRequire("aw1H1");

var $l4ULz = parcelRequire("l4ULz");

var $ljlev = parcelRequire("ljlev");
/**
 * Makes a route private by checking everytime if the user has the required
 * permissions to view a certain route. otherwise it sends the user into
 * the home page
 */ const $eca80709b7ce150f$var$PrivateRoute = ({ children: children, requiredRole: requiredRole = 6, redirectTo: redirectTo })=>{
    const projectId = (0, $8oEKT.default)();
    const navigate = (0, $aw1H1.useNavigate)();
    const roleId = (0, $l4ULz.default)();
    const authSession = (0, $ljlev.default)();
    const redirect = ()=>navigate(redirectTo || `/${projectId}/`);
    (0, $7hhBq.useEffect)(()=>{
        try {
            const { token: token } = authSession;
            if (!token) throw new Error('No token found');
            if (roleId > requiredRole) redirect();
        } catch (err) {
            redirect();
            authSession.destroySession();
        }
    }, []);
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iHpLz.Fragment), {
        children: children
    });
};
var $eca80709b7ce150f$export$2e2bcd8739ae039 = $eca80709b7ce150f$var$PrivateRoute;

});
parcelRegister("l4ULz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9129b449d6f55d5$export$2e2bcd8739ae039; });

var $ljlev = parcelRequire("ljlev");
const $b9129b449d6f55d5$var$userRoleId = ()=>{
    const authSession = (0, $ljlev.default)();
    if (!authSession.isActive) return 99;
    return authSession.sessionData.projectRole;
};
var $b9129b449d6f55d5$export$2e2bcd8739ae039 = $b9129b449d6f55d5$var$userRoleId;

});


parcelRegister("7Uawk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c15ec7bf9d67cd4$export$2e2bcd8739ae039; });

var $8Q9JX = parcelRequire("8Q9JX");

var $iHpLz = parcelRequire("iHpLz");
"use client";
var $5c15ec7bf9d67cd4$export$2e2bcd8739ae039 = (0, $8Q9JX.default)(/*#__PURE__*/ (0, $iHpLz.jsx)("path", {
    d: "M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2m-9 7.5h-2v-2h2zm0-4.5h-2v-2h2zm0-4.5h-2v-2h2z"
}), 'ConfirmationNumber');

});

parcelRegister("7pnBU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $564d2ebbc2204d57$export$2e2bcd8739ae039; });

var $8Q9JX = parcelRequire("8Q9JX");

var $iHpLz = parcelRequire("iHpLz");
"use client";
var $564d2ebbc2204d57$export$2e2bcd8739ae039 = (0, $8Q9JX.default)(/*#__PURE__*/ (0, $iHpLz.jsx)("path", {
    d: "M17 12h-5v5h5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1zm3 18H5V8h14z"
}), 'Event');

});

parcelRegister("2ZRHk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22eaee8c6f507734$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");



var $eET99 = parcelRequire("eET99");

var $cCeEk = parcelRequire("cCeEk");

var $14n8O = parcelRequire("14n8O");

var $18TeW = parcelRequire("18TeW");

var $1zv4u = parcelRequire("1zv4u");

var $4ZZLe = parcelRequire("4ZZLe");

var $73ken = parcelRequire("73ken");

var $dHiJW = parcelRequire("dHiJW");

var $jpGj9 = parcelRequire("jpGj9");

var $bVaPR = parcelRequire("bVaPR");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $22eaee8c6f507734$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $eET99.default)(slots, (0, $jpGj9.getModalUtilityClass), classes);
};
const $22eaee8c6f507734$var$ModalRoot = (0, $18TeW.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $1zv4u.default)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $22eaee8c6f507734$var$ModalBackdrop = (0, $18TeW.default)((0, $73ken.default), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $22eaee8c6f507734$var$Modal = /*#__PURE__*/ $7hhBq.forwardRef(function Modal(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $22eaee8c6f507734$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme } = props, other = (0, $6pkKu._)(props, [
        "BackdropComponent",
        "BackdropProps",
        "classes",
        "className",
        "closeAfterTransition",
        "children",
        "container",
        "component",
        "components",
        "componentsProps",
        "disableAutoFocus",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "onBackdropClick",
        "onClose",
        "onTransitionEnter",
        "onTransitionExited",
        "open",
        "slotProps",
        "slots",
        "theme"
    ]);
    const propsWithDefaults = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $dHiJW.default)((0, $cNnl8._)((0, $dok7x._)({}, propsWithDefaults), {
        rootRef: ref
    }));
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, propsWithDefaults), {
        exited: exited
    });
    const classes = $22eaee8c6f507734$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: (0, $dok7x._)({
            root: components.Root,
            backdrop: components.Backdrop
        }, slots),
        slotProps: (0, $dok7x._)({}, componentsProps, slotProps)
    };
    const [RootSlot, rootProps] = (0, $bVaPR.default)('root', {
        ref: ref,
        elementType: $22eaee8c6f507734$var$ModalRoot,
        externalForwardedProps: (0, $cNnl8._)((0, $dok7x._)({}, externalForwardedProps, other), {
            component: component
        }),
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $5vmbh.default)(className, classes === null || classes === void 0 ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes === null || classes === void 0 ? void 0 : classes.hidden))
    });
    const [BackdropSlot, backdropProps] = (0, $bVaPR.default)('backdrop', {
        ref: BackdropProps === null || BackdropProps === void 0 ? void 0 : BackdropProps.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $cNnl8._)((0, $dok7x._)({}, otherHandlers), {
                onClick: (event)=>{
                    if (onBackdropClick) onBackdropClick(event);
                    if (otherHandlers === null || otherHandlers === void 0 ? void 0 : otherHandlers.onClick) otherHandlers.onClick(event);
                }
            }));
        },
        className: (0, $5vmbh.default)(BackdropProps === null || BackdropProps === void 0 ? void 0 : BackdropProps.className, classes === null || classes === void 0 ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $14n8O.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $iHpLz.jsxs)(RootSlot, (0, $cNnl8._)((0, $dok7x._)({}, rootProps), {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $iHpLz.jsx)(BackdropSlot, (0, $dok7x._)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $iHpLz.jsx)((0, $cCeEk.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $7hhBq.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $22eaee8c6f507734$export$2e2bcd8739ae039 = $22eaee8c6f507734$var$Modal;

});
parcelRegister("cCeEk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92f465b8a0de36d1$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");


var $8aEjg = parcelRequire("8aEjg");
var $eM5Ur = parcelRequire("eM5Ur");
var $8bPXz = parcelRequire("8bPXz");

var $iHpLz = parcelRequire("iHpLz");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $92f465b8a0de36d1$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $92f465b8a0de36d1$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $92f465b8a0de36d1$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $92f465b8a0de36d1$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $92f465b8a0de36d1$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $92f465b8a0de36d1$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($92f465b8a0de36d1$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $92f465b8a0de36d1$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$92f465b8a0de36d1$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $92f465b8a0de36d1$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $92f465b8a0de36d1$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $92f465b8a0de36d1$var$defaultGetTabbable, isEnabled: isEnabled = $92f465b8a0de36d1$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $7hhBq.useRef(false);
    const sentinelStart = $7hhBq.useRef(null);
    const sentinelEnd = $7hhBq.useRef(null);
    const nodeToRestore = $7hhBq.useRef(null);
    const reactFocusEventTarget = $7hhBq.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $7hhBq.useRef(false);
    const rootRef = $7hhBq.useRef(null);
    const handleRef = (0, $8bPXz.default)((0, $8aEjg.default)(children), rootRef);
    const lastKeydown = $7hhBq.useRef(null);
    $7hhBq.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $7hhBq.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $eM5Ur.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $7hhBq.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $eM5Ur.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown_current, _lastKeydown_current1;
                const isShiftTab = Boolean(((_lastKeydown_current = lastKeydown.current) === null || _lastKeydown_current === void 0 ? void 0 : _lastKeydown_current.shiftKey) && ((_lastKeydown_current1 = lastKeydown.current) === null || _lastKeydown_current1 === void 0 ? void 0 : _lastKeydown_current1.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $iHpLz.jsxs)($7hhBq.Fragment, {
        children: [
            /*#__PURE__*/ (0, $iHpLz.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $7hhBq.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $iHpLz.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $92f465b8a0de36d1$export$2e2bcd8739ae039 = $92f465b8a0de36d1$var$FocusTrap;

});
parcelRegister("8aEjg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f2e868ce4347ebe$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");
function $5f2e868ce4347ebe$export$2e2bcd8739ae039(element) {
    var _element_props;
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($7hhBq.version, 10) >= 19) return (element === null || element === void 0 ? void 0 : (_element_props = element.props) === null || _element_props === void 0 ? void 0 : _element_props.ref) || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element === null || element === void 0 ? void 0 : element.ref) || null;
}

});

parcelRegister("eM5Ur", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac1a21e0ab6e428a$export$2e2bcd8739ae039; });
function $ac1a21e0ab6e428a$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});


parcelRegister("14n8O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c781d875fa7f77f$export$2e2bcd8739ae039; });

var $7hhBq = parcelRequire("7hhBq");

var $4unLw = parcelRequire("4unLw");


var $8aEjg = parcelRequire("8aEjg");
var $hwkp9 = parcelRequire("hwkp9");
var $bWfnw = parcelRequire("bWfnw");
var $8bPXz = parcelRequire("8bPXz");
'use client';
function $0c781d875fa7f77f$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://v6.mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://v6.mui.com/material-ui/api/portal/)
 */ const $0c781d875fa7f77f$var$Portal = /*#__PURE__*/ $7hhBq.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $7hhBq.useState(null);
    const handleRef = (0, $8bPXz.default)(/*#__PURE__*/ $7hhBq.isValidElement(children) ? (0, $8aEjg.default)(children) : null, forwardedRef);
    (0, $bWfnw.default)(()=>{
        if (!disablePortal) setMountNode($0c781d875fa7f77f$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $bWfnw.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $hwkp9.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $hwkp9.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $7hhBq.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $7hhBq.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $4unLw.createPortal(children, mountNode) : mountNode;
});
var $0c781d875fa7f77f$export$2e2bcd8739ae039 = $0c781d875fa7f77f$var$Portal;

});
parcelRegister("hwkp9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc1540ca11dd235c$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $cc1540ca11dd235c$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("73ken", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $522881ac6e40a3e2$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");

var $eET99 = parcelRequire("eET99");

var $18TeW = parcelRequire("18TeW");

var $4ZZLe = parcelRequire("4ZZLe");

var $bVaPR = parcelRequire("bVaPR");

var $5odmd = parcelRequire("5odmd");

var $cEBun = parcelRequire("cEBun");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $522881ac6e40a3e2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $eET99.default)(slots, (0, $cEBun.getBackdropUtilityClass), classes);
};
const $522881ac6e40a3e2$var$BackdropRoot = (0, $18TeW.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $522881ac6e40a3e2$var$Backdrop = /*#__PURE__*/ $7hhBq.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration } = props, other = (0, $6pkKu._)(props, [
        "children",
        "className",
        "component",
        "invisible",
        "open",
        "components",
        "componentsProps",
        "slotProps",
        "slots",
        "TransitionComponent",
        "transitionDuration"
    ]);
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        component: component,
        invisible: invisible
    });
    const classes = $522881ac6e40a3e2$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, $dok7x._)({
        transition: TransitionComponentProp,
        root: components.Root
    }, slots);
    const backwardCompatibleSlotProps = (0, $dok7x._)({}, componentsProps, slotProps);
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $bVaPR.default)('root', {
        elementType: $522881ac6e40a3e2$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $5vmbh.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $bVaPR.default)('transition', {
        elementType: (0, $5odmd.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $iHpLz.jsx)(TransitionSlot, (0, $cNnl8._)((0, $dok7x._)({
        in: open,
        timeout: transitionDuration
    }, other, transitionProps), {
        children: /*#__PURE__*/ (0, $iHpLz.jsx)(RootSlot, (0, $cNnl8._)((0, $dok7x._)({
            "aria-hidden": true
        }, rootProps), {
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $522881ac6e40a3e2$export$2e2bcd8739ae039 = $522881ac6e40a3e2$var$Backdrop;

});
parcelRegister("bVaPR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8add6c461a684b0e$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $8bPXz = parcelRequire("8bPXz");

var $9JnKJ = parcelRequire("9JnKJ");

var $e851D = parcelRequire("e851D");

var $99fLg = parcelRequire("99fLg");
'use client';
function $8add6c461a684b0e$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false } = parameters, useSlotPropsParams = (0, $6pkKu._)(parameters, [
        "className",
        "elementType",
        "ownerState",
        "externalForwardedProps",
        "internalForwardedProps",
        "shouldForwardComponentProp"
    ]);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $6pkKu._)(externalForwardedProps, [
        "component",
        "slots",
        "slotProps"
    ]);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $e851D.default)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $99fLg.default)((0, $cNnl8._)((0, $dok7x._)({
        className: className
    }, useSlotPropsParams), {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $6pkKu._)(_mergeSlotProps.props, [
        "component"
    ]);
    const ref = (0, $8bPXz.default)(internalRef, resolvedComponentsProps === null || resolvedComponentsProps === void 0 ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $9JnKJ.default)(elementType, (0, $cNnl8._)((0, $dok7x._)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && !shouldForwardComponentProp && {
        as: LeafComponent
    }, LeafComponent && shouldForwardComponentProp && {
        component: LeafComponent
    }), {
        ref: ref
    }), ownerState);
    return [
        elementType,
        props
    ];
}

});
parcelRegister("9JnKJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $715abdd909e7fe5e$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $7WhJu = parcelRequire("7WhJu");
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $715abdd909e7fe5e$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $7WhJu.default)(elementType)) return otherProps;
    return (0, $cNnl8._)((0, $dok7x._)({}, otherProps), {
        ownerState: (0, $dok7x._)({}, otherProps.ownerState, ownerState)
    });
}
var $715abdd909e7fe5e$export$2e2bcd8739ae039 = $715abdd909e7fe5e$var$appendOwnerState;

});
parcelRegister("7WhJu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c7bb48c11c76af0$export$2e2bcd8739ae039; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $5c7bb48c11c76af0$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $5c7bb48c11c76af0$export$2e2bcd8739ae039 = $5c7bb48c11c76af0$var$isHostComponent;

});


parcelRegister("e851D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a495b5f8544d70ff$export$2e2bcd8739ae039; });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $a495b5f8544d70ff$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $a495b5f8544d70ff$export$2e2bcd8739ae039 = $a495b5f8544d70ff$var$resolveComponentProps;

});

parcelRegister("99fLg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a912e301fdb07ff$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $5vmbh = parcelRequire("5vmbh");

var $5hszz = parcelRequire("5hszz");

var $2MtnD = parcelRequire("2MtnD");
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $6a912e301fdb07ff$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $5vmbh.default)(additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.className, className, externalForwardedProps === null || externalForwardedProps === void 0 ? void 0 : externalForwardedProps.className, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $dok7x._)({}, additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.style, externalForwardedProps === null || externalForwardedProps === void 0 ? void 0 : externalForwardedProps.style, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.style);
        const props = (0, $dok7x._)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $5hszz.default)((0, $dok7x._)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $2MtnD.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $2MtnD.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $5vmbh.default)(internalSlotProps === null || internalSlotProps === void 0 ? void 0 : internalSlotProps.className, additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.className, className, externalForwardedProps === null || externalForwardedProps === void 0 ? void 0 : externalForwardedProps.className, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $dok7x._)({}, internalSlotProps === null || internalSlotProps === void 0 ? void 0 : internalSlotProps.style, additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.style, externalForwardedProps === null || externalForwardedProps === void 0 ? void 0 : externalForwardedProps.style, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.style);
    const props = (0, $dok7x._)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $6a912e301fdb07ff$export$2e2bcd8739ae039 = $6a912e301fdb07ff$var$mergeSlotProps;

});
parcelRegister("5hszz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d84b43f06554917$export$2e2bcd8739ae039; });
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $3d84b43f06554917$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $3d84b43f06554917$export$2e2bcd8739ae039 = $3d84b43f06554917$var$extractEventHandlers;

});

parcelRegister("2MtnD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2066dac732b159bd$export$2e2bcd8739ae039; });
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $2066dac732b159bd$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $2066dac732b159bd$export$2e2bcd8739ae039 = $2066dac732b159bd$var$omitEventHandlers;

});



parcelRegister("5odmd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ec98e242091ff7f$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $2v7gK = parcelRequire("2v7gK");


var $8aEjg = parcelRequire("8aEjg");

var $eGBcx = parcelRequire("eGBcx");

var $5Chn3 = parcelRequire("5Chn3");

var $drmCR = parcelRequire("drmCR");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $3ec98e242091ff7f$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $3ec98e242091ff7f$var$Fade = /*#__PURE__*/ $7hhBq.forwardRef(function Fade(props, ref) {
    const theme = (0, $eGBcx.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $2v7gK.default) } = props, other = (0, $6pkKu._)(props, [
        "addEndListener",
        "appear",
        "children",
        "easing",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    const enableStrictModeCompat = true;
    const nodeRef = $7hhBq.useRef(null);
    const handleRef = (0, $drmCR.default)(nodeRef, (0, $8aEjg.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $5Chn3.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $5Chn3.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $5Chn3.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $iHpLz.jsx)(TransitionComponent, (0, $cNnl8._)((0, $dok7x._)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other), {
        children: (state, _param)=>{
            var { ownerState: ownerState } = _param, restChildProps = (0, $6pkKu._)(_param, [
                "ownerState"
            ]);
            return /*#__PURE__*/ $7hhBq.cloneElement(children, (0, $dok7x._)({
                style: (0, $dok7x._)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $3ec98e242091ff7f$var$styles[state], style, children.props.style),
                ref: handleRef
            }, restChildProps));
        }
    }));
});
var $3ec98e242091ff7f$export$2e2bcd8739ae039 = $3ec98e242091ff7f$var$Fade;

});
parcelRegister("2v7gK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d241d85027c6fbd$export$2e2bcd8739ae039; });

var $ctw6m = parcelRequire("ctw6m");

var $441XV = parcelRequire("441XV");


var $7hhBq = parcelRequire("7hhBq");

var $4unLw = parcelRequire("4unLw");

var $cJN0C = parcelRequire("cJN0C");


var $rJ5y8 = parcelRequire("rJ5y8");

var $9adaV = parcelRequire("9adaV");
var $1d241d85027c6fbd$export$bb38bb9a1161268 = 'unmounted';
var $1d241d85027c6fbd$export$84cbff306f539230 = 'exited';
var $1d241d85027c6fbd$export$df38205c966be359 = 'entering';
var $1d241d85027c6fbd$export$78e9e6e3e014d60a = 'entered';
var $1d241d85027c6fbd$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $1d241d85027c6fbd$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $441XV.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $1d241d85027c6fbd$export$84cbff306f539230;
                _this.appearStatus = $1d241d85027c6fbd$export$df38205c966be359;
            } else initialStatus = $1d241d85027c6fbd$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $1d241d85027c6fbd$export$bb38bb9a1161268;
        else initialStatus = $1d241d85027c6fbd$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $1d241d85027c6fbd$export$bb38bb9a1161268) return {
            status: $1d241d85027c6fbd$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $1d241d85027c6fbd$export$df38205c966be359 && status !== $1d241d85027c6fbd$export$78e9e6e3e014d60a) nextStatus = $1d241d85027c6fbd$export$df38205c966be359;
            } else if (status === $1d241d85027c6fbd$export$df38205c966be359 || status === $1d241d85027c6fbd$export$78e9e6e3e014d60a) nextStatus = $1d241d85027c6fbd$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $1d241d85027c6fbd$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($4unLw))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $9adaV.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $1d241d85027c6fbd$export$84cbff306f539230) this.setState({
            status: $1d241d85027c6fbd$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($4unLw))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $cJN0C.default).disabled) {
            this.safeSetState({
                status: $1d241d85027c6fbd$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $1d241d85027c6fbd$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $1d241d85027c6fbd$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($4unLw))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $cJN0C.default).disabled) {
            this.safeSetState({
                status: $1d241d85027c6fbd$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $1d241d85027c6fbd$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $1d241d85027c6fbd$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($4unLw))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $1d241d85027c6fbd$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $ctw6m.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement((0, $rJ5y8.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).Component);
$1d241d85027c6fbd$var$Transition.contextType = (0, $rJ5y8.default);
$1d241d85027c6fbd$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $1d241d85027c6fbd$var$noop() {}
$1d241d85027c6fbd$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $1d241d85027c6fbd$var$noop,
    onEntering: $1d241d85027c6fbd$var$noop,
    onEntered: $1d241d85027c6fbd$var$noop,
    onExit: $1d241d85027c6fbd$var$noop,
    onExiting: $1d241d85027c6fbd$var$noop,
    onExited: $1d241d85027c6fbd$var$noop
};
$1d241d85027c6fbd$var$Transition.UNMOUNTED = $1d241d85027c6fbd$export$bb38bb9a1161268;
$1d241d85027c6fbd$var$Transition.EXITED = $1d241d85027c6fbd$export$84cbff306f539230;
$1d241d85027c6fbd$var$Transition.ENTERING = $1d241d85027c6fbd$export$df38205c966be359;
$1d241d85027c6fbd$var$Transition.ENTERED = $1d241d85027c6fbd$export$78e9e6e3e014d60a;
$1d241d85027c6fbd$var$Transition.EXITING = $1d241d85027c6fbd$export$4aacc83d4d59139f;
var $1d241d85027c6fbd$export$2e2bcd8739ae039 = $1d241d85027c6fbd$var$Transition;

});
parcelRegister("cJN0C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $945fb42c024d099a$export$2e2bcd8739ae039; });
var $945fb42c024d099a$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("9adaV", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $6abf448edc57964b$export$7d26bbb1236dafd6; });
var $6abf448edc57964b$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("5Chn3", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $416df9dbb9209c2e$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $416df9dbb9209c2e$export$8cb1e9b404609ae9; });
const $416df9dbb9209c2e$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $416df9dbb9209c2e$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    var _style_transitionDuration, _style_transitionTimingFunction;
    return {
        duration: (_style_transitionDuration = style.transitionDuration) !== null && _style_transitionDuration !== void 0 ? _style_transitionDuration : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style_transitionTimingFunction = style.transitionTimingFunction) !== null && _style_transitionTimingFunction !== void 0 ? _style_transitionTimingFunction : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});


parcelRegister("cEBun", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", function () { return $93664d00cd811dbe$export$9927a91fd93152bd; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $93664d00cd811dbe$export$9927a91fd93152bd(slot) {
    return (0, $200uu.default)('MuiBackdrop', slot);
}
const $93664d00cd811dbe$var$backdropClasses = (0, $5blE7.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $93664d00cd811dbe$export$2e2bcd8739ae039 = $93664d00cd811dbe$var$backdropClasses;

});


parcelRegister("dHiJW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f8dd3e839ad656f$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $7hhBq = parcelRequire("7hhBq");

var $5DysP = parcelRequire("5DysP");
var $eM5Ur = parcelRequire("eM5Ur");
var $3Z3Qo = parcelRequire("3Z3Qo");
var $8bPXz = parcelRequire("8bPXz");

var $5hszz = parcelRequire("5hszz");

var $blvoZ = parcelRequire("blvoZ");
'use client';
function $9f8dd3e839ad656f$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $9f8dd3e839ad656f$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $9f8dd3e839ad656f$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $9f8dd3e839ad656f$var$manager = new (0, $blvoZ.ModalManager)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $9f8dd3e839ad656f$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $7hhBq.useRef({});
    const mountNodeRef = $7hhBq.useRef(null);
    const modalRef = $7hhBq.useRef(null);
    const handleRef = (0, $8bPXz.default)(modalRef, rootRef);
    const [exited, setExited] = $7hhBq.useState(!open);
    const hasTransition = $9f8dd3e839ad656f$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $eM5Ur.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $9f8dd3e839ad656f$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $3Z3Qo.default)(()=>{
        const resolvedContainer = $9f8dd3e839ad656f$var$getContainer(container) || getDoc().body;
        $9f8dd3e839ad656f$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$9f8dd3e839ad656f$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $3Z3Qo.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $blvoZ.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $7hhBq.useCallback(()=>{
        $9f8dd3e839ad656f$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $7hhBq.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $7hhBq.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers_onKeyDown;
            (_otherHandlers_onKeyDown = otherHandlers.onKeyDown) === null || _otherHandlers_onKeyDown === void 0 ? void 0 : _otherHandlers_onKeyDown.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers_onClick;
            (_otherHandlers_onClick = otherHandlers.onClick) === null || _otherHandlers_onClick === void 0 ? void 0 : _otherHandlers_onClick.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $5hszz.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $dok7x._)({}, propsEventHandlers, otherHandlers);
        return (0, $cNnl8._)((0, $dok7x._)({
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation'
        }, externalEventHandlers), {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $cNnl8._)((0, $dok7x._)({
            'aria-hidden': true
        }, externalEventHandlers), {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        var _children_props_onEnter, _children_props_onExited;
        return {
            onEnter: (0, $5DysP.default)(handleEnter, (_children_props_onEnter = children === null || children === void 0 ? void 0 : children.props.onEnter) !== null && _children_props_onEnter !== void 0 ? _children_props_onEnter : $9f8dd3e839ad656f$var$noop),
            onExited: (0, $5DysP.default)(handleExited, (_children_props_onExited = children === null || children === void 0 ? void 0 : children.props.onExited) !== null && _children_props_onExited !== void 0 ? _children_props_onExited : $9f8dd3e839ad656f$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $9f8dd3e839ad656f$export$2e2bcd8739ae039 = $9f8dd3e839ad656f$var$useModal;

});
parcelRegister("5DysP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41ab5419094532aa$export$2e2bcd8739ae039; });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $41ab5419094532aa$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("blvoZ", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $842a03aa9c6c24e3$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "ModalManager", function () { return $842a03aa9c6c24e3$export$ce11c4ecd08cea67; });

var $detzR = parcelRequire("detzR");
var $eM5Ur = parcelRequire("eM5Ur");
var $erwCg = parcelRequire("erwCg");
// Is a vertical scrollbar displayed?
function $842a03aa9c6c24e3$var$isOverflowing(container) {
    const doc = (0, $eM5Ur.default)(container);
    if (doc.body === container) return (0, $erwCg.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $842a03aa9c6c24e3$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $842a03aa9c6c24e3$var$getPaddingRight(element) {
    return parseInt((0, $erwCg.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $842a03aa9c6c24e3$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $842a03aa9c6c24e3$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$842a03aa9c6c24e3$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $842a03aa9c6c24e3$export$e1bd0c6150f13d96(element, hide);
    });
}
function $842a03aa9c6c24e3$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $842a03aa9c6c24e3$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($842a03aa9c6c24e3$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $detzR.default)((0, $erwCg.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$842a03aa9c6c24e3$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $eM5Ur.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$842a03aa9c6c24e3$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $eM5Ur.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $erwCg.default)(container);
            scrollContainer = (parent === null || parent === void 0 ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $842a03aa9c6c24e3$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $842a03aa9c6c24e3$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $842a03aa9c6c24e3$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $842a03aa9c6c24e3$var$getHiddenSiblings(container);
        $842a03aa9c6c24e3$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $842a03aa9c6c24e3$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $842a03aa9c6c24e3$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $842a03aa9c6c24e3$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $842a03aa9c6c24e3$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $842a03aa9c6c24e3$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $842a03aa9c6c24e3$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $842a03aa9c6c24e3$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.modals = [];
        this.containers = [];
    }
}

});
parcelRegister("detzR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a2386a5dc032e2e$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $9a2386a5dc032e2e$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

});

parcelRegister("erwCg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a83ce3319db36b51$export$2e2bcd8739ae039; });

var $eM5Ur = parcelRequire("eM5Ur");
function $a83ce3319db36b51$export$2e2bcd8739ae039(node) {
    const doc = (0, $eM5Ur.default)(node);
    return doc.defaultView || window;
}

});



parcelRegister("jpGj9", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", function () { return $e2212b99ff3b3e83$export$67960e22b12a638d; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $e2212b99ff3b3e83$export$67960e22b12a638d(slot) {
    return (0, $200uu.default)('MuiModal', slot);
}
const $e2212b99ff3b3e83$var$modalClasses = (0, $5blE7.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $e2212b99ff3b3e83$export$2e2bcd8739ae039 = $e2212b99ff3b3e83$var$modalClasses;

});


parcelRegister("f1VUu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af13debb3fdddc18$export$2e2bcd8739ae039; });

var $9i3UY = parcelRequire("9i3UY");
var $af13debb3fdddc18$export$2e2bcd8739ae039 = (0, $9i3UY.default);

});
parcelRegister("9i3UY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c38d5854f5f7ede$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $6c38d5854f5f7ede$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRegister("d0gXo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97786dbd2494dcae$export$2e2bcd8739ae039; });

var $erwCg = parcelRequire("erwCg");
var $97786dbd2494dcae$export$2e2bcd8739ae039 = (0, $erwCg.default);

});

parcelRegister("cbi7u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8de49151b82036ff$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");



var $eET99 = parcelRequire("eET99");

var $cqwHw = parcelRequire("cqwHw");

var $18TeW = parcelRequire("18TeW");
var $eGBcx = parcelRequire("eGBcx");

var $1zv4u = parcelRequire("1zv4u");

var $4ZZLe = parcelRequire("4ZZLe");

var $1zr8O = parcelRequire("1zr8O");

var $aH2XS = parcelRequire("aH2XS");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $8de49151b82036ff$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $eET99.default)(slots, (0, $aH2XS.getPaperUtilityClass), classes);
};
const $8de49151b82036ff$var$PaperRoot = (0, $18TeW.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $1zv4u.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $8de49151b82036ff$var$Paper = /*#__PURE__*/ $7hhBq.forwardRef(function Paper(inProps, ref) {
    var _theme_vars_overlays;
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $eGBcx.default)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $6pkKu._)(props, [
        "className",
        "component",
        "elevation",
        "square",
        "variant"
    ]);
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $8de49151b82036ff$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iHpLz.jsx)($8de49151b82036ff$var$PaperRoot, (0, $cNnl8._)((0, $dok7x._)({
        as: component,
        ownerState: ownerState,
        className: (0, $5vmbh.default)(classes.root, className),
        ref: ref
    }, other), {
        style: (0, $dok7x._)({}, variant === 'elevation' && (0, $dok7x._)({
            '--Paper-shadow': (theme.vars || theme).shadows[elevation]
        }, theme.vars && {
            '--Paper-overlay': (_theme_vars_overlays = theme.vars.overlays) === null || _theme_vars_overlays === void 0 ? void 0 : _theme_vars_overlays[elevation]
        }, !theme.vars && theme.palette.mode === 'dark' && {
            '--Paper-overlay': `linear-gradient(${(0, $cqwHw.alpha)('#fff', (0, $1zr8O.default)(elevation))}, ${(0, $cqwHw.alpha)('#fff', (0, $1zr8O.default)(elevation))})`
        }), other.style)
    }));
});
var $8de49151b82036ff$export$2e2bcd8739ae039 = $8de49151b82036ff$var$Paper;

});
parcelRegister("aH2XS", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", function () { return $7c90384c9aab7001$export$29cdb466b9b6f20b; });

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $7c90384c9aab7001$export$29cdb466b9b6f20b(slot) {
    return (0, $200uu.default)('MuiPaper', slot);
}
const $7c90384c9aab7001$var$paperClasses = (0, $5blE7.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $7c90384c9aab7001$export$2e2bcd8739ae039 = $7c90384c9aab7001$var$paperClasses;

});


parcelRegister("lnlFY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8fc8f610e4d4902$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $5vmbh = parcelRequire("5vmbh");
function $f8fc8f610e4d4902$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps((0, $dok7x._)({}, ownerState, defaultSlotPropsValue)) : externalSlotProps;
        const className = (0, $5vmbh.default)(ownerState === null || ownerState === void 0 ? void 0 : ownerState.className, defaultSlotPropsValue === null || defaultSlotPropsValue === void 0 ? void 0 : defaultSlotPropsValue.className, externalSlotPropsValue === null || externalSlotPropsValue === void 0 ? void 0 : externalSlotPropsValue.className);
        return (0, $dok7x._)({}, defaultSlotPropsValue, externalSlotPropsValue, !!className && {
            className: className
        }, (defaultSlotPropsValue === null || defaultSlotPropsValue === void 0 ? void 0 : defaultSlotPropsValue.style) && (externalSlotPropsValue === null || externalSlotPropsValue === void 0 ? void 0 : externalSlotPropsValue.style) && {
            style: (0, $dok7x._)({}, defaultSlotPropsValue.style, externalSlotPropsValue.style)
        }, (defaultSlotPropsValue === null || defaultSlotPropsValue === void 0 ? void 0 : defaultSlotPropsValue.sx) && (externalSlotPropsValue === null || externalSlotPropsValue === void 0 ? void 0 : externalSlotPropsValue.sx) && {
            sx: [
                ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                    defaultSlotPropsValue.sx
                ],
                ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                    externalSlotPropsValue.sx
                ]
            ]
        });
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const className = (0, $5vmbh.default)(typedDefaultSlotProps === null || typedDefaultSlotProps === void 0 ? void 0 : typedDefaultSlotProps.className, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.className);
    return (0, $dok7x._)({}, defaultSlotProps, externalSlotProps, !!className && {
        className: className
    }, (typedDefaultSlotProps === null || typedDefaultSlotProps === void 0 ? void 0 : typedDefaultSlotProps.style) && (externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.style) && {
        style: (0, $dok7x._)({}, typedDefaultSlotProps.style, externalSlotProps.style)
    }, (typedDefaultSlotProps === null || typedDefaultSlotProps === void 0 ? void 0 : typedDefaultSlotProps.sx) && (externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.sx) && {
        sx: [
            ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                typedDefaultSlotProps.sx
            ],
            ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                externalSlotProps.sx
            ]
        ]
    });
}

});

parcelRegister("h0qGp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6172273b8cc4044$export$2e2bcd8739ae039; });

var $eM5Ur = parcelRequire("eM5Ur");
var $c6172273b8cc4044$export$2e2bcd8739ae039 = (0, $eM5Ur.default);

});

parcelRegister("fUkkz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b94bdb3aaf6183ee$export$2e2bcd8739ae039; });

var $bWfnw = parcelRequire("bWfnw");
'use client';
var $b94bdb3aaf6183ee$export$2e2bcd8739ae039 = (0, $bWfnw.default);

});

parcelRegister("7Nk55", function(module, exports) {
module.exports = $parcel$resolve("fstC1");

});

parcelRegister("jU43v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7d664a57660fe5b$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");

var $c5Qzo = parcelRequire("c5Qzo");

var $hMJr1 = parcelRequire("hMJr1");

var $bsJ6C = parcelRequire("bsJ6C");

var $OIZ7O = parcelRequire("OIZ7O");

var $lvA8a = parcelRequire("lvA8a");

var $dMV2x = parcelRequire("dMV2x");

var $l4RsO = parcelRequire("l4RsO");

var $8jy2g = parcelRequire("8jy2g");
'use client';
function $e7d664a57660fe5b$var$getClasses({ state: state, stylesOptions: stylesOptions }, classes, Component) {
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
    // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    let generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $hMJr1.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $e7d664a57660fe5b$var$attach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator, name: name }, props) {
    if (stylesOptions.disableGeneration) return;
    let sheetManager = (0, $bsJ6C.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $bsJ6C.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    const options = (0, $cNnl8._)((0, $dok7x._)({}, stylesCreator.options, stylesOptions), {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        let staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $bsJ6C.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        const styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $dok7x._)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $bsJ6C.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $c5Qzo.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        const dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $dok7x._)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $hMJr1.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $e7d664a57660fe5b$var$update({ state: state }, props) {
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $e7d664a57660fe5b$var$detach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator }) {
    if (stylesOptions.disableGeneration) return;
    const sheetManager = (0, $bsJ6C.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $bsJ6C.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $e7d664a57660fe5b$var$useSynchronousEffect(func, values) {
    const key = $7hhBq.useRef([]);
    let output;
    // Store "generation" key. Just returns a new object every time
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    const currentKey = $7hhBq.useMemo(()=>({}), values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    $7hhBq.useEffect(()=>()=>{
            if (output) output();
        }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $e7d664a57660fe5b$export$2e2bcd8739ae039(stylesOrCreator, options = {}) {
    const { name: // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name, // Help with debuggability.
    classNamePrefix: classNamePrefixOption, Component: Component, defaultTheme: defaultTheme = (0, $8jy2g.default) } = options, stylesOptions2 = (0, $6pkKu._)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    const stylesCreator = (0, $l4RsO.default)(stylesOrCreator);
    const classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $dMV2x.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    const useStyles = (props = {})=>{
        const theme = (0, $OIZ7O.default)() || defaultTheme;
        const stylesOptions = (0, $dok7x._)({}, $7hhBq.useContext((0, $lvA8a.StylesContext)), stylesOptions2);
        const instance = $7hhBq.useRef();
        const shouldUpdate = $7hhBq.useRef();
        $e7d664a57660fe5b$var$useSynchronousEffect(()=>{
            const current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $e7d664a57660fe5b$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return ()=>{
                $e7d664a57660fe5b$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        $7hhBq.useEffect(()=>{
            if (shouldUpdate.current) $e7d664a57660fe5b$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        const classes = $e7d664a57660fe5b$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("c5Qzo", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $jamvR = parcelRequire("jamvR");

var $6Uz3n = parcelRequire("6Uz3n");

var $ezuq9 = parcelRequire("ezuq9");

var $aulKd = parcelRequire("aulKd");

var $441XV = parcelRequire("441XV");

var $6pEJ7 = parcelRequire("6pEJ7");

var $ctw6m = parcelRequire("ctw6m");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $441XV.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $6pEJ7.default)((0, $6pEJ7.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    };
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    };
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $jamvR.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $aulKd.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $jamvR.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $jamvR.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $jamvR.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $441XV.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $jamvR.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $jamvR.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    };
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $jamvR.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    };
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    };
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    };
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    };
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    };
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    };
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    };
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $jamvR.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    };
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    };
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    };
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    };
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    };
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    };
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    };
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    };
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    };
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    };
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    };
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    };
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    };
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    };
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    };
    _proto.reset = function reset() {
        this.registry = [];
    };
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    };
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $ctw6m.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $aulKd.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    };
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    };
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    };
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    };
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    };
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    };
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    };
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    };
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $6Uz3n.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $jamvR.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    };
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $jamvR.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    };
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    };
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, $jamvR.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $ezuq9.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $ezuq9.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $aulKd.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $8cdebaf091ccb972$export$2e2bcd8739ae039 = index;

});
parcelRegister("6Uz3n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $508329f2319fdc36$export$2e2bcd8739ae039; });
var $508329f2319fdc36$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $508329f2319fdc36$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $508329f2319fdc36$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $508329f2319fdc36$var$_typeof(document)) === 'object' && document.nodeType === 9;
var $508329f2319fdc36$export$2e2bcd8739ae039 = $508329f2319fdc36$export$4e09c449d6c407f7;

});

parcelRegister("ezuq9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9bbee80b6663573$export$2e2bcd8739ae039; });
var $a9bbee80b6663573$var$isProduction = true;
function $a9bbee80b6663573$var$warning(condition, message) {
    if (!$a9bbee80b6663573$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $a9bbee80b6663573$export$2e2bcd8739ae039 = $a9bbee80b6663573$var$warning;

});

parcelRegister("aulKd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a2d92b169b9e3dd$export$2e2bcd8739ae039; });

var $71KzI = parcelRequire("71KzI");
function $7a2d92b169b9e3dd$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $71KzI.default)(o.key), o);
    }
}
function $7a2d92b169b9e3dd$export$2e2bcd8739ae039(e, r, t) {
    return r && $7a2d92b169b9e3dd$var$_defineProperties(e.prototype, r), t && $7a2d92b169b9e3dd$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("71KzI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51dcc13c6ce9ce54$export$2e2bcd8739ae039; });

var $is6Hj = parcelRequire("is6Hj");

var $kIngX = parcelRequire("kIngX");
function $51dcc13c6ce9ce54$export$2e2bcd8739ae039(t) {
    var i = (0, $kIngX.default)(t, "string");
    return "symbol" == (0, $is6Hj.default)(i) ? i : i + "";
}

});
parcelRegister("is6Hj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6f00981a83d40f1$export$2e2bcd8739ae039; });
function $d6f00981a83d40f1$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $d6f00981a83d40f1$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d6f00981a83d40f1$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kIngX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f149f821d063d8b0$export$2e2bcd8739ae039; });

var $is6Hj = parcelRequire("is6Hj");
function $f149f821d063d8b0$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $is6Hj.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $is6Hj.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("hMJr1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf2a29c3b2ac26b4$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

function $cf2a29c3b2ac26b4$export$2e2bcd8739ae039(options = {}) {
    const { baseClasses: baseClasses, newClasses: newClasses, Component: Component } = options;
    if (!newClasses) return baseClasses;
    const nextClasses = (0, $dok7x._)({}, baseClasses);
    Object.keys(newClasses).forEach((key)=>{
        if (newClasses[key]) nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
    });
    return nextClasses;
}

});

parcelRegister("bsJ6C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85854c4afb92f39c$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
const $85854c4afb92f39c$var$multiKeyStore = {
    set: (cache, key1, key2, value)=>{
        let subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $85854c4afb92f39c$export$2e2bcd8739ae039 = $85854c4afb92f39c$var$multiKeyStore;

});

parcelRegister("OIZ7O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $098790b011d68be2$export$2e2bcd8739ae039; });

var $buEo5 = parcelRequire("buEo5");
function $098790b011d68be2$export$2e2bcd8739ae039() {
    const privateTheme = (0, $buEo5.default)();
    var _privateTheme_$$material;
    return (_privateTheme_$$material = privateTheme === null || privateTheme === void 0 ? void 0 : privateTheme.$$material) !== null && _privateTheme_$$material !== void 0 ? _privateTheme_$$material : privateTheme;
}

});

parcelRegister("lvA8a", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $fa888502ebe85ae3$export$f4de434b269fe487; });

var $dok7x = parcelRequire("dok7x");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");



var $c5Qzo = parcelRequire("c5Qzo");

var $gQCTR = parcelRequire("gQCTR");

var $aJNVA = parcelRequire("aJNVA");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $fa888502ebe85ae3$var$defaultJSS = (0, $c5Qzo.create)((0, $aJNVA.default)());
// Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
const $fa888502ebe85ae3$var$defaultGenerateClassName = (0, $gQCTR.default)();
const $fa888502ebe85ae3$export$70a8aea9ff58d1cd = new Map();
const $fa888502ebe85ae3$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $fa888502ebe85ae3$var$defaultGenerateClassName,
    jss: $fa888502ebe85ae3$var$defaultJSS,
    sheetsCache: null,
    sheetsManager: $fa888502ebe85ae3$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
const $fa888502ebe85ae3$export$f4de434b269fe487 = /*#__PURE__*/ $7hhBq.createContext($fa888502ebe85ae3$var$defaultOptions);
let $fa888502ebe85ae3$var$injectFirstNode;
function $fa888502ebe85ae3$export$2e2bcd8739ae039(props) {
    const { children: children, injectFirst: injectFirst = false, disableGeneration: disableGeneration = false } = props, localOptions = (0, $6pkKu._)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    const outerOptions = $7hhBq.useContext($fa888502ebe85ae3$export$f4de434b269fe487);
    const { generateClassName: generateClassName, jss: jss, serverGenerateClassName: serverGenerateClassName, sheetsCache: sheetsCache, sheetsManager: sheetsManager, sheetsRegistry: sheetsRegistry } = (0, $dok7x._)({}, outerOptions, localOptions);
    const value = $7hhBq.useMemo(()=>{
        const context = {
            disableGeneration: disableGeneration,
            generateClassName: generateClassName,
            jss: jss,
            serverGenerateClassName: serverGenerateClassName,
            sheetsCache: sheetsCache,
            sheetsManager: sheetsManager,
            sheetsRegistry: sheetsRegistry
        };
        if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
            if (!$fa888502ebe85ae3$var$injectFirstNode) {
                const head = document.head;
                // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- injectFirstNode is called inside callback
                $fa888502ebe85ae3$var$injectFirstNode = document.createComment('mui-inject-first');
                head.insertBefore($fa888502ebe85ae3$var$injectFirstNode, head.firstChild);
            }
            context.jss = (0, $c5Qzo.create)({
                plugins: (0, $aJNVA.default)().plugins,
                insertionPoint: $fa888502ebe85ae3$var$injectFirstNode
            });
        }
        return context;
    }, [
        injectFirst,
        disableGeneration,
        generateClassName,
        jss,
        serverGenerateClassName,
        sheetsCache,
        sheetsManager,
        sheetsRegistry
    ]);
    return /*#__PURE__*/ (0, $iHpLz.jsx)($fa888502ebe85ae3$export$f4de434b269fe487.Provider, {
        value: value,
        children: children
    });
}

});
parcelRegister("gQCTR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c43fad6558f313e3$export$2e2bcd8739ae039; });

var $byty1 = parcelRequire("byty1");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously defined styles as well as
 * being untouched by simple user overrides.
 */ const $c43fad6558f313e3$var$stateClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
];
function $c43fad6558f313e3$export$2e2bcd8739ae039(options = {}) {
    const { disableGlobal: disableGlobal = false, productionPrefix: productionPrefix = 'jss', seed: seed = '' } = options;
    const seedPrefix = seed === '' ? '' : `${seed}-`;
    let ruleCounter = 0;
    const getNextCounterId = ()=>{
        ruleCounter += 1;
        return ruleCounter;
    };
    return (rule, styleSheet)=>{
        const name = styleSheet.options.name;
        // Is a global static MUI style?
        if (name && name.startsWith('Mui') && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($c43fad6558f313e3$var$stateClasses.includes(rule.key)) return `Mui-${rule.key}`;
            const prefix = `${seedPrefix}${name}-${rule.key}`;
            if (!styleSheet.options.theme[0, $byty1.default] || seed !== '') return prefix;
            return `${prefix}-${getNextCounterId()}`;
        }
        return `${seedPrefix}${productionPrefix}${getNextCounterId()}`;
    };
}

});

parcelRegister("aJNVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d14d5f4e7247842$export$2e2bcd8739ae039; });

var $e2dcw = parcelRequire("e2dcw");

var $9uYcz = parcelRequire("9uYcz");

var $8B0cW = parcelRequire("8B0cW");

var $2FGnn = parcelRequire("2FGnn");

var $3W4WD = parcelRequire("3W4WD");

var $dG6Qz = parcelRequire("dG6Qz");

var $5x6WR = parcelRequire("5x6WR");
function $7d14d5f4e7247842$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $e2dcw.default)(),
            (0, $9uYcz.default)(),
            (0, $8B0cW.default)(),
            (0, $2FGnn.default)(),
            (0, $3W4WD.default)(),
            // Disable the vendor prefixer server-side, it does nothing.
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $dG6Qz.default)(),
            (0, $5x6WR.default)()
        ]
    };
}

});
parcelRegister("e2dcw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a37b7e0dfa4847f5$export$2e2bcd8739ae039; });


var $c5Qzo = parcelRequire("c5Qzo");
var $a37b7e0dfa4847f5$var$now = Date.now();
var $a37b7e0dfa4847f5$var$fnValuesNs = "fnValues" + $a37b7e0dfa4847f5$var$now;
var $a37b7e0dfa4847f5$var$fnRuleNs = "fnStyle" + ++$a37b7e0dfa4847f5$var$now;
var $a37b7e0dfa4847f5$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, $c5Qzo.createRule)(name, {}, options);
            rule[$a37b7e0dfa4847f5$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($a37b7e0dfa4847f5$var$fnValuesNs in rule || $a37b7e0dfa4847f5$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$a37b7e0dfa4847f5$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$a37b7e0dfa4847f5$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$a37b7e0dfa4847f5$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $a37b7e0dfa4847f5$export$2e2bcd8739ae039 = $a37b7e0dfa4847f5$var$functionPlugin;

});

parcelRegister("9uYcz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ea59d3b4cd68d9d$export$2e2bcd8739ae039; });

var $jamvR = parcelRequire("jamvR");

var $c5Qzo = parcelRequire("c5Qzo");
var $6ea59d3b4cd68d9d$var$at = '@global';
var $6ea59d3b4cd68d9d$var$atPrefix = '@global ';
var $6ea59d3b4cd68d9d$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = $6ea59d3b4cd68d9d$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $c5Qzo.RuleList)((0, $jamvR.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $6ea59d3b4cd68d9d$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = $6ea59d3b4cd68d9d$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($6ea59d3b4cd68d9d$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $jamvR.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var $6ea59d3b4cd68d9d$var$separatorRegExp = /\s*,\s*/g;
function $6ea59d3b4cd68d9d$var$addScope(selector, scope) {
    var parts = selector.split($6ea59d3b4cd68d9d$var$separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function $6ea59d3b4cd68d9d$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$6ea59d3b4cd68d9d$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $jamvR.default)({}, options, {
        selector: $6ea59d3b4cd68d9d$var$addScope(name, rule.selector)
    }));
    delete style[$6ea59d3b4cd68d9d$var$at];
}
function $6ea59d3b4cd68d9d$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, $6ea59d3b4cd68d9d$var$at.length) !== $6ea59d3b4cd68d9d$var$at) continue;
        var selector = $6ea59d3b4cd68d9d$var$addScope(prop.substr($6ea59d3b4cd68d9d$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $jamvR.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $6ea59d3b4cd68d9d$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $6ea59d3b4cd68d9d$var$at) return new $6ea59d3b4cd68d9d$var$GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, $6ea59d3b4cd68d9d$var$atPrefix.length) === $6ea59d3b4cd68d9d$var$atPrefix) return new $6ea59d3b4cd68d9d$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        $6ea59d3b4cd68d9d$var$handleNestedGlobalContainerRule(rule, sheet);
        $6ea59d3b4cd68d9d$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $6ea59d3b4cd68d9d$export$2e2bcd8739ae039 = $6ea59d3b4cd68d9d$var$jssGlobal;

});

parcelRegister("8B0cW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6421f0af45655d2a$export$2e2bcd8739ae039; });

var $jamvR = parcelRequire("jamvR");

var $6421f0af45655d2a$var$separatorRegExp = /\s*,\s*/g;
var $6421f0af45655d2a$var$parentRegExp = /&/g;
var $6421f0af45655d2a$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $6421f0af45655d2a$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($6421f0af45655d2a$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($6421f0af45655d2a$var$separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace($6421f0af45655d2a$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $jamvR.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $jamvR.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($6421f0af45655d2a$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $jamvR.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $jamvR.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $6421f0af45655d2a$export$2e2bcd8739ae039 = $6421f0af45655d2a$var$jssNested;

});

parcelRegister("2FGnn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f20481ad127b8ed$export$2e2bcd8739ae039; });

var $7mlMX = parcelRequire("7mlMX");
/**
 * Convert camel cased property names to dash separated.
 */ function $1f20481ad127b8ed$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, $7mlMX.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($1f20481ad127b8ed$var$convertCase);
        else converted.fallbacks = $1f20481ad127b8ed$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $1f20481ad127b8ed$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $1f20481ad127b8ed$var$convertCase(style[index]);
            return style;
        }
        return $1f20481ad127b8ed$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, $7mlMX.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $1f20481ad127b8ed$export$2e2bcd8739ae039 = $1f20481ad127b8ed$var$camelCase;

});
parcelRegister("7mlMX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55bb7d44b310945f$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $55bb7d44b310945f$var$uppercasePattern = /[A-Z]/g;
var $55bb7d44b310945f$var$msPattern = /^ms-/;
var $55bb7d44b310945f$var$cache = {};
function $55bb7d44b310945f$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $55bb7d44b310945f$var$hyphenateStyleName(name) {
    if ($55bb7d44b310945f$var$cache.hasOwnProperty(name)) return $55bb7d44b310945f$var$cache[name];
    var hName = name.replace($55bb7d44b310945f$var$uppercasePattern, $55bb7d44b310945f$var$toHyphenLower);
    return $55bb7d44b310945f$var$cache[name] = $55bb7d44b310945f$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $55bb7d44b310945f$export$2e2bcd8739ae039 = $55bb7d44b310945f$var$hyphenateStyleName;

});


parcelRegister("3W4WD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dda9fc7175bcf5c$export$2e2bcd8739ae039; });

var $c5Qzo = parcelRequire("c5Qzo");
var $2dda9fc7175bcf5c$var$px = (0, $c5Qzo.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var $2dda9fc7175bcf5c$var$ms = (0, $c5Qzo.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var $2dda9fc7175bcf5c$var$percent = (0, $c5Qzo.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $2dda9fc7175bcf5c$var$defaultUnits = {
    // Animation properties
    'animation-delay': $2dda9fc7175bcf5c$var$ms,
    'animation-duration': $2dda9fc7175bcf5c$var$ms,
    // Background properties
    'background-position': $2dda9fc7175bcf5c$var$px,
    'background-position-x': $2dda9fc7175bcf5c$var$px,
    'background-position-y': $2dda9fc7175bcf5c$var$px,
    'background-size': $2dda9fc7175bcf5c$var$px,
    // Border Properties
    border: $2dda9fc7175bcf5c$var$px,
    'border-bottom': $2dda9fc7175bcf5c$var$px,
    'border-bottom-left-radius': $2dda9fc7175bcf5c$var$px,
    'border-bottom-right-radius': $2dda9fc7175bcf5c$var$px,
    'border-bottom-width': $2dda9fc7175bcf5c$var$px,
    'border-left': $2dda9fc7175bcf5c$var$px,
    'border-left-width': $2dda9fc7175bcf5c$var$px,
    'border-radius': $2dda9fc7175bcf5c$var$px,
    'border-right': $2dda9fc7175bcf5c$var$px,
    'border-right-width': $2dda9fc7175bcf5c$var$px,
    'border-top': $2dda9fc7175bcf5c$var$px,
    'border-top-left-radius': $2dda9fc7175bcf5c$var$px,
    'border-top-right-radius': $2dda9fc7175bcf5c$var$px,
    'border-top-width': $2dda9fc7175bcf5c$var$px,
    'border-width': $2dda9fc7175bcf5c$var$px,
    'border-block': $2dda9fc7175bcf5c$var$px,
    'border-block-end': $2dda9fc7175bcf5c$var$px,
    'border-block-end-width': $2dda9fc7175bcf5c$var$px,
    'border-block-start': $2dda9fc7175bcf5c$var$px,
    'border-block-start-width': $2dda9fc7175bcf5c$var$px,
    'border-block-width': $2dda9fc7175bcf5c$var$px,
    'border-inline': $2dda9fc7175bcf5c$var$px,
    'border-inline-end': $2dda9fc7175bcf5c$var$px,
    'border-inline-end-width': $2dda9fc7175bcf5c$var$px,
    'border-inline-start': $2dda9fc7175bcf5c$var$px,
    'border-inline-start-width': $2dda9fc7175bcf5c$var$px,
    'border-inline-width': $2dda9fc7175bcf5c$var$px,
    'border-start-start-radius': $2dda9fc7175bcf5c$var$px,
    'border-start-end-radius': $2dda9fc7175bcf5c$var$px,
    'border-end-start-radius': $2dda9fc7175bcf5c$var$px,
    'border-end-end-radius': $2dda9fc7175bcf5c$var$px,
    // Margin properties
    margin: $2dda9fc7175bcf5c$var$px,
    'margin-bottom': $2dda9fc7175bcf5c$var$px,
    'margin-left': $2dda9fc7175bcf5c$var$px,
    'margin-right': $2dda9fc7175bcf5c$var$px,
    'margin-top': $2dda9fc7175bcf5c$var$px,
    'margin-block': $2dda9fc7175bcf5c$var$px,
    'margin-block-end': $2dda9fc7175bcf5c$var$px,
    'margin-block-start': $2dda9fc7175bcf5c$var$px,
    'margin-inline': $2dda9fc7175bcf5c$var$px,
    'margin-inline-end': $2dda9fc7175bcf5c$var$px,
    'margin-inline-start': $2dda9fc7175bcf5c$var$px,
    // Padding properties
    padding: $2dda9fc7175bcf5c$var$px,
    'padding-bottom': $2dda9fc7175bcf5c$var$px,
    'padding-left': $2dda9fc7175bcf5c$var$px,
    'padding-right': $2dda9fc7175bcf5c$var$px,
    'padding-top': $2dda9fc7175bcf5c$var$px,
    'padding-block': $2dda9fc7175bcf5c$var$px,
    'padding-block-end': $2dda9fc7175bcf5c$var$px,
    'padding-block-start': $2dda9fc7175bcf5c$var$px,
    'padding-inline': $2dda9fc7175bcf5c$var$px,
    'padding-inline-end': $2dda9fc7175bcf5c$var$px,
    'padding-inline-start': $2dda9fc7175bcf5c$var$px,
    // Mask properties
    'mask-position-x': $2dda9fc7175bcf5c$var$px,
    'mask-position-y': $2dda9fc7175bcf5c$var$px,
    'mask-size': $2dda9fc7175bcf5c$var$px,
    // Width and height properties
    height: $2dda9fc7175bcf5c$var$px,
    width: $2dda9fc7175bcf5c$var$px,
    'min-height': $2dda9fc7175bcf5c$var$px,
    'max-height': $2dda9fc7175bcf5c$var$px,
    'min-width': $2dda9fc7175bcf5c$var$px,
    'max-width': $2dda9fc7175bcf5c$var$px,
    // Position properties
    bottom: $2dda9fc7175bcf5c$var$px,
    left: $2dda9fc7175bcf5c$var$px,
    top: $2dda9fc7175bcf5c$var$px,
    right: $2dda9fc7175bcf5c$var$px,
    inset: $2dda9fc7175bcf5c$var$px,
    'inset-block': $2dda9fc7175bcf5c$var$px,
    'inset-block-end': $2dda9fc7175bcf5c$var$px,
    'inset-block-start': $2dda9fc7175bcf5c$var$px,
    'inset-inline': $2dda9fc7175bcf5c$var$px,
    'inset-inline-end': $2dda9fc7175bcf5c$var$px,
    'inset-inline-start': $2dda9fc7175bcf5c$var$px,
    // Shadow properties
    'box-shadow': $2dda9fc7175bcf5c$var$px,
    'text-shadow': $2dda9fc7175bcf5c$var$px,
    // Column properties
    'column-gap': $2dda9fc7175bcf5c$var$px,
    'column-rule': $2dda9fc7175bcf5c$var$px,
    'column-rule-width': $2dda9fc7175bcf5c$var$px,
    'column-width': $2dda9fc7175bcf5c$var$px,
    // Font and text properties
    'font-size': $2dda9fc7175bcf5c$var$px,
    'font-size-delta': $2dda9fc7175bcf5c$var$px,
    'letter-spacing': $2dda9fc7175bcf5c$var$px,
    'text-decoration-thickness': $2dda9fc7175bcf5c$var$px,
    'text-indent': $2dda9fc7175bcf5c$var$px,
    'text-stroke': $2dda9fc7175bcf5c$var$px,
    'text-stroke-width': $2dda9fc7175bcf5c$var$px,
    'word-spacing': $2dda9fc7175bcf5c$var$px,
    // Motion properties
    motion: $2dda9fc7175bcf5c$var$px,
    'motion-offset': $2dda9fc7175bcf5c$var$px,
    // Outline properties
    outline: $2dda9fc7175bcf5c$var$px,
    'outline-offset': $2dda9fc7175bcf5c$var$px,
    'outline-width': $2dda9fc7175bcf5c$var$px,
    // Perspective properties
    perspective: $2dda9fc7175bcf5c$var$px,
    'perspective-origin-x': $2dda9fc7175bcf5c$var$percent,
    'perspective-origin-y': $2dda9fc7175bcf5c$var$percent,
    // Transform properties
    'transform-origin': $2dda9fc7175bcf5c$var$percent,
    'transform-origin-x': $2dda9fc7175bcf5c$var$percent,
    'transform-origin-y': $2dda9fc7175bcf5c$var$percent,
    'transform-origin-z': $2dda9fc7175bcf5c$var$percent,
    // Transition properties
    'transition-delay': $2dda9fc7175bcf5c$var$ms,
    'transition-duration': $2dda9fc7175bcf5c$var$ms,
    // Alignment properties
    'vertical-align': $2dda9fc7175bcf5c$var$px,
    'flex-basis': $2dda9fc7175bcf5c$var$px,
    // Some random properties
    'shape-margin': $2dda9fc7175bcf5c$var$px,
    size: $2dda9fc7175bcf5c$var$px,
    gap: $2dda9fc7175bcf5c$var$px,
    // Grid properties
    grid: $2dda9fc7175bcf5c$var$px,
    'grid-gap': $2dda9fc7175bcf5c$var$px,
    'row-gap': $2dda9fc7175bcf5c$var$px,
    'grid-row-gap': $2dda9fc7175bcf5c$var$px,
    'grid-column-gap': $2dda9fc7175bcf5c$var$px,
    'grid-template-rows': $2dda9fc7175bcf5c$var$px,
    'grid-template-columns': $2dda9fc7175bcf5c$var$px,
    'grid-auto-rows': $2dda9fc7175bcf5c$var$px,
    'grid-auto-columns': $2dda9fc7175bcf5c$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': $2dda9fc7175bcf5c$var$px,
    'box-shadow-y': $2dda9fc7175bcf5c$var$px,
    'box-shadow-blur': $2dda9fc7175bcf5c$var$px,
    'box-shadow-spread': $2dda9fc7175bcf5c$var$px,
    'font-line-height': $2dda9fc7175bcf5c$var$px,
    'text-shadow-x': $2dda9fc7175bcf5c$var$px,
    'text-shadow-y': $2dda9fc7175bcf5c$var$px,
    'text-shadow-blur': $2dda9fc7175bcf5c$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $2dda9fc7175bcf5c$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $2dda9fc7175bcf5c$var$units = $2dda9fc7175bcf5c$var$addCamelCasedVersion($2dda9fc7175bcf5c$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $2dda9fc7175bcf5c$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $2dda9fc7175bcf5c$var$iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = $2dda9fc7175bcf5c$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $2dda9fc7175bcf5c$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || $2dda9fc7175bcf5c$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $2dda9fc7175bcf5c$var$px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $2dda9fc7175bcf5c$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $2dda9fc7175bcf5c$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = $2dda9fc7175bcf5c$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $2dda9fc7175bcf5c$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $2dda9fc7175bcf5c$export$2e2bcd8739ae039 = $2dda9fc7175bcf5c$var$defaultUnit;

});

parcelRegister("dG6Qz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f54823fe6d448dc$export$2e2bcd8739ae039; });

var $ioxMD = parcelRequire("ioxMD");

var $c5Qzo = parcelRequire("c5Qzo");
/**
 * Add vendor prefix to a property name when needed.
 */ function $9f54823fe6d448dc$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, $ioxMD.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $ioxMD.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $ioxMD.supportedValue)(supportedProp, (0, $c5Qzo.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $ioxMD.supportedValue)(prop, (0, $c5Qzo.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $9f54823fe6d448dc$export$2e2bcd8739ae039 = $9f54823fe6d448dc$var$jssVendorPrefixer;

});
parcelRegister("ioxMD", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $d644ac8d26ad6e37$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $d644ac8d26ad6e37$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $d644ac8d26ad6e37$export$511766124059c277; });

var $6Uz3n = parcelRequire("6Uz3n");

var $bXxaA = parcelRequire("bXxaA");
// Export javascript style and css style vendor prefixes.
var $d644ac8d26ad6e37$var$js = '';
var $d644ac8d26ad6e37$var$css = '';
var $d644ac8d26ad6e37$var$vendor = '';
var $d644ac8d26ad6e37$var$browser = '';
var $d644ac8d26ad6e37$var$isTouch = (0, $6Uz3n.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, $6Uz3n.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $d644ac8d26ad6e37$var$jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var $d644ac8d26ad6e37$var$_document$createEleme = document.createElement('p'), $d644ac8d26ad6e37$var$style = $d644ac8d26ad6e37$var$_document$createEleme.style;
    var $d644ac8d26ad6e37$var$testProp = 'Transform';
    for(var $d644ac8d26ad6e37$var$key in $d644ac8d26ad6e37$var$jsCssMap)if ($d644ac8d26ad6e37$var$key + $d644ac8d26ad6e37$var$testProp in $d644ac8d26ad6e37$var$style) {
        $d644ac8d26ad6e37$var$js = $d644ac8d26ad6e37$var$key;
        $d644ac8d26ad6e37$var$css = $d644ac8d26ad6e37$var$jsCssMap[$d644ac8d26ad6e37$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($d644ac8d26ad6e37$var$js === 'Webkit' && 'msHyphens' in $d644ac8d26ad6e37$var$style) {
        $d644ac8d26ad6e37$var$js = 'ms';
        $d644ac8d26ad6e37$var$css = $d644ac8d26ad6e37$var$jsCssMap.ms;
        $d644ac8d26ad6e37$var$browser = 'edge';
    } // Correctly detect the Safari browser.
    if ($d644ac8d26ad6e37$var$js === 'Webkit' && '-apple-trailing-word' in $d644ac8d26ad6e37$var$style) $d644ac8d26ad6e37$var$vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $d644ac8d26ad6e37$export$82e9f45cca5ba907 = {
    js: $d644ac8d26ad6e37$var$js,
    css: $d644ac8d26ad6e37$var$css,
    vendor: $d644ac8d26ad6e37$var$vendor,
    browser: $d644ac8d26ad6e37$var$browser,
    isTouch: $d644ac8d26ad6e37$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $d644ac8d26ad6e37$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'ms') return key;
    return "@" + $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $d644ac8d26ad6e37$var$appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'ms') return "-webkit-" + prop;
        return $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $d644ac8d26ad6e37$var$colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'Webkit') return $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $d644ac8d26ad6e37$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $d644ac8d26ad6e37$var$toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $d644ac8d26ad6e37$var$camelize(str) {
    return str.replace($d644ac8d26ad6e37$var$regExp, $d644ac8d26ad6e37$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $d644ac8d26ad6e37$var$pascalize(str) {
    return $d644ac8d26ad6e37$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $d644ac8d26ad6e37$var$mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'Webkit') {
            var longhand = 'mask-image';
            if ($d644ac8d26ad6e37$var$camelize(longhand) in style) return prop;
            if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js + $d644ac8d26ad6e37$var$pascalize(longhand) in style) return $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $d644ac8d26ad6e37$var$textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.vendor === 'apple' && !$d644ac8d26ad6e37$export$82e9f45cca5ba907.isTouch) return $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $d644ac8d26ad6e37$var$transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $d644ac8d26ad6e37$var$transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $d644ac8d26ad6e37$var$writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'Webkit' || $d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'ms' && $d644ac8d26ad6e37$export$82e9f45cca5ba907.browser !== 'edge') return $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $d644ac8d26ad6e37$var$userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'Moz' || $d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'ms' || $d644ac8d26ad6e37$export$82e9f45cca5ba907.vendor === 'apple') return $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $d644ac8d26ad6e37$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'Webkit') {
            var jsProp = "WebkitColumn" + $d644ac8d26ad6e37$var$pascalize(prop);
            return jsProp in style ? $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'Moz') {
            var _jsProp = "page" + $d644ac8d26ad6e37$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $d644ac8d26ad6e37$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return $d644ac8d26ad6e37$export$82e9f45cca5ba907.js + $d644ac8d26ad6e37$var$pascalize(newProp) in style ? $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $d644ac8d26ad6e37$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $d644ac8d26ad6e37$var$camelize(prop) in style ? prop : false;
    }
};
var $d644ac8d26ad6e37$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $d644ac8d26ad6e37$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js + pascalized in style) return $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $d644ac8d26ad6e37$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'ms') return "" + $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $d644ac8d26ad6e37$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if ($d644ac8d26ad6e37$export$82e9f45cca5ba907.js === 'ms') return $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $d644ac8d26ad6e37$var$propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $d644ac8d26ad6e37$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $d644ac8d26ad6e37$var$propMap[prop];
        if (!newProp) return false;
        return $d644ac8d26ad6e37$export$82e9f45cca5ba907.js + $d644ac8d26ad6e37$var$pascalize(newProp) in style ? $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $d644ac8d26ad6e37$var$propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var $d644ac8d26ad6e37$var$propKeys = Object.keys($d644ac8d26ad6e37$var$propMap$1);
var $d644ac8d26ad6e37$var$prefixCss = function prefixCss(p) {
    return $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $d644ac8d26ad6e37$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($d644ac8d26ad6e37$var$propKeys.indexOf(prop) > -1) {
            var newProp = $d644ac8d26ad6e37$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $d644ac8d26ad6e37$export$82e9f45cca5ba907.js + $d644ac8d26ad6e37$var$pascalize(newProp) in style ? $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($d644ac8d26ad6e37$export$82e9f45cca5ba907.js + $d644ac8d26ad6e37$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($d644ac8d26ad6e37$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $d644ac8d26ad6e37$var$plugins = [
    $d644ac8d26ad6e37$var$appearence,
    $d644ac8d26ad6e37$var$colorAdjust,
    $d644ac8d26ad6e37$var$mask,
    $d644ac8d26ad6e37$var$textOrientation,
    $d644ac8d26ad6e37$var$transform,
    $d644ac8d26ad6e37$var$transition,
    $d644ac8d26ad6e37$var$writingMode,
    $d644ac8d26ad6e37$var$userSelect,
    $d644ac8d26ad6e37$var$breakPropsOld,
    $d644ac8d26ad6e37$var$inlineLogicalOld,
    $d644ac8d26ad6e37$var$unprefixed,
    $d644ac8d26ad6e37$var$prefixed,
    $d644ac8d26ad6e37$var$scrollSnap,
    $d644ac8d26ad6e37$var$overscrollBehavior,
    $d644ac8d26ad6e37$var$flex2012,
    $d644ac8d26ad6e37$var$flex2009
];
var $d644ac8d26ad6e37$var$propertyDetectors = $d644ac8d26ad6e37$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $d644ac8d26ad6e37$var$noPrefill = $d644ac8d26ad6e37$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $bXxaA.default)(p.noPrefill));
    return a;
}, []);
var $d644ac8d26ad6e37$var$el;
var $d644ac8d26ad6e37$var$cache = {};
if (0, $6Uz3n.default) {
    $d644ac8d26ad6e37$var$el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $d644ac8d26ad6e37$var$computed = window.getComputedStyle(document.documentElement, '');
    for(var $d644ac8d26ad6e37$var$key$1 in $d644ac8d26ad6e37$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($d644ac8d26ad6e37$var$key$1)) $d644ac8d26ad6e37$var$cache[$d644ac8d26ad6e37$var$computed[$d644ac8d26ad6e37$var$key$1]] = $d644ac8d26ad6e37$var$computed[$d644ac8d26ad6e37$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $d644ac8d26ad6e37$var$noPrefill.forEach(function(x) {
        return delete $d644ac8d26ad6e37$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $d644ac8d26ad6e37$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$d644ac8d26ad6e37$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($d644ac8d26ad6e37$var$cache[prop] != null) return $d644ac8d26ad6e37$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in $d644ac8d26ad6e37$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $d644ac8d26ad6e37$var$propertyDetectors.length; i++){
        $d644ac8d26ad6e37$var$cache[prop] = $d644ac8d26ad6e37$var$propertyDetectors[i](prop, $d644ac8d26ad6e37$var$el.style, options); // Break loop, if value found.
        if ($d644ac8d26ad6e37$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $d644ac8d26ad6e37$var$el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return $d644ac8d26ad6e37$var$cache[prop];
}
var $d644ac8d26ad6e37$var$cache$1 = {};
var $d644ac8d26ad6e37$var$transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var $d644ac8d26ad6e37$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $d644ac8d26ad6e37$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $d644ac8d26ad6e37$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? $d644ac8d26ad6e37$export$ce097f82c2e4551a(p1) : ", " + $d644ac8d26ad6e37$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $6Uz3n.default) $d644ac8d26ad6e37$var$el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $d644ac8d26ad6e37$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$d644ac8d26ad6e37$var$el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($d644ac8d26ad6e37$var$cache$1[cacheKey] != null) return $d644ac8d26ad6e37$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $d644ac8d26ad6e37$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $d644ac8d26ad6e37$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($d644ac8d26ad6e37$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($d644ac8d26ad6e37$var$transPropsRegExp, $d644ac8d26ad6e37$var$prefixTransitionCallback);
    else if ($d644ac8d26ad6e37$var$el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = $d644ac8d26ad6e37$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') $d644ac8d26ad6e37$var$el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        $d644ac8d26ad6e37$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($d644ac8d26ad6e37$var$el$1.style[property] === '') {
            $d644ac8d26ad6e37$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $d644ac8d26ad6e37$var$el$1.style[property] = ''; // Write current value to cache.
    $d644ac8d26ad6e37$var$cache$1[cacheKey] = prefixedValue;
    return $d644ac8d26ad6e37$var$cache$1[cacheKey];
}

});
parcelRegister("bXxaA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b4eef3b1768b4df$export$2e2bcd8739ae039; });

var $9M5BZ = parcelRequire("9M5BZ");

var $8o69r = parcelRequire("8o69r");

var $6RahR = parcelRequire("6RahR");

var $5ufih = parcelRequire("5ufih");
function $8b4eef3b1768b4df$export$2e2bcd8739ae039(r) {
    return (0, $9M5BZ.default)(r) || (0, $8o69r.default)(r) || (0, $6RahR.default)(r) || (0, $5ufih.default)();
}

});
parcelRegister("9M5BZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71dcf31b7b6d8c57$export$2e2bcd8739ae039; });

var $llM1x = parcelRequire("llM1x");
function $71dcf31b7b6d8c57$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $llM1x.default)(r);
}

});
parcelRegister("llM1x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8b0cfa5a53e2056$export$2e2bcd8739ae039; });
function $f8b0cfa5a53e2056$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("8o69r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61b556288129c995$export$2e2bcd8739ae039; });
function $61b556288129c995$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("6RahR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fdfac1f49a856f2$export$2e2bcd8739ae039; });

var $llM1x = parcelRequire("llM1x");
function $4fdfac1f49a856f2$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $llM1x.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $llM1x.default)(r, a) : void 0;
    }
}

});

parcelRegister("5ufih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0107ede7b3152112$export$2e2bcd8739ae039; });
function $0107ede7b3152112$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("5x6WR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40756ca1b0b6003a$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $40756ca1b0b6003a$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $40756ca1b0b6003a$export$2e2bcd8739ae039 = $40756ca1b0b6003a$var$jssPropsSort;

});



parcelRegister("dMV2x", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $a09c00fe95639b5d$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
let $a09c00fe95639b5d$var$indexCounter = -1000000000;
function $a09c00fe95639b5d$export$a2647aa13413c947() {
    $a09c00fe95639b5d$var$indexCounter += 1;
    return $a09c00fe95639b5d$var$indexCounter;
}

});

parcelRegister("l4RsO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f583717eb539abb4$export$2e2bcd8739ae039; });

var $dok7x = parcelRequire("dok7x");

var $f6ZlQ = parcelRequire("f6ZlQ");

var $dC2GL = parcelRequire("dC2GL");

function $f583717eb539abb4$export$2e2bcd8739ae039(stylesOrCreator) {
    const themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: (theme, name)=>{
            let styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.components || !theme.components[name] || !theme.components[name].styleOverrides && !theme.components[name].variants) return styles;
            const overrides = theme.components[name].styleOverrides || {};
            const variants = theme.components[name].variants || [];
            const stylesWithOverrides = (0, $dok7x._)({}, styles);
            Object.keys(overrides).forEach((key)=>{
                stylesWithOverrides[key] = (0, $f6ZlQ.default)(stylesWithOverrides[key] || {}, overrides[key]);
            });
            variants.forEach((definition)=>{
                const classKey = (0, $dC2GL.default)(definition.props);
                stylesWithOverrides[classKey] = (0, $f6ZlQ.default)(stylesWithOverrides[classKey] || {}, definition.style);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("dC2GL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e90e8e46fdba51b$export$2e2bcd8739ae039; });

var $6pkKu = parcelRequire("6pkKu");

var $31bjE = parcelRequire("31bjE");
function $9e90e8e46fdba51b$var$isEmpty(string) {
    return string.length === 0;
}
function $9e90e8e46fdba51b$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $6pkKu._)(props, [
        "variant"
    ]);
    let classKey = variant || '';
    Object.keys(other).sort().forEach((key)=>{
        if (key === 'color') classKey += $9e90e8e46fdba51b$var$isEmpty(classKey) ? props[key] : (0, $31bjE.default)(props[key]);
        else classKey += `${$9e90e8e46fdba51b$var$isEmpty(classKey) ? key : (0, $31bjE.default)(key)}${(0, $31bjE.default)(props[key].toString())}`;
    });
    return classKey;
}

});


parcelRegister("8jy2g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60da7fd6753a255d$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
const $60da7fd6753a255d$var$noopTheme = {};
var $60da7fd6753a255d$export$2e2bcd8739ae039 = $60da7fd6753a255d$var$noopTheme;

});


parcelRegister("6COaG", function(module, exports) {

$parcel$export(module.exports, "enqueueSnackbar", function () { return $4d2d35ac28015762$export$9d70c354f0150b1b; });
$parcel$export(module.exports, "closeSnackbar", function () { return $4d2d35ac28015762$export$823cdc5238933767; });
$parcel$export(module.exports, "SnackbarProvider", function () { return $4d2d35ac28015762$export$d1e619fddc3508ce; });

var $7hhBq = parcelRequire("7hhBq");

var $4unLw = parcelRequire("4unLw");

var $dFDKW = parcelRequire("dFDKW");

var $feump = parcelRequire("feump");
function $4d2d35ac28015762$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4d2d35ac28015762$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4d2d35ac28015762$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4d2d35ac28015762$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4d2d35ac28015762$var$_extends() {
    $4d2d35ac28015762$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4d2d35ac28015762$var$_extends.apply(this, arguments);
}
function $4d2d35ac28015762$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $4d2d35ac28015762$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4d2d35ac28015762$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $4d2d35ac28015762$var$noOp = function noOp() {
    return '';
};
var $4d2d35ac28015762$var$SnackbarContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createContext({
    enqueueSnackbar: $4d2d35ac28015762$var$noOp,
    closeSnackbar: $4d2d35ac28015762$var$noOp
});
var $4d2d35ac28015762$var$breakpoints = {
    downXs: '@media (max-width:599.95px)',
    upSm: '@media (min-width:600px)'
};
var $4d2d35ac28015762$var$capitalise = function capitalise(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
var $4d2d35ac28015762$var$originKeyExtractor = function originKeyExtractor(anchor) {
    return "" + $4d2d35ac28015762$var$capitalise(anchor.vertical) + $4d2d35ac28015762$var$capitalise(anchor.horizontal);
};
var $4d2d35ac28015762$var$isDefined = function isDefined(value) {
    return !!value || value === 0;
};
var $4d2d35ac28015762$var$UNMOUNTED = 'unmounted';
var $4d2d35ac28015762$var$EXITED = 'exited';
var $4d2d35ac28015762$var$ENTERING = 'entering';
var $4d2d35ac28015762$var$ENTERED = 'entered';
var $4d2d35ac28015762$var$EXITING = 'exiting';
var $4d2d35ac28015762$export$be58926105124dd4 = /*#__PURE__*/ function(_React$Component) {
    $4d2d35ac28015762$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var appear = props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props["in"]) {
            if (appear) {
                initialStatus = $4d2d35ac28015762$var$EXITED;
                _this.appearStatus = $4d2d35ac28015762$var$ENTERING;
            } else initialStatus = $4d2d35ac28015762$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $4d2d35ac28015762$var$UNMOUNTED;
        else initialStatus = $4d2d35ac28015762$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref["in"];
        if (nextIn && prevState.status === $4d2d35ac28015762$var$UNMOUNTED) return {
            status: $4d2d35ac28015762$var$EXITED
        };
        return null;
    };
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props["in"]) {
                if (status !== $4d2d35ac28015762$var$ENTERING && status !== $4d2d35ac28015762$var$ENTERED) nextStatus = $4d2d35ac28015762$var$ENTERING;
            } else if (status === $4d2d35ac28015762$var$ENTERING || status === $4d2d35ac28015762$var$ENTERED) nextStatus = $4d2d35ac28015762$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var enter = timeout;
        var exit = timeout;
        if (timeout != null && typeof timeout !== 'number' && typeof timeout !== 'string') {
            exit = timeout.exit;
            enter = timeout.enter;
        }
        return {
            exit: exit,
            enter: enter
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            this.cancelNextCallback();
            if (nextStatus === $4d2d35ac28015762$var$ENTERING) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $4d2d35ac28015762$var$EXITED) this.setState({
            status: $4d2d35ac28015762$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var isAppearing = mounting;
        var timeouts = this.getTimeouts();
        if (!mounting && !enter) {
            this.safeSetState({
                status: $4d2d35ac28015762$var$ENTERED
            }, function() {
                if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
            });
            return;
        }
        if (this.props.onEnter) this.props.onEnter(this.node, isAppearing);
        this.safeSetState({
            status: $4d2d35ac28015762$var$ENTERING
        }, function() {
            if (_this2.props.onEntering) _this2.props.onEntering(_this2.node, isAppearing);
            _this2.onTransitionEnd(timeouts.enter, function() {
                _this2.safeSetState({
                    status: $4d2d35ac28015762$var$ENTERED
                }, function() {
                    if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $4d2d35ac28015762$var$EXITED
            }, function() {
                if (_this3.props.onExited) _this3.props.onExited(_this3.node);
            });
            return;
        }
        if (this.props.onExit) this.props.onExit(this.node);
        this.safeSetState({
            status: $4d2d35ac28015762$var$EXITING
        }, function() {
            if (_this3.props.onExiting) _this3.props.onExiting(_this3.node);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $4d2d35ac28015762$var$EXITED
                }, function() {
                    if (_this3.props.onExited) _this3.props.onExited(_this3.node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null && this.nextCallback.cancel) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function() {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback();
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!this.node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(this.node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $4d2d35ac28015762$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $4d2d35ac28015762$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return children(status, childProps);
    };
    $4d2d35ac28015762$var$_createClass(Transition, [
        {
            key: "node",
            get: function get() {
                var _this$props$nodeRef;
                var node = (_this$props$nodeRef = this.props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current;
                if (!node) throw new Error('notistack - Custom snackbar is not refForwarding');
                return node;
            }
        }
    ]);
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).Component);
function $4d2d35ac28015762$var$noop() {}
$4d2d35ac28015762$export$be58926105124dd4.defaultProps = {
    "in": false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $4d2d35ac28015762$var$noop,
    onEntering: $4d2d35ac28015762$var$noop,
    onEntered: $4d2d35ac28015762$var$noop,
    onExit: $4d2d35ac28015762$var$noop,
    onExiting: $4d2d35ac28015762$var$noop,
    onExited: $4d2d35ac28015762$var$noop
};
/**
 * Credit to MUI team @ https://mui.com
 */ /**
 * passes {value} to {ref}
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $4d2d35ac28015762$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}
function $4d2d35ac28015762$var$useForkRef(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return (0, $7hhBq.useMemo)(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            $4d2d35ac28015762$var$setRef(refA, refValue);
            $4d2d35ac28015762$var$setRef(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function $4d2d35ac28015762$var$getTransitionProps(props) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style, mode = props.mode;
    return {
        duration: typeof timeout === 'object' ? timeout[mode] || 0 : timeout,
        easing: style.transitionTimingFunction,
        delay: style.transitionDelay
    };
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $4d2d35ac28015762$var$defaultEasing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
/**
 * CSS hack to force a repaint
 */ var $4d2d35ac28015762$var$reflow = function reflow(node) {
    // We have to do something with node.scrollTop.
    // Otherwise it's removed from the compiled code by optimisers
    // eslint-disable-next-line no-self-assign
    node.scrollTop = node.scrollTop;
};
var $4d2d35ac28015762$var$formatMs = function formatMs(milliseconds) {
    return Math.round(milliseconds) + "ms";
};
function $4d2d35ac28015762$var$createTransition(props, options) {
    if (props === void 0) props = [
        'all'
    ];
    var _ref = options || {}, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 300 : _ref$duration, _ref$easing = _ref.easing, easing = _ref$easing === void 0 ? $4d2d35ac28015762$var$defaultEasing.easeInOut : _ref$easing, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay;
    var properties = Array.isArray(props) ? props : [
        props
    ];
    return properties.map(function(animatedProp) {
        var formattedDuration = typeof duration === 'string' ? duration : $4d2d35ac28015762$var$formatMs(duration);
        var formattedDelay = typeof delay === 'string' ? delay : $4d2d35ac28015762$var$formatMs(delay);
        return animatedProp + " " + formattedDuration + " " + easing + " " + formattedDelay;
    }).join(',');
}
function $4d2d35ac28015762$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}
function $4d2d35ac28015762$var$ownerWindow(node) {
    var doc = $4d2d35ac28015762$var$ownerDocument(node);
    return doc.defaultView || window;
}
/**
 * Corresponds to 10 frames at 60 Hz.
 * A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
 */ function $4d2d35ac28015762$var$debounce(func, wait) {
    if (wait === void 0) wait = 166;
    var timeout;
    function debounced() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var later = function later() {
            // @ts-ignore
            func.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}
/**
 * Translate the node so it can't be seen on the screen.
 * Later, we're going to translate the node back to its original location with `none`.
 */ function $4d2d35ac28015762$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var containerWindow = $4d2d35ac28015762$var$ownerWindow(node);
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    switch(direction){
        case 'left':
            return "translateX(" + (containerWindow.innerWidth + offsetX - rect.left) + "px)";
        case 'right':
            return "translateX(-" + (rect.left + rect.width - offsetX) + "px)";
        case 'up':
            return "translateY(" + (containerWindow.innerHeight + offsetY - rect.top) + "px)";
        default:
            // down
            return "translateY(-" + (rect.top + rect.height - offsetY) + "px)";
    }
}
function $4d2d35ac28015762$var$setTranslateValue(direction, node) {
    if (!node) return;
    var transform = $4d2d35ac28015762$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $4d2d35ac28015762$var$Slide = /*#__PURE__*/ (0, $7hhBq.forwardRef)(function(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'down' : _props$direction, inProp = props["in"], style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 0 : _props$timeout, onEnter = props.onEnter, onEntered = props.onEntered, onExit = props.onExit, onExited = props.onExited, other = $4d2d35ac28015762$var$_objectWithoutPropertiesLoose(props, [
        "children",
        "direction",
        "in",
        "style",
        "timeout",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var nodeRef = (0, $7hhBq.useRef)(null);
    var handleRefIntermediary = $4d2d35ac28015762$var$useForkRef(children.ref, nodeRef);
    var handleRef = $4d2d35ac28015762$var$useForkRef(handleRefIntermediary, ref);
    var handleEnter = function handleEnter(node, isAppearing) {
        $4d2d35ac28015762$var$setTranslateValue(direction, node);
        $4d2d35ac28015762$var$reflow(node);
        if (onEnter) onEnter(node, isAppearing);
    };
    var handleEntering = function handleEntering(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $4d2d35ac28015762$var$defaultEasing.easeOut;
        var transitionProps = $4d2d35ac28015762$var$getTransitionProps({
            timeout: timeout,
            mode: 'enter',
            style: $4d2d35ac28015762$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $4d2d35ac28015762$var$createTransition('-webkit-transform', transitionProps);
        node.style.transition = $4d2d35ac28015762$var$createTransition('transform', transitionProps);
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
    };
    var handleExit = function handleExit(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $4d2d35ac28015762$var$defaultEasing.sharp;
        var transitionProps = $4d2d35ac28015762$var$getTransitionProps({
            timeout: timeout,
            mode: 'exit',
            style: $4d2d35ac28015762$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $4d2d35ac28015762$var$createTransition('-webkit-transform', transitionProps);
        node.style.transition = $4d2d35ac28015762$var$createTransition('transform', transitionProps);
        $4d2d35ac28015762$var$setTranslateValue(direction, node);
        if (onExit) onExit(node);
    };
    var handleExited = function handleExited(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    };
    var updatePosition = (0, $7hhBq.useCallback)(function() {
        if (nodeRef.current) $4d2d35ac28015762$var$setTranslateValue(direction, nodeRef.current);
    }, [
        direction
    ]);
    (0, $7hhBq.useEffect)(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        var handleResize = $4d2d35ac28015762$var$debounce(function() {
            if (nodeRef.current) $4d2d35ac28015762$var$setTranslateValue(direction, nodeRef.current);
        });
        var containerWindow = $4d2d35ac28015762$var$ownerWindow(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    (0, $7hhBq.useEffect)(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return (0, $7hhBq.createElement)($4d2d35ac28015762$export$be58926105124dd4, Object.assign({
        appear: true,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: onEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        "in": inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return (0, $7hhBq.cloneElement)(children, $4d2d35ac28015762$var$_extends({
            ref: handleRef,
            style: $4d2d35ac28015762$var$_extends({
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, style, {}, children.props.style)
        }, childProps));
    });
});
$4d2d35ac28015762$var$Slide.displayName = 'Slide';
var $4d2d35ac28015762$var$SvgIcon = function SvgIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement("svg", Object.assign({
        viewBox: "0 0 24 24",
        focusable: "false",
        style: {
            fontSize: 20,
            marginInlineEnd: 8,
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0
        }
    }, props));
};
var $4d2d35ac28015762$var$CheckIcon = function CheckIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement("path", {
        d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    }));
};
var $4d2d35ac28015762$var$WarningIcon = function WarningIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement("path", {
        d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
    }));
};
var $4d2d35ac28015762$var$ErrorIcon = function ErrorIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement("path", {
        d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
    }));
};
var $4d2d35ac28015762$var$InfoIcon = function InfoIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement("path", {
        d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
    }));
};
var $4d2d35ac28015762$var$defaultIconVariants = {
    "default": undefined,
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$CheckIcon, null),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$WarningIcon, null),
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$ErrorIcon, null),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$InfoIcon, null)
};
var $4d2d35ac28015762$var$defaults = {
    maxSnack: 3,
    persist: false,
    hideIconVariant: false,
    disableWindowBlurListener: false,
    variant: 'default',
    autoHideDuration: 5000,
    iconVariant: $4d2d35ac28015762$var$defaultIconVariants,
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    TransitionComponent: $4d2d35ac28015762$var$Slide,
    transitionDuration: {
        enter: 225,
        exit: 195
    }
};
/**
 * Derives the right autoHideDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $4d2d35ac28015762$var$getAutoHideDuration = function getAutoHideDuration(optionsDuration, propsDuration) {
    var isNumberOrNull = function isNumberOrNull(numberish) {
        return typeof numberish === 'number' || numberish === null;
    };
    if (isNumberOrNull(optionsDuration)) return optionsDuration;
    if (isNumberOrNull(propsDuration)) return propsDuration;
    return $4d2d35ac28015762$var$defaults.autoHideDuration;
};
/**
 * Derives the right transitionDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $4d2d35ac28015762$var$getTransitionDuration = function getTransitionDuration(optionsDuration, propsDuration) {
    var is = function is(item, types) {
        return types.some(function(t) {
            return typeof item === t;
        });
    };
    if (is(optionsDuration, [
        'string',
        'number'
    ])) return optionsDuration;
    if (is(optionsDuration, [
        'object'
    ])) return $4d2d35ac28015762$var$_extends({}, $4d2d35ac28015762$var$defaults.transitionDuration, {}, is(propsDuration, [
        'object'
    ]) && propsDuration, {}, optionsDuration);
    if (is(propsDuration, [
        'string',
        'number'
    ])) return propsDuration;
    if (is(propsDuration, [
        'object'
    ])) return $4d2d35ac28015762$var$_extends({}, $4d2d35ac28015762$var$defaults.transitionDuration, {}, propsDuration);
    return $4d2d35ac28015762$var$defaults.transitionDuration;
};
var $4d2d35ac28015762$var$merge = function merge(options, props) {
    return function(name, shouldObjectMerge) {
        if (shouldObjectMerge === void 0) shouldObjectMerge = false;
        if (shouldObjectMerge) return $4d2d35ac28015762$var$_extends({}, $4d2d35ac28015762$var$defaults[name], {}, props[name], {}, options[name]);
        if (name === 'autoHideDuration') return $4d2d35ac28015762$var$getAutoHideDuration(options.autoHideDuration, props.autoHideDuration);
        if (name === 'transitionDuration') return $4d2d35ac28015762$var$getTransitionDuration(options.transitionDuration, props.transitionDuration);
        return options[name] || props[name] || $4d2d35ac28015762$var$defaults[name];
    };
};
function $4d2d35ac28015762$var$makeStyles(styles) {
    return Object.entries(styles).reduce(function(acc, _ref) {
        var _extends2;
        var key = _ref[0], value = _ref[1];
        return $4d2d35ac28015762$var$_extends({}, acc, (_extends2 = {}, _extends2[key] = (0, $feump.css)(value), _extends2));
    }, {});
}
var $4d2d35ac28015762$var$ComponentClasses = {
    SnackbarContainer: 'notistack-SnackbarContainer',
    Snackbar: 'notistack-Snackbar',
    CollapseWrapper: 'notistack-CollapseWrapper',
    MuiContent: 'notistack-MuiContent',
    MuiContentVariant: function MuiContentVariant(variant) {
        return "notistack-MuiContent-" + variant;
    }
};
var $4d2d35ac28015762$var$classes = /*#__PURE__*/ $4d2d35ac28015762$var$makeStyles({
    root: {
        height: 0
    },
    entered: {
        height: 'auto'
    }
});
var $4d2d35ac28015762$var$collapsedSize = '0px';
var $4d2d35ac28015762$var$timeout = 175;
var $4d2d35ac28015762$var$Collapse = /*#__PURE__*/ (0, $7hhBq.forwardRef)(function(props, ref) {
    var children = props.children, inProp = props["in"], onExited = props.onExited;
    var wrapperRef = (0, $7hhBq.useRef)(null);
    var nodeRef = (0, $7hhBq.useRef)(null);
    var handleRef = $4d2d35ac28015762$var$useForkRef(ref, nodeRef);
    var getWrapperSize = function getWrapperSize() {
        return wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    };
    var handleEnter = function handleEnter(node) {
        node.style.height = $4d2d35ac28015762$var$collapsedSize;
    };
    var handleEntering = function handleEntering(node) {
        var wrapperSize = getWrapperSize();
        var _getTransitionProps = $4d2d35ac28015762$var$getTransitionProps({
            timeout: $4d2d35ac28015762$var$timeout,
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration, easing = _getTransitionProps.easing;
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
        node.style.height = wrapperSize + "px";
        node.style.transitionTimingFunction = easing || '';
    };
    var handleEntered = function handleEntered(node) {
        node.style.height = 'auto';
    };
    var handleExit = function handleExit(node) {
        node.style.height = getWrapperSize() + "px";
    };
    var handleExiting = function handleExiting(node) {
        $4d2d35ac28015762$var$reflow(node);
        var _getTransitionProps2 = $4d2d35ac28015762$var$getTransitionProps({
            timeout: $4d2d35ac28015762$var$timeout,
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration, easing = _getTransitionProps2.easing;
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + "ms";
        node.style.height = $4d2d35ac28015762$var$collapsedSize;
        node.style.transitionTimingFunction = easing || '';
    };
    return (0, $7hhBq.createElement)($4d2d35ac28015762$export$be58926105124dd4, {
        "in": inProp,
        unmountOnExit: true,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: onExited,
        onExiting: handleExiting,
        nodeRef: nodeRef,
        timeout: $4d2d35ac28015762$var$timeout
    }, function(state, childProps) {
        return (0, $7hhBq.createElement)("div", Object.assign({
            ref: handleRef,
            className: (0, $dFDKW.default)($4d2d35ac28015762$var$classes.root, state === 'entered' && $4d2d35ac28015762$var$classes.entered),
            style: $4d2d35ac28015762$var$_extends({
                pointerEvents: 'all',
                overflow: 'hidden',
                minHeight: $4d2d35ac28015762$var$collapsedSize,
                transition: $4d2d35ac28015762$var$createTransition('height')
            }, state === 'entered' && {
                overflow: 'visible'
            }, {}, state === 'exited' && !inProp && {
                visibility: 'hidden'
            })
        }, childProps), (0, $7hhBq.createElement)("div", {
            ref: wrapperRef,
            className: $4d2d35ac28015762$var$ComponentClasses.CollapseWrapper,
            // Hack to get children with a negative margin to not falsify the height computation.
            style: {
                display: 'flex',
                width: '100%'
            }
        }, children));
    });
});
$4d2d35ac28015762$var$Collapse.displayName = 'Collapse';
var $4d2d35ac28015762$var$direction = {
    right: 'left',
    left: 'right',
    bottom: 'up',
    top: 'down'
};
var $4d2d35ac28015762$var$getSlideDirection = function getSlideDirection(anchorOrigin) {
    if (anchorOrigin.horizontal !== 'center') return $4d2d35ac28015762$var$direction[anchorOrigin.horizontal];
    return $4d2d35ac28015762$var$direction[anchorOrigin.vertical];
};
/** Tranforms classes name */ var $4d2d35ac28015762$var$toSnackbarAnchorOrigin = function toSnackbarAnchorOrigin(anchorOrigin) {
    return "anchorOrigin" + $4d2d35ac28015762$var$originKeyExtractor(anchorOrigin);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */ var $4d2d35ac28015762$var$keepSnackbarClassKeys = function keepSnackbarClassKeys(classes) {
    if (classes === void 0) classes = {};
    var containerClasses = {
        containerRoot: true,
        containerAnchorOriginTopCenter: true,
        containerAnchorOriginBottomCenter: true,
        containerAnchorOriginTopRight: true,
        containerAnchorOriginBottomRight: true,
        containerAnchorOriginTopLeft: true,
        containerAnchorOriginBottomLeft: true
    };
    return Object.keys(classes).filter(function(key) {
        return !containerClasses[key];
    }).reduce(function(obj, key) {
        var _extends2;
        return $4d2d35ac28015762$var$_extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
    }, {});
};
var $4d2d35ac28015762$var$noOp$1 = function noOp() {
/* */ };
/**
 * Credit to MUI team @ https://mui.com
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $4d2d35ac28015762$var$createChainedFunction(funcs, snackbarId) {
    // @ts-ignore
    return funcs.reduce(function(acc, func) {
        if (func === null || func === undefined) return acc;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var argums = [].concat(args);
            if (snackbarId && argums.indexOf(snackbarId) === -1) argums.push(snackbarId);
             // @ts-ignore
            acc.apply(this, argums);
            func.apply(this, argums);
        };
    }, $4d2d35ac28015762$var$noOp$1);
}
/**
 * Credit to MUI team @ https://mui.com
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */ var $4d2d35ac28015762$var$useEnhancedEffect = typeof window !== 'undefined' ? (0, $7hhBq.useLayoutEffect) : (0, $7hhBq.useEffect);
function $4d2d35ac28015762$var$useEventCallback(fn) {
    var ref = (0, $7hhBq.useRef)(fn);
    $4d2d35ac28015762$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return (0, $7hhBq.useCallback)(function() {
        return ref.current.apply(void 0, arguments);
    }, []);
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $4d2d35ac28015762$var$Snackbar = /*#__PURE__*/ (0, $7hhBq.forwardRef)(function(props, ref) {
    var children = props.children, className = props.className, autoHideDuration = props.autoHideDuration, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, onClose = props.onClose, id = props.id, open = props.open, _props$SnackbarProps = props.SnackbarProps, SnackbarProps = _props$SnackbarProps === void 0 ? {} : _props$SnackbarProps;
    var timerAutoHide = (0, $7hhBq.useRef)();
    var handleClose = $4d2d35ac28015762$var$useEventCallback(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = $4d2d35ac28015762$var$useEventCallback(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, 'timeout', id);
        }, autoHideDurationParam);
    });
    (0, $7hhBq.useEffect)(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */ var handlePause = function handlePause() {
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
    };
    /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */ var handleResume = (0, $7hhBq.useCallback)(function() {
        if (autoHideDuration != null) setAutoHideTimer(autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (SnackbarProps.onMouseEnter) SnackbarProps.onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (SnackbarProps.onMouseLeave) SnackbarProps.onMouseLeave(event);
        handleResume();
    };
    (0, $7hhBq.useEffect)(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return function() {
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    return (0, $7hhBq.createElement)("div", Object.assign({
        ref: ref
    }, SnackbarProps, {
        className: (0, $dFDKW.default)($4d2d35ac28015762$var$ComponentClasses.Snackbar, className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }), children);
});
$4d2d35ac28015762$var$Snackbar.displayName = 'Snackbar';
var $4d2d35ac28015762$var$_root;
var $4d2d35ac28015762$var$classes$1 = /*#__PURE__*/ $4d2d35ac28015762$var$makeStyles({
    root: ($4d2d35ac28015762$var$_root = {
        display: 'flex',
        flexWrap: 'wrap',
        flexGrow: 1
    }, $4d2d35ac28015762$var$_root[$4d2d35ac28015762$var$breakpoints.upSm] = {
        flexGrow: 'initial',
        minWidth: '288px'
    }, $4d2d35ac28015762$var$_root)
});
var $4d2d35ac28015762$export$860cef82710cac7 = /*#__PURE__*/ (0, $7hhBq.forwardRef)(function(_ref, ref) {
    var className = _ref.className, props = $4d2d35ac28015762$var$_objectWithoutPropertiesLoose(_ref, [
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement("div", Object.assign({
        ref: ref,
        className: (0, $dFDKW.default)($4d2d35ac28015762$var$classes$1.root, className)
    }, props));
});
$4d2d35ac28015762$export$860cef82710cac7.displayName = 'SnackbarContent';
var $4d2d35ac28015762$var$classes$2 = /*#__PURE__*/ $4d2d35ac28015762$var$makeStyles({
    root: {
        backgroundColor: '#313131',
        fontSize: '0.875rem',
        lineHeight: 1.43,
        letterSpacing: '0.01071em',
        color: '#fff',
        alignItems: 'center',
        padding: '6px 16px',
        borderRadius: '4px',
        boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)'
    },
    lessPadding: {
        paddingLeft: "20px"
    },
    "default": {
        backgroundColor: '#313131'
    },
    success: {
        backgroundColor: '#43a047'
    },
    error: {
        backgroundColor: '#d32f2f'
    },
    warning: {
        backgroundColor: '#ff9800'
    },
    info: {
        backgroundColor: '#2196f3'
    },
    message: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 0'
    },
    action: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingLeft: '16px',
        marginRight: '-8px'
    }
});
var $4d2d35ac28015762$var$ariaDescribedby = 'notistack-snackbar';
var $4d2d35ac28015762$var$MaterialDesignContent = /*#__PURE__*/ (0, $7hhBq.forwardRef)(function(props, forwardedRef) {
    var id = props.id, message = props.message, componentOrFunctionAction = props.action, iconVariant = props.iconVariant, variant = props.variant, hideIconVariant = props.hideIconVariant, style = props.style, className = props.className;
    var icon = iconVariant[variant];
    var action = componentOrFunctionAction;
    if (typeof action === 'function') action = action(id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$export$860cef82710cac7, {
        ref: forwardedRef,
        role: "alert",
        "aria-describedby": $4d2d35ac28015762$var$ariaDescribedby,
        style: style,
        className: (0, $dFDKW.default)($4d2d35ac28015762$var$ComponentClasses.MuiContent, $4d2d35ac28015762$var$ComponentClasses.MuiContentVariant(variant), $4d2d35ac28015762$var$classes$2.root, $4d2d35ac28015762$var$classes$2[variant], className, !hideIconVariant && icon && $4d2d35ac28015762$var$classes$2.lessPadding)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement("div", {
        id: $4d2d35ac28015762$var$ariaDescribedby,
        className: $4d2d35ac28015762$var$classes$2.message
    }, !hideIconVariant ? icon : null, message), action && (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement("div", {
        className: $4d2d35ac28015762$var$classes$2.action
    }, action));
});
$4d2d35ac28015762$var$MaterialDesignContent.displayName = 'MaterialDesignContent';
var $4d2d35ac28015762$export$407b0b907b65dfeb = /*#__PURE__*/ (0, $7hhBq.memo)($4d2d35ac28015762$var$MaterialDesignContent);
var $4d2d35ac28015762$var$styles = /*#__PURE__*/ $4d2d35ac28015762$var$makeStyles({
    wrappedRoot: {
        width: '100%',
        position: 'relative',
        transform: 'translateX(0)',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        minWidth: '288px'
    }
});
var $4d2d35ac28015762$var$SnackbarItem = function SnackbarItem(props) {
    var timeout = (0, $7hhBq.useRef)();
    var _useState = (0, $7hhBq.useState)(true), collapsed = _useState[0], setCollapsed = _useState[1];
    var handleClose = $4d2d35ac28015762$var$createChainedFunction([
        props.snack.onClose,
        props.onClose
    ]);
    var handleEntered = function handleEntered() {
        if (props.snack.requestClose) handleClose(null, 'instructed', props.snack.id);
    };
    var handleExitedScreen = (0, $7hhBq.useCallback)(function() {
        timeout.current = setTimeout(function() {
            setCollapsed(function(col) {
                return !col;
            });
        }, 125);
    }, []);
    (0, $7hhBq.useEffect)(function() {
        return function() {
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    var snack = props.snack, allClasses = props.classes, _props$Component = props.Component, Component = _props$Component === void 0 ? $4d2d35ac28015762$export$407b0b907b65dfeb : _props$Component;
    var classes = (0, $7hhBq.useMemo)(function() {
        return $4d2d35ac28015762$var$keepSnackbarClassKeys(allClasses);
    }, [
        allClasses
    ]);
    var open = snack.open, SnackbarProps = snack.SnackbarProps, TransitionComponent = snack.TransitionComponent, TransitionProps = snack.TransitionProps, transitionDuration = snack.transitionDuration, disableWindowBlurListener = snack.disableWindowBlurListener, componentOrFunctionContent = snack.content, otherSnack = $4d2d35ac28015762$var$_objectWithoutPropertiesLoose(snack, [
        "open",
        "SnackbarProps",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration",
        "disableWindowBlurListener",
        "content",
        "entered",
        "requestClose",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var transitionProps = $4d2d35ac28015762$var$_extends({
        direction: $4d2d35ac28015762$var$getSlideDirection(otherSnack.anchorOrigin),
        timeout: transitionDuration
    }, TransitionProps);
    var content = componentOrFunctionContent;
    if (typeof content === 'function') content = content(otherSnack.id, otherSnack.message);
    var callbacks = [
        'onEnter',
        'onEntered',
        'onExit',
        'onExited'
    ].reduce(function(acc, cbName) {
        var _extends2;
        return $4d2d35ac28015762$var$_extends({}, acc, (_extends2 = {}, _extends2[cbName] = $4d2d35ac28015762$var$createChainedFunction([
            props.snack[cbName],
            props[cbName]
        ], otherSnack.id), _extends2));
    }, {});
    return (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$Collapse, {
        "in": collapsed,
        onExited: callbacks.onExited
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$Snackbar, {
        open: open,
        id: otherSnack.id,
        disableWindowBlurListener: disableWindowBlurListener,
        autoHideDuration: otherSnack.autoHideDuration,
        className: (0, $dFDKW.default)($4d2d35ac28015762$var$styles.wrappedRoot, classes.root, classes[$4d2d35ac28015762$var$toSnackbarAnchorOrigin(otherSnack.anchorOrigin)]),
        SnackbarProps: SnackbarProps,
        onClose: handleClose
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement(TransitionComponent, Object.assign({}, transitionProps, {
        appear: true,
        "in": open,
        onExit: callbacks.onExit,
        onExited: handleExitedScreen,
        onEnter: callbacks.onEnter,
        // order matters. first callbacks.onEntered to set entered: true,
        // then handleEntered to check if there's a request for closing
        onEntered: $4d2d35ac28015762$var$createChainedFunction([
            callbacks.onEntered,
            handleEntered
        ], otherSnack.id)
    }), content || (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement(Component, Object.assign({}, otherSnack)))));
};
var $4d2d35ac28015762$var$_root$1, $4d2d35ac28015762$var$_rootDense, $4d2d35ac28015762$var$_left, $4d2d35ac28015762$var$_right, $4d2d35ac28015762$var$_center;
var $4d2d35ac28015762$var$indents = {
    view: {
        "default": 20,
        dense: 4
    },
    snackbar: {
        "default": 6,
        dense: 2
    }
};
var $4d2d35ac28015762$var$collapseWrapper = "." + $4d2d35ac28015762$var$ComponentClasses.CollapseWrapper;
var $4d2d35ac28015762$var$xsWidthMargin = 16;
var $4d2d35ac28015762$var$styles$1 = /*#__PURE__*/ $4d2d35ac28015762$var$makeStyles({
    root: ($4d2d35ac28015762$var$_root$1 = {
        boxSizing: 'border-box',
        display: 'flex',
        maxHeight: '100%',
        position: 'fixed',
        zIndex: 1400,
        height: 'auto',
        width: 'auto',
        transition: /*#__PURE__*/ $4d2d35ac28015762$var$createTransition([
            'top',
            'right',
            'bottom',
            'left',
            'max-width'
        ], {
            duration: 300,
            easing: 'ease'
        }),
        // container itself is invisible and should not block clicks, clicks should be passed to its children
        // a pointerEvents: all is applied in the collapse component
        pointerEvents: 'none'
    }, $4d2d35ac28015762$var$_root$1[$4d2d35ac28015762$var$collapseWrapper] = {
        padding: $4d2d35ac28015762$var$indents.snackbar["default"] + "px 0px",
        transition: 'padding 300ms ease 0ms'
    }, $4d2d35ac28015762$var$_root$1.maxWidth = "calc(100% - " + $4d2d35ac28015762$var$indents.view["default"] * 2 + "px)", $4d2d35ac28015762$var$_root$1[$4d2d35ac28015762$var$breakpoints.downXs] = {
        width: '100%',
        maxWidth: "calc(100% - " + $4d2d35ac28015762$var$xsWidthMargin * 2 + "px)"
    }, $4d2d35ac28015762$var$_root$1),
    rootDense: ($4d2d35ac28015762$var$_rootDense = {}, $4d2d35ac28015762$var$_rootDense[$4d2d35ac28015762$var$collapseWrapper] = {
        padding: $4d2d35ac28015762$var$indents.snackbar.dense + "px 0px"
    }, $4d2d35ac28015762$var$_rootDense),
    top: {
        top: $4d2d35ac28015762$var$indents.view["default"] - $4d2d35ac28015762$var$indents.snackbar["default"] + "px",
        flexDirection: 'column'
    },
    bottom: {
        bottom: $4d2d35ac28015762$var$indents.view["default"] - $4d2d35ac28015762$var$indents.snackbar["default"] + "px",
        flexDirection: 'column-reverse'
    },
    left: ($4d2d35ac28015762$var$_left = {
        left: $4d2d35ac28015762$var$indents.view["default"] + "px"
    }, $4d2d35ac28015762$var$_left[$4d2d35ac28015762$var$breakpoints.upSm] = {
        alignItems: 'flex-start'
    }, $4d2d35ac28015762$var$_left[$4d2d35ac28015762$var$breakpoints.downXs] = {
        left: $4d2d35ac28015762$var$xsWidthMargin + "px"
    }, $4d2d35ac28015762$var$_left),
    right: ($4d2d35ac28015762$var$_right = {
        right: $4d2d35ac28015762$var$indents.view["default"] + "px"
    }, $4d2d35ac28015762$var$_right[$4d2d35ac28015762$var$breakpoints.upSm] = {
        alignItems: 'flex-end'
    }, $4d2d35ac28015762$var$_right[$4d2d35ac28015762$var$breakpoints.downXs] = {
        right: $4d2d35ac28015762$var$xsWidthMargin + "px"
    }, $4d2d35ac28015762$var$_right),
    center: ($4d2d35ac28015762$var$_center = {
        left: '50%',
        transform: 'translateX(-50%)'
    }, $4d2d35ac28015762$var$_center[$4d2d35ac28015762$var$breakpoints.upSm] = {
        alignItems: 'center'
    }, $4d2d35ac28015762$var$_center)
});
var $4d2d35ac28015762$var$SnackbarContainer = function SnackbarContainer(props) {
    var _props$classes = props.classes, classes = _props$classes === void 0 ? {} : _props$classes, anchorOrigin = props.anchorOrigin, dense = props.dense, children = props.children;
    var combinedClassname = (0, $dFDKW.default)($4d2d35ac28015762$var$ComponentClasses.SnackbarContainer, $4d2d35ac28015762$var$styles$1[anchorOrigin.vertical], $4d2d35ac28015762$var$styles$1[anchorOrigin.horizontal], $4d2d35ac28015762$var$styles$1.root, classes.containerRoot, classes["containerAnchorOrigin" + $4d2d35ac28015762$var$originKeyExtractor(anchorOrigin)], dense && $4d2d35ac28015762$var$styles$1.rootDense);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement("div", {
        className: combinedClassname
    }, children);
};
var $4d2d35ac28015762$var$SnackbarContainer$1 = /*#__PURE__*/ (0, $7hhBq.memo)($4d2d35ac28015762$var$SnackbarContainer);
/* eslint-disable */ var $4d2d35ac28015762$var$__DEV__ = false;
var $4d2d35ac28015762$var$messages = {
    NO_PERSIST_ALL: "Reached maxSnack while all enqueued snackbars have 'persist' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented."
};
var $4d2d35ac28015762$var$warning = function(messageKey) {
    if (!$4d2d35ac28015762$var$__DEV__) return;
    var message = $4d2d35ac28015762$var$messages[messageKey];
    if (typeof console !== 'undefined') console.error("WARNING - notistack: " + message);
    try {
        throw new Error(message);
    } catch (x) {}
};
var $4d2d35ac28015762$var$isOptions = function isOptions(messageOrOptions) {
    var isMessage = typeof messageOrOptions === 'string' || (0, $7hhBq.isValidElement)(messageOrOptions);
    return !isMessage;
};
var $4d2d35ac28015762$export$9d70c354f0150b1b;
var $4d2d35ac28015762$export$823cdc5238933767;
var $4d2d35ac28015762$export$d1e619fddc3508ce = /*#__PURE__*/ function(_Component) {
    $4d2d35ac28015762$var$_inheritsLoose(SnackbarProvider, _Component);
    function SnackbarProvider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */ _this.enqueueSnackbar = function(messageOrOptions, optsOrUndefined) {
            if (optsOrUndefined === void 0) optsOrUndefined = {};
            if (messageOrOptions === undefined || messageOrOptions === null) throw new Error('enqueueSnackbar called with invalid argument');
            var opts = $4d2d35ac28015762$var$isOptions(messageOrOptions) ? messageOrOptions : optsOrUndefined;
            var message = $4d2d35ac28015762$var$isOptions(messageOrOptions) ? messageOrOptions.message : messageOrOptions;
            var key = opts.key, preventDuplicate = opts.preventDuplicate, options = $4d2d35ac28015762$var$_objectWithoutPropertiesLoose(opts, [
                "key",
                "preventDuplicate"
            ]);
            var hasSpecifiedKey = $4d2d35ac28015762$var$isDefined(key);
            var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
            var merger = $4d2d35ac28015762$var$merge(options, _this.props);
            var snack = $4d2d35ac28015762$var$_extends({
                id: id
            }, options, {
                message: message,
                open: true,
                entered: false,
                requestClose: false,
                persist: merger('persist'),
                action: merger('action'),
                content: merger('content'),
                variant: merger('variant'),
                anchorOrigin: merger('anchorOrigin'),
                disableWindowBlurListener: merger('disableWindowBlurListener'),
                autoHideDuration: merger('autoHideDuration'),
                hideIconVariant: merger('hideIconVariant'),
                TransitionComponent: merger('TransitionComponent'),
                transitionDuration: merger('transitionDuration'),
                TransitionProps: merger('TransitionProps', true),
                iconVariant: merger('iconVariant', true),
                style: merger('style', true),
                SnackbarProps: merger('SnackbarProps', true),
                className: (0, $dFDKW.default)(_this.props.className, options.className)
            });
            if (snack.persist) snack.autoHideDuration = undefined;
            _this.setState(function(state) {
                if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
                    var compareFunction = function compareFunction(item) {
                        return hasSpecifiedKey ? item.id === id : item.message === message;
                    };
                    var inQueue = state.queue.findIndex(compareFunction) > -1;
                    var inView = state.snacks.findIndex(compareFunction) > -1;
                    if (inQueue || inView) return state;
                }
                return _this.handleDisplaySnack($4d2d35ac28015762$var$_extends({}, state, {
                    queue: [].concat(state.queue, [
                        snack
                    ])
                }));
            });
            return id;
        };
        /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */ _this.handleDisplaySnack = function(state) {
            var snacks = state.snacks;
            if (snacks.length >= _this.maxSnack) return _this.handleDismissOldest(state);
            return _this.processQueue(state);
        };
        /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */ _this.processQueue = function(state) {
            var queue = state.queue, snacks = state.snacks;
            if (queue.length > 0) return $4d2d35ac28015762$var$_extends({}, state, {
                snacks: [].concat(snacks, [
                    queue[0]
                ]),
                queue: queue.slice(1, queue.length)
            });
            return state;
        };
        /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */ _this.handleDismissOldest = function(state) {
            if (state.snacks.some(function(item) {
                return !item.open || item.requestClose;
            })) return state;
            var popped = false;
            var ignore = false;
            var persistentCount = state.snacks.reduce(function(acc, current) {
                return acc + (current.open && current.persist ? 1 : 0);
            }, 0);
            if (persistentCount === _this.maxSnack) ignore = true;
            var snacks = state.snacks.map(function(item) {
                if (!popped && (!item.persist || ignore)) {
                    popped = true;
                    if (!item.entered) return $4d2d35ac28015762$var$_extends({}, item, {
                        requestClose: true
                    });
                    if (item.onClose) item.onClose(null, 'maxsnack', item.id);
                    if (_this.props.onClose) _this.props.onClose(null, 'maxsnack', item.id);
                    return $4d2d35ac28015762$var$_extends({}, item, {
                        open: false
                    });
                }
                return $4d2d35ac28015762$var$_extends({}, item);
            });
            return $4d2d35ac28015762$var$_extends({}, state, {
                snacks: snacks
            });
        };
        /**
     * Set the entered state of the snackbar with the given key.
     */ _this.handleEnteredSnack = function(node, isAppearing, key) {
            if (!$4d2d35ac28015762$var$isDefined(key)) throw new Error('handleEnteredSnack Cannot be called with undefined key');
            _this.setState(function(_ref) {
                var snacks = _ref.snacks;
                return {
                    snacks: snacks.map(function(item) {
                        return item.id === key ? $4d2d35ac28015762$var$_extends({}, item, {
                            entered: true
                        }) : $4d2d35ac28015762$var$_extends({}, item);
                    })
                };
            });
        };
        /**
     * Hide a snackbar after its timeout.
     */ _this.handleCloseSnack = function(event, reason, key) {
            // should not use createChainedFunction for onClose.
            // because this.closeSnackbar called this function
            if (_this.props.onClose) _this.props.onClose(event, reason, key);
            var shouldCloseAll = key === undefined;
            _this.setState(function(_ref2) {
                var snacks = _ref2.snacks, queue = _ref2.queue;
                return {
                    snacks: snacks.map(function(item) {
                        if (!shouldCloseAll && item.id !== key) return $4d2d35ac28015762$var$_extends({}, item);
                        return item.entered ? $4d2d35ac28015762$var$_extends({}, item, {
                            open: false
                        }) : $4d2d35ac28015762$var$_extends({}, item, {
                            requestClose: true
                        });
                    }),
                    queue: queue.filter(function(item) {
                        return item.id !== key;
                    })
                };
            });
        };
        /**
     * Close snackbar with the given key
     */ _this.closeSnackbar = function(key) {
            // call individual snackbar onClose callback passed through options parameter
            var toBeClosed = _this.state.snacks.find(function(item) {
                return item.id === key;
            });
            if ($4d2d35ac28015762$var$isDefined(key) && toBeClosed && toBeClosed.onClose) toBeClosed.onClose(null, 'instructed', key);
            _this.handleCloseSnack(null, 'instructed', key);
        };
        /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */ _this.handleExitedSnack = function(node, key) {
            if (!$4d2d35ac28015762$var$isDefined(key)) throw new Error('handleExitedSnack Cannot be called with undefined key');
            _this.setState(function(state) {
                var newState = _this.processQueue($4d2d35ac28015762$var$_extends({}, state, {
                    snacks: state.snacks.filter(function(item) {
                        return item.id !== key;
                    })
                }));
                if (newState.queue.length === 0) return newState;
                return _this.handleDismissOldest(newState);
            });
        };
        $4d2d35ac28015762$export$9d70c354f0150b1b = _this.enqueueSnackbar;
        $4d2d35ac28015762$export$823cdc5238933767 = _this.closeSnackbar;
        _this.state = {
            snacks: [],
            queue: [],
            contextValue: {
                enqueueSnackbar: _this.enqueueSnackbar.bind($4d2d35ac28015762$var$_assertThisInitialized(_this)),
                closeSnackbar: _this.closeSnackbar.bind($4d2d35ac28015762$var$_assertThisInitialized(_this))
            }
        };
        return _this;
    }
    var _proto = SnackbarProvider.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var contextValue = this.state.contextValue;
        var _this$props = this.props, domRoot = _this$props.domRoot, children = _this$props.children, _this$props$dense = _this$props.dense, dense = _this$props$dense === void 0 ? false : _this$props$dense, _this$props$Component = _this$props.Components, Components = _this$props$Component === void 0 ? {} : _this$props$Component, classes = _this$props.classes;
        var categ = this.state.snacks.reduce(function(acc, current) {
            var _extends2;
            var category = $4d2d35ac28015762$var$originKeyExtractor(current.anchorOrigin);
            var existingOfCategory = acc[category] || [];
            return $4d2d35ac28015762$var$_extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [
                current
            ]), _extends2));
        }, {});
        var snackbars = Object.keys(categ).map(function(origin) {
            var snacks = categ[origin];
            var nomineeSnack = snacks[0];
            return (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$SnackbarContainer$1, {
                key: origin,
                dense: dense,
                anchorOrigin: nomineeSnack.anchorOrigin,
                classes: classes
            }, snacks.map(function(snack) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$SnackbarItem, {
                    key: snack.id,
                    snack: snack,
                    classes: classes,
                    Component: Components[snack.variant],
                    onClose: _this2.handleCloseSnack,
                    onEnter: _this2.props.onEnter,
                    onExit: _this2.props.onExit,
                    onExited: $4d2d35ac28015762$var$createChainedFunction([
                        _this2.handleExitedSnack,
                        _this2.props.onExited
                    ], snack.id),
                    onEntered: $4d2d35ac28015762$var$createChainedFunction([
                        _this2.handleEnteredSnack,
                        _this2.props.onEntered
                    ], snack.id)
                });
            }));
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).createElement($4d2d35ac28015762$var$SnackbarContext.Provider, {
            value: contextValue
        }, children, domRoot ? (0, $4unLw.createPortal)(snackbars, domRoot) : snackbars);
    };
    $4d2d35ac28015762$var$_createClass(SnackbarProvider, [
        {
            key: "maxSnack",
            get: function get() {
                return this.props.maxSnack || $4d2d35ac28015762$var$defaults.maxSnack;
            }
        }
    ]);
    return SnackbarProvider;
}((0, $7hhBq.Component));
var $4d2d35ac28015762$export$1c97ac2c9a6e7c09 = function() {
    return (0, $7hhBq.useContext)($4d2d35ac28015762$var$SnackbarContext);
};

});
parcelRegister("dFDKW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f3df1719e13962d$export$2e2bcd8739ae039; });
function $9f3df1719e13962d$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $9f3df1719e13962d$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $9f3df1719e13962d$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $9f3df1719e13962d$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $9f3df1719e13962d$export$2e2bcd8739ae039 = $9f3df1719e13962d$export$4f5d2d50c9deca37;

});

parcelRegister("feump", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $b16fb6c7d8ac84d7$export$dbf350e5966cf602; });
let $b16fb6c7d8ac84d7$var$e = {
    data: ""
}, $b16fb6c7d8ac84d7$var$t = (t)=>{
    if ("object" == typeof window) {
        let e = (t ? t.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), {
            innerHTML: " ",
            id: "_goober"
        });
        return e.nonce = window.__nonce__, e.parentNode || (t || document.head).appendChild(e), e.firstChild;
    }
    return t || $b16fb6c7d8ac84d7$var$e;
}, $b16fb6c7d8ac84d7$export$54aba348a7896325 = (e)=>{
    let r = $b16fb6c7d8ac84d7$var$t(e), a = r.data;
    return r.data = "", a;
}, $b16fb6c7d8ac84d7$var$a = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $b16fb6c7d8ac84d7$var$l = /\/\*[^]*?\*\/|  +/g, $b16fb6c7d8ac84d7$var$n = /\n+/g, $b16fb6c7d8ac84d7$var$o = (e, t)=>{
    let r = "", a = "", l = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : a += "f" == n[1] ? $b16fb6c7d8ac84d7$var$o(c, n) : n + "{" + $b16fb6c7d8ac84d7$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? a += $b16fb6c7d8ac84d7$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = "-" == n[1] ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), l += $b16fb6c7d8ac84d7$var$o.p ? $b16fb6c7d8ac84d7$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && l ? t + "{" + l + "}" : l) + a;
}, $b16fb6c7d8ac84d7$var$c = {}, $b16fb6c7d8ac84d7$var$i = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $b16fb6c7d8ac84d7$var$i(e[r]);
        return t;
    }
    return e;
}, $b16fb6c7d8ac84d7$var$s = (e, t, r, s, p)=>{
    let u = $b16fb6c7d8ac84d7$var$i(e), d = $b16fb6c7d8ac84d7$var$c[u] || ($b16fb6c7d8ac84d7$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$b16fb6c7d8ac84d7$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $b16fb6c7d8ac84d7$var$a.exec(e.replace($b16fb6c7d8ac84d7$var$l, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($b16fb6c7d8ac84d7$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($b16fb6c7d8ac84d7$var$n, " ").trim();
            return o[0];
        })(e);
        $b16fb6c7d8ac84d7$var$c[d] = $b16fb6c7d8ac84d7$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $b16fb6c7d8ac84d7$var$c.g;
    return r && ($b16fb6c7d8ac84d7$var$c.g = $b16fb6c7d8ac84d7$var$c[d]), ((e, t, r, a)=>{
        a ? t.data = t.data.replace(a, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($b16fb6c7d8ac84d7$var$c[d], t, s, f), d;
}, $b16fb6c7d8ac84d7$var$p = (e, t, r)=>e.reduce((e, a, l)=>{
        let n = t[l];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $b16fb6c7d8ac84d7$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + a + (null == n ? "" : n);
    }, "");
function $b16fb6c7d8ac84d7$export$dbf350e5966cf602(e) {
    let r = this || {}, a = e.call ? e(r.p) : e;
    return $b16fb6c7d8ac84d7$var$s(a.unshift ? a.raw ? $b16fb6c7d8ac84d7$var$p(a, [].slice.call(arguments, 1), r.p) : a.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : a, $b16fb6c7d8ac84d7$var$t(r.target), r.g, r.o, r.k);
}
let $b16fb6c7d8ac84d7$var$d, $b16fb6c7d8ac84d7$var$f, $b16fb6c7d8ac84d7$var$g, $b16fb6c7d8ac84d7$export$442f1a04865e4790 = $b16fb6c7d8ac84d7$export$dbf350e5966cf602.bind({
    g: 1
}), $b16fb6c7d8ac84d7$export$d25ddfdf17c3ad3e = $b16fb6c7d8ac84d7$export$dbf350e5966cf602.bind({
    k: 1
});
function $b16fb6c7d8ac84d7$export$de27182ff8187d6c(e, t, r, a) {
    $b16fb6c7d8ac84d7$var$o.p = t, $b16fb6c7d8ac84d7$var$d = e, $b16fb6c7d8ac84d7$var$f = r, $b16fb6c7d8ac84d7$var$g = a;
}
function $b16fb6c7d8ac84d7$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let a = arguments;
        function l(n, o) {
            let c = Object.assign({}, n), i = c.className || l.className;
            r.p = Object.assign({
                theme: $b16fb6c7d8ac84d7$var$f && $b16fb6c7d8ac84d7$var$f()
            }, c), r.o = /go\d/.test(i), c.className = $b16fb6c7d8ac84d7$export$dbf350e5966cf602.apply(r, a) + (i ? " " + i : ""), t && (c.ref = o);
            let s = e;
            return e[0] && (s = c.as || e, delete c.as), $b16fb6c7d8ac84d7$var$g && s[0] && $b16fb6c7d8ac84d7$var$g(c), $b16fb6c7d8ac84d7$var$d(s, c);
        }
        return t ? t(l) : l;
    };
}

});


parcelRegister("7Ry7z", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("gcZpX"))($parcel$resolve("euda6")),
    (parcelRequire("gcZpX"))($parcel$resolve("3hFDT")),
    (parcelRequire("gcZpX"))($parcel$resolve("fZkIx")),
    (parcelRequire("gcZpX"))($parcel$resolve("5K6ez")),
    (parcelRequire("gcZpX"))($parcel$resolve("jUTny")),
    (parcelRequire("gcZpX"))($parcel$resolve("4vJ3Y"))
]).then(()=>parcelRequire('iUzK1'));

});
parcelRegister("gcZpX", function(module, exports) {
"use strict";

var $1WvIt = parcelRequire("1WvIt");
module.exports = $1WvIt(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("1WvIt", function(module, exports) {
"use strict";
var $16a3cf6f6a94595f$var$cachedBundles = {};
var $16a3cf6f6a94595f$var$cachedPreloads = {};
var $16a3cf6f6a94595f$var$cachedPrefetches = {};
function $16a3cf6f6a94595f$var$getCache(type) {
    switch(type){
        case 'preload':
            return $16a3cf6f6a94595f$var$cachedPreloads;
        case 'prefetch':
            return $16a3cf6f6a94595f$var$cachedPrefetches;
        default:
            return $16a3cf6f6a94595f$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $16a3cf6f6a94595f$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("2zsj5", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("gcZpX"))($parcel$resolve("jUTny")),
    (parcelRequire("gcZpX"))($parcel$resolve("7bnC1"))
]).then(()=>parcelRequire('4f9AZ'));

});

parcelRegister("NU2ei", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("gcZpX"))($parcel$resolve("5K6ez")),
    (parcelRequire("gcZpX"))($parcel$resolve("jUTny")),
    (parcelRequire("gcZpX"))($parcel$resolve("gD8XX"))
]).then(()=>parcelRequire('lWNpV'));

});

parcelRegister("arQiA", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("gcZpX"))($parcel$resolve("k9get")),
    (parcelRequire("gcZpX"))($parcel$resolve("4ASvr")),
    (parcelRequire("gcZpX"))($parcel$resolve("euda6")),
    (parcelRequire("gcZpX"))($parcel$resolve("3hFDT")),
    (parcelRequire("gcZpX"))($parcel$resolve("jUTny")),
    (parcelRequire("gcZpX"))($parcel$resolve("1snBr"))
]).then(()=>parcelRequire('ccDhk'));

});

parcelRegister("4yZea", function(module, exports) {







module.exports = Promise.all([
    (parcelRequire("gcZpX"))($parcel$resolve("8vTzW")),
    (parcelRequire("is1kK"))($parcel$resolve("OpDnX")),
    (parcelRequire("gcZpX"))($parcel$resolve("k9get")),
    (parcelRequire("gcZpX"))($parcel$resolve("euda6")),
    (parcelRequire("gcZpX"))($parcel$resolve("3hFDT")),
    (parcelRequire("gcZpX"))($parcel$resolve("jUTny")),
    (parcelRequire("gcZpX"))($parcel$resolve("8cL2w"))
]).then(()=>parcelRequire('9cCzS'));

});
parcelRegister("is1kK", function(module, exports) {
"use strict";

var $1WvIt = parcelRequire("1WvIt");
module.exports = $1WvIt(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});


parcelRegister("lhNqY", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("gcZpX"))($parcel$resolve("k9get")),
    (parcelRequire("gcZpX"))($parcel$resolve("4ASvr")),
    (parcelRequire("gcZpX"))($parcel$resolve("euda6")),
    (parcelRequire("gcZpX"))($parcel$resolve("3hFDT")),
    (parcelRequire("gcZpX"))($parcel$resolve("jUTny")),
    (parcelRequire("gcZpX"))($parcel$resolve("1qeDw"))
]).then(()=>parcelRequire('loKn0'));

});

parcelRegister("hUY3i", function(module, exports) {

module.exports = (parcelRequire("gcZpX"))($parcel$resolve("kf19U")).then(()=>parcelRequire('aehQD'));

});

parcelRegister("1xKEy", function(module, exports) {

module.exports = (parcelRequire("gcZpX"))($parcel$resolve("eOcT2")).then(()=>parcelRequire('7Qg5D'));

});

parcelRegister("5DVwY", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("gcZpX"))($parcel$resolve("jUTny")),
    (parcelRequire("gcZpX"))($parcel$resolve("iNowr"))
]).then(()=>parcelRequire('fBXv7'));

});

parcelRegister("2PoQG", function(module, exports) {

module.exports = (parcelRequire("gcZpX"))($parcel$resolve("6XEag")).then(()=>parcelRequire('1SPPg'));

});

parcelRegister("eVsYn", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("gcZpX"))($parcel$resolve("eSxxR")),
    (parcelRequire("gcZpX"))($parcel$resolve("euda6")),
    (parcelRequire("gcZpX"))($parcel$resolve("3hFDT")),
    (parcelRequire("gcZpX"))($parcel$resolve("fZkIx")),
    (parcelRequire("gcZpX"))($parcel$resolve("jUTny")),
    (parcelRequire("gcZpX"))($parcel$resolve("1yYlq"))
]).then(()=>parcelRequire('gT01z'));

});

parcelRegister("lsood", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("gcZpX"))($parcel$resolve("eSxxR")),
    (parcelRequire("gcZpX"))($parcel$resolve("8vTzW")),
    (parcelRequire("gcZpX"))($parcel$resolve("euda6")),
    (parcelRequire("gcZpX"))($parcel$resolve("3hFDT")),
    (parcelRequire("gcZpX"))($parcel$resolve("jUTny")),
    (parcelRequire("gcZpX"))($parcel$resolve("cdF1a"))
]).then(()=>parcelRequire('iV0SC'));

});

parcelRegister("97Al8", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("gcZpX"))($parcel$resolve("8vTzW")),
    (parcelRequire("gcZpX"))($parcel$resolve("euda6")),
    (parcelRequire("gcZpX"))($parcel$resolve("9G197"))
]).then(()=>parcelRequire('4viYP'));

});

parcelRegister("i9chW", function(module, exports) {

module.exports = (parcelRequire("gcZpX"))($parcel$resolve("042ir")).then(()=>parcelRequire('7Qoop'));

});

parcelRegister("7hS4X", function(module, exports) {

module.exports = (parcelRequire("gcZpX"))($parcel$resolve("kN2QZ")).then(()=>parcelRequire('6mhTU'));

});

var $f60606d899c70f51$exports = {};
$parcel$extendImportMap({
    "jiofU": "start1.4a1f97ad.webp",
    "8IYK3": "logo_100.dff76b2b.png",
    "fstC1": "logo_500.56e07fad.webp",
    "4vJ3Y": "CreateAccount.d10f669a.js",
    "jUTny": "CreateAccount.e449591c.js",
    "5K6ez": "CreateAccount.4d0e87f7.js",
    "fZkIx": "CreateAccount.0109be4b.js",
    "3hFDT": "CreateAccount.8286281a.js",
    "euda6": "CreateAccount.97c4975d.js",
    "7bnC1": "LoginReset.58d623a7.js",
    "gD8XX": "Login.76650622.js",
    "1snBr": "Events.efe7416c.js",
    "4ASvr": "Events.5a4f2202.js",
    "k9get": "Events.869fc9fb.js",
    "8cL2w": "Admin.d1ad8ff7.js",
    "eO7Ow": "EventList.1b154853.js",
    "OpDnX": "Admin.76178c5a.css",
    "8vTzW": "Admin.d8278e2e.js",
    "1qeDw": "Tickets.17143416.js",
    "kf19U": "SentForgot.44e70f18.js",
    "eOcT2": "ConfirmEmail.e695fc30.js",
    "iNowr": "LoginForgot.25d4ee47.js",
    "6XEag": "LogoutPage.e106013e.js",
    "1yYlq": "WriteProjectInfo.70983080.js",
    "eSxxR": "WriteProjectInfo.e72a18f9.js",
    "cdF1a": "Profile.39dc98f9.js",
    "9G197": "About.f11cbbfc.js",
    "042ir": "Pony.a123e6bd.js",
    "kN2QZ": "PatchEmail.b0200b33.js"
});


var $iHpLz = parcelRequire("iHpLz");
var $f921c969471b625d$export$882461b6382ed46c;
var $f921c969471b625d$export$757ceba2d55c277e;
'use strict';

var $4unLw = parcelRequire("4unLw");
var $f921c969471b625d$var$i;
$f921c969471b625d$export$882461b6382ed46c = $4unLw.createRoot;
$f921c969471b625d$export$757ceba2d55c277e = $4unLw.hydrateRoot;



// src/queryClient.ts

var $j5YGc = parcelRequire("j5YGc");

var $iIj9i = parcelRequire("iIj9i");

var $dDvrN = parcelRequire("dDvrN");
function $000d31c03c25750a$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.set) {
        if (!descriptor.get) throw new TypeError("attempted to read set only private field");
        if (!("__destrWrapper" in descriptor)) descriptor.__destrWrapper = {
            set value (v){
                descriptor.set.call(receiver, v);
            },
            get value () {
                return descriptor.get.call(receiver);
            }
        };
        return descriptor.__destrWrapper;
    } else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        return descriptor;
    }
}



var $1kkP8 = parcelRequire("1kkP8");
function $d74e4fe19737d8c4$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $1kkP8._)(receiver, privateMap, "update");
    return (0, $000d31c03c25750a$export$71511d61b312f219)(receiver, descriptor);
}



var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $49ckD = parcelRequire("49ckD");
// src/queryCache.ts

var $j5YGc = parcelRequire("j5YGc");

var $iIj9i = parcelRequire("iIj9i");

var $dDvrN = parcelRequire("dDvrN");

var $dok7x = parcelRequire("dok7x");

var $49ckD = parcelRequire("49ckD");

var $hRF8n = parcelRequire("hRF8n");

var $csodM = parcelRequire("csodM");

var $efvjD = parcelRequire("efvjD");
var $e94bcecc36adc7bd$var$_queries;
var $e94bcecc36adc7bd$export$5dde0cd941da8468 = ($e94bcecc36adc7bd$var$_queries = /*#__PURE__*/ new WeakMap(), class extends (0, $efvjD.Subscribable) {
    build(client, options, state) {
        const queryKey = options.queryKey;
        var _options_queryHash;
        const queryHash = (_options_queryHash = options.queryHash) !== null && _options_queryHash !== void 0 ? _options_queryHash : (0, $49ckD.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $hRF8n.Query)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $j5YGc._)(this, $e94bcecc36adc7bd$var$_queries).has(query.queryHash)) {
            (0, $j5YGc._)(this, $e94bcecc36adc7bd$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $j5YGc._)(this, $e94bcecc36adc7bd$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $j5YGc._)(this, $e94bcecc36adc7bd$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $csodM.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $j5YGc._)(this, $e94bcecc36adc7bd$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $j5YGc._)(this, $e94bcecc36adc7bd$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = (0, $dok7x._)({
            exact: true
        }, filters);
        return this.getAll().find((query)=>(0, $49ckD.matchQuery)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $49ckD.matchQuery)(filters, query)) : queries;
    }
    notify(event) {
        (0, $csodM.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $csodM.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $csodM.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
    constructor(config = {}){
        super(), (0, $iIj9i._)(this, $e94bcecc36adc7bd$var$_queries, {
            writable: true,
            value: void 0
        });
        this.config = config;
        (0, $dDvrN._)(this, $e94bcecc36adc7bd$var$_queries, /* @__PURE__ */ new Map());
    }
});


// src/mutationCache.ts

var $j5YGc = parcelRequire("j5YGc");

var $iIj9i = parcelRequire("iIj9i");

var $dDvrN = parcelRequire("dDvrN");


var $dok7x = parcelRequire("dok7x");

var $csodM = parcelRequire("csodM");

var $h3w18 = parcelRequire("h3w18");

var $49ckD = parcelRequire("49ckD");

var $efvjD = parcelRequire("efvjD");
var $5df07efcf462aa45$var$_mutations, $5df07efcf462aa45$var$_scopes, $5df07efcf462aa45$var$_mutationId;
var $5df07efcf462aa45$export$1fcfd9a244434844 = ($5df07efcf462aa45$var$_mutations = /*#__PURE__*/ new WeakMap(), $5df07efcf462aa45$var$_scopes = /*#__PURE__*/ new WeakMap(), $5df07efcf462aa45$var$_mutationId = /*#__PURE__*/ new WeakMap(), class extends (0, $efvjD.Subscribable) {
    build(client, options, state) {
        const mutation = new (0, $h3w18.Mutation)({
            client: client,
            mutationCache: this,
            mutationId: ++(0, $d74e4fe19737d8c4$export$71511d61b312f219)(this, $5df07efcf462aa45$var$_mutationId).value,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $j5YGc._)(this, $5df07efcf462aa45$var$_mutations).add(mutation);
        const scope = $5df07efcf462aa45$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, $j5YGc._)(this, $5df07efcf462aa45$var$_scopes).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, $j5YGc._)(this, $5df07efcf462aa45$var$_scopes).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if ((0, $j5YGc._)(this, $5df07efcf462aa45$var$_mutations).delete(mutation)) {
            const scope = $5df07efcf462aa45$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, $j5YGc._)(this, $5df07efcf462aa45$var$_scopes).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, $j5YGc._)(this, $5df07efcf462aa45$var$_scopes).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $5df07efcf462aa45$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, $j5YGc._)(this, $5df07efcf462aa45$var$_scopes).get(scope);
            const firstPendingMutation = mutationsWithSameScope === null || mutationsWithSameScope === void 0 ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = $5df07efcf462aa45$var$scopeFor(mutation);
        if (typeof scope === "string") {
            var _class_private_field_get_get;
            const foundMutation = (_class_private_field_get_get = (0, $j5YGc._)(this, $5df07efcf462aa45$var$_scopes).get(scope)) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.find((m)=>m !== mutation && m.state.isPaused);
            var _foundMutation_continue;
            return (_foundMutation_continue = foundMutation === null || foundMutation === void 0 ? void 0 : foundMutation.continue()) !== null && _foundMutation_continue !== void 0 ? _foundMutation_continue : Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $csodM.notifyManager).batch(()=>{
            (0, $j5YGc._)(this, $5df07efcf462aa45$var$_mutations).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            (0, $j5YGc._)(this, $5df07efcf462aa45$var$_mutations).clear();
            (0, $j5YGc._)(this, $5df07efcf462aa45$var$_scopes).clear();
        });
    }
    getAll() {
        return Array.from((0, $j5YGc._)(this, $5df07efcf462aa45$var$_mutations));
    }
    find(filters) {
        const defaultedFilters = (0, $dok7x._)({
            exact: true
        }, filters);
        return this.getAll().find((mutation)=>(0, $49ckD.matchMutation)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $49ckD.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $csodM.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $csodM.notifyManager).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $49ckD.noop)))));
    }
    constructor(config = {}){
        super(), (0, $iIj9i._)(this, $5df07efcf462aa45$var$_mutations, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $5df07efcf462aa45$var$_scopes, {
            writable: true,
            value: void 0
        }), (0, $iIj9i._)(this, $5df07efcf462aa45$var$_mutationId, {
            writable: true,
            value: void 0
        });
        this.config = config;
        (0, $dDvrN._)(this, $5df07efcf462aa45$var$_mutations, /* @__PURE__ */ new Set());
        (0, $dDvrN._)(this, $5df07efcf462aa45$var$_scopes, /* @__PURE__ */ new Map());
        (0, $dDvrN._)(this, $5df07efcf462aa45$var$_mutationId, 0);
    }
});
function $5df07efcf462aa45$var$scopeFor(mutation) {
    var _mutation_options_scope;
    return (_mutation_options_scope = mutation.options.scope) === null || _mutation_options_scope === void 0 ? void 0 : _mutation_options_scope.id;
}



var $jVNuv = parcelRequire("jVNuv");

var $gsfBp = parcelRequire("gsfBp");

var $csodM = parcelRequire("csodM");
var $a3d1320b6b87071b$var$_queryCache, $a3d1320b6b87071b$var$_mutationCache, $a3d1320b6b87071b$var$_defaultOptions, $a3d1320b6b87071b$var$_queryDefaults, $a3d1320b6b87071b$var$_mutationDefaults, $a3d1320b6b87071b$var$_mountCount, $a3d1320b6b87071b$var$_unsubscribeFocus, $a3d1320b6b87071b$var$_unsubscribeOnline;
var $a3d1320b6b87071b$export$405d0624ed55a03f = ($a3d1320b6b87071b$var$_queryCache = /*#__PURE__*/ new WeakMap(), $a3d1320b6b87071b$var$_mutationCache = /*#__PURE__*/ new WeakMap(), $a3d1320b6b87071b$var$_defaultOptions = /*#__PURE__*/ new WeakMap(), $a3d1320b6b87071b$var$_queryDefaults = /*#__PURE__*/ new WeakMap(), $a3d1320b6b87071b$var$_mutationDefaults = /*#__PURE__*/ new WeakMap(), $a3d1320b6b87071b$var$_mountCount = /*#__PURE__*/ new WeakMap(), $a3d1320b6b87071b$var$_unsubscribeFocus = /*#__PURE__*/ new WeakMap(), $a3d1320b6b87071b$var$_unsubscribeOnline = /*#__PURE__*/ new WeakMap(), class {
    mount() {
        (0, $d74e4fe19737d8c4$export$71511d61b312f219)(this, $a3d1320b6b87071b$var$_mountCount).value++;
        if ((0, $j5YGc._)(this, $a3d1320b6b87071b$var$_mountCount) !== 1) return;
        (0, $dDvrN._)(this, $a3d1320b6b87071b$var$_unsubscribeFocus, (0, $jVNuv.focusManager).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).onFocus();
            }
        }));
        (0, $dDvrN._)(this, $a3d1320b6b87071b$var$_unsubscribeOnline, (0, $gsfBp.onlineManager).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _this, _this1, _ref, _this2, _this3, _ref1;
        (0, $d74e4fe19737d8c4$export$71511d61b312f219)(this, $a3d1320b6b87071b$var$_mountCount).value--;
        if ((0, $j5YGc._)(this, $a3d1320b6b87071b$var$_mountCount) !== 0) return;
        (_this = (0, $j5YGc._)(_ref = _this1 = this, $a3d1320b6b87071b$var$_unsubscribeFocus)) === null || _this === void 0 ? void 0 : _this.call(_this1);
        (0, $dDvrN._)(this, $a3d1320b6b87071b$var$_unsubscribeFocus, void 0);
        (_this2 = (0, $j5YGc._)(_ref1 = _this3 = this, $a3d1320b6b87071b$var$_unsubscribeOnline)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3);
        (0, $dDvrN._)(this, $a3d1320b6b87071b$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).findAll((0, $cNnl8._)((0, $dok7x._)({}, filters), {
            fetchStatus: "fetching"
        })).length;
    }
    isMutating(filters) {
        return (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_mutationCache).findAll((0, $cNnl8._)((0, $dok7x._)({}, filters), {
            status: "pending"
        })).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        var _class_private_field_get_get;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_class_private_field_get_get = (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).get(options.queryHash)) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $49ckD.resolveStaleTime)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query === null || query === void 0 ? void 0 : query.state.data;
        const data = (0, $49ckD.functionalUpdate)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).build(this, defaultedOptions).setData(data, (0, $cNnl8._)((0, $dok7x._)({}, options), {
            manual: true
        }));
    }
    setQueriesData(filters, updater, options) {
        return (0, $csodM.notifyManager).batch(()=>(0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _class_private_field_get_get;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_class_private_field_get_get = (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).get(options.queryHash)) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache);
        (0, $csodM.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache);
        return (0, $csodM.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries((0, $dok7x._)({
                type: "active"
            }, filters), options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = (0, $dok7x._)({
            revert: true
        }, cancelOptions);
        const promises = (0, $csodM.notifyManager).batch(()=>(0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $49ckD.noop)).catch((0, $49ckD.noop));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $csodM.notifyManager).batch(()=>{
            (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters === null || filters === void 0 ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            var _filters_refetchType, _ref;
            return this.refetchQueries((0, $cNnl8._)((0, $dok7x._)({}, filters), {
                type: (_ref = (_filters_refetchType = filters === null || filters === void 0 ? void 0 : filters.refetchType) !== null && _filters_refetchType !== void 0 ? _filters_refetchType : filters === null || filters === void 0 ? void 0 : filters.type) !== null && _ref !== void 0 ? _ref : "active"
            }), options);
        });
    }
    refetchQueries(filters, options = {}) {
        var _options_cancelRefetch;
        const fetchOptions = (0, $cNnl8._)((0, $dok7x._)({}, options), {
            cancelRefetch: (_options_cancelRefetch = options.cancelRefetch) !== null && _options_cancelRefetch !== void 0 ? _options_cancelRefetch : true
        });
        const promises = (0, $csodM.notifyManager).batch(()=>(0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $49ckD.noop));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $49ckD.noop));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $49ckD.resolveStaleTime)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $49ckD.noop)).catch((0, $49ckD.noop));
    }
    fetchInfiniteQuery(options) {
        options._type = "infinite";
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $49ckD.noop)).catch((0, $49ckD.noop));
    }
    ensureInfiniteQueryData(options) {
        options._type = "infinite";
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $gsfBp.onlineManager).isOnline()) return (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache);
    }
    getMutationCache() {
        return (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $dDvrN._)(this, $a3d1320b6b87071b$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryDefaults).set((0, $49ckD.hashKey)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $49ckD.partialMatchKey)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_mutationDefaults).set((0, $49ckD.hashKey)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $j5YGc._)(this, $a3d1320b6b87071b$var$_mutationDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $49ckD.partialMatchKey)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = (0, $cNnl8._)((0, $dok7x._)({}, (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_defaultOptions).queries, this.getQueryDefaults(options.queryKey), options), {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $49ckD.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $49ckD.skipToken)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options === null || options === void 0 ? void 0 : options._defaulted) return options;
        return (0, $cNnl8._)((0, $dok7x._)({}, (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_defaultOptions).mutations, (options === null || options === void 0 ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey), options), {
            _defaulted: true
        });
    }
    clear() {
        (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_queryCache).clear();
        (0, $j5YGc._)(this, $a3d1320b6b87071b$var$_mutationCache).clear();
    }
    constructor(config = {}){
        (0, $iIj9i._)(this, $a3d1320b6b87071b$var$_queryCache, {
            writable: true,
            value: void 0
        });
        (0, $iIj9i._)(this, $a3d1320b6b87071b$var$_mutationCache, {
            writable: true,
            value: void 0
        });
        (0, $iIj9i._)(this, $a3d1320b6b87071b$var$_defaultOptions, {
            writable: true,
            value: void 0
        });
        (0, $iIj9i._)(this, $a3d1320b6b87071b$var$_queryDefaults, {
            writable: true,
            value: void 0
        });
        (0, $iIj9i._)(this, $a3d1320b6b87071b$var$_mutationDefaults, {
            writable: true,
            value: void 0
        });
        (0, $iIj9i._)(this, $a3d1320b6b87071b$var$_mountCount, {
            writable: true,
            value: void 0
        });
        (0, $iIj9i._)(this, $a3d1320b6b87071b$var$_unsubscribeFocus, {
            writable: true,
            value: void 0
        });
        (0, $iIj9i._)(this, $a3d1320b6b87071b$var$_unsubscribeOnline, {
            writable: true,
            value: void 0
        });
        (0, $dDvrN._)(this, $a3d1320b6b87071b$var$_queryCache, config.queryCache || new (0, $e94bcecc36adc7bd$export$5dde0cd941da8468)());
        (0, $dDvrN._)(this, $a3d1320b6b87071b$var$_mutationCache, config.mutationCache || new (0, $5df07efcf462aa45$export$1fcfd9a244434844)());
        (0, $dDvrN._)(this, $a3d1320b6b87071b$var$_defaultOptions, config.defaultOptions || {});
        (0, $dDvrN._)(this, $a3d1320b6b87071b$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $dDvrN._)(this, $a3d1320b6b87071b$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $dDvrN._)(this, $a3d1320b6b87071b$var$_mountCount, 0);
    }
});


var $a0iaM = parcelRequire("a0iaM");

var $iHpLz = parcelRequire("iHpLz");

var $7hhBq = parcelRequire("7hhBq");

var $b5Oyq = parcelRequire("b5Oyq");

var $k2lc8 = parcelRequire("k2lc8");
var $edeoK = parcelRequire("edeoK");

var $aw1H1 = parcelRequire("aw1H1");

var $d0uAT = parcelRequire("d0uAT");

var $iHpLz = parcelRequire("iHpLz");

var $dmsNZ = parcelRequire("dmsNZ");
var $18TeW = parcelRequire("18TeW");
parcelRequire("7hhBq");
const $1a11c5a4e40f40a3$var$RootGrid = (0, $18TeW.default)((0, $dmsNZ.default))(({ theme: theme })=>({
        margin: '0 auto',
        maxWidth: theme.breakpoints.values.lg
    }));
const $1a11c5a4e40f40a3$var$AppContent = ({ children: children })=>{
    return /*#__PURE__*/ (0, $iHpLz.jsx)($1a11c5a4e40f40a3$var$RootGrid, {
        container: true,
        justifyContent: "center",
        children: children
    });
};
var $1a11c5a4e40f40a3$export$2e2bcd8739ae039 = $1a11c5a4e40f40a3$var$AppContent;



var $iHpLz = parcelRequire("iHpLz");

var $7hhBq = parcelRequire("7hhBq");

var $aw1H1 = parcelRequire("aw1H1");

var $ddi3l = parcelRequire("ddi3l");

var $dkNUW = parcelRequire("dkNUW");
const $f2bec9eed9f6029f$var$isExistingSlug = (slug)=>({
        queryKey: [
            'slugExists',
            slug
        ],
        queryFn: ()=>$f2bec9eed9f6029f$var$fetchSlug(slug),
        enabled: !!slug,
        gcTime: Infinity,
        staleTime: 86400000
    });
const $f2bec9eed9f6029f$var$fetchSlug = async (slug)=>{
    try {
        await $dkNUW.request('GET', `/content-public/${slug}/exists`);
        return true;
    } catch (_) {
        return false;
    }
};
var $f2bec9eed9f6029f$export$2e2bcd8739ae039 = $f2bec9eed9f6029f$var$isExistingSlug;



var $iZUkI = parcelRequire("iZUkI");
/**
 * Renders page depending on if the project exists or not
 * To prevent wrong URLs.
 */ const $169887c0cff00317$var$ProjectRender = ({ children: children })=>{
    const navigate = (0, $aw1H1.useNavigate)();
    const { projectId: projectId } = (0, $aw1H1.useParams)();
    const [somethingWrong, setSomethingWrong] = (0, $7hhBq.useState)(false);
    const { data: isSlugExisting, isLoading: isLoading } = (0, $ddi3l.useQuery)((0, $f2bec9eed9f6029f$export$2e2bcd8739ae039)(projectId || ''));
    (0, $7hhBq.useEffect)(()=>{
        // Only redirect if we're not already at the default route
        if (!isLoading && !isSlugExisting && projectId !== (0, $iZUkI.DEFAULT_PROJECT).toString()) {
            setSomethingWrong(true);
            navigate((0, $iZUkI.DEFAULT_ROUTE), {
                replace: true
            });
        }
    }, [
        isLoading,
        isSlugExisting,
        projectId,
        navigate
    ]);
    // It won't render anything while it is loading the first time.
    if (isLoading) return null;
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iHpLz.Fragment), {
        children: !somethingWrong && children
    });
};
var $169887c0cff00317$export$2e2bcd8739ae039 = $169887c0cff00317$var$ProjectRender;



var $6WeUp = parcelRequire("6WeUp");

var $dok7x = parcelRequire("dok7x");

var $ddi3l = parcelRequire("ddi3l");

var $f5flw = parcelRequire("f5flw");
const $daef2f9da5d41884$var$theme = (0, $f5flw.default)({
    palette: {
        primary: {
            main: '#750505',
            light: '#aa3d2e',
            dark: '#460000',
            contrastText: '#ffffff'
        },
        secondary: {
            main: '#104e75',
            light: '#497aa4',
            dark: '#002649',
            contrastText: '#ffffff'
        },
        error: {
            main: '#B00020',
            light: '#B00020',
            dark: '#B00020',
            contrastText: '#ffffff'
        },
        success: {
            main: '#20B000',
            light: '#20B000',
            dark: '#20B000',
            contrastText: '#ffffff'
        },
        warning: {
            main: '#F16F3A',
            light: '#F16F3A',
            dark: '#F16F3A',
            contrastText: '#000000'
        },
        info: {
            main: '#a4a4a4',
            light: '#a4a4a4',
            dark: '#a4a4a4',
            contrastText: '#000000'
        },
        neutral: {
            main: '#616161',
            light: '#8e8e8e',
            dark: '#373737',
            contrastText: '#ffffff'
        },
        background: {
            main: '#FFFFFF',
            text: '#000000'
        },
        surface: {
            main: '#FFFFFF',
            text: '#000000'
        },
        other: {
            opacityHigh: 'CC',
            opacityMedium: '99',
            opacityDisabled: '61'
        },
        overlay: {
            opacity: {
                hover: '30',
                selected: '14',
                activated: '1E',
                deactivated: '4C',
                pressed: '1E',
                dragged: '14',
                enabled: '00'
            }
        }
    },
    typography: {
        fontFamily: 'Roboto',
        fontSize: 16,
        h1: {
            fontWeight: '300',
            fontSize: 95,
            letterSpacing: '-1.5px'
        },
        h2: {
            fontWeight: '300',
            fontSize: 59,
            letterSpacing: '-0.5px'
        },
        h3: {
            fontWeight: '400',
            fontSize: 48,
            letterSpacing: '0px'
        },
        h4: {
            fontWeight: '400',
            fontSize: 34,
            letterSpacing: '0.25px'
        },
        h5: {
            fontWeight: '400',
            fontSize: 24,
            letterSpacing: '0px'
        },
        h6: {
            fontWeight: '500',
            fontSize: 20,
            letterSpacing: '0.15px'
        },
        subtitle1: {
            fontFamily: 'Open Sans',
            fontWeight: '400',
            fontSize: 16,
            letterSpacing: '0.15px'
        },
        subtitle2: {
            fontFamily: 'Open Sans',
            fontWeight: '600',
            fontSize: 14,
            letterSpacing: '0.1px'
        },
        body1: {
            fontSize: 16,
            letterSpacing: '0.5px'
        },
        body2: {
            fontSize: 14,
            letterSpacing: '0.25px'
        },
        caption: {
            fontSize: 12,
            letterSpacing: '0.4px'
        },
        overline: {
            fontSize: 10,
            letterSpacing: '1.5px'
        },
        button: {
            fontWeight: '600',
            fontSize: 14,
            letterSpacing: '1.25px'
        }
    },
    breakpoints: {
        values: {
            xs: 320,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920
        }
    },
    spacing: 4
});
var $daef2f9da5d41884$export$2e2bcd8739ae039 = $daef2f9da5d41884$var$theme;



var $dkNUW = parcelRequire("dkNUW");
const $1607a7f7b8da2e71$var$fetchTheme = async (pid)=>{
    const result = await $dkNUW.request('get', `/content-public/${pid}/theme/colors`);
    return result.data.data;
};
const $1607a7f7b8da2e71$var$getTheme = (pid)=>({
        queryKey: [
            'getTheme',
            pid
        ],
        queryFn: ()=>$1607a7f7b8da2e71$var$fetchTheme(pid),
        enabled: !!pid,
        gcTime: 3600000,
        // 1 hour
        // If the colors don't exist, we don't wanna wait too long to load the app.
        // Furthermore, the theme will load before it validates the project ID.
        // If the project does not exist, this should fail fast so we can redirect
        // to the default project before the user notices.
        // Old value: 1.
        retry: 0,
        retryDelay: 20000
    });
var $1607a7f7b8da2e71$export$2e2bcd8739ae039 = $1607a7f7b8da2e71$var$getTheme;



var $8oEKT = parcelRequire("8oEKT");
const $82f77024a75ce78a$var$useFetchTheme = ()=>{
    const projectId = (0, $8oEKT.default)();
    const { data: data, isLoading: isLoading } = (0, $ddi3l.useQuery)((0, $1607a7f7b8da2e71$export$2e2bcd8739ae039)(projectId));
    if (isLoading || !data) return {
        theme: $daef2f9da5d41884$export$2e2bcd8739ae039,
        isLoading: isLoading
    };
    const newTheme = (0, $dok7x._)({}, (0, $daef2f9da5d41884$export$2e2bcd8739ae039));
    newTheme.palette.primary = data.primary;
    newTheme.palette.secondary = data.secondary;
    newTheme.palette.error = data.error;
    newTheme.palette.success = data.success;
    newTheme.palette.warning = data.warning;
    newTheme.palette.info = data.info;
    return {
        theme: newTheme,
        isLoading: isLoading
    };
};
var $82f77024a75ce78a$export$2e2bcd8739ae039 = $82f77024a75ce78a$var$useFetchTheme;



var $iHpLz = parcelRequire("iHpLz");

var $8oEKT = parcelRequire("8oEKT");
parcelRequire("7hhBq");

var $aw1H1 = parcelRequire("aw1H1");
const $66c5d7e930dd48aa$var$RedirectPage = ()=>{
    const projectId = (0, $8oEKT.default)();
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Navigate), {
        to: `/${projectId}/`,
        replace: true
    });
};
var $66c5d7e930dd48aa$export$2e2bcd8739ae039 = $66c5d7e930dd48aa$var$RedirectPage;



var $iHpLz = parcelRequire("iHpLz");

var $d0uAT = parcelRequire("d0uAT");

var $ddi3l = parcelRequire("ddi3l");

var $ljlev = parcelRequire("ljlev");
const $a9d02e0c14f9ebae$var$useLoggedIn = ()=>{
    return (0, $ljlev.default)().isActive;
};
var $a9d02e0c14f9ebae$export$2e2bcd8739ae039 = $a9d02e0c14f9ebae$var$useLoggedIn;



var $8oEKT = parcelRequire("8oEKT");

var $iHpLz = parcelRequire("iHpLz");
parcelRequire("7hhBq");

var $c5JDL = parcelRequire("c5JDL");

var $iVlmI = parcelRequire("iVlmI");

var $iHpLz = parcelRequire("iHpLz");

var $18TeW = parcelRequire("18TeW");
parcelRequire("7hhBq");
var $66b37ad941da62ae$exports = {};
$66b37ad941da62ae$exports = $parcel$resolve("jiofU");



var $5cFwf = parcelRequire("5cFwf");

var $h3hKu = parcelRequire("h3hKu");

var $iHpLz = parcelRequire("iHpLz");

var $9jigW = parcelRequire("9jigW");
var $18TeW = parcelRequire("18TeW");


var $8oEKT = parcelRequire("8oEKT");
parcelRequire("7hhBq");

var $aw1H1 = parcelRequire("aw1H1");
const $8c003f1e9230c272$var$RegisterButton = (0, $18TeW.default)((0, $9jigW.default))(({ theme: theme })=>({
        width: '97px',
        marginRight: '51px',
        [theme.breakpoints.down('sm')]: {
            marginRight: '27px'
        }
    }));
const $8c003f1e9230c272$var$LoginButton = (0, $18TeW.default)((0, $9jigW.default))(({ theme: theme })=>({
        width: '97px',
        marginLeft: '51px',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '27px'
        }
    }));
const $8c003f1e9230c272$var$ButtonContainer = (0, $18TeW.default)('div')(({ theme: theme })=>({
        margin: '0 auto',
        width: '297px',
        marginTop: '456px',
        [theme.breakpoints.down('md')]: {
            marginTop: '383px'
        },
        [theme.breakpoints.down('sm')]: {
            width: '248px',
            marginTop: '295px'
        }
    }));
const $8c003f1e9230c272$var$JumbotronButtons = ()=>{
    const navigate = (0, $aw1H1.useNavigate)();
    const projectId = (0, $8oEKT.default)();
    const loggedIn = (0, $a9d02e0c14f9ebae$export$2e2bcd8739ae039)();
    if (!loggedIn) return /*#__PURE__*/ (0, $iHpLz.jsxs)($8c003f1e9230c272$var$ButtonContainer, {
        children: [
            /*#__PURE__*/ (0, $iHpLz.jsx)($8c003f1e9230c272$var$RegisterButton, {
                color: "secondary",
                variant: "contained",
                onClick: ()=>navigate(`/${projectId}/createaccount`),
                children: "Register"
            }),
            /*#__PURE__*/ (0, $iHpLz.jsx)($8c003f1e9230c272$var$LoginButton, {
                color: "secondary",
                variant: "contained",
                onClick: ()=>navigate(`/${projectId}/login`),
                children: "Login"
            })
        ]
    });
    return /*#__PURE__*/ (0, $iHpLz.jsx)($8c003f1e9230c272$var$ButtonContainer, {});
};
var $8c003f1e9230c272$export$2e2bcd8739ae039 = $8c003f1e9230c272$var$JumbotronButtons;


const $af426410d8a55710$var$ImageContainer = (0, $18TeW.default)('div')(({ theme: theme, src: src })=>({
        position: 'relative',
        width: '100%',
        backgroundImage: `url(${src})`,
        height: '530px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 50%',
        [theme.breakpoints.down('md')]: {
            height: '480px'
        },
        [theme.breakpoints.down('sm')]: {
            height: '430px'
        }
    }));
const $af426410d8a55710$var$Jumbotron = ()=>{
    const theme = (0, $h3hKu.default)();
    const imageUrl = (0, $5cFwf.default)('LANDING', (0, (/*@__PURE__*/$parcel$interopDefault($66b37ad941da62ae$exports))));
    return /*#__PURE__*/ (0, $iHpLz.jsx)($af426410d8a55710$var$ImageContainer, {
        src: imageUrl,
        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $8c003f1e9230c272$export$2e2bcd8739ae039), {})
    });
};
var $af426410d8a55710$export$2e2bcd8739ae039 = $af426410d8a55710$var$Jumbotron;



var $1HEu7 = parcelRequire("1HEu7");


var $hoDlW = parcelRequire("hoDlW");

var $gSXnV = parcelRequire("gSXnV");
const $dd128a8572500698$var$Home = ()=>{
    const { FRONTPAGE_MAIN: text } = (0, $c5JDL.useProjectTextContext)();
    return /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $iHpLz.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iHpLz.jsx)((0, $af426410d8a55710$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iVlmI.default), {
                children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $hoDlW.default), {
                    children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $1HEu7.Markdown), {
                        children: text !== null && text !== void 0 ? text : ''
                    })
                })
            }),
            /*#__PURE__*/ (0, $iHpLz.jsx)((0, $gSXnV.default), {})
        ]
    });
};
var $dd128a8572500698$export$2e2bcd8739ae039 = $dd128a8572500698$var$Home;



var $ir54T = parcelRequire("ir54T");
parcelRequire("7hhBq");

var $aw1H1 = parcelRequire("aw1H1");
const $c9657a7c0ff100d4$var$RootPage = ()=>{
    var _inProject_data;
    const loggedIn = (0, $a9d02e0c14f9ebae$export$2e2bcd8739ae039)();
    const projectId = (0, $8oEKT.default)();
    const inProject = (0, $ddi3l.useQuery)((0, $ir54T.userInProject)({
        projectId: projectId,
        loggedIn: loggedIn
    }));
    if (!loggedIn) return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $dd128a8572500698$export$2e2bcd8739ae039), {});
    if (inProject.isLoading || !inProject.data) return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $d0uAT.default), {
        color: "secondary"
    });
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iHpLz.Fragment), {
        children: !((_inProject_data = inProject.data) === null || _inProject_data === void 0 ? void 0 : _inProject_data.isSigned) ? /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Navigate), {
            to: `/${projectId}/projectInfo`,
            replace: true
        }) : /*#__PURE__*/ (0, $iHpLz.jsx)((0, $dd128a8572500698$export$2e2bcd8739ae039), {})
    });
};
var $c9657a7c0ff100d4$export$2e2bcd8739ae039 = $c9657a7c0ff100d4$var$RootPage;



var $i813w = parcelRequire("i813w");

var $iHpLz = parcelRequire("iHpLz");
parcelRequire("7hhBq");

var $aw1H1 = parcelRequire("aw1H1");

var $6WeUp = parcelRequire("6WeUp");

var $c2CkC = parcelRequire("c2CkC");

var $8oEKT = parcelRequire("8oEKT");

var $ddi3l = parcelRequire("ddi3l");


var $8oEKT = parcelRequire("8oEKT");

var $ir54T = parcelRequire("ir54T");

var $7hhBq = parcelRequire("7hhBq");

var $aw1H1 = parcelRequire("aw1H1");

var $iHpLz = parcelRequire("iHpLz");

var $8Q9JX = parcelRequire("8Q9JX");

var $iHpLz = parcelRequire("iHpLz");
"use client";
var $8706d1a9dc6dd1e8$export$2e2bcd8739ae039 = (0, $8Q9JX.default)(/*#__PURE__*/ (0, $iHpLz.jsx)("path", {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), 'Home');



var $7Uawk = parcelRequire("7Uawk");

var $8Q9JX = parcelRequire("8Q9JX");

var $iHpLz = parcelRequire("iHpLz");
"use client";
var $9358485207721352$export$2e2bcd8739ae039 = (0, $8Q9JX.default)(/*#__PURE__*/ (0, $iHpLz.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20"
}), 'AccountCircle');



var $8Q9JX = parcelRequire("8Q9JX");

var $iHpLz = parcelRequire("iHpLz");
"use client";
var $d5570da5b6ef65fa$export$2e2bcd8739ae039 = (0, $8Q9JX.default)(/*#__PURE__*/ (0, $iHpLz.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), 'Settings');



var $7pnBU = parcelRequire("7pnBU");

var $8Q9JX = parcelRequire("8Q9JX");

var $iHpLz = parcelRequire("iHpLz");
"use client";
var $295e1b2034b4bdc0$export$2e2bcd8739ae039 = (0, $8Q9JX.default)(/*#__PURE__*/ (0, $iHpLz.jsx)("path", {
    d: "M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
}), 'ExitToApp');


const $1ab2729568d07d25$var$routesList = [
    {
        name: 'Home',
        icon: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $8706d1a9dc6dd1e8$export$2e2bcd8739ae039), {}),
        location: 'middle'
    },
    {
        name: 'Events',
        icon: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $7pnBU.default), {}),
        location: 'middle'
    },
    {
        name: 'Tickets',
        icon: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $7Uawk.default), {}),
        location: 'middle'
    },
    {
        name: 'Admin',
        icon: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $d5570da5b6ef65fa$export$2e2bcd8739ae039), {}),
        location: 'right'
    },
    {
        name: 'Profile',
        icon: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $9358485207721352$export$2e2bcd8739ae039), {}),
        location: 'right'
    },
    {
        name: 'Login',
        icon: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $295e1b2034b4bdc0$export$2e2bcd8739ae039), {}),
        location: 'right'
    },
    {
        name: 'Logout',
        icon: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $295e1b2034b4bdc0$export$2e2bcd8739ae039), {}),
        location: 'right'
    }
];
var $1ab2729568d07d25$export$2e2bcd8739ae039 = $1ab2729568d07d25$var$routesList;



var $ljlev = parcelRequire("ljlev");
const $44a745b3450b1a79$var$ADMIN_ROUTES = [
    'Home',
    'Events',
    'Tickets',
    'Profile',
    'Logout',
    'Admin'
];
const $44a745b3450b1a79$var$STUDENT_ROUTES = [
    'Home',
    'Events',
    'Tickets',
    'Profile',
    'Logout'
];
const $44a745b3450b1a79$var$NO_PROJECT_ROUTES = [
    'Logout'
];
const $44a745b3450b1a79$var$EMPTY_ROUTES = [
    'Login'
];
const $44a745b3450b1a79$var$useAccessRoutes = ()=>{
    var _inProject_data;
    const location = (0, $aw1H1.useLocation)();
    const projectId = (0, $8oEKT.default)();
    const loggedIn = (0, $a9d02e0c14f9ebae$export$2e2bcd8739ae039)();
    const authSession = (0, $ljlev.default)();
    const inProject = (0, $ddi3l.useQuery)((0, $ir54T.userInProject)({
        projectId: projectId,
        loggedIn: loggedIn
    }));
    const [availableRoutes, setAvailableRoutes] = (0, $7hhBq.useState)([]);
    const [page, setPage] = (0, $7hhBq.useState)('');
    (0, $7hhBq.useEffect)(()=>{
        try {
            setPage(location.pathname.split('/')[2].toLocaleLowerCase());
        } catch (e) {
            setPage('');
        }
    }, [
        location.pathname
    ]);
    (0, $7hhBq.useEffect)(()=>{
        const getRoutes = ()=>{
            var _inProject_data;
            if (!authSession.isActive) return $44a745b3450b1a79$var$EMPTY_ROUTES;
            if (!((_inProject_data = inProject.data) === null || _inProject_data === void 0 ? void 0 : _inProject_data.isSigned)) return $44a745b3450b1a79$var$NO_PROJECT_ROUTES;
            if (authSession.sessionData.projectRole < 6) return $44a745b3450b1a79$var$ADMIN_ROUTES;
            return $44a745b3450b1a79$var$STUDENT_ROUTES;
        };
        setAvailableRoutes((0, $1ab2729568d07d25$export$2e2bcd8739ae039).filter((x)=>{
            var _getRoutes;
            return (_getRoutes = getRoutes()) === null || _getRoutes === void 0 ? void 0 : _getRoutes.includes(x.name);
        }));
    }, [
        location.pathname,
        authSession.isActive,
        (_inProject_data = inProject.data) === null || _inProject_data === void 0 ? void 0 : _inProject_data.isSigned
    ]);
    return {
        availableRoutes: availableRoutes,
        page: page
    };
};
var $44a745b3450b1a79$export$2e2bcd8739ae039 = $44a745b3450b1a79$var$useAccessRoutes;



var $7hhBq = parcelRequire("7hhBq");
const $2631a44a280766fa$var$useDrawer = ()=>{
    const [open, setOpen] = (0, $7hhBq.useState)(false);
    const handleToggle = ()=>{
        setOpen(!open);
    };
    return {
        open: open,
        handleToggle: handleToggle
    };
};
var $2631a44a280766fa$export$2e2bcd8739ae039 = $2631a44a280766fa$var$useDrawer;



var $iHpLz = parcelRequire("iHpLz");
parcelRequire("7hhBq");

var $8Q9JX = parcelRequire("8Q9JX");

var $iHpLz = parcelRequire("iHpLz");
"use client";
var $f1bb14912a7e22bf$export$2e2bcd8739ae039 = (0, $8Q9JX.default)(/*#__PURE__*/ (0, $iHpLz.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');



var $iHpLz = parcelRequire("iHpLz");

var $9jigW = parcelRequire("9jigW");
var $18TeW = parcelRequire("18TeW");
parcelRequire("7hhBq");
const $21515aab11245d0a$var$CustomButton = (0, $18TeW.default)((0, $9jigW.default), {
    shouldForwardProp: (prop)=>prop !== 'active'
})(({ theme: theme, active: active })=>({
        color: theme.palette.surface.main,
        borderRadius: 0,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        paddingTop: 0,
        paddingBottom: 0,
        backgroundColor: active ? `${theme.palette.background.main}${theme.palette.overlay.opacity.activated}` : undefined,
        '&:hover': {
            backgroundColor: `${theme.palette.background.main}${theme.palette.overlay.opacity.hover}`
        }
    }));
const $21515aab11245d0a$var$MenuButton = ({ page: page, name: name, children: children, onClick: onClick })=>{
    const isActive = ()=>{
        return page.toLocaleLowerCase() === name.toLocaleLowerCase();
    };
    return /*#__PURE__*/ (0, $iHpLz.jsx)($21515aab11245d0a$var$CustomButton, {
        active: isActive(),
        disableRipple: true,
        disableElevation: true,
        onClick: onClick,
        children: children
    });
};
var $21515aab11245d0a$export$2e2bcd8739ae039 = $21515aab11245d0a$var$MenuButton;


const $fb30d7c947dd6f5f$var$BurgerButton = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $21515aab11245d0a$export$2e2bcd8739ae039), {
        page: "oaisndoiansdoiansdoiansdoidan",
        onClick: onClick,
        name: "",
        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $f1bb14912a7e22bf$export$2e2bcd8739ae039), {
            style: {
                width: '24px'
            }
        })
    });
};
var $fb30d7c947dd6f5f$export$2e2bcd8739ae039 = $fb30d7c947dd6f5f$var$BurgerButton;



var $iHpLz = parcelRequire("iHpLz");
parcelRequire("7hhBq");


var $5cFwf = parcelRequire("5cFwf");

var $dQSvw = parcelRequire("dQSvw");
const $5c8f74021ea3f325$var$LogoButton = ({ page: page, onClick: onClick })=>{
    const imageUrl = (0, $5cFwf.default)('NAVBAR_LOGO', (0, (/*@__PURE__*/$parcel$interopDefault($dQSvw))));
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $21515aab11245d0a$export$2e2bcd8739ae039), {
        page: page,
        onClick: onClick,
        name: "",
        children: /*#__PURE__*/ (0, $iHpLz.jsx)("img", {
            src: imageUrl,
            alt: "ths-logo",
            style: {
                width: '48px',
                height: '48px'
            }
        })
    });
};
var $5c8f74021ea3f325$export$2e2bcd8739ae039 = $5c8f74021ea3f325$var$LogoButton;



var $iHpLz = parcelRequire("iHpLz");

var $b5Oyq = parcelRequire("b5Oyq");
parcelRequire("7hhBq");

var $h3hKu = parcelRequire("h3hKu");

const $901db9a776ac3496$var$TextButton = ({ label: label, page: page, onClick: onClick })=>{
    const theme = (0, $h3hKu.default)();
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $21515aab11245d0a$export$2e2bcd8739ae039), {
        page: page,
        onClick: onClick,
        name: label,
        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $b5Oyq.default), {
            variant: "h6",
            color: theme.palette.primary.contrastText,
            children: label
        })
    });
};
var $901db9a776ac3496$export$2e2bcd8739ae039 = $901db9a776ac3496$var$TextButton;



var $iHpLz = parcelRequire("iHpLz");

var $b5Oyq = parcelRequire("b5Oyq");

var $7hhBq = parcelRequire("7hhBq");
const $7cbdcd367eba8bbd$var$routesList = [
    {
        url: 'createaccount',
        name: 'Register'
    },
    {
        url: 'about',
        name: 'About'
    },
    {
        url: 'forgot',
        name: 'Forgot password'
    },
    {
        url: 'reset',
        name: 'Forgot password'
    },
    {
        url: 'sentforgot',
        name: 'Forgot password'
    },
    {
        url: 'projectinfo',
        name: 'Project rules'
    },
    {
        url: '',
        name: 'Home'
    }
];
const $7cbdcd367eba8bbd$var$MobileLocation = ({ location: location, routes: routes })=>{
    const [displayText, setDisplayText] = (0, (/*@__PURE__*/$parcel$interopDefault($7hhBq))).useState('');
    const setCurrentlocation = ()=>{
        let set = false;
        routes.forEach((route)=>{
            if (route.name.toLowerCase() === location.toLowerCase()) {
                // passed routes
                set = true;
                setDisplayText(route.name);
            }
        });
        if (!set) $7cbdcd367eba8bbd$var$routesList.forEach((route)=>{
            if (set) return;
            if (location.toLowerCase().includes(route.url)) {
                set = true;
                setDisplayText(route.name);
            }
        });
        if (!set) // if nothing is found
        setDisplayText('');
    };
    (0, $7hhBq.useEffect)(()=>{
        setCurrentlocation();
    }, [
        location,
        routes
    ]);
    return /*#__PURE__*/ (0, $iHpLz.jsx)("div", {
        style: {
            height: '100%',
            display: 'flex',
            alignItems: 'center'
        },
        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $b5Oyq.default), {
            variant: "h6",
            style: {
                color: 'white',
                marginLeft: '0.5rem',
                fontWeight: 400
            },
            children: displayText
        })
    });
};
var $7cbdcd367eba8bbd$export$2e2bcd8739ae039 = $7cbdcd367eba8bbd$var$MobileLocation;



var $iHpLz = parcelRequire("iHpLz");

var $18TeW = parcelRequire("18TeW");
parcelRequire("7hhBq");
const $992b0453aa704fee$var$Root = (0, $18TeW.default)('section')(({ theme: theme })=>({
        width: '100%',
        height: '64px',
        padding: '0 24px',
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.primary.main,
        [theme.breakpoints.down('md')]: {
            height: '56px',
            padding: '0'
        }
    }));
const $992b0453aa704fee$var$NavContainer = ({ left: left, right: right })=>{
    return /*#__PURE__*/ (0, $iHpLz.jsxs)($992b0453aa704fee$var$Root, {
        children: [
            /*#__PURE__*/ (0, $iHpLz.jsx)("div", {
                style: {
                    display: 'flex'
                },
                children: left
            }),
            /*#__PURE__*/ (0, $iHpLz.jsx)("div", {
                style: {
                    display: 'flex'
                },
                children: right
            })
        ]
    });
};
var $992b0453aa704fee$export$2e2bcd8739ae039 = $992b0453aa704fee$var$NavContainer;



var $iHpLz = parcelRequire("iHpLz");

var $1fpj1 = parcelRequire("1fpj1");
var $18TeW = parcelRequire("18TeW");
var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");

var $4unLw = parcelRequire("4unLw");



var $7hhBq = parcelRequire("7hhBq");


var $bWfnw = parcelRequire("bWfnw");
'use client';
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 *
 * * Escape hatch for broken dependencies not supporting SSR.
 * * Improve the time-to-first paint on the client by only rendering above the fold.
 * * Reduce the rendering time on the server.
 * * Under too heavy server load, you can turn on service degradation.
 *
 * Demos:
 *
 * - [No SSR](https://v6.mui.com/material-ui/react-no-ssr/)
 *
 * API:
 *
 * - [NoSsr API](https://v6.mui.com/material-ui/api/no-ssr/)
 */ function $5184a072bfc7080a$var$NoSsr(props) {
    const { children: children, defer: defer = false, fallback: fallback = null } = props;
    const [mountedState, setMountedState] = $7hhBq.useState(false);
    (0, $bWfnw.default)(()=>{
        if (!defer) setMountedState(true);
    }, [
        defer
    ]);
    $7hhBq.useEffect(()=>{
        if (defer) setMountedState(true);
    }, [
        defer
    ]);
    // TODO casting won't be needed at one point https://github.com/DefinitelyTyped/DefinitelyTyped/pull/65135
    return mountedState ? children : fallback;
}
var $5184a072bfc7080a$export$2e2bcd8739ae039 = $5184a072bfc7080a$var$NoSsr;



var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");


var $eET99 = parcelRequire("eET99");

var $6PpZS = parcelRequire("6PpZS");

var $2ZRHk = parcelRequire("2ZRHk");

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $2v7gK = parcelRequire("2v7gK");




var $8aEjg = parcelRequire("8aEjg");

var $f1VUu = parcelRequire("f1VUu");

var $drmCR = parcelRequire("drmCR");

var $eGBcx = parcelRequire("eGBcx");

var $5Chn3 = parcelRequire("5Chn3");

var $d0gXo = parcelRequire("d0gXo");

var $iHpLz = parcelRequire("iHpLz");
'use client';
function $a8da55ae5cbe386f$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $d0gXo.default)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $a8da55ae5cbe386f$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $a8da55ae5cbe386f$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $a8da55ae5cbe386f$var$resolveContainer(containerProp);
    const transform = $a8da55ae5cbe386f$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $a8da55ae5cbe386f$var$Slide = /*#__PURE__*/ $7hhBq.forwardRef(function Slide(props, ref) {
    const theme = (0, $eGBcx.default)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $2v7gK.default) } = props, other = (0, $6pkKu._)(props, [
        "addEndListener",
        "appear",
        "children",
        "container",
        "direction",
        "easing",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    const childrenRef = $7hhBq.useRef(null);
    const handleRef = (0, $drmCR.default)((0, $8aEjg.default)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $a8da55ae5cbe386f$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $5Chn3.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $5Chn3.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $dok7x._)({}, transitionProps));
        node.style.transition = theme.transitions.create('transform', (0, $dok7x._)({}, transitionProps));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $5Chn3.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $a8da55ae5cbe386f$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $7hhBq.useCallback(()=>{
        if (childrenRef.current) $a8da55ae5cbe386f$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $7hhBq.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $f1VUu.default)(()=>{
            if (childrenRef.current) $a8da55ae5cbe386f$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $d0gXo.default)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $7hhBq.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $iHpLz.jsx)(TransitionComponent, (0, $cNnl8._)((0, $dok7x._)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other), {
        children: (state, _param)=>{
            var { ownerState: ownerState } = _param, restChildProps = (0, $6pkKu._)(_param, [
                "ownerState"
            ]);
            return /*#__PURE__*/ $7hhBq.cloneElement(children, (0, $dok7x._)({
                ref: handleRef,
                style: (0, $dok7x._)({
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, style, children.props.style)
            }, restChildProps));
        }
    }));
});
var $a8da55ae5cbe386f$export$2e2bcd8739ae039 = $a8da55ae5cbe386f$var$Slide;



var $cbi7u = parcelRequire("cbi7u");

var $bUnnb = parcelRequire("bUnnb");

var $2fhVh = parcelRequire("2fhVh");

var $18TeW = parcelRequire("18TeW");
var $eGBcx = parcelRequire("eGBcx");

var $1zv4u = parcelRequire("1zv4u");

var $4ZZLe = parcelRequire("4ZZLe");

var $5blE7 = parcelRequire("5blE7");

var $200uu = parcelRequire("200uu");
function $c159a73b98befa7e$export$b801318a856c9cd2(slot) {
    return (0, $200uu.default)('MuiDrawer', slot);
}
const $c159a73b98befa7e$var$drawerClasses = (0, $5blE7.default)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'anchorLeft',
    'anchorRight',
    'anchorTop',
    'anchorBottom',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $c159a73b98befa7e$export$2e2bcd8739ae039 = $c159a73b98befa7e$var$drawerClasses;



var $bVaPR = parcelRequire("bVaPR");

var $lnlFY = parcelRequire("lnlFY");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $9c15fd65c0cb6af3$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $9c15fd65c0cb6af3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `anchor${(0, $bUnnb.default)(anchor)}`
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $bUnnb.default)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $bUnnb.default)(anchor)}`
        ]
    };
    return (0, $eET99.default)(slots, (0, $c159a73b98befa7e$export$b801318a856c9cd2), classes);
};
const $9c15fd65c0cb6af3$var$DrawerRoot = (0, $18TeW.default)((0, $2ZRHk.default), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $9c15fd65c0cb6af3$var$overridesResolver
})((0, $1zv4u.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    })));
const $9c15fd65c0cb6af3$var$DrawerDockedRoot = (0, $18TeW.default)('div', {
    shouldForwardProp: (0, $2fhVh.default),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $9c15fd65c0cb6af3$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $9c15fd65c0cb6af3$var$DrawerPaper = (0, $18TeW.default)((0, $cbi7u.default), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $bUnnb.default)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $bUnnb.default)(ownerState.anchor)}`]
        ];
    }
})((0, $1zv4u.default)(({ theme: theme })=>({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    left: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    left: 0,
                    bottom: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'left' && ownerState.variant !== 'temporary',
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'top' && ownerState.variant !== 'temporary',
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'right' && ownerState.variant !== 'temporary',
                style: {
                    borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary',
                style: {
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            }
        ]
    })));
const $9c15fd65c0cb6af3$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $9c15fd65c0cb6af3$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].includes(anchor);
}
function $9c15fd65c0cb6af3$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === 'rtl' && $9c15fd65c0cb6af3$export$2a62b49acb270576(anchor) ? $9c15fd65c0cb6af3$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $9c15fd65c0cb6af3$var$Drawer = /*#__PURE__*/ $7hhBq.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $eGBcx.default)();
    const isRtl = (0, $6PpZS.useRtl)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent, transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary', slots: slots = {}, slotProps: slotProps = {} } = props, ModalProps = (0, $6pkKu._)(props.ModalProps, [
        "BackdropProps"
    ]), other = (0, $6pkKu._)(props, [
        "anchor",
        "BackdropProps",
        "children",
        "className",
        "elevation",
        "hideBackdrop",
        "ModalProps",
        "onClose",
        "open",
        "PaperProps",
        "SlideProps",
        "TransitionComponent",
        "transitionDuration",
        "variant",
        "slots",
        "slotProps"
    ]);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $7hhBq.useRef(false);
    $7hhBq.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $9c15fd65c0cb6af3$export$830f4f08342d299e({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $dok7x._)((0, $cNnl8._)((0, $dok7x._)({}, props), {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }), other);
    const classes = $9c15fd65c0cb6af3$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $dok7x._)({
            transition: TransitionComponent
        }, slots),
        slotProps: (0, $cNnl8._)((0, $dok7x._)({
            paper: PaperProps,
            transition: SlideProps
        }, slotProps), {
            backdrop: (0, $lnlFY.default)(slotProps.backdrop || (0, $dok7x._)({}, BackdropProps, BackdropPropsProp), {
                transitionDuration: transitionDuration
            })
        })
    };
    const [RootSlot, rootSlotProps] = (0, $bVaPR.default)('root', {
        ref: ref,
        elementType: $9c15fd65c0cb6af3$var$DrawerRoot,
        className: (0, $5vmbh.default)(classes.root, classes.modal, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: (0, $dok7x._)({}, externalForwardedProps, other, ModalProps),
        additionalProps: {
            open: open,
            onClose: onClose,
            hideBackdrop: hideBackdrop,
            slots: {
                backdrop: externalForwardedProps.slots.backdrop
            },
            slotProps: {
                backdrop: externalForwardedProps.slotProps.backdrop
            }
        }
    });
    const [PaperSlot, paperSlotProps] = (0, $bVaPR.default)('paper', {
        elementType: $9c15fd65c0cb6af3$var$DrawerPaper,
        shouldForwardComponentProp: true,
        className: (0, $5vmbh.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            elevation: variant === 'temporary' ? elevation : 0,
            square: true
        }
    });
    const [DockedSlot, dockedSlotProps] = (0, $bVaPR.default)('docked', {
        elementType: $9c15fd65c0cb6af3$var$DrawerDockedRoot,
        ref: ref,
        className: (0, $5vmbh.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: other // pass `other` here because `DockedSlot` is also a root slot for some variants
    });
    const [TransitionSlot, transitionSlotProps] = (0, $bVaPR.default)('transition', {
        elementType: (0, $a8da55ae5cbe386f$export$2e2bcd8739ae039),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            in: open,
            direction: $9c15fd65c0cb6af3$var$oppositeDirection[anchorInvariant],
            timeout: transitionDuration,
            appear: mounted.current
        }
    });
    const drawer = /*#__PURE__*/ (0, $iHpLz.jsx)(PaperSlot, (0, $cNnl8._)((0, $dok7x._)({}, paperSlotProps), {
        children: children
    }));
    if (variant === 'permanent') return /*#__PURE__*/ (0, $iHpLz.jsx)(DockedSlot, (0, $cNnl8._)((0, $dok7x._)({}, dockedSlotProps), {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $iHpLz.jsx)(TransitionSlot, (0, $cNnl8._)((0, $dok7x._)({}, transitionSlotProps), {
        children: drawer
    }));
    if (variant === 'persistent') return /*#__PURE__*/ (0, $iHpLz.jsx)(DockedSlot, (0, $cNnl8._)((0, $dok7x._)({}, dockedSlotProps), {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $iHpLz.jsx)(RootSlot, (0, $cNnl8._)((0, $dok7x._)({}, rootSlotProps), {
        children: slidingDrawer
    }));
});
var $9c15fd65c0cb6af3$export$2e2bcd8739ae039 = $9c15fd65c0cb6af3$var$Drawer;



var $drmCR = parcelRequire("drmCR");

var $h0qGp = parcelRequire("h0qGp");

var $d0gXo = parcelRequire("d0gXo");

var $60H1a = parcelRequire("60H1a");

var $fUkkz = parcelRequire("fUkkz");

var $eGBcx = parcelRequire("eGBcx");

var $4ZZLe = parcelRequire("4ZZLe");

var $5Chn3 = parcelRequire("5Chn3");

var $lnlFY = parcelRequire("lnlFY");

var $bVaPR = parcelRequire("bVaPR");

var $dok7x = parcelRequire("dok7x");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");

var $18TeW = parcelRequire("18TeW");

var $1zv4u = parcelRequire("1zv4u");

var $2fhVh = parcelRequire("2fhVh");

var $bUnnb = parcelRequire("bUnnb");


var $iHpLz = parcelRequire("iHpLz");
'use client';
const $c90bfcc326c760bf$var$SwipeAreaRoot = (0, $18TeW.default)('div', {
    name: 'MuiSwipeArea',
    shouldForwardProp: (0, $2fhVh.default)
})((0, $1zv4u.default)(({ theme: theme })=>({
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: theme.zIndex.drawer - 1,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    right: 'auto'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    bottom: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    bottom: 0,
                    right: 0
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ const $c90bfcc326c760bf$var$SwipeArea = /*#__PURE__*/ $7hhBq.forwardRef(function SwipeArea(props, ref) {
    const { anchor: anchor, classes: classes = {}, className: className, width: width, style: style } = props, other = (0, $6pkKu._)(props, [
        "anchor",
        "classes",
        "className",
        "width",
        "style"
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $iHpLz.jsx)($c90bfcc326c760bf$var$SwipeAreaRoot, (0, $dok7x._)({
        className: (0, $5vmbh.default)('PrivateSwipeArea-root', classes.root, classes[`anchor${(0, $bUnnb.default)(anchor)}`], className),
        ref: ref,
        style: (0, $dok7x._)({
            [(0, $9c15fd65c0cb6af3$export$2a62b49acb270576)(anchor) ? 'width' : 'height']: width
        }, style),
        ownerState: ownerState
    }, other));
});
var $c90bfcc326c760bf$export$2e2bcd8739ae039 = $c90bfcc326c760bf$var$SwipeArea;



var $iHpLz = parcelRequire("iHpLz");
'use client';
const $510652765a980631$var$UNCERTAINTY_THRESHOLD = 3; // px
// This is the part of the drawer displayed on touch start.
const $510652765a980631$var$DRAG_STARTED_SIGNAL = 20; // px
// We can only have one instance at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.
let $510652765a980631$var$claimedSwipeInstance = null;
function $510652765a980631$export$aad8462122ac592b() {
    $510652765a980631$var$claimedSwipeInstance = null;
}
function $510652765a980631$var$calculateCurrentX(anchor, touches, doc) {
    return anchor === 'right' ? doc.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}
function $510652765a980631$var$calculateCurrentY(anchor, touches, containerWindow) {
    return anchor === 'bottom' ? containerWindow.innerHeight - touches[0].clientY : touches[0].clientY;
}
function $510652765a980631$var$getMaxTranslate(horizontalSwipe, paperInstance) {
    return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}
function $510652765a980631$var$getTranslate(currentTranslate, startLocation, open, maxTranslate) {
    return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}
/**
 * @param {Element | null} element
 * @param {Element} rootNode
 */ function $510652765a980631$var$getDomTreeShapes(element, rootNode) {
    // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
    const domTreeShapes = [];
    while(element && element !== rootNode.parentElement){
        const style = (0, $d0gXo.default)(rootNode).getComputedStyle(element);
        if (// Ignore the scroll children if the element is absolute positioned.
        style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
        style.getPropertyValue('overflow-x') === 'hidden') ;
        else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) // Ignore the nodes that have no width.
        // Keep elements with a scroll
        domTreeShapes.push(element);
        element = element.parentElement;
    }
    return domTreeShapes;
}
/**
 * @param {object} param0
 * @param {ReturnType<getDomTreeShapes>} param0.domTreeShapes
 */ function $510652765a980631$var$computeHasNativeHandler({ domTreeShapes: domTreeShapes, start: start, current: current, anchor: anchor }) {
    // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
    const axisProperties = {
        scrollPosition: {
            x: 'scrollLeft',
            y: 'scrollTop'
        },
        scrollLength: {
            x: 'scrollWidth',
            y: 'scrollHeight'
        },
        clientLength: {
            x: 'clientWidth',
            y: 'clientHeight'
        }
    };
    return domTreeShapes.some((shape)=>{
        // Determine if we are going backward or forward.
        let goingForward = current >= start;
        if (anchor === 'top' || anchor === 'left') goingForward = !goingForward;
        const axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
        const scrollPosition = Math.round(shape[axisProperties.scrollPosition[axis]]);
        const areNotAtStart = scrollPosition > 0;
        const areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
        if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) return true;
        return false;
    });
}
const $510652765a980631$var$iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
const $510652765a980631$var$SwipeableDrawer = /*#__PURE__*/ $7hhBq.forwardRef(function SwipeableDrawer(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        name: 'MuiSwipeableDrawer',
        props: inProps
    });
    const theme = (0, $eGBcx.default)();
    const transitionDurationDefault = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchor = 'left', disableBackdropTransition: disableBackdropTransition = false, disableDiscovery: disableDiscovery = false, disableSwipeToOpen: disableSwipeToOpen = $510652765a980631$var$iOS, hideBackdrop: hideBackdrop, hysteresis: hysteresis = 0.52, allowSwipeInChildren: allowSwipeInChildren = false, minFlingVelocity: minFlingVelocity = 450, ModalProps: { BackdropProps: BackdropProps } = {}, onClose: onClose, onOpen: onOpen, open: open = false, PaperProps: PaperProps = {}, SwipeAreaProps: SwipeAreaProps, swipeAreaWidth: swipeAreaWidth = 20, transitionDuration: transitionDuration = transitionDurationDefault, variant: variant = 'temporary', slots: // Mobile first.
    slots = {}, slotProps: slotProps = {} } = props, ModalPropsProp = (0, $6pkKu._)(props.ModalProps, [
        "BackdropProps"
    ]), other = (0, $6pkKu._)(props, [
        "anchor",
        "disableBackdropTransition",
        "disableDiscovery",
        "disableSwipeToOpen",
        "hideBackdrop",
        "hysteresis",
        "allowSwipeInChildren",
        "minFlingVelocity",
        "ModalProps",
        "onClose",
        "onOpen",
        "open",
        "PaperProps",
        "SwipeAreaProps",
        "swipeAreaWidth",
        "transitionDuration",
        "variant",
        "slots",
        "slotProps"
    ]);
    const [maybeSwiping, setMaybeSwiping] = $7hhBq.useState(false);
    const swipeInstance = $7hhBq.useRef({
        isSwiping: null
    });
    const swipeAreaRef = $7hhBq.useRef();
    const backdropRef = $7hhBq.useRef();
    const paperRef = $7hhBq.useRef();
    const handleRef = (0, $drmCR.default)(PaperProps.ref, paperRef);
    const touchDetected = $7hhBq.useRef(false);
    // Ref for transition duration based on / to match swipe speed
    const calculatedDurationRef = $7hhBq.useRef();
    // Use a ref so the open value used is always up to date inside useCallback.
    (0, $fUkkz.default)(()=>{
        calculatedDurationRef.current = null;
    }, [
        open
    ]);
    const setPosition = $7hhBq.useCallback((translate, options = {})=>{
        const { mode: mode = null, changeTransition: changeTransition = true } = options;
        const anchorRtl = (0, $9c15fd65c0cb6af3$export$830f4f08342d299e)(theme, anchor);
        const rtlTranslateMultiplier = [
            'right',
            'bottom'
        ].includes(anchorRtl) ? 1 : -1;
        const horizontalSwipe = (0, $9c15fd65c0cb6af3$export$2a62b49acb270576)(anchor);
        const transform = horizontalSwipe ? `translate(${rtlTranslateMultiplier * translate}px, 0)` : `translate(0, ${rtlTranslateMultiplier * translate}px)`;
        const drawerStyle = paperRef.current.style;
        drawerStyle.webkitTransform = transform;
        drawerStyle.transform = transform;
        let transition = '';
        if (mode) transition = theme.transitions.create('all', (0, $5Chn3.getTransitionProps)({
            easing: undefined,
            style: undefined,
            timeout: transitionDuration
        }, {
            mode: mode
        }));
        if (changeTransition) {
            drawerStyle.webkitTransition = transition;
            drawerStyle.transition = transition;
        }
        if (!disableBackdropTransition && !hideBackdrop) {
            const backdropStyle = backdropRef.current.style;
            backdropStyle.opacity = 1 - translate / $510652765a980631$var$getMaxTranslate(horizontalSwipe, paperRef.current);
            if (changeTransition) {
                backdropStyle.webkitTransition = transition;
                backdropStyle.transition = transition;
            }
        }
    }, [
        anchor,
        disableBackdropTransition,
        hideBackdrop,
        theme,
        transitionDuration
    ]);
    const handleBodyTouchEnd = (0, $60H1a.default)((nativeEvent)=>{
        if (!touchDetected.current) return;
        // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- claimedSwipeInstance is a singleton
        $510652765a980631$var$claimedSwipeInstance = null;
        touchDetected.current = false;
        $4unLw.flushSync(()=>{
            setMaybeSwiping(false);
        });
        // The swipe wasn't started.
        if (!swipeInstance.current.isSwiping) {
            swipeInstance.current.isSwiping = null;
            return;
        }
        swipeInstance.current.isSwiping = null;
        const anchorRtl = (0, $9c15fd65c0cb6af3$export$830f4f08342d299e)(theme, anchor);
        const horizontal = (0, $9c15fd65c0cb6af3$export$2a62b49acb270576)(anchor);
        let current;
        if (horizontal) current = $510652765a980631$var$calculateCurrentX(anchorRtl, nativeEvent.changedTouches, (0, $h0qGp.default)(nativeEvent.currentTarget));
        else current = $510652765a980631$var$calculateCurrentY(anchorRtl, nativeEvent.changedTouches, (0, $d0gXo.default)(nativeEvent.currentTarget));
        const startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
        const maxTranslate = $510652765a980631$var$getMaxTranslate(horizontal, paperRef.current);
        const currentTranslate = $510652765a980631$var$getTranslate(current, startLocation, open, maxTranslate);
        const translateRatio = currentTranslate / maxTranslate;
        if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) // Calculate transition duration to match swipe speed
        calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
        if (open) {
            if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) onClose();
            else // Reset the position, the swipe was aborted.
            setPosition(0, {
                mode: 'exit'
            });
            return;
        }
        if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) onOpen();
        else // Reset the position, the swipe was aborted.
        setPosition($510652765a980631$var$getMaxTranslate(horizontal, paperRef.current), {
            mode: 'enter'
        });
    });
    const startMaybeSwiping = (force = false)=>{
        if (!maybeSwiping) {
            // on Safari Mobile, if you want to be able to have the 'click' event fired on child elements, nothing in the DOM can be changed.
            // this is because Safari Mobile will not fire any mouse events (still fires touch though) if the DOM changes during mousemove.
            // so do this change on first touchmove instead of touchstart
            if (force || !(disableDiscovery && allowSwipeInChildren)) $4unLw.flushSync(()=>{
                setMaybeSwiping(true);
            });
            const horizontalSwipe = (0, $9c15fd65c0cb6af3$export$2a62b49acb270576)(anchor);
            if (!open && paperRef.current) // The ref may be null when a parent component updates while swiping.
            setPosition($510652765a980631$var$getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 15 : -$510652765a980631$var$DRAG_STARTED_SIGNAL), {
                changeTransition: false
            });
            swipeInstance.current.velocity = 0;
            swipeInstance.current.lastTime = null;
            swipeInstance.current.lastTranslate = null;
            swipeInstance.current.paperHit = false;
            touchDetected.current = true;
        }
    };
    const handleBodyTouchMove = (0, $60H1a.default)((nativeEvent)=>{
        // the ref may be null when a parent component updates while swiping
        if (!paperRef.current || !touchDetected.current) return;
        // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer
        if ($510652765a980631$var$claimedSwipeInstance !== null && $510652765a980631$var$claimedSwipeInstance !== swipeInstance.current) return;
        startMaybeSwiping(true);
        const anchorRtl = (0, $9c15fd65c0cb6af3$export$830f4f08342d299e)(theme, anchor);
        const horizontalSwipe = (0, $9c15fd65c0cb6af3$export$2a62b49acb270576)(anchor);
        const currentX = $510652765a980631$var$calculateCurrentX(anchorRtl, nativeEvent.touches, (0, $h0qGp.default)(nativeEvent.currentTarget));
        const currentY = $510652765a980631$var$calculateCurrentY(anchorRtl, nativeEvent.touches, (0, $d0gXo.default)(nativeEvent.currentTarget));
        if (open && paperRef.current.contains(nativeEvent.target) && $510652765a980631$var$claimedSwipeInstance === null) {
            const domTreeShapes = $510652765a980631$var$getDomTreeShapes(nativeEvent.target, paperRef.current);
            const hasNativeHandler = $510652765a980631$var$computeHasNativeHandler({
                domTreeShapes: domTreeShapes,
                start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
                current: horizontalSwipe ? currentX : currentY,
                anchor: anchor
            });
            if (hasNativeHandler) {
                $510652765a980631$var$claimedSwipeInstance = true;
                return;
            }
            $510652765a980631$var$claimedSwipeInstance = swipeInstance.current;
        }
        // We don't know yet.
        if (swipeInstance.current.isSwiping == null) {
            const dx = Math.abs(currentX - swipeInstance.current.startX);
            const dy = Math.abs(currentY - swipeInstance.current.startY);
            const definitelySwiping = horizontalSwipe ? dx > dy && dx > $510652765a980631$var$UNCERTAINTY_THRESHOLD : dy > dx && dy > $510652765a980631$var$UNCERTAINTY_THRESHOLD;
            if (definitelySwiping && nativeEvent.cancelable) nativeEvent.preventDefault();
            if (definitelySwiping === true || (horizontalSwipe ? dy > $510652765a980631$var$UNCERTAINTY_THRESHOLD : dx > $510652765a980631$var$UNCERTAINTY_THRESHOLD)) {
                swipeInstance.current.isSwiping = definitelySwiping;
                if (!definitelySwiping) {
                    handleBodyTouchEnd(nativeEvent);
                    return;
                }
                // Shift the starting point.
                swipeInstance.current.startX = currentX;
                swipeInstance.current.startY = currentY;
                // Compensate for the part of the drawer displayed on touch start.
                if (!disableDiscovery && !open) {
                    if (horizontalSwipe) swipeInstance.current.startX -= $510652765a980631$var$DRAG_STARTED_SIGNAL;
                    else swipeInstance.current.startY -= $510652765a980631$var$DRAG_STARTED_SIGNAL;
                }
            }
        }
        if (!swipeInstance.current.isSwiping) return;
        const maxTranslate = $510652765a980631$var$getMaxTranslate(horizontalSwipe, paperRef.current);
        let startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
        if (open && !swipeInstance.current.paperHit) startLocation = Math.min(startLocation, maxTranslate);
        const translate = $510652765a980631$var$getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);
        if (open) {
            if (!swipeInstance.current.paperHit) {
                const paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;
                if (paperHit) {
                    swipeInstance.current.paperHit = true;
                    swipeInstance.current.startX = currentX;
                    swipeInstance.current.startY = currentY;
                } else return;
            } else if (translate === 0) {
                swipeInstance.current.startX = currentX;
                swipeInstance.current.startY = currentY;
            }
        }
        if (swipeInstance.current.lastTranslate === null) {
            swipeInstance.current.lastTranslate = translate;
            swipeInstance.current.lastTime = performance.now() + 1;
        }
        const velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3;
        // Low Pass filter.
        swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
        swipeInstance.current.lastTranslate = translate;
        swipeInstance.current.lastTime = performance.now();
        // We are swiping, let's prevent the scroll event on iOS.
        if (nativeEvent.cancelable) nativeEvent.preventDefault();
        setPosition(translate);
    });
    const handleBodyTouchStart = (0, $60H1a.default)((nativeEvent)=>{
        // We are not supposed to handle this touch move.
        // Example of use case: ignore the event if there is a Slider.
        if (nativeEvent.defaultPrevented) return;
        // We can only have one node at the time claiming ownership for handling the swipe.
        if (nativeEvent.defaultMuiPrevented) return;
        // At least one element clogs the drawer interaction zone.
        if (open && (hideBackdrop || !backdropRef.current.contains(nativeEvent.target)) && !paperRef.current.contains(nativeEvent.target)) return;
        const anchorRtl = (0, $9c15fd65c0cb6af3$export$830f4f08342d299e)(theme, anchor);
        const horizontalSwipe = (0, $9c15fd65c0cb6af3$export$2a62b49acb270576)(anchor);
        const currentX = $510652765a980631$var$calculateCurrentX(anchorRtl, nativeEvent.touches, (0, $h0qGp.default)(nativeEvent.currentTarget));
        const currentY = $510652765a980631$var$calculateCurrentY(anchorRtl, nativeEvent.touches, (0, $d0gXo.default)(nativeEvent.currentTarget));
        if (!open) {
            var _paperRef_current;
            // logic for if swipe should be ignored:
            // if disableSwipeToOpen
            // if target != swipeArea, and target is not a child of paper ref
            // if is a child of paper ref, and `allowSwipeInChildren` does not allow it
            if (disableSwipeToOpen || !(nativeEvent.target === swipeAreaRef.current || ((_paperRef_current = paperRef.current) === null || _paperRef_current === void 0 ? void 0 : _paperRef_current.contains(nativeEvent.target)) && (typeof allowSwipeInChildren === 'function' ? allowSwipeInChildren(nativeEvent, swipeAreaRef.current, paperRef.current) : allowSwipeInChildren))) return;
            if (horizontalSwipe) {
                if (currentX > swipeAreaWidth) return;
            } else if (currentY > swipeAreaWidth) return;
        }
        nativeEvent.defaultMuiPrevented = true;
        $510652765a980631$var$claimedSwipeInstance = null;
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
        startMaybeSwiping();
    });
    $7hhBq.useEffect(()=>{
        if (variant === 'temporary') {
            const doc = (0, $h0qGp.default)(paperRef.current);
            doc.addEventListener('touchstart', handleBodyTouchStart);
            // A blocking listener prevents Firefox's navbar to auto-hide on scroll.
            // It only needs to prevent scrolling on the drawer's content when open.
            // When closed, the overlay prevents scrolling.
            doc.addEventListener('touchmove', handleBodyTouchMove, {
                passive: !open
            });
            doc.addEventListener('touchend', handleBodyTouchEnd);
            return ()=>{
                doc.removeEventListener('touchstart', handleBodyTouchStart);
                doc.removeEventListener('touchmove', handleBodyTouchMove, {
                    passive: !open
                });
                doc.removeEventListener('touchend', handleBodyTouchEnd);
            };
        }
        return undefined;
    }, [
        variant,
        open,
        handleBodyTouchStart,
        handleBodyTouchMove,
        handleBodyTouchEnd
    ]);
    $7hhBq.useEffect(()=>()=>{
            // We need to release the lock.
            if ($510652765a980631$var$claimedSwipeInstance === swipeInstance.current) $510652765a980631$var$claimedSwipeInstance = null;
        }, []);
    $7hhBq.useEffect(()=>{
        if (!open) setMaybeSwiping(false);
    }, [
        open
    ]);
    const [SwipeAreaSlot, swipeAreaSlotProps] = (0, $bVaPR.default)('swipeArea', {
        ref: swipeAreaRef,
        elementType: (0, $c90bfcc326c760bf$export$2e2bcd8739ae039),
        ownerState: props,
        externalForwardedProps: {
            slots: slots,
            slotProps: (0, $dok7x._)({
                swipeArea: SwipeAreaProps
            }, slotProps)
        },
        additionalProps: {
            width: swipeAreaWidth,
            anchor: anchor
        }
    });
    var _slotProps_backdrop, _slotProps_paper;
    return /*#__PURE__*/ (0, $iHpLz.jsxs)($7hhBq.Fragment, {
        children: [
            /*#__PURE__*/ (0, $iHpLz.jsx)((0, $9c15fd65c0cb6af3$export$2e2bcd8739ae039), (0, $dok7x._)({
                open: variant === 'temporary' && maybeSwiping ? true : open,
                variant: variant,
                ModalProps: (0, $dok7x._)({
                    BackdropProps: (0, $cNnl8._)((0, $dok7x._)({}, BackdropProps), {
                        ref: backdropRef
                    })
                }, variant === 'temporary' && {
                    keepMounted: true
                }, ModalPropsProp),
                hideBackdrop: hideBackdrop,
                anchor: anchor,
                transitionDuration: calculatedDurationRef.current || transitionDuration,
                onClose: onClose,
                ref: ref,
                slots: slots,
                slotProps: (0, $cNnl8._)((0, $dok7x._)({}, slotProps), {
                    backdrop: (0, $lnlFY.default)((_slotProps_backdrop = slotProps.backdrop) !== null && _slotProps_backdrop !== void 0 ? _slotProps_backdrop : BackdropProps, {
                        ref: backdropRef
                    }),
                    paper: (0, $lnlFY.default)((_slotProps_paper = slotProps.paper) !== null && _slotProps_paper !== void 0 ? _slotProps_paper : PaperProps, {
                        style: {
                            pointerEvents: variant === 'temporary' && !open && !allowSwipeInChildren ? 'none' : ''
                        },
                        ref: handleRef
                    })
                })
            }, other)),
            !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/ (0, $iHpLz.jsx)((0, $5184a072bfc7080a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iHpLz.jsx)(SwipeAreaSlot, (0, $dok7x._)({}, swipeAreaSlotProps))
            })
        ]
    });
});
var $510652765a980631$export$2e2bcd8739ae039 = $510652765a980631$var$SwipeableDrawer;


var $b5Oyq = parcelRequire("b5Oyq");
parcelRequire("7hhBq");

var $7Nk55 = parcelRequire("7Nk55");

var $5cFwf = parcelRequire("5cFwf");

var $c5JDL = parcelRequire("c5JDL");
const $adbd1649a448de68$var$Head = (0, $18TeW.default)('div')(({ theme: theme })=>({
        width: '224px',
        paddingTop: theme.spacing(8),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(6),
        paddingBottom: theme.spacing(4),
        borderBottom: `1px solid ${theme.palette.primary.main}${theme.palette.overlay.opacity.selected}`
    }));
const $adbd1649a448de68$var$MenuList = (0, $18TeW.default)((0, $1fpj1.default))(({ theme: theme })=>({
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(2)
    }));
const $adbd1649a448de68$var$Subtitle = (0, $18TeW.default)((0, $b5Oyq.default))(({ theme: theme })=>({
        color: `${theme.palette.surface.text}${theme.palette.other.opacityDisabled}`,
        marginTop: '0.5rem'
    }));
const $adbd1649a448de68$var$NavDrawer = ({ open: open, children: children, toggleDrawer: toggleDrawer })=>{
    const imageUrl = (0, $5cFwf.default)('BRAND_LOGO', (0, (/*@__PURE__*/$parcel$interopDefault($7Nk55))));
    const { PROJECT_NAME: name } = (0, $c5JDL.useProjectTextContext)();
    return /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $510652765a980631$export$2e2bcd8739ae039), {
        disableBackdropTransition: true,
        sx: {
            width: '264px'
        },
        open: open,
        onClick: toggleDrawer,
        onOpen: toggleDrawer,
        onClose: toggleDrawer,
        children: [
            /*#__PURE__*/ (0, $iHpLz.jsxs)($adbd1649a448de68$var$Head, {
                children: [
                    /*#__PURE__*/ (0, $iHpLz.jsx)("img", {
                        src: imageUrl,
                        alt: "ths-logo",
                        style: {
                            height: '100px'
                        }
                    }),
                    /*#__PURE__*/ (0, $iHpLz.jsx)((0, $b5Oyq.default), {
                        variant: "h6",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $iHpLz.jsx)($adbd1649a448de68$var$Subtitle, {
                        variant: "subtitle2",
                        children: "Event Signup"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iHpLz.jsx)($adbd1649a448de68$var$MenuList, {
                children: children
            })
        ]
    });
};
var $adbd1649a448de68$export$2e2bcd8739ae039 = $adbd1649a448de68$var$NavDrawer;



var $iHpLz = parcelRequire("iHpLz");
parcelRequire("7hhBq");

var $dok7x = parcelRequire("dok7x");

var $cNnl8 = parcelRequire("cNnl8");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $5vmbh = parcelRequire("5vmbh");

var $eET99 = parcelRequire("eET99");

var $cqwHw = parcelRequire("cqwHw");

var $18TeW = parcelRequire("18TeW");

var $1zv4u = parcelRequire("1zv4u");

var $4ZZLe = parcelRequire("4ZZLe");

var $2fhVh = parcelRequire("2fhVh");

var $bJAa6 = parcelRequire("bJAa6");

var $fUkkz = parcelRequire("fUkkz");

var $drmCR = parcelRequire("drmCR");

var $ghvvy = parcelRequire("ghvvy");

var $FG59X = parcelRequire("FG59X");

var $iHpLz = parcelRequire("iHpLz");
'use client';
const $4b4b418a7a782c1d$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $4b4b418a7a782c1d$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $eET99.default)(slots, (0, $FG59X.getListItemButtonUtilityClass), classes);
    return (0, $dok7x._)({}, classes, composedClasses);
};
const $4b4b418a7a782c1d$var$ListItemButtonRoot = (0, $18TeW.default)((0, $bJAa6.default), {
    shouldForwardProp: (prop)=>(0, $2fhVh.default)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $4b4b418a7a782c1d$export$4334bb34c76fef24
})((0, $1zv4u.default)(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $FG59X.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cqwHw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $FG59X.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cqwHw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $FG59X.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cqwHw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cqwHw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $FG59X.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $FG59X.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            }
        ]
    })));
const $4b4b418a7a782c1d$var$ListItemButton = /*#__PURE__*/ $7hhBq.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $4ZZLe.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $6pkKu._)(props, [
        "alignItems",
        "autoFocus",
        "component",
        "children",
        "dense",
        "disableGutters",
        "divider",
        "focusVisibleClassName",
        "selected",
        "className"
    ]);
    const context = $7hhBq.useContext((0, $ghvvy.default));
    const childContext = $7hhBq.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $7hhBq.useRef(null);
    (0, $fUkkz.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $cNnl8._)((0, $dok7x._)({}, props), {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $4b4b418a7a782c1d$var$useUtilityClasses(ownerState);
    const handleRef = (0, $drmCR.default)(listItemRef, ref);
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $ghvvy.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $iHpLz.jsx)($4b4b418a7a782c1d$var$ListItemButtonRoot, (0, $cNnl8._)((0, $dok7x._)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, $5vmbh.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $5vmbh.default)(classes.root, className)
        }, other), {
            classes: classes,
            children: children
        }))
    });
});
var $4b4b418a7a782c1d$export$2e2bcd8739ae039 = $4b4b418a7a782c1d$var$ListItemButton;


var $b5Oyq = parcelRequire("b5Oyq");

var $dok7x = parcelRequire("dok7x");

var $6pkKu = parcelRequire("6pkKu");

var $7hhBq = parcelRequire("7hhBq");


var $4o8qq = parcelRequire("4o8qq");


var $jU43v = parcelRequire("jU43v");

var $dok7x = parcelRequire("dok7x");
function $89249bb0a46bc8d0$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    const output = (0, $dok7x._)({}, props);
    // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    const defaultProps = theme.components[name].defaultProps;
    let propName;
    for(propName in defaultProps)if (output[propName] === undefined) output[propName] = defaultProps[propName];
    return output;
}



var $OIZ7O = parcelRequire("OIZ7O");

var $iHpLz = parcelRequire("iHpLz");
const $ede9ec86f5316a62$var$withStyles = (stylesOrCreator, options = {})=>(Component)=>{
        const { defaultTheme: defaultTheme, withTheme: withTheme = false, name: name } = options, stylesOptions = (0, $6pkKu._)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        let classNamePrefix = name;
        const useStyles = (0, $jU43v.default)(stylesOrCreator, (0, $dok7x._)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        const WithStyles = /*#__PURE__*/ $7hhBq.forwardRef(function WithStyles(props, ref) {
            const { classes: classesProp } = props, other = (0, $6pkKu._)(props, [
                "classes"
            ]);
            // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            const classes = useStyles((0, $dok7x._)({}, Component.defaultProps, props));
            let theme;
            let more = other;
            if (typeof name === 'string' || withTheme) {
                // name and withTheme are invariant in the outer scope
                // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $OIZ7O.default)() || defaultTheme;
                if (name) more = (0, $89249bb0a46bc8d0$export$2e2bcd8739ae039)({
                    theme: theme,
                    name: name,
                    props: other
                });
                // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, $iHpLz.jsx)(Component, (0, $dok7x._)({
                ref: ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4o8qq)))(WithStyles, Component);
        return WithStyles;
    };
var $ede9ec86f5316a62$export$2e2bcd8739ae039 = $ede9ec86f5316a62$var$withStyles;


const $b2c4bf647cf42881$var$CustomListItem = (0, $ede9ec86f5316a62$export$2e2bcd8739ae039)((t)=>({
        root: {
            fontSize: '24px',
            height: '48px',
            paddingTop: t.spacing(1),
            paddingBottom: t.spacing(1),
            paddingLeft: '8px',
            color: `#00000087`,
            ' & > p': {
                margin: '0',
                paddingLeft: '28px',
                lineHeight: 'inherit'
            },
            '&:active, &:hover': {
                backgroundColor: `${t.palette.primary.main}12 !important`,
                color: `${t.palette.primary.main} !important`
            }
        },
        selected: {
            backgroundColor: `${t.palette.primary.main}12 !important`,
            color: t.palette.primary.main
        }
    }))((0, $4b4b418a7a782c1d$export$2e2bcd8739ae039));
const $b2c4bf647cf42881$var$NavDrawerButton = ({ page: page, label: label, icon: icon, onClick: onClick })=>{
    const isActive = ()=>{
        return page.toLocaleLowerCase() === label.toLocaleLowerCase();
    };
    return /*#__PURE__*/ (0, $iHpLz.jsxs)($b2c4bf647cf42881$var$CustomListItem, {
        selected: isActive(),
        onClick: onClick,
        children: [
            icon,
            /*#__PURE__*/ (0, $iHpLz.jsx)((0, $b5Oyq.default), {
                variant: "body1",
                children: label
            })
        ]
    });
};
var $b2c4bf647cf42881$export$2e2bcd8739ae039 = $b2c4bf647cf42881$var$NavDrawerButton;


const $42084619fd653ae9$var$Navbar = ()=>{
    const navigate = (0, $aw1H1.useNavigate)();
    const isMobile = (0, $c2CkC.default)();
    const { isSubMenu: isSubMenu } = (0, $6WeUp.useSubMenuContext)();
    const projectId = (0, $8oEKT.default)();
    const { open: open, handleToggle: handleToggle } = (0, $2631a44a280766fa$export$2e2bcd8739ae039)();
    const { availableRoutes: availableRoutes, page: page } = (0, $44a745b3450b1a79$export$2e2bcd8739ae039)();
    const navigateTo = (path)=>{
        navigate(`/${projectId}/${path.toLowerCase()}`);
    };
    if (isMobile && isSubMenu) return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $iHpLz.Fragment), {});
    return /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $iHpLz.Fragment), {
        children: [
            isMobile && /*#__PURE__*/ (0, $iHpLz.jsx)((0, $adbd1649a448de68$export$2e2bcd8739ae039), {
                open: open,
                toggleDrawer: handleToggle,
                children: availableRoutes.map((r)=>/*#__PURE__*/ (0, $iHpLz.jsx)((0, $b2c4bf647cf42881$export$2e2bcd8739ae039), {
                        page: page,
                        label: r.name,
                        icon: r.icon,
                        onClick: ()=>{
                            navigateTo(r.name);
                        }
                    }, `drawer-button-${r.name}`))
            }),
            /*#__PURE__*/ (0, $iHpLz.jsx)((0, $992b0453aa704fee$export$2e2bcd8739ae039), {
                left: /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $iHpLz.Fragment), {
                    children: [
                        isMobile && /*#__PURE__*/ (0, $iHpLz.jsx)((0, $fb30d7c947dd6f5f$export$2e2bcd8739ae039), {
                            onClick: handleToggle
                        }),
                        isMobile && /*#__PURE__*/ (0, $iHpLz.jsx)((0, $7cbdcd367eba8bbd$export$2e2bcd8739ae039), {
                            location: page,
                            routes: availableRoutes
                        }),
                        !isMobile && /*#__PURE__*/ (0, $iHpLz.jsx)((0, $5c8f74021ea3f325$export$2e2bcd8739ae039), {
                            page: page,
                            onClick: ()=>navigateTo('')
                        }),
                        !isMobile && availableRoutes.filter((r)=>r.location === 'middle' && r.name !== 'Home').map((r)=>/*#__PURE__*/ (0, $iHpLz.jsx)((0, $901db9a776ac3496$export$2e2bcd8739ae039), {
                                page: page,
                                onClick: ()=>navigateTo(r.name),
                                label: r.name
                            }, `navbar-button-text-${r.name}`))
                    ]
                }),
                right: /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $iHpLz.Fragment), {
                    children: [
                        isMobile && /*#__PURE__*/ (0, $iHpLz.jsx)((0, $5c8f74021ea3f325$export$2e2bcd8739ae039), {
                            page: page,
                            onClick: ()=>navigateTo('')
                        }),
                        !isMobile && availableRoutes.filter((r)=>r.location === 'right').map((r)=>/*#__PURE__*/ (0, $iHpLz.jsx)((0, $901db9a776ac3496$export$2e2bcd8739ae039), {
                                page: page,
                                onClick: ()=>navigateTo(r.name),
                                label: r.name
                            }, `navbar-button-text-${r.name}`))
                    ]
                })
            })
        ]
    });
};
var $42084619fd653ae9$export$2e2bcd8739ae039 = $42084619fd653ae9$var$Navbar;



var $c5JDL = parcelRequire("c5JDL");

var $6COaG = parcelRequire("6COaG");

var $iZUkI = parcelRequire("iZUkI");

var $ljlev = parcelRequire("ljlev");

const $8b9660c97f1a5d4f$var$CreateAccount = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("7Ry7z")));

const $8b9660c97f1a5d4f$var$LoginReset = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("2zsj5")));

const $8b9660c97f1a5d4f$var$Login = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("NU2ei")));

const $8b9660c97f1a5d4f$var$Events = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("arQiA")));

const $8b9660c97f1a5d4f$var$Admin = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("4yZea")));

const $8b9660c97f1a5d4f$var$Tickets = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("lhNqY")));

const $8b9660c97f1a5d4f$var$SentForgot = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("hUY3i")));

const $8b9660c97f1a5d4f$var$ConfirmEmail = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("1xKEy")));

const $8b9660c97f1a5d4f$var$LoginForgot = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("5DVwY")));

const $8b9660c97f1a5d4f$var$Logout = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("2PoQG")));

const $8b9660c97f1a5d4f$var$WriteProjectInfo = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("eVsYn")));

const $8b9660c97f1a5d4f$var$Profile = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("lsood")));

const $8b9660c97f1a5d4f$var$About = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("97Al8")));

const $8b9660c97f1a5d4f$var$Pony = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("i9chW")));

const $8b9660c97f1a5d4f$var$PatchEmail = /*#__PURE__*/ (0, $7hhBq.lazy)(()=>(parcelRequire("7hS4X")));
const $8b9660c97f1a5d4f$var$App = ()=>{
    const { theme: theme, isLoading: isLoading } = (0, $82f77024a75ce78a$export$2e2bcd8739ae039)();
    if (isLoading) return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $k2lc8.default), {
        injectFirst: true,
        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $edeoK.default), {
            theme: theme,
            children: /*#__PURE__*/ (0, $iHpLz.jsx)("div", {
                style: {
                    padding: '16px'
                },
                children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $d0uAT.default), {
                    color: "secondary"
                })
            })
        })
    });
    return /*#__PURE__*/ (0, $iHpLz.jsx)((0, $k2lc8.default), {
        injectFirst: true,
        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $edeoK.default), {
            theme: theme,
            children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $c5JDL.ProjectTextProvider), {
                children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $6WeUp.SubMenuProvider), {
                    children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $b5Oyq.default), {
                        component: "section",
                        children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $1a11c5a4e40f40a3$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.BrowserRouter), {
                                children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $ljlev.AuthProvider), {
                                    children: /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $6COaG.SnackbarProvider), {
                                        maxSnack: 4,
                                        children: [
                                            /*#__PURE__*/ (0, $iHpLz.jsx)((0, $42084619fd653ae9$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $aw1H1.Routes), {
                                                children: [
                                                    /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                        path: "/:projectId/*",
                                                        element: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $169887c0cff00317$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $7hhBq.Suspense), {
                                                                fallback: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $d0uAT.default), {
                                                                    color: "secondary"
                                                                }),
                                                                children: /*#__PURE__*/ (0, $iHpLz.jsxs)((0, $aw1H1.Routes), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/login/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$Login, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/events/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $i813w.default), {
                                                                                children: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$Events, {})
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/tickets/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $i813w.default), {
                                                                                children: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$Tickets, {})
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/admin/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $i813w.default), {
                                                                                requiredRole: 2,
                                                                                children: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$Admin, {})
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/profile/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $i813w.default), {
                                                                                children: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$Profile, {})
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/logout/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $i813w.default), {
                                                                                children: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$Logout, {})
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/forgot/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$LoginForgot, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/reset/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$LoginReset, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/createAccount/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$CreateAccount, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/sentForgot/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$SentForgot, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/confirm/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$ConfirmEmail, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/patchEmail/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$PatchEmail, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/pony/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$Pony, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/projectInfo/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$WriteProjectInfo, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "about/*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)($8b9660c97f1a5d4f$var$About, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "/",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $c9657a7c0ff100d4$export$2e2bcd8739ae039), {})
                                                                        }),
                                                                        /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                                            path: "*",
                                                                            element: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $66c5d7e930dd48aa$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Route), {
                                                        path: "*",
                                                        element: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $aw1H1.Navigate), {
                                                            to: (0, $iZUkI.DEFAULT_ROUTE),
                                                            replace: true
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
var $8b9660c97f1a5d4f$export$2e2bcd8739ae039 = $8b9660c97f1a5d4f$var$App;


const $e09653a5647e295a$var$queryClient = new (0, $a3d1320b6b87071b$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            retry: false
        }
    }
});
const $e09653a5647e295a$var$root = (0, $f921c969471b625d$export$882461b6382ed46c)(document.querySelector('#root'));
$e09653a5647e295a$var$root.render(/*#__PURE__*/ (0, $iHpLz.jsx)((0, $a0iaM.QueryClientProvider), {
    client: $e09653a5647e295a$var$queryClient,
    children: /*#__PURE__*/ (0, $iHpLz.jsx)((0, $8b9660c97f1a5d4f$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=repo.12971fac.js.map
